import {
  createReadContract,
  createWriteContract,
  createSimulateContract,
  createWatchContractEvent,
} from '@wagmi/core/codegen'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// ACLManager-Taiko
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x24c9d39A8779D5Ec019D3C3E66741f861DE9a92E)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x67e9aceB00D177776c54467BCE75eF0e98878F46)
 */
export const aclManagerTaikoAbi = [
  {
    type: 'constructor',
    inputs: [
      {
        name: 'provider',
        internalType: 'contract IPoolAddressesProvider',
        type: 'address',
      },
    ],
    stateMutability: 'nonpayable',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'role', internalType: 'bytes32', type: 'bytes32', indexed: true },
      {
        name: 'previousAdminRole',
        internalType: 'bytes32',
        type: 'bytes32',
        indexed: true,
      },
      {
        name: 'newAdminRole',
        internalType: 'bytes32',
        type: 'bytes32',
        indexed: true,
      },
    ],
    name: 'RoleAdminChanged',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'role', internalType: 'bytes32', type: 'bytes32', indexed: true },
      {
        name: 'account',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'sender',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'RoleGranted',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'role', internalType: 'bytes32', type: 'bytes32', indexed: true },
      {
        name: 'account',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'sender',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'RoleRevoked',
  },
  {
    type: 'function',
    inputs: [],
    name: 'ADDRESSES_PROVIDER',
    outputs: [
      {
        name: '',
        internalType: 'contract IPoolAddressesProvider',
        type: 'address',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'ASSET_LISTING_ADMIN_ROLE',
    outputs: [{ name: '', internalType: 'bytes32', type: 'bytes32' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'BRIDGE_ROLE',
    outputs: [{ name: '', internalType: 'bytes32', type: 'bytes32' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'DEFAULT_ADMIN_ROLE',
    outputs: [{ name: '', internalType: 'bytes32', type: 'bytes32' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'EMERGENCY_ADMIN_ROLE',
    outputs: [{ name: '', internalType: 'bytes32', type: 'bytes32' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'FLASH_BORROWER_ROLE',
    outputs: [{ name: '', internalType: 'bytes32', type: 'bytes32' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'POOL_ADMIN_ROLE',
    outputs: [{ name: '', internalType: 'bytes32', type: 'bytes32' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'RISK_ADMIN_ROLE',
    outputs: [{ name: '', internalType: 'bytes32', type: 'bytes32' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'admin', internalType: 'address', type: 'address' }],
    name: 'addAssetListingAdmin',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'bridge', internalType: 'address', type: 'address' }],
    name: 'addBridge',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'admin', internalType: 'address', type: 'address' }],
    name: 'addEmergencyAdmin',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'borrower', internalType: 'address', type: 'address' }],
    name: 'addFlashBorrower',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'admin', internalType: 'address', type: 'address' }],
    name: 'addPoolAdmin',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'admin', internalType: 'address', type: 'address' }],
    name: 'addRiskAdmin',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'role', internalType: 'bytes32', type: 'bytes32' }],
    name: 'getRoleAdmin',
    outputs: [{ name: '', internalType: 'bytes32', type: 'bytes32' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'role', internalType: 'bytes32', type: 'bytes32' },
      { name: 'account', internalType: 'address', type: 'address' },
    ],
    name: 'grantRole',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'role', internalType: 'bytes32', type: 'bytes32' },
      { name: 'account', internalType: 'address', type: 'address' },
    ],
    name: 'hasRole',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'admin', internalType: 'address', type: 'address' }],
    name: 'isAssetListingAdmin',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'bridge', internalType: 'address', type: 'address' }],
    name: 'isBridge',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'admin', internalType: 'address', type: 'address' }],
    name: 'isEmergencyAdmin',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'borrower', internalType: 'address', type: 'address' }],
    name: 'isFlashBorrower',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'admin', internalType: 'address', type: 'address' }],
    name: 'isPoolAdmin',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'admin', internalType: 'address', type: 'address' }],
    name: 'isRiskAdmin',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'admin', internalType: 'address', type: 'address' }],
    name: 'removeAssetListingAdmin',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'bridge', internalType: 'address', type: 'address' }],
    name: 'removeBridge',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'admin', internalType: 'address', type: 'address' }],
    name: 'removeEmergencyAdmin',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'borrower', internalType: 'address', type: 'address' }],
    name: 'removeFlashBorrower',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'admin', internalType: 'address', type: 'address' }],
    name: 'removePoolAdmin',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'admin', internalType: 'address', type: 'address' }],
    name: 'removeRiskAdmin',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'role', internalType: 'bytes32', type: 'bytes32' },
      { name: 'account', internalType: 'address', type: 'address' },
    ],
    name: 'renounceRole',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'role', internalType: 'bytes32', type: 'bytes32' },
      { name: 'account', internalType: 'address', type: 'address' },
    ],
    name: 'revokeRole',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'role', internalType: 'bytes32', type: 'bytes32' },
      { name: 'adminRole', internalType: 'bytes32', type: 'bytes32' },
    ],
    name: 'setRoleAdmin',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'interfaceId', internalType: 'bytes4', type: 'bytes4' }],
    name: 'supportsInterface',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
] as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x24c9d39A8779D5Ec019D3C3E66741f861DE9a92E)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x67e9aceB00D177776c54467BCE75eF0e98878F46)
 */
export const aclManagerTaikoAddress = {
  17000: '0x24c9d39A8779D5Ec019D3C3E66741f861DE9a92E',
  167009: '0x67e9aceB00D177776c54467BCE75eF0e98878F46',
} as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x24c9d39A8779D5Ec019D3C3E66741f861DE9a92E)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x67e9aceB00D177776c54467BCE75eF0e98878F46)
 */
export const aclManagerTaikoConfig = {
  address: aclManagerTaikoAddress,
  abi: aclManagerTaikoAbi,
} as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// AToken-Taiko
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x6b73157d672FB22C974b2068610cC0a71BAC1be5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x126983388eA103c29437C4a22d3704800039304A)
 */
export const aTokenTaikoAbi = [
  {
    type: 'constructor',
    inputs: [{ name: 'pool', internalType: 'contract IPool', type: 'address' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'owner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'spender',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Approval',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'from', internalType: 'address', type: 'address', indexed: true },
      { name: 'to', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'index',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'BalanceTransfer',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'from', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'target',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'balanceIncrease',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'index',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Burn',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'underlyingAsset',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      { name: 'pool', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'treasury',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
      {
        name: 'incentivesController',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
      {
        name: 'aTokenDecimals',
        internalType: 'uint8',
        type: 'uint8',
        indexed: false,
      },
      {
        name: 'aTokenName',
        internalType: 'string',
        type: 'string',
        indexed: false,
      },
      {
        name: 'aTokenSymbol',
        internalType: 'string',
        type: 'string',
        indexed: false,
      },
      { name: 'params', internalType: 'bytes', type: 'bytes', indexed: false },
    ],
    name: 'Initialized',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'caller',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'onBehalfOf',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'balanceIncrease',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'index',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Mint',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'from', internalType: 'address', type: 'address', indexed: true },
      { name: 'to', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Transfer',
  },
  {
    type: 'function',
    inputs: [],
    name: 'ATOKEN_REVISION',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'DOMAIN_SEPARATOR',
    outputs: [{ name: '', internalType: 'bytes32', type: 'bytes32' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'EIP712_REVISION',
    outputs: [{ name: '', internalType: 'bytes', type: 'bytes' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'PERMIT_TYPEHASH',
    outputs: [{ name: '', internalType: 'bytes32', type: 'bytes32' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'POOL',
    outputs: [{ name: '', internalType: 'contract IPool', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'RESERVE_TREASURY_ADDRESS',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'UNDERLYING_ASSET_ADDRESS',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'owner', internalType: 'address', type: 'address' },
      { name: 'spender', internalType: 'address', type: 'address' },
    ],
    name: 'allowance',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'spender', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'approve',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'user', internalType: 'address', type: 'address' }],
    name: 'balanceOf',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'from', internalType: 'address', type: 'address' },
      {
        name: 'receiverOfUnderlying',
        internalType: 'address',
        type: 'address',
      },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
      { name: 'index', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'burn',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'decimals',
    outputs: [{ name: '', internalType: 'uint8', type: 'uint8' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'spender', internalType: 'address', type: 'address' },
      { name: 'subtractedValue', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'decreaseAllowance',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getIncentivesController',
    outputs: [
      {
        name: '',
        internalType: 'contract IAaveIncentivesController',
        type: 'address',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'user', internalType: 'address', type: 'address' }],
    name: 'getPreviousIndex',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'user', internalType: 'address', type: 'address' }],
    name: 'getScaledUserBalanceAndSupply',
    outputs: [
      { name: '', internalType: 'uint256', type: 'uint256' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'user', internalType: 'address', type: 'address' },
      { name: 'onBehalfOf', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'handleRepayment',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'spender', internalType: 'address', type: 'address' },
      { name: 'addedValue', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'increaseAllowance',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'initializingPool',
        internalType: 'contract IPool',
        type: 'address',
      },
      { name: 'treasury', internalType: 'address', type: 'address' },
      { name: 'underlyingAsset', internalType: 'address', type: 'address' },
      {
        name: 'incentivesController',
        internalType: 'contract IAaveIncentivesController',
        type: 'address',
      },
      { name: 'aTokenDecimals', internalType: 'uint8', type: 'uint8' },
      { name: 'aTokenName', internalType: 'string', type: 'string' },
      { name: 'aTokenSymbol', internalType: 'string', type: 'string' },
      { name: 'params', internalType: 'bytes', type: 'bytes' },
    ],
    name: 'initialize',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'caller', internalType: 'address', type: 'address' },
      { name: 'onBehalfOf', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
      { name: 'index', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'mint',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
      { name: 'index', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'mintToTreasury',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'name',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'owner', internalType: 'address', type: 'address' }],
    name: 'nonces',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'owner', internalType: 'address', type: 'address' },
      { name: 'spender', internalType: 'address', type: 'address' },
      { name: 'value', internalType: 'uint256', type: 'uint256' },
      { name: 'deadline', internalType: 'uint256', type: 'uint256' },
      { name: 'v', internalType: 'uint8', type: 'uint8' },
      { name: 'r', internalType: 'bytes32', type: 'bytes32' },
      { name: 's', internalType: 'bytes32', type: 'bytes32' },
    ],
    name: 'permit',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'token', internalType: 'address', type: 'address' },
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'rescueTokens',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'user', internalType: 'address', type: 'address' }],
    name: 'scaledBalanceOf',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'scaledTotalSupply',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'controller',
        internalType: 'contract IAaveIncentivesController',
        type: 'address',
      },
    ],
    name: 'setIncentivesController',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'symbol',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'totalSupply',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'recipient', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transfer',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'sender', internalType: 'address', type: 'address' },
      { name: 'recipient', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transferFrom',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'from', internalType: 'address', type: 'address' },
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'value', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transferOnLiquidation',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'target', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transferUnderlyingTo',
    outputs: [],
    stateMutability: 'nonpayable',
  },
] as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x6b73157d672FB22C974b2068610cC0a71BAC1be5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x126983388eA103c29437C4a22d3704800039304A)
 */
export const aTokenTaikoAddress = {
  17000: '0x6b73157d672FB22C974b2068610cC0a71BAC1be5',
  167009: '0x126983388eA103c29437C4a22d3704800039304A',
} as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x6b73157d672FB22C974b2068610cC0a71BAC1be5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x126983388eA103c29437C4a22d3704800039304A)
 */
export const aTokenTaikoConfig = {
  address: aTokenTaikoAddress,
  abi: aTokenTaikoAbi,
} as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// AaveOracle-Taiko
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x1fB6d773fE35266eC3363a935a4163f330a18b15)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x30f508945e0eB6A3D0dA99226B7E3eEA246A720e)
 */
export const aaveOracleTaikoAbi = [
  {
    type: 'constructor',
    inputs: [
      {
        name: 'provider',
        internalType: 'contract IPoolAddressesProvider',
        type: 'address',
      },
      { name: 'assets', internalType: 'address[]', type: 'address[]' },
      { name: 'sources', internalType: 'address[]', type: 'address[]' },
      { name: 'fallbackOracle', internalType: 'address', type: 'address' },
      { name: 'baseCurrency', internalType: 'address', type: 'address' },
      { name: 'baseCurrencyUnit', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'nonpayable',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'asset',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'source',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'AssetSourceUpdated',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'baseCurrency',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'baseCurrencyUnit',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'BaseCurrencySet',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'fallbackOracle',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'FallbackOracleUpdated',
  },
  {
    type: 'function',
    inputs: [],
    name: 'ADDRESSES_PROVIDER',
    outputs: [
      {
        name: '',
        internalType: 'contract IPoolAddressesProvider',
        type: 'address',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'BASE_CURRENCY',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'BASE_CURRENCY_UNIT',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'forceFallbackOracle',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'asset', internalType: 'address', type: 'address' }],
    name: 'getAssetPrice',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'assets', internalType: 'address[]', type: 'address[]' }],
    name: 'getAssetsPrices',
    outputs: [{ name: '', internalType: 'uint256[]', type: 'uint256[]' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getFallbackOracle',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'asset', internalType: 'address', type: 'address' }],
    name: 'getSourceOfAsset',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'assets', internalType: 'address[]', type: 'address[]' },
      { name: 'sources', internalType: 'address[]', type: 'address[]' },
    ],
    name: 'setAssetSources',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'fallbackOracle', internalType: 'address', type: 'address' },
    ],
    name: 'setFallbackOracle',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: '_forceFallbackOracle', internalType: 'bool', type: 'bool' },
    ],
    name: 'toggleFallbackOracle',
    outputs: [],
    stateMutability: 'nonpayable',
  },
] as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x1fB6d773fE35266eC3363a935a4163f330a18b15)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x30f508945e0eB6A3D0dA99226B7E3eEA246A720e)
 */
export const aaveOracleTaikoAddress = {
  17000: '0x1fB6d773fE35266eC3363a935a4163f330a18b15',
  167009: '0x30f508945e0eB6A3D0dA99226B7E3eEA246A720e',
} as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x1fB6d773fE35266eC3363a935a4163f330a18b15)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x30f508945e0eB6A3D0dA99226B7E3eEA246A720e)
 */
export const aaveOracleTaikoConfig = {
  address: aaveOracleTaikoAddress,
  abi: aaveOracleTaikoAbi,
} as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// BorrowLogic
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x0D180a98BB91aaC18A0C4fb0537914013CAe4226)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x11913178d32d8eb0f02146abDDb74B4963DEfa7F)
 */
export const borrowLogicAbi = [
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'reserve',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'user',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
      {
        name: 'onBehalfOf',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'amount',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'interestRateMode',
        internalType: 'enum DataTypes.InterestRateMode',
        type: 'uint8',
        indexed: false,
      },
      {
        name: 'borrowRate',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'referralCode',
        internalType: 'uint16',
        type: 'uint16',
        indexed: true,
      },
    ],
    name: 'Borrow',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'asset',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'totalDebt',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'IsolationModeTotalDebtUpdated',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'asset',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'totalDebt',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'IsolationModeTotalDebtUpdated',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'reserve',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      { name: 'user', internalType: 'address', type: 'address', indexed: true },
    ],
    name: 'RebalanceStableBorrowRate',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'reserve',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      { name: 'user', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'repayer',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'amount',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'useATokens',
        internalType: 'bool',
        type: 'bool',
        indexed: false,
      },
    ],
    name: 'Repay',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'reserve',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'liquidityRate',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'stableBorrowRate',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'variableBorrowRate',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'liquidityIndex',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'variableBorrowIndex',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'ReserveDataUpdated',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'reserve',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      { name: 'user', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'interestRateMode',
        internalType: 'enum DataTypes.InterestRateMode',
        type: 'uint8',
        indexed: false,
      },
    ],
    name: 'SwapBorrowRateMode',
  },
] as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x0D180a98BB91aaC18A0C4fb0537914013CAe4226)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x11913178d32d8eb0f02146abDDb74B4963DEfa7F)
 */
export const borrowLogicAddress = {
  17000: '0x0D180a98BB91aaC18A0C4fb0537914013CAe4226',
  167009: '0x11913178d32d8eb0f02146abDDb74B4963DEfa7F',
} as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x0D180a98BB91aaC18A0C4fb0537914013CAe4226)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x11913178d32d8eb0f02146abDDb74B4963DEfa7F)
 */
export const borrowLogicConfig = {
  address: borrowLogicAddress,
  abi: borrowLogicAbi,
} as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// BridgeLogic
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xD8b5E00454881b7329E590f0Aa0424fc436Cc352)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9b3877fB198CE30cc80feF984b1809470ac4114c)
 */
export const bridgeLogicAbi = [
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'reserve',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'backer',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'amount',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      { name: 'fee', internalType: 'uint256', type: 'uint256', indexed: false },
    ],
    name: 'BackUnbacked',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'reserve',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'user',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
      {
        name: 'onBehalfOf',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'amount',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'referralCode',
        internalType: 'uint16',
        type: 'uint16',
        indexed: true,
      },
    ],
    name: 'MintUnbacked',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'reserve',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'liquidityRate',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'stableBorrowRate',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'variableBorrowRate',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'liquidityIndex',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'variableBorrowIndex',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'ReserveDataUpdated',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'reserve',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      { name: 'user', internalType: 'address', type: 'address', indexed: true },
    ],
    name: 'ReserveUsedAsCollateralEnabled',
  },
] as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xD8b5E00454881b7329E590f0Aa0424fc436Cc352)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9b3877fB198CE30cc80feF984b1809470ac4114c)
 */
export const bridgeLogicAddress = {
  17000: '0xD8b5E00454881b7329E590f0Aa0424fc436Cc352',
  167009: '0x9b3877fB198CE30cc80feF984b1809470ac4114c',
} as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xD8b5E00454881b7329E590f0Aa0424fc436Cc352)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9b3877fB198CE30cc80feF984b1809470ac4114c)
 */
export const bridgeLogicConfig = {
  address: bridgeLogicAddress,
  abi: bridgeLogicAbi,
} as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// ConfiguratorLogic
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xe183ecd498E9d1140f1e0799539D63E85683881C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7625557118c21218cD5A3A6Cc0C3b797eEcF230C)
 */
export const configuratorLogicAbi = [
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'asset',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'proxy',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'implementation',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'ATokenUpgraded',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'asset',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'aToken',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'stableDebtToken',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
      {
        name: 'variableDebtToken',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
      {
        name: 'interestRateStrategyAddress',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
    ],
    name: 'ReserveInitialized',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'asset',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'proxy',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'implementation',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'StableDebtTokenUpgraded',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'asset',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'proxy',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'implementation',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'VariableDebtTokenUpgraded',
  },
] as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xe183ecd498E9d1140f1e0799539D63E85683881C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7625557118c21218cD5A3A6Cc0C3b797eEcF230C)
 */
export const configuratorLogicAddress = {
  17000: '0xe183ecd498E9d1140f1e0799539D63E85683881C',
  167009: '0x7625557118c21218cD5A3A6Cc0C3b797eEcF230C',
} as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xe183ecd498E9d1140f1e0799539D63E85683881C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7625557118c21218cD5A3A6Cc0C3b797eEcF230C)
 */
export const configuratorLogicConfig = {
  address: configuratorLogicAddress,
  abi: configuratorLogicAbi,
} as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// DelegationAwareAToken-Taiko
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd70510E4523658d77f9e7fD5d892b468d1b3b2f7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeDA1B335A62C7FE079f5C507C64322aA246e3405)
 */
export const delegationAwareATokenTaikoAbi = [
  {
    type: 'constructor',
    inputs: [{ name: 'pool', internalType: 'contract IPool', type: 'address' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'owner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'spender',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Approval',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'from', internalType: 'address', type: 'address', indexed: true },
      { name: 'to', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'index',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'BalanceTransfer',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'from', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'target',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'balanceIncrease',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'index',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Burn',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'delegatee',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'DelegateUnderlyingTo',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'underlyingAsset',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      { name: 'pool', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'treasury',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
      {
        name: 'incentivesController',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
      {
        name: 'aTokenDecimals',
        internalType: 'uint8',
        type: 'uint8',
        indexed: false,
      },
      {
        name: 'aTokenName',
        internalType: 'string',
        type: 'string',
        indexed: false,
      },
      {
        name: 'aTokenSymbol',
        internalType: 'string',
        type: 'string',
        indexed: false,
      },
      { name: 'params', internalType: 'bytes', type: 'bytes', indexed: false },
    ],
    name: 'Initialized',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'caller',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'onBehalfOf',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'balanceIncrease',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'index',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Mint',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'from', internalType: 'address', type: 'address', indexed: true },
      { name: 'to', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Transfer',
  },
  {
    type: 'function',
    inputs: [],
    name: 'ATOKEN_REVISION',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'DOMAIN_SEPARATOR',
    outputs: [{ name: '', internalType: 'bytes32', type: 'bytes32' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'EIP712_REVISION',
    outputs: [{ name: '', internalType: 'bytes', type: 'bytes' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'PERMIT_TYPEHASH',
    outputs: [{ name: '', internalType: 'bytes32', type: 'bytes32' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'POOL',
    outputs: [{ name: '', internalType: 'contract IPool', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'RESERVE_TREASURY_ADDRESS',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'UNDERLYING_ASSET_ADDRESS',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'owner', internalType: 'address', type: 'address' },
      { name: 'spender', internalType: 'address', type: 'address' },
    ],
    name: 'allowance',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'spender', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'approve',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'user', internalType: 'address', type: 'address' }],
    name: 'balanceOf',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'from', internalType: 'address', type: 'address' },
      {
        name: 'receiverOfUnderlying',
        internalType: 'address',
        type: 'address',
      },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
      { name: 'index', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'burn',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'decimals',
    outputs: [{ name: '', internalType: 'uint8', type: 'uint8' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'spender', internalType: 'address', type: 'address' },
      { name: 'subtractedValue', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'decreaseAllowance',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'delegatee', internalType: 'address', type: 'address' }],
    name: 'delegateUnderlyingTo',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getIncentivesController',
    outputs: [
      {
        name: '',
        internalType: 'contract IAaveIncentivesController',
        type: 'address',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'user', internalType: 'address', type: 'address' }],
    name: 'getPreviousIndex',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'user', internalType: 'address', type: 'address' }],
    name: 'getScaledUserBalanceAndSupply',
    outputs: [
      { name: '', internalType: 'uint256', type: 'uint256' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'user', internalType: 'address', type: 'address' },
      { name: 'onBehalfOf', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'handleRepayment',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'spender', internalType: 'address', type: 'address' },
      { name: 'addedValue', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'increaseAllowance',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'initializingPool',
        internalType: 'contract IPool',
        type: 'address',
      },
      { name: 'treasury', internalType: 'address', type: 'address' },
      { name: 'underlyingAsset', internalType: 'address', type: 'address' },
      {
        name: 'incentivesController',
        internalType: 'contract IAaveIncentivesController',
        type: 'address',
      },
      { name: 'aTokenDecimals', internalType: 'uint8', type: 'uint8' },
      { name: 'aTokenName', internalType: 'string', type: 'string' },
      { name: 'aTokenSymbol', internalType: 'string', type: 'string' },
      { name: 'params', internalType: 'bytes', type: 'bytes' },
    ],
    name: 'initialize',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'caller', internalType: 'address', type: 'address' },
      { name: 'onBehalfOf', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
      { name: 'index', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'mint',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
      { name: 'index', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'mintToTreasury',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'name',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'owner', internalType: 'address', type: 'address' }],
    name: 'nonces',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'owner', internalType: 'address', type: 'address' },
      { name: 'spender', internalType: 'address', type: 'address' },
      { name: 'value', internalType: 'uint256', type: 'uint256' },
      { name: 'deadline', internalType: 'uint256', type: 'uint256' },
      { name: 'v', internalType: 'uint8', type: 'uint8' },
      { name: 'r', internalType: 'bytes32', type: 'bytes32' },
      { name: 's', internalType: 'bytes32', type: 'bytes32' },
    ],
    name: 'permit',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'token', internalType: 'address', type: 'address' },
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'rescueTokens',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'user', internalType: 'address', type: 'address' }],
    name: 'scaledBalanceOf',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'scaledTotalSupply',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'controller',
        internalType: 'contract IAaveIncentivesController',
        type: 'address',
      },
    ],
    name: 'setIncentivesController',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'symbol',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'totalSupply',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'recipient', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transfer',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'sender', internalType: 'address', type: 'address' },
      { name: 'recipient', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transferFrom',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'from', internalType: 'address', type: 'address' },
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'value', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transferOnLiquidation',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'target', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transferUnderlyingTo',
    outputs: [],
    stateMutability: 'nonpayable',
  },
] as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd70510E4523658d77f9e7fD5d892b468d1b3b2f7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeDA1B335A62C7FE079f5C507C64322aA246e3405)
 */
export const delegationAwareATokenTaikoAddress = {
  17000: '0xd70510E4523658d77f9e7fD5d892b468d1b3b2f7',
  167009: '0xeDA1B335A62C7FE079f5C507C64322aA246e3405',
} as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd70510E4523658d77f9e7fD5d892b468d1b3b2f7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeDA1B335A62C7FE079f5C507C64322aA246e3405)
 */
export const delegationAwareATokenTaikoConfig = {
  address: delegationAwareATokenTaikoAddress,
  abi: delegationAwareATokenTaikoAbi,
} as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// EModeLogic
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x6Aa37b935CED6698BfBC79266dc26B6c339e5462)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x22A15ea811fbb16AEB7d76c22D993feA4574dBd4)
 */
export const eModeLogicAbi = [
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'user', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'categoryId',
        internalType: 'uint8',
        type: 'uint8',
        indexed: false,
      },
    ],
    name: 'UserEModeSet',
  },
] as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x6Aa37b935CED6698BfBC79266dc26B6c339e5462)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x22A15ea811fbb16AEB7d76c22D993feA4574dBd4)
 */
export const eModeLogicAddress = {
  17000: '0x6Aa37b935CED6698BfBC79266dc26B6c339e5462',
  167009: '0x22A15ea811fbb16AEB7d76c22D993feA4574dBd4',
} as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x6Aa37b935CED6698BfBC79266dc26B6c339e5462)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x22A15ea811fbb16AEB7d76c22D993feA4574dBd4)
 */
export const eModeLogicConfig = {
  address: eModeLogicAddress,
  abi: eModeLogicAbi,
} as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// EmissionManager
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x75A562F96c538cA6d7f6603b7b7B1d22eFd46fa7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9e64f07168E782f839d0f296aE6bc488Fdb45049)
 */
export const emissionManagerAbi = [
  {
    type: 'constructor',
    inputs: [{ name: 'owner', internalType: 'address', type: 'address' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'reward',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'oldAdmin',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'newAdmin',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'EmissionAdminUpdated',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'previousOwner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'newOwner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'OwnershipTransferred',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'config',
        internalType: 'struct RewardsDataTypes.RewardsConfigInput[]',
        type: 'tuple[]',
        components: [
          { name: 'emissionPerSecond', internalType: 'uint88', type: 'uint88' },
          { name: 'totalSupply', internalType: 'uint256', type: 'uint256' },
          { name: 'distributionEnd', internalType: 'uint32', type: 'uint32' },
          { name: 'asset', internalType: 'address', type: 'address' },
          { name: 'reward', internalType: 'address', type: 'address' },
          {
            name: 'transferStrategy',
            internalType: 'contract ITransferStrategyBase',
            type: 'address',
          },
          {
            name: 'rewardOracle',
            internalType: 'contract IEACAggregatorProxy',
            type: 'address',
          },
        ],
      },
    ],
    name: 'configureAssets',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'reward', internalType: 'address', type: 'address' }],
    name: 'getEmissionAdmin',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getRewardsController',
    outputs: [
      {
        name: '',
        internalType: 'contract IRewardsController',
        type: 'address',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'owner',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'renounceOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'user', internalType: 'address', type: 'address' },
      { name: 'claimer', internalType: 'address', type: 'address' },
    ],
    name: 'setClaimer',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'asset', internalType: 'address', type: 'address' },
      { name: 'reward', internalType: 'address', type: 'address' },
      { name: 'newDistributionEnd', internalType: 'uint32', type: 'uint32' },
    ],
    name: 'setDistributionEnd',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'reward', internalType: 'address', type: 'address' },
      { name: 'admin', internalType: 'address', type: 'address' },
    ],
    name: 'setEmissionAdmin',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'asset', internalType: 'address', type: 'address' },
      { name: 'rewards', internalType: 'address[]', type: 'address[]' },
      {
        name: 'newEmissionsPerSecond',
        internalType: 'uint88[]',
        type: 'uint88[]',
      },
    ],
    name: 'setEmissionPerSecond',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'reward', internalType: 'address', type: 'address' },
      {
        name: 'rewardOracle',
        internalType: 'contract IEACAggregatorProxy',
        type: 'address',
      },
    ],
    name: 'setRewardOracle',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'controller', internalType: 'address', type: 'address' }],
    name: 'setRewardsController',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'reward', internalType: 'address', type: 'address' },
      {
        name: 'transferStrategy',
        internalType: 'contract ITransferStrategyBase',
        type: 'address',
      },
    ],
    name: 'setTransferStrategy',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'newOwner', internalType: 'address', type: 'address' }],
    name: 'transferOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
  },
] as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x75A562F96c538cA6d7f6603b7b7B1d22eFd46fa7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9e64f07168E782f839d0f296aE6bc488Fdb45049)
 */
export const emissionManagerAddress = {
  17000: '0x75A562F96c538cA6d7f6603b7b7B1d22eFd46fa7',
  167009: '0x9e64f07168E782f839d0f296aE6bc488Fdb45049',
} as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x75A562F96c538cA6d7f6603b7b7B1d22eFd46fa7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9e64f07168E782f839d0f296aE6bc488Fdb45049)
 */
export const emissionManagerConfig = {
  address: emissionManagerAddress,
  abi: emissionManagerAbi,
} as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Faucet-Taiko
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x98c168B8677bf4A36f75169D22E8E3DfadDC2310)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4726A3aC8A62f8f58b3294E2D8f100E8123fFcbf)
 */
export const faucetTaikoAbi = [
  {
    type: 'constructor',
    inputs: [
      { name: '_signerAddress', internalType: 'address', type: 'address' },
      { name: '_WBTC', internalType: 'address', type: 'address' },
      { name: '_USDC', internalType: 'address', type: 'address' },
      { name: '_USDT', internalType: 'address', type: 'address' },
      { name: '_TTKOK', internalType: 'address', type: 'address' },
    ],
    stateMutability: 'nonpayable',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'previousOwner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'newOwner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'OwnershipTransferred',
  },
  {
    type: 'function',
    inputs: [],
    name: 'TTKOK',
    outputs: [{ name: '', internalType: 'contract IERC20', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'USDC',
    outputs: [{ name: '', internalType: 'contract IERC20', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'USDT',
    outputs: [{ name: '', internalType: 'contract IERC20', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'WAIT_TIME',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'WBTC',
    outputs: [{ name: '', internalType: 'contract IERC20', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'drip',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: '_nonce', internalType: 'bytes', type: 'bytes' },
      { name: '_signature', internalType: 'bytes', type: 'bytes' },
    ],
    name: 'dripWithTko',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'tokens', internalType: 'address[]', type: 'address[]' }],
    name: 'emergencyWithdraw',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: '_userAddress', internalType: 'address', type: 'address' },
    ],
    name: 'lastDripTime',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: '', internalType: 'bytes', type: 'bytes' }],
    name: 'nonceUsed',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'owner',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'renounceOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: '_wbtcAmount', internalType: 'uint256', type: 'uint256' },
      { name: '_usdcAmount', internalType: 'uint256', type: 'uint256' },
      { name: '_usdtAmount', internalType: 'uint256', type: 'uint256' },
      { name: '_ttkokAmount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'setDripAmounts',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: '_WBTC', internalType: 'address', type: 'address' },
      { name: '_USDC', internalType: 'address', type: 'address' },
      { name: '_USDT', internalType: 'address', type: 'address' },
      { name: '_TTKOK', internalType: 'address', type: 'address' },
    ],
    name: 'setTokenAddresses',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'signerAddress',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: '', internalType: 'address', type: 'address' }],
    name: 'totalDrips',
    outputs: [{ name: '', internalType: 'uint8', type: 'uint8' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'newOwner', internalType: 'address', type: 'address' }],
    name: 'transferOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'ttkokAmount',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'usdcAmount',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'usdtAmount',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'wbtcAmount',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
] as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x98c168B8677bf4A36f75169D22E8E3DfadDC2310)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4726A3aC8A62f8f58b3294E2D8f100E8123fFcbf)
 */
export const faucetTaikoAddress = {
  17000: '0x98c168B8677bf4A36f75169D22E8E3DfadDC2310',
  167009: '0x4726A3aC8A62f8f58b3294E2D8f100E8123fFcbf',
} as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x98c168B8677bf4A36f75169D22E8E3DfadDC2310)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4726A3aC8A62f8f58b3294E2D8f100E8123fFcbf)
 */
export const faucetTaikoConfig = {
  address: faucetTaikoAddress,
  abi: faucetTaikoAbi,
} as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// FlashLoanLogic
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x2ac33f53aB4e8AD624791CE698AE038fCD169000)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xCdeB8671fE2d5fC7c8d09C0824668D2063e253b2)
 */
export const flashLoanLogicAbi = [
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'target',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'initiator',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
      {
        name: 'asset',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'amount',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'interestRateMode',
        internalType: 'enum DataTypes.InterestRateMode',
        type: 'uint8',
        indexed: false,
      },
      {
        name: 'premium',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'referralCode',
        internalType: 'uint16',
        type: 'uint16',
        indexed: true,
      },
    ],
    name: 'FlashLoan',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'reserve',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'liquidityRate',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'stableBorrowRate',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'variableBorrowRate',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'liquidityIndex',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'variableBorrowIndex',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'ReserveDataUpdated',
  },
] as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x2ac33f53aB4e8AD624791CE698AE038fCD169000)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xCdeB8671fE2d5fC7c8d09C0824668D2063e253b2)
 */
export const flashLoanLogicAddress = {
  17000: '0x2ac33f53aB4e8AD624791CE698AE038fCD169000',
  167009: '0xCdeB8671fE2d5fC7c8d09C0824668D2063e253b2',
} as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x2ac33f53aB4e8AD624791CE698AE038fCD169000)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xCdeB8671fE2d5fC7c8d09C0824668D2063e253b2)
 */
export const flashLoanLogicConfig = {
  address: flashLoanLogicAddress,
  abi: flashLoanLogicAbi,
} as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// HANA-TestnetMintableERC20-Reward-Taiko
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7f4DEc9C71Cdb4b8b731dec592153B7f39049870)
 */
export const hanaTestnetMintableErc20RewardTaikoAbi = [
  {
    type: 'constructor',
    inputs: [
      { name: '_name', internalType: 'string', type: 'string' },
      { name: '_symbol', internalType: 'string', type: 'string' },
      { name: '_decimals', internalType: 'uint8', type: 'uint8' },
    ],
    stateMutability: 'nonpayable',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'owner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'spender',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Approval',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'from', internalType: 'address', type: 'address', indexed: true },
      { name: 'to', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Transfer',
  },
  {
    type: 'function',
    inputs: [
      { name: 'owner', internalType: 'address', type: 'address' },
      { name: 'spender', internalType: 'address', type: 'address' },
    ],
    name: 'allowance',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'spender', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'approve',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'account', internalType: 'address', type: 'address' }],
    name: 'balanceOf',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'decimals',
    outputs: [{ name: '', internalType: 'uint8', type: 'uint8' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'spender', internalType: 'address', type: 'address' },
      { name: 'subtractedValue', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'decreaseAllowance',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'spender', internalType: 'address', type: 'address' },
      { name: 'addedValue', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'increaseAllowance',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'name',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'symbol',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'tokenDecimals',
    outputs: [{ name: '', internalType: 'uint8', type: 'uint8' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'totalSupply',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transfer',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'from', internalType: 'address', type: 'address' },
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transferFrom',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
] as const

/**
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7f4DEc9C71Cdb4b8b731dec592153B7f39049870)
 */
export const hanaTestnetMintableErc20RewardTaikoAddress = {
  167009: '0x7f4DEc9C71Cdb4b8b731dec592153B7f39049870',
} as const

/**
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7f4DEc9C71Cdb4b8b731dec592153B7f39049870)
 */
export const hanaTestnetMintableErc20RewardTaikoConfig = {
  address: hanaTestnetMintableErc20RewardTaikoAddress,
  abi: hanaTestnetMintableErc20RewardTaikoAbi,
} as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// HANA-TestnetPriceAggregator-Taiko
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xe3473c9c941c6B0a4F9EC9101CD0d3338a2620B8)
 */
export const hanaTestnetPriceAggregatorTaikoAbi = [
  {
    type: 'constructor',
    inputs: [{ name: 'initialAnswer', internalType: 'int256', type: 'int256' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'current',
        internalType: 'int256',
        type: 'int256',
        indexed: true,
      },
      {
        name: 'roundId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: true,
      },
      {
        name: 'updatedAt',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'AnswerUpdated',
  },
  {
    type: 'function',
    inputs: [],
    name: 'decimals',
    outputs: [{ name: '', internalType: 'uint8', type: 'uint8' }],
    stateMutability: 'pure',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getTokenType',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'pure',
  },
  {
    type: 'function',
    inputs: [],
    name: 'latestAnswer',
    outputs: [{ name: '', internalType: 'int256', type: 'int256' }],
    stateMutability: 'view',
  },
] as const

/**
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xe3473c9c941c6B0a4F9EC9101CD0d3338a2620B8)
 */
export const hanaTestnetPriceAggregatorTaikoAddress = {
  167009: '0xe3473c9c941c6B0a4F9EC9101CD0d3338a2620B8',
} as const

/**
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xe3473c9c941c6B0a4F9EC9101CD0d3338a2620B8)
 */
export const hanaTestnetPriceAggregatorTaikoConfig = {
  address: hanaTestnetPriceAggregatorTaikoAddress,
  abi: hanaTestnetPriceAggregatorTaikoAbi,
} as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// HanaEACAggregatorProxy
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x25e665B12406179565B97eFC17D55438fe83B823)
 */
export const hanaEacAggregatorProxyAbi = [
  {
    type: 'constructor',
    inputs: [
      { name: '_reserveAddress', internalType: 'address', type: 'address' },
      {
        name: '_oracle',
        internalType: 'contract IAaveOracle',
        type: 'address',
      },
    ],
    stateMutability: 'nonpayable',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'current',
        internalType: 'int256',
        type: 'int256',
        indexed: true,
      },
      {
        name: 'roundId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: true,
      },
      {
        name: 'timestamp',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'AnswerUpdated',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'roundId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: true,
      },
      {
        name: 'startedBy',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'NewRound',
  },
  {
    type: 'function',
    inputs: [],
    name: 'decimals',
    outputs: [{ name: '', internalType: 'uint8', type: 'uint8' }],
    stateMutability: 'pure',
  },
  {
    type: 'function',
    inputs: [{ name: 'roundId', internalType: 'uint256', type: 'uint256' }],
    name: 'getAnswer',
    outputs: [{ name: '', internalType: 'int256', type: 'int256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'roundId', internalType: 'uint256', type: 'uint256' }],
    name: 'getTimestamp',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'latestAnswer',
    outputs: [{ name: '', internalType: 'int256', type: 'int256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'latestRound',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'pure',
  },
  {
    type: 'function',
    inputs: [],
    name: 'latestTimestamp',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'oracle',
    outputs: [
      { name: '', internalType: 'contract IAaveOracle', type: 'address' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'reserveAddress',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
] as const

/**
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x25e665B12406179565B97eFC17D55438fe83B823)
 */
export const hanaEacAggregatorProxyAddress = {
  167009: '0x25e665B12406179565B97eFC17D55438fe83B823',
} as const

/**
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x25e665B12406179565B97eFC17D55438fe83B823)
 */
export const hanaEacAggregatorProxyConfig = {
  address: hanaEacAggregatorProxyAddress,
  abi: hanaEacAggregatorProxyAbi,
} as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// HanaFallbackOracle-Taiko
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xCaf827bA6B7f19487b04521F91A5890af7750E8c)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x604C6Db3cC11bBAef98F967496Ee10916c00E778)
 */
export const hanaFallbackOracleTaikoAbi = [
  {
    type: 'constructor',
    inputs: [
      { name: '_sValueFeed', internalType: 'address', type: 'address' },
      { name: '_assetAddresses', internalType: 'address[]', type: 'address[]' },
      { name: '_pairIds', internalType: 'uint256[]', type: 'uint256[]' },
      { name: '_hanaController', internalType: 'address', type: 'address' },
    ],
    stateMutability: 'nonpayable',
  },
  { type: 'error', inputs: [], name: 'ArrayLengthMismatched' },
  {
    type: 'error',
    inputs: [{ name: 'pairId', internalType: 'uint256', type: 'uint256' }],
    name: 'DerivedPairNotAvailable',
  },
  { type: 'error', inputs: [], name: 'InvalidDerivedPair' },
  { type: 'error', inputs: [], name: 'InvalidOperation' },
  { type: 'error', inputs: [], name: 'InvalidPull' },
  { type: 'error', inputs: [], name: 'InvalidVerifier' },
  { type: 'error', inputs: [], name: 'PairIdIsAbsentForHCC' },
  { type: 'error', inputs: [], name: 'PairIdsAreAbsentForHCC' },
  { type: 'error', inputs: [], name: 'UnauthorisedAccess' },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: '_updatedVerifierAddress',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
    ],
    name: 'HanaControllerUpdated',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'previousOwner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'newOwner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'OwnershipTransferred',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: '_updatedPullAddress',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
    ],
    name: 'SupraPullUpdated',
  },
  {
    type: 'function',
    inputs: [],
    name: 'BASE_CURRENCY',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'BASE_CURRENCY_UNIT',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: '', internalType: 'address', type: 'address' }],
    name: 'assetToId',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'forceHanaOracle',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'asset', internalType: 'address', type: 'address' }],
    name: 'getAssetPrice',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'pair_id_1', internalType: 'uint256', type: 'uint256' },
      { name: 'pair_id_2', internalType: 'uint256', type: 'uint256' },
      { name: 'operation', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'getDerivedSvalue',
    outputs: [
      {
        name: '',
        internalType: 'struct ISupraSValueFeed.derivedData',
        type: 'tuple',
        components: [
          { name: 'roundDifference', internalType: 'int256', type: 'int256' },
          { name: 'derivedPrice', internalType: 'uint256', type: 'uint256' },
          { name: 'decimals', internalType: 'uint256', type: 'uint256' },
        ],
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'pair_id_1', internalType: 'uint256', type: 'uint256' },
      { name: 'pair_id_2', internalType: 'uint256', type: 'uint256' },
      { name: 'operation', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'getDerivedValueOfPair',
    outputs: [
      {
        name: '',
        internalType: 'struct ISupraSValueFeed.derivedData',
        type: 'tuple',
        components: [
          { name: 'roundDifference', internalType: 'int256', type: 'int256' },
          { name: 'derivedPrice', internalType: 'uint256', type: 'uint256' },
          { name: 'decimals', internalType: 'uint256', type: 'uint256' },
        ],
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: '_priceIndex', internalType: 'uint256', type: 'uint256' }],
    name: 'getPrice',
    outputs: [
      {
        name: 'price',
        internalType: 'struct ISupraSValueFeed.priceFeed',
        type: 'tuple',
        components: [
          { name: 'round', internalType: 'uint256', type: 'uint256' },
          { name: 'decimals', internalType: 'uint256', type: 'uint256' },
          { name: 'time', internalType: 'uint256', type: 'uint256' },
          { name: 'price', internalType: 'uint256', type: 'uint256' },
        ],
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '_pairIndexes', internalType: 'uint256[]', type: 'uint256[]' },
    ],
    name: 'getPriceForMultiplePair',
    outputs: [
      {
        name: 'prices',
        internalType: 'struct ISupraSValueFeed.priceFeed[]',
        type: 'tuple[]',
        components: [
          { name: 'round', internalType: 'uint256', type: 'uint256' },
          { name: 'decimals', internalType: 'uint256', type: 'uint256' },
          { name: 'time', internalType: 'uint256', type: 'uint256' },
          { name: 'price', internalType: 'uint256', type: 'uint256' },
        ],
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: '_pairIndex', internalType: 'uint256', type: 'uint256' }],
    name: 'getSvalue',
    outputs: [
      {
        name: '',
        internalType: 'struct ISupraSValueFeed.priceFeed',
        type: 'tuple',
        components: [
          { name: 'round', internalType: 'uint256', type: 'uint256' },
          { name: 'decimals', internalType: 'uint256', type: 'uint256' },
          { name: 'time', internalType: 'uint256', type: 'uint256' },
          { name: 'price', internalType: 'uint256', type: 'uint256' },
        ],
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: '_pairIndex', internalType: 'uint64', type: 'uint64' }],
    name: 'getSvalue',
    outputs: [
      { name: '', internalType: 'bytes32', type: 'bytes32' },
      { name: '', internalType: 'bool', type: 'bool' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '_pairIndexes', internalType: 'uint64[]', type: 'uint64[]' },
    ],
    name: 'getSvalues',
    outputs: [
      { name: '', internalType: 'bytes32[]', type: 'bytes32[]' },
      { name: '', internalType: 'bool[]', type: 'bool[]' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '_pairIndexes', internalType: 'uint256[]', type: 'uint256[]' },
    ],
    name: 'getSvalues',
    outputs: [
      {
        name: '',
        internalType: 'struct ISupraSValueFeed.priceFeed[]',
        type: 'tuple[]',
        components: [
          { name: 'round', internalType: 'uint256', type: 'uint256' },
          { name: 'decimals', internalType: 'uint256', type: 'uint256' },
          { name: 'time', internalType: 'uint256', type: 'uint256' },
          { name: 'price', internalType: 'uint256', type: 'uint256' },
        ],
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '_tradingPair', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'getTimestamp',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'hanaController',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    name: 'idToPrice',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'owner',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'renounceOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: '_index', internalType: 'uint256[]', type: 'uint256[]' },
      { name: '_bytes', internalType: 'bytes32[]', type: 'bytes32[]' },
    ],
    name: 'restrictedMultiSetSupraStorage',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: '_index', internalType: 'uint256', type: 'uint256' },
      { name: '_bytes', internalType: 'bytes32', type: 'bytes32' },
    ],
    name: 'restrictedSetSupraStorage',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: '_forceHanaOracle', internalType: 'bool', type: 'bool' }],
    name: 'setforceHanaOracle',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'newOwner', internalType: 'address', type: 'address' }],
    name: 'transferOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: '_newHanaController', internalType: 'address', type: 'address' },
    ],
    name: 'updateSupraSValueFeedVerifier',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      {
        name: '_newSValueFeed',
        internalType: 'contract ISupraSValueFeed',
        type: 'address',
      },
    ],
    name: 'updateSupraSvalueFeed',
    outputs: [],
    stateMutability: 'nonpayable',
  },
] as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xCaf827bA6B7f19487b04521F91A5890af7750E8c)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x604C6Db3cC11bBAef98F967496Ee10916c00E778)
 */
export const hanaFallbackOracleTaikoAddress = {
  17000: '0xCaf827bA6B7f19487b04521F91A5890af7750E8c',
  167009: '0x604C6Db3cC11bBAef98F967496Ee10916c00E778',
} as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xCaf827bA6B7f19487b04521F91A5890af7750E8c)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x604C6Db3cC11bBAef98F967496Ee10916c00E778)
 */
export const hanaFallbackOracleTaikoConfig = {
  address: hanaFallbackOracleTaikoAddress,
  abi: hanaFallbackOracleTaikoAbi,
} as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// HenjinBTC
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * -
 * - [__View Contract on Taiko Katla Alpha 6 Testnet Blockscout__](https://explorer.katla.taiko.xyz/address/0x55C9FDc6dd65cbb9793B7b3327ec0723e778598E)
 */
export const henjinBtcAbi = [
  {
    type: 'function',
    inputs: [],
    name: 'decimals',
    outputs: [{ name: '', internalType: 'uint8', type: 'uint8' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'name',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'symbol',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
] as const

/**
 * -
 * - [__View Contract on Taiko Katla Alpha 6 Testnet Blockscout__](https://explorer.katla.taiko.xyz/address/0x55C9FDc6dd65cbb9793B7b3327ec0723e778598E)
 */
export const henjinBtcAddress = {
  31337: '0x55C9FDc6dd65cbb9793B7b3327ec0723e778598E',
  167008: '0x55C9FDc6dd65cbb9793B7b3327ec0723e778598E',
} as const

/**
 * -
 * - [__View Contract on Taiko Katla Alpha 6 Testnet Blockscout__](https://explorer.katla.taiko.xyz/address/0x55C9FDc6dd65cbb9793B7b3327ec0723e778598E)
 */
export const henjinBtcConfig = {
  address: henjinBtcAddress,
  abi: henjinBtcAbi,
} as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// HenjinUSDC
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * -
 * - [__View Contract on Taiko Katla Alpha 6 Testnet Blockscout__](https://explorer.katla.taiko.xyz/address/0x367F1F510036fD3feccBfa5eBD162e9dD244E5E8)
 */
export const henjinUsdcAbi = [
  {
    type: 'function',
    inputs: [],
    name: 'decimals',
    outputs: [{ name: '', internalType: 'uint8', type: 'uint8' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'name',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'symbol',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
] as const

/**
 * -
 * - [__View Contract on Taiko Katla Alpha 6 Testnet Blockscout__](https://explorer.katla.taiko.xyz/address/0x367F1F510036fD3feccBfa5eBD162e9dD244E5E8)
 */
export const henjinUsdcAddress = {
  31337: '0x55C9FDc6dd65cbb9793B7b3327ec0723e778598E',
  167008: '0x367F1F510036fD3feccBfa5eBD162e9dD244E5E8',
} as const

/**
 * -
 * - [__View Contract on Taiko Katla Alpha 6 Testnet Blockscout__](https://explorer.katla.taiko.xyz/address/0x367F1F510036fD3feccBfa5eBD162e9dD244E5E8)
 */
export const henjinUsdcConfig = {
  address: henjinUsdcAddress,
  abi: henjinUsdcAbi,
} as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// HenjinUSDT
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * -
 * - [__View Contract on Taiko Katla Alpha 6 Testnet Blockscout__](https://explorer.katla.taiko.xyz/address/0x80C459d9b36Acb9176C03577d9706E18d40cd193)
 */
export const henjinUsdtAbi = [
  {
    type: 'function',
    inputs: [],
    name: 'decimals',
    outputs: [{ name: '', internalType: 'uint8', type: 'uint8' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'name',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'symbol',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
] as const

/**
 * -
 * - [__View Contract on Taiko Katla Alpha 6 Testnet Blockscout__](https://explorer.katla.taiko.xyz/address/0x80C459d9b36Acb9176C03577d9706E18d40cd193)
 */
export const henjinUsdtAddress = {
  31337: '0x55C9FDc6dd65cbb9793B7b3327ec0723e778598E',
  167008: '0x80C459d9b36Acb9176C03577d9706E18d40cd193',
} as const

/**
 * -
 * - [__View Contract on Taiko Katla Alpha 6 Testnet Blockscout__](https://explorer.katla.taiko.xyz/address/0x80C459d9b36Acb9176C03577d9706E18d40cd193)
 */
export const henjinUsdtConfig = {
  address: henjinUsdtAddress,
  abi: henjinUsdtAbi,
} as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// IncentivesProxy
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE69A7CFC442770951377ad9Abec9C2264ad873f7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x36c3b7AEFbDec76E0E6C6BFB550af8472B2334B6)
 */
export const incentivesProxyAbi = [
  {
    type: 'constructor',
    inputs: [{ name: 'admin', internalType: 'address', type: 'address' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'implementation',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'Upgraded',
  },
  { type: 'fallback', stateMutability: 'payable' },
  {
    type: 'function',
    inputs: [],
    name: 'admin',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'implementation',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: '_logic', internalType: 'address', type: 'address' },
      { name: '_data', internalType: 'bytes', type: 'bytes' },
    ],
    name: 'initialize',
    outputs: [],
    stateMutability: 'payable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'newImplementation', internalType: 'address', type: 'address' },
    ],
    name: 'upgradeTo',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'newImplementation', internalType: 'address', type: 'address' },
      { name: 'data', internalType: 'bytes', type: 'bytes' },
    ],
    name: 'upgradeToAndCall',
    outputs: [],
    stateMutability: 'payable',
  },
] as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE69A7CFC442770951377ad9Abec9C2264ad873f7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x36c3b7AEFbDec76E0E6C6BFB550af8472B2334B6)
 */
export const incentivesProxyAddress = {
  17000: '0xE69A7CFC442770951377ad9Abec9C2264ad873f7',
  167009: '0x36c3b7AEFbDec76E0E6C6BFB550af8472B2334B6',
} as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE69A7CFC442770951377ad9Abec9C2264ad873f7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x36c3b7AEFbDec76E0E6C6BFB550af8472B2334B6)
 */
export const incentivesProxyConfig = {
  address: incentivesProxyAddress,
  abi: incentivesProxyAbi,
} as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// IncentivesV2-Implementation
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBA3Ce58a674f3097C9450E2c9ae04BaBBd60e3b3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7A13F9E2236C234907f53Ea60818f94928b5D540)
 */
export const incentivesV2ImplementationAbi = [
  {
    type: 'constructor',
    inputs: [
      { name: 'emissionManager', internalType: 'address', type: 'address' },
    ],
    stateMutability: 'nonpayable',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'asset',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'reward',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      { name: 'user', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'assetIndex',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'userIndex',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'rewardsAccrued',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Accrued',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'asset',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'reward',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'oldEmission',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'newEmission',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'oldDistributionEnd',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'newDistributionEnd',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'assetIndex',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'AssetConfigUpdated',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'user', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'claimer',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'ClaimerSet',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'reward',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'rewardOracle',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'RewardOracleUpdated',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'user', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'reward',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      { name: 'to', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'claimer',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
      {
        name: 'amount',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'RewardsClaimed',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'reward',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'transferStrategy',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'TransferStrategyInstalled',
  },
  {
    type: 'function',
    inputs: [],
    name: 'EMISSION_MANAGER',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'REVISION',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'assets', internalType: 'address[]', type: 'address[]' },
      { name: 'to', internalType: 'address', type: 'address' },
    ],
    name: 'claimAllRewards',
    outputs: [
      { name: 'rewardsList', internalType: 'address[]', type: 'address[]' },
      { name: 'claimedAmounts', internalType: 'uint256[]', type: 'uint256[]' },
    ],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'assets', internalType: 'address[]', type: 'address[]' },
      { name: 'user', internalType: 'address', type: 'address' },
      { name: 'to', internalType: 'address', type: 'address' },
    ],
    name: 'claimAllRewardsOnBehalf',
    outputs: [
      { name: 'rewardsList', internalType: 'address[]', type: 'address[]' },
      { name: 'claimedAmounts', internalType: 'uint256[]', type: 'uint256[]' },
    ],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'assets', internalType: 'address[]', type: 'address[]' }],
    name: 'claimAllRewardsToSelf',
    outputs: [
      { name: 'rewardsList', internalType: 'address[]', type: 'address[]' },
      { name: 'claimedAmounts', internalType: 'uint256[]', type: 'uint256[]' },
    ],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'assets', internalType: 'address[]', type: 'address[]' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'reward', internalType: 'address', type: 'address' },
    ],
    name: 'claimRewards',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'assets', internalType: 'address[]', type: 'address[]' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
      { name: 'user', internalType: 'address', type: 'address' },
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'reward', internalType: 'address', type: 'address' },
    ],
    name: 'claimRewardsOnBehalf',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'assets', internalType: 'address[]', type: 'address[]' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
      { name: 'reward', internalType: 'address', type: 'address' },
    ],
    name: 'claimRewardsToSelf',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'config',
        internalType: 'struct RewardsDataTypes.RewardsConfigInput[]',
        type: 'tuple[]',
        components: [
          { name: 'emissionPerSecond', internalType: 'uint88', type: 'uint88' },
          { name: 'totalSupply', internalType: 'uint256', type: 'uint256' },
          { name: 'distributionEnd', internalType: 'uint32', type: 'uint32' },
          { name: 'asset', internalType: 'address', type: 'address' },
          { name: 'reward', internalType: 'address', type: 'address' },
          {
            name: 'transferStrategy',
            internalType: 'contract ITransferStrategyBase',
            type: 'address',
          },
          {
            name: 'rewardOracle',
            internalType: 'contract IEACAggregatorProxy',
            type: 'address',
          },
        ],
      },
    ],
    name: 'configureAssets',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'assets', internalType: 'address[]', type: 'address[]' },
      { name: 'user', internalType: 'address', type: 'address' },
    ],
    name: 'getAllUserRewards',
    outputs: [
      { name: 'rewardsList', internalType: 'address[]', type: 'address[]' },
      {
        name: 'unclaimedAmounts',
        internalType: 'uint256[]',
        type: 'uint256[]',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'asset', internalType: 'address', type: 'address' }],
    name: 'getAssetDecimals',
    outputs: [{ name: '', internalType: 'uint8', type: 'uint8' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'asset', internalType: 'address', type: 'address' },
      { name: 'reward', internalType: 'address', type: 'address' },
    ],
    name: 'getAssetIndex',
    outputs: [
      { name: '', internalType: 'uint256', type: 'uint256' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'user', internalType: 'address', type: 'address' }],
    name: 'getClaimer',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'asset', internalType: 'address', type: 'address' },
      { name: 'reward', internalType: 'address', type: 'address' },
    ],
    name: 'getDistributionEnd',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getEmissionManager',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'reward', internalType: 'address', type: 'address' }],
    name: 'getRewardOracle',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'asset', internalType: 'address', type: 'address' }],
    name: 'getRewardsByAsset',
    outputs: [{ name: '', internalType: 'address[]', type: 'address[]' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'asset', internalType: 'address', type: 'address' },
      { name: 'reward', internalType: 'address', type: 'address' },
    ],
    name: 'getRewardsData',
    outputs: [
      { name: '', internalType: 'uint256', type: 'uint256' },
      { name: '', internalType: 'uint256', type: 'uint256' },
      { name: '', internalType: 'uint256', type: 'uint256' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getRewardsList',
    outputs: [{ name: '', internalType: 'address[]', type: 'address[]' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'reward', internalType: 'address', type: 'address' }],
    name: 'getTransferStrategy',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'user', internalType: 'address', type: 'address' },
      { name: 'reward', internalType: 'address', type: 'address' },
    ],
    name: 'getUserAccruedRewards',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'user', internalType: 'address', type: 'address' },
      { name: 'asset', internalType: 'address', type: 'address' },
      { name: 'reward', internalType: 'address', type: 'address' },
    ],
    name: 'getUserAssetIndex',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'assets', internalType: 'address[]', type: 'address[]' },
      { name: 'user', internalType: 'address', type: 'address' },
      { name: 'reward', internalType: 'address', type: 'address' },
    ],
    name: 'getUserRewards',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'user', internalType: 'address', type: 'address' },
      { name: 'totalSupply', internalType: 'uint256', type: 'uint256' },
      { name: 'userBalance', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'handleAction',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: '', internalType: 'address', type: 'address' }],
    name: 'initialize',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'user', internalType: 'address', type: 'address' },
      { name: 'caller', internalType: 'address', type: 'address' },
    ],
    name: 'setClaimer',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'asset', internalType: 'address', type: 'address' },
      { name: 'reward', internalType: 'address', type: 'address' },
      { name: 'newDistributionEnd', internalType: 'uint32', type: 'uint32' },
    ],
    name: 'setDistributionEnd',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'asset', internalType: 'address', type: 'address' },
      { name: 'rewards', internalType: 'address[]', type: 'address[]' },
      {
        name: 'newEmissionsPerSecond',
        internalType: 'uint88[]',
        type: 'uint88[]',
      },
    ],
    name: 'setEmissionPerSecond',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'reward', internalType: 'address', type: 'address' },
      {
        name: 'rewardOracle',
        internalType: 'contract IEACAggregatorProxy',
        type: 'address',
      },
    ],
    name: 'setRewardOracle',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'reward', internalType: 'address', type: 'address' },
      {
        name: 'transferStrategy',
        internalType: 'contract ITransferStrategyBase',
        type: 'address',
      },
    ],
    name: 'setTransferStrategy',
    outputs: [],
    stateMutability: 'nonpayable',
  },
] as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBA3Ce58a674f3097C9450E2c9ae04BaBBd60e3b3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7A13F9E2236C234907f53Ea60818f94928b5D540)
 */
export const incentivesV2ImplementationAddress = {
  17000: '0xBA3Ce58a674f3097C9450E2c9ae04BaBBd60e3b3',
  167009: '0x7A13F9E2236C234907f53Ea60818f94928b5D540',
} as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBA3Ce58a674f3097C9450E2c9ae04BaBBd60e3b3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7A13F9E2236C234907f53Ea60818f94928b5D540)
 */
export const incentivesV2ImplementationConfig = {
  address: incentivesV2ImplementationAddress,
  abi: incentivesV2ImplementationAbi,
} as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// LiquidationLogic
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xDf8B8Bf7dD0b9564dbE2251e4A253F0bD37a1824)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x8a24Ff16329BDe7fDF0caA9B0171a2acC4f64442)
 */
export const liquidationLogicAbi = [
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'asset',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'totalDebt',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'IsolationModeTotalDebtUpdated',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'collateralAsset',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'debtAsset',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      { name: 'user', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'debtToCover',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'liquidatedCollateralAmount',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'liquidator',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
      {
        name: 'receiveAToken',
        internalType: 'bool',
        type: 'bool',
        indexed: false,
      },
    ],
    name: 'LiquidationCall',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'reserve',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'liquidityRate',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'stableBorrowRate',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'variableBorrowRate',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'liquidityIndex',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'variableBorrowIndex',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'ReserveDataUpdated',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'reserve',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      { name: 'user', internalType: 'address', type: 'address', indexed: true },
    ],
    name: 'ReserveUsedAsCollateralDisabled',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'reserve',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      { name: 'user', internalType: 'address', type: 'address', indexed: true },
    ],
    name: 'ReserveUsedAsCollateralEnabled',
  },
  {
    type: 'function',
    inputs: [],
    name: 'CLOSE_FACTOR_HF_THRESHOLD',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'MAX_LIQUIDATION_CLOSE_FACTOR',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
] as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xDf8B8Bf7dD0b9564dbE2251e4A253F0bD37a1824)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x8a24Ff16329BDe7fDF0caA9B0171a2acC4f64442)
 */
export const liquidationLogicAddress = {
  17000: '0xDf8B8Bf7dD0b9564dbE2251e4A253F0bD37a1824',
  167009: '0x8a24Ff16329BDe7fDF0caA9B0171a2acC4f64442',
} as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xDf8B8Bf7dD0b9564dbE2251e4A253F0bD37a1824)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x8a24Ff16329BDe7fDF0caA9B0171a2acC4f64442)
 */
export const liquidationLogicConfig = {
  address: liquidationLogicAddress,
  abi: liquidationLogicAbi,
} as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// MockFlashLoanReceiver
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x512132149bf29C4A64aD019BA8b4f45fEb6B00c7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2fBD9d72fc46f9Db7F6e7ed9c63723900971e256)
 */
export const mockFlashLoanReceiverAbi = [
  {
    type: 'constructor',
    inputs: [
      {
        name: 'provider',
        internalType: 'contract IPoolAddressesProvider',
        type: 'address',
      },
    ],
    stateMutability: 'nonpayable',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: '_assets',
        internalType: 'address[]',
        type: 'address[]',
        indexed: false,
      },
      {
        name: '_amounts',
        internalType: 'uint256[]',
        type: 'uint256[]',
        indexed: false,
      },
      {
        name: '_premiums',
        internalType: 'uint256[]',
        type: 'uint256[]',
        indexed: false,
      },
    ],
    name: 'ExecutedWithFail',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: '_assets',
        internalType: 'address[]',
        type: 'address[]',
        indexed: false,
      },
      {
        name: '_amounts',
        internalType: 'uint256[]',
        type: 'uint256[]',
        indexed: false,
      },
      {
        name: '_premiums',
        internalType: 'uint256[]',
        type: 'uint256[]',
        indexed: false,
      },
    ],
    name: 'ExecutedWithSuccess',
  },
  {
    type: 'function',
    inputs: [],
    name: 'ADDRESSES_PROVIDER',
    outputs: [
      {
        name: '',
        internalType: 'contract IPoolAddressesProvider',
        type: 'address',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'POOL',
    outputs: [{ name: '', internalType: 'contract IPool', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'assets', internalType: 'address[]', type: 'address[]' },
      { name: 'amounts', internalType: 'uint256[]', type: 'uint256[]' },
      { name: 'premiums', internalType: 'uint256[]', type: 'uint256[]' },
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'bytes', type: 'bytes' },
    ],
    name: 'executeOperation',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getAmountToApprove',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'amountToApprove', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'setAmountToApprove',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'fail', internalType: 'bool', type: 'bool' }],
    name: 'setFailExecutionTransfer',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'flag', internalType: 'bool', type: 'bool' }],
    name: 'setSimulateEOA',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'simulateEOA',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
] as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x512132149bf29C4A64aD019BA8b4f45fEb6B00c7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2fBD9d72fc46f9Db7F6e7ed9c63723900971e256)
 */
export const mockFlashLoanReceiverAddress = {
  17000: '0x512132149bf29C4A64aD019BA8b4f45fEb6B00c7',
  167009: '0x2fBD9d72fc46f9Db7F6e7ed9c63723900971e256',
} as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x512132149bf29C4A64aD019BA8b4f45fEb6B00c7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2fBD9d72fc46f9Db7F6e7ed9c63723900971e256)
 */
export const mockFlashLoanReceiverConfig = {
  address: mockFlashLoanReceiverAddress,
  abi: mockFlashLoanReceiverAbi,
} as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Pool-Implementation
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const poolImplementationAbi = [
  {
    type: 'constructor',
    inputs: [
      {
        name: 'provider',
        internalType: 'contract IPoolAddressesProvider',
        type: 'address',
      },
    ],
    stateMutability: 'nonpayable',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'reserve',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'backer',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'amount',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      { name: 'fee', internalType: 'uint256', type: 'uint256', indexed: false },
    ],
    name: 'BackUnbacked',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'reserve',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'user',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
      {
        name: 'onBehalfOf',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'amount',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'interestRateMode',
        internalType: 'enum DataTypes.InterestRateMode',
        type: 'uint8',
        indexed: false,
      },
      {
        name: 'borrowRate',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'referralCode',
        internalType: 'uint16',
        type: 'uint16',
        indexed: true,
      },
    ],
    name: 'Borrow',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'target',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'initiator',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
      {
        name: 'asset',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'amount',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'interestRateMode',
        internalType: 'enum DataTypes.InterestRateMode',
        type: 'uint8',
        indexed: false,
      },
      {
        name: 'premium',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'referralCode',
        internalType: 'uint16',
        type: 'uint16',
        indexed: true,
      },
    ],
    name: 'FlashLoan',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'asset',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'totalDebt',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'IsolationModeTotalDebtUpdated',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'collateralAsset',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'debtAsset',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      { name: 'user', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'debtToCover',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'liquidatedCollateralAmount',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'liquidator',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
      {
        name: 'receiveAToken',
        internalType: 'bool',
        type: 'bool',
        indexed: false,
      },
    ],
    name: 'LiquidationCall',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'reserve',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'user',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
      {
        name: 'onBehalfOf',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'amount',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'referralCode',
        internalType: 'uint16',
        type: 'uint16',
        indexed: true,
      },
    ],
    name: 'MintUnbacked',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'reserve',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'amountMinted',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'MintedToTreasury',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'reserve',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      { name: 'user', internalType: 'address', type: 'address', indexed: true },
    ],
    name: 'RebalanceStableBorrowRate',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'reserve',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      { name: 'user', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'repayer',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'amount',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'useATokens',
        internalType: 'bool',
        type: 'bool',
        indexed: false,
      },
    ],
    name: 'Repay',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'reserve',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'liquidityRate',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'stableBorrowRate',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'variableBorrowRate',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'liquidityIndex',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'variableBorrowIndex',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'ReserveDataUpdated',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'reserve',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      { name: 'user', internalType: 'address', type: 'address', indexed: true },
    ],
    name: 'ReserveUsedAsCollateralDisabled',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'reserve',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      { name: 'user', internalType: 'address', type: 'address', indexed: true },
    ],
    name: 'ReserveUsedAsCollateralEnabled',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'reserve',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'user',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
      {
        name: 'onBehalfOf',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'amount',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'referralCode',
        internalType: 'uint16',
        type: 'uint16',
        indexed: true,
      },
    ],
    name: 'Supply',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'reserve',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      { name: 'user', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'interestRateMode',
        internalType: 'enum DataTypes.InterestRateMode',
        type: 'uint8',
        indexed: false,
      },
    ],
    name: 'SwapBorrowRateMode',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'user', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'categoryId',
        internalType: 'uint8',
        type: 'uint8',
        indexed: false,
      },
    ],
    name: 'UserEModeSet',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'reserve',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      { name: 'user', internalType: 'address', type: 'address', indexed: true },
      { name: 'to', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'amount',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Withdraw',
  },
  {
    type: 'function',
    inputs: [],
    name: 'ADDRESSES_PROVIDER',
    outputs: [
      {
        name: '',
        internalType: 'contract IPoolAddressesProvider',
        type: 'address',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'BRIDGE_PROTOCOL_FEE',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'FLASHLOAN_PREMIUM_TOTAL',
    outputs: [{ name: '', internalType: 'uint128', type: 'uint128' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'FLASHLOAN_PREMIUM_TO_PROTOCOL',
    outputs: [{ name: '', internalType: 'uint128', type: 'uint128' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'MAX_NUMBER_RESERVES',
    outputs: [{ name: '', internalType: 'uint16', type: 'uint16' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'MAX_STABLE_RATE_BORROW_SIZE_PERCENT',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'POOL_REVISION',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'asset', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
      { name: 'fee', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'backUnbacked',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'asset', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
      { name: 'interestRateMode', internalType: 'uint256', type: 'uint256' },
      { name: 'referralCode', internalType: 'uint16', type: 'uint16' },
      { name: 'onBehalfOf', internalType: 'address', type: 'address' },
    ],
    name: 'borrow',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'id', internalType: 'uint8', type: 'uint8' },
      {
        name: 'category',
        internalType: 'struct DataTypes.EModeCategory',
        type: 'tuple',
        components: [
          { name: 'ltv', internalType: 'uint16', type: 'uint16' },
          {
            name: 'liquidationThreshold',
            internalType: 'uint16',
            type: 'uint16',
          },
          { name: 'liquidationBonus', internalType: 'uint16', type: 'uint16' },
          { name: 'priceSource', internalType: 'address', type: 'address' },
          { name: 'label', internalType: 'string', type: 'string' },
        ],
      },
    ],
    name: 'configureEModeCategory',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'asset', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
      { name: 'onBehalfOf', internalType: 'address', type: 'address' },
      { name: 'referralCode', internalType: 'uint16', type: 'uint16' },
    ],
    name: 'deposit',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'asset', internalType: 'address', type: 'address' }],
    name: 'dropReserve',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'asset', internalType: 'address', type: 'address' },
      { name: 'from', internalType: 'address', type: 'address' },
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
      { name: 'balanceFromBefore', internalType: 'uint256', type: 'uint256' },
      { name: 'balanceToBefore', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'finalizeTransfer',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'receiverAddress', internalType: 'address', type: 'address' },
      { name: 'assets', internalType: 'address[]', type: 'address[]' },
      { name: 'amounts', internalType: 'uint256[]', type: 'uint256[]' },
      {
        name: 'interestRateModes',
        internalType: 'uint256[]',
        type: 'uint256[]',
      },
      { name: 'onBehalfOf', internalType: 'address', type: 'address' },
      { name: 'params', internalType: 'bytes', type: 'bytes' },
      { name: 'referralCode', internalType: 'uint16', type: 'uint16' },
    ],
    name: 'flashLoan',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'receiverAddress', internalType: 'address', type: 'address' },
      { name: 'asset', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
      { name: 'params', internalType: 'bytes', type: 'bytes' },
      { name: 'referralCode', internalType: 'uint16', type: 'uint16' },
    ],
    name: 'flashLoanSimple',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'asset', internalType: 'address', type: 'address' }],
    name: 'getConfiguration',
    outputs: [
      {
        name: '',
        internalType: 'struct DataTypes.ReserveConfigurationMap',
        type: 'tuple',
        components: [
          { name: 'data', internalType: 'uint256', type: 'uint256' },
        ],
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'id', internalType: 'uint8', type: 'uint8' }],
    name: 'getEModeCategoryData',
    outputs: [
      {
        name: '',
        internalType: 'struct DataTypes.EModeCategory',
        type: 'tuple',
        components: [
          { name: 'ltv', internalType: 'uint16', type: 'uint16' },
          {
            name: 'liquidationThreshold',
            internalType: 'uint16',
            type: 'uint16',
          },
          { name: 'liquidationBonus', internalType: 'uint16', type: 'uint16' },
          { name: 'priceSource', internalType: 'address', type: 'address' },
          { name: 'label', internalType: 'string', type: 'string' },
        ],
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'id', internalType: 'uint16', type: 'uint16' }],
    name: 'getReserveAddressById',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'asset', internalType: 'address', type: 'address' }],
    name: 'getReserveData',
    outputs: [
      {
        name: '',
        internalType: 'struct DataTypes.ReserveData',
        type: 'tuple',
        components: [
          {
            name: 'configuration',
            internalType: 'struct DataTypes.ReserveConfigurationMap',
            type: 'tuple',
            components: [
              { name: 'data', internalType: 'uint256', type: 'uint256' },
            ],
          },
          { name: 'liquidityIndex', internalType: 'uint128', type: 'uint128' },
          {
            name: 'currentLiquidityRate',
            internalType: 'uint128',
            type: 'uint128',
          },
          {
            name: 'variableBorrowIndex',
            internalType: 'uint128',
            type: 'uint128',
          },
          {
            name: 'currentVariableBorrowRate',
            internalType: 'uint128',
            type: 'uint128',
          },
          {
            name: 'currentStableBorrowRate',
            internalType: 'uint128',
            type: 'uint128',
          },
          {
            name: 'lastUpdateTimestamp',
            internalType: 'uint40',
            type: 'uint40',
          },
          { name: 'id', internalType: 'uint16', type: 'uint16' },
          { name: 'aTokenAddress', internalType: 'address', type: 'address' },
          {
            name: 'stableDebtTokenAddress',
            internalType: 'address',
            type: 'address',
          },
          {
            name: 'variableDebtTokenAddress',
            internalType: 'address',
            type: 'address',
          },
          {
            name: 'interestRateStrategyAddress',
            internalType: 'address',
            type: 'address',
          },
          {
            name: 'accruedToTreasury',
            internalType: 'uint128',
            type: 'uint128',
          },
          { name: 'unbacked', internalType: 'uint128', type: 'uint128' },
          {
            name: 'isolationModeTotalDebt',
            internalType: 'uint128',
            type: 'uint128',
          },
        ],
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'asset', internalType: 'address', type: 'address' }],
    name: 'getReserveNormalizedIncome',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'asset', internalType: 'address', type: 'address' }],
    name: 'getReserveNormalizedVariableDebt',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getReservesList',
    outputs: [{ name: '', internalType: 'address[]', type: 'address[]' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'user', internalType: 'address', type: 'address' }],
    name: 'getUserAccountData',
    outputs: [
      { name: 'totalCollateralBase', internalType: 'uint256', type: 'uint256' },
      { name: 'totalDebtBase', internalType: 'uint256', type: 'uint256' },
      {
        name: 'availableBorrowsBase',
        internalType: 'uint256',
        type: 'uint256',
      },
      {
        name: 'currentLiquidationThreshold',
        internalType: 'uint256',
        type: 'uint256',
      },
      { name: 'ltv', internalType: 'uint256', type: 'uint256' },
      { name: 'healthFactor', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'user', internalType: 'address', type: 'address' }],
    name: 'getUserConfiguration',
    outputs: [
      {
        name: '',
        internalType: 'struct DataTypes.UserConfigurationMap',
        type: 'tuple',
        components: [
          { name: 'data', internalType: 'uint256', type: 'uint256' },
        ],
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'user', internalType: 'address', type: 'address' }],
    name: 'getUserEMode',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'asset', internalType: 'address', type: 'address' },
      { name: 'aTokenAddress', internalType: 'address', type: 'address' },
      { name: 'stableDebtAddress', internalType: 'address', type: 'address' },
      { name: 'variableDebtAddress', internalType: 'address', type: 'address' },
      {
        name: 'interestRateStrategyAddress',
        internalType: 'address',
        type: 'address',
      },
    ],
    name: 'initReserve',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'provider',
        internalType: 'contract IPoolAddressesProvider',
        type: 'address',
      },
    ],
    name: 'initialize',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'collateralAsset', internalType: 'address', type: 'address' },
      { name: 'debtAsset', internalType: 'address', type: 'address' },
      { name: 'user', internalType: 'address', type: 'address' },
      { name: 'debtToCover', internalType: 'uint256', type: 'uint256' },
      { name: 'receiveAToken', internalType: 'bool', type: 'bool' },
    ],
    name: 'liquidationCall',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'assets', internalType: 'address[]', type: 'address[]' }],
    name: 'mintToTreasury',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'asset', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
      { name: 'onBehalfOf', internalType: 'address', type: 'address' },
      { name: 'referralCode', internalType: 'uint16', type: 'uint16' },
    ],
    name: 'mintUnbacked',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'asset', internalType: 'address', type: 'address' },
      { name: 'user', internalType: 'address', type: 'address' },
    ],
    name: 'rebalanceStableBorrowRate',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'asset', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
      { name: 'interestRateMode', internalType: 'uint256', type: 'uint256' },
      { name: 'onBehalfOf', internalType: 'address', type: 'address' },
    ],
    name: 'repay',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'asset', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
      { name: 'interestRateMode', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'repayWithATokens',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'asset', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
      { name: 'interestRateMode', internalType: 'uint256', type: 'uint256' },
      { name: 'onBehalfOf', internalType: 'address', type: 'address' },
      { name: 'deadline', internalType: 'uint256', type: 'uint256' },
      { name: 'permitV', internalType: 'uint8', type: 'uint8' },
      { name: 'permitR', internalType: 'bytes32', type: 'bytes32' },
      { name: 'permitS', internalType: 'bytes32', type: 'bytes32' },
    ],
    name: 'repayWithPermit',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'token', internalType: 'address', type: 'address' },
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'rescueTokens',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'asset', internalType: 'address', type: 'address' }],
    name: 'resetIsolationModeTotalDebt',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'asset', internalType: 'address', type: 'address' },
      {
        name: 'configuration',
        internalType: 'struct DataTypes.ReserveConfigurationMap',
        type: 'tuple',
        components: [
          { name: 'data', internalType: 'uint256', type: 'uint256' },
        ],
      },
    ],
    name: 'setConfiguration',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'asset', internalType: 'address', type: 'address' },
      { name: 'rateStrategyAddress', internalType: 'address', type: 'address' },
    ],
    name: 'setReserveInterestRateStrategyAddress',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'categoryId', internalType: 'uint8', type: 'uint8' }],
    name: 'setUserEMode',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'asset', internalType: 'address', type: 'address' },
      { name: 'useAsCollateral', internalType: 'bool', type: 'bool' },
    ],
    name: 'setUserUseReserveAsCollateral',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'asset', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
      { name: 'onBehalfOf', internalType: 'address', type: 'address' },
      { name: 'referralCode', internalType: 'uint16', type: 'uint16' },
    ],
    name: 'supply',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'asset', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
      { name: 'onBehalfOf', internalType: 'address', type: 'address' },
      { name: 'referralCode', internalType: 'uint16', type: 'uint16' },
      { name: 'deadline', internalType: 'uint256', type: 'uint256' },
      { name: 'permitV', internalType: 'uint8', type: 'uint8' },
      { name: 'permitR', internalType: 'bytes32', type: 'bytes32' },
      { name: 'permitS', internalType: 'bytes32', type: 'bytes32' },
    ],
    name: 'supplyWithPermit',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'asset', internalType: 'address', type: 'address' },
      { name: 'interestRateMode', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'swapBorrowRateMode',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'protocolFee', internalType: 'uint256', type: 'uint256' }],
    name: 'updateBridgeProtocolFee',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'flashLoanPremiumTotal',
        internalType: 'uint128',
        type: 'uint128',
      },
      {
        name: 'flashLoanPremiumToProtocol',
        internalType: 'uint128',
        type: 'uint128',
      },
    ],
    name: 'updateFlashloanPremiums',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'asset', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
      { name: 'to', internalType: 'address', type: 'address' },
    ],
    name: 'withdraw',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'nonpayable',
  },
] as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const poolImplementationAddress = {
  17000: '0xF32fc8E3DF99A76112381568abf860bE3cc4D11C',
  167009: '0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420',
} as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const poolImplementationConfig = {
  address: poolImplementationAddress,
  abi: poolImplementationAbi,
} as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Pool-Proxy-Taiko
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xC67c87a333E33d934d831AE8c6CE4Da47C3809fA)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x625B9FAefF9A9c843ba3fDe62C6E3bAb1a48eE78)
 */
export const poolProxyTaikoAbi = [
  {
    type: 'constructor',
    inputs: [{ name: 'admin', internalType: 'address', type: 'address' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'implementation',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'Upgraded',
  },
  { type: 'fallback', stateMutability: 'payable' },
  {
    type: 'function',
    inputs: [],
    name: 'admin',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'implementation',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: '_logic', internalType: 'address', type: 'address' },
      { name: '_data', internalType: 'bytes', type: 'bytes' },
    ],
    name: 'initialize',
    outputs: [],
    stateMutability: 'payable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'newImplementation', internalType: 'address', type: 'address' },
    ],
    name: 'upgradeTo',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'newImplementation', internalType: 'address', type: 'address' },
      { name: 'data', internalType: 'bytes', type: 'bytes' },
    ],
    name: 'upgradeToAndCall',
    outputs: [],
    stateMutability: 'payable',
  },
] as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xC67c87a333E33d934d831AE8c6CE4Da47C3809fA)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x625B9FAefF9A9c843ba3fDe62C6E3bAb1a48eE78)
 */
export const poolProxyTaikoAddress = {
  17000: '0xC67c87a333E33d934d831AE8c6CE4Da47C3809fA',
  167009: '0x625B9FAefF9A9c843ba3fDe62C6E3bAb1a48eE78',
} as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xC67c87a333E33d934d831AE8c6CE4Da47C3809fA)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x625B9FAefF9A9c843ba3fDe62C6E3bAb1a48eE78)
 */
export const poolProxyTaikoConfig = {
  address: poolProxyTaikoAddress,
  abi: poolProxyTaikoAbi,
} as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// PoolAddressesProvider-Taiko
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xAb31CA5C925921d92750190732FdC347C23F9987)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa357E6d3Fdea67F4F2D60fC22F037551682AAd95)
 */
export const poolAddressesProviderTaikoAbi = [
  {
    type: 'constructor',
    inputs: [
      { name: 'marketId', internalType: 'string', type: 'string' },
      { name: 'owner', internalType: 'address', type: 'address' },
    ],
    stateMutability: 'nonpayable',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'oldAddress',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'newAddress',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'ACLAdminUpdated',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'oldAddress',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'newAddress',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'ACLManagerUpdated',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'id', internalType: 'bytes32', type: 'bytes32', indexed: true },
      {
        name: 'oldAddress',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'newAddress',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'AddressSet',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'id', internalType: 'bytes32', type: 'bytes32', indexed: true },
      {
        name: 'proxyAddress',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'oldImplementationAddress',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
      {
        name: 'newImplementationAddress',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'AddressSetAsProxy',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'oldMarketId',
        internalType: 'string',
        type: 'string',
        indexed: true,
      },
      {
        name: 'newMarketId',
        internalType: 'string',
        type: 'string',
        indexed: true,
      },
    ],
    name: 'MarketIdSet',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'previousOwner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'newOwner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'OwnershipTransferred',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'oldAddress',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'newAddress',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'PoolConfiguratorUpdated',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'oldAddress',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'newAddress',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'PoolDataProviderUpdated',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'oldAddress',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'newAddress',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'PoolUpdated',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'oldAddress',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'newAddress',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'PriceOracleSentinelUpdated',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'oldAddress',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'newAddress',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'PriceOracleUpdated',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'id', internalType: 'bytes32', type: 'bytes32', indexed: true },
      {
        name: 'proxyAddress',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'implementationAddress',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'ProxyCreated',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getACLAdmin',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getACLManager',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'id', internalType: 'bytes32', type: 'bytes32' }],
    name: 'getAddress',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getMarketId',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getPool',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getPoolConfigurator',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getPoolDataProvider',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getPriceOracle',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getPriceOracleSentinel',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'owner',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'renounceOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'newAclAdmin', internalType: 'address', type: 'address' }],
    name: 'setACLAdmin',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'newAclManager', internalType: 'address', type: 'address' },
    ],
    name: 'setACLManager',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'id', internalType: 'bytes32', type: 'bytes32' },
      { name: 'newAddress', internalType: 'address', type: 'address' },
    ],
    name: 'setAddress',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'id', internalType: 'bytes32', type: 'bytes32' },
      {
        name: 'newImplementationAddress',
        internalType: 'address',
        type: 'address',
      },
    ],
    name: 'setAddressAsProxy',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'newMarketId', internalType: 'string', type: 'string' }],
    name: 'setMarketId',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'newPoolConfiguratorImpl',
        internalType: 'address',
        type: 'address',
      },
    ],
    name: 'setPoolConfiguratorImpl',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'newDataProvider', internalType: 'address', type: 'address' },
    ],
    name: 'setPoolDataProvider',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'newPoolImpl', internalType: 'address', type: 'address' }],
    name: 'setPoolImpl',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'newPriceOracle', internalType: 'address', type: 'address' },
    ],
    name: 'setPriceOracle',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'newPriceOracleSentinel',
        internalType: 'address',
        type: 'address',
      },
    ],
    name: 'setPriceOracleSentinel',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'newOwner', internalType: 'address', type: 'address' }],
    name: 'transferOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
  },
] as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xAb31CA5C925921d92750190732FdC347C23F9987)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa357E6d3Fdea67F4F2D60fC22F037551682AAd95)
 */
export const poolAddressesProviderTaikoAddress = {
  17000: '0xAb31CA5C925921d92750190732FdC347C23F9987',
  167009: '0xa357E6d3Fdea67F4F2D60fC22F037551682AAd95',
} as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xAb31CA5C925921d92750190732FdC347C23F9987)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa357E6d3Fdea67F4F2D60fC22F037551682AAd95)
 */
export const poolAddressesProviderTaikoConfig = {
  address: poolAddressesProviderTaikoAddress,
  abi: poolAddressesProviderTaikoAbi,
} as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// PoolAddressesProviderRegistry
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x79DD82A3f64a91F084dc22ceBa3138e75F573319)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7B354b408A11fD09b1Cf275d83DC05A8A3b2eE52)
 */
export const poolAddressesProviderRegistryAbi = [
  {
    type: 'constructor',
    inputs: [{ name: 'owner', internalType: 'address', type: 'address' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'addressesProvider',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      { name: 'id', internalType: 'uint256', type: 'uint256', indexed: true },
    ],
    name: 'AddressesProviderRegistered',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'addressesProvider',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      { name: 'id', internalType: 'uint256', type: 'uint256', indexed: true },
    ],
    name: 'AddressesProviderUnregistered',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'previousOwner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'newOwner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'OwnershipTransferred',
  },
  {
    type: 'function',
    inputs: [{ name: 'id', internalType: 'uint256', type: 'uint256' }],
    name: 'getAddressesProviderAddressById',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'addressesProvider', internalType: 'address', type: 'address' },
    ],
    name: 'getAddressesProviderIdByAddress',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getAddressesProvidersList',
    outputs: [{ name: '', internalType: 'address[]', type: 'address[]' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'owner',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'provider', internalType: 'address', type: 'address' },
      { name: 'id', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'registerAddressesProvider',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'renounceOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'newOwner', internalType: 'address', type: 'address' }],
    name: 'transferOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'provider', internalType: 'address', type: 'address' }],
    name: 'unregisterAddressesProvider',
    outputs: [],
    stateMutability: 'nonpayable',
  },
] as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x79DD82A3f64a91F084dc22ceBa3138e75F573319)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7B354b408A11fD09b1Cf275d83DC05A8A3b2eE52)
 */
export const poolAddressesProviderRegistryAddress = {
  17000: '0x79DD82A3f64a91F084dc22ceBa3138e75F573319',
  167009: '0x7B354b408A11fD09b1Cf275d83DC05A8A3b2eE52',
} as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x79DD82A3f64a91F084dc22ceBa3138e75F573319)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7B354b408A11fD09b1Cf275d83DC05A8A3b2eE52)
 */
export const poolAddressesProviderRegistryConfig = {
  address: poolAddressesProviderRegistryAddress,
  abi: poolAddressesProviderRegistryAbi,
} as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// PoolConfigurator-Implementation
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x841df6066adc8b81b1EA401294Dc051e0E43EeBc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA6F7AAcb380B07aE906a1C77873256525718Ed1a)
 */
export const poolConfiguratorImplementationAbi = [
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'asset',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'proxy',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'implementation',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'ATokenUpgraded',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'asset',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'oldBorrowCap',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'newBorrowCap',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'BorrowCapChanged',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'asset',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
      {
        name: 'borrowable',
        internalType: 'bool',
        type: 'bool',
        indexed: false,
      },
    ],
    name: 'BorrowableInIsolationChanged',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'oldBridgeProtocolFee',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'newBridgeProtocolFee',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'BridgeProtocolFeeUpdated',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'asset',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      { name: 'ltv', internalType: 'uint256', type: 'uint256', indexed: false },
      {
        name: 'liquidationThreshold',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'liquidationBonus',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'CollateralConfigurationChanged',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'asset',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'oldDebtCeiling',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'newDebtCeiling',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'DebtCeilingChanged',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'asset',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'oldCategoryId',
        internalType: 'uint8',
        type: 'uint8',
        indexed: false,
      },
      {
        name: 'newCategoryId',
        internalType: 'uint8',
        type: 'uint8',
        indexed: false,
      },
    ],
    name: 'EModeAssetCategoryChanged',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'categoryId',
        internalType: 'uint8',
        type: 'uint8',
        indexed: true,
      },
      { name: 'ltv', internalType: 'uint256', type: 'uint256', indexed: false },
      {
        name: 'liquidationThreshold',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'liquidationBonus',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'oracle',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
      { name: 'label', internalType: 'string', type: 'string', indexed: false },
    ],
    name: 'EModeCategoryAdded',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'oldFlashloanPremiumToProtocol',
        internalType: 'uint128',
        type: 'uint128',
        indexed: false,
      },
      {
        name: 'newFlashloanPremiumToProtocol',
        internalType: 'uint128',
        type: 'uint128',
        indexed: false,
      },
    ],
    name: 'FlashloanPremiumToProtocolUpdated',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'oldFlashloanPremiumTotal',
        internalType: 'uint128',
        type: 'uint128',
        indexed: false,
      },
      {
        name: 'newFlashloanPremiumTotal',
        internalType: 'uint128',
        type: 'uint128',
        indexed: false,
      },
    ],
    name: 'FlashloanPremiumTotalUpdated',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'asset',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'oldFee',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'newFee',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'LiquidationProtocolFeeChanged',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'asset',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      { name: 'active', internalType: 'bool', type: 'bool', indexed: false },
    ],
    name: 'ReserveActive',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'asset',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      { name: 'enabled', internalType: 'bool', type: 'bool', indexed: false },
    ],
    name: 'ReserveBorrowing',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'asset',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'ReserveDropped',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'asset',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'oldReserveFactor',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'newReserveFactor',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'ReserveFactorChanged',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'asset',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      { name: 'enabled', internalType: 'bool', type: 'bool', indexed: false },
    ],
    name: 'ReserveFlashLoaning',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'asset',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      { name: 'frozen', internalType: 'bool', type: 'bool', indexed: false },
    ],
    name: 'ReserveFrozen',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'asset',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'aToken',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'stableDebtToken',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
      {
        name: 'variableDebtToken',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
      {
        name: 'interestRateStrategyAddress',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
    ],
    name: 'ReserveInitialized',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'asset',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'oldStrategy',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
      {
        name: 'newStrategy',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
    ],
    name: 'ReserveInterestRateStrategyChanged',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'asset',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      { name: 'paused', internalType: 'bool', type: 'bool', indexed: false },
    ],
    name: 'ReservePaused',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'asset',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      { name: 'enabled', internalType: 'bool', type: 'bool', indexed: false },
    ],
    name: 'ReserveStableRateBorrowing',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'asset',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      { name: 'oldState', internalType: 'bool', type: 'bool', indexed: false },
      { name: 'newState', internalType: 'bool', type: 'bool', indexed: false },
    ],
    name: 'SiloedBorrowingChanged',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'asset',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'proxy',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'implementation',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'StableDebtTokenUpgraded',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'asset',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'oldSupplyCap',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'newSupplyCap',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'SupplyCapChanged',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'asset',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'oldUnbackedMintCap',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'newUnbackedMintCap',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'UnbackedMintCapChanged',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'asset',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'proxy',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'implementation',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'VariableDebtTokenUpgraded',
  },
  {
    type: 'function',
    inputs: [],
    name: 'CONFIGURATOR_REVISION',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'asset', internalType: 'address', type: 'address' },
      { name: 'ltv', internalType: 'uint256', type: 'uint256' },
      {
        name: 'liquidationThreshold',
        internalType: 'uint256',
        type: 'uint256',
      },
      { name: 'liquidationBonus', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'configureReserveAsCollateral',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'asset', internalType: 'address', type: 'address' }],
    name: 'dropReserve',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'input',
        internalType: 'struct ConfiguratorInputTypes.InitReserveInput[]',
        type: 'tuple[]',
        components: [
          { name: 'aTokenImpl', internalType: 'address', type: 'address' },
          {
            name: 'stableDebtTokenImpl',
            internalType: 'address',
            type: 'address',
          },
          {
            name: 'variableDebtTokenImpl',
            internalType: 'address',
            type: 'address',
          },
          {
            name: 'underlyingAssetDecimals',
            internalType: 'uint8',
            type: 'uint8',
          },
          {
            name: 'interestRateStrategyAddress',
            internalType: 'address',
            type: 'address',
          },
          { name: 'underlyingAsset', internalType: 'address', type: 'address' },
          { name: 'treasury', internalType: 'address', type: 'address' },
          {
            name: 'incentivesController',
            internalType: 'address',
            type: 'address',
          },
          { name: 'aTokenName', internalType: 'string', type: 'string' },
          { name: 'aTokenSymbol', internalType: 'string', type: 'string' },
          {
            name: 'variableDebtTokenName',
            internalType: 'string',
            type: 'string',
          },
          {
            name: 'variableDebtTokenSymbol',
            internalType: 'string',
            type: 'string',
          },
          {
            name: 'stableDebtTokenName',
            internalType: 'string',
            type: 'string',
          },
          {
            name: 'stableDebtTokenSymbol',
            internalType: 'string',
            type: 'string',
          },
          { name: 'params', internalType: 'bytes', type: 'bytes' },
        ],
      },
    ],
    name: 'initReserves',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'provider',
        internalType: 'contract IPoolAddressesProvider',
        type: 'address',
      },
    ],
    name: 'initialize',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'asset', internalType: 'address', type: 'address' },
      { name: 'newCategoryId', internalType: 'uint8', type: 'uint8' },
    ],
    name: 'setAssetEModeCategory',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'asset', internalType: 'address', type: 'address' },
      { name: 'newBorrowCap', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'setBorrowCap',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'asset', internalType: 'address', type: 'address' },
      { name: 'borrowable', internalType: 'bool', type: 'bool' },
    ],
    name: 'setBorrowableInIsolation',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'asset', internalType: 'address', type: 'address' },
      { name: 'newDebtCeiling', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'setDebtCeiling',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'categoryId', internalType: 'uint8', type: 'uint8' },
      { name: 'ltv', internalType: 'uint16', type: 'uint16' },
      { name: 'liquidationThreshold', internalType: 'uint16', type: 'uint16' },
      { name: 'liquidationBonus', internalType: 'uint16', type: 'uint16' },
      { name: 'oracle', internalType: 'address', type: 'address' },
      { name: 'label', internalType: 'string', type: 'string' },
    ],
    name: 'setEModeCategory',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'asset', internalType: 'address', type: 'address' },
      { name: 'newFee', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'setLiquidationProtocolFee',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'paused', internalType: 'bool', type: 'bool' }],
    name: 'setPoolPause',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'asset', internalType: 'address', type: 'address' },
      { name: 'active', internalType: 'bool', type: 'bool' },
    ],
    name: 'setReserveActive',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'asset', internalType: 'address', type: 'address' },
      { name: 'enabled', internalType: 'bool', type: 'bool' },
    ],
    name: 'setReserveBorrowing',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'asset', internalType: 'address', type: 'address' },
      { name: 'newReserveFactor', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'setReserveFactor',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'asset', internalType: 'address', type: 'address' },
      { name: 'enabled', internalType: 'bool', type: 'bool' },
    ],
    name: 'setReserveFlashLoaning',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'asset', internalType: 'address', type: 'address' },
      { name: 'freeze', internalType: 'bool', type: 'bool' },
    ],
    name: 'setReserveFreeze',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'asset', internalType: 'address', type: 'address' },
      {
        name: 'newRateStrategyAddress',
        internalType: 'address',
        type: 'address',
      },
    ],
    name: 'setReserveInterestRateStrategyAddress',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'asset', internalType: 'address', type: 'address' },
      { name: 'paused', internalType: 'bool', type: 'bool' },
    ],
    name: 'setReservePause',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'asset', internalType: 'address', type: 'address' },
      { name: 'enabled', internalType: 'bool', type: 'bool' },
    ],
    name: 'setReserveStableRateBorrowing',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'asset', internalType: 'address', type: 'address' },
      { name: 'newSiloed', internalType: 'bool', type: 'bool' },
    ],
    name: 'setSiloedBorrowing',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'asset', internalType: 'address', type: 'address' },
      { name: 'newSupplyCap', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'setSupplyCap',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'asset', internalType: 'address', type: 'address' },
      { name: 'newUnbackedMintCap', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'setUnbackedMintCap',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'input',
        internalType: 'struct ConfiguratorInputTypes.UpdateATokenInput',
        type: 'tuple',
        components: [
          { name: 'asset', internalType: 'address', type: 'address' },
          { name: 'treasury', internalType: 'address', type: 'address' },
          {
            name: 'incentivesController',
            internalType: 'address',
            type: 'address',
          },
          { name: 'name', internalType: 'string', type: 'string' },
          { name: 'symbol', internalType: 'string', type: 'string' },
          { name: 'implementation', internalType: 'address', type: 'address' },
          { name: 'params', internalType: 'bytes', type: 'bytes' },
        ],
      },
    ],
    name: 'updateAToken',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'newBridgeProtocolFee',
        internalType: 'uint256',
        type: 'uint256',
      },
    ],
    name: 'updateBridgeProtocolFee',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'newFlashloanPremiumToProtocol',
        internalType: 'uint128',
        type: 'uint128',
      },
    ],
    name: 'updateFlashloanPremiumToProtocol',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'newFlashloanPremiumTotal',
        internalType: 'uint128',
        type: 'uint128',
      },
    ],
    name: 'updateFlashloanPremiumTotal',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'input',
        internalType: 'struct ConfiguratorInputTypes.UpdateDebtTokenInput',
        type: 'tuple',
        components: [
          { name: 'asset', internalType: 'address', type: 'address' },
          {
            name: 'incentivesController',
            internalType: 'address',
            type: 'address',
          },
          { name: 'name', internalType: 'string', type: 'string' },
          { name: 'symbol', internalType: 'string', type: 'string' },
          { name: 'implementation', internalType: 'address', type: 'address' },
          { name: 'params', internalType: 'bytes', type: 'bytes' },
        ],
      },
    ],
    name: 'updateStableDebtToken',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'input',
        internalType: 'struct ConfiguratorInputTypes.UpdateDebtTokenInput',
        type: 'tuple',
        components: [
          { name: 'asset', internalType: 'address', type: 'address' },
          {
            name: 'incentivesController',
            internalType: 'address',
            type: 'address',
          },
          { name: 'name', internalType: 'string', type: 'string' },
          { name: 'symbol', internalType: 'string', type: 'string' },
          { name: 'implementation', internalType: 'address', type: 'address' },
          { name: 'params', internalType: 'bytes', type: 'bytes' },
        ],
      },
    ],
    name: 'updateVariableDebtToken',
    outputs: [],
    stateMutability: 'nonpayable',
  },
] as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x841df6066adc8b81b1EA401294Dc051e0E43EeBc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA6F7AAcb380B07aE906a1C77873256525718Ed1a)
 */
export const poolConfiguratorImplementationAddress = {
  17000: '0x841df6066adc8b81b1EA401294Dc051e0E43EeBc',
  167009: '0xA6F7AAcb380B07aE906a1C77873256525718Ed1a',
} as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x841df6066adc8b81b1EA401294Dc051e0E43EeBc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA6F7AAcb380B07aE906a1C77873256525718Ed1a)
 */
export const poolConfiguratorImplementationConfig = {
  address: poolConfiguratorImplementationAddress,
  abi: poolConfiguratorImplementationAbi,
} as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// PoolConfigurator-Proxy-Taiko
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x9aDFE6F23FD709e1be5C6213531213b2789563B3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x617c6dB48B462541aB84F12f7696346f33473F90)
 */
export const poolConfiguratorProxyTaikoAbi = [
  {
    type: 'constructor',
    inputs: [{ name: 'admin', internalType: 'address', type: 'address' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'implementation',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'Upgraded',
  },
  { type: 'fallback', stateMutability: 'payable' },
  {
    type: 'function',
    inputs: [],
    name: 'admin',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'implementation',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: '_logic', internalType: 'address', type: 'address' },
      { name: '_data', internalType: 'bytes', type: 'bytes' },
    ],
    name: 'initialize',
    outputs: [],
    stateMutability: 'payable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'newImplementation', internalType: 'address', type: 'address' },
    ],
    name: 'upgradeTo',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'newImplementation', internalType: 'address', type: 'address' },
      { name: 'data', internalType: 'bytes', type: 'bytes' },
    ],
    name: 'upgradeToAndCall',
    outputs: [],
    stateMutability: 'payable',
  },
] as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x9aDFE6F23FD709e1be5C6213531213b2789563B3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x617c6dB48B462541aB84F12f7696346f33473F90)
 */
export const poolConfiguratorProxyTaikoAddress = {
  17000: '0x9aDFE6F23FD709e1be5C6213531213b2789563B3',
  167009: '0x617c6dB48B462541aB84F12f7696346f33473F90',
} as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x9aDFE6F23FD709e1be5C6213531213b2789563B3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x617c6dB48B462541aB84F12f7696346f33473F90)
 */
export const poolConfiguratorProxyTaikoConfig = {
  address: poolConfiguratorProxyTaikoAddress,
  abi: poolConfiguratorProxyTaikoAbi,
} as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// PoolDataProvider-Taiko
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE0c692f5e3003DD91e9ddd405cda309D15056Dc5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x3bD8FC1d1998A3fA7c80C9BAc2dA7986B1c97771)
 */
export const poolDataProviderTaikoAbi = [
  {
    type: 'constructor',
    inputs: [
      {
        name: 'addressesProvider',
        internalType: 'contract IPoolAddressesProvider',
        type: 'address',
      },
    ],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'ADDRESSES_PROVIDER',
    outputs: [
      {
        name: '',
        internalType: 'contract IPoolAddressesProvider',
        type: 'address',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'asset', internalType: 'address', type: 'address' }],
    name: 'getATokenTotalSupply',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getAllATokens',
    outputs: [
      {
        name: '',
        internalType: 'struct IPoolDataProvider.TokenData[]',
        type: 'tuple[]',
        components: [
          { name: 'symbol', internalType: 'string', type: 'string' },
          { name: 'tokenAddress', internalType: 'address', type: 'address' },
        ],
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getAllReservesTokens',
    outputs: [
      {
        name: '',
        internalType: 'struct IPoolDataProvider.TokenData[]',
        type: 'tuple[]',
        components: [
          { name: 'symbol', internalType: 'string', type: 'string' },
          { name: 'tokenAddress', internalType: 'address', type: 'address' },
        ],
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'asset', internalType: 'address', type: 'address' }],
    name: 'getDebtCeiling',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getDebtCeilingDecimals',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'pure',
  },
  {
    type: 'function',
    inputs: [{ name: 'asset', internalType: 'address', type: 'address' }],
    name: 'getFlashLoanEnabled',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'asset', internalType: 'address', type: 'address' }],
    name: 'getInterestRateStrategyAddress',
    outputs: [
      { name: 'irStrategyAddress', internalType: 'address', type: 'address' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'asset', internalType: 'address', type: 'address' }],
    name: 'getLiquidationProtocolFee',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'asset', internalType: 'address', type: 'address' }],
    name: 'getPaused',
    outputs: [{ name: 'isPaused', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'asset', internalType: 'address', type: 'address' }],
    name: 'getReserveCaps',
    outputs: [
      { name: 'borrowCap', internalType: 'uint256', type: 'uint256' },
      { name: 'supplyCap', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'asset', internalType: 'address', type: 'address' }],
    name: 'getReserveConfigurationData',
    outputs: [
      { name: 'decimals', internalType: 'uint256', type: 'uint256' },
      { name: 'ltv', internalType: 'uint256', type: 'uint256' },
      {
        name: 'liquidationThreshold',
        internalType: 'uint256',
        type: 'uint256',
      },
      { name: 'liquidationBonus', internalType: 'uint256', type: 'uint256' },
      { name: 'reserveFactor', internalType: 'uint256', type: 'uint256' },
      { name: 'usageAsCollateralEnabled', internalType: 'bool', type: 'bool' },
      { name: 'borrowingEnabled', internalType: 'bool', type: 'bool' },
      { name: 'stableBorrowRateEnabled', internalType: 'bool', type: 'bool' },
      { name: 'isActive', internalType: 'bool', type: 'bool' },
      { name: 'isFrozen', internalType: 'bool', type: 'bool' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'asset', internalType: 'address', type: 'address' }],
    name: 'getReserveData',
    outputs: [
      { name: 'unbacked', internalType: 'uint256', type: 'uint256' },
      {
        name: 'accruedToTreasuryScaled',
        internalType: 'uint256',
        type: 'uint256',
      },
      { name: 'totalAToken', internalType: 'uint256', type: 'uint256' },
      { name: 'totalStableDebt', internalType: 'uint256', type: 'uint256' },
      { name: 'totalVariableDebt', internalType: 'uint256', type: 'uint256' },
      { name: 'liquidityRate', internalType: 'uint256', type: 'uint256' },
      { name: 'variableBorrowRate', internalType: 'uint256', type: 'uint256' },
      { name: 'stableBorrowRate', internalType: 'uint256', type: 'uint256' },
      {
        name: 'averageStableBorrowRate',
        internalType: 'uint256',
        type: 'uint256',
      },
      { name: 'liquidityIndex', internalType: 'uint256', type: 'uint256' },
      { name: 'variableBorrowIndex', internalType: 'uint256', type: 'uint256' },
      { name: 'lastUpdateTimestamp', internalType: 'uint40', type: 'uint40' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'asset', internalType: 'address', type: 'address' }],
    name: 'getReserveEModeCategory',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'asset', internalType: 'address', type: 'address' }],
    name: 'getReserveTokensAddresses',
    outputs: [
      { name: 'aTokenAddress', internalType: 'address', type: 'address' },
      {
        name: 'stableDebtTokenAddress',
        internalType: 'address',
        type: 'address',
      },
      {
        name: 'variableDebtTokenAddress',
        internalType: 'address',
        type: 'address',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'asset', internalType: 'address', type: 'address' }],
    name: 'getSiloedBorrowing',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'asset', internalType: 'address', type: 'address' }],
    name: 'getTotalDebt',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'asset', internalType: 'address', type: 'address' }],
    name: 'getUnbackedMintCap',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'asset', internalType: 'address', type: 'address' },
      { name: 'user', internalType: 'address', type: 'address' },
    ],
    name: 'getUserReserveData',
    outputs: [
      {
        name: 'currentATokenBalance',
        internalType: 'uint256',
        type: 'uint256',
      },
      { name: 'currentStableDebt', internalType: 'uint256', type: 'uint256' },
      { name: 'currentVariableDebt', internalType: 'uint256', type: 'uint256' },
      { name: 'principalStableDebt', internalType: 'uint256', type: 'uint256' },
      { name: 'scaledVariableDebt', internalType: 'uint256', type: 'uint256' },
      { name: 'stableBorrowRate', internalType: 'uint256', type: 'uint256' },
      { name: 'liquidityRate', internalType: 'uint256', type: 'uint256' },
      { name: 'stableRateLastUpdated', internalType: 'uint40', type: 'uint40' },
      { name: 'usageAsCollateralEnabled', internalType: 'bool', type: 'bool' },
    ],
    stateMutability: 'view',
  },
] as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE0c692f5e3003DD91e9ddd405cda309D15056Dc5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x3bD8FC1d1998A3fA7c80C9BAc2dA7986B1c97771)
 */
export const poolDataProviderTaikoAddress = {
  17000: '0xE0c692f5e3003DD91e9ddd405cda309D15056Dc5',
  167009: '0x3bD8FC1d1998A3fA7c80C9BAc2dA7986B1c97771',
} as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE0c692f5e3003DD91e9ddd405cda309D15056Dc5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x3bD8FC1d1998A3fA7c80C9BAc2dA7986B1c97771)
 */
export const poolDataProviderTaikoConfig = {
  address: poolDataProviderTaikoAddress,
  abi: poolDataProviderTaikoAbi,
} as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// PoolLogic
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x108122C4E3df0F087Ddc41d8FA15F6390c7125D7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xF3d84dba7c4ac5FeBc53286c7E5A3F4fEd5F2Bae)
 */
export const poolLogicAbi = [
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'asset',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'totalDebt',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'IsolationModeTotalDebtUpdated',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'reserve',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'amountMinted',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'MintedToTreasury',
  },
] as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x108122C4E3df0F087Ddc41d8FA15F6390c7125D7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xF3d84dba7c4ac5FeBc53286c7E5A3F4fEd5F2Bae)
 */
export const poolLogicAddress = {
  17000: '0x108122C4E3df0F087Ddc41d8FA15F6390c7125D7',
  167009: '0xF3d84dba7c4ac5FeBc53286c7E5A3F4fEd5F2Bae',
} as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x108122C4E3df0F087Ddc41d8FA15F6390c7125D7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xF3d84dba7c4ac5FeBc53286c7E5A3F4fEd5F2Bae)
 */
export const poolLogicConfig = {
  address: poolLogicAddress,
  abi: poolLogicAbi,
} as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// PullRewardsTransferStrategy
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xcDa727FC3ab1B502D8ffb92dDA7A6F2aCF040107)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa382c7147A7c9847e38b7D236DFB572Ff3e6576F)
 */
export const pullRewardsTransferStrategyAbi = [
  {
    type: 'constructor',
    inputs: [
      {
        name: 'incentivesController',
        internalType: 'address',
        type: 'address',
      },
      { name: 'rewardsAdmin', internalType: 'address', type: 'address' },
      { name: 'rewardsVault', internalType: 'address', type: 'address' },
    ],
    stateMutability: 'nonpayable',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'caller',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'token',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      { name: 'to', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'amount',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'EmergencyWithdrawal',
  },
  {
    type: 'function',
    inputs: [
      { name: 'token', internalType: 'address', type: 'address' },
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'emergencyWithdrawal',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getIncentivesController',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getRewardsAdmin',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getRewardsVault',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'reward', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'performTransfer',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
] as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xcDa727FC3ab1B502D8ffb92dDA7A6F2aCF040107)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa382c7147A7c9847e38b7D236DFB572Ff3e6576F)
 */
export const pullRewardsTransferStrategyAddress = {
  17000: '0xcDa727FC3ab1B502D8ffb92dDA7A6F2aCF040107',
  167009: '0xa382c7147A7c9847e38b7D236DFB572Ff3e6576F',
} as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xcDa727FC3ab1B502D8ffb92dDA7A6F2aCF040107)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa382c7147A7c9847e38b7D236DFB572Ff3e6576F)
 */
export const pullRewardsTransferStrategyConfig = {
  address: pullRewardsTransferStrategyAddress,
  abi: pullRewardsTransferStrategyAbi,
} as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// ReserveStrategy-rateStrategyStableOne
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xc1Bc62b5E91Db9cBb4055F4DC9B2983d4cbc32f6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x3E4260a74E2EAc5DCdb983BCB99FafEdF215e4e5)
 */
export const reserveStrategyRateStrategyStableOneAbi = [
  {
    type: 'constructor',
    inputs: [
      {
        name: 'provider',
        internalType: 'contract IPoolAddressesProvider',
        type: 'address',
      },
      { name: 'optimalUsageRatio', internalType: 'uint256', type: 'uint256' },
      {
        name: 'baseVariableBorrowRate',
        internalType: 'uint256',
        type: 'uint256',
      },
      { name: 'variableRateSlope1', internalType: 'uint256', type: 'uint256' },
      { name: 'variableRateSlope2', internalType: 'uint256', type: 'uint256' },
      { name: 'stableRateSlope1', internalType: 'uint256', type: 'uint256' },
      { name: 'stableRateSlope2', internalType: 'uint256', type: 'uint256' },
      {
        name: 'baseStableRateOffset',
        internalType: 'uint256',
        type: 'uint256',
      },
      {
        name: 'stableRateExcessOffset',
        internalType: 'uint256',
        type: 'uint256',
      },
      {
        name: 'optimalStableToTotalDebtRatio',
        internalType: 'uint256',
        type: 'uint256',
      },
    ],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'ADDRESSES_PROVIDER',
    outputs: [
      {
        name: '',
        internalType: 'contract IPoolAddressesProvider',
        type: 'address',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'MAX_EXCESS_STABLE_TO_TOTAL_DEBT_RATIO',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'MAX_EXCESS_USAGE_RATIO',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'OPTIMAL_STABLE_TO_TOTAL_DEBT_RATIO',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'OPTIMAL_USAGE_RATIO',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'params',
        internalType: 'struct DataTypes.CalculateInterestRatesParams',
        type: 'tuple',
        components: [
          { name: 'unbacked', internalType: 'uint256', type: 'uint256' },
          { name: 'liquidityAdded', internalType: 'uint256', type: 'uint256' },
          { name: 'liquidityTaken', internalType: 'uint256', type: 'uint256' },
          { name: 'totalStableDebt', internalType: 'uint256', type: 'uint256' },
          {
            name: 'totalVariableDebt',
            internalType: 'uint256',
            type: 'uint256',
          },
          {
            name: 'averageStableBorrowRate',
            internalType: 'uint256',
            type: 'uint256',
          },
          { name: 'reserveFactor', internalType: 'uint256', type: 'uint256' },
          { name: 'reserve', internalType: 'address', type: 'address' },
          { name: 'aToken', internalType: 'address', type: 'address' },
        ],
      },
    ],
    name: 'calculateInterestRates',
    outputs: [
      { name: '', internalType: 'uint256', type: 'uint256' },
      { name: '', internalType: 'uint256', type: 'uint256' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getBaseStableBorrowRate',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getBaseVariableBorrowRate',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getMaxVariableBorrowRate',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getStableRateExcessOffset',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getStableRateSlope1',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getStableRateSlope2',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getVariableRateSlope1',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getVariableRateSlope2',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
] as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xc1Bc62b5E91Db9cBb4055F4DC9B2983d4cbc32f6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x3E4260a74E2EAc5DCdb983BCB99FafEdF215e4e5)
 */
export const reserveStrategyRateStrategyStableOneAddress = {
  17000: '0xc1Bc62b5E91Db9cBb4055F4DC9B2983d4cbc32f6',
  167009: '0x3E4260a74E2EAc5DCdb983BCB99FafEdF215e4e5',
} as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xc1Bc62b5E91Db9cBb4055F4DC9B2983d4cbc32f6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x3E4260a74E2EAc5DCdb983BCB99FafEdF215e4e5)
 */
export const reserveStrategyRateStrategyStableOneConfig = {
  address: reserveStrategyRateStrategyStableOneAddress,
  abi: reserveStrategyRateStrategyStableOneAbi,
} as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// ReserveStrategy-rateStrategyStableTwo
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBC19Ef2e78472a986BB78B09D467f4D61F9F35f3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7bBbD2a37226928d1E67CC3079aFd40204FC4531)
 */
export const reserveStrategyRateStrategyStableTwoAbi = [
  {
    type: 'constructor',
    inputs: [
      {
        name: 'provider',
        internalType: 'contract IPoolAddressesProvider',
        type: 'address',
      },
      { name: 'optimalUsageRatio', internalType: 'uint256', type: 'uint256' },
      {
        name: 'baseVariableBorrowRate',
        internalType: 'uint256',
        type: 'uint256',
      },
      { name: 'variableRateSlope1', internalType: 'uint256', type: 'uint256' },
      { name: 'variableRateSlope2', internalType: 'uint256', type: 'uint256' },
      { name: 'stableRateSlope1', internalType: 'uint256', type: 'uint256' },
      { name: 'stableRateSlope2', internalType: 'uint256', type: 'uint256' },
      {
        name: 'baseStableRateOffset',
        internalType: 'uint256',
        type: 'uint256',
      },
      {
        name: 'stableRateExcessOffset',
        internalType: 'uint256',
        type: 'uint256',
      },
      {
        name: 'optimalStableToTotalDebtRatio',
        internalType: 'uint256',
        type: 'uint256',
      },
    ],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'ADDRESSES_PROVIDER',
    outputs: [
      {
        name: '',
        internalType: 'contract IPoolAddressesProvider',
        type: 'address',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'MAX_EXCESS_STABLE_TO_TOTAL_DEBT_RATIO',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'MAX_EXCESS_USAGE_RATIO',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'OPTIMAL_STABLE_TO_TOTAL_DEBT_RATIO',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'OPTIMAL_USAGE_RATIO',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'params',
        internalType: 'struct DataTypes.CalculateInterestRatesParams',
        type: 'tuple',
        components: [
          { name: 'unbacked', internalType: 'uint256', type: 'uint256' },
          { name: 'liquidityAdded', internalType: 'uint256', type: 'uint256' },
          { name: 'liquidityTaken', internalType: 'uint256', type: 'uint256' },
          { name: 'totalStableDebt', internalType: 'uint256', type: 'uint256' },
          {
            name: 'totalVariableDebt',
            internalType: 'uint256',
            type: 'uint256',
          },
          {
            name: 'averageStableBorrowRate',
            internalType: 'uint256',
            type: 'uint256',
          },
          { name: 'reserveFactor', internalType: 'uint256', type: 'uint256' },
          { name: 'reserve', internalType: 'address', type: 'address' },
          { name: 'aToken', internalType: 'address', type: 'address' },
        ],
      },
    ],
    name: 'calculateInterestRates',
    outputs: [
      { name: '', internalType: 'uint256', type: 'uint256' },
      { name: '', internalType: 'uint256', type: 'uint256' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getBaseStableBorrowRate',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getBaseVariableBorrowRate',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getMaxVariableBorrowRate',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getStableRateExcessOffset',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getStableRateSlope1',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getStableRateSlope2',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getVariableRateSlope1',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getVariableRateSlope2',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
] as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBC19Ef2e78472a986BB78B09D467f4D61F9F35f3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7bBbD2a37226928d1E67CC3079aFd40204FC4531)
 */
export const reserveStrategyRateStrategyStableTwoAddress = {
  17000: '0xBC19Ef2e78472a986BB78B09D467f4D61F9F35f3',
  167009: '0x7bBbD2a37226928d1E67CC3079aFd40204FC4531',
} as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBC19Ef2e78472a986BB78B09D467f4D61F9F35f3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7bBbD2a37226928d1E67CC3079aFd40204FC4531)
 */
export const reserveStrategyRateStrategyStableTwoConfig = {
  address: reserveStrategyRateStrategyStableTwoAddress,
  abi: reserveStrategyRateStrategyStableTwoAbi,
} as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// ReserveStrategy-rateStrategyVolatileOne
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x7CE156823Dec1A2106285308296E11B97e9356a4)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x3e8Be7364FE6dE5B5B54F6e6E2739A8aB7157d0a)
 */
export const reserveStrategyRateStrategyVolatileOneAbi = [
  {
    type: 'constructor',
    inputs: [
      {
        name: 'provider',
        internalType: 'contract IPoolAddressesProvider',
        type: 'address',
      },
      { name: 'optimalUsageRatio', internalType: 'uint256', type: 'uint256' },
      {
        name: 'baseVariableBorrowRate',
        internalType: 'uint256',
        type: 'uint256',
      },
      { name: 'variableRateSlope1', internalType: 'uint256', type: 'uint256' },
      { name: 'variableRateSlope2', internalType: 'uint256', type: 'uint256' },
      { name: 'stableRateSlope1', internalType: 'uint256', type: 'uint256' },
      { name: 'stableRateSlope2', internalType: 'uint256', type: 'uint256' },
      {
        name: 'baseStableRateOffset',
        internalType: 'uint256',
        type: 'uint256',
      },
      {
        name: 'stableRateExcessOffset',
        internalType: 'uint256',
        type: 'uint256',
      },
      {
        name: 'optimalStableToTotalDebtRatio',
        internalType: 'uint256',
        type: 'uint256',
      },
    ],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'ADDRESSES_PROVIDER',
    outputs: [
      {
        name: '',
        internalType: 'contract IPoolAddressesProvider',
        type: 'address',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'MAX_EXCESS_STABLE_TO_TOTAL_DEBT_RATIO',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'MAX_EXCESS_USAGE_RATIO',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'OPTIMAL_STABLE_TO_TOTAL_DEBT_RATIO',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'OPTIMAL_USAGE_RATIO',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'params',
        internalType: 'struct DataTypes.CalculateInterestRatesParams',
        type: 'tuple',
        components: [
          { name: 'unbacked', internalType: 'uint256', type: 'uint256' },
          { name: 'liquidityAdded', internalType: 'uint256', type: 'uint256' },
          { name: 'liquidityTaken', internalType: 'uint256', type: 'uint256' },
          { name: 'totalStableDebt', internalType: 'uint256', type: 'uint256' },
          {
            name: 'totalVariableDebt',
            internalType: 'uint256',
            type: 'uint256',
          },
          {
            name: 'averageStableBorrowRate',
            internalType: 'uint256',
            type: 'uint256',
          },
          { name: 'reserveFactor', internalType: 'uint256', type: 'uint256' },
          { name: 'reserve', internalType: 'address', type: 'address' },
          { name: 'aToken', internalType: 'address', type: 'address' },
        ],
      },
    ],
    name: 'calculateInterestRates',
    outputs: [
      { name: '', internalType: 'uint256', type: 'uint256' },
      { name: '', internalType: 'uint256', type: 'uint256' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getBaseStableBorrowRate',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getBaseVariableBorrowRate',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getMaxVariableBorrowRate',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getStableRateExcessOffset',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getStableRateSlope1',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getStableRateSlope2',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getVariableRateSlope1',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getVariableRateSlope2',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
] as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x7CE156823Dec1A2106285308296E11B97e9356a4)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x3e8Be7364FE6dE5B5B54F6e6E2739A8aB7157d0a)
 */
export const reserveStrategyRateStrategyVolatileOneAddress = {
  17000: '0x7CE156823Dec1A2106285308296E11B97e9356a4',
  167009: '0x3e8Be7364FE6dE5B5B54F6e6E2739A8aB7157d0a',
} as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x7CE156823Dec1A2106285308296E11B97e9356a4)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x3e8Be7364FE6dE5B5B54F6e6E2739A8aB7157d0a)
 */
export const reserveStrategyRateStrategyVolatileOneConfig = {
  address: reserveStrategyRateStrategyVolatileOneAddress,
  abi: reserveStrategyRateStrategyVolatileOneAbi,
} as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// ReserveStrategy-rateStrategyVolatileTKO
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x620d0e1371c1E0B44867E04E17d166EbfeAF5759)
 */
export const reserveStrategyRateStrategyVolatileTkoAbi = [
  {
    type: 'constructor',
    inputs: [
      {
        name: 'provider',
        internalType: 'contract IPoolAddressesProvider',
        type: 'address',
      },
      { name: 'optimalUsageRatio', internalType: 'uint256', type: 'uint256' },
      {
        name: 'baseVariableBorrowRate',
        internalType: 'uint256',
        type: 'uint256',
      },
      { name: 'variableRateSlope1', internalType: 'uint256', type: 'uint256' },
      { name: 'variableRateSlope2', internalType: 'uint256', type: 'uint256' },
      { name: 'stableRateSlope1', internalType: 'uint256', type: 'uint256' },
      { name: 'stableRateSlope2', internalType: 'uint256', type: 'uint256' },
      {
        name: 'baseStableRateOffset',
        internalType: 'uint256',
        type: 'uint256',
      },
      {
        name: 'stableRateExcessOffset',
        internalType: 'uint256',
        type: 'uint256',
      },
      {
        name: 'optimalStableToTotalDebtRatio',
        internalType: 'uint256',
        type: 'uint256',
      },
    ],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'ADDRESSES_PROVIDER',
    outputs: [
      {
        name: '',
        internalType: 'contract IPoolAddressesProvider',
        type: 'address',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'MAX_EXCESS_STABLE_TO_TOTAL_DEBT_RATIO',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'MAX_EXCESS_USAGE_RATIO',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'OPTIMAL_STABLE_TO_TOTAL_DEBT_RATIO',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'OPTIMAL_USAGE_RATIO',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'params',
        internalType: 'struct DataTypes.CalculateInterestRatesParams',
        type: 'tuple',
        components: [
          { name: 'unbacked', internalType: 'uint256', type: 'uint256' },
          { name: 'liquidityAdded', internalType: 'uint256', type: 'uint256' },
          { name: 'liquidityTaken', internalType: 'uint256', type: 'uint256' },
          { name: 'totalStableDebt', internalType: 'uint256', type: 'uint256' },
          {
            name: 'totalVariableDebt',
            internalType: 'uint256',
            type: 'uint256',
          },
          {
            name: 'averageStableBorrowRate',
            internalType: 'uint256',
            type: 'uint256',
          },
          { name: 'reserveFactor', internalType: 'uint256', type: 'uint256' },
          { name: 'reserve', internalType: 'address', type: 'address' },
          { name: 'aToken', internalType: 'address', type: 'address' },
        ],
      },
    ],
    name: 'calculateInterestRates',
    outputs: [
      { name: '', internalType: 'uint256', type: 'uint256' },
      { name: '', internalType: 'uint256', type: 'uint256' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getBaseStableBorrowRate',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getBaseVariableBorrowRate',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getMaxVariableBorrowRate',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getStableRateExcessOffset',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getStableRateSlope1',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getStableRateSlope2',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getVariableRateSlope1',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getVariableRateSlope2',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
] as const

/**
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x620d0e1371c1E0B44867E04E17d166EbfeAF5759)
 */
export const reserveStrategyRateStrategyVolatileTkoAddress = {
  167009: '0x620d0e1371c1E0B44867E04E17d166EbfeAF5759',
} as const

/**
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x620d0e1371c1E0B44867E04E17d166EbfeAF5759)
 */
export const reserveStrategyRateStrategyVolatileTkoConfig = {
  address: reserveStrategyRateStrategyVolatileTkoAddress,
  abi: reserveStrategyRateStrategyVolatileTkoAbi,
} as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// ReserveStrategy-rateStrategyVolatileUSDC
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9611eb463e34dCCd09bEEDFBF9C6a6039cB6Ec15)
 */
export const reserveStrategyRateStrategyVolatileUsdcAbi = [
  {
    type: 'constructor',
    inputs: [
      {
        name: 'provider',
        internalType: 'contract IPoolAddressesProvider',
        type: 'address',
      },
      { name: 'optimalUsageRatio', internalType: 'uint256', type: 'uint256' },
      {
        name: 'baseVariableBorrowRate',
        internalType: 'uint256',
        type: 'uint256',
      },
      { name: 'variableRateSlope1', internalType: 'uint256', type: 'uint256' },
      { name: 'variableRateSlope2', internalType: 'uint256', type: 'uint256' },
      { name: 'stableRateSlope1', internalType: 'uint256', type: 'uint256' },
      { name: 'stableRateSlope2', internalType: 'uint256', type: 'uint256' },
      {
        name: 'baseStableRateOffset',
        internalType: 'uint256',
        type: 'uint256',
      },
      {
        name: 'stableRateExcessOffset',
        internalType: 'uint256',
        type: 'uint256',
      },
      {
        name: 'optimalStableToTotalDebtRatio',
        internalType: 'uint256',
        type: 'uint256',
      },
    ],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'ADDRESSES_PROVIDER',
    outputs: [
      {
        name: '',
        internalType: 'contract IPoolAddressesProvider',
        type: 'address',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'MAX_EXCESS_STABLE_TO_TOTAL_DEBT_RATIO',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'MAX_EXCESS_USAGE_RATIO',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'OPTIMAL_STABLE_TO_TOTAL_DEBT_RATIO',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'OPTIMAL_USAGE_RATIO',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'params',
        internalType: 'struct DataTypes.CalculateInterestRatesParams',
        type: 'tuple',
        components: [
          { name: 'unbacked', internalType: 'uint256', type: 'uint256' },
          { name: 'liquidityAdded', internalType: 'uint256', type: 'uint256' },
          { name: 'liquidityTaken', internalType: 'uint256', type: 'uint256' },
          { name: 'totalStableDebt', internalType: 'uint256', type: 'uint256' },
          {
            name: 'totalVariableDebt',
            internalType: 'uint256',
            type: 'uint256',
          },
          {
            name: 'averageStableBorrowRate',
            internalType: 'uint256',
            type: 'uint256',
          },
          { name: 'reserveFactor', internalType: 'uint256', type: 'uint256' },
          { name: 'reserve', internalType: 'address', type: 'address' },
          { name: 'aToken', internalType: 'address', type: 'address' },
        ],
      },
    ],
    name: 'calculateInterestRates',
    outputs: [
      { name: '', internalType: 'uint256', type: 'uint256' },
      { name: '', internalType: 'uint256', type: 'uint256' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getBaseStableBorrowRate',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getBaseVariableBorrowRate',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getMaxVariableBorrowRate',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getStableRateExcessOffset',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getStableRateSlope1',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getStableRateSlope2',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getVariableRateSlope1',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getVariableRateSlope2',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
] as const

/**
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9611eb463e34dCCd09bEEDFBF9C6a6039cB6Ec15)
 */
export const reserveStrategyRateStrategyVolatileUsdcAddress = {
  167009: '0x9611eb463e34dCCd09bEEDFBF9C6a6039cB6Ec15',
} as const

/**
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9611eb463e34dCCd09bEEDFBF9C6a6039cB6Ec15)
 */
export const reserveStrategyRateStrategyVolatileUsdcConfig = {
  address: reserveStrategyRateStrategyVolatileUsdcAddress,
  abi: reserveStrategyRateStrategyVolatileUsdcAbi,
} as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// ReserveStrategy-rateStrategyVolatileUSDT
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xDAa306d7bdC7f465030506F47aaDE074787960B3)
 */
export const reserveStrategyRateStrategyVolatileUsdtAbi = [
  {
    type: 'constructor',
    inputs: [
      {
        name: 'provider',
        internalType: 'contract IPoolAddressesProvider',
        type: 'address',
      },
      { name: 'optimalUsageRatio', internalType: 'uint256', type: 'uint256' },
      {
        name: 'baseVariableBorrowRate',
        internalType: 'uint256',
        type: 'uint256',
      },
      { name: 'variableRateSlope1', internalType: 'uint256', type: 'uint256' },
      { name: 'variableRateSlope2', internalType: 'uint256', type: 'uint256' },
      { name: 'stableRateSlope1', internalType: 'uint256', type: 'uint256' },
      { name: 'stableRateSlope2', internalType: 'uint256', type: 'uint256' },
      {
        name: 'baseStableRateOffset',
        internalType: 'uint256',
        type: 'uint256',
      },
      {
        name: 'stableRateExcessOffset',
        internalType: 'uint256',
        type: 'uint256',
      },
      {
        name: 'optimalStableToTotalDebtRatio',
        internalType: 'uint256',
        type: 'uint256',
      },
    ],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'ADDRESSES_PROVIDER',
    outputs: [
      {
        name: '',
        internalType: 'contract IPoolAddressesProvider',
        type: 'address',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'MAX_EXCESS_STABLE_TO_TOTAL_DEBT_RATIO',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'MAX_EXCESS_USAGE_RATIO',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'OPTIMAL_STABLE_TO_TOTAL_DEBT_RATIO',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'OPTIMAL_USAGE_RATIO',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'params',
        internalType: 'struct DataTypes.CalculateInterestRatesParams',
        type: 'tuple',
        components: [
          { name: 'unbacked', internalType: 'uint256', type: 'uint256' },
          { name: 'liquidityAdded', internalType: 'uint256', type: 'uint256' },
          { name: 'liquidityTaken', internalType: 'uint256', type: 'uint256' },
          { name: 'totalStableDebt', internalType: 'uint256', type: 'uint256' },
          {
            name: 'totalVariableDebt',
            internalType: 'uint256',
            type: 'uint256',
          },
          {
            name: 'averageStableBorrowRate',
            internalType: 'uint256',
            type: 'uint256',
          },
          { name: 'reserveFactor', internalType: 'uint256', type: 'uint256' },
          { name: 'reserve', internalType: 'address', type: 'address' },
          { name: 'aToken', internalType: 'address', type: 'address' },
        ],
      },
    ],
    name: 'calculateInterestRates',
    outputs: [
      { name: '', internalType: 'uint256', type: 'uint256' },
      { name: '', internalType: 'uint256', type: 'uint256' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getBaseStableBorrowRate',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getBaseVariableBorrowRate',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getMaxVariableBorrowRate',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getStableRateExcessOffset',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getStableRateSlope1',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getStableRateSlope2',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getVariableRateSlope1',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getVariableRateSlope2',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
] as const

/**
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xDAa306d7bdC7f465030506F47aaDE074787960B3)
 */
export const reserveStrategyRateStrategyVolatileUsdtAddress = {
  167009: '0xDAa306d7bdC7f465030506F47aaDE074787960B3',
} as const

/**
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xDAa306d7bdC7f465030506F47aaDE074787960B3)
 */
export const reserveStrategyRateStrategyVolatileUsdtConfig = {
  address: reserveStrategyRateStrategyVolatileUsdtAddress,
  abi: reserveStrategyRateStrategyVolatileUsdtAbi,
} as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// ReserveStrategy-rateStrategyVolatileWBTC
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xae87cbb46dBAf6657a09db02DE78b477317224D8)
 */
export const reserveStrategyRateStrategyVolatileWbtcAbi = [
  {
    type: 'constructor',
    inputs: [
      {
        name: 'provider',
        internalType: 'contract IPoolAddressesProvider',
        type: 'address',
      },
      { name: 'optimalUsageRatio', internalType: 'uint256', type: 'uint256' },
      {
        name: 'baseVariableBorrowRate',
        internalType: 'uint256',
        type: 'uint256',
      },
      { name: 'variableRateSlope1', internalType: 'uint256', type: 'uint256' },
      { name: 'variableRateSlope2', internalType: 'uint256', type: 'uint256' },
      { name: 'stableRateSlope1', internalType: 'uint256', type: 'uint256' },
      { name: 'stableRateSlope2', internalType: 'uint256', type: 'uint256' },
      {
        name: 'baseStableRateOffset',
        internalType: 'uint256',
        type: 'uint256',
      },
      {
        name: 'stableRateExcessOffset',
        internalType: 'uint256',
        type: 'uint256',
      },
      {
        name: 'optimalStableToTotalDebtRatio',
        internalType: 'uint256',
        type: 'uint256',
      },
    ],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'ADDRESSES_PROVIDER',
    outputs: [
      {
        name: '',
        internalType: 'contract IPoolAddressesProvider',
        type: 'address',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'MAX_EXCESS_STABLE_TO_TOTAL_DEBT_RATIO',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'MAX_EXCESS_USAGE_RATIO',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'OPTIMAL_STABLE_TO_TOTAL_DEBT_RATIO',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'OPTIMAL_USAGE_RATIO',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'params',
        internalType: 'struct DataTypes.CalculateInterestRatesParams',
        type: 'tuple',
        components: [
          { name: 'unbacked', internalType: 'uint256', type: 'uint256' },
          { name: 'liquidityAdded', internalType: 'uint256', type: 'uint256' },
          { name: 'liquidityTaken', internalType: 'uint256', type: 'uint256' },
          { name: 'totalStableDebt', internalType: 'uint256', type: 'uint256' },
          {
            name: 'totalVariableDebt',
            internalType: 'uint256',
            type: 'uint256',
          },
          {
            name: 'averageStableBorrowRate',
            internalType: 'uint256',
            type: 'uint256',
          },
          { name: 'reserveFactor', internalType: 'uint256', type: 'uint256' },
          { name: 'reserve', internalType: 'address', type: 'address' },
          { name: 'aToken', internalType: 'address', type: 'address' },
        ],
      },
    ],
    name: 'calculateInterestRates',
    outputs: [
      { name: '', internalType: 'uint256', type: 'uint256' },
      { name: '', internalType: 'uint256', type: 'uint256' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getBaseStableBorrowRate',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getBaseVariableBorrowRate',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getMaxVariableBorrowRate',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getStableRateExcessOffset',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getStableRateSlope1',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getStableRateSlope2',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getVariableRateSlope1',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getVariableRateSlope2',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
] as const

/**
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xae87cbb46dBAf6657a09db02DE78b477317224D8)
 */
export const reserveStrategyRateStrategyVolatileWbtcAddress = {
  167009: '0xae87cbb46dBAf6657a09db02DE78b477317224D8',
} as const

/**
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xae87cbb46dBAf6657a09db02DE78b477317224D8)
 */
export const reserveStrategyRateStrategyVolatileWbtcConfig = {
  address: reserveStrategyRateStrategyVolatileWbtcAddress,
  abi: reserveStrategyRateStrategyVolatileWbtcAbi,
} as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// ReserveStrategy-rateStrategyVolatileWETH
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa32455dF66E7b580133fb7d3aa50D600791e73a0)
 */
export const reserveStrategyRateStrategyVolatileWethAbi = [
  {
    type: 'constructor',
    inputs: [
      {
        name: 'provider',
        internalType: 'contract IPoolAddressesProvider',
        type: 'address',
      },
      { name: 'optimalUsageRatio', internalType: 'uint256', type: 'uint256' },
      {
        name: 'baseVariableBorrowRate',
        internalType: 'uint256',
        type: 'uint256',
      },
      { name: 'variableRateSlope1', internalType: 'uint256', type: 'uint256' },
      { name: 'variableRateSlope2', internalType: 'uint256', type: 'uint256' },
      { name: 'stableRateSlope1', internalType: 'uint256', type: 'uint256' },
      { name: 'stableRateSlope2', internalType: 'uint256', type: 'uint256' },
      {
        name: 'baseStableRateOffset',
        internalType: 'uint256',
        type: 'uint256',
      },
      {
        name: 'stableRateExcessOffset',
        internalType: 'uint256',
        type: 'uint256',
      },
      {
        name: 'optimalStableToTotalDebtRatio',
        internalType: 'uint256',
        type: 'uint256',
      },
    ],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'ADDRESSES_PROVIDER',
    outputs: [
      {
        name: '',
        internalType: 'contract IPoolAddressesProvider',
        type: 'address',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'MAX_EXCESS_STABLE_TO_TOTAL_DEBT_RATIO',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'MAX_EXCESS_USAGE_RATIO',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'OPTIMAL_STABLE_TO_TOTAL_DEBT_RATIO',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'OPTIMAL_USAGE_RATIO',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'params',
        internalType: 'struct DataTypes.CalculateInterestRatesParams',
        type: 'tuple',
        components: [
          { name: 'unbacked', internalType: 'uint256', type: 'uint256' },
          { name: 'liquidityAdded', internalType: 'uint256', type: 'uint256' },
          { name: 'liquidityTaken', internalType: 'uint256', type: 'uint256' },
          { name: 'totalStableDebt', internalType: 'uint256', type: 'uint256' },
          {
            name: 'totalVariableDebt',
            internalType: 'uint256',
            type: 'uint256',
          },
          {
            name: 'averageStableBorrowRate',
            internalType: 'uint256',
            type: 'uint256',
          },
          { name: 'reserveFactor', internalType: 'uint256', type: 'uint256' },
          { name: 'reserve', internalType: 'address', type: 'address' },
          { name: 'aToken', internalType: 'address', type: 'address' },
        ],
      },
    ],
    name: 'calculateInterestRates',
    outputs: [
      { name: '', internalType: 'uint256', type: 'uint256' },
      { name: '', internalType: 'uint256', type: 'uint256' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getBaseStableBorrowRate',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getBaseVariableBorrowRate',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getMaxVariableBorrowRate',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getStableRateExcessOffset',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getStableRateSlope1',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getStableRateSlope2',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getVariableRateSlope1',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getVariableRateSlope2',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
] as const

/**
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa32455dF66E7b580133fb7d3aa50D600791e73a0)
 */
export const reserveStrategyRateStrategyVolatileWethAddress = {
  167009: '0xa32455dF66E7b580133fb7d3aa50D600791e73a0',
} as const

/**
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa32455dF66E7b580133fb7d3aa50D600791e73a0)
 */
export const reserveStrategyRateStrategyVolatileWethConfig = {
  address: reserveStrategyRateStrategyVolatileWethAddress,
  abi: reserveStrategyRateStrategyVolatileWethAbi,
} as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// ReservesSetupHelper
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x7E433415DaBBc7E8791369EEc827E3FD860Fe6d8)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x614F3E4318F57E9B2cc840Ad5f6CD3979fC83A86)
 */
export const reservesSetupHelperAbi = [
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'previousOwner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'newOwner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'OwnershipTransferred',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'configurator',
        internalType: 'contract PoolConfigurator',
        type: 'address',
      },
      {
        name: 'inputParams',
        internalType: 'struct ReservesSetupHelper.ConfigureReserveInput[]',
        type: 'tuple[]',
        components: [
          { name: 'asset', internalType: 'address', type: 'address' },
          { name: 'baseLTV', internalType: 'uint256', type: 'uint256' },
          {
            name: 'liquidationThreshold',
            internalType: 'uint256',
            type: 'uint256',
          },
          {
            name: 'liquidationBonus',
            internalType: 'uint256',
            type: 'uint256',
          },
          { name: 'reserveFactor', internalType: 'uint256', type: 'uint256' },
          { name: 'borrowCap', internalType: 'uint256', type: 'uint256' },
          { name: 'supplyCap', internalType: 'uint256', type: 'uint256' },
          {
            name: 'stableBorrowingEnabled',
            internalType: 'bool',
            type: 'bool',
          },
          { name: 'borrowingEnabled', internalType: 'bool', type: 'bool' },
          { name: 'flashLoanEnabled', internalType: 'bool', type: 'bool' },
        ],
      },
    ],
    name: 'configureReserves',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'owner',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'renounceOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'newOwner', internalType: 'address', type: 'address' }],
    name: 'transferOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
  },
] as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x7E433415DaBBc7E8791369EEc827E3FD860Fe6d8)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x614F3E4318F57E9B2cc840Ad5f6CD3979fC83A86)
 */
export const reservesSetupHelperAddress = {
  17000: '0x7E433415DaBBc7E8791369EEc827E3FD860Fe6d8',
  167009: '0x614F3E4318F57E9B2cc840Ad5f6CD3979fC83A86',
} as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x7E433415DaBBc7E8791369EEc827E3FD860Fe6d8)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x614F3E4318F57E9B2cc840Ad5f6CD3979fC83A86)
 */
export const reservesSetupHelperConfig = {
  address: reservesSetupHelperAddress,
  abi: reservesSetupHelperAbi,
} as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// StableDebtToken-Taiko
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE49F0a33a206e89ba09B54188b42702E8C560AE3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x039D11D56527a9Bd9BbCc9c0cAF73c32bd18866A)
 */
export const stableDebtTokenTaikoAbi = [
  {
    type: 'constructor',
    inputs: [{ name: 'pool', internalType: 'contract IPool', type: 'address' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'owner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'spender',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Approval',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'fromUser',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'toUser',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'asset',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'amount',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'BorrowAllowanceDelegated',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'from', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'amount',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'currentBalance',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'balanceIncrease',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'avgStableRate',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'newTotalSupply',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Burn',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'underlyingAsset',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      { name: 'pool', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'incentivesController',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
      {
        name: 'debtTokenDecimals',
        internalType: 'uint8',
        type: 'uint8',
        indexed: false,
      },
      {
        name: 'debtTokenName',
        internalType: 'string',
        type: 'string',
        indexed: false,
      },
      {
        name: 'debtTokenSymbol',
        internalType: 'string',
        type: 'string',
        indexed: false,
      },
      { name: 'params', internalType: 'bytes', type: 'bytes', indexed: false },
    ],
    name: 'Initialized',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'user', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'onBehalfOf',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'amount',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'currentBalance',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'balanceIncrease',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'newRate',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'avgStableRate',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'newTotalSupply',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Mint',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'from', internalType: 'address', type: 'address', indexed: true },
      { name: 'to', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Transfer',
  },
  {
    type: 'function',
    inputs: [],
    name: 'DEBT_TOKEN_REVISION',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'DELEGATION_WITH_SIG_TYPEHASH',
    outputs: [{ name: '', internalType: 'bytes32', type: 'bytes32' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'DOMAIN_SEPARATOR',
    outputs: [{ name: '', internalType: 'bytes32', type: 'bytes32' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'EIP712_REVISION',
    outputs: [{ name: '', internalType: 'bytes', type: 'bytes' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'POOL',
    outputs: [{ name: '', internalType: 'contract IPool', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'UNDERLYING_ASSET_ADDRESS',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'address', type: 'address' },
    ],
    name: 'allowance',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'approve',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'delegatee', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'approveDelegation',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'account', internalType: 'address', type: 'address' }],
    name: 'balanceOf',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'fromUser', internalType: 'address', type: 'address' },
      { name: 'toUser', internalType: 'address', type: 'address' },
    ],
    name: 'borrowAllowance',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'from', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'burn',
    outputs: [
      { name: '', internalType: 'uint256', type: 'uint256' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'decimals',
    outputs: [{ name: '', internalType: 'uint8', type: 'uint8' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'decreaseAllowance',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'delegator', internalType: 'address', type: 'address' },
      { name: 'delegatee', internalType: 'address', type: 'address' },
      { name: 'value', internalType: 'uint256', type: 'uint256' },
      { name: 'deadline', internalType: 'uint256', type: 'uint256' },
      { name: 'v', internalType: 'uint8', type: 'uint8' },
      { name: 'r', internalType: 'bytes32', type: 'bytes32' },
      { name: 's', internalType: 'bytes32', type: 'bytes32' },
    ],
    name: 'delegationWithSig',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getAverageStableRate',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getIncentivesController',
    outputs: [
      {
        name: '',
        internalType: 'contract IAaveIncentivesController',
        type: 'address',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getSupplyData',
    outputs: [
      { name: '', internalType: 'uint256', type: 'uint256' },
      { name: '', internalType: 'uint256', type: 'uint256' },
      { name: '', internalType: 'uint256', type: 'uint256' },
      { name: '', internalType: 'uint40', type: 'uint40' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getTotalSupplyAndAvgRate',
    outputs: [
      { name: '', internalType: 'uint256', type: 'uint256' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getTotalSupplyLastUpdated',
    outputs: [{ name: '', internalType: 'uint40', type: 'uint40' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'user', internalType: 'address', type: 'address' }],
    name: 'getUserLastUpdated',
    outputs: [{ name: '', internalType: 'uint40', type: 'uint40' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'user', internalType: 'address', type: 'address' }],
    name: 'getUserStableRate',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'increaseAllowance',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'initializingPool',
        internalType: 'contract IPool',
        type: 'address',
      },
      { name: 'underlyingAsset', internalType: 'address', type: 'address' },
      {
        name: 'incentivesController',
        internalType: 'contract IAaveIncentivesController',
        type: 'address',
      },
      { name: 'debtTokenDecimals', internalType: 'uint8', type: 'uint8' },
      { name: 'debtTokenName', internalType: 'string', type: 'string' },
      { name: 'debtTokenSymbol', internalType: 'string', type: 'string' },
      { name: 'params', internalType: 'bytes', type: 'bytes' },
    ],
    name: 'initialize',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'user', internalType: 'address', type: 'address' },
      { name: 'onBehalfOf', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
      { name: 'rate', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'mint',
    outputs: [
      { name: '', internalType: 'bool', type: 'bool' },
      { name: '', internalType: 'uint256', type: 'uint256' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'name',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'owner', internalType: 'address', type: 'address' }],
    name: 'nonces',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'user', internalType: 'address', type: 'address' }],
    name: 'principalBalanceOf',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'controller',
        internalType: 'contract IAaveIncentivesController',
        type: 'address',
      },
    ],
    name: 'setIncentivesController',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'symbol',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'totalSupply',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transfer',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transferFrom',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
] as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE49F0a33a206e89ba09B54188b42702E8C560AE3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x039D11D56527a9Bd9BbCc9c0cAF73c32bd18866A)
 */
export const stableDebtTokenTaikoAddress = {
  17000: '0xE49F0a33a206e89ba09B54188b42702E8C560AE3',
  167009: '0x039D11D56527a9Bd9BbCc9c0cAF73c32bd18866A',
} as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE49F0a33a206e89ba09B54188b42702E8C560AE3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x039D11D56527a9Bd9BbCc9c0cAF73c32bd18866A)
 */
export const stableDebtTokenTaikoConfig = {
  address: stableDebtTokenTaikoAddress,
  abi: stableDebtTokenTaikoAbi,
} as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// StkAave-TestnetMintableERC20-Reward-Taiko
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD7b74D0C6830F4A34DC971E9524698771B9f9B59)
 */
export const stkAaveTestnetMintableErc20RewardTaikoAbi = [
  {
    type: 'constructor',
    inputs: [
      { name: '_name', internalType: 'string', type: 'string' },
      { name: '_symbol', internalType: 'string', type: 'string' },
      { name: '_decimals', internalType: 'uint8', type: 'uint8' },
    ],
    stateMutability: 'nonpayable',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'owner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'spender',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Approval',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'from', internalType: 'address', type: 'address', indexed: true },
      { name: 'to', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Transfer',
  },
  {
    type: 'function',
    inputs: [
      { name: 'owner', internalType: 'address', type: 'address' },
      { name: 'spender', internalType: 'address', type: 'address' },
    ],
    name: 'allowance',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'spender', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'approve',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'account', internalType: 'address', type: 'address' }],
    name: 'balanceOf',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'decimals',
    outputs: [{ name: '', internalType: 'uint8', type: 'uint8' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'spender', internalType: 'address', type: 'address' },
      { name: 'subtractedValue', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'decreaseAllowance',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'spender', internalType: 'address', type: 'address' },
      { name: 'addedValue', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'increaseAllowance',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'name',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'symbol',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'tokenDecimals',
    outputs: [{ name: '', internalType: 'uint8', type: 'uint8' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'totalSupply',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transfer',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'from', internalType: 'address', type: 'address' },
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transferFrom',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
] as const

/**
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD7b74D0C6830F4A34DC971E9524698771B9f9B59)
 */
export const stkAaveTestnetMintableErc20RewardTaikoAddress = {
  167009: '0xD7b74D0C6830F4A34DC971E9524698771B9f9B59',
} as const

/**
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD7b74D0C6830F4A34DC971E9524698771B9f9B59)
 */
export const stkAaveTestnetMintableErc20RewardTaikoConfig = {
  address: stkAaveTestnetMintableErc20RewardTaikoAddress,
  abi: stkAaveTestnetMintableErc20RewardTaikoAbi,
} as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// StkAave-TestnetPriceAggregator-Taiko
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x8567F4386C117166Cbc14FBAd9ED4E6E74e6393B)
 */
export const stkAaveTestnetPriceAggregatorTaikoAbi = [
  {
    type: 'constructor',
    inputs: [{ name: 'initialAnswer', internalType: 'int256', type: 'int256' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'current',
        internalType: 'int256',
        type: 'int256',
        indexed: true,
      },
      {
        name: 'roundId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: true,
      },
      {
        name: 'updatedAt',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'AnswerUpdated',
  },
  {
    type: 'function',
    inputs: [],
    name: 'decimals',
    outputs: [{ name: '', internalType: 'uint8', type: 'uint8' }],
    stateMutability: 'pure',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getTokenType',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'pure',
  },
  {
    type: 'function',
    inputs: [],
    name: 'latestAnswer',
    outputs: [{ name: '', internalType: 'int256', type: 'int256' }],
    stateMutability: 'view',
  },
] as const

/**
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x8567F4386C117166Cbc14FBAd9ED4E6E74e6393B)
 */
export const stkAaveTestnetPriceAggregatorTaikoAddress = {
  167009: '0x8567F4386C117166Cbc14FBAd9ED4E6E74e6393B',
} as const

/**
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x8567F4386C117166Cbc14FBAd9ED4E6E74e6393B)
 */
export const stkAaveTestnetPriceAggregatorTaikoConfig = {
  address: stkAaveTestnetPriceAggregatorTaikoAddress,
  abi: stkAaveTestnetPriceAggregatorTaikoAbi,
} as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// SupplyLogic
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x825708dF3Ff36465D1115B14918D5bF23EC5bfa2)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x60701aD1Cf7ad0aE0b607f03Aa2b08Ba48B63d2F)
 */
export const supplyLogicAbi = [
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'reserve',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'liquidityRate',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'stableBorrowRate',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'variableBorrowRate',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'liquidityIndex',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'variableBorrowIndex',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'ReserveDataUpdated',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'reserve',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      { name: 'user', internalType: 'address', type: 'address', indexed: true },
    ],
    name: 'ReserveUsedAsCollateralDisabled',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'reserve',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      { name: 'user', internalType: 'address', type: 'address', indexed: true },
    ],
    name: 'ReserveUsedAsCollateralEnabled',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'reserve',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'user',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
      {
        name: 'onBehalfOf',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'amount',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'referralCode',
        internalType: 'uint16',
        type: 'uint16',
        indexed: true,
      },
    ],
    name: 'Supply',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'reserve',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      { name: 'user', internalType: 'address', type: 'address', indexed: true },
      { name: 'to', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'amount',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Withdraw',
  },
] as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x825708dF3Ff36465D1115B14918D5bF23EC5bfa2)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x60701aD1Cf7ad0aE0b607f03Aa2b08Ba48B63d2F)
 */
export const supplyLogicAddress = {
  17000: '0x825708dF3Ff36465D1115B14918D5bF23EC5bfa2',
  167009: '0x60701aD1Cf7ad0aE0b607f03Aa2b08Ba48B63d2F',
} as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x825708dF3Ff36465D1115B14918D5bF23EC5bfa2)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x60701aD1Cf7ad0aE0b607f03Aa2b08Ba48B63d2F)
 */
export const supplyLogicConfig = {
  address: supplyLogicAddress,
  abi: supplyLogicAbi,
} as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// TKO-AToken-Taiko
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xad29323BC72FBaa6379602237b2Ae76265804f81)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x1474467995939740B68E4A66cEd94c2824d8CE7b)
 */
export const tkoATokenTaikoAbi = [
  {
    type: 'constructor',
    inputs: [{ name: 'pool', internalType: 'contract IPool', type: 'address' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'owner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'spender',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Approval',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'from', internalType: 'address', type: 'address', indexed: true },
      { name: 'to', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'index',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'BalanceTransfer',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'from', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'target',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'balanceIncrease',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'index',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Burn',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'underlyingAsset',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      { name: 'pool', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'treasury',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
      {
        name: 'incentivesController',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
      {
        name: 'aTokenDecimals',
        internalType: 'uint8',
        type: 'uint8',
        indexed: false,
      },
      {
        name: 'aTokenName',
        internalType: 'string',
        type: 'string',
        indexed: false,
      },
      {
        name: 'aTokenSymbol',
        internalType: 'string',
        type: 'string',
        indexed: false,
      },
      { name: 'params', internalType: 'bytes', type: 'bytes', indexed: false },
    ],
    name: 'Initialized',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'caller',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'onBehalfOf',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'balanceIncrease',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'index',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Mint',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'from', internalType: 'address', type: 'address', indexed: true },
      { name: 'to', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Transfer',
  },
  {
    type: 'function',
    inputs: [],
    name: 'ATOKEN_REVISION',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'DOMAIN_SEPARATOR',
    outputs: [{ name: '', internalType: 'bytes32', type: 'bytes32' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'EIP712_REVISION',
    outputs: [{ name: '', internalType: 'bytes', type: 'bytes' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'PERMIT_TYPEHASH',
    outputs: [{ name: '', internalType: 'bytes32', type: 'bytes32' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'POOL',
    outputs: [{ name: '', internalType: 'contract IPool', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'RESERVE_TREASURY_ADDRESS',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'UNDERLYING_ASSET_ADDRESS',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'owner', internalType: 'address', type: 'address' },
      { name: 'spender', internalType: 'address', type: 'address' },
    ],
    name: 'allowance',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'spender', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'approve',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'user', internalType: 'address', type: 'address' }],
    name: 'balanceOf',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'from', internalType: 'address', type: 'address' },
      {
        name: 'receiverOfUnderlying',
        internalType: 'address',
        type: 'address',
      },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
      { name: 'index', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'burn',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'decimals',
    outputs: [{ name: '', internalType: 'uint8', type: 'uint8' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'spender', internalType: 'address', type: 'address' },
      { name: 'subtractedValue', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'decreaseAllowance',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getIncentivesController',
    outputs: [
      {
        name: '',
        internalType: 'contract IAaveIncentivesController',
        type: 'address',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'user', internalType: 'address', type: 'address' }],
    name: 'getPreviousIndex',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'user', internalType: 'address', type: 'address' }],
    name: 'getScaledUserBalanceAndSupply',
    outputs: [
      { name: '', internalType: 'uint256', type: 'uint256' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'user', internalType: 'address', type: 'address' },
      { name: 'onBehalfOf', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'handleRepayment',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'spender', internalType: 'address', type: 'address' },
      { name: 'addedValue', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'increaseAllowance',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'initializingPool',
        internalType: 'contract IPool',
        type: 'address',
      },
      { name: 'treasury', internalType: 'address', type: 'address' },
      { name: 'underlyingAsset', internalType: 'address', type: 'address' },
      {
        name: 'incentivesController',
        internalType: 'contract IAaveIncentivesController',
        type: 'address',
      },
      { name: 'aTokenDecimals', internalType: 'uint8', type: 'uint8' },
      { name: 'aTokenName', internalType: 'string', type: 'string' },
      { name: 'aTokenSymbol', internalType: 'string', type: 'string' },
      { name: 'params', internalType: 'bytes', type: 'bytes' },
    ],
    name: 'initialize',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'caller', internalType: 'address', type: 'address' },
      { name: 'onBehalfOf', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
      { name: 'index', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'mint',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
      { name: 'index', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'mintToTreasury',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'name',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'owner', internalType: 'address', type: 'address' }],
    name: 'nonces',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'owner', internalType: 'address', type: 'address' },
      { name: 'spender', internalType: 'address', type: 'address' },
      { name: 'value', internalType: 'uint256', type: 'uint256' },
      { name: 'deadline', internalType: 'uint256', type: 'uint256' },
      { name: 'v', internalType: 'uint8', type: 'uint8' },
      { name: 'r', internalType: 'bytes32', type: 'bytes32' },
      { name: 's', internalType: 'bytes32', type: 'bytes32' },
    ],
    name: 'permit',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'token', internalType: 'address', type: 'address' },
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'rescueTokens',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'user', internalType: 'address', type: 'address' }],
    name: 'scaledBalanceOf',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'scaledTotalSupply',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'controller',
        internalType: 'contract IAaveIncentivesController',
        type: 'address',
      },
    ],
    name: 'setIncentivesController',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'symbol',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'totalSupply',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'recipient', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transfer',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'sender', internalType: 'address', type: 'address' },
      { name: 'recipient', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transferFrom',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'from', internalType: 'address', type: 'address' },
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'value', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transferOnLiquidation',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'target', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transferUnderlyingTo',
    outputs: [],
    stateMutability: 'nonpayable',
  },
] as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xad29323BC72FBaa6379602237b2Ae76265804f81)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x1474467995939740B68E4A66cEd94c2824d8CE7b)
 */
export const tkoATokenTaikoAddress = {
  17000: '0xad29323BC72FBaa6379602237b2Ae76265804f81',
  167009: '0x1474467995939740B68E4A66cEd94c2824d8CE7b',
} as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xad29323BC72FBaa6379602237b2Ae76265804f81)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x1474467995939740B68E4A66cEd94c2824d8CE7b)
 */
export const tkoATokenTaikoConfig = {
  address: tkoATokenTaikoAddress,
  abi: tkoATokenTaikoAbi,
} as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// TKO-StableDebtToken-Taiko
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x659c695e2E56b27EA9BC4eF9083039D207bffF18)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x17C6748e4445d7ef7a8ebBe89C640c83D4D896e1)
 */
export const tkoStableDebtTokenTaikoAbi = [
  {
    type: 'constructor',
    inputs: [{ name: 'pool', internalType: 'contract IPool', type: 'address' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'owner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'spender',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Approval',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'fromUser',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'toUser',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'asset',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'amount',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'BorrowAllowanceDelegated',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'from', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'amount',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'currentBalance',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'balanceIncrease',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'avgStableRate',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'newTotalSupply',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Burn',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'underlyingAsset',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      { name: 'pool', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'incentivesController',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
      {
        name: 'debtTokenDecimals',
        internalType: 'uint8',
        type: 'uint8',
        indexed: false,
      },
      {
        name: 'debtTokenName',
        internalType: 'string',
        type: 'string',
        indexed: false,
      },
      {
        name: 'debtTokenSymbol',
        internalType: 'string',
        type: 'string',
        indexed: false,
      },
      { name: 'params', internalType: 'bytes', type: 'bytes', indexed: false },
    ],
    name: 'Initialized',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'user', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'onBehalfOf',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'amount',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'currentBalance',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'balanceIncrease',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'newRate',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'avgStableRate',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'newTotalSupply',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Mint',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'from', internalType: 'address', type: 'address', indexed: true },
      { name: 'to', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Transfer',
  },
  {
    type: 'function',
    inputs: [],
    name: 'DEBT_TOKEN_REVISION',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'DELEGATION_WITH_SIG_TYPEHASH',
    outputs: [{ name: '', internalType: 'bytes32', type: 'bytes32' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'DOMAIN_SEPARATOR',
    outputs: [{ name: '', internalType: 'bytes32', type: 'bytes32' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'EIP712_REVISION',
    outputs: [{ name: '', internalType: 'bytes', type: 'bytes' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'POOL',
    outputs: [{ name: '', internalType: 'contract IPool', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'UNDERLYING_ASSET_ADDRESS',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'address', type: 'address' },
    ],
    name: 'allowance',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'approve',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'delegatee', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'approveDelegation',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'account', internalType: 'address', type: 'address' }],
    name: 'balanceOf',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'fromUser', internalType: 'address', type: 'address' },
      { name: 'toUser', internalType: 'address', type: 'address' },
    ],
    name: 'borrowAllowance',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'from', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'burn',
    outputs: [
      { name: '', internalType: 'uint256', type: 'uint256' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'decimals',
    outputs: [{ name: '', internalType: 'uint8', type: 'uint8' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'decreaseAllowance',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'delegator', internalType: 'address', type: 'address' },
      { name: 'delegatee', internalType: 'address', type: 'address' },
      { name: 'value', internalType: 'uint256', type: 'uint256' },
      { name: 'deadline', internalType: 'uint256', type: 'uint256' },
      { name: 'v', internalType: 'uint8', type: 'uint8' },
      { name: 'r', internalType: 'bytes32', type: 'bytes32' },
      { name: 's', internalType: 'bytes32', type: 'bytes32' },
    ],
    name: 'delegationWithSig',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getAverageStableRate',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getIncentivesController',
    outputs: [
      {
        name: '',
        internalType: 'contract IAaveIncentivesController',
        type: 'address',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getSupplyData',
    outputs: [
      { name: '', internalType: 'uint256', type: 'uint256' },
      { name: '', internalType: 'uint256', type: 'uint256' },
      { name: '', internalType: 'uint256', type: 'uint256' },
      { name: '', internalType: 'uint40', type: 'uint40' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getTotalSupplyAndAvgRate',
    outputs: [
      { name: '', internalType: 'uint256', type: 'uint256' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getTotalSupplyLastUpdated',
    outputs: [{ name: '', internalType: 'uint40', type: 'uint40' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'user', internalType: 'address', type: 'address' }],
    name: 'getUserLastUpdated',
    outputs: [{ name: '', internalType: 'uint40', type: 'uint40' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'user', internalType: 'address', type: 'address' }],
    name: 'getUserStableRate',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'increaseAllowance',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'initializingPool',
        internalType: 'contract IPool',
        type: 'address',
      },
      { name: 'underlyingAsset', internalType: 'address', type: 'address' },
      {
        name: 'incentivesController',
        internalType: 'contract IAaveIncentivesController',
        type: 'address',
      },
      { name: 'debtTokenDecimals', internalType: 'uint8', type: 'uint8' },
      { name: 'debtTokenName', internalType: 'string', type: 'string' },
      { name: 'debtTokenSymbol', internalType: 'string', type: 'string' },
      { name: 'params', internalType: 'bytes', type: 'bytes' },
    ],
    name: 'initialize',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'user', internalType: 'address', type: 'address' },
      { name: 'onBehalfOf', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
      { name: 'rate', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'mint',
    outputs: [
      { name: '', internalType: 'bool', type: 'bool' },
      { name: '', internalType: 'uint256', type: 'uint256' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'name',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'owner', internalType: 'address', type: 'address' }],
    name: 'nonces',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'user', internalType: 'address', type: 'address' }],
    name: 'principalBalanceOf',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'controller',
        internalType: 'contract IAaveIncentivesController',
        type: 'address',
      },
    ],
    name: 'setIncentivesController',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'symbol',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'totalSupply',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transfer',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transferFrom',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
] as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x659c695e2E56b27EA9BC4eF9083039D207bffF18)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x17C6748e4445d7ef7a8ebBe89C640c83D4D896e1)
 */
export const tkoStableDebtTokenTaikoAddress = {
  17000: '0x659c695e2E56b27EA9BC4eF9083039D207bffF18',
  167009: '0x17C6748e4445d7ef7a8ebBe89C640c83D4D896e1',
} as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x659c695e2E56b27EA9BC4eF9083039D207bffF18)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x17C6748e4445d7ef7a8ebBe89C640c83D4D896e1)
 */
export const tkoStableDebtTokenTaikoConfig = {
  address: tkoStableDebtTokenTaikoAddress,
  abi: tkoStableDebtTokenTaikoAbi,
} as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// TKO-TestnetMintableERC20-Taiko
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd4Ce092363B0B4d8F6E508CF37dBc94b299c0bD8)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x46c0AE0f2e52425C3e5Ea0D05e94B87ACC381CAe)
 */
export const tkoTestnetMintableErc20TaikoAbi = [
  {
    type: 'constructor',
    inputs: [
      { name: '_name', internalType: 'string', type: 'string' },
      { name: '_symbol', internalType: 'string', type: 'string' },
      { name: '_decimals', internalType: 'uint8', type: 'uint8' },
    ],
    stateMutability: 'nonpayable',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'owner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'spender',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Approval',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'from', internalType: 'address', type: 'address', indexed: true },
      { name: 'to', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Transfer',
  },
  {
    type: 'function',
    inputs: [
      { name: 'owner', internalType: 'address', type: 'address' },
      { name: 'spender', internalType: 'address', type: 'address' },
    ],
    name: 'allowance',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'spender', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'approve',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'account', internalType: 'address', type: 'address' }],
    name: 'balanceOf',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'decimals',
    outputs: [{ name: '', internalType: 'uint8', type: 'uint8' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'spender', internalType: 'address', type: 'address' },
      { name: 'subtractedValue', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'decreaseAllowance',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'spender', internalType: 'address', type: 'address' },
      { name: 'addedValue', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'increaseAllowance',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'name',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'symbol',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'tokenDecimals',
    outputs: [{ name: '', internalType: 'uint8', type: 'uint8' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'totalSupply',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transfer',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'from', internalType: 'address', type: 'address' },
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transferFrom',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
] as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd4Ce092363B0B4d8F6E508CF37dBc94b299c0bD8)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x46c0AE0f2e52425C3e5Ea0D05e94B87ACC381CAe)
 */
export const tkoTestnetMintableErc20TaikoAddress = {
  17000: '0xd4Ce092363B0B4d8F6E508CF37dBc94b299c0bD8',
  167009: '0x46c0AE0f2e52425C3e5Ea0D05e94B87ACC381CAe',
} as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd4Ce092363B0B4d8F6E508CF37dBc94b299c0bD8)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x46c0AE0f2e52425C3e5Ea0D05e94B87ACC381CAe)
 */
export const tkoTestnetMintableErc20TaikoConfig = {
  address: tkoTestnetMintableErc20TaikoAddress,
  abi: tkoTestnetMintableErc20TaikoAbi,
} as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// TKO-TestnetPriceAggregator-Taiko
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBb1822FBc419a9A4b7Bd19C717442f067CF5CcBE)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7444F0465d29190835f71F1fc1a9c1E23e14d2d0)
 */
export const tkoTestnetPriceAggregatorTaikoAbi = [
  {
    type: 'constructor',
    inputs: [{ name: 'initialAnswer', internalType: 'int256', type: 'int256' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'current',
        internalType: 'int256',
        type: 'int256',
        indexed: true,
      },
      {
        name: 'roundId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: true,
      },
      {
        name: 'updatedAt',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'AnswerUpdated',
  },
  {
    type: 'function',
    inputs: [],
    name: 'decimals',
    outputs: [{ name: '', internalType: 'uint8', type: 'uint8' }],
    stateMutability: 'pure',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getTokenType',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'pure',
  },
  {
    type: 'function',
    inputs: [],
    name: 'latestAnswer',
    outputs: [{ name: '', internalType: 'int256', type: 'int256' }],
    stateMutability: 'view',
  },
] as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBb1822FBc419a9A4b7Bd19C717442f067CF5CcBE)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7444F0465d29190835f71F1fc1a9c1E23e14d2d0)
 */
export const tkoTestnetPriceAggregatorTaikoAddress = {
  17000: '0xBb1822FBc419a9A4b7Bd19C717442f067CF5CcBE',
  167009: '0x7444F0465d29190835f71F1fc1a9c1E23e14d2d0',
} as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBb1822FBc419a9A4b7Bd19C717442f067CF5CcBE)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7444F0465d29190835f71F1fc1a9c1E23e14d2d0)
 */
export const tkoTestnetPriceAggregatorTaikoConfig = {
  address: tkoTestnetPriceAggregatorTaikoAddress,
  abi: tkoTestnetPriceAggregatorTaikoAbi,
} as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// TKO-VariableDebtToken-Taiko
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x54cE8BA483EE93098f58737f7068181aaa136DEe)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2bD5240967ea526892CaAeEEA2Dc9A871374e8ec)
 */
export const tkoVariableDebtTokenTaikoAbi = [
  {
    type: 'constructor',
    inputs: [{ name: 'pool', internalType: 'contract IPool', type: 'address' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'owner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'spender',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Approval',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'fromUser',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'toUser',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'asset',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'amount',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'BorrowAllowanceDelegated',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'from', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'target',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'balanceIncrease',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'index',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Burn',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'underlyingAsset',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      { name: 'pool', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'incentivesController',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
      {
        name: 'debtTokenDecimals',
        internalType: 'uint8',
        type: 'uint8',
        indexed: false,
      },
      {
        name: 'debtTokenName',
        internalType: 'string',
        type: 'string',
        indexed: false,
      },
      {
        name: 'debtTokenSymbol',
        internalType: 'string',
        type: 'string',
        indexed: false,
      },
      { name: 'params', internalType: 'bytes', type: 'bytes', indexed: false },
    ],
    name: 'Initialized',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'caller',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'onBehalfOf',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'balanceIncrease',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'index',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Mint',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'from', internalType: 'address', type: 'address', indexed: true },
      { name: 'to', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Transfer',
  },
  {
    type: 'function',
    inputs: [],
    name: 'DEBT_TOKEN_REVISION',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'DELEGATION_WITH_SIG_TYPEHASH',
    outputs: [{ name: '', internalType: 'bytes32', type: 'bytes32' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'DOMAIN_SEPARATOR',
    outputs: [{ name: '', internalType: 'bytes32', type: 'bytes32' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'EIP712_REVISION',
    outputs: [{ name: '', internalType: 'bytes', type: 'bytes' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'POOL',
    outputs: [{ name: '', internalType: 'contract IPool', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'UNDERLYING_ASSET_ADDRESS',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'address', type: 'address' },
    ],
    name: 'allowance',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'approve',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'delegatee', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'approveDelegation',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'user', internalType: 'address', type: 'address' }],
    name: 'balanceOf',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'fromUser', internalType: 'address', type: 'address' },
      { name: 'toUser', internalType: 'address', type: 'address' },
    ],
    name: 'borrowAllowance',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'from', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
      { name: 'index', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'burn',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'decimals',
    outputs: [{ name: '', internalType: 'uint8', type: 'uint8' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'decreaseAllowance',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'delegator', internalType: 'address', type: 'address' },
      { name: 'delegatee', internalType: 'address', type: 'address' },
      { name: 'value', internalType: 'uint256', type: 'uint256' },
      { name: 'deadline', internalType: 'uint256', type: 'uint256' },
      { name: 'v', internalType: 'uint8', type: 'uint8' },
      { name: 'r', internalType: 'bytes32', type: 'bytes32' },
      { name: 's', internalType: 'bytes32', type: 'bytes32' },
    ],
    name: 'delegationWithSig',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getIncentivesController',
    outputs: [
      {
        name: '',
        internalType: 'contract IAaveIncentivesController',
        type: 'address',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'user', internalType: 'address', type: 'address' }],
    name: 'getPreviousIndex',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'user', internalType: 'address', type: 'address' }],
    name: 'getScaledUserBalanceAndSupply',
    outputs: [
      { name: '', internalType: 'uint256', type: 'uint256' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'increaseAllowance',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'initializingPool',
        internalType: 'contract IPool',
        type: 'address',
      },
      { name: 'underlyingAsset', internalType: 'address', type: 'address' },
      {
        name: 'incentivesController',
        internalType: 'contract IAaveIncentivesController',
        type: 'address',
      },
      { name: 'debtTokenDecimals', internalType: 'uint8', type: 'uint8' },
      { name: 'debtTokenName', internalType: 'string', type: 'string' },
      { name: 'debtTokenSymbol', internalType: 'string', type: 'string' },
      { name: 'params', internalType: 'bytes', type: 'bytes' },
    ],
    name: 'initialize',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'user', internalType: 'address', type: 'address' },
      { name: 'onBehalfOf', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
      { name: 'index', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'mint',
    outputs: [
      { name: '', internalType: 'bool', type: 'bool' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'name',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'owner', internalType: 'address', type: 'address' }],
    name: 'nonces',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'user', internalType: 'address', type: 'address' }],
    name: 'scaledBalanceOf',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'scaledTotalSupply',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'controller',
        internalType: 'contract IAaveIncentivesController',
        type: 'address',
      },
    ],
    name: 'setIncentivesController',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'symbol',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'totalSupply',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transfer',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transferFrom',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
] as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x54cE8BA483EE93098f58737f7068181aaa136DEe)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2bD5240967ea526892CaAeEEA2Dc9A871374e8ec)
 */
export const tkoVariableDebtTokenTaikoAddress = {
  17000: '0x54cE8BA483EE93098f58737f7068181aaa136DEe',
  167009: '0x2bD5240967ea526892CaAeEEA2Dc9A871374e8ec',
} as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x54cE8BA483EE93098f58737f7068181aaa136DEe)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2bD5240967ea526892CaAeEEA2Dc9A871374e8ec)
 */
export const tkoVariableDebtTokenTaikoConfig = {
  address: tkoVariableDebtTokenTaikoAddress,
  abi: tkoVariableDebtTokenTaikoAbi,
} as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Treasury-Controller
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xcEdBa84E998e1A6b5Fd3F3539FE43475bAa2a068)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x919E20cE5949a7106e06F34aE9eAAF1fc32E658a)
 */
export const treasuryControllerAbi = [
  {
    type: 'constructor',
    inputs: [
      {
        name: 'aaveGovShortTimelock',
        internalType: 'address',
        type: 'address',
      },
    ],
    stateMutability: 'nonpayable',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'previousOwner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'newOwner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'OwnershipTransferred',
  },
  {
    type: 'function',
    inputs: [
      { name: 'collector', internalType: 'address', type: 'address' },
      { name: 'token', internalType: 'contract IERC20', type: 'address' },
      { name: 'recipient', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'approve',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'collector', internalType: 'address', type: 'address' },
      { name: 'streamId', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'cancelStream',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'collector', internalType: 'address', type: 'address' },
      { name: 'recipient', internalType: 'address', type: 'address' },
      { name: 'deposit', internalType: 'uint256', type: 'uint256' },
      {
        name: 'tokenAddress',
        internalType: 'contract IERC20',
        type: 'address',
      },
      { name: 'startTime', internalType: 'uint256', type: 'uint256' },
      { name: 'stopTime', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'createStream',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'owner',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'renounceOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'collector', internalType: 'address', type: 'address' },
      { name: 'token', internalType: 'contract IERC20', type: 'address' },
      { name: 'recipient', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transfer',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'newOwner', internalType: 'address', type: 'address' }],
    name: 'transferOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'collector', internalType: 'address', type: 'address' },
      { name: 'streamId', internalType: 'uint256', type: 'uint256' },
      { name: 'funds', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'withdrawFromStream',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
] as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xcEdBa84E998e1A6b5Fd3F3539FE43475bAa2a068)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x919E20cE5949a7106e06F34aE9eAAF1fc32E658a)
 */
export const treasuryControllerAddress = {
  17000: '0xcEdBa84E998e1A6b5Fd3F3539FE43475bAa2a068',
  167009: '0x919E20cE5949a7106e06F34aE9eAAF1fc32E658a',
} as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xcEdBa84E998e1A6b5Fd3F3539FE43475bAa2a068)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x919E20cE5949a7106e06F34aE9eAAF1fc32E658a)
 */
export const treasuryControllerConfig = {
  address: treasuryControllerAddress,
  abi: treasuryControllerAbi,
} as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Treasury-Implementation
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xbC5E4723E7b3C8E9f454C8790919ee637006d630)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x44E02c96bD227500B2a5D999f9313c6957E0B1c9)
 */
export const treasuryImplementationAbi = [
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'streamId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: true,
      },
      {
        name: 'sender',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'recipient',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'senderBalance',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'recipientBalance',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'CancelStream',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'streamId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: true,
      },
      {
        name: 'sender',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'recipient',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'deposit',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'tokenAddress',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
      {
        name: 'startTime',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'stopTime',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'CreateStream',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'fundsAdmin',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'NewFundsAdmin',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'streamId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: true,
      },
      {
        name: 'recipient',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'amount',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'WithdrawFromStream',
  },
  {
    type: 'function',
    inputs: [],
    name: 'ETH_MOCK_ADDRESS',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'REVISION',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'token', internalType: 'contract IERC20', type: 'address' },
      { name: 'recipient', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'approve',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'streamId', internalType: 'uint256', type: 'uint256' },
      { name: 'who', internalType: 'address', type: 'address' },
    ],
    name: 'balanceOf',
    outputs: [{ name: 'balance', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'streamId', internalType: 'uint256', type: 'uint256' }],
    name: 'cancelStream',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'recipient', internalType: 'address', type: 'address' },
      { name: 'deposit', internalType: 'uint256', type: 'uint256' },
      { name: 'tokenAddress', internalType: 'address', type: 'address' },
      { name: 'startTime', internalType: 'uint256', type: 'uint256' },
      { name: 'stopTime', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'createStream',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'streamId', internalType: 'uint256', type: 'uint256' }],
    name: 'deltaOf',
    outputs: [{ name: 'delta', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getFundsAdmin',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getNextStreamId',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'streamId', internalType: 'uint256', type: 'uint256' }],
    name: 'getStream',
    outputs: [
      { name: 'sender', internalType: 'address', type: 'address' },
      { name: 'recipient', internalType: 'address', type: 'address' },
      { name: 'deposit', internalType: 'uint256', type: 'uint256' },
      { name: 'tokenAddress', internalType: 'address', type: 'address' },
      { name: 'startTime', internalType: 'uint256', type: 'uint256' },
      { name: 'stopTime', internalType: 'uint256', type: 'uint256' },
      { name: 'remainingBalance', internalType: 'uint256', type: 'uint256' },
      { name: 'ratePerSecond', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'fundsAdmin', internalType: 'address', type: 'address' }],
    name: 'initialize',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'token', internalType: 'contract IERC20', type: 'address' },
      { name: 'recipient', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transfer',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'streamId', internalType: 'uint256', type: 'uint256' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'withdrawFromStream',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  { type: 'receive', stateMutability: 'payable' },
] as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xbC5E4723E7b3C8E9f454C8790919ee637006d630)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x44E02c96bD227500B2a5D999f9313c6957E0B1c9)
 */
export const treasuryImplementationAddress = {
  17000: '0xbC5E4723E7b3C8E9f454C8790919ee637006d630',
  167009: '0x44E02c96bD227500B2a5D999f9313c6957E0B1c9',
} as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xbC5E4723E7b3C8E9f454C8790919ee637006d630)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x44E02c96bD227500B2a5D999f9313c6957E0B1c9)
 */
export const treasuryImplementationConfig = {
  address: treasuryImplementationAddress,
  abi: treasuryImplementationAbi,
} as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// TreasuryProxy
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x262EF110b0537459d39c476857Ed72634193bf14)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2bcD314Ce1D4aBAD0F0A17102e15C9FF2eAC5fC2)
 */
export const treasuryProxyAbi = [
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'previousAdmin',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
      {
        name: 'newAdmin',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
    ],
    name: 'AdminChanged',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'implementation',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'Upgraded',
  },
  { type: 'fallback', stateMutability: 'payable' },
  {
    type: 'function',
    inputs: [],
    name: 'admin',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'newAdmin', internalType: 'address', type: 'address' }],
    name: 'changeAdmin',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'implementation',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'logic', internalType: 'address', type: 'address' },
      { name: 'admin', internalType: 'address', type: 'address' },
      { name: 'data', internalType: 'bytes', type: 'bytes' },
    ],
    name: 'initialize',
    outputs: [],
    stateMutability: 'payable',
  },
  {
    type: 'function',
    inputs: [
      { name: '_logic', internalType: 'address', type: 'address' },
      { name: '_data', internalType: 'bytes', type: 'bytes' },
    ],
    name: 'initialize',
    outputs: [],
    stateMutability: 'payable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'newImplementation', internalType: 'address', type: 'address' },
    ],
    name: 'upgradeTo',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'newImplementation', internalType: 'address', type: 'address' },
      { name: 'data', internalType: 'bytes', type: 'bytes' },
    ],
    name: 'upgradeToAndCall',
    outputs: [],
    stateMutability: 'payable',
  },
] as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x262EF110b0537459d39c476857Ed72634193bf14)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2bcD314Ce1D4aBAD0F0A17102e15C9FF2eAC5fC2)
 */
export const treasuryProxyAddress = {
  17000: '0x262EF110b0537459d39c476857Ed72634193bf14',
  167009: '0x2bcD314Ce1D4aBAD0F0A17102e15C9FF2eAC5fC2',
} as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x262EF110b0537459d39c476857Ed72634193bf14)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2bcD314Ce1D4aBAD0F0A17102e15C9FF2eAC5fC2)
 */
export const treasuryProxyConfig = {
  address: treasuryProxyAddress,
  abi: treasuryProxyAbi,
} as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// USDC-AToken-Taiko
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa1741a827c35250c437187406fDe16d3581232e6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeC0B304fB75eEf2d83305070e14E4ed914E4FCe0)
 */
export const usdcATokenTaikoAbi = [
  {
    type: 'constructor',
    inputs: [{ name: 'pool', internalType: 'contract IPool', type: 'address' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'owner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'spender',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Approval',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'from', internalType: 'address', type: 'address', indexed: true },
      { name: 'to', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'index',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'BalanceTransfer',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'from', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'target',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'balanceIncrease',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'index',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Burn',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'underlyingAsset',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      { name: 'pool', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'treasury',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
      {
        name: 'incentivesController',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
      {
        name: 'aTokenDecimals',
        internalType: 'uint8',
        type: 'uint8',
        indexed: false,
      },
      {
        name: 'aTokenName',
        internalType: 'string',
        type: 'string',
        indexed: false,
      },
      {
        name: 'aTokenSymbol',
        internalType: 'string',
        type: 'string',
        indexed: false,
      },
      { name: 'params', internalType: 'bytes', type: 'bytes', indexed: false },
    ],
    name: 'Initialized',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'caller',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'onBehalfOf',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'balanceIncrease',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'index',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Mint',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'from', internalType: 'address', type: 'address', indexed: true },
      { name: 'to', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Transfer',
  },
  {
    type: 'function',
    inputs: [],
    name: 'ATOKEN_REVISION',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'DOMAIN_SEPARATOR',
    outputs: [{ name: '', internalType: 'bytes32', type: 'bytes32' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'EIP712_REVISION',
    outputs: [{ name: '', internalType: 'bytes', type: 'bytes' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'PERMIT_TYPEHASH',
    outputs: [{ name: '', internalType: 'bytes32', type: 'bytes32' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'POOL',
    outputs: [{ name: '', internalType: 'contract IPool', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'RESERVE_TREASURY_ADDRESS',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'UNDERLYING_ASSET_ADDRESS',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'owner', internalType: 'address', type: 'address' },
      { name: 'spender', internalType: 'address', type: 'address' },
    ],
    name: 'allowance',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'spender', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'approve',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'user', internalType: 'address', type: 'address' }],
    name: 'balanceOf',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'from', internalType: 'address', type: 'address' },
      {
        name: 'receiverOfUnderlying',
        internalType: 'address',
        type: 'address',
      },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
      { name: 'index', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'burn',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'decimals',
    outputs: [{ name: '', internalType: 'uint8', type: 'uint8' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'spender', internalType: 'address', type: 'address' },
      { name: 'subtractedValue', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'decreaseAllowance',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getIncentivesController',
    outputs: [
      {
        name: '',
        internalType: 'contract IAaveIncentivesController',
        type: 'address',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'user', internalType: 'address', type: 'address' }],
    name: 'getPreviousIndex',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'user', internalType: 'address', type: 'address' }],
    name: 'getScaledUserBalanceAndSupply',
    outputs: [
      { name: '', internalType: 'uint256', type: 'uint256' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'user', internalType: 'address', type: 'address' },
      { name: 'onBehalfOf', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'handleRepayment',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'spender', internalType: 'address', type: 'address' },
      { name: 'addedValue', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'increaseAllowance',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'initializingPool',
        internalType: 'contract IPool',
        type: 'address',
      },
      { name: 'treasury', internalType: 'address', type: 'address' },
      { name: 'underlyingAsset', internalType: 'address', type: 'address' },
      {
        name: 'incentivesController',
        internalType: 'contract IAaveIncentivesController',
        type: 'address',
      },
      { name: 'aTokenDecimals', internalType: 'uint8', type: 'uint8' },
      { name: 'aTokenName', internalType: 'string', type: 'string' },
      { name: 'aTokenSymbol', internalType: 'string', type: 'string' },
      { name: 'params', internalType: 'bytes', type: 'bytes' },
    ],
    name: 'initialize',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'caller', internalType: 'address', type: 'address' },
      { name: 'onBehalfOf', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
      { name: 'index', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'mint',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
      { name: 'index', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'mintToTreasury',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'name',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'owner', internalType: 'address', type: 'address' }],
    name: 'nonces',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'owner', internalType: 'address', type: 'address' },
      { name: 'spender', internalType: 'address', type: 'address' },
      { name: 'value', internalType: 'uint256', type: 'uint256' },
      { name: 'deadline', internalType: 'uint256', type: 'uint256' },
      { name: 'v', internalType: 'uint8', type: 'uint8' },
      { name: 'r', internalType: 'bytes32', type: 'bytes32' },
      { name: 's', internalType: 'bytes32', type: 'bytes32' },
    ],
    name: 'permit',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'token', internalType: 'address', type: 'address' },
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'rescueTokens',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'user', internalType: 'address', type: 'address' }],
    name: 'scaledBalanceOf',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'scaledTotalSupply',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'controller',
        internalType: 'contract IAaveIncentivesController',
        type: 'address',
      },
    ],
    name: 'setIncentivesController',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'symbol',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'totalSupply',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'recipient', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transfer',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'sender', internalType: 'address', type: 'address' },
      { name: 'recipient', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transferFrom',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'from', internalType: 'address', type: 'address' },
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'value', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transferOnLiquidation',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'target', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transferUnderlyingTo',
    outputs: [],
    stateMutability: 'nonpayable',
  },
] as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa1741a827c35250c437187406fDe16d3581232e6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeC0B304fB75eEf2d83305070e14E4ed914E4FCe0)
 */
export const usdcATokenTaikoAddress = {
  17000: '0xa1741a827c35250c437187406fDe16d3581232e6',
  167009: '0xeC0B304fB75eEf2d83305070e14E4ed914E4FCe0',
} as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa1741a827c35250c437187406fDe16d3581232e6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeC0B304fB75eEf2d83305070e14E4ed914E4FCe0)
 */
export const usdcATokenTaikoConfig = {
  address: usdcATokenTaikoAddress,
  abi: usdcATokenTaikoAbi,
} as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// USDC-StableDebtToken-Taiko
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xB612eE4d4C5F59ae4e974993177d0ff3EFA5E35f)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x0d42DD8d1979fE6c4a5F79094e648c5e788e5F27)
 */
export const usdcStableDebtTokenTaikoAbi = [
  {
    type: 'constructor',
    inputs: [{ name: 'pool', internalType: 'contract IPool', type: 'address' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'owner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'spender',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Approval',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'fromUser',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'toUser',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'asset',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'amount',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'BorrowAllowanceDelegated',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'from', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'amount',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'currentBalance',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'balanceIncrease',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'avgStableRate',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'newTotalSupply',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Burn',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'underlyingAsset',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      { name: 'pool', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'incentivesController',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
      {
        name: 'debtTokenDecimals',
        internalType: 'uint8',
        type: 'uint8',
        indexed: false,
      },
      {
        name: 'debtTokenName',
        internalType: 'string',
        type: 'string',
        indexed: false,
      },
      {
        name: 'debtTokenSymbol',
        internalType: 'string',
        type: 'string',
        indexed: false,
      },
      { name: 'params', internalType: 'bytes', type: 'bytes', indexed: false },
    ],
    name: 'Initialized',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'user', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'onBehalfOf',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'amount',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'currentBalance',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'balanceIncrease',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'newRate',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'avgStableRate',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'newTotalSupply',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Mint',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'from', internalType: 'address', type: 'address', indexed: true },
      { name: 'to', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Transfer',
  },
  {
    type: 'function',
    inputs: [],
    name: 'DEBT_TOKEN_REVISION',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'DELEGATION_WITH_SIG_TYPEHASH',
    outputs: [{ name: '', internalType: 'bytes32', type: 'bytes32' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'DOMAIN_SEPARATOR',
    outputs: [{ name: '', internalType: 'bytes32', type: 'bytes32' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'EIP712_REVISION',
    outputs: [{ name: '', internalType: 'bytes', type: 'bytes' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'POOL',
    outputs: [{ name: '', internalType: 'contract IPool', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'UNDERLYING_ASSET_ADDRESS',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'address', type: 'address' },
    ],
    name: 'allowance',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'approve',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'delegatee', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'approveDelegation',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'account', internalType: 'address', type: 'address' }],
    name: 'balanceOf',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'fromUser', internalType: 'address', type: 'address' },
      { name: 'toUser', internalType: 'address', type: 'address' },
    ],
    name: 'borrowAllowance',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'from', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'burn',
    outputs: [
      { name: '', internalType: 'uint256', type: 'uint256' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'decimals',
    outputs: [{ name: '', internalType: 'uint8', type: 'uint8' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'decreaseAllowance',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'delegator', internalType: 'address', type: 'address' },
      { name: 'delegatee', internalType: 'address', type: 'address' },
      { name: 'value', internalType: 'uint256', type: 'uint256' },
      { name: 'deadline', internalType: 'uint256', type: 'uint256' },
      { name: 'v', internalType: 'uint8', type: 'uint8' },
      { name: 'r', internalType: 'bytes32', type: 'bytes32' },
      { name: 's', internalType: 'bytes32', type: 'bytes32' },
    ],
    name: 'delegationWithSig',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getAverageStableRate',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getIncentivesController',
    outputs: [
      {
        name: '',
        internalType: 'contract IAaveIncentivesController',
        type: 'address',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getSupplyData',
    outputs: [
      { name: '', internalType: 'uint256', type: 'uint256' },
      { name: '', internalType: 'uint256', type: 'uint256' },
      { name: '', internalType: 'uint256', type: 'uint256' },
      { name: '', internalType: 'uint40', type: 'uint40' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getTotalSupplyAndAvgRate',
    outputs: [
      { name: '', internalType: 'uint256', type: 'uint256' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getTotalSupplyLastUpdated',
    outputs: [{ name: '', internalType: 'uint40', type: 'uint40' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'user', internalType: 'address', type: 'address' }],
    name: 'getUserLastUpdated',
    outputs: [{ name: '', internalType: 'uint40', type: 'uint40' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'user', internalType: 'address', type: 'address' }],
    name: 'getUserStableRate',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'increaseAllowance',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'initializingPool',
        internalType: 'contract IPool',
        type: 'address',
      },
      { name: 'underlyingAsset', internalType: 'address', type: 'address' },
      {
        name: 'incentivesController',
        internalType: 'contract IAaveIncentivesController',
        type: 'address',
      },
      { name: 'debtTokenDecimals', internalType: 'uint8', type: 'uint8' },
      { name: 'debtTokenName', internalType: 'string', type: 'string' },
      { name: 'debtTokenSymbol', internalType: 'string', type: 'string' },
      { name: 'params', internalType: 'bytes', type: 'bytes' },
    ],
    name: 'initialize',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'user', internalType: 'address', type: 'address' },
      { name: 'onBehalfOf', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
      { name: 'rate', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'mint',
    outputs: [
      { name: '', internalType: 'bool', type: 'bool' },
      { name: '', internalType: 'uint256', type: 'uint256' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'name',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'owner', internalType: 'address', type: 'address' }],
    name: 'nonces',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'user', internalType: 'address', type: 'address' }],
    name: 'principalBalanceOf',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'controller',
        internalType: 'contract IAaveIncentivesController',
        type: 'address',
      },
    ],
    name: 'setIncentivesController',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'symbol',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'totalSupply',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transfer',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transferFrom',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
] as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xB612eE4d4C5F59ae4e974993177d0ff3EFA5E35f)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x0d42DD8d1979fE6c4a5F79094e648c5e788e5F27)
 */
export const usdcStableDebtTokenTaikoAddress = {
  17000: '0xB612eE4d4C5F59ae4e974993177d0ff3EFA5E35f',
  167009: '0x0d42DD8d1979fE6c4a5F79094e648c5e788e5F27',
} as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xB612eE4d4C5F59ae4e974993177d0ff3EFA5E35f)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x0d42DD8d1979fE6c4a5F79094e648c5e788e5F27)
 */
export const usdcStableDebtTokenTaikoConfig = {
  address: usdcStableDebtTokenTaikoAddress,
  abi: usdcStableDebtTokenTaikoAbi,
} as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// USDC-TestnetMintableERC20-Taiko
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBB54E2B6C5Cb9513B46D5E6EC20E59568cD26b3f)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x3faCa18a990b2b06878f1E4b0ea594758e114812)
 */
export const usdcTestnetMintableErc20TaikoAbi = [
  {
    type: 'constructor',
    inputs: [
      { name: '_name', internalType: 'string', type: 'string' },
      { name: '_symbol', internalType: 'string', type: 'string' },
      { name: '_decimals', internalType: 'uint8', type: 'uint8' },
    ],
    stateMutability: 'nonpayable',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'owner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'spender',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Approval',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'from', internalType: 'address', type: 'address', indexed: true },
      { name: 'to', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Transfer',
  },
  {
    type: 'function',
    inputs: [
      { name: 'owner', internalType: 'address', type: 'address' },
      { name: 'spender', internalType: 'address', type: 'address' },
    ],
    name: 'allowance',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'spender', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'approve',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'account', internalType: 'address', type: 'address' }],
    name: 'balanceOf',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'decimals',
    outputs: [{ name: '', internalType: 'uint8', type: 'uint8' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'spender', internalType: 'address', type: 'address' },
      { name: 'subtractedValue', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'decreaseAllowance',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'spender', internalType: 'address', type: 'address' },
      { name: 'addedValue', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'increaseAllowance',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'name',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'symbol',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'tokenDecimals',
    outputs: [{ name: '', internalType: 'uint8', type: 'uint8' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'totalSupply',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transfer',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'from', internalType: 'address', type: 'address' },
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transferFrom',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
] as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBB54E2B6C5Cb9513B46D5E6EC20E59568cD26b3f)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x3faCa18a990b2b06878f1E4b0ea594758e114812)
 */
export const usdcTestnetMintableErc20TaikoAddress = {
  17000: '0xBB54E2B6C5Cb9513B46D5E6EC20E59568cD26b3f',
  167009: '0x3faCa18a990b2b06878f1E4b0ea594758e114812',
} as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBB54E2B6C5Cb9513B46D5E6EC20E59568cD26b3f)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x3faCa18a990b2b06878f1E4b0ea594758e114812)
 */
export const usdcTestnetMintableErc20TaikoConfig = {
  address: usdcTestnetMintableErc20TaikoAddress,
  abi: usdcTestnetMintableErc20TaikoAbi,
} as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// USDC-TestnetPriceAggregator-Taiko
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xB227D89B288fB2e84D1103493A7aC35215c7F817)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xe70c7A48C27b6b5D56D768f9494CA9CAb73bE86E)
 */
export const usdcTestnetPriceAggregatorTaikoAbi = [
  {
    type: 'constructor',
    inputs: [{ name: 'initialAnswer', internalType: 'int256', type: 'int256' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'current',
        internalType: 'int256',
        type: 'int256',
        indexed: true,
      },
      {
        name: 'roundId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: true,
      },
      {
        name: 'updatedAt',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'AnswerUpdated',
  },
  {
    type: 'function',
    inputs: [],
    name: 'decimals',
    outputs: [{ name: '', internalType: 'uint8', type: 'uint8' }],
    stateMutability: 'pure',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getTokenType',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'pure',
  },
  {
    type: 'function',
    inputs: [],
    name: 'latestAnswer',
    outputs: [{ name: '', internalType: 'int256', type: 'int256' }],
    stateMutability: 'view',
  },
] as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xB227D89B288fB2e84D1103493A7aC35215c7F817)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xe70c7A48C27b6b5D56D768f9494CA9CAb73bE86E)
 */
export const usdcTestnetPriceAggregatorTaikoAddress = {
  17000: '0xB227D89B288fB2e84D1103493A7aC35215c7F817',
  167009: '0xe70c7A48C27b6b5D56D768f9494CA9CAb73bE86E',
} as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xB227D89B288fB2e84D1103493A7aC35215c7F817)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xe70c7A48C27b6b5D56D768f9494CA9CAb73bE86E)
 */
export const usdcTestnetPriceAggregatorTaikoConfig = {
  address: usdcTestnetPriceAggregatorTaikoAddress,
  abi: usdcTestnetPriceAggregatorTaikoAbi,
} as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// USDC-VariableDebtToken-Taiko
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x3b0B993247C9D9EF4e92817380b1A16D0f55813b)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xdf50fE60bFc34bC034e40E05C0Ef8EB2DFb0B181)
 */
export const usdcVariableDebtTokenTaikoAbi = [
  {
    type: 'constructor',
    inputs: [{ name: 'pool', internalType: 'contract IPool', type: 'address' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'owner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'spender',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Approval',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'fromUser',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'toUser',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'asset',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'amount',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'BorrowAllowanceDelegated',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'from', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'target',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'balanceIncrease',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'index',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Burn',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'underlyingAsset',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      { name: 'pool', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'incentivesController',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
      {
        name: 'debtTokenDecimals',
        internalType: 'uint8',
        type: 'uint8',
        indexed: false,
      },
      {
        name: 'debtTokenName',
        internalType: 'string',
        type: 'string',
        indexed: false,
      },
      {
        name: 'debtTokenSymbol',
        internalType: 'string',
        type: 'string',
        indexed: false,
      },
      { name: 'params', internalType: 'bytes', type: 'bytes', indexed: false },
    ],
    name: 'Initialized',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'caller',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'onBehalfOf',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'balanceIncrease',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'index',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Mint',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'from', internalType: 'address', type: 'address', indexed: true },
      { name: 'to', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Transfer',
  },
  {
    type: 'function',
    inputs: [],
    name: 'DEBT_TOKEN_REVISION',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'DELEGATION_WITH_SIG_TYPEHASH',
    outputs: [{ name: '', internalType: 'bytes32', type: 'bytes32' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'DOMAIN_SEPARATOR',
    outputs: [{ name: '', internalType: 'bytes32', type: 'bytes32' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'EIP712_REVISION',
    outputs: [{ name: '', internalType: 'bytes', type: 'bytes' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'POOL',
    outputs: [{ name: '', internalType: 'contract IPool', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'UNDERLYING_ASSET_ADDRESS',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'address', type: 'address' },
    ],
    name: 'allowance',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'approve',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'delegatee', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'approveDelegation',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'user', internalType: 'address', type: 'address' }],
    name: 'balanceOf',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'fromUser', internalType: 'address', type: 'address' },
      { name: 'toUser', internalType: 'address', type: 'address' },
    ],
    name: 'borrowAllowance',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'from', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
      { name: 'index', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'burn',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'decimals',
    outputs: [{ name: '', internalType: 'uint8', type: 'uint8' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'decreaseAllowance',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'delegator', internalType: 'address', type: 'address' },
      { name: 'delegatee', internalType: 'address', type: 'address' },
      { name: 'value', internalType: 'uint256', type: 'uint256' },
      { name: 'deadline', internalType: 'uint256', type: 'uint256' },
      { name: 'v', internalType: 'uint8', type: 'uint8' },
      { name: 'r', internalType: 'bytes32', type: 'bytes32' },
      { name: 's', internalType: 'bytes32', type: 'bytes32' },
    ],
    name: 'delegationWithSig',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getIncentivesController',
    outputs: [
      {
        name: '',
        internalType: 'contract IAaveIncentivesController',
        type: 'address',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'user', internalType: 'address', type: 'address' }],
    name: 'getPreviousIndex',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'user', internalType: 'address', type: 'address' }],
    name: 'getScaledUserBalanceAndSupply',
    outputs: [
      { name: '', internalType: 'uint256', type: 'uint256' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'increaseAllowance',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'initializingPool',
        internalType: 'contract IPool',
        type: 'address',
      },
      { name: 'underlyingAsset', internalType: 'address', type: 'address' },
      {
        name: 'incentivesController',
        internalType: 'contract IAaveIncentivesController',
        type: 'address',
      },
      { name: 'debtTokenDecimals', internalType: 'uint8', type: 'uint8' },
      { name: 'debtTokenName', internalType: 'string', type: 'string' },
      { name: 'debtTokenSymbol', internalType: 'string', type: 'string' },
      { name: 'params', internalType: 'bytes', type: 'bytes' },
    ],
    name: 'initialize',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'user', internalType: 'address', type: 'address' },
      { name: 'onBehalfOf', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
      { name: 'index', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'mint',
    outputs: [
      { name: '', internalType: 'bool', type: 'bool' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'name',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'owner', internalType: 'address', type: 'address' }],
    name: 'nonces',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'user', internalType: 'address', type: 'address' }],
    name: 'scaledBalanceOf',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'scaledTotalSupply',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'controller',
        internalType: 'contract IAaveIncentivesController',
        type: 'address',
      },
    ],
    name: 'setIncentivesController',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'symbol',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'totalSupply',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transfer',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transferFrom',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
] as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x3b0B993247C9D9EF4e92817380b1A16D0f55813b)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xdf50fE60bFc34bC034e40E05C0Ef8EB2DFb0B181)
 */
export const usdcVariableDebtTokenTaikoAddress = {
  17000: '0x3b0B993247C9D9EF4e92817380b1A16D0f55813b',
  167009: '0xdf50fE60bFc34bC034e40E05C0Ef8EB2DFb0B181',
} as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x3b0B993247C9D9EF4e92817380b1A16D0f55813b)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xdf50fE60bFc34bC034e40E05C0Ef8EB2DFb0B181)
 */
export const usdcVariableDebtTokenTaikoConfig = {
  address: usdcVariableDebtTokenTaikoAddress,
  abi: usdcVariableDebtTokenTaikoAbi,
} as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// USDT-AToken-Taiko
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x745E25edB9D10391A288b28ae1385f82F6B1CaCc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x58e3db70e6Ee1a1D192650Da34bcBFEa705da09E)
 */
export const usdtATokenTaikoAbi = [
  {
    type: 'constructor',
    inputs: [{ name: 'pool', internalType: 'contract IPool', type: 'address' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'owner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'spender',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Approval',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'from', internalType: 'address', type: 'address', indexed: true },
      { name: 'to', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'index',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'BalanceTransfer',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'from', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'target',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'balanceIncrease',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'index',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Burn',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'underlyingAsset',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      { name: 'pool', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'treasury',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
      {
        name: 'incentivesController',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
      {
        name: 'aTokenDecimals',
        internalType: 'uint8',
        type: 'uint8',
        indexed: false,
      },
      {
        name: 'aTokenName',
        internalType: 'string',
        type: 'string',
        indexed: false,
      },
      {
        name: 'aTokenSymbol',
        internalType: 'string',
        type: 'string',
        indexed: false,
      },
      { name: 'params', internalType: 'bytes', type: 'bytes', indexed: false },
    ],
    name: 'Initialized',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'caller',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'onBehalfOf',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'balanceIncrease',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'index',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Mint',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'from', internalType: 'address', type: 'address', indexed: true },
      { name: 'to', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Transfer',
  },
  {
    type: 'function',
    inputs: [],
    name: 'ATOKEN_REVISION',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'DOMAIN_SEPARATOR',
    outputs: [{ name: '', internalType: 'bytes32', type: 'bytes32' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'EIP712_REVISION',
    outputs: [{ name: '', internalType: 'bytes', type: 'bytes' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'PERMIT_TYPEHASH',
    outputs: [{ name: '', internalType: 'bytes32', type: 'bytes32' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'POOL',
    outputs: [{ name: '', internalType: 'contract IPool', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'RESERVE_TREASURY_ADDRESS',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'UNDERLYING_ASSET_ADDRESS',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'owner', internalType: 'address', type: 'address' },
      { name: 'spender', internalType: 'address', type: 'address' },
    ],
    name: 'allowance',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'spender', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'approve',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'user', internalType: 'address', type: 'address' }],
    name: 'balanceOf',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'from', internalType: 'address', type: 'address' },
      {
        name: 'receiverOfUnderlying',
        internalType: 'address',
        type: 'address',
      },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
      { name: 'index', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'burn',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'decimals',
    outputs: [{ name: '', internalType: 'uint8', type: 'uint8' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'spender', internalType: 'address', type: 'address' },
      { name: 'subtractedValue', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'decreaseAllowance',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getIncentivesController',
    outputs: [
      {
        name: '',
        internalType: 'contract IAaveIncentivesController',
        type: 'address',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'user', internalType: 'address', type: 'address' }],
    name: 'getPreviousIndex',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'user', internalType: 'address', type: 'address' }],
    name: 'getScaledUserBalanceAndSupply',
    outputs: [
      { name: '', internalType: 'uint256', type: 'uint256' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'user', internalType: 'address', type: 'address' },
      { name: 'onBehalfOf', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'handleRepayment',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'spender', internalType: 'address', type: 'address' },
      { name: 'addedValue', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'increaseAllowance',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'initializingPool',
        internalType: 'contract IPool',
        type: 'address',
      },
      { name: 'treasury', internalType: 'address', type: 'address' },
      { name: 'underlyingAsset', internalType: 'address', type: 'address' },
      {
        name: 'incentivesController',
        internalType: 'contract IAaveIncentivesController',
        type: 'address',
      },
      { name: 'aTokenDecimals', internalType: 'uint8', type: 'uint8' },
      { name: 'aTokenName', internalType: 'string', type: 'string' },
      { name: 'aTokenSymbol', internalType: 'string', type: 'string' },
      { name: 'params', internalType: 'bytes', type: 'bytes' },
    ],
    name: 'initialize',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'caller', internalType: 'address', type: 'address' },
      { name: 'onBehalfOf', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
      { name: 'index', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'mint',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
      { name: 'index', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'mintToTreasury',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'name',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'owner', internalType: 'address', type: 'address' }],
    name: 'nonces',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'owner', internalType: 'address', type: 'address' },
      { name: 'spender', internalType: 'address', type: 'address' },
      { name: 'value', internalType: 'uint256', type: 'uint256' },
      { name: 'deadline', internalType: 'uint256', type: 'uint256' },
      { name: 'v', internalType: 'uint8', type: 'uint8' },
      { name: 'r', internalType: 'bytes32', type: 'bytes32' },
      { name: 's', internalType: 'bytes32', type: 'bytes32' },
    ],
    name: 'permit',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'token', internalType: 'address', type: 'address' },
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'rescueTokens',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'user', internalType: 'address', type: 'address' }],
    name: 'scaledBalanceOf',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'scaledTotalSupply',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'controller',
        internalType: 'contract IAaveIncentivesController',
        type: 'address',
      },
    ],
    name: 'setIncentivesController',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'symbol',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'totalSupply',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'recipient', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transfer',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'sender', internalType: 'address', type: 'address' },
      { name: 'recipient', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transferFrom',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'from', internalType: 'address', type: 'address' },
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'value', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transferOnLiquidation',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'target', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transferUnderlyingTo',
    outputs: [],
    stateMutability: 'nonpayable',
  },
] as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x745E25edB9D10391A288b28ae1385f82F6B1CaCc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x58e3db70e6Ee1a1D192650Da34bcBFEa705da09E)
 */
export const usdtATokenTaikoAddress = {
  17000: '0x745E25edB9D10391A288b28ae1385f82F6B1CaCc',
  167009: '0x58e3db70e6Ee1a1D192650Da34bcBFEa705da09E',
} as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x745E25edB9D10391A288b28ae1385f82F6B1CaCc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x58e3db70e6Ee1a1D192650Da34bcBFEa705da09E)
 */
export const usdtATokenTaikoConfig = {
  address: usdtATokenTaikoAddress,
  abi: usdtATokenTaikoAbi,
} as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// USDT-StableDebtToken-Taiko
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xA436Ebde4FdBf95DDc419b2BB378f91eb2196972)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7B2974f5f356Dc6516716a4BBCc06AB0230aCC77)
 */
export const usdtStableDebtTokenTaikoAbi = [
  {
    type: 'constructor',
    inputs: [{ name: 'pool', internalType: 'contract IPool', type: 'address' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'owner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'spender',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Approval',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'fromUser',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'toUser',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'asset',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'amount',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'BorrowAllowanceDelegated',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'from', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'amount',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'currentBalance',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'balanceIncrease',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'avgStableRate',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'newTotalSupply',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Burn',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'underlyingAsset',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      { name: 'pool', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'incentivesController',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
      {
        name: 'debtTokenDecimals',
        internalType: 'uint8',
        type: 'uint8',
        indexed: false,
      },
      {
        name: 'debtTokenName',
        internalType: 'string',
        type: 'string',
        indexed: false,
      },
      {
        name: 'debtTokenSymbol',
        internalType: 'string',
        type: 'string',
        indexed: false,
      },
      { name: 'params', internalType: 'bytes', type: 'bytes', indexed: false },
    ],
    name: 'Initialized',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'user', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'onBehalfOf',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'amount',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'currentBalance',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'balanceIncrease',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'newRate',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'avgStableRate',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'newTotalSupply',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Mint',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'from', internalType: 'address', type: 'address', indexed: true },
      { name: 'to', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Transfer',
  },
  {
    type: 'function',
    inputs: [],
    name: 'DEBT_TOKEN_REVISION',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'DELEGATION_WITH_SIG_TYPEHASH',
    outputs: [{ name: '', internalType: 'bytes32', type: 'bytes32' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'DOMAIN_SEPARATOR',
    outputs: [{ name: '', internalType: 'bytes32', type: 'bytes32' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'EIP712_REVISION',
    outputs: [{ name: '', internalType: 'bytes', type: 'bytes' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'POOL',
    outputs: [{ name: '', internalType: 'contract IPool', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'UNDERLYING_ASSET_ADDRESS',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'address', type: 'address' },
    ],
    name: 'allowance',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'approve',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'delegatee', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'approveDelegation',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'account', internalType: 'address', type: 'address' }],
    name: 'balanceOf',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'fromUser', internalType: 'address', type: 'address' },
      { name: 'toUser', internalType: 'address', type: 'address' },
    ],
    name: 'borrowAllowance',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'from', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'burn',
    outputs: [
      { name: '', internalType: 'uint256', type: 'uint256' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'decimals',
    outputs: [{ name: '', internalType: 'uint8', type: 'uint8' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'decreaseAllowance',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'delegator', internalType: 'address', type: 'address' },
      { name: 'delegatee', internalType: 'address', type: 'address' },
      { name: 'value', internalType: 'uint256', type: 'uint256' },
      { name: 'deadline', internalType: 'uint256', type: 'uint256' },
      { name: 'v', internalType: 'uint8', type: 'uint8' },
      { name: 'r', internalType: 'bytes32', type: 'bytes32' },
      { name: 's', internalType: 'bytes32', type: 'bytes32' },
    ],
    name: 'delegationWithSig',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getAverageStableRate',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getIncentivesController',
    outputs: [
      {
        name: '',
        internalType: 'contract IAaveIncentivesController',
        type: 'address',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getSupplyData',
    outputs: [
      { name: '', internalType: 'uint256', type: 'uint256' },
      { name: '', internalType: 'uint256', type: 'uint256' },
      { name: '', internalType: 'uint256', type: 'uint256' },
      { name: '', internalType: 'uint40', type: 'uint40' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getTotalSupplyAndAvgRate',
    outputs: [
      { name: '', internalType: 'uint256', type: 'uint256' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getTotalSupplyLastUpdated',
    outputs: [{ name: '', internalType: 'uint40', type: 'uint40' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'user', internalType: 'address', type: 'address' }],
    name: 'getUserLastUpdated',
    outputs: [{ name: '', internalType: 'uint40', type: 'uint40' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'user', internalType: 'address', type: 'address' }],
    name: 'getUserStableRate',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'increaseAllowance',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'initializingPool',
        internalType: 'contract IPool',
        type: 'address',
      },
      { name: 'underlyingAsset', internalType: 'address', type: 'address' },
      {
        name: 'incentivesController',
        internalType: 'contract IAaveIncentivesController',
        type: 'address',
      },
      { name: 'debtTokenDecimals', internalType: 'uint8', type: 'uint8' },
      { name: 'debtTokenName', internalType: 'string', type: 'string' },
      { name: 'debtTokenSymbol', internalType: 'string', type: 'string' },
      { name: 'params', internalType: 'bytes', type: 'bytes' },
    ],
    name: 'initialize',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'user', internalType: 'address', type: 'address' },
      { name: 'onBehalfOf', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
      { name: 'rate', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'mint',
    outputs: [
      { name: '', internalType: 'bool', type: 'bool' },
      { name: '', internalType: 'uint256', type: 'uint256' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'name',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'owner', internalType: 'address', type: 'address' }],
    name: 'nonces',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'user', internalType: 'address', type: 'address' }],
    name: 'principalBalanceOf',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'controller',
        internalType: 'contract IAaveIncentivesController',
        type: 'address',
      },
    ],
    name: 'setIncentivesController',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'symbol',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'totalSupply',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transfer',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transferFrom',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
] as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xA436Ebde4FdBf95DDc419b2BB378f91eb2196972)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7B2974f5f356Dc6516716a4BBCc06AB0230aCC77)
 */
export const usdtStableDebtTokenTaikoAddress = {
  17000: '0xA436Ebde4FdBf95DDc419b2BB378f91eb2196972',
  167009: '0x7B2974f5f356Dc6516716a4BBCc06AB0230aCC77',
} as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xA436Ebde4FdBf95DDc419b2BB378f91eb2196972)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7B2974f5f356Dc6516716a4BBCc06AB0230aCC77)
 */
export const usdtStableDebtTokenTaikoConfig = {
  address: usdtStableDebtTokenTaikoAddress,
  abi: usdtStableDebtTokenTaikoAbi,
} as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// USDT-TestnetMintableERC20-Taiko
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x3E6FA96c2188d15739B17174cb6c824758FeC3e2)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x15642042D7e71C662b1963fF70760495b39259d5)
 */
export const usdtTestnetMintableErc20TaikoAbi = [
  {
    type: 'constructor',
    inputs: [
      { name: '_name', internalType: 'string', type: 'string' },
      { name: '_symbol', internalType: 'string', type: 'string' },
      { name: '_decimals', internalType: 'uint8', type: 'uint8' },
    ],
    stateMutability: 'nonpayable',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'owner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'spender',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Approval',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'from', internalType: 'address', type: 'address', indexed: true },
      { name: 'to', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Transfer',
  },
  {
    type: 'function',
    inputs: [
      { name: 'owner', internalType: 'address', type: 'address' },
      { name: 'spender', internalType: 'address', type: 'address' },
    ],
    name: 'allowance',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'spender', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'approve',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'account', internalType: 'address', type: 'address' }],
    name: 'balanceOf',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'decimals',
    outputs: [{ name: '', internalType: 'uint8', type: 'uint8' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'spender', internalType: 'address', type: 'address' },
      { name: 'subtractedValue', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'decreaseAllowance',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'spender', internalType: 'address', type: 'address' },
      { name: 'addedValue', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'increaseAllowance',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'name',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'symbol',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'tokenDecimals',
    outputs: [{ name: '', internalType: 'uint8', type: 'uint8' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'totalSupply',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transfer',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'from', internalType: 'address', type: 'address' },
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transferFrom',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
] as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x3E6FA96c2188d15739B17174cb6c824758FeC3e2)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x15642042D7e71C662b1963fF70760495b39259d5)
 */
export const usdtTestnetMintableErc20TaikoAddress = {
  17000: '0x3E6FA96c2188d15739B17174cb6c824758FeC3e2',
  167009: '0x15642042D7e71C662b1963fF70760495b39259d5',
} as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x3E6FA96c2188d15739B17174cb6c824758FeC3e2)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x15642042D7e71C662b1963fF70760495b39259d5)
 */
export const usdtTestnetMintableErc20TaikoConfig = {
  address: usdtTestnetMintableErc20TaikoAddress,
  abi: usdtTestnetMintableErc20TaikoAbi,
} as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// USDT-TestnetPriceAggregator-Taiko
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xC292D916A9E49e5BbA779aBc0977ECCA4a245eA3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4CB7ba14e4c0207479d058C40ee5e102D2d4fD06)
 */
export const usdtTestnetPriceAggregatorTaikoAbi = [
  {
    type: 'constructor',
    inputs: [{ name: 'initialAnswer', internalType: 'int256', type: 'int256' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'current',
        internalType: 'int256',
        type: 'int256',
        indexed: true,
      },
      {
        name: 'roundId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: true,
      },
      {
        name: 'updatedAt',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'AnswerUpdated',
  },
  {
    type: 'function',
    inputs: [],
    name: 'decimals',
    outputs: [{ name: '', internalType: 'uint8', type: 'uint8' }],
    stateMutability: 'pure',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getTokenType',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'pure',
  },
  {
    type: 'function',
    inputs: [],
    name: 'latestAnswer',
    outputs: [{ name: '', internalType: 'int256', type: 'int256' }],
    stateMutability: 'view',
  },
] as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xC292D916A9E49e5BbA779aBc0977ECCA4a245eA3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4CB7ba14e4c0207479d058C40ee5e102D2d4fD06)
 */
export const usdtTestnetPriceAggregatorTaikoAddress = {
  17000: '0xC292D916A9E49e5BbA779aBc0977ECCA4a245eA3',
  167009: '0x4CB7ba14e4c0207479d058C40ee5e102D2d4fD06',
} as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xC292D916A9E49e5BbA779aBc0977ECCA4a245eA3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4CB7ba14e4c0207479d058C40ee5e102D2d4fD06)
 */
export const usdtTestnetPriceAggregatorTaikoConfig = {
  address: usdtTestnetPriceAggregatorTaikoAddress,
  abi: usdtTestnetPriceAggregatorTaikoAbi,
} as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// USDT-VariableDebtToken-Taiko
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa6738aC9F9176b51dB5A19D75A9a2F6315EE8a58)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x6adc80126542a27Fb76051B1bbb43E1F2F11cD9F)
 */
export const usdtVariableDebtTokenTaikoAbi = [
  {
    type: 'constructor',
    inputs: [{ name: 'pool', internalType: 'contract IPool', type: 'address' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'owner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'spender',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Approval',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'fromUser',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'toUser',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'asset',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'amount',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'BorrowAllowanceDelegated',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'from', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'target',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'balanceIncrease',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'index',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Burn',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'underlyingAsset',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      { name: 'pool', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'incentivesController',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
      {
        name: 'debtTokenDecimals',
        internalType: 'uint8',
        type: 'uint8',
        indexed: false,
      },
      {
        name: 'debtTokenName',
        internalType: 'string',
        type: 'string',
        indexed: false,
      },
      {
        name: 'debtTokenSymbol',
        internalType: 'string',
        type: 'string',
        indexed: false,
      },
      { name: 'params', internalType: 'bytes', type: 'bytes', indexed: false },
    ],
    name: 'Initialized',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'caller',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'onBehalfOf',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'balanceIncrease',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'index',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Mint',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'from', internalType: 'address', type: 'address', indexed: true },
      { name: 'to', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Transfer',
  },
  {
    type: 'function',
    inputs: [],
    name: 'DEBT_TOKEN_REVISION',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'DELEGATION_WITH_SIG_TYPEHASH',
    outputs: [{ name: '', internalType: 'bytes32', type: 'bytes32' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'DOMAIN_SEPARATOR',
    outputs: [{ name: '', internalType: 'bytes32', type: 'bytes32' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'EIP712_REVISION',
    outputs: [{ name: '', internalType: 'bytes', type: 'bytes' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'POOL',
    outputs: [{ name: '', internalType: 'contract IPool', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'UNDERLYING_ASSET_ADDRESS',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'address', type: 'address' },
    ],
    name: 'allowance',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'approve',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'delegatee', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'approveDelegation',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'user', internalType: 'address', type: 'address' }],
    name: 'balanceOf',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'fromUser', internalType: 'address', type: 'address' },
      { name: 'toUser', internalType: 'address', type: 'address' },
    ],
    name: 'borrowAllowance',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'from', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
      { name: 'index', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'burn',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'decimals',
    outputs: [{ name: '', internalType: 'uint8', type: 'uint8' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'decreaseAllowance',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'delegator', internalType: 'address', type: 'address' },
      { name: 'delegatee', internalType: 'address', type: 'address' },
      { name: 'value', internalType: 'uint256', type: 'uint256' },
      { name: 'deadline', internalType: 'uint256', type: 'uint256' },
      { name: 'v', internalType: 'uint8', type: 'uint8' },
      { name: 'r', internalType: 'bytes32', type: 'bytes32' },
      { name: 's', internalType: 'bytes32', type: 'bytes32' },
    ],
    name: 'delegationWithSig',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getIncentivesController',
    outputs: [
      {
        name: '',
        internalType: 'contract IAaveIncentivesController',
        type: 'address',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'user', internalType: 'address', type: 'address' }],
    name: 'getPreviousIndex',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'user', internalType: 'address', type: 'address' }],
    name: 'getScaledUserBalanceAndSupply',
    outputs: [
      { name: '', internalType: 'uint256', type: 'uint256' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'increaseAllowance',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'initializingPool',
        internalType: 'contract IPool',
        type: 'address',
      },
      { name: 'underlyingAsset', internalType: 'address', type: 'address' },
      {
        name: 'incentivesController',
        internalType: 'contract IAaveIncentivesController',
        type: 'address',
      },
      { name: 'debtTokenDecimals', internalType: 'uint8', type: 'uint8' },
      { name: 'debtTokenName', internalType: 'string', type: 'string' },
      { name: 'debtTokenSymbol', internalType: 'string', type: 'string' },
      { name: 'params', internalType: 'bytes', type: 'bytes' },
    ],
    name: 'initialize',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'user', internalType: 'address', type: 'address' },
      { name: 'onBehalfOf', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
      { name: 'index', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'mint',
    outputs: [
      { name: '', internalType: 'bool', type: 'bool' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'name',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'owner', internalType: 'address', type: 'address' }],
    name: 'nonces',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'user', internalType: 'address', type: 'address' }],
    name: 'scaledBalanceOf',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'scaledTotalSupply',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'controller',
        internalType: 'contract IAaveIncentivesController',
        type: 'address',
      },
    ],
    name: 'setIncentivesController',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'symbol',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'totalSupply',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transfer',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transferFrom',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
] as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa6738aC9F9176b51dB5A19D75A9a2F6315EE8a58)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x6adc80126542a27Fb76051B1bbb43E1F2F11cD9F)
 */
export const usdtVariableDebtTokenTaikoAddress = {
  17000: '0xa6738aC9F9176b51dB5A19D75A9a2F6315EE8a58',
  167009: '0x6adc80126542a27Fb76051B1bbb43E1F2F11cD9F',
} as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa6738aC9F9176b51dB5A19D75A9a2F6315EE8a58)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x6adc80126542a27Fb76051B1bbb43E1F2F11cD9F)
 */
export const usdtVariableDebtTokenTaikoConfig = {
  address: usdtVariableDebtTokenTaikoAddress,
  abi: usdtVariableDebtTokenTaikoAbi,
} as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// UiIncentiveDataProviderV3
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x520A3776050B4bbE4CD30c2303c123DeF90671fD)
 */
export const uiIncentiveDataProviderV3Abi = [
  {
    type: 'function',
    inputs: [
      {
        name: 'provider',
        internalType: 'contract IPoolAddressesProvider',
        type: 'address',
      },
      { name: 'user', internalType: 'address', type: 'address' },
    ],
    name: 'getFullReservesIncentiveData',
    outputs: [
      {
        name: '',
        internalType:
          'struct IUiIncentiveDataProviderV3.AggregatedReserveIncentiveData[]',
        type: 'tuple[]',
        components: [
          { name: 'underlyingAsset', internalType: 'address', type: 'address' },
          {
            name: 'aIncentiveData',
            internalType: 'struct IUiIncentiveDataProviderV3.IncentiveData',
            type: 'tuple',
            components: [
              {
                name: 'tokenAddress',
                internalType: 'address',
                type: 'address',
              },
              {
                name: 'incentiveControllerAddress',
                internalType: 'address',
                type: 'address',
              },
              {
                name: 'rewardsTokenInformation',
                internalType: 'struct IUiIncentiveDataProviderV3.RewardInfo[]',
                type: 'tuple[]',
                components: [
                  {
                    name: 'rewardTokenSymbol',
                    internalType: 'string',
                    type: 'string',
                  },
                  {
                    name: 'rewardTokenAddress',
                    internalType: 'address',
                    type: 'address',
                  },
                  {
                    name: 'rewardOracleAddress',
                    internalType: 'address',
                    type: 'address',
                  },
                  {
                    name: 'emissionPerSecond',
                    internalType: 'uint256',
                    type: 'uint256',
                  },
                  {
                    name: 'incentivesLastUpdateTimestamp',
                    internalType: 'uint256',
                    type: 'uint256',
                  },
                  {
                    name: 'tokenIncentivesIndex',
                    internalType: 'uint256',
                    type: 'uint256',
                  },
                  {
                    name: 'emissionEndTimestamp',
                    internalType: 'uint256',
                    type: 'uint256',
                  },
                  {
                    name: 'rewardPriceFeed',
                    internalType: 'int256',
                    type: 'int256',
                  },
                  {
                    name: 'rewardTokenDecimals',
                    internalType: 'uint8',
                    type: 'uint8',
                  },
                  { name: 'precision', internalType: 'uint8', type: 'uint8' },
                  {
                    name: 'priceFeedDecimals',
                    internalType: 'uint8',
                    type: 'uint8',
                  },
                ],
              },
            ],
          },
          {
            name: 'vIncentiveData',
            internalType: 'struct IUiIncentiveDataProviderV3.IncentiveData',
            type: 'tuple',
            components: [
              {
                name: 'tokenAddress',
                internalType: 'address',
                type: 'address',
              },
              {
                name: 'incentiveControllerAddress',
                internalType: 'address',
                type: 'address',
              },
              {
                name: 'rewardsTokenInformation',
                internalType: 'struct IUiIncentiveDataProviderV3.RewardInfo[]',
                type: 'tuple[]',
                components: [
                  {
                    name: 'rewardTokenSymbol',
                    internalType: 'string',
                    type: 'string',
                  },
                  {
                    name: 'rewardTokenAddress',
                    internalType: 'address',
                    type: 'address',
                  },
                  {
                    name: 'rewardOracleAddress',
                    internalType: 'address',
                    type: 'address',
                  },
                  {
                    name: 'emissionPerSecond',
                    internalType: 'uint256',
                    type: 'uint256',
                  },
                  {
                    name: 'incentivesLastUpdateTimestamp',
                    internalType: 'uint256',
                    type: 'uint256',
                  },
                  {
                    name: 'tokenIncentivesIndex',
                    internalType: 'uint256',
                    type: 'uint256',
                  },
                  {
                    name: 'emissionEndTimestamp',
                    internalType: 'uint256',
                    type: 'uint256',
                  },
                  {
                    name: 'rewardPriceFeed',
                    internalType: 'int256',
                    type: 'int256',
                  },
                  {
                    name: 'rewardTokenDecimals',
                    internalType: 'uint8',
                    type: 'uint8',
                  },
                  { name: 'precision', internalType: 'uint8', type: 'uint8' },
                  {
                    name: 'priceFeedDecimals',
                    internalType: 'uint8',
                    type: 'uint8',
                  },
                ],
              },
            ],
          },
          {
            name: 'sIncentiveData',
            internalType: 'struct IUiIncentiveDataProviderV3.IncentiveData',
            type: 'tuple',
            components: [
              {
                name: 'tokenAddress',
                internalType: 'address',
                type: 'address',
              },
              {
                name: 'incentiveControllerAddress',
                internalType: 'address',
                type: 'address',
              },
              {
                name: 'rewardsTokenInformation',
                internalType: 'struct IUiIncentiveDataProviderV3.RewardInfo[]',
                type: 'tuple[]',
                components: [
                  {
                    name: 'rewardTokenSymbol',
                    internalType: 'string',
                    type: 'string',
                  },
                  {
                    name: 'rewardTokenAddress',
                    internalType: 'address',
                    type: 'address',
                  },
                  {
                    name: 'rewardOracleAddress',
                    internalType: 'address',
                    type: 'address',
                  },
                  {
                    name: 'emissionPerSecond',
                    internalType: 'uint256',
                    type: 'uint256',
                  },
                  {
                    name: 'incentivesLastUpdateTimestamp',
                    internalType: 'uint256',
                    type: 'uint256',
                  },
                  {
                    name: 'tokenIncentivesIndex',
                    internalType: 'uint256',
                    type: 'uint256',
                  },
                  {
                    name: 'emissionEndTimestamp',
                    internalType: 'uint256',
                    type: 'uint256',
                  },
                  {
                    name: 'rewardPriceFeed',
                    internalType: 'int256',
                    type: 'int256',
                  },
                  {
                    name: 'rewardTokenDecimals',
                    internalType: 'uint8',
                    type: 'uint8',
                  },
                  { name: 'precision', internalType: 'uint8', type: 'uint8' },
                  {
                    name: 'priceFeedDecimals',
                    internalType: 'uint8',
                    type: 'uint8',
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        name: '',
        internalType:
          'struct IUiIncentiveDataProviderV3.UserReserveIncentiveData[]',
        type: 'tuple[]',
        components: [
          { name: 'underlyingAsset', internalType: 'address', type: 'address' },
          {
            name: 'aTokenIncentivesUserData',
            internalType: 'struct IUiIncentiveDataProviderV3.UserIncentiveData',
            type: 'tuple',
            components: [
              {
                name: 'tokenAddress',
                internalType: 'address',
                type: 'address',
              },
              {
                name: 'incentiveControllerAddress',
                internalType: 'address',
                type: 'address',
              },
              {
                name: 'userRewardsInformation',
                internalType:
                  'struct IUiIncentiveDataProviderV3.UserRewardInfo[]',
                type: 'tuple[]',
                components: [
                  {
                    name: 'rewardTokenSymbol',
                    internalType: 'string',
                    type: 'string',
                  },
                  {
                    name: 'rewardOracleAddress',
                    internalType: 'address',
                    type: 'address',
                  },
                  {
                    name: 'rewardTokenAddress',
                    internalType: 'address',
                    type: 'address',
                  },
                  {
                    name: 'userUnclaimedRewards',
                    internalType: 'uint256',
                    type: 'uint256',
                  },
                  {
                    name: 'tokenIncentivesUserIndex',
                    internalType: 'uint256',
                    type: 'uint256',
                  },
                  {
                    name: 'rewardPriceFeed',
                    internalType: 'int256',
                    type: 'int256',
                  },
                  {
                    name: 'priceFeedDecimals',
                    internalType: 'uint8',
                    type: 'uint8',
                  },
                  {
                    name: 'rewardTokenDecimals',
                    internalType: 'uint8',
                    type: 'uint8',
                  },
                ],
              },
            ],
          },
          {
            name: 'vTokenIncentivesUserData',
            internalType: 'struct IUiIncentiveDataProviderV3.UserIncentiveData',
            type: 'tuple',
            components: [
              {
                name: 'tokenAddress',
                internalType: 'address',
                type: 'address',
              },
              {
                name: 'incentiveControllerAddress',
                internalType: 'address',
                type: 'address',
              },
              {
                name: 'userRewardsInformation',
                internalType:
                  'struct IUiIncentiveDataProviderV3.UserRewardInfo[]',
                type: 'tuple[]',
                components: [
                  {
                    name: 'rewardTokenSymbol',
                    internalType: 'string',
                    type: 'string',
                  },
                  {
                    name: 'rewardOracleAddress',
                    internalType: 'address',
                    type: 'address',
                  },
                  {
                    name: 'rewardTokenAddress',
                    internalType: 'address',
                    type: 'address',
                  },
                  {
                    name: 'userUnclaimedRewards',
                    internalType: 'uint256',
                    type: 'uint256',
                  },
                  {
                    name: 'tokenIncentivesUserIndex',
                    internalType: 'uint256',
                    type: 'uint256',
                  },
                  {
                    name: 'rewardPriceFeed',
                    internalType: 'int256',
                    type: 'int256',
                  },
                  {
                    name: 'priceFeedDecimals',
                    internalType: 'uint8',
                    type: 'uint8',
                  },
                  {
                    name: 'rewardTokenDecimals',
                    internalType: 'uint8',
                    type: 'uint8',
                  },
                ],
              },
            ],
          },
          {
            name: 'sTokenIncentivesUserData',
            internalType: 'struct IUiIncentiveDataProviderV3.UserIncentiveData',
            type: 'tuple',
            components: [
              {
                name: 'tokenAddress',
                internalType: 'address',
                type: 'address',
              },
              {
                name: 'incentiveControllerAddress',
                internalType: 'address',
                type: 'address',
              },
              {
                name: 'userRewardsInformation',
                internalType:
                  'struct IUiIncentiveDataProviderV3.UserRewardInfo[]',
                type: 'tuple[]',
                components: [
                  {
                    name: 'rewardTokenSymbol',
                    internalType: 'string',
                    type: 'string',
                  },
                  {
                    name: 'rewardOracleAddress',
                    internalType: 'address',
                    type: 'address',
                  },
                  {
                    name: 'rewardTokenAddress',
                    internalType: 'address',
                    type: 'address',
                  },
                  {
                    name: 'userUnclaimedRewards',
                    internalType: 'uint256',
                    type: 'uint256',
                  },
                  {
                    name: 'tokenIncentivesUserIndex',
                    internalType: 'uint256',
                    type: 'uint256',
                  },
                  {
                    name: 'rewardPriceFeed',
                    internalType: 'int256',
                    type: 'int256',
                  },
                  {
                    name: 'priceFeedDecimals',
                    internalType: 'uint8',
                    type: 'uint8',
                  },
                  {
                    name: 'rewardTokenDecimals',
                    internalType: 'uint8',
                    type: 'uint8',
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'provider',
        internalType: 'contract IPoolAddressesProvider',
        type: 'address',
      },
    ],
    name: 'getReservesIncentivesData',
    outputs: [
      {
        name: '',
        internalType:
          'struct IUiIncentiveDataProviderV3.AggregatedReserveIncentiveData[]',
        type: 'tuple[]',
        components: [
          { name: 'underlyingAsset', internalType: 'address', type: 'address' },
          {
            name: 'aIncentiveData',
            internalType: 'struct IUiIncentiveDataProviderV3.IncentiveData',
            type: 'tuple',
            components: [
              {
                name: 'tokenAddress',
                internalType: 'address',
                type: 'address',
              },
              {
                name: 'incentiveControllerAddress',
                internalType: 'address',
                type: 'address',
              },
              {
                name: 'rewardsTokenInformation',
                internalType: 'struct IUiIncentiveDataProviderV3.RewardInfo[]',
                type: 'tuple[]',
                components: [
                  {
                    name: 'rewardTokenSymbol',
                    internalType: 'string',
                    type: 'string',
                  },
                  {
                    name: 'rewardTokenAddress',
                    internalType: 'address',
                    type: 'address',
                  },
                  {
                    name: 'rewardOracleAddress',
                    internalType: 'address',
                    type: 'address',
                  },
                  {
                    name: 'emissionPerSecond',
                    internalType: 'uint256',
                    type: 'uint256',
                  },
                  {
                    name: 'incentivesLastUpdateTimestamp',
                    internalType: 'uint256',
                    type: 'uint256',
                  },
                  {
                    name: 'tokenIncentivesIndex',
                    internalType: 'uint256',
                    type: 'uint256',
                  },
                  {
                    name: 'emissionEndTimestamp',
                    internalType: 'uint256',
                    type: 'uint256',
                  },
                  {
                    name: 'rewardPriceFeed',
                    internalType: 'int256',
                    type: 'int256',
                  },
                  {
                    name: 'rewardTokenDecimals',
                    internalType: 'uint8',
                    type: 'uint8',
                  },
                  { name: 'precision', internalType: 'uint8', type: 'uint8' },
                  {
                    name: 'priceFeedDecimals',
                    internalType: 'uint8',
                    type: 'uint8',
                  },
                ],
              },
            ],
          },
          {
            name: 'vIncentiveData',
            internalType: 'struct IUiIncentiveDataProviderV3.IncentiveData',
            type: 'tuple',
            components: [
              {
                name: 'tokenAddress',
                internalType: 'address',
                type: 'address',
              },
              {
                name: 'incentiveControllerAddress',
                internalType: 'address',
                type: 'address',
              },
              {
                name: 'rewardsTokenInformation',
                internalType: 'struct IUiIncentiveDataProviderV3.RewardInfo[]',
                type: 'tuple[]',
                components: [
                  {
                    name: 'rewardTokenSymbol',
                    internalType: 'string',
                    type: 'string',
                  },
                  {
                    name: 'rewardTokenAddress',
                    internalType: 'address',
                    type: 'address',
                  },
                  {
                    name: 'rewardOracleAddress',
                    internalType: 'address',
                    type: 'address',
                  },
                  {
                    name: 'emissionPerSecond',
                    internalType: 'uint256',
                    type: 'uint256',
                  },
                  {
                    name: 'incentivesLastUpdateTimestamp',
                    internalType: 'uint256',
                    type: 'uint256',
                  },
                  {
                    name: 'tokenIncentivesIndex',
                    internalType: 'uint256',
                    type: 'uint256',
                  },
                  {
                    name: 'emissionEndTimestamp',
                    internalType: 'uint256',
                    type: 'uint256',
                  },
                  {
                    name: 'rewardPriceFeed',
                    internalType: 'int256',
                    type: 'int256',
                  },
                  {
                    name: 'rewardTokenDecimals',
                    internalType: 'uint8',
                    type: 'uint8',
                  },
                  { name: 'precision', internalType: 'uint8', type: 'uint8' },
                  {
                    name: 'priceFeedDecimals',
                    internalType: 'uint8',
                    type: 'uint8',
                  },
                ],
              },
            ],
          },
          {
            name: 'sIncentiveData',
            internalType: 'struct IUiIncentiveDataProviderV3.IncentiveData',
            type: 'tuple',
            components: [
              {
                name: 'tokenAddress',
                internalType: 'address',
                type: 'address',
              },
              {
                name: 'incentiveControllerAddress',
                internalType: 'address',
                type: 'address',
              },
              {
                name: 'rewardsTokenInformation',
                internalType: 'struct IUiIncentiveDataProviderV3.RewardInfo[]',
                type: 'tuple[]',
                components: [
                  {
                    name: 'rewardTokenSymbol',
                    internalType: 'string',
                    type: 'string',
                  },
                  {
                    name: 'rewardTokenAddress',
                    internalType: 'address',
                    type: 'address',
                  },
                  {
                    name: 'rewardOracleAddress',
                    internalType: 'address',
                    type: 'address',
                  },
                  {
                    name: 'emissionPerSecond',
                    internalType: 'uint256',
                    type: 'uint256',
                  },
                  {
                    name: 'incentivesLastUpdateTimestamp',
                    internalType: 'uint256',
                    type: 'uint256',
                  },
                  {
                    name: 'tokenIncentivesIndex',
                    internalType: 'uint256',
                    type: 'uint256',
                  },
                  {
                    name: 'emissionEndTimestamp',
                    internalType: 'uint256',
                    type: 'uint256',
                  },
                  {
                    name: 'rewardPriceFeed',
                    internalType: 'int256',
                    type: 'int256',
                  },
                  {
                    name: 'rewardTokenDecimals',
                    internalType: 'uint8',
                    type: 'uint8',
                  },
                  { name: 'precision', internalType: 'uint8', type: 'uint8' },
                  {
                    name: 'priceFeedDecimals',
                    internalType: 'uint8',
                    type: 'uint8',
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'provider',
        internalType: 'contract IPoolAddressesProvider',
        type: 'address',
      },
      { name: 'user', internalType: 'address', type: 'address' },
    ],
    name: 'getUserReservesIncentivesData',
    outputs: [
      {
        name: '',
        internalType:
          'struct IUiIncentiveDataProviderV3.UserReserveIncentiveData[]',
        type: 'tuple[]',
        components: [
          { name: 'underlyingAsset', internalType: 'address', type: 'address' },
          {
            name: 'aTokenIncentivesUserData',
            internalType: 'struct IUiIncentiveDataProviderV3.UserIncentiveData',
            type: 'tuple',
            components: [
              {
                name: 'tokenAddress',
                internalType: 'address',
                type: 'address',
              },
              {
                name: 'incentiveControllerAddress',
                internalType: 'address',
                type: 'address',
              },
              {
                name: 'userRewardsInformation',
                internalType:
                  'struct IUiIncentiveDataProviderV3.UserRewardInfo[]',
                type: 'tuple[]',
                components: [
                  {
                    name: 'rewardTokenSymbol',
                    internalType: 'string',
                    type: 'string',
                  },
                  {
                    name: 'rewardOracleAddress',
                    internalType: 'address',
                    type: 'address',
                  },
                  {
                    name: 'rewardTokenAddress',
                    internalType: 'address',
                    type: 'address',
                  },
                  {
                    name: 'userUnclaimedRewards',
                    internalType: 'uint256',
                    type: 'uint256',
                  },
                  {
                    name: 'tokenIncentivesUserIndex',
                    internalType: 'uint256',
                    type: 'uint256',
                  },
                  {
                    name: 'rewardPriceFeed',
                    internalType: 'int256',
                    type: 'int256',
                  },
                  {
                    name: 'priceFeedDecimals',
                    internalType: 'uint8',
                    type: 'uint8',
                  },
                  {
                    name: 'rewardTokenDecimals',
                    internalType: 'uint8',
                    type: 'uint8',
                  },
                ],
              },
            ],
          },
          {
            name: 'vTokenIncentivesUserData',
            internalType: 'struct IUiIncentiveDataProviderV3.UserIncentiveData',
            type: 'tuple',
            components: [
              {
                name: 'tokenAddress',
                internalType: 'address',
                type: 'address',
              },
              {
                name: 'incentiveControllerAddress',
                internalType: 'address',
                type: 'address',
              },
              {
                name: 'userRewardsInformation',
                internalType:
                  'struct IUiIncentiveDataProviderV3.UserRewardInfo[]',
                type: 'tuple[]',
                components: [
                  {
                    name: 'rewardTokenSymbol',
                    internalType: 'string',
                    type: 'string',
                  },
                  {
                    name: 'rewardOracleAddress',
                    internalType: 'address',
                    type: 'address',
                  },
                  {
                    name: 'rewardTokenAddress',
                    internalType: 'address',
                    type: 'address',
                  },
                  {
                    name: 'userUnclaimedRewards',
                    internalType: 'uint256',
                    type: 'uint256',
                  },
                  {
                    name: 'tokenIncentivesUserIndex',
                    internalType: 'uint256',
                    type: 'uint256',
                  },
                  {
                    name: 'rewardPriceFeed',
                    internalType: 'int256',
                    type: 'int256',
                  },
                  {
                    name: 'priceFeedDecimals',
                    internalType: 'uint8',
                    type: 'uint8',
                  },
                  {
                    name: 'rewardTokenDecimals',
                    internalType: 'uint8',
                    type: 'uint8',
                  },
                ],
              },
            ],
          },
          {
            name: 'sTokenIncentivesUserData',
            internalType: 'struct IUiIncentiveDataProviderV3.UserIncentiveData',
            type: 'tuple',
            components: [
              {
                name: 'tokenAddress',
                internalType: 'address',
                type: 'address',
              },
              {
                name: 'incentiveControllerAddress',
                internalType: 'address',
                type: 'address',
              },
              {
                name: 'userRewardsInformation',
                internalType:
                  'struct IUiIncentiveDataProviderV3.UserRewardInfo[]',
                type: 'tuple[]',
                components: [
                  {
                    name: 'rewardTokenSymbol',
                    internalType: 'string',
                    type: 'string',
                  },
                  {
                    name: 'rewardOracleAddress',
                    internalType: 'address',
                    type: 'address',
                  },
                  {
                    name: 'rewardTokenAddress',
                    internalType: 'address',
                    type: 'address',
                  },
                  {
                    name: 'userUnclaimedRewards',
                    internalType: 'uint256',
                    type: 'uint256',
                  },
                  {
                    name: 'tokenIncentivesUserIndex',
                    internalType: 'uint256',
                    type: 'uint256',
                  },
                  {
                    name: 'rewardPriceFeed',
                    internalType: 'int256',
                    type: 'int256',
                  },
                  {
                    name: 'priceFeedDecimals',
                    internalType: 'uint8',
                    type: 'uint8',
                  },
                  {
                    name: 'rewardTokenDecimals',
                    internalType: 'uint8',
                    type: 'uint8',
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
    stateMutability: 'view',
  },
] as const

/**
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x520A3776050B4bbE4CD30c2303c123DeF90671fD)
 */
export const uiIncentiveDataProviderV3Address = {
  167009: '0x520A3776050B4bbE4CD30c2303c123DeF90671fD',
} as const

/**
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x520A3776050B4bbE4CD30c2303c123DeF90671fD)
 */
export const uiIncentiveDataProviderV3Config = {
  address: uiIncentiveDataProviderV3Address,
  abi: uiIncentiveDataProviderV3Abi,
} as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// UiPoolDataProviderV3
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9877f86A83825B6900aDcb27978C073FaEAD55Dd)
 */
export const uiPoolDataProviderV3Abi = [
  {
    type: 'constructor',
    inputs: [
      {
        name: '_networkBaseTokenPriceInUsdProxyAggregator',
        internalType: 'contract IEACAggregatorProxy',
        type: 'address',
      },
      {
        name: '_marketReferenceCurrencyPriceInUsdProxyAggregator',
        internalType: 'contract IEACAggregatorProxy',
        type: 'address',
      },
    ],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'ETH_CURRENCY_UNIT',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'MKR_ADDRESS',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: '_bytes32', internalType: 'bytes32', type: 'bytes32' }],
    name: 'bytes32ToString',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'pure',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'provider',
        internalType: 'contract IPoolAddressesProvider',
        type: 'address',
      },
    ],
    name: 'getReservesData',
    outputs: [
      {
        name: '',
        internalType: 'struct IUiPoolDataProviderV3.AggregatedReserveData[]',
        type: 'tuple[]',
        components: [
          { name: 'underlyingAsset', internalType: 'address', type: 'address' },
          { name: 'name', internalType: 'string', type: 'string' },
          { name: 'symbol', internalType: 'string', type: 'string' },
          { name: 'decimals', internalType: 'uint256', type: 'uint256' },
          {
            name: 'baseLTVasCollateral',
            internalType: 'uint256',
            type: 'uint256',
          },
          {
            name: 'reserveLiquidationThreshold',
            internalType: 'uint256',
            type: 'uint256',
          },
          {
            name: 'reserveLiquidationBonus',
            internalType: 'uint256',
            type: 'uint256',
          },
          { name: 'reserveFactor', internalType: 'uint256', type: 'uint256' },
          {
            name: 'usageAsCollateralEnabled',
            internalType: 'bool',
            type: 'bool',
          },
          { name: 'borrowingEnabled', internalType: 'bool', type: 'bool' },
          {
            name: 'stableBorrowRateEnabled',
            internalType: 'bool',
            type: 'bool',
          },
          { name: 'isActive', internalType: 'bool', type: 'bool' },
          { name: 'isFrozen', internalType: 'bool', type: 'bool' },
          { name: 'liquidityIndex', internalType: 'uint128', type: 'uint128' },
          {
            name: 'variableBorrowIndex',
            internalType: 'uint128',
            type: 'uint128',
          },
          { name: 'liquidityRate', internalType: 'uint128', type: 'uint128' },
          {
            name: 'variableBorrowRate',
            internalType: 'uint128',
            type: 'uint128',
          },
          {
            name: 'stableBorrowRate',
            internalType: 'uint128',
            type: 'uint128',
          },
          {
            name: 'lastUpdateTimestamp',
            internalType: 'uint40',
            type: 'uint40',
          },
          { name: 'aTokenAddress', internalType: 'address', type: 'address' },
          {
            name: 'stableDebtTokenAddress',
            internalType: 'address',
            type: 'address',
          },
          {
            name: 'variableDebtTokenAddress',
            internalType: 'address',
            type: 'address',
          },
          {
            name: 'interestRateStrategyAddress',
            internalType: 'address',
            type: 'address',
          },
          {
            name: 'availableLiquidity',
            internalType: 'uint256',
            type: 'uint256',
          },
          {
            name: 'totalPrincipalStableDebt',
            internalType: 'uint256',
            type: 'uint256',
          },
          {
            name: 'averageStableRate',
            internalType: 'uint256',
            type: 'uint256',
          },
          {
            name: 'stableDebtLastUpdateTimestamp',
            internalType: 'uint256',
            type: 'uint256',
          },
          {
            name: 'totalScaledVariableDebt',
            internalType: 'uint256',
            type: 'uint256',
          },
          {
            name: 'priceInMarketReferenceCurrency',
            internalType: 'uint256',
            type: 'uint256',
          },
          { name: 'priceOracle', internalType: 'address', type: 'address' },
          {
            name: 'variableRateSlope1',
            internalType: 'uint256',
            type: 'uint256',
          },
          {
            name: 'variableRateSlope2',
            internalType: 'uint256',
            type: 'uint256',
          },
          {
            name: 'stableRateSlope1',
            internalType: 'uint256',
            type: 'uint256',
          },
          {
            name: 'stableRateSlope2',
            internalType: 'uint256',
            type: 'uint256',
          },
          {
            name: 'baseStableBorrowRate',
            internalType: 'uint256',
            type: 'uint256',
          },
          {
            name: 'baseVariableBorrowRate',
            internalType: 'uint256',
            type: 'uint256',
          },
          {
            name: 'optimalUsageRatio',
            internalType: 'uint256',
            type: 'uint256',
          },
          { name: 'isPaused', internalType: 'bool', type: 'bool' },
          { name: 'isSiloedBorrowing', internalType: 'bool', type: 'bool' },
          {
            name: 'accruedToTreasury',
            internalType: 'uint128',
            type: 'uint128',
          },
          { name: 'unbacked', internalType: 'uint128', type: 'uint128' },
          {
            name: 'isolationModeTotalDebt',
            internalType: 'uint128',
            type: 'uint128',
          },
          { name: 'flashLoanEnabled', internalType: 'bool', type: 'bool' },
          { name: 'debtCeiling', internalType: 'uint256', type: 'uint256' },
          {
            name: 'debtCeilingDecimals',
            internalType: 'uint256',
            type: 'uint256',
          },
          { name: 'eModeCategoryId', internalType: 'uint8', type: 'uint8' },
          { name: 'borrowCap', internalType: 'uint256', type: 'uint256' },
          { name: 'supplyCap', internalType: 'uint256', type: 'uint256' },
          { name: 'eModeLtv', internalType: 'uint16', type: 'uint16' },
          {
            name: 'eModeLiquidationThreshold',
            internalType: 'uint16',
            type: 'uint16',
          },
          {
            name: 'eModeLiquidationBonus',
            internalType: 'uint16',
            type: 'uint16',
          },
          {
            name: 'eModePriceSource',
            internalType: 'address',
            type: 'address',
          },
          { name: 'eModeLabel', internalType: 'string', type: 'string' },
          { name: 'borrowableInIsolation', internalType: 'bool', type: 'bool' },
        ],
      },
      {
        name: '',
        internalType: 'struct IUiPoolDataProviderV3.BaseCurrencyInfo',
        type: 'tuple',
        components: [
          {
            name: 'marketReferenceCurrencyUnit',
            internalType: 'uint256',
            type: 'uint256',
          },
          {
            name: 'marketReferenceCurrencyPriceInUsd',
            internalType: 'int256',
            type: 'int256',
          },
          {
            name: 'networkBaseTokenPriceInUsd',
            internalType: 'int256',
            type: 'int256',
          },
          {
            name: 'networkBaseTokenPriceDecimals',
            internalType: 'uint8',
            type: 'uint8',
          },
        ],
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'provider',
        internalType: 'contract IPoolAddressesProvider',
        type: 'address',
      },
    ],
    name: 'getReservesList',
    outputs: [{ name: '', internalType: 'address[]', type: 'address[]' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'provider',
        internalType: 'contract IPoolAddressesProvider',
        type: 'address',
      },
      { name: 'user', internalType: 'address', type: 'address' },
    ],
    name: 'getUserReservesData',
    outputs: [
      {
        name: '',
        internalType: 'struct IUiPoolDataProviderV3.UserReserveData[]',
        type: 'tuple[]',
        components: [
          { name: 'underlyingAsset', internalType: 'address', type: 'address' },
          {
            name: 'scaledATokenBalance',
            internalType: 'uint256',
            type: 'uint256',
          },
          {
            name: 'usageAsCollateralEnabledOnUser',
            internalType: 'bool',
            type: 'bool',
          },
          {
            name: 'stableBorrowRate',
            internalType: 'uint256',
            type: 'uint256',
          },
          {
            name: 'scaledVariableDebt',
            internalType: 'uint256',
            type: 'uint256',
          },
          {
            name: 'principalStableDebt',
            internalType: 'uint256',
            type: 'uint256',
          },
          {
            name: 'stableBorrowLastUpdateTimestamp',
            internalType: 'uint256',
            type: 'uint256',
          },
        ],
      },
      { name: '', internalType: 'uint8', type: 'uint8' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'marketReferenceCurrencyPriceInUsdProxyAggregator',
    outputs: [
      {
        name: '',
        internalType: 'contract IEACAggregatorProxy',
        type: 'address',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'networkBaseTokenPriceInUsdProxyAggregator',
    outputs: [
      {
        name: '',
        internalType: 'contract IEACAggregatorProxy',
        type: 'address',
      },
    ],
    stateMutability: 'view',
  },
] as const

/**
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9877f86A83825B6900aDcb27978C073FaEAD55Dd)
 */
export const uiPoolDataProviderV3Address = {
  167009: '0x9877f86A83825B6900aDcb27978C073FaEAD55Dd',
} as const

/**
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9877f86A83825B6900aDcb27978C073FaEAD55Dd)
 */
export const uiPoolDataProviderV3Config = {
  address: uiPoolDataProviderV3Address,
  abi: uiPoolDataProviderV3Abi,
} as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// VariableDebtToken-Taiko
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xb4055dF6337c84e2e1Ae8d938DF0E0f8CAd242c6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD3ac76c5eE3765d465Ec77664F3Afc6C21Ce09DD)
 */
export const variableDebtTokenTaikoAbi = [
  {
    type: 'constructor',
    inputs: [{ name: 'pool', internalType: 'contract IPool', type: 'address' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'owner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'spender',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Approval',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'fromUser',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'toUser',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'asset',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'amount',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'BorrowAllowanceDelegated',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'from', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'target',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'balanceIncrease',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'index',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Burn',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'underlyingAsset',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      { name: 'pool', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'incentivesController',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
      {
        name: 'debtTokenDecimals',
        internalType: 'uint8',
        type: 'uint8',
        indexed: false,
      },
      {
        name: 'debtTokenName',
        internalType: 'string',
        type: 'string',
        indexed: false,
      },
      {
        name: 'debtTokenSymbol',
        internalType: 'string',
        type: 'string',
        indexed: false,
      },
      { name: 'params', internalType: 'bytes', type: 'bytes', indexed: false },
    ],
    name: 'Initialized',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'caller',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'onBehalfOf',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'balanceIncrease',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'index',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Mint',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'from', internalType: 'address', type: 'address', indexed: true },
      { name: 'to', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Transfer',
  },
  {
    type: 'function',
    inputs: [],
    name: 'DEBT_TOKEN_REVISION',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'DELEGATION_WITH_SIG_TYPEHASH',
    outputs: [{ name: '', internalType: 'bytes32', type: 'bytes32' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'DOMAIN_SEPARATOR',
    outputs: [{ name: '', internalType: 'bytes32', type: 'bytes32' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'EIP712_REVISION',
    outputs: [{ name: '', internalType: 'bytes', type: 'bytes' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'POOL',
    outputs: [{ name: '', internalType: 'contract IPool', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'UNDERLYING_ASSET_ADDRESS',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'address', type: 'address' },
    ],
    name: 'allowance',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'approve',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'delegatee', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'approveDelegation',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'user', internalType: 'address', type: 'address' }],
    name: 'balanceOf',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'fromUser', internalType: 'address', type: 'address' },
      { name: 'toUser', internalType: 'address', type: 'address' },
    ],
    name: 'borrowAllowance',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'from', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
      { name: 'index', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'burn',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'decimals',
    outputs: [{ name: '', internalType: 'uint8', type: 'uint8' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'decreaseAllowance',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'delegator', internalType: 'address', type: 'address' },
      { name: 'delegatee', internalType: 'address', type: 'address' },
      { name: 'value', internalType: 'uint256', type: 'uint256' },
      { name: 'deadline', internalType: 'uint256', type: 'uint256' },
      { name: 'v', internalType: 'uint8', type: 'uint8' },
      { name: 'r', internalType: 'bytes32', type: 'bytes32' },
      { name: 's', internalType: 'bytes32', type: 'bytes32' },
    ],
    name: 'delegationWithSig',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getIncentivesController',
    outputs: [
      {
        name: '',
        internalType: 'contract IAaveIncentivesController',
        type: 'address',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'user', internalType: 'address', type: 'address' }],
    name: 'getPreviousIndex',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'user', internalType: 'address', type: 'address' }],
    name: 'getScaledUserBalanceAndSupply',
    outputs: [
      { name: '', internalType: 'uint256', type: 'uint256' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'increaseAllowance',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'initializingPool',
        internalType: 'contract IPool',
        type: 'address',
      },
      { name: 'underlyingAsset', internalType: 'address', type: 'address' },
      {
        name: 'incentivesController',
        internalType: 'contract IAaveIncentivesController',
        type: 'address',
      },
      { name: 'debtTokenDecimals', internalType: 'uint8', type: 'uint8' },
      { name: 'debtTokenName', internalType: 'string', type: 'string' },
      { name: 'debtTokenSymbol', internalType: 'string', type: 'string' },
      { name: 'params', internalType: 'bytes', type: 'bytes' },
    ],
    name: 'initialize',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'user', internalType: 'address', type: 'address' },
      { name: 'onBehalfOf', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
      { name: 'index', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'mint',
    outputs: [
      { name: '', internalType: 'bool', type: 'bool' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'name',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'owner', internalType: 'address', type: 'address' }],
    name: 'nonces',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'user', internalType: 'address', type: 'address' }],
    name: 'scaledBalanceOf',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'scaledTotalSupply',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'controller',
        internalType: 'contract IAaveIncentivesController',
        type: 'address',
      },
    ],
    name: 'setIncentivesController',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'symbol',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'totalSupply',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transfer',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transferFrom',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
] as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xb4055dF6337c84e2e1Ae8d938DF0E0f8CAd242c6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD3ac76c5eE3765d465Ec77664F3Afc6C21Ce09DD)
 */
export const variableDebtTokenTaikoAddress = {
  17000: '0xb4055dF6337c84e2e1Ae8d938DF0E0f8CAd242c6',
  167009: '0xD3ac76c5eE3765d465Ec77664F3Afc6C21Ce09DD',
} as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xb4055dF6337c84e2e1Ae8d938DF0E0f8CAd242c6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD3ac76c5eE3765d465Ec77664F3Afc6C21Ce09DD)
 */
export const variableDebtTokenTaikoConfig = {
  address: variableDebtTokenTaikoAddress,
  abi: variableDebtTokenTaikoAbi,
} as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// WBTC-AToken-Taiko
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x2319E98b2E8CdBF09CbBE0764E363A4d5b3414Fd)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4B91BB1816973B4A4A6F19091964C89ED57238a3)
 */
export const wbtcATokenTaikoAbi = [
  {
    type: 'constructor',
    inputs: [{ name: 'pool', internalType: 'contract IPool', type: 'address' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'owner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'spender',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Approval',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'from', internalType: 'address', type: 'address', indexed: true },
      { name: 'to', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'index',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'BalanceTransfer',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'from', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'target',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'balanceIncrease',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'index',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Burn',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'underlyingAsset',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      { name: 'pool', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'treasury',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
      {
        name: 'incentivesController',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
      {
        name: 'aTokenDecimals',
        internalType: 'uint8',
        type: 'uint8',
        indexed: false,
      },
      {
        name: 'aTokenName',
        internalType: 'string',
        type: 'string',
        indexed: false,
      },
      {
        name: 'aTokenSymbol',
        internalType: 'string',
        type: 'string',
        indexed: false,
      },
      { name: 'params', internalType: 'bytes', type: 'bytes', indexed: false },
    ],
    name: 'Initialized',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'caller',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'onBehalfOf',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'balanceIncrease',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'index',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Mint',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'from', internalType: 'address', type: 'address', indexed: true },
      { name: 'to', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Transfer',
  },
  {
    type: 'function',
    inputs: [],
    name: 'ATOKEN_REVISION',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'DOMAIN_SEPARATOR',
    outputs: [{ name: '', internalType: 'bytes32', type: 'bytes32' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'EIP712_REVISION',
    outputs: [{ name: '', internalType: 'bytes', type: 'bytes' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'PERMIT_TYPEHASH',
    outputs: [{ name: '', internalType: 'bytes32', type: 'bytes32' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'POOL',
    outputs: [{ name: '', internalType: 'contract IPool', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'RESERVE_TREASURY_ADDRESS',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'UNDERLYING_ASSET_ADDRESS',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'owner', internalType: 'address', type: 'address' },
      { name: 'spender', internalType: 'address', type: 'address' },
    ],
    name: 'allowance',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'spender', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'approve',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'user', internalType: 'address', type: 'address' }],
    name: 'balanceOf',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'from', internalType: 'address', type: 'address' },
      {
        name: 'receiverOfUnderlying',
        internalType: 'address',
        type: 'address',
      },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
      { name: 'index', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'burn',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'decimals',
    outputs: [{ name: '', internalType: 'uint8', type: 'uint8' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'spender', internalType: 'address', type: 'address' },
      { name: 'subtractedValue', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'decreaseAllowance',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getIncentivesController',
    outputs: [
      {
        name: '',
        internalType: 'contract IAaveIncentivesController',
        type: 'address',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'user', internalType: 'address', type: 'address' }],
    name: 'getPreviousIndex',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'user', internalType: 'address', type: 'address' }],
    name: 'getScaledUserBalanceAndSupply',
    outputs: [
      { name: '', internalType: 'uint256', type: 'uint256' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'user', internalType: 'address', type: 'address' },
      { name: 'onBehalfOf', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'handleRepayment',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'spender', internalType: 'address', type: 'address' },
      { name: 'addedValue', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'increaseAllowance',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'initializingPool',
        internalType: 'contract IPool',
        type: 'address',
      },
      { name: 'treasury', internalType: 'address', type: 'address' },
      { name: 'underlyingAsset', internalType: 'address', type: 'address' },
      {
        name: 'incentivesController',
        internalType: 'contract IAaveIncentivesController',
        type: 'address',
      },
      { name: 'aTokenDecimals', internalType: 'uint8', type: 'uint8' },
      { name: 'aTokenName', internalType: 'string', type: 'string' },
      { name: 'aTokenSymbol', internalType: 'string', type: 'string' },
      { name: 'params', internalType: 'bytes', type: 'bytes' },
    ],
    name: 'initialize',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'caller', internalType: 'address', type: 'address' },
      { name: 'onBehalfOf', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
      { name: 'index', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'mint',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
      { name: 'index', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'mintToTreasury',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'name',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'owner', internalType: 'address', type: 'address' }],
    name: 'nonces',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'owner', internalType: 'address', type: 'address' },
      { name: 'spender', internalType: 'address', type: 'address' },
      { name: 'value', internalType: 'uint256', type: 'uint256' },
      { name: 'deadline', internalType: 'uint256', type: 'uint256' },
      { name: 'v', internalType: 'uint8', type: 'uint8' },
      { name: 'r', internalType: 'bytes32', type: 'bytes32' },
      { name: 's', internalType: 'bytes32', type: 'bytes32' },
    ],
    name: 'permit',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'token', internalType: 'address', type: 'address' },
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'rescueTokens',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'user', internalType: 'address', type: 'address' }],
    name: 'scaledBalanceOf',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'scaledTotalSupply',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'controller',
        internalType: 'contract IAaveIncentivesController',
        type: 'address',
      },
    ],
    name: 'setIncentivesController',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'symbol',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'totalSupply',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'recipient', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transfer',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'sender', internalType: 'address', type: 'address' },
      { name: 'recipient', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transferFrom',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'from', internalType: 'address', type: 'address' },
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'value', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transferOnLiquidation',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'target', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transferUnderlyingTo',
    outputs: [],
    stateMutability: 'nonpayable',
  },
] as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x2319E98b2E8CdBF09CbBE0764E363A4d5b3414Fd)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4B91BB1816973B4A4A6F19091964C89ED57238a3)
 */
export const wbtcATokenTaikoAddress = {
  17000: '0x2319E98b2E8CdBF09CbBE0764E363A4d5b3414Fd',
  167009: '0x4B91BB1816973B4A4A6F19091964C89ED57238a3',
} as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x2319E98b2E8CdBF09CbBE0764E363A4d5b3414Fd)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4B91BB1816973B4A4A6F19091964C89ED57238a3)
 */
export const wbtcATokenTaikoConfig = {
  address: wbtcATokenTaikoAddress,
  abi: wbtcATokenTaikoAbi,
} as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// WBTC-StableDebtToken-Taiko
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x122C2c5dc7DCfd9eeC4B18144bC6Efa025A04e74)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x8A0013e4711464648f7F46e0cC92D50f3E899e6b)
 */
export const wbtcStableDebtTokenTaikoAbi = [
  {
    type: 'constructor',
    inputs: [{ name: 'pool', internalType: 'contract IPool', type: 'address' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'owner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'spender',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Approval',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'fromUser',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'toUser',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'asset',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'amount',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'BorrowAllowanceDelegated',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'from', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'amount',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'currentBalance',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'balanceIncrease',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'avgStableRate',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'newTotalSupply',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Burn',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'underlyingAsset',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      { name: 'pool', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'incentivesController',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
      {
        name: 'debtTokenDecimals',
        internalType: 'uint8',
        type: 'uint8',
        indexed: false,
      },
      {
        name: 'debtTokenName',
        internalType: 'string',
        type: 'string',
        indexed: false,
      },
      {
        name: 'debtTokenSymbol',
        internalType: 'string',
        type: 'string',
        indexed: false,
      },
      { name: 'params', internalType: 'bytes', type: 'bytes', indexed: false },
    ],
    name: 'Initialized',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'user', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'onBehalfOf',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'amount',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'currentBalance',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'balanceIncrease',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'newRate',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'avgStableRate',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'newTotalSupply',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Mint',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'from', internalType: 'address', type: 'address', indexed: true },
      { name: 'to', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Transfer',
  },
  {
    type: 'function',
    inputs: [],
    name: 'DEBT_TOKEN_REVISION',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'DELEGATION_WITH_SIG_TYPEHASH',
    outputs: [{ name: '', internalType: 'bytes32', type: 'bytes32' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'DOMAIN_SEPARATOR',
    outputs: [{ name: '', internalType: 'bytes32', type: 'bytes32' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'EIP712_REVISION',
    outputs: [{ name: '', internalType: 'bytes', type: 'bytes' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'POOL',
    outputs: [{ name: '', internalType: 'contract IPool', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'UNDERLYING_ASSET_ADDRESS',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'address', type: 'address' },
    ],
    name: 'allowance',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'approve',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'delegatee', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'approveDelegation',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'account', internalType: 'address', type: 'address' }],
    name: 'balanceOf',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'fromUser', internalType: 'address', type: 'address' },
      { name: 'toUser', internalType: 'address', type: 'address' },
    ],
    name: 'borrowAllowance',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'from', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'burn',
    outputs: [
      { name: '', internalType: 'uint256', type: 'uint256' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'decimals',
    outputs: [{ name: '', internalType: 'uint8', type: 'uint8' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'decreaseAllowance',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'delegator', internalType: 'address', type: 'address' },
      { name: 'delegatee', internalType: 'address', type: 'address' },
      { name: 'value', internalType: 'uint256', type: 'uint256' },
      { name: 'deadline', internalType: 'uint256', type: 'uint256' },
      { name: 'v', internalType: 'uint8', type: 'uint8' },
      { name: 'r', internalType: 'bytes32', type: 'bytes32' },
      { name: 's', internalType: 'bytes32', type: 'bytes32' },
    ],
    name: 'delegationWithSig',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getAverageStableRate',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getIncentivesController',
    outputs: [
      {
        name: '',
        internalType: 'contract IAaveIncentivesController',
        type: 'address',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getSupplyData',
    outputs: [
      { name: '', internalType: 'uint256', type: 'uint256' },
      { name: '', internalType: 'uint256', type: 'uint256' },
      { name: '', internalType: 'uint256', type: 'uint256' },
      { name: '', internalType: 'uint40', type: 'uint40' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getTotalSupplyAndAvgRate',
    outputs: [
      { name: '', internalType: 'uint256', type: 'uint256' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getTotalSupplyLastUpdated',
    outputs: [{ name: '', internalType: 'uint40', type: 'uint40' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'user', internalType: 'address', type: 'address' }],
    name: 'getUserLastUpdated',
    outputs: [{ name: '', internalType: 'uint40', type: 'uint40' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'user', internalType: 'address', type: 'address' }],
    name: 'getUserStableRate',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'increaseAllowance',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'initializingPool',
        internalType: 'contract IPool',
        type: 'address',
      },
      { name: 'underlyingAsset', internalType: 'address', type: 'address' },
      {
        name: 'incentivesController',
        internalType: 'contract IAaveIncentivesController',
        type: 'address',
      },
      { name: 'debtTokenDecimals', internalType: 'uint8', type: 'uint8' },
      { name: 'debtTokenName', internalType: 'string', type: 'string' },
      { name: 'debtTokenSymbol', internalType: 'string', type: 'string' },
      { name: 'params', internalType: 'bytes', type: 'bytes' },
    ],
    name: 'initialize',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'user', internalType: 'address', type: 'address' },
      { name: 'onBehalfOf', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
      { name: 'rate', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'mint',
    outputs: [
      { name: '', internalType: 'bool', type: 'bool' },
      { name: '', internalType: 'uint256', type: 'uint256' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'name',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'owner', internalType: 'address', type: 'address' }],
    name: 'nonces',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'user', internalType: 'address', type: 'address' }],
    name: 'principalBalanceOf',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'controller',
        internalType: 'contract IAaveIncentivesController',
        type: 'address',
      },
    ],
    name: 'setIncentivesController',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'symbol',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'totalSupply',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transfer',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transferFrom',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
] as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x122C2c5dc7DCfd9eeC4B18144bC6Efa025A04e74)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x8A0013e4711464648f7F46e0cC92D50f3E899e6b)
 */
export const wbtcStableDebtTokenTaikoAddress = {
  17000: '0x122C2c5dc7DCfd9eeC4B18144bC6Efa025A04e74',
  167009: '0x8A0013e4711464648f7F46e0cC92D50f3E899e6b',
} as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x122C2c5dc7DCfd9eeC4B18144bC6Efa025A04e74)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x8A0013e4711464648f7F46e0cC92D50f3E899e6b)
 */
export const wbtcStableDebtTokenTaikoConfig = {
  address: wbtcStableDebtTokenTaikoAddress,
  abi: wbtcStableDebtTokenTaikoAbi,
} as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// WBTC-TestnetMintableERC20-Taiko
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x181aAaE8fd558f6F21E895c59274dB153001E8b4)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x31dEcF589B30c8fbDA934f1F4b1E0aF5bECfFb86)
 */
export const wbtcTestnetMintableErc20TaikoAbi = [
  {
    type: 'constructor',
    inputs: [
      { name: '_name', internalType: 'string', type: 'string' },
      { name: '_symbol', internalType: 'string', type: 'string' },
      { name: '_decimals', internalType: 'uint8', type: 'uint8' },
    ],
    stateMutability: 'nonpayable',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'owner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'spender',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Approval',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'from', internalType: 'address', type: 'address', indexed: true },
      { name: 'to', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Transfer',
  },
  {
    type: 'function',
    inputs: [
      { name: 'owner', internalType: 'address', type: 'address' },
      { name: 'spender', internalType: 'address', type: 'address' },
    ],
    name: 'allowance',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'spender', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'approve',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'account', internalType: 'address', type: 'address' }],
    name: 'balanceOf',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'decimals',
    outputs: [{ name: '', internalType: 'uint8', type: 'uint8' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'spender', internalType: 'address', type: 'address' },
      { name: 'subtractedValue', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'decreaseAllowance',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'spender', internalType: 'address', type: 'address' },
      { name: 'addedValue', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'increaseAllowance',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'name',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'symbol',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'tokenDecimals',
    outputs: [{ name: '', internalType: 'uint8', type: 'uint8' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'totalSupply',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transfer',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'from', internalType: 'address', type: 'address' },
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transferFrom',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
] as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x181aAaE8fd558f6F21E895c59274dB153001E8b4)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x31dEcF589B30c8fbDA934f1F4b1E0aF5bECfFb86)
 */
export const wbtcTestnetMintableErc20TaikoAddress = {
  17000: '0x181aAaE8fd558f6F21E895c59274dB153001E8b4',
  167009: '0x31dEcF589B30c8fbDA934f1F4b1E0aF5bECfFb86',
} as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x181aAaE8fd558f6F21E895c59274dB153001E8b4)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x31dEcF589B30c8fbDA934f1F4b1E0aF5bECfFb86)
 */
export const wbtcTestnetMintableErc20TaikoConfig = {
  address: wbtcTestnetMintableErc20TaikoAddress,
  abi: wbtcTestnetMintableErc20TaikoAbi,
} as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// WBTC-TestnetPriceAggregator-Taiko
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x7e6554731E5B1eA348ec911366a3Bc766d6601c0)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xf2A0bFA07E920A708C51f5CB98e7A6CbD1D02c24)
 */
export const wbtcTestnetPriceAggregatorTaikoAbi = [
  {
    type: 'constructor',
    inputs: [{ name: 'initialAnswer', internalType: 'int256', type: 'int256' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'current',
        internalType: 'int256',
        type: 'int256',
        indexed: true,
      },
      {
        name: 'roundId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: true,
      },
      {
        name: 'updatedAt',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'AnswerUpdated',
  },
  {
    type: 'function',
    inputs: [],
    name: 'decimals',
    outputs: [{ name: '', internalType: 'uint8', type: 'uint8' }],
    stateMutability: 'pure',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getTokenType',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'pure',
  },
  {
    type: 'function',
    inputs: [],
    name: 'latestAnswer',
    outputs: [{ name: '', internalType: 'int256', type: 'int256' }],
    stateMutability: 'view',
  },
] as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x7e6554731E5B1eA348ec911366a3Bc766d6601c0)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xf2A0bFA07E920A708C51f5CB98e7A6CbD1D02c24)
 */
export const wbtcTestnetPriceAggregatorTaikoAddress = {
  17000: '0x7e6554731E5B1eA348ec911366a3Bc766d6601c0',
  167009: '0xf2A0bFA07E920A708C51f5CB98e7A6CbD1D02c24',
} as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x7e6554731E5B1eA348ec911366a3Bc766d6601c0)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xf2A0bFA07E920A708C51f5CB98e7A6CbD1D02c24)
 */
export const wbtcTestnetPriceAggregatorTaikoConfig = {
  address: wbtcTestnetPriceAggregatorTaikoAddress,
  abi: wbtcTestnetPriceAggregatorTaikoAbi,
} as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// WBTC-VariableDebtToken-Taiko
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x30B5199E490876eA6E8B2BAC4d5f3294AdA3C4A5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x935c15D0B4e464474F2011Ff3A8aF5283A82929a)
 */
export const wbtcVariableDebtTokenTaikoAbi = [
  {
    type: 'constructor',
    inputs: [{ name: 'pool', internalType: 'contract IPool', type: 'address' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'owner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'spender',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Approval',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'fromUser',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'toUser',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'asset',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'amount',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'BorrowAllowanceDelegated',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'from', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'target',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'balanceIncrease',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'index',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Burn',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'underlyingAsset',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      { name: 'pool', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'incentivesController',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
      {
        name: 'debtTokenDecimals',
        internalType: 'uint8',
        type: 'uint8',
        indexed: false,
      },
      {
        name: 'debtTokenName',
        internalType: 'string',
        type: 'string',
        indexed: false,
      },
      {
        name: 'debtTokenSymbol',
        internalType: 'string',
        type: 'string',
        indexed: false,
      },
      { name: 'params', internalType: 'bytes', type: 'bytes', indexed: false },
    ],
    name: 'Initialized',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'caller',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'onBehalfOf',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'balanceIncrease',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'index',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Mint',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'from', internalType: 'address', type: 'address', indexed: true },
      { name: 'to', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Transfer',
  },
  {
    type: 'function',
    inputs: [],
    name: 'DEBT_TOKEN_REVISION',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'DELEGATION_WITH_SIG_TYPEHASH',
    outputs: [{ name: '', internalType: 'bytes32', type: 'bytes32' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'DOMAIN_SEPARATOR',
    outputs: [{ name: '', internalType: 'bytes32', type: 'bytes32' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'EIP712_REVISION',
    outputs: [{ name: '', internalType: 'bytes', type: 'bytes' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'POOL',
    outputs: [{ name: '', internalType: 'contract IPool', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'UNDERLYING_ASSET_ADDRESS',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'address', type: 'address' },
    ],
    name: 'allowance',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'approve',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'delegatee', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'approveDelegation',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'user', internalType: 'address', type: 'address' }],
    name: 'balanceOf',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'fromUser', internalType: 'address', type: 'address' },
      { name: 'toUser', internalType: 'address', type: 'address' },
    ],
    name: 'borrowAllowance',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'from', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
      { name: 'index', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'burn',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'decimals',
    outputs: [{ name: '', internalType: 'uint8', type: 'uint8' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'decreaseAllowance',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'delegator', internalType: 'address', type: 'address' },
      { name: 'delegatee', internalType: 'address', type: 'address' },
      { name: 'value', internalType: 'uint256', type: 'uint256' },
      { name: 'deadline', internalType: 'uint256', type: 'uint256' },
      { name: 'v', internalType: 'uint8', type: 'uint8' },
      { name: 'r', internalType: 'bytes32', type: 'bytes32' },
      { name: 's', internalType: 'bytes32', type: 'bytes32' },
    ],
    name: 'delegationWithSig',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getIncentivesController',
    outputs: [
      {
        name: '',
        internalType: 'contract IAaveIncentivesController',
        type: 'address',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'user', internalType: 'address', type: 'address' }],
    name: 'getPreviousIndex',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'user', internalType: 'address', type: 'address' }],
    name: 'getScaledUserBalanceAndSupply',
    outputs: [
      { name: '', internalType: 'uint256', type: 'uint256' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'increaseAllowance',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'initializingPool',
        internalType: 'contract IPool',
        type: 'address',
      },
      { name: 'underlyingAsset', internalType: 'address', type: 'address' },
      {
        name: 'incentivesController',
        internalType: 'contract IAaveIncentivesController',
        type: 'address',
      },
      { name: 'debtTokenDecimals', internalType: 'uint8', type: 'uint8' },
      { name: 'debtTokenName', internalType: 'string', type: 'string' },
      { name: 'debtTokenSymbol', internalType: 'string', type: 'string' },
      { name: 'params', internalType: 'bytes', type: 'bytes' },
    ],
    name: 'initialize',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'user', internalType: 'address', type: 'address' },
      { name: 'onBehalfOf', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
      { name: 'index', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'mint',
    outputs: [
      { name: '', internalType: 'bool', type: 'bool' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'name',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'owner', internalType: 'address', type: 'address' }],
    name: 'nonces',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'user', internalType: 'address', type: 'address' }],
    name: 'scaledBalanceOf',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'scaledTotalSupply',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'controller',
        internalType: 'contract IAaveIncentivesController',
        type: 'address',
      },
    ],
    name: 'setIncentivesController',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'symbol',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'totalSupply',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transfer',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transferFrom',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
] as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x30B5199E490876eA6E8B2BAC4d5f3294AdA3C4A5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x935c15D0B4e464474F2011Ff3A8aF5283A82929a)
 */
export const wbtcVariableDebtTokenTaikoAddress = {
  17000: '0x30B5199E490876eA6E8B2BAC4d5f3294AdA3C4A5',
  167009: '0x935c15D0B4e464474F2011Ff3A8aF5283A82929a',
} as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x30B5199E490876eA6E8B2BAC4d5f3294AdA3C4A5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x935c15D0B4e464474F2011Ff3A8aF5283A82929a)
 */
export const wbtcVariableDebtTokenTaikoConfig = {
  address: wbtcVariableDebtTokenTaikoAddress,
  abi: wbtcVariableDebtTokenTaikoAbi,
} as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// WETH-AToken-Taiko
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x0fB34fAd66429AEB99b3342De150F301BB4f45Ce)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xbE810D925931A6c6899aD8361668409CEDDC2A12)
 */
export const wethATokenTaikoAbi = [
  {
    type: 'constructor',
    inputs: [{ name: 'pool', internalType: 'contract IPool', type: 'address' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'owner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'spender',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Approval',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'from', internalType: 'address', type: 'address', indexed: true },
      { name: 'to', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'index',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'BalanceTransfer',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'from', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'target',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'balanceIncrease',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'index',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Burn',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'underlyingAsset',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      { name: 'pool', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'treasury',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
      {
        name: 'incentivesController',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
      {
        name: 'aTokenDecimals',
        internalType: 'uint8',
        type: 'uint8',
        indexed: false,
      },
      {
        name: 'aTokenName',
        internalType: 'string',
        type: 'string',
        indexed: false,
      },
      {
        name: 'aTokenSymbol',
        internalType: 'string',
        type: 'string',
        indexed: false,
      },
      { name: 'params', internalType: 'bytes', type: 'bytes', indexed: false },
    ],
    name: 'Initialized',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'caller',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'onBehalfOf',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'balanceIncrease',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'index',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Mint',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'from', internalType: 'address', type: 'address', indexed: true },
      { name: 'to', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Transfer',
  },
  {
    type: 'function',
    inputs: [],
    name: 'ATOKEN_REVISION',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'DOMAIN_SEPARATOR',
    outputs: [{ name: '', internalType: 'bytes32', type: 'bytes32' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'EIP712_REVISION',
    outputs: [{ name: '', internalType: 'bytes', type: 'bytes' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'PERMIT_TYPEHASH',
    outputs: [{ name: '', internalType: 'bytes32', type: 'bytes32' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'POOL',
    outputs: [{ name: '', internalType: 'contract IPool', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'RESERVE_TREASURY_ADDRESS',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'UNDERLYING_ASSET_ADDRESS',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'owner', internalType: 'address', type: 'address' },
      { name: 'spender', internalType: 'address', type: 'address' },
    ],
    name: 'allowance',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'spender', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'approve',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'user', internalType: 'address', type: 'address' }],
    name: 'balanceOf',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'from', internalType: 'address', type: 'address' },
      {
        name: 'receiverOfUnderlying',
        internalType: 'address',
        type: 'address',
      },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
      { name: 'index', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'burn',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'decimals',
    outputs: [{ name: '', internalType: 'uint8', type: 'uint8' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'spender', internalType: 'address', type: 'address' },
      { name: 'subtractedValue', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'decreaseAllowance',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getIncentivesController',
    outputs: [
      {
        name: '',
        internalType: 'contract IAaveIncentivesController',
        type: 'address',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'user', internalType: 'address', type: 'address' }],
    name: 'getPreviousIndex',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'user', internalType: 'address', type: 'address' }],
    name: 'getScaledUserBalanceAndSupply',
    outputs: [
      { name: '', internalType: 'uint256', type: 'uint256' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'user', internalType: 'address', type: 'address' },
      { name: 'onBehalfOf', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'handleRepayment',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'spender', internalType: 'address', type: 'address' },
      { name: 'addedValue', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'increaseAllowance',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'initializingPool',
        internalType: 'contract IPool',
        type: 'address',
      },
      { name: 'treasury', internalType: 'address', type: 'address' },
      { name: 'underlyingAsset', internalType: 'address', type: 'address' },
      {
        name: 'incentivesController',
        internalType: 'contract IAaveIncentivesController',
        type: 'address',
      },
      { name: 'aTokenDecimals', internalType: 'uint8', type: 'uint8' },
      { name: 'aTokenName', internalType: 'string', type: 'string' },
      { name: 'aTokenSymbol', internalType: 'string', type: 'string' },
      { name: 'params', internalType: 'bytes', type: 'bytes' },
    ],
    name: 'initialize',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'caller', internalType: 'address', type: 'address' },
      { name: 'onBehalfOf', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
      { name: 'index', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'mint',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
      { name: 'index', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'mintToTreasury',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'name',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'owner', internalType: 'address', type: 'address' }],
    name: 'nonces',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'owner', internalType: 'address', type: 'address' },
      { name: 'spender', internalType: 'address', type: 'address' },
      { name: 'value', internalType: 'uint256', type: 'uint256' },
      { name: 'deadline', internalType: 'uint256', type: 'uint256' },
      { name: 'v', internalType: 'uint8', type: 'uint8' },
      { name: 'r', internalType: 'bytes32', type: 'bytes32' },
      { name: 's', internalType: 'bytes32', type: 'bytes32' },
    ],
    name: 'permit',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'token', internalType: 'address', type: 'address' },
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'rescueTokens',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'user', internalType: 'address', type: 'address' }],
    name: 'scaledBalanceOf',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'scaledTotalSupply',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'controller',
        internalType: 'contract IAaveIncentivesController',
        type: 'address',
      },
    ],
    name: 'setIncentivesController',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'symbol',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'totalSupply',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'recipient', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transfer',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'sender', internalType: 'address', type: 'address' },
      { name: 'recipient', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transferFrom',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'from', internalType: 'address', type: 'address' },
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'value', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transferOnLiquidation',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'target', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transferUnderlyingTo',
    outputs: [],
    stateMutability: 'nonpayable',
  },
] as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x0fB34fAd66429AEB99b3342De150F301BB4f45Ce)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xbE810D925931A6c6899aD8361668409CEDDC2A12)
 */
export const wethATokenTaikoAddress = {
  17000: '0x0fB34fAd66429AEB99b3342De150F301BB4f45Ce',
  167009: '0xbE810D925931A6c6899aD8361668409CEDDC2A12',
} as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x0fB34fAd66429AEB99b3342De150F301BB4f45Ce)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xbE810D925931A6c6899aD8361668409CEDDC2A12)
 */
export const wethATokenTaikoConfig = {
  address: wethATokenTaikoAddress,
  abi: wethATokenTaikoAbi,
} as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// WETH-StableDebtToken-Taiko
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xD7E39C0d80912033490b897A866C03E7509ed3bb)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xC7B7BF79A006785cf7c037E287Be0185f0B17219)
 */
export const wethStableDebtTokenTaikoAbi = [
  {
    type: 'constructor',
    inputs: [{ name: 'pool', internalType: 'contract IPool', type: 'address' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'owner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'spender',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Approval',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'fromUser',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'toUser',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'asset',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'amount',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'BorrowAllowanceDelegated',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'from', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'amount',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'currentBalance',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'balanceIncrease',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'avgStableRate',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'newTotalSupply',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Burn',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'underlyingAsset',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      { name: 'pool', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'incentivesController',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
      {
        name: 'debtTokenDecimals',
        internalType: 'uint8',
        type: 'uint8',
        indexed: false,
      },
      {
        name: 'debtTokenName',
        internalType: 'string',
        type: 'string',
        indexed: false,
      },
      {
        name: 'debtTokenSymbol',
        internalType: 'string',
        type: 'string',
        indexed: false,
      },
      { name: 'params', internalType: 'bytes', type: 'bytes', indexed: false },
    ],
    name: 'Initialized',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'user', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'onBehalfOf',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'amount',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'currentBalance',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'balanceIncrease',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'newRate',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'avgStableRate',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'newTotalSupply',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Mint',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'from', internalType: 'address', type: 'address', indexed: true },
      { name: 'to', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Transfer',
  },
  {
    type: 'function',
    inputs: [],
    name: 'DEBT_TOKEN_REVISION',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'DELEGATION_WITH_SIG_TYPEHASH',
    outputs: [{ name: '', internalType: 'bytes32', type: 'bytes32' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'DOMAIN_SEPARATOR',
    outputs: [{ name: '', internalType: 'bytes32', type: 'bytes32' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'EIP712_REVISION',
    outputs: [{ name: '', internalType: 'bytes', type: 'bytes' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'POOL',
    outputs: [{ name: '', internalType: 'contract IPool', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'UNDERLYING_ASSET_ADDRESS',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'address', type: 'address' },
    ],
    name: 'allowance',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'approve',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'delegatee', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'approveDelegation',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'account', internalType: 'address', type: 'address' }],
    name: 'balanceOf',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'fromUser', internalType: 'address', type: 'address' },
      { name: 'toUser', internalType: 'address', type: 'address' },
    ],
    name: 'borrowAllowance',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'from', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'burn',
    outputs: [
      { name: '', internalType: 'uint256', type: 'uint256' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'decimals',
    outputs: [{ name: '', internalType: 'uint8', type: 'uint8' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'decreaseAllowance',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'delegator', internalType: 'address', type: 'address' },
      { name: 'delegatee', internalType: 'address', type: 'address' },
      { name: 'value', internalType: 'uint256', type: 'uint256' },
      { name: 'deadline', internalType: 'uint256', type: 'uint256' },
      { name: 'v', internalType: 'uint8', type: 'uint8' },
      { name: 'r', internalType: 'bytes32', type: 'bytes32' },
      { name: 's', internalType: 'bytes32', type: 'bytes32' },
    ],
    name: 'delegationWithSig',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getAverageStableRate',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getIncentivesController',
    outputs: [
      {
        name: '',
        internalType: 'contract IAaveIncentivesController',
        type: 'address',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getSupplyData',
    outputs: [
      { name: '', internalType: 'uint256', type: 'uint256' },
      { name: '', internalType: 'uint256', type: 'uint256' },
      { name: '', internalType: 'uint256', type: 'uint256' },
      { name: '', internalType: 'uint40', type: 'uint40' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getTotalSupplyAndAvgRate',
    outputs: [
      { name: '', internalType: 'uint256', type: 'uint256' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getTotalSupplyLastUpdated',
    outputs: [{ name: '', internalType: 'uint40', type: 'uint40' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'user', internalType: 'address', type: 'address' }],
    name: 'getUserLastUpdated',
    outputs: [{ name: '', internalType: 'uint40', type: 'uint40' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'user', internalType: 'address', type: 'address' }],
    name: 'getUserStableRate',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'increaseAllowance',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'initializingPool',
        internalType: 'contract IPool',
        type: 'address',
      },
      { name: 'underlyingAsset', internalType: 'address', type: 'address' },
      {
        name: 'incentivesController',
        internalType: 'contract IAaveIncentivesController',
        type: 'address',
      },
      { name: 'debtTokenDecimals', internalType: 'uint8', type: 'uint8' },
      { name: 'debtTokenName', internalType: 'string', type: 'string' },
      { name: 'debtTokenSymbol', internalType: 'string', type: 'string' },
      { name: 'params', internalType: 'bytes', type: 'bytes' },
    ],
    name: 'initialize',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'user', internalType: 'address', type: 'address' },
      { name: 'onBehalfOf', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
      { name: 'rate', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'mint',
    outputs: [
      { name: '', internalType: 'bool', type: 'bool' },
      { name: '', internalType: 'uint256', type: 'uint256' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'name',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'owner', internalType: 'address', type: 'address' }],
    name: 'nonces',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'user', internalType: 'address', type: 'address' }],
    name: 'principalBalanceOf',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'controller',
        internalType: 'contract IAaveIncentivesController',
        type: 'address',
      },
    ],
    name: 'setIncentivesController',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'symbol',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'totalSupply',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transfer',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transferFrom',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
] as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xD7E39C0d80912033490b897A866C03E7509ed3bb)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xC7B7BF79A006785cf7c037E287Be0185f0B17219)
 */
export const wethStableDebtTokenTaikoAddress = {
  17000: '0xD7E39C0d80912033490b897A866C03E7509ed3bb',
  167009: '0xC7B7BF79A006785cf7c037E287Be0185f0B17219',
} as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xD7E39C0d80912033490b897A866C03E7509ed3bb)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xC7B7BF79A006785cf7c037E287Be0185f0B17219)
 */
export const wethStableDebtTokenTaikoConfig = {
  address: wethStableDebtTokenTaikoAddress,
  abi: wethStableDebtTokenTaikoAbi,
} as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// WETH-TestnetMintableERC20-Taiko
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x063D33aCa020dE70Dc5f6B12b94F9fA44C9D9330)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2B070a1C7CcE823d9DD4B54DdC44794Fc995c66c)
 */
export const wethTestnetMintableErc20TaikoAbi = [
  {
    type: 'constructor',
    inputs: [
      { name: 'mockName', internalType: 'string', type: 'string' },
      { name: 'mockSymbol', internalType: 'string', type: 'string' },
      { name: 'owner', internalType: 'address', type: 'address' },
    ],
    stateMutability: 'nonpayable',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'src', internalType: 'address', type: 'address', indexed: true },
      { name: 'guy', internalType: 'address', type: 'address', indexed: true },
      { name: 'wad', internalType: 'uint256', type: 'uint256', indexed: false },
    ],
    name: 'Approval',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'dst', internalType: 'address', type: 'address', indexed: true },
      { name: 'wad', internalType: 'uint256', type: 'uint256', indexed: false },
    ],
    name: 'Deposit',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'previousOwner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'newOwner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'OwnershipTransferred',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'src', internalType: 'address', type: 'address', indexed: true },
      { name: 'dst', internalType: 'address', type: 'address', indexed: true },
      { name: 'wad', internalType: 'uint256', type: 'uint256', indexed: false },
    ],
    name: 'Transfer',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'src', internalType: 'address', type: 'address', indexed: true },
      { name: 'wad', internalType: 'uint256', type: 'uint256', indexed: false },
    ],
    name: 'Withdrawal',
  },
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'address', type: 'address' },
    ],
    name: 'allowance',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'guy', internalType: 'address', type: 'address' },
      { name: 'wad', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'approve',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: '', internalType: 'address', type: 'address' }],
    name: 'balanceOf',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'decimals',
    outputs: [{ name: '', internalType: 'uint8', type: 'uint8' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'deposit',
    outputs: [],
    stateMutability: 'payable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'isProtected',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'account', internalType: 'address', type: 'address' },
      { name: 'value', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'mint',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'name',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'owner',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'renounceOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'state', internalType: 'bool', type: 'bool' }],
    name: 'setProtected',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'symbol',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'totalSupply',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'dst', internalType: 'address', type: 'address' },
      { name: 'wad', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transfer',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'src', internalType: 'address', type: 'address' },
      { name: 'dst', internalType: 'address', type: 'address' },
      { name: 'wad', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transferFrom',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'newOwner', internalType: 'address', type: 'address' }],
    name: 'transferOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'wad', internalType: 'uint256', type: 'uint256' }],
    name: 'withdraw',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  { type: 'receive', stateMutability: 'payable' },
] as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x063D33aCa020dE70Dc5f6B12b94F9fA44C9D9330)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2B070a1C7CcE823d9DD4B54DdC44794Fc995c66c)
 */
export const wethTestnetMintableErc20TaikoAddress = {
  17000: '0x063D33aCa020dE70Dc5f6B12b94F9fA44C9D9330',
  167009: '0x2B070a1C7CcE823d9DD4B54DdC44794Fc995c66c',
} as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x063D33aCa020dE70Dc5f6B12b94F9fA44C9D9330)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2B070a1C7CcE823d9DD4B54DdC44794Fc995c66c)
 */
export const wethTestnetMintableErc20TaikoConfig = {
  address: wethTestnetMintableErc20TaikoAddress,
  abi: wethTestnetMintableErc20TaikoAbi,
} as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// WETH-TestnetPriceAggregator-Taiko
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd7a093a0Aa77939374d83FB85A38e453c5D4B174)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA21F729Edccd1249F719Be2C917d238435d1a792)
 */
export const wethTestnetPriceAggregatorTaikoAbi = [
  {
    type: 'constructor',
    inputs: [{ name: 'initialAnswer', internalType: 'int256', type: 'int256' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'current',
        internalType: 'int256',
        type: 'int256',
        indexed: true,
      },
      {
        name: 'roundId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: true,
      },
      {
        name: 'updatedAt',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'AnswerUpdated',
  },
  {
    type: 'function',
    inputs: [],
    name: 'decimals',
    outputs: [{ name: '', internalType: 'uint8', type: 'uint8' }],
    stateMutability: 'pure',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getTokenType',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'pure',
  },
  {
    type: 'function',
    inputs: [],
    name: 'latestAnswer',
    outputs: [{ name: '', internalType: 'int256', type: 'int256' }],
    stateMutability: 'view',
  },
] as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd7a093a0Aa77939374d83FB85A38e453c5D4B174)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA21F729Edccd1249F719Be2C917d238435d1a792)
 */
export const wethTestnetPriceAggregatorTaikoAddress = {
  17000: '0xd7a093a0Aa77939374d83FB85A38e453c5D4B174',
  167009: '0xA21F729Edccd1249F719Be2C917d238435d1a792',
} as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd7a093a0Aa77939374d83FB85A38e453c5D4B174)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA21F729Edccd1249F719Be2C917d238435d1a792)
 */
export const wethTestnetPriceAggregatorTaikoConfig = {
  address: wethTestnetPriceAggregatorTaikoAddress,
  abi: wethTestnetPriceAggregatorTaikoAbi,
} as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// WETH-VariableDebtToken-Taiko
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x739E2f35970fC4351C59a2E44480696bEe5de1ad)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa5505643bB243c38e18Fef93672534a44B52c1AD)
 */
export const wethVariableDebtTokenTaikoAbi = [
  {
    type: 'constructor',
    inputs: [{ name: 'pool', internalType: 'contract IPool', type: 'address' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'owner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'spender',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Approval',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'fromUser',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'toUser',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'asset',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'amount',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'BorrowAllowanceDelegated',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'from', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'target',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'balanceIncrease',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'index',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Burn',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'underlyingAsset',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      { name: 'pool', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'incentivesController',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
      {
        name: 'debtTokenDecimals',
        internalType: 'uint8',
        type: 'uint8',
        indexed: false,
      },
      {
        name: 'debtTokenName',
        internalType: 'string',
        type: 'string',
        indexed: false,
      },
      {
        name: 'debtTokenSymbol',
        internalType: 'string',
        type: 'string',
        indexed: false,
      },
      { name: 'params', internalType: 'bytes', type: 'bytes', indexed: false },
    ],
    name: 'Initialized',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'caller',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'onBehalfOf',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'balanceIncrease',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'index',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Mint',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'from', internalType: 'address', type: 'address', indexed: true },
      { name: 'to', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Transfer',
  },
  {
    type: 'function',
    inputs: [],
    name: 'DEBT_TOKEN_REVISION',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'DELEGATION_WITH_SIG_TYPEHASH',
    outputs: [{ name: '', internalType: 'bytes32', type: 'bytes32' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'DOMAIN_SEPARATOR',
    outputs: [{ name: '', internalType: 'bytes32', type: 'bytes32' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'EIP712_REVISION',
    outputs: [{ name: '', internalType: 'bytes', type: 'bytes' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'POOL',
    outputs: [{ name: '', internalType: 'contract IPool', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'UNDERLYING_ASSET_ADDRESS',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'address', type: 'address' },
    ],
    name: 'allowance',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'approve',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'delegatee', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'approveDelegation',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'user', internalType: 'address', type: 'address' }],
    name: 'balanceOf',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'fromUser', internalType: 'address', type: 'address' },
      { name: 'toUser', internalType: 'address', type: 'address' },
    ],
    name: 'borrowAllowance',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'from', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
      { name: 'index', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'burn',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'decimals',
    outputs: [{ name: '', internalType: 'uint8', type: 'uint8' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'decreaseAllowance',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'delegator', internalType: 'address', type: 'address' },
      { name: 'delegatee', internalType: 'address', type: 'address' },
      { name: 'value', internalType: 'uint256', type: 'uint256' },
      { name: 'deadline', internalType: 'uint256', type: 'uint256' },
      { name: 'v', internalType: 'uint8', type: 'uint8' },
      { name: 'r', internalType: 'bytes32', type: 'bytes32' },
      { name: 's', internalType: 'bytes32', type: 'bytes32' },
    ],
    name: 'delegationWithSig',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getIncentivesController',
    outputs: [
      {
        name: '',
        internalType: 'contract IAaveIncentivesController',
        type: 'address',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'user', internalType: 'address', type: 'address' }],
    name: 'getPreviousIndex',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'user', internalType: 'address', type: 'address' }],
    name: 'getScaledUserBalanceAndSupply',
    outputs: [
      { name: '', internalType: 'uint256', type: 'uint256' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'increaseAllowance',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'initializingPool',
        internalType: 'contract IPool',
        type: 'address',
      },
      { name: 'underlyingAsset', internalType: 'address', type: 'address' },
      {
        name: 'incentivesController',
        internalType: 'contract IAaveIncentivesController',
        type: 'address',
      },
      { name: 'debtTokenDecimals', internalType: 'uint8', type: 'uint8' },
      { name: 'debtTokenName', internalType: 'string', type: 'string' },
      { name: 'debtTokenSymbol', internalType: 'string', type: 'string' },
      { name: 'params', internalType: 'bytes', type: 'bytes' },
    ],
    name: 'initialize',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'user', internalType: 'address', type: 'address' },
      { name: 'onBehalfOf', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
      { name: 'index', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'mint',
    outputs: [
      { name: '', internalType: 'bool', type: 'bool' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'name',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'owner', internalType: 'address', type: 'address' }],
    name: 'nonces',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'user', internalType: 'address', type: 'address' }],
    name: 'scaledBalanceOf',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'scaledTotalSupply',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'controller',
        internalType: 'contract IAaveIncentivesController',
        type: 'address',
      },
    ],
    name: 'setIncentivesController',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'symbol',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'totalSupply',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transfer',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transferFrom',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
] as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x739E2f35970fC4351C59a2E44480696bEe5de1ad)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa5505643bB243c38e18Fef93672534a44B52c1AD)
 */
export const wethVariableDebtTokenTaikoAddress = {
  17000: '0x739E2f35970fC4351C59a2E44480696bEe5de1ad',
  167009: '0xa5505643bB243c38e18Fef93672534a44B52c1AD',
} as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x739E2f35970fC4351C59a2E44480696bEe5de1ad)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa5505643bB243c38e18Fef93672534a44B52c1AD)
 */
export const wethVariableDebtTokenTaikoConfig = {
  address: wethVariableDebtTokenTaikoAddress,
  abi: wethVariableDebtTokenTaikoAbi,
} as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// WalletBalanceProvider
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x0B96Cb6F51501e309eE7c134951f5715d0A4021b)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xb60a23256a168A2401C0FBa01a7dD91AdC3Bab74)
 */
export const walletBalanceProviderAbi = [
  {
    type: 'function',
    inputs: [
      { name: 'user', internalType: 'address', type: 'address' },
      { name: 'token', internalType: 'address', type: 'address' },
    ],
    name: 'balanceOf',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'users', internalType: 'address[]', type: 'address[]' },
      { name: 'tokens', internalType: 'address[]', type: 'address[]' },
    ],
    name: 'batchBalanceOf',
    outputs: [{ name: '', internalType: 'uint256[]', type: 'uint256[]' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'provider', internalType: 'address', type: 'address' },
      { name: 'user', internalType: 'address', type: 'address' },
    ],
    name: 'getUserWalletBalances',
    outputs: [
      { name: '', internalType: 'address[]', type: 'address[]' },
      { name: '', internalType: 'uint256[]', type: 'uint256[]' },
    ],
    stateMutability: 'view',
  },
  { type: 'receive', stateMutability: 'payable' },
] as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x0B96Cb6F51501e309eE7c134951f5715d0A4021b)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xb60a23256a168A2401C0FBa01a7dD91AdC3Bab74)
 */
export const walletBalanceProviderAddress = {
  17000: '0x0B96Cb6F51501e309eE7c134951f5715d0A4021b',
  167009: '0xb60a23256a168A2401C0FBa01a7dD91AdC3Bab74',
} as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x0B96Cb6F51501e309eE7c134951f5715d0A4021b)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xb60a23256a168A2401C0FBa01a7dD91AdC3Bab74)
 */
export const walletBalanceProviderConfig = {
  address: walletBalanceProviderAddress,
  abi: walletBalanceProviderAbi,
} as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// WrappedTokenGatewayV3
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xFfA91f8ab6521C2DbCa1E9978a02DC124109c716)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x273c9Bfa85EA5993F770Da9857268b329b32A65b)
 */
export const wrappedTokenGatewayV3Abi = [
  {
    type: 'constructor',
    inputs: [
      { name: 'weth', internalType: 'address', type: 'address' },
      { name: 'owner', internalType: 'address', type: 'address' },
      { name: 'pool', internalType: 'contract IPool', type: 'address' },
    ],
    stateMutability: 'nonpayable',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'previousOwner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'newOwner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'OwnershipTransferred',
  },
  { type: 'fallback', stateMutability: 'payable' },
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
      { name: 'interestRateMode', internalType: 'uint256', type: 'uint256' },
      { name: 'referralCode', internalType: 'uint16', type: 'uint16' },
    ],
    name: 'borrowETH',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'address', type: 'address' },
      { name: 'onBehalfOf', internalType: 'address', type: 'address' },
      { name: 'referralCode', internalType: 'uint16', type: 'uint16' },
    ],
    name: 'depositETH',
    outputs: [],
    stateMutability: 'payable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'emergencyEtherTransfer',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'token', internalType: 'address', type: 'address' },
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'emergencyTokenTransfer',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getWETHAddress',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'owner',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'renounceOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
      { name: 'rateMode', internalType: 'uint256', type: 'uint256' },
      { name: 'onBehalfOf', internalType: 'address', type: 'address' },
    ],
    name: 'repayETH',
    outputs: [],
    stateMutability: 'payable',
  },
  {
    type: 'function',
    inputs: [{ name: 'newOwner', internalType: 'address', type: 'address' }],
    name: 'transferOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
      { name: 'to', internalType: 'address', type: 'address' },
    ],
    name: 'withdrawETH',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'deadline', internalType: 'uint256', type: 'uint256' },
      { name: 'permitV', internalType: 'uint8', type: 'uint8' },
      { name: 'permitR', internalType: 'bytes32', type: 'bytes32' },
      { name: 'permitS', internalType: 'bytes32', type: 'bytes32' },
    ],
    name: 'withdrawETHWithPermit',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  { type: 'receive', stateMutability: 'payable' },
] as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xFfA91f8ab6521C2DbCa1E9978a02DC124109c716)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x273c9Bfa85EA5993F770Da9857268b329b32A65b)
 */
export const wrappedTokenGatewayV3Address = {
  17000: '0xFfA91f8ab6521C2DbCa1E9978a02DC124109c716',
  167009: '0x273c9Bfa85EA5993F770Da9857268b329b32A65b',
} as const

/**
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xFfA91f8ab6521C2DbCa1E9978a02DC124109c716)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x273c9Bfa85EA5993F770Da9857268b329b32A65b)
 */
export const wrappedTokenGatewayV3Config = {
  address: wrappedTokenGatewayV3Address,
  abi: wrappedTokenGatewayV3Abi,
} as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// earlyHANA-TestnetMintableERC20-Reward-Taiko
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD2877dDbf7A412fe3c998091496b3186AdCFB6E0)
 */
export const earlyHanaTestnetMintableErc20RewardTaikoAbi = [
  {
    type: 'constructor',
    inputs: [
      { name: '_name', internalType: 'string', type: 'string' },
      { name: '_symbol', internalType: 'string', type: 'string' },
      { name: '_decimals', internalType: 'uint8', type: 'uint8' },
    ],
    stateMutability: 'nonpayable',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'owner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'spender',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Approval',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'from', internalType: 'address', type: 'address', indexed: true },
      { name: 'to', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'Transfer',
  },
  {
    type: 'function',
    inputs: [
      { name: 'owner', internalType: 'address', type: 'address' },
      { name: 'spender', internalType: 'address', type: 'address' },
    ],
    name: 'allowance',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'spender', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'approve',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'account', internalType: 'address', type: 'address' }],
    name: 'balanceOf',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'decimals',
    outputs: [{ name: '', internalType: 'uint8', type: 'uint8' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'spender', internalType: 'address', type: 'address' },
      { name: 'subtractedValue', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'decreaseAllowance',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'spender', internalType: 'address', type: 'address' },
      { name: 'addedValue', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'increaseAllowance',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'name',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'symbol',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'tokenDecimals',
    outputs: [{ name: '', internalType: 'uint8', type: 'uint8' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'totalSupply',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transfer',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'from', internalType: 'address', type: 'address' },
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transferFrom',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
] as const

/**
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD2877dDbf7A412fe3c998091496b3186AdCFB6E0)
 */
export const earlyHanaTestnetMintableErc20RewardTaikoAddress = {
  167009: '0xD2877dDbf7A412fe3c998091496b3186AdCFB6E0',
} as const

/**
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD2877dDbf7A412fe3c998091496b3186AdCFB6E0)
 */
export const earlyHanaTestnetMintableErc20RewardTaikoConfig = {
  address: earlyHanaTestnetMintableErc20RewardTaikoAddress,
  abi: earlyHanaTestnetMintableErc20RewardTaikoAbi,
} as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// earlyHANA-TestnetPriceAggregator-Taiko
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xcaF395a7cBF8F949231Fc7344Dd6B5f639B4c5F0)
 */
export const earlyHanaTestnetPriceAggregatorTaikoAbi = [
  {
    type: 'constructor',
    inputs: [{ name: 'initialAnswer', internalType: 'int256', type: 'int256' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'current',
        internalType: 'int256',
        type: 'int256',
        indexed: true,
      },
      {
        name: 'roundId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: true,
      },
      {
        name: 'updatedAt',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'AnswerUpdated',
  },
  {
    type: 'function',
    inputs: [],
    name: 'decimals',
    outputs: [{ name: '', internalType: 'uint8', type: 'uint8' }],
    stateMutability: 'pure',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getTokenType',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'pure',
  },
  {
    type: 'function',
    inputs: [],
    name: 'latestAnswer',
    outputs: [{ name: '', internalType: 'int256', type: 'int256' }],
    stateMutability: 'view',
  },
] as const

/**
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xcaF395a7cBF8F949231Fc7344Dd6B5f639B4c5F0)
 */
export const earlyHanaTestnetPriceAggregatorTaikoAddress = {
  167009: '0xcaF395a7cBF8F949231Fc7344Dd6B5f639B4c5F0',
} as const

/**
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xcaF395a7cBF8F949231Fc7344Dd6B5f639B4c5F0)
 */
export const earlyHanaTestnetPriceAggregatorTaikoConfig = {
  address: earlyHanaTestnetPriceAggregatorTaikoAddress,
  abi: earlyHanaTestnetPriceAggregatorTaikoAbi,
} as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Action
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link aclManagerTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x24c9d39A8779D5Ec019D3C3E66741f861DE9a92E)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x67e9aceB00D177776c54467BCE75eF0e98878F46)
 */
export const readAclManagerTaiko = /*#__PURE__*/ createReadContract({
  abi: aclManagerTaikoAbi,
  address: aclManagerTaikoAddress,
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link aclManagerTaikoAbi}__ and `functionName` set to `"ADDRESSES_PROVIDER"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x24c9d39A8779D5Ec019D3C3E66741f861DE9a92E)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x67e9aceB00D177776c54467BCE75eF0e98878F46)
 */
export const readAclManagerTaikoAddressesProvider =
  /*#__PURE__*/ createReadContract({
    abi: aclManagerTaikoAbi,
    address: aclManagerTaikoAddress,
    functionName: 'ADDRESSES_PROVIDER',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link aclManagerTaikoAbi}__ and `functionName` set to `"ASSET_LISTING_ADMIN_ROLE"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x24c9d39A8779D5Ec019D3C3E66741f861DE9a92E)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x67e9aceB00D177776c54467BCE75eF0e98878F46)
 */
export const readAclManagerTaikoAssetListingAdminRole =
  /*#__PURE__*/ createReadContract({
    abi: aclManagerTaikoAbi,
    address: aclManagerTaikoAddress,
    functionName: 'ASSET_LISTING_ADMIN_ROLE',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link aclManagerTaikoAbi}__ and `functionName` set to `"BRIDGE_ROLE"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x24c9d39A8779D5Ec019D3C3E66741f861DE9a92E)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x67e9aceB00D177776c54467BCE75eF0e98878F46)
 */
export const readAclManagerTaikoBridgeRole = /*#__PURE__*/ createReadContract({
  abi: aclManagerTaikoAbi,
  address: aclManagerTaikoAddress,
  functionName: 'BRIDGE_ROLE',
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link aclManagerTaikoAbi}__ and `functionName` set to `"DEFAULT_ADMIN_ROLE"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x24c9d39A8779D5Ec019D3C3E66741f861DE9a92E)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x67e9aceB00D177776c54467BCE75eF0e98878F46)
 */
export const readAclManagerTaikoDefaultAdminRole =
  /*#__PURE__*/ createReadContract({
    abi: aclManagerTaikoAbi,
    address: aclManagerTaikoAddress,
    functionName: 'DEFAULT_ADMIN_ROLE',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link aclManagerTaikoAbi}__ and `functionName` set to `"EMERGENCY_ADMIN_ROLE"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x24c9d39A8779D5Ec019D3C3E66741f861DE9a92E)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x67e9aceB00D177776c54467BCE75eF0e98878F46)
 */
export const readAclManagerTaikoEmergencyAdminRole =
  /*#__PURE__*/ createReadContract({
    abi: aclManagerTaikoAbi,
    address: aclManagerTaikoAddress,
    functionName: 'EMERGENCY_ADMIN_ROLE',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link aclManagerTaikoAbi}__ and `functionName` set to `"FLASH_BORROWER_ROLE"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x24c9d39A8779D5Ec019D3C3E66741f861DE9a92E)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x67e9aceB00D177776c54467BCE75eF0e98878F46)
 */
export const readAclManagerTaikoFlashBorrowerRole =
  /*#__PURE__*/ createReadContract({
    abi: aclManagerTaikoAbi,
    address: aclManagerTaikoAddress,
    functionName: 'FLASH_BORROWER_ROLE',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link aclManagerTaikoAbi}__ and `functionName` set to `"POOL_ADMIN_ROLE"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x24c9d39A8779D5Ec019D3C3E66741f861DE9a92E)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x67e9aceB00D177776c54467BCE75eF0e98878F46)
 */
export const readAclManagerTaikoPoolAdminRole =
  /*#__PURE__*/ createReadContract({
    abi: aclManagerTaikoAbi,
    address: aclManagerTaikoAddress,
    functionName: 'POOL_ADMIN_ROLE',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link aclManagerTaikoAbi}__ and `functionName` set to `"RISK_ADMIN_ROLE"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x24c9d39A8779D5Ec019D3C3E66741f861DE9a92E)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x67e9aceB00D177776c54467BCE75eF0e98878F46)
 */
export const readAclManagerTaikoRiskAdminRole =
  /*#__PURE__*/ createReadContract({
    abi: aclManagerTaikoAbi,
    address: aclManagerTaikoAddress,
    functionName: 'RISK_ADMIN_ROLE',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link aclManagerTaikoAbi}__ and `functionName` set to `"getRoleAdmin"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x24c9d39A8779D5Ec019D3C3E66741f861DE9a92E)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x67e9aceB00D177776c54467BCE75eF0e98878F46)
 */
export const readAclManagerTaikoGetRoleAdmin = /*#__PURE__*/ createReadContract(
  {
    abi: aclManagerTaikoAbi,
    address: aclManagerTaikoAddress,
    functionName: 'getRoleAdmin',
  },
)

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link aclManagerTaikoAbi}__ and `functionName` set to `"hasRole"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x24c9d39A8779D5Ec019D3C3E66741f861DE9a92E)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x67e9aceB00D177776c54467BCE75eF0e98878F46)
 */
export const readAclManagerTaikoHasRole = /*#__PURE__*/ createReadContract({
  abi: aclManagerTaikoAbi,
  address: aclManagerTaikoAddress,
  functionName: 'hasRole',
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link aclManagerTaikoAbi}__ and `functionName` set to `"isAssetListingAdmin"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x24c9d39A8779D5Ec019D3C3E66741f861DE9a92E)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x67e9aceB00D177776c54467BCE75eF0e98878F46)
 */
export const readAclManagerTaikoIsAssetListingAdmin =
  /*#__PURE__*/ createReadContract({
    abi: aclManagerTaikoAbi,
    address: aclManagerTaikoAddress,
    functionName: 'isAssetListingAdmin',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link aclManagerTaikoAbi}__ and `functionName` set to `"isBridge"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x24c9d39A8779D5Ec019D3C3E66741f861DE9a92E)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x67e9aceB00D177776c54467BCE75eF0e98878F46)
 */
export const readAclManagerTaikoIsBridge = /*#__PURE__*/ createReadContract({
  abi: aclManagerTaikoAbi,
  address: aclManagerTaikoAddress,
  functionName: 'isBridge',
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link aclManagerTaikoAbi}__ and `functionName` set to `"isEmergencyAdmin"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x24c9d39A8779D5Ec019D3C3E66741f861DE9a92E)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x67e9aceB00D177776c54467BCE75eF0e98878F46)
 */
export const readAclManagerTaikoIsEmergencyAdmin =
  /*#__PURE__*/ createReadContract({
    abi: aclManagerTaikoAbi,
    address: aclManagerTaikoAddress,
    functionName: 'isEmergencyAdmin',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link aclManagerTaikoAbi}__ and `functionName` set to `"isFlashBorrower"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x24c9d39A8779D5Ec019D3C3E66741f861DE9a92E)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x67e9aceB00D177776c54467BCE75eF0e98878F46)
 */
export const readAclManagerTaikoIsFlashBorrower =
  /*#__PURE__*/ createReadContract({
    abi: aclManagerTaikoAbi,
    address: aclManagerTaikoAddress,
    functionName: 'isFlashBorrower',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link aclManagerTaikoAbi}__ and `functionName` set to `"isPoolAdmin"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x24c9d39A8779D5Ec019D3C3E66741f861DE9a92E)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x67e9aceB00D177776c54467BCE75eF0e98878F46)
 */
export const readAclManagerTaikoIsPoolAdmin = /*#__PURE__*/ createReadContract({
  abi: aclManagerTaikoAbi,
  address: aclManagerTaikoAddress,
  functionName: 'isPoolAdmin',
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link aclManagerTaikoAbi}__ and `functionName` set to `"isRiskAdmin"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x24c9d39A8779D5Ec019D3C3E66741f861DE9a92E)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x67e9aceB00D177776c54467BCE75eF0e98878F46)
 */
export const readAclManagerTaikoIsRiskAdmin = /*#__PURE__*/ createReadContract({
  abi: aclManagerTaikoAbi,
  address: aclManagerTaikoAddress,
  functionName: 'isRiskAdmin',
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link aclManagerTaikoAbi}__ and `functionName` set to `"supportsInterface"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x24c9d39A8779D5Ec019D3C3E66741f861DE9a92E)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x67e9aceB00D177776c54467BCE75eF0e98878F46)
 */
export const readAclManagerTaikoSupportsInterface =
  /*#__PURE__*/ createReadContract({
    abi: aclManagerTaikoAbi,
    address: aclManagerTaikoAddress,
    functionName: 'supportsInterface',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link aclManagerTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x24c9d39A8779D5Ec019D3C3E66741f861DE9a92E)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x67e9aceB00D177776c54467BCE75eF0e98878F46)
 */
export const writeAclManagerTaiko = /*#__PURE__*/ createWriteContract({
  abi: aclManagerTaikoAbi,
  address: aclManagerTaikoAddress,
})

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link aclManagerTaikoAbi}__ and `functionName` set to `"addAssetListingAdmin"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x24c9d39A8779D5Ec019D3C3E66741f861DE9a92E)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x67e9aceB00D177776c54467BCE75eF0e98878F46)
 */
export const writeAclManagerTaikoAddAssetListingAdmin =
  /*#__PURE__*/ createWriteContract({
    abi: aclManagerTaikoAbi,
    address: aclManagerTaikoAddress,
    functionName: 'addAssetListingAdmin',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link aclManagerTaikoAbi}__ and `functionName` set to `"addBridge"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x24c9d39A8779D5Ec019D3C3E66741f861DE9a92E)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x67e9aceB00D177776c54467BCE75eF0e98878F46)
 */
export const writeAclManagerTaikoAddBridge = /*#__PURE__*/ createWriteContract({
  abi: aclManagerTaikoAbi,
  address: aclManagerTaikoAddress,
  functionName: 'addBridge',
})

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link aclManagerTaikoAbi}__ and `functionName` set to `"addEmergencyAdmin"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x24c9d39A8779D5Ec019D3C3E66741f861DE9a92E)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x67e9aceB00D177776c54467BCE75eF0e98878F46)
 */
export const writeAclManagerTaikoAddEmergencyAdmin =
  /*#__PURE__*/ createWriteContract({
    abi: aclManagerTaikoAbi,
    address: aclManagerTaikoAddress,
    functionName: 'addEmergencyAdmin',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link aclManagerTaikoAbi}__ and `functionName` set to `"addFlashBorrower"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x24c9d39A8779D5Ec019D3C3E66741f861DE9a92E)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x67e9aceB00D177776c54467BCE75eF0e98878F46)
 */
export const writeAclManagerTaikoAddFlashBorrower =
  /*#__PURE__*/ createWriteContract({
    abi: aclManagerTaikoAbi,
    address: aclManagerTaikoAddress,
    functionName: 'addFlashBorrower',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link aclManagerTaikoAbi}__ and `functionName` set to `"addPoolAdmin"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x24c9d39A8779D5Ec019D3C3E66741f861DE9a92E)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x67e9aceB00D177776c54467BCE75eF0e98878F46)
 */
export const writeAclManagerTaikoAddPoolAdmin =
  /*#__PURE__*/ createWriteContract({
    abi: aclManagerTaikoAbi,
    address: aclManagerTaikoAddress,
    functionName: 'addPoolAdmin',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link aclManagerTaikoAbi}__ and `functionName` set to `"addRiskAdmin"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x24c9d39A8779D5Ec019D3C3E66741f861DE9a92E)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x67e9aceB00D177776c54467BCE75eF0e98878F46)
 */
export const writeAclManagerTaikoAddRiskAdmin =
  /*#__PURE__*/ createWriteContract({
    abi: aclManagerTaikoAbi,
    address: aclManagerTaikoAddress,
    functionName: 'addRiskAdmin',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link aclManagerTaikoAbi}__ and `functionName` set to `"grantRole"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x24c9d39A8779D5Ec019D3C3E66741f861DE9a92E)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x67e9aceB00D177776c54467BCE75eF0e98878F46)
 */
export const writeAclManagerTaikoGrantRole = /*#__PURE__*/ createWriteContract({
  abi: aclManagerTaikoAbi,
  address: aclManagerTaikoAddress,
  functionName: 'grantRole',
})

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link aclManagerTaikoAbi}__ and `functionName` set to `"removeAssetListingAdmin"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x24c9d39A8779D5Ec019D3C3E66741f861DE9a92E)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x67e9aceB00D177776c54467BCE75eF0e98878F46)
 */
export const writeAclManagerTaikoRemoveAssetListingAdmin =
  /*#__PURE__*/ createWriteContract({
    abi: aclManagerTaikoAbi,
    address: aclManagerTaikoAddress,
    functionName: 'removeAssetListingAdmin',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link aclManagerTaikoAbi}__ and `functionName` set to `"removeBridge"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x24c9d39A8779D5Ec019D3C3E66741f861DE9a92E)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x67e9aceB00D177776c54467BCE75eF0e98878F46)
 */
export const writeAclManagerTaikoRemoveBridge =
  /*#__PURE__*/ createWriteContract({
    abi: aclManagerTaikoAbi,
    address: aclManagerTaikoAddress,
    functionName: 'removeBridge',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link aclManagerTaikoAbi}__ and `functionName` set to `"removeEmergencyAdmin"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x24c9d39A8779D5Ec019D3C3E66741f861DE9a92E)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x67e9aceB00D177776c54467BCE75eF0e98878F46)
 */
export const writeAclManagerTaikoRemoveEmergencyAdmin =
  /*#__PURE__*/ createWriteContract({
    abi: aclManagerTaikoAbi,
    address: aclManagerTaikoAddress,
    functionName: 'removeEmergencyAdmin',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link aclManagerTaikoAbi}__ and `functionName` set to `"removeFlashBorrower"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x24c9d39A8779D5Ec019D3C3E66741f861DE9a92E)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x67e9aceB00D177776c54467BCE75eF0e98878F46)
 */
export const writeAclManagerTaikoRemoveFlashBorrower =
  /*#__PURE__*/ createWriteContract({
    abi: aclManagerTaikoAbi,
    address: aclManagerTaikoAddress,
    functionName: 'removeFlashBorrower',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link aclManagerTaikoAbi}__ and `functionName` set to `"removePoolAdmin"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x24c9d39A8779D5Ec019D3C3E66741f861DE9a92E)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x67e9aceB00D177776c54467BCE75eF0e98878F46)
 */
export const writeAclManagerTaikoRemovePoolAdmin =
  /*#__PURE__*/ createWriteContract({
    abi: aclManagerTaikoAbi,
    address: aclManagerTaikoAddress,
    functionName: 'removePoolAdmin',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link aclManagerTaikoAbi}__ and `functionName` set to `"removeRiskAdmin"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x24c9d39A8779D5Ec019D3C3E66741f861DE9a92E)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x67e9aceB00D177776c54467BCE75eF0e98878F46)
 */
export const writeAclManagerTaikoRemoveRiskAdmin =
  /*#__PURE__*/ createWriteContract({
    abi: aclManagerTaikoAbi,
    address: aclManagerTaikoAddress,
    functionName: 'removeRiskAdmin',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link aclManagerTaikoAbi}__ and `functionName` set to `"renounceRole"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x24c9d39A8779D5Ec019D3C3E66741f861DE9a92E)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x67e9aceB00D177776c54467BCE75eF0e98878F46)
 */
export const writeAclManagerTaikoRenounceRole =
  /*#__PURE__*/ createWriteContract({
    abi: aclManagerTaikoAbi,
    address: aclManagerTaikoAddress,
    functionName: 'renounceRole',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link aclManagerTaikoAbi}__ and `functionName` set to `"revokeRole"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x24c9d39A8779D5Ec019D3C3E66741f861DE9a92E)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x67e9aceB00D177776c54467BCE75eF0e98878F46)
 */
export const writeAclManagerTaikoRevokeRole = /*#__PURE__*/ createWriteContract(
  {
    abi: aclManagerTaikoAbi,
    address: aclManagerTaikoAddress,
    functionName: 'revokeRole',
  },
)

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link aclManagerTaikoAbi}__ and `functionName` set to `"setRoleAdmin"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x24c9d39A8779D5Ec019D3C3E66741f861DE9a92E)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x67e9aceB00D177776c54467BCE75eF0e98878F46)
 */
export const writeAclManagerTaikoSetRoleAdmin =
  /*#__PURE__*/ createWriteContract({
    abi: aclManagerTaikoAbi,
    address: aclManagerTaikoAddress,
    functionName: 'setRoleAdmin',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link aclManagerTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x24c9d39A8779D5Ec019D3C3E66741f861DE9a92E)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x67e9aceB00D177776c54467BCE75eF0e98878F46)
 */
export const simulateAclManagerTaiko = /*#__PURE__*/ createSimulateContract({
  abi: aclManagerTaikoAbi,
  address: aclManagerTaikoAddress,
})

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link aclManagerTaikoAbi}__ and `functionName` set to `"addAssetListingAdmin"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x24c9d39A8779D5Ec019D3C3E66741f861DE9a92E)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x67e9aceB00D177776c54467BCE75eF0e98878F46)
 */
export const simulateAclManagerTaikoAddAssetListingAdmin =
  /*#__PURE__*/ createSimulateContract({
    abi: aclManagerTaikoAbi,
    address: aclManagerTaikoAddress,
    functionName: 'addAssetListingAdmin',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link aclManagerTaikoAbi}__ and `functionName` set to `"addBridge"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x24c9d39A8779D5Ec019D3C3E66741f861DE9a92E)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x67e9aceB00D177776c54467BCE75eF0e98878F46)
 */
export const simulateAclManagerTaikoAddBridge =
  /*#__PURE__*/ createSimulateContract({
    abi: aclManagerTaikoAbi,
    address: aclManagerTaikoAddress,
    functionName: 'addBridge',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link aclManagerTaikoAbi}__ and `functionName` set to `"addEmergencyAdmin"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x24c9d39A8779D5Ec019D3C3E66741f861DE9a92E)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x67e9aceB00D177776c54467BCE75eF0e98878F46)
 */
export const simulateAclManagerTaikoAddEmergencyAdmin =
  /*#__PURE__*/ createSimulateContract({
    abi: aclManagerTaikoAbi,
    address: aclManagerTaikoAddress,
    functionName: 'addEmergencyAdmin',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link aclManagerTaikoAbi}__ and `functionName` set to `"addFlashBorrower"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x24c9d39A8779D5Ec019D3C3E66741f861DE9a92E)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x67e9aceB00D177776c54467BCE75eF0e98878F46)
 */
export const simulateAclManagerTaikoAddFlashBorrower =
  /*#__PURE__*/ createSimulateContract({
    abi: aclManagerTaikoAbi,
    address: aclManagerTaikoAddress,
    functionName: 'addFlashBorrower',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link aclManagerTaikoAbi}__ and `functionName` set to `"addPoolAdmin"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x24c9d39A8779D5Ec019D3C3E66741f861DE9a92E)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x67e9aceB00D177776c54467BCE75eF0e98878F46)
 */
export const simulateAclManagerTaikoAddPoolAdmin =
  /*#__PURE__*/ createSimulateContract({
    abi: aclManagerTaikoAbi,
    address: aclManagerTaikoAddress,
    functionName: 'addPoolAdmin',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link aclManagerTaikoAbi}__ and `functionName` set to `"addRiskAdmin"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x24c9d39A8779D5Ec019D3C3E66741f861DE9a92E)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x67e9aceB00D177776c54467BCE75eF0e98878F46)
 */
export const simulateAclManagerTaikoAddRiskAdmin =
  /*#__PURE__*/ createSimulateContract({
    abi: aclManagerTaikoAbi,
    address: aclManagerTaikoAddress,
    functionName: 'addRiskAdmin',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link aclManagerTaikoAbi}__ and `functionName` set to `"grantRole"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x24c9d39A8779D5Ec019D3C3E66741f861DE9a92E)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x67e9aceB00D177776c54467BCE75eF0e98878F46)
 */
export const simulateAclManagerTaikoGrantRole =
  /*#__PURE__*/ createSimulateContract({
    abi: aclManagerTaikoAbi,
    address: aclManagerTaikoAddress,
    functionName: 'grantRole',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link aclManagerTaikoAbi}__ and `functionName` set to `"removeAssetListingAdmin"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x24c9d39A8779D5Ec019D3C3E66741f861DE9a92E)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x67e9aceB00D177776c54467BCE75eF0e98878F46)
 */
export const simulateAclManagerTaikoRemoveAssetListingAdmin =
  /*#__PURE__*/ createSimulateContract({
    abi: aclManagerTaikoAbi,
    address: aclManagerTaikoAddress,
    functionName: 'removeAssetListingAdmin',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link aclManagerTaikoAbi}__ and `functionName` set to `"removeBridge"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x24c9d39A8779D5Ec019D3C3E66741f861DE9a92E)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x67e9aceB00D177776c54467BCE75eF0e98878F46)
 */
export const simulateAclManagerTaikoRemoveBridge =
  /*#__PURE__*/ createSimulateContract({
    abi: aclManagerTaikoAbi,
    address: aclManagerTaikoAddress,
    functionName: 'removeBridge',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link aclManagerTaikoAbi}__ and `functionName` set to `"removeEmergencyAdmin"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x24c9d39A8779D5Ec019D3C3E66741f861DE9a92E)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x67e9aceB00D177776c54467BCE75eF0e98878F46)
 */
export const simulateAclManagerTaikoRemoveEmergencyAdmin =
  /*#__PURE__*/ createSimulateContract({
    abi: aclManagerTaikoAbi,
    address: aclManagerTaikoAddress,
    functionName: 'removeEmergencyAdmin',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link aclManagerTaikoAbi}__ and `functionName` set to `"removeFlashBorrower"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x24c9d39A8779D5Ec019D3C3E66741f861DE9a92E)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x67e9aceB00D177776c54467BCE75eF0e98878F46)
 */
export const simulateAclManagerTaikoRemoveFlashBorrower =
  /*#__PURE__*/ createSimulateContract({
    abi: aclManagerTaikoAbi,
    address: aclManagerTaikoAddress,
    functionName: 'removeFlashBorrower',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link aclManagerTaikoAbi}__ and `functionName` set to `"removePoolAdmin"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x24c9d39A8779D5Ec019D3C3E66741f861DE9a92E)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x67e9aceB00D177776c54467BCE75eF0e98878F46)
 */
export const simulateAclManagerTaikoRemovePoolAdmin =
  /*#__PURE__*/ createSimulateContract({
    abi: aclManagerTaikoAbi,
    address: aclManagerTaikoAddress,
    functionName: 'removePoolAdmin',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link aclManagerTaikoAbi}__ and `functionName` set to `"removeRiskAdmin"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x24c9d39A8779D5Ec019D3C3E66741f861DE9a92E)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x67e9aceB00D177776c54467BCE75eF0e98878F46)
 */
export const simulateAclManagerTaikoRemoveRiskAdmin =
  /*#__PURE__*/ createSimulateContract({
    abi: aclManagerTaikoAbi,
    address: aclManagerTaikoAddress,
    functionName: 'removeRiskAdmin',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link aclManagerTaikoAbi}__ and `functionName` set to `"renounceRole"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x24c9d39A8779D5Ec019D3C3E66741f861DE9a92E)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x67e9aceB00D177776c54467BCE75eF0e98878F46)
 */
export const simulateAclManagerTaikoRenounceRole =
  /*#__PURE__*/ createSimulateContract({
    abi: aclManagerTaikoAbi,
    address: aclManagerTaikoAddress,
    functionName: 'renounceRole',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link aclManagerTaikoAbi}__ and `functionName` set to `"revokeRole"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x24c9d39A8779D5Ec019D3C3E66741f861DE9a92E)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x67e9aceB00D177776c54467BCE75eF0e98878F46)
 */
export const simulateAclManagerTaikoRevokeRole =
  /*#__PURE__*/ createSimulateContract({
    abi: aclManagerTaikoAbi,
    address: aclManagerTaikoAddress,
    functionName: 'revokeRole',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link aclManagerTaikoAbi}__ and `functionName` set to `"setRoleAdmin"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x24c9d39A8779D5Ec019D3C3E66741f861DE9a92E)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x67e9aceB00D177776c54467BCE75eF0e98878F46)
 */
export const simulateAclManagerTaikoSetRoleAdmin =
  /*#__PURE__*/ createSimulateContract({
    abi: aclManagerTaikoAbi,
    address: aclManagerTaikoAddress,
    functionName: 'setRoleAdmin',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link aclManagerTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x24c9d39A8779D5Ec019D3C3E66741f861DE9a92E)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x67e9aceB00D177776c54467BCE75eF0e98878F46)
 */
export const watchAclManagerTaikoEvent = /*#__PURE__*/ createWatchContractEvent(
  { abi: aclManagerTaikoAbi, address: aclManagerTaikoAddress },
)

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link aclManagerTaikoAbi}__ and `eventName` set to `"RoleAdminChanged"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x24c9d39A8779D5Ec019D3C3E66741f861DE9a92E)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x67e9aceB00D177776c54467BCE75eF0e98878F46)
 */
export const watchAclManagerTaikoRoleAdminChangedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: aclManagerTaikoAbi,
    address: aclManagerTaikoAddress,
    eventName: 'RoleAdminChanged',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link aclManagerTaikoAbi}__ and `eventName` set to `"RoleGranted"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x24c9d39A8779D5Ec019D3C3E66741f861DE9a92E)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x67e9aceB00D177776c54467BCE75eF0e98878F46)
 */
export const watchAclManagerTaikoRoleGrantedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: aclManagerTaikoAbi,
    address: aclManagerTaikoAddress,
    eventName: 'RoleGranted',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link aclManagerTaikoAbi}__ and `eventName` set to `"RoleRevoked"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x24c9d39A8779D5Ec019D3C3E66741f861DE9a92E)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x67e9aceB00D177776c54467BCE75eF0e98878F46)
 */
export const watchAclManagerTaikoRoleRevokedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: aclManagerTaikoAbi,
    address: aclManagerTaikoAddress,
    eventName: 'RoleRevoked',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link aTokenTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x6b73157d672FB22C974b2068610cC0a71BAC1be5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x126983388eA103c29437C4a22d3704800039304A)
 */
export const readATokenTaiko = /*#__PURE__*/ createReadContract({
  abi: aTokenTaikoAbi,
  address: aTokenTaikoAddress,
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link aTokenTaikoAbi}__ and `functionName` set to `"ATOKEN_REVISION"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x6b73157d672FB22C974b2068610cC0a71BAC1be5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x126983388eA103c29437C4a22d3704800039304A)
 */
export const readATokenTaikoAtokenRevision = /*#__PURE__*/ createReadContract({
  abi: aTokenTaikoAbi,
  address: aTokenTaikoAddress,
  functionName: 'ATOKEN_REVISION',
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link aTokenTaikoAbi}__ and `functionName` set to `"DOMAIN_SEPARATOR"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x6b73157d672FB22C974b2068610cC0a71BAC1be5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x126983388eA103c29437C4a22d3704800039304A)
 */
export const readATokenTaikoDomainSeparator = /*#__PURE__*/ createReadContract({
  abi: aTokenTaikoAbi,
  address: aTokenTaikoAddress,
  functionName: 'DOMAIN_SEPARATOR',
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link aTokenTaikoAbi}__ and `functionName` set to `"EIP712_REVISION"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x6b73157d672FB22C974b2068610cC0a71BAC1be5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x126983388eA103c29437C4a22d3704800039304A)
 */
export const readATokenTaikoEip712Revision = /*#__PURE__*/ createReadContract({
  abi: aTokenTaikoAbi,
  address: aTokenTaikoAddress,
  functionName: 'EIP712_REVISION',
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link aTokenTaikoAbi}__ and `functionName` set to `"PERMIT_TYPEHASH"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x6b73157d672FB22C974b2068610cC0a71BAC1be5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x126983388eA103c29437C4a22d3704800039304A)
 */
export const readATokenTaikoPermitTypehash = /*#__PURE__*/ createReadContract({
  abi: aTokenTaikoAbi,
  address: aTokenTaikoAddress,
  functionName: 'PERMIT_TYPEHASH',
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link aTokenTaikoAbi}__ and `functionName` set to `"POOL"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x6b73157d672FB22C974b2068610cC0a71BAC1be5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x126983388eA103c29437C4a22d3704800039304A)
 */
export const readATokenTaikoPool = /*#__PURE__*/ createReadContract({
  abi: aTokenTaikoAbi,
  address: aTokenTaikoAddress,
  functionName: 'POOL',
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link aTokenTaikoAbi}__ and `functionName` set to `"RESERVE_TREASURY_ADDRESS"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x6b73157d672FB22C974b2068610cC0a71BAC1be5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x126983388eA103c29437C4a22d3704800039304A)
 */
export const readATokenTaikoReserveTreasuryAddress =
  /*#__PURE__*/ createReadContract({
    abi: aTokenTaikoAbi,
    address: aTokenTaikoAddress,
    functionName: 'RESERVE_TREASURY_ADDRESS',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link aTokenTaikoAbi}__ and `functionName` set to `"UNDERLYING_ASSET_ADDRESS"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x6b73157d672FB22C974b2068610cC0a71BAC1be5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x126983388eA103c29437C4a22d3704800039304A)
 */
export const readATokenTaikoUnderlyingAssetAddress =
  /*#__PURE__*/ createReadContract({
    abi: aTokenTaikoAbi,
    address: aTokenTaikoAddress,
    functionName: 'UNDERLYING_ASSET_ADDRESS',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link aTokenTaikoAbi}__ and `functionName` set to `"allowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x6b73157d672FB22C974b2068610cC0a71BAC1be5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x126983388eA103c29437C4a22d3704800039304A)
 */
export const readATokenTaikoAllowance = /*#__PURE__*/ createReadContract({
  abi: aTokenTaikoAbi,
  address: aTokenTaikoAddress,
  functionName: 'allowance',
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link aTokenTaikoAbi}__ and `functionName` set to `"balanceOf"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x6b73157d672FB22C974b2068610cC0a71BAC1be5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x126983388eA103c29437C4a22d3704800039304A)
 */
export const readATokenTaikoBalanceOf = /*#__PURE__*/ createReadContract({
  abi: aTokenTaikoAbi,
  address: aTokenTaikoAddress,
  functionName: 'balanceOf',
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link aTokenTaikoAbi}__ and `functionName` set to `"decimals"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x6b73157d672FB22C974b2068610cC0a71BAC1be5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x126983388eA103c29437C4a22d3704800039304A)
 */
export const readATokenTaikoDecimals = /*#__PURE__*/ createReadContract({
  abi: aTokenTaikoAbi,
  address: aTokenTaikoAddress,
  functionName: 'decimals',
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link aTokenTaikoAbi}__ and `functionName` set to `"getIncentivesController"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x6b73157d672FB22C974b2068610cC0a71BAC1be5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x126983388eA103c29437C4a22d3704800039304A)
 */
export const readATokenTaikoGetIncentivesController =
  /*#__PURE__*/ createReadContract({
    abi: aTokenTaikoAbi,
    address: aTokenTaikoAddress,
    functionName: 'getIncentivesController',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link aTokenTaikoAbi}__ and `functionName` set to `"getPreviousIndex"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x6b73157d672FB22C974b2068610cC0a71BAC1be5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x126983388eA103c29437C4a22d3704800039304A)
 */
export const readATokenTaikoGetPreviousIndex = /*#__PURE__*/ createReadContract(
  {
    abi: aTokenTaikoAbi,
    address: aTokenTaikoAddress,
    functionName: 'getPreviousIndex',
  },
)

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link aTokenTaikoAbi}__ and `functionName` set to `"getScaledUserBalanceAndSupply"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x6b73157d672FB22C974b2068610cC0a71BAC1be5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x126983388eA103c29437C4a22d3704800039304A)
 */
export const readATokenTaikoGetScaledUserBalanceAndSupply =
  /*#__PURE__*/ createReadContract({
    abi: aTokenTaikoAbi,
    address: aTokenTaikoAddress,
    functionName: 'getScaledUserBalanceAndSupply',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link aTokenTaikoAbi}__ and `functionName` set to `"name"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x6b73157d672FB22C974b2068610cC0a71BAC1be5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x126983388eA103c29437C4a22d3704800039304A)
 */
export const readATokenTaikoName = /*#__PURE__*/ createReadContract({
  abi: aTokenTaikoAbi,
  address: aTokenTaikoAddress,
  functionName: 'name',
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link aTokenTaikoAbi}__ and `functionName` set to `"nonces"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x6b73157d672FB22C974b2068610cC0a71BAC1be5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x126983388eA103c29437C4a22d3704800039304A)
 */
export const readATokenTaikoNonces = /*#__PURE__*/ createReadContract({
  abi: aTokenTaikoAbi,
  address: aTokenTaikoAddress,
  functionName: 'nonces',
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link aTokenTaikoAbi}__ and `functionName` set to `"scaledBalanceOf"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x6b73157d672FB22C974b2068610cC0a71BAC1be5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x126983388eA103c29437C4a22d3704800039304A)
 */
export const readATokenTaikoScaledBalanceOf = /*#__PURE__*/ createReadContract({
  abi: aTokenTaikoAbi,
  address: aTokenTaikoAddress,
  functionName: 'scaledBalanceOf',
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link aTokenTaikoAbi}__ and `functionName` set to `"scaledTotalSupply"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x6b73157d672FB22C974b2068610cC0a71BAC1be5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x126983388eA103c29437C4a22d3704800039304A)
 */
export const readATokenTaikoScaledTotalSupply =
  /*#__PURE__*/ createReadContract({
    abi: aTokenTaikoAbi,
    address: aTokenTaikoAddress,
    functionName: 'scaledTotalSupply',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link aTokenTaikoAbi}__ and `functionName` set to `"symbol"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x6b73157d672FB22C974b2068610cC0a71BAC1be5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x126983388eA103c29437C4a22d3704800039304A)
 */
export const readATokenTaikoSymbol = /*#__PURE__*/ createReadContract({
  abi: aTokenTaikoAbi,
  address: aTokenTaikoAddress,
  functionName: 'symbol',
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link aTokenTaikoAbi}__ and `functionName` set to `"totalSupply"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x6b73157d672FB22C974b2068610cC0a71BAC1be5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x126983388eA103c29437C4a22d3704800039304A)
 */
export const readATokenTaikoTotalSupply = /*#__PURE__*/ createReadContract({
  abi: aTokenTaikoAbi,
  address: aTokenTaikoAddress,
  functionName: 'totalSupply',
})

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link aTokenTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x6b73157d672FB22C974b2068610cC0a71BAC1be5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x126983388eA103c29437C4a22d3704800039304A)
 */
export const writeATokenTaiko = /*#__PURE__*/ createWriteContract({
  abi: aTokenTaikoAbi,
  address: aTokenTaikoAddress,
})

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link aTokenTaikoAbi}__ and `functionName` set to `"approve"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x6b73157d672FB22C974b2068610cC0a71BAC1be5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x126983388eA103c29437C4a22d3704800039304A)
 */
export const writeATokenTaikoApprove = /*#__PURE__*/ createWriteContract({
  abi: aTokenTaikoAbi,
  address: aTokenTaikoAddress,
  functionName: 'approve',
})

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link aTokenTaikoAbi}__ and `functionName` set to `"burn"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x6b73157d672FB22C974b2068610cC0a71BAC1be5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x126983388eA103c29437C4a22d3704800039304A)
 */
export const writeATokenTaikoBurn = /*#__PURE__*/ createWriteContract({
  abi: aTokenTaikoAbi,
  address: aTokenTaikoAddress,
  functionName: 'burn',
})

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link aTokenTaikoAbi}__ and `functionName` set to `"decreaseAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x6b73157d672FB22C974b2068610cC0a71BAC1be5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x126983388eA103c29437C4a22d3704800039304A)
 */
export const writeATokenTaikoDecreaseAllowance =
  /*#__PURE__*/ createWriteContract({
    abi: aTokenTaikoAbi,
    address: aTokenTaikoAddress,
    functionName: 'decreaseAllowance',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link aTokenTaikoAbi}__ and `functionName` set to `"handleRepayment"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x6b73157d672FB22C974b2068610cC0a71BAC1be5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x126983388eA103c29437C4a22d3704800039304A)
 */
export const writeATokenTaikoHandleRepayment =
  /*#__PURE__*/ createWriteContract({
    abi: aTokenTaikoAbi,
    address: aTokenTaikoAddress,
    functionName: 'handleRepayment',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link aTokenTaikoAbi}__ and `functionName` set to `"increaseAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x6b73157d672FB22C974b2068610cC0a71BAC1be5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x126983388eA103c29437C4a22d3704800039304A)
 */
export const writeATokenTaikoIncreaseAllowance =
  /*#__PURE__*/ createWriteContract({
    abi: aTokenTaikoAbi,
    address: aTokenTaikoAddress,
    functionName: 'increaseAllowance',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link aTokenTaikoAbi}__ and `functionName` set to `"initialize"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x6b73157d672FB22C974b2068610cC0a71BAC1be5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x126983388eA103c29437C4a22d3704800039304A)
 */
export const writeATokenTaikoInitialize = /*#__PURE__*/ createWriteContract({
  abi: aTokenTaikoAbi,
  address: aTokenTaikoAddress,
  functionName: 'initialize',
})

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link aTokenTaikoAbi}__ and `functionName` set to `"mint"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x6b73157d672FB22C974b2068610cC0a71BAC1be5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x126983388eA103c29437C4a22d3704800039304A)
 */
export const writeATokenTaikoMint = /*#__PURE__*/ createWriteContract({
  abi: aTokenTaikoAbi,
  address: aTokenTaikoAddress,
  functionName: 'mint',
})

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link aTokenTaikoAbi}__ and `functionName` set to `"mintToTreasury"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x6b73157d672FB22C974b2068610cC0a71BAC1be5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x126983388eA103c29437C4a22d3704800039304A)
 */
export const writeATokenTaikoMintToTreasury = /*#__PURE__*/ createWriteContract(
  {
    abi: aTokenTaikoAbi,
    address: aTokenTaikoAddress,
    functionName: 'mintToTreasury',
  },
)

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link aTokenTaikoAbi}__ and `functionName` set to `"permit"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x6b73157d672FB22C974b2068610cC0a71BAC1be5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x126983388eA103c29437C4a22d3704800039304A)
 */
export const writeATokenTaikoPermit = /*#__PURE__*/ createWriteContract({
  abi: aTokenTaikoAbi,
  address: aTokenTaikoAddress,
  functionName: 'permit',
})

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link aTokenTaikoAbi}__ and `functionName` set to `"rescueTokens"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x6b73157d672FB22C974b2068610cC0a71BAC1be5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x126983388eA103c29437C4a22d3704800039304A)
 */
export const writeATokenTaikoRescueTokens = /*#__PURE__*/ createWriteContract({
  abi: aTokenTaikoAbi,
  address: aTokenTaikoAddress,
  functionName: 'rescueTokens',
})

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link aTokenTaikoAbi}__ and `functionName` set to `"setIncentivesController"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x6b73157d672FB22C974b2068610cC0a71BAC1be5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x126983388eA103c29437C4a22d3704800039304A)
 */
export const writeATokenTaikoSetIncentivesController =
  /*#__PURE__*/ createWriteContract({
    abi: aTokenTaikoAbi,
    address: aTokenTaikoAddress,
    functionName: 'setIncentivesController',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link aTokenTaikoAbi}__ and `functionName` set to `"transfer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x6b73157d672FB22C974b2068610cC0a71BAC1be5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x126983388eA103c29437C4a22d3704800039304A)
 */
export const writeATokenTaikoTransfer = /*#__PURE__*/ createWriteContract({
  abi: aTokenTaikoAbi,
  address: aTokenTaikoAddress,
  functionName: 'transfer',
})

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link aTokenTaikoAbi}__ and `functionName` set to `"transferFrom"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x6b73157d672FB22C974b2068610cC0a71BAC1be5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x126983388eA103c29437C4a22d3704800039304A)
 */
export const writeATokenTaikoTransferFrom = /*#__PURE__*/ createWriteContract({
  abi: aTokenTaikoAbi,
  address: aTokenTaikoAddress,
  functionName: 'transferFrom',
})

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link aTokenTaikoAbi}__ and `functionName` set to `"transferOnLiquidation"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x6b73157d672FB22C974b2068610cC0a71BAC1be5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x126983388eA103c29437C4a22d3704800039304A)
 */
export const writeATokenTaikoTransferOnLiquidation =
  /*#__PURE__*/ createWriteContract({
    abi: aTokenTaikoAbi,
    address: aTokenTaikoAddress,
    functionName: 'transferOnLiquidation',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link aTokenTaikoAbi}__ and `functionName` set to `"transferUnderlyingTo"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x6b73157d672FB22C974b2068610cC0a71BAC1be5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x126983388eA103c29437C4a22d3704800039304A)
 */
export const writeATokenTaikoTransferUnderlyingTo =
  /*#__PURE__*/ createWriteContract({
    abi: aTokenTaikoAbi,
    address: aTokenTaikoAddress,
    functionName: 'transferUnderlyingTo',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link aTokenTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x6b73157d672FB22C974b2068610cC0a71BAC1be5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x126983388eA103c29437C4a22d3704800039304A)
 */
export const simulateATokenTaiko = /*#__PURE__*/ createSimulateContract({
  abi: aTokenTaikoAbi,
  address: aTokenTaikoAddress,
})

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link aTokenTaikoAbi}__ and `functionName` set to `"approve"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x6b73157d672FB22C974b2068610cC0a71BAC1be5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x126983388eA103c29437C4a22d3704800039304A)
 */
export const simulateATokenTaikoApprove = /*#__PURE__*/ createSimulateContract({
  abi: aTokenTaikoAbi,
  address: aTokenTaikoAddress,
  functionName: 'approve',
})

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link aTokenTaikoAbi}__ and `functionName` set to `"burn"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x6b73157d672FB22C974b2068610cC0a71BAC1be5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x126983388eA103c29437C4a22d3704800039304A)
 */
export const simulateATokenTaikoBurn = /*#__PURE__*/ createSimulateContract({
  abi: aTokenTaikoAbi,
  address: aTokenTaikoAddress,
  functionName: 'burn',
})

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link aTokenTaikoAbi}__ and `functionName` set to `"decreaseAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x6b73157d672FB22C974b2068610cC0a71BAC1be5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x126983388eA103c29437C4a22d3704800039304A)
 */
export const simulateATokenTaikoDecreaseAllowance =
  /*#__PURE__*/ createSimulateContract({
    abi: aTokenTaikoAbi,
    address: aTokenTaikoAddress,
    functionName: 'decreaseAllowance',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link aTokenTaikoAbi}__ and `functionName` set to `"handleRepayment"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x6b73157d672FB22C974b2068610cC0a71BAC1be5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x126983388eA103c29437C4a22d3704800039304A)
 */
export const simulateATokenTaikoHandleRepayment =
  /*#__PURE__*/ createSimulateContract({
    abi: aTokenTaikoAbi,
    address: aTokenTaikoAddress,
    functionName: 'handleRepayment',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link aTokenTaikoAbi}__ and `functionName` set to `"increaseAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x6b73157d672FB22C974b2068610cC0a71BAC1be5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x126983388eA103c29437C4a22d3704800039304A)
 */
export const simulateATokenTaikoIncreaseAllowance =
  /*#__PURE__*/ createSimulateContract({
    abi: aTokenTaikoAbi,
    address: aTokenTaikoAddress,
    functionName: 'increaseAllowance',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link aTokenTaikoAbi}__ and `functionName` set to `"initialize"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x6b73157d672FB22C974b2068610cC0a71BAC1be5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x126983388eA103c29437C4a22d3704800039304A)
 */
export const simulateATokenTaikoInitialize =
  /*#__PURE__*/ createSimulateContract({
    abi: aTokenTaikoAbi,
    address: aTokenTaikoAddress,
    functionName: 'initialize',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link aTokenTaikoAbi}__ and `functionName` set to `"mint"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x6b73157d672FB22C974b2068610cC0a71BAC1be5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x126983388eA103c29437C4a22d3704800039304A)
 */
export const simulateATokenTaikoMint = /*#__PURE__*/ createSimulateContract({
  abi: aTokenTaikoAbi,
  address: aTokenTaikoAddress,
  functionName: 'mint',
})

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link aTokenTaikoAbi}__ and `functionName` set to `"mintToTreasury"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x6b73157d672FB22C974b2068610cC0a71BAC1be5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x126983388eA103c29437C4a22d3704800039304A)
 */
export const simulateATokenTaikoMintToTreasury =
  /*#__PURE__*/ createSimulateContract({
    abi: aTokenTaikoAbi,
    address: aTokenTaikoAddress,
    functionName: 'mintToTreasury',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link aTokenTaikoAbi}__ and `functionName` set to `"permit"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x6b73157d672FB22C974b2068610cC0a71BAC1be5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x126983388eA103c29437C4a22d3704800039304A)
 */
export const simulateATokenTaikoPermit = /*#__PURE__*/ createSimulateContract({
  abi: aTokenTaikoAbi,
  address: aTokenTaikoAddress,
  functionName: 'permit',
})

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link aTokenTaikoAbi}__ and `functionName` set to `"rescueTokens"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x6b73157d672FB22C974b2068610cC0a71BAC1be5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x126983388eA103c29437C4a22d3704800039304A)
 */
export const simulateATokenTaikoRescueTokens =
  /*#__PURE__*/ createSimulateContract({
    abi: aTokenTaikoAbi,
    address: aTokenTaikoAddress,
    functionName: 'rescueTokens',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link aTokenTaikoAbi}__ and `functionName` set to `"setIncentivesController"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x6b73157d672FB22C974b2068610cC0a71BAC1be5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x126983388eA103c29437C4a22d3704800039304A)
 */
export const simulateATokenTaikoSetIncentivesController =
  /*#__PURE__*/ createSimulateContract({
    abi: aTokenTaikoAbi,
    address: aTokenTaikoAddress,
    functionName: 'setIncentivesController',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link aTokenTaikoAbi}__ and `functionName` set to `"transfer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x6b73157d672FB22C974b2068610cC0a71BAC1be5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x126983388eA103c29437C4a22d3704800039304A)
 */
export const simulateATokenTaikoTransfer = /*#__PURE__*/ createSimulateContract(
  {
    abi: aTokenTaikoAbi,
    address: aTokenTaikoAddress,
    functionName: 'transfer',
  },
)

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link aTokenTaikoAbi}__ and `functionName` set to `"transferFrom"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x6b73157d672FB22C974b2068610cC0a71BAC1be5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x126983388eA103c29437C4a22d3704800039304A)
 */
export const simulateATokenTaikoTransferFrom =
  /*#__PURE__*/ createSimulateContract({
    abi: aTokenTaikoAbi,
    address: aTokenTaikoAddress,
    functionName: 'transferFrom',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link aTokenTaikoAbi}__ and `functionName` set to `"transferOnLiquidation"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x6b73157d672FB22C974b2068610cC0a71BAC1be5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x126983388eA103c29437C4a22d3704800039304A)
 */
export const simulateATokenTaikoTransferOnLiquidation =
  /*#__PURE__*/ createSimulateContract({
    abi: aTokenTaikoAbi,
    address: aTokenTaikoAddress,
    functionName: 'transferOnLiquidation',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link aTokenTaikoAbi}__ and `functionName` set to `"transferUnderlyingTo"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x6b73157d672FB22C974b2068610cC0a71BAC1be5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x126983388eA103c29437C4a22d3704800039304A)
 */
export const simulateATokenTaikoTransferUnderlyingTo =
  /*#__PURE__*/ createSimulateContract({
    abi: aTokenTaikoAbi,
    address: aTokenTaikoAddress,
    functionName: 'transferUnderlyingTo',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link aTokenTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x6b73157d672FB22C974b2068610cC0a71BAC1be5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x126983388eA103c29437C4a22d3704800039304A)
 */
export const watchATokenTaikoEvent = /*#__PURE__*/ createWatchContractEvent({
  abi: aTokenTaikoAbi,
  address: aTokenTaikoAddress,
})

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link aTokenTaikoAbi}__ and `eventName` set to `"Approval"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x6b73157d672FB22C974b2068610cC0a71BAC1be5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x126983388eA103c29437C4a22d3704800039304A)
 */
export const watchATokenTaikoApprovalEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: aTokenTaikoAbi,
    address: aTokenTaikoAddress,
    eventName: 'Approval',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link aTokenTaikoAbi}__ and `eventName` set to `"BalanceTransfer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x6b73157d672FB22C974b2068610cC0a71BAC1be5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x126983388eA103c29437C4a22d3704800039304A)
 */
export const watchATokenTaikoBalanceTransferEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: aTokenTaikoAbi,
    address: aTokenTaikoAddress,
    eventName: 'BalanceTransfer',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link aTokenTaikoAbi}__ and `eventName` set to `"Burn"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x6b73157d672FB22C974b2068610cC0a71BAC1be5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x126983388eA103c29437C4a22d3704800039304A)
 */
export const watchATokenTaikoBurnEvent = /*#__PURE__*/ createWatchContractEvent(
  { abi: aTokenTaikoAbi, address: aTokenTaikoAddress, eventName: 'Burn' },
)

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link aTokenTaikoAbi}__ and `eventName` set to `"Initialized"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x6b73157d672FB22C974b2068610cC0a71BAC1be5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x126983388eA103c29437C4a22d3704800039304A)
 */
export const watchATokenTaikoInitializedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: aTokenTaikoAbi,
    address: aTokenTaikoAddress,
    eventName: 'Initialized',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link aTokenTaikoAbi}__ and `eventName` set to `"Mint"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x6b73157d672FB22C974b2068610cC0a71BAC1be5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x126983388eA103c29437C4a22d3704800039304A)
 */
export const watchATokenTaikoMintEvent = /*#__PURE__*/ createWatchContractEvent(
  { abi: aTokenTaikoAbi, address: aTokenTaikoAddress, eventName: 'Mint' },
)

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link aTokenTaikoAbi}__ and `eventName` set to `"Transfer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x6b73157d672FB22C974b2068610cC0a71BAC1be5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x126983388eA103c29437C4a22d3704800039304A)
 */
export const watchATokenTaikoTransferEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: aTokenTaikoAbi,
    address: aTokenTaikoAddress,
    eventName: 'Transfer',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link aaveOracleTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x1fB6d773fE35266eC3363a935a4163f330a18b15)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x30f508945e0eB6A3D0dA99226B7E3eEA246A720e)
 */
export const readAaveOracleTaiko = /*#__PURE__*/ createReadContract({
  abi: aaveOracleTaikoAbi,
  address: aaveOracleTaikoAddress,
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link aaveOracleTaikoAbi}__ and `functionName` set to `"ADDRESSES_PROVIDER"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x1fB6d773fE35266eC3363a935a4163f330a18b15)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x30f508945e0eB6A3D0dA99226B7E3eEA246A720e)
 */
export const readAaveOracleTaikoAddressesProvider =
  /*#__PURE__*/ createReadContract({
    abi: aaveOracleTaikoAbi,
    address: aaveOracleTaikoAddress,
    functionName: 'ADDRESSES_PROVIDER',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link aaveOracleTaikoAbi}__ and `functionName` set to `"BASE_CURRENCY"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x1fB6d773fE35266eC3363a935a4163f330a18b15)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x30f508945e0eB6A3D0dA99226B7E3eEA246A720e)
 */
export const readAaveOracleTaikoBaseCurrency = /*#__PURE__*/ createReadContract(
  {
    abi: aaveOracleTaikoAbi,
    address: aaveOracleTaikoAddress,
    functionName: 'BASE_CURRENCY',
  },
)

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link aaveOracleTaikoAbi}__ and `functionName` set to `"BASE_CURRENCY_UNIT"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x1fB6d773fE35266eC3363a935a4163f330a18b15)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x30f508945e0eB6A3D0dA99226B7E3eEA246A720e)
 */
export const readAaveOracleTaikoBaseCurrencyUnit =
  /*#__PURE__*/ createReadContract({
    abi: aaveOracleTaikoAbi,
    address: aaveOracleTaikoAddress,
    functionName: 'BASE_CURRENCY_UNIT',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link aaveOracleTaikoAbi}__ and `functionName` set to `"forceFallbackOracle"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x1fB6d773fE35266eC3363a935a4163f330a18b15)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x30f508945e0eB6A3D0dA99226B7E3eEA246A720e)
 */
export const readAaveOracleTaikoForceFallbackOracle =
  /*#__PURE__*/ createReadContract({
    abi: aaveOracleTaikoAbi,
    address: aaveOracleTaikoAddress,
    functionName: 'forceFallbackOracle',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link aaveOracleTaikoAbi}__ and `functionName` set to `"getAssetPrice"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x1fB6d773fE35266eC3363a935a4163f330a18b15)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x30f508945e0eB6A3D0dA99226B7E3eEA246A720e)
 */
export const readAaveOracleTaikoGetAssetPrice =
  /*#__PURE__*/ createReadContract({
    abi: aaveOracleTaikoAbi,
    address: aaveOracleTaikoAddress,
    functionName: 'getAssetPrice',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link aaveOracleTaikoAbi}__ and `functionName` set to `"getAssetsPrices"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x1fB6d773fE35266eC3363a935a4163f330a18b15)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x30f508945e0eB6A3D0dA99226B7E3eEA246A720e)
 */
export const readAaveOracleTaikoGetAssetsPrices =
  /*#__PURE__*/ createReadContract({
    abi: aaveOracleTaikoAbi,
    address: aaveOracleTaikoAddress,
    functionName: 'getAssetsPrices',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link aaveOracleTaikoAbi}__ and `functionName` set to `"getFallbackOracle"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x1fB6d773fE35266eC3363a935a4163f330a18b15)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x30f508945e0eB6A3D0dA99226B7E3eEA246A720e)
 */
export const readAaveOracleTaikoGetFallbackOracle =
  /*#__PURE__*/ createReadContract({
    abi: aaveOracleTaikoAbi,
    address: aaveOracleTaikoAddress,
    functionName: 'getFallbackOracle',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link aaveOracleTaikoAbi}__ and `functionName` set to `"getSourceOfAsset"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x1fB6d773fE35266eC3363a935a4163f330a18b15)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x30f508945e0eB6A3D0dA99226B7E3eEA246A720e)
 */
export const readAaveOracleTaikoGetSourceOfAsset =
  /*#__PURE__*/ createReadContract({
    abi: aaveOracleTaikoAbi,
    address: aaveOracleTaikoAddress,
    functionName: 'getSourceOfAsset',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link aaveOracleTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x1fB6d773fE35266eC3363a935a4163f330a18b15)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x30f508945e0eB6A3D0dA99226B7E3eEA246A720e)
 */
export const writeAaveOracleTaiko = /*#__PURE__*/ createWriteContract({
  abi: aaveOracleTaikoAbi,
  address: aaveOracleTaikoAddress,
})

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link aaveOracleTaikoAbi}__ and `functionName` set to `"setAssetSources"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x1fB6d773fE35266eC3363a935a4163f330a18b15)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x30f508945e0eB6A3D0dA99226B7E3eEA246A720e)
 */
export const writeAaveOracleTaikoSetAssetSources =
  /*#__PURE__*/ createWriteContract({
    abi: aaveOracleTaikoAbi,
    address: aaveOracleTaikoAddress,
    functionName: 'setAssetSources',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link aaveOracleTaikoAbi}__ and `functionName` set to `"setFallbackOracle"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x1fB6d773fE35266eC3363a935a4163f330a18b15)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x30f508945e0eB6A3D0dA99226B7E3eEA246A720e)
 */
export const writeAaveOracleTaikoSetFallbackOracle =
  /*#__PURE__*/ createWriteContract({
    abi: aaveOracleTaikoAbi,
    address: aaveOracleTaikoAddress,
    functionName: 'setFallbackOracle',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link aaveOracleTaikoAbi}__ and `functionName` set to `"toggleFallbackOracle"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x1fB6d773fE35266eC3363a935a4163f330a18b15)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x30f508945e0eB6A3D0dA99226B7E3eEA246A720e)
 */
export const writeAaveOracleTaikoToggleFallbackOracle =
  /*#__PURE__*/ createWriteContract({
    abi: aaveOracleTaikoAbi,
    address: aaveOracleTaikoAddress,
    functionName: 'toggleFallbackOracle',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link aaveOracleTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x1fB6d773fE35266eC3363a935a4163f330a18b15)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x30f508945e0eB6A3D0dA99226B7E3eEA246A720e)
 */
export const simulateAaveOracleTaiko = /*#__PURE__*/ createSimulateContract({
  abi: aaveOracleTaikoAbi,
  address: aaveOracleTaikoAddress,
})

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link aaveOracleTaikoAbi}__ and `functionName` set to `"setAssetSources"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x1fB6d773fE35266eC3363a935a4163f330a18b15)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x30f508945e0eB6A3D0dA99226B7E3eEA246A720e)
 */
export const simulateAaveOracleTaikoSetAssetSources =
  /*#__PURE__*/ createSimulateContract({
    abi: aaveOracleTaikoAbi,
    address: aaveOracleTaikoAddress,
    functionName: 'setAssetSources',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link aaveOracleTaikoAbi}__ and `functionName` set to `"setFallbackOracle"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x1fB6d773fE35266eC3363a935a4163f330a18b15)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x30f508945e0eB6A3D0dA99226B7E3eEA246A720e)
 */
export const simulateAaveOracleTaikoSetFallbackOracle =
  /*#__PURE__*/ createSimulateContract({
    abi: aaveOracleTaikoAbi,
    address: aaveOracleTaikoAddress,
    functionName: 'setFallbackOracle',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link aaveOracleTaikoAbi}__ and `functionName` set to `"toggleFallbackOracle"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x1fB6d773fE35266eC3363a935a4163f330a18b15)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x30f508945e0eB6A3D0dA99226B7E3eEA246A720e)
 */
export const simulateAaveOracleTaikoToggleFallbackOracle =
  /*#__PURE__*/ createSimulateContract({
    abi: aaveOracleTaikoAbi,
    address: aaveOracleTaikoAddress,
    functionName: 'toggleFallbackOracle',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link aaveOracleTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x1fB6d773fE35266eC3363a935a4163f330a18b15)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x30f508945e0eB6A3D0dA99226B7E3eEA246A720e)
 */
export const watchAaveOracleTaikoEvent = /*#__PURE__*/ createWatchContractEvent(
  { abi: aaveOracleTaikoAbi, address: aaveOracleTaikoAddress },
)

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link aaveOracleTaikoAbi}__ and `eventName` set to `"AssetSourceUpdated"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x1fB6d773fE35266eC3363a935a4163f330a18b15)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x30f508945e0eB6A3D0dA99226B7E3eEA246A720e)
 */
export const watchAaveOracleTaikoAssetSourceUpdatedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: aaveOracleTaikoAbi,
    address: aaveOracleTaikoAddress,
    eventName: 'AssetSourceUpdated',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link aaveOracleTaikoAbi}__ and `eventName` set to `"BaseCurrencySet"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x1fB6d773fE35266eC3363a935a4163f330a18b15)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x30f508945e0eB6A3D0dA99226B7E3eEA246A720e)
 */
export const watchAaveOracleTaikoBaseCurrencySetEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: aaveOracleTaikoAbi,
    address: aaveOracleTaikoAddress,
    eventName: 'BaseCurrencySet',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link aaveOracleTaikoAbi}__ and `eventName` set to `"FallbackOracleUpdated"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x1fB6d773fE35266eC3363a935a4163f330a18b15)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x30f508945e0eB6A3D0dA99226B7E3eEA246A720e)
 */
export const watchAaveOracleTaikoFallbackOracleUpdatedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: aaveOracleTaikoAbi,
    address: aaveOracleTaikoAddress,
    eventName: 'FallbackOracleUpdated',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link borrowLogicAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x0D180a98BB91aaC18A0C4fb0537914013CAe4226)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x11913178d32d8eb0f02146abDDb74B4963DEfa7F)
 */
export const watchBorrowLogicEvent = /*#__PURE__*/ createWatchContractEvent({
  abi: borrowLogicAbi,
  address: borrowLogicAddress,
})

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link borrowLogicAbi}__ and `eventName` set to `"Borrow"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x0D180a98BB91aaC18A0C4fb0537914013CAe4226)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x11913178d32d8eb0f02146abDDb74B4963DEfa7F)
 */
export const watchBorrowLogicBorrowEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: borrowLogicAbi,
    address: borrowLogicAddress,
    eventName: 'Borrow',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link borrowLogicAbi}__ and `eventName` set to `"IsolationModeTotalDebtUpdated"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x0D180a98BB91aaC18A0C4fb0537914013CAe4226)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x11913178d32d8eb0f02146abDDb74B4963DEfa7F)
 */
export const watchBorrowLogicIsolationModeTotalDebtUpdatedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: borrowLogicAbi,
    address: borrowLogicAddress,
    eventName: 'IsolationModeTotalDebtUpdated',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link borrowLogicAbi}__ and `eventName` set to `"RebalanceStableBorrowRate"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x0D180a98BB91aaC18A0C4fb0537914013CAe4226)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x11913178d32d8eb0f02146abDDb74B4963DEfa7F)
 */
export const watchBorrowLogicRebalanceStableBorrowRateEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: borrowLogicAbi,
    address: borrowLogicAddress,
    eventName: 'RebalanceStableBorrowRate',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link borrowLogicAbi}__ and `eventName` set to `"Repay"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x0D180a98BB91aaC18A0C4fb0537914013CAe4226)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x11913178d32d8eb0f02146abDDb74B4963DEfa7F)
 */
export const watchBorrowLogicRepayEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: borrowLogicAbi,
    address: borrowLogicAddress,
    eventName: 'Repay',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link borrowLogicAbi}__ and `eventName` set to `"ReserveDataUpdated"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x0D180a98BB91aaC18A0C4fb0537914013CAe4226)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x11913178d32d8eb0f02146abDDb74B4963DEfa7F)
 */
export const watchBorrowLogicReserveDataUpdatedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: borrowLogicAbi,
    address: borrowLogicAddress,
    eventName: 'ReserveDataUpdated',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link borrowLogicAbi}__ and `eventName` set to `"SwapBorrowRateMode"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x0D180a98BB91aaC18A0C4fb0537914013CAe4226)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x11913178d32d8eb0f02146abDDb74B4963DEfa7F)
 */
export const watchBorrowLogicSwapBorrowRateModeEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: borrowLogicAbi,
    address: borrowLogicAddress,
    eventName: 'SwapBorrowRateMode',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link bridgeLogicAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xD8b5E00454881b7329E590f0Aa0424fc436Cc352)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9b3877fB198CE30cc80feF984b1809470ac4114c)
 */
export const watchBridgeLogicEvent = /*#__PURE__*/ createWatchContractEvent({
  abi: bridgeLogicAbi,
  address: bridgeLogicAddress,
})

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link bridgeLogicAbi}__ and `eventName` set to `"BackUnbacked"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xD8b5E00454881b7329E590f0Aa0424fc436Cc352)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9b3877fB198CE30cc80feF984b1809470ac4114c)
 */
export const watchBridgeLogicBackUnbackedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: bridgeLogicAbi,
    address: bridgeLogicAddress,
    eventName: 'BackUnbacked',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link bridgeLogicAbi}__ and `eventName` set to `"MintUnbacked"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xD8b5E00454881b7329E590f0Aa0424fc436Cc352)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9b3877fB198CE30cc80feF984b1809470ac4114c)
 */
export const watchBridgeLogicMintUnbackedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: bridgeLogicAbi,
    address: bridgeLogicAddress,
    eventName: 'MintUnbacked',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link bridgeLogicAbi}__ and `eventName` set to `"ReserveDataUpdated"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xD8b5E00454881b7329E590f0Aa0424fc436Cc352)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9b3877fB198CE30cc80feF984b1809470ac4114c)
 */
export const watchBridgeLogicReserveDataUpdatedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: bridgeLogicAbi,
    address: bridgeLogicAddress,
    eventName: 'ReserveDataUpdated',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link bridgeLogicAbi}__ and `eventName` set to `"ReserveUsedAsCollateralEnabled"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xD8b5E00454881b7329E590f0Aa0424fc436Cc352)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9b3877fB198CE30cc80feF984b1809470ac4114c)
 */
export const watchBridgeLogicReserveUsedAsCollateralEnabledEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: bridgeLogicAbi,
    address: bridgeLogicAddress,
    eventName: 'ReserveUsedAsCollateralEnabled',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link configuratorLogicAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xe183ecd498E9d1140f1e0799539D63E85683881C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7625557118c21218cD5A3A6Cc0C3b797eEcF230C)
 */
export const watchConfiguratorLogicEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: configuratorLogicAbi,
    address: configuratorLogicAddress,
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link configuratorLogicAbi}__ and `eventName` set to `"ATokenUpgraded"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xe183ecd498E9d1140f1e0799539D63E85683881C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7625557118c21218cD5A3A6Cc0C3b797eEcF230C)
 */
export const watchConfiguratorLogicATokenUpgradedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: configuratorLogicAbi,
    address: configuratorLogicAddress,
    eventName: 'ATokenUpgraded',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link configuratorLogicAbi}__ and `eventName` set to `"ReserveInitialized"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xe183ecd498E9d1140f1e0799539D63E85683881C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7625557118c21218cD5A3A6Cc0C3b797eEcF230C)
 */
export const watchConfiguratorLogicReserveInitializedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: configuratorLogicAbi,
    address: configuratorLogicAddress,
    eventName: 'ReserveInitialized',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link configuratorLogicAbi}__ and `eventName` set to `"StableDebtTokenUpgraded"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xe183ecd498E9d1140f1e0799539D63E85683881C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7625557118c21218cD5A3A6Cc0C3b797eEcF230C)
 */
export const watchConfiguratorLogicStableDebtTokenUpgradedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: configuratorLogicAbi,
    address: configuratorLogicAddress,
    eventName: 'StableDebtTokenUpgraded',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link configuratorLogicAbi}__ and `eventName` set to `"VariableDebtTokenUpgraded"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xe183ecd498E9d1140f1e0799539D63E85683881C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7625557118c21218cD5A3A6Cc0C3b797eEcF230C)
 */
export const watchConfiguratorLogicVariableDebtTokenUpgradedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: configuratorLogicAbi,
    address: configuratorLogicAddress,
    eventName: 'VariableDebtTokenUpgraded',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link delegationAwareATokenTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd70510E4523658d77f9e7fD5d892b468d1b3b2f7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeDA1B335A62C7FE079f5C507C64322aA246e3405)
 */
export const readDelegationAwareATokenTaiko = /*#__PURE__*/ createReadContract({
  abi: delegationAwareATokenTaikoAbi,
  address: delegationAwareATokenTaikoAddress,
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link delegationAwareATokenTaikoAbi}__ and `functionName` set to `"ATOKEN_REVISION"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd70510E4523658d77f9e7fD5d892b468d1b3b2f7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeDA1B335A62C7FE079f5C507C64322aA246e3405)
 */
export const readDelegationAwareATokenTaikoAtokenRevision =
  /*#__PURE__*/ createReadContract({
    abi: delegationAwareATokenTaikoAbi,
    address: delegationAwareATokenTaikoAddress,
    functionName: 'ATOKEN_REVISION',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link delegationAwareATokenTaikoAbi}__ and `functionName` set to `"DOMAIN_SEPARATOR"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd70510E4523658d77f9e7fD5d892b468d1b3b2f7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeDA1B335A62C7FE079f5C507C64322aA246e3405)
 */
export const readDelegationAwareATokenTaikoDomainSeparator =
  /*#__PURE__*/ createReadContract({
    abi: delegationAwareATokenTaikoAbi,
    address: delegationAwareATokenTaikoAddress,
    functionName: 'DOMAIN_SEPARATOR',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link delegationAwareATokenTaikoAbi}__ and `functionName` set to `"EIP712_REVISION"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd70510E4523658d77f9e7fD5d892b468d1b3b2f7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeDA1B335A62C7FE079f5C507C64322aA246e3405)
 */
export const readDelegationAwareATokenTaikoEip712Revision =
  /*#__PURE__*/ createReadContract({
    abi: delegationAwareATokenTaikoAbi,
    address: delegationAwareATokenTaikoAddress,
    functionName: 'EIP712_REVISION',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link delegationAwareATokenTaikoAbi}__ and `functionName` set to `"PERMIT_TYPEHASH"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd70510E4523658d77f9e7fD5d892b468d1b3b2f7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeDA1B335A62C7FE079f5C507C64322aA246e3405)
 */
export const readDelegationAwareATokenTaikoPermitTypehash =
  /*#__PURE__*/ createReadContract({
    abi: delegationAwareATokenTaikoAbi,
    address: delegationAwareATokenTaikoAddress,
    functionName: 'PERMIT_TYPEHASH',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link delegationAwareATokenTaikoAbi}__ and `functionName` set to `"POOL"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd70510E4523658d77f9e7fD5d892b468d1b3b2f7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeDA1B335A62C7FE079f5C507C64322aA246e3405)
 */
export const readDelegationAwareATokenTaikoPool =
  /*#__PURE__*/ createReadContract({
    abi: delegationAwareATokenTaikoAbi,
    address: delegationAwareATokenTaikoAddress,
    functionName: 'POOL',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link delegationAwareATokenTaikoAbi}__ and `functionName` set to `"RESERVE_TREASURY_ADDRESS"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd70510E4523658d77f9e7fD5d892b468d1b3b2f7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeDA1B335A62C7FE079f5C507C64322aA246e3405)
 */
export const readDelegationAwareATokenTaikoReserveTreasuryAddress =
  /*#__PURE__*/ createReadContract({
    abi: delegationAwareATokenTaikoAbi,
    address: delegationAwareATokenTaikoAddress,
    functionName: 'RESERVE_TREASURY_ADDRESS',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link delegationAwareATokenTaikoAbi}__ and `functionName` set to `"UNDERLYING_ASSET_ADDRESS"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd70510E4523658d77f9e7fD5d892b468d1b3b2f7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeDA1B335A62C7FE079f5C507C64322aA246e3405)
 */
export const readDelegationAwareATokenTaikoUnderlyingAssetAddress =
  /*#__PURE__*/ createReadContract({
    abi: delegationAwareATokenTaikoAbi,
    address: delegationAwareATokenTaikoAddress,
    functionName: 'UNDERLYING_ASSET_ADDRESS',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link delegationAwareATokenTaikoAbi}__ and `functionName` set to `"allowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd70510E4523658d77f9e7fD5d892b468d1b3b2f7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeDA1B335A62C7FE079f5C507C64322aA246e3405)
 */
export const readDelegationAwareATokenTaikoAllowance =
  /*#__PURE__*/ createReadContract({
    abi: delegationAwareATokenTaikoAbi,
    address: delegationAwareATokenTaikoAddress,
    functionName: 'allowance',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link delegationAwareATokenTaikoAbi}__ and `functionName` set to `"balanceOf"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd70510E4523658d77f9e7fD5d892b468d1b3b2f7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeDA1B335A62C7FE079f5C507C64322aA246e3405)
 */
export const readDelegationAwareATokenTaikoBalanceOf =
  /*#__PURE__*/ createReadContract({
    abi: delegationAwareATokenTaikoAbi,
    address: delegationAwareATokenTaikoAddress,
    functionName: 'balanceOf',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link delegationAwareATokenTaikoAbi}__ and `functionName` set to `"decimals"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd70510E4523658d77f9e7fD5d892b468d1b3b2f7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeDA1B335A62C7FE079f5C507C64322aA246e3405)
 */
export const readDelegationAwareATokenTaikoDecimals =
  /*#__PURE__*/ createReadContract({
    abi: delegationAwareATokenTaikoAbi,
    address: delegationAwareATokenTaikoAddress,
    functionName: 'decimals',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link delegationAwareATokenTaikoAbi}__ and `functionName` set to `"getIncentivesController"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd70510E4523658d77f9e7fD5d892b468d1b3b2f7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeDA1B335A62C7FE079f5C507C64322aA246e3405)
 */
export const readDelegationAwareATokenTaikoGetIncentivesController =
  /*#__PURE__*/ createReadContract({
    abi: delegationAwareATokenTaikoAbi,
    address: delegationAwareATokenTaikoAddress,
    functionName: 'getIncentivesController',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link delegationAwareATokenTaikoAbi}__ and `functionName` set to `"getPreviousIndex"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd70510E4523658d77f9e7fD5d892b468d1b3b2f7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeDA1B335A62C7FE079f5C507C64322aA246e3405)
 */
export const readDelegationAwareATokenTaikoGetPreviousIndex =
  /*#__PURE__*/ createReadContract({
    abi: delegationAwareATokenTaikoAbi,
    address: delegationAwareATokenTaikoAddress,
    functionName: 'getPreviousIndex',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link delegationAwareATokenTaikoAbi}__ and `functionName` set to `"getScaledUserBalanceAndSupply"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd70510E4523658d77f9e7fD5d892b468d1b3b2f7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeDA1B335A62C7FE079f5C507C64322aA246e3405)
 */
export const readDelegationAwareATokenTaikoGetScaledUserBalanceAndSupply =
  /*#__PURE__*/ createReadContract({
    abi: delegationAwareATokenTaikoAbi,
    address: delegationAwareATokenTaikoAddress,
    functionName: 'getScaledUserBalanceAndSupply',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link delegationAwareATokenTaikoAbi}__ and `functionName` set to `"name"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd70510E4523658d77f9e7fD5d892b468d1b3b2f7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeDA1B335A62C7FE079f5C507C64322aA246e3405)
 */
export const readDelegationAwareATokenTaikoName =
  /*#__PURE__*/ createReadContract({
    abi: delegationAwareATokenTaikoAbi,
    address: delegationAwareATokenTaikoAddress,
    functionName: 'name',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link delegationAwareATokenTaikoAbi}__ and `functionName` set to `"nonces"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd70510E4523658d77f9e7fD5d892b468d1b3b2f7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeDA1B335A62C7FE079f5C507C64322aA246e3405)
 */
export const readDelegationAwareATokenTaikoNonces =
  /*#__PURE__*/ createReadContract({
    abi: delegationAwareATokenTaikoAbi,
    address: delegationAwareATokenTaikoAddress,
    functionName: 'nonces',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link delegationAwareATokenTaikoAbi}__ and `functionName` set to `"scaledBalanceOf"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd70510E4523658d77f9e7fD5d892b468d1b3b2f7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeDA1B335A62C7FE079f5C507C64322aA246e3405)
 */
export const readDelegationAwareATokenTaikoScaledBalanceOf =
  /*#__PURE__*/ createReadContract({
    abi: delegationAwareATokenTaikoAbi,
    address: delegationAwareATokenTaikoAddress,
    functionName: 'scaledBalanceOf',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link delegationAwareATokenTaikoAbi}__ and `functionName` set to `"scaledTotalSupply"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd70510E4523658d77f9e7fD5d892b468d1b3b2f7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeDA1B335A62C7FE079f5C507C64322aA246e3405)
 */
export const readDelegationAwareATokenTaikoScaledTotalSupply =
  /*#__PURE__*/ createReadContract({
    abi: delegationAwareATokenTaikoAbi,
    address: delegationAwareATokenTaikoAddress,
    functionName: 'scaledTotalSupply',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link delegationAwareATokenTaikoAbi}__ and `functionName` set to `"symbol"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd70510E4523658d77f9e7fD5d892b468d1b3b2f7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeDA1B335A62C7FE079f5C507C64322aA246e3405)
 */
export const readDelegationAwareATokenTaikoSymbol =
  /*#__PURE__*/ createReadContract({
    abi: delegationAwareATokenTaikoAbi,
    address: delegationAwareATokenTaikoAddress,
    functionName: 'symbol',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link delegationAwareATokenTaikoAbi}__ and `functionName` set to `"totalSupply"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd70510E4523658d77f9e7fD5d892b468d1b3b2f7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeDA1B335A62C7FE079f5C507C64322aA246e3405)
 */
export const readDelegationAwareATokenTaikoTotalSupply =
  /*#__PURE__*/ createReadContract({
    abi: delegationAwareATokenTaikoAbi,
    address: delegationAwareATokenTaikoAddress,
    functionName: 'totalSupply',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link delegationAwareATokenTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd70510E4523658d77f9e7fD5d892b468d1b3b2f7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeDA1B335A62C7FE079f5C507C64322aA246e3405)
 */
export const writeDelegationAwareATokenTaiko =
  /*#__PURE__*/ createWriteContract({
    abi: delegationAwareATokenTaikoAbi,
    address: delegationAwareATokenTaikoAddress,
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link delegationAwareATokenTaikoAbi}__ and `functionName` set to `"approve"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd70510E4523658d77f9e7fD5d892b468d1b3b2f7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeDA1B335A62C7FE079f5C507C64322aA246e3405)
 */
export const writeDelegationAwareATokenTaikoApprove =
  /*#__PURE__*/ createWriteContract({
    abi: delegationAwareATokenTaikoAbi,
    address: delegationAwareATokenTaikoAddress,
    functionName: 'approve',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link delegationAwareATokenTaikoAbi}__ and `functionName` set to `"burn"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd70510E4523658d77f9e7fD5d892b468d1b3b2f7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeDA1B335A62C7FE079f5C507C64322aA246e3405)
 */
export const writeDelegationAwareATokenTaikoBurn =
  /*#__PURE__*/ createWriteContract({
    abi: delegationAwareATokenTaikoAbi,
    address: delegationAwareATokenTaikoAddress,
    functionName: 'burn',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link delegationAwareATokenTaikoAbi}__ and `functionName` set to `"decreaseAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd70510E4523658d77f9e7fD5d892b468d1b3b2f7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeDA1B335A62C7FE079f5C507C64322aA246e3405)
 */
export const writeDelegationAwareATokenTaikoDecreaseAllowance =
  /*#__PURE__*/ createWriteContract({
    abi: delegationAwareATokenTaikoAbi,
    address: delegationAwareATokenTaikoAddress,
    functionName: 'decreaseAllowance',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link delegationAwareATokenTaikoAbi}__ and `functionName` set to `"delegateUnderlyingTo"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd70510E4523658d77f9e7fD5d892b468d1b3b2f7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeDA1B335A62C7FE079f5C507C64322aA246e3405)
 */
export const writeDelegationAwareATokenTaikoDelegateUnderlyingTo =
  /*#__PURE__*/ createWriteContract({
    abi: delegationAwareATokenTaikoAbi,
    address: delegationAwareATokenTaikoAddress,
    functionName: 'delegateUnderlyingTo',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link delegationAwareATokenTaikoAbi}__ and `functionName` set to `"handleRepayment"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd70510E4523658d77f9e7fD5d892b468d1b3b2f7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeDA1B335A62C7FE079f5C507C64322aA246e3405)
 */
export const writeDelegationAwareATokenTaikoHandleRepayment =
  /*#__PURE__*/ createWriteContract({
    abi: delegationAwareATokenTaikoAbi,
    address: delegationAwareATokenTaikoAddress,
    functionName: 'handleRepayment',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link delegationAwareATokenTaikoAbi}__ and `functionName` set to `"increaseAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd70510E4523658d77f9e7fD5d892b468d1b3b2f7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeDA1B335A62C7FE079f5C507C64322aA246e3405)
 */
export const writeDelegationAwareATokenTaikoIncreaseAllowance =
  /*#__PURE__*/ createWriteContract({
    abi: delegationAwareATokenTaikoAbi,
    address: delegationAwareATokenTaikoAddress,
    functionName: 'increaseAllowance',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link delegationAwareATokenTaikoAbi}__ and `functionName` set to `"initialize"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd70510E4523658d77f9e7fD5d892b468d1b3b2f7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeDA1B335A62C7FE079f5C507C64322aA246e3405)
 */
export const writeDelegationAwareATokenTaikoInitialize =
  /*#__PURE__*/ createWriteContract({
    abi: delegationAwareATokenTaikoAbi,
    address: delegationAwareATokenTaikoAddress,
    functionName: 'initialize',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link delegationAwareATokenTaikoAbi}__ and `functionName` set to `"mint"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd70510E4523658d77f9e7fD5d892b468d1b3b2f7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeDA1B335A62C7FE079f5C507C64322aA246e3405)
 */
export const writeDelegationAwareATokenTaikoMint =
  /*#__PURE__*/ createWriteContract({
    abi: delegationAwareATokenTaikoAbi,
    address: delegationAwareATokenTaikoAddress,
    functionName: 'mint',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link delegationAwareATokenTaikoAbi}__ and `functionName` set to `"mintToTreasury"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd70510E4523658d77f9e7fD5d892b468d1b3b2f7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeDA1B335A62C7FE079f5C507C64322aA246e3405)
 */
export const writeDelegationAwareATokenTaikoMintToTreasury =
  /*#__PURE__*/ createWriteContract({
    abi: delegationAwareATokenTaikoAbi,
    address: delegationAwareATokenTaikoAddress,
    functionName: 'mintToTreasury',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link delegationAwareATokenTaikoAbi}__ and `functionName` set to `"permit"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd70510E4523658d77f9e7fD5d892b468d1b3b2f7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeDA1B335A62C7FE079f5C507C64322aA246e3405)
 */
export const writeDelegationAwareATokenTaikoPermit =
  /*#__PURE__*/ createWriteContract({
    abi: delegationAwareATokenTaikoAbi,
    address: delegationAwareATokenTaikoAddress,
    functionName: 'permit',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link delegationAwareATokenTaikoAbi}__ and `functionName` set to `"rescueTokens"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd70510E4523658d77f9e7fD5d892b468d1b3b2f7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeDA1B335A62C7FE079f5C507C64322aA246e3405)
 */
export const writeDelegationAwareATokenTaikoRescueTokens =
  /*#__PURE__*/ createWriteContract({
    abi: delegationAwareATokenTaikoAbi,
    address: delegationAwareATokenTaikoAddress,
    functionName: 'rescueTokens',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link delegationAwareATokenTaikoAbi}__ and `functionName` set to `"setIncentivesController"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd70510E4523658d77f9e7fD5d892b468d1b3b2f7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeDA1B335A62C7FE079f5C507C64322aA246e3405)
 */
export const writeDelegationAwareATokenTaikoSetIncentivesController =
  /*#__PURE__*/ createWriteContract({
    abi: delegationAwareATokenTaikoAbi,
    address: delegationAwareATokenTaikoAddress,
    functionName: 'setIncentivesController',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link delegationAwareATokenTaikoAbi}__ and `functionName` set to `"transfer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd70510E4523658d77f9e7fD5d892b468d1b3b2f7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeDA1B335A62C7FE079f5C507C64322aA246e3405)
 */
export const writeDelegationAwareATokenTaikoTransfer =
  /*#__PURE__*/ createWriteContract({
    abi: delegationAwareATokenTaikoAbi,
    address: delegationAwareATokenTaikoAddress,
    functionName: 'transfer',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link delegationAwareATokenTaikoAbi}__ and `functionName` set to `"transferFrom"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd70510E4523658d77f9e7fD5d892b468d1b3b2f7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeDA1B335A62C7FE079f5C507C64322aA246e3405)
 */
export const writeDelegationAwareATokenTaikoTransferFrom =
  /*#__PURE__*/ createWriteContract({
    abi: delegationAwareATokenTaikoAbi,
    address: delegationAwareATokenTaikoAddress,
    functionName: 'transferFrom',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link delegationAwareATokenTaikoAbi}__ and `functionName` set to `"transferOnLiquidation"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd70510E4523658d77f9e7fD5d892b468d1b3b2f7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeDA1B335A62C7FE079f5C507C64322aA246e3405)
 */
export const writeDelegationAwareATokenTaikoTransferOnLiquidation =
  /*#__PURE__*/ createWriteContract({
    abi: delegationAwareATokenTaikoAbi,
    address: delegationAwareATokenTaikoAddress,
    functionName: 'transferOnLiquidation',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link delegationAwareATokenTaikoAbi}__ and `functionName` set to `"transferUnderlyingTo"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd70510E4523658d77f9e7fD5d892b468d1b3b2f7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeDA1B335A62C7FE079f5C507C64322aA246e3405)
 */
export const writeDelegationAwareATokenTaikoTransferUnderlyingTo =
  /*#__PURE__*/ createWriteContract({
    abi: delegationAwareATokenTaikoAbi,
    address: delegationAwareATokenTaikoAddress,
    functionName: 'transferUnderlyingTo',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link delegationAwareATokenTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd70510E4523658d77f9e7fD5d892b468d1b3b2f7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeDA1B335A62C7FE079f5C507C64322aA246e3405)
 */
export const simulateDelegationAwareATokenTaiko =
  /*#__PURE__*/ createSimulateContract({
    abi: delegationAwareATokenTaikoAbi,
    address: delegationAwareATokenTaikoAddress,
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link delegationAwareATokenTaikoAbi}__ and `functionName` set to `"approve"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd70510E4523658d77f9e7fD5d892b468d1b3b2f7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeDA1B335A62C7FE079f5C507C64322aA246e3405)
 */
export const simulateDelegationAwareATokenTaikoApprove =
  /*#__PURE__*/ createSimulateContract({
    abi: delegationAwareATokenTaikoAbi,
    address: delegationAwareATokenTaikoAddress,
    functionName: 'approve',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link delegationAwareATokenTaikoAbi}__ and `functionName` set to `"burn"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd70510E4523658d77f9e7fD5d892b468d1b3b2f7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeDA1B335A62C7FE079f5C507C64322aA246e3405)
 */
export const simulateDelegationAwareATokenTaikoBurn =
  /*#__PURE__*/ createSimulateContract({
    abi: delegationAwareATokenTaikoAbi,
    address: delegationAwareATokenTaikoAddress,
    functionName: 'burn',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link delegationAwareATokenTaikoAbi}__ and `functionName` set to `"decreaseAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd70510E4523658d77f9e7fD5d892b468d1b3b2f7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeDA1B335A62C7FE079f5C507C64322aA246e3405)
 */
export const simulateDelegationAwareATokenTaikoDecreaseAllowance =
  /*#__PURE__*/ createSimulateContract({
    abi: delegationAwareATokenTaikoAbi,
    address: delegationAwareATokenTaikoAddress,
    functionName: 'decreaseAllowance',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link delegationAwareATokenTaikoAbi}__ and `functionName` set to `"delegateUnderlyingTo"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd70510E4523658d77f9e7fD5d892b468d1b3b2f7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeDA1B335A62C7FE079f5C507C64322aA246e3405)
 */
export const simulateDelegationAwareATokenTaikoDelegateUnderlyingTo =
  /*#__PURE__*/ createSimulateContract({
    abi: delegationAwareATokenTaikoAbi,
    address: delegationAwareATokenTaikoAddress,
    functionName: 'delegateUnderlyingTo',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link delegationAwareATokenTaikoAbi}__ and `functionName` set to `"handleRepayment"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd70510E4523658d77f9e7fD5d892b468d1b3b2f7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeDA1B335A62C7FE079f5C507C64322aA246e3405)
 */
export const simulateDelegationAwareATokenTaikoHandleRepayment =
  /*#__PURE__*/ createSimulateContract({
    abi: delegationAwareATokenTaikoAbi,
    address: delegationAwareATokenTaikoAddress,
    functionName: 'handleRepayment',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link delegationAwareATokenTaikoAbi}__ and `functionName` set to `"increaseAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd70510E4523658d77f9e7fD5d892b468d1b3b2f7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeDA1B335A62C7FE079f5C507C64322aA246e3405)
 */
export const simulateDelegationAwareATokenTaikoIncreaseAllowance =
  /*#__PURE__*/ createSimulateContract({
    abi: delegationAwareATokenTaikoAbi,
    address: delegationAwareATokenTaikoAddress,
    functionName: 'increaseAllowance',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link delegationAwareATokenTaikoAbi}__ and `functionName` set to `"initialize"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd70510E4523658d77f9e7fD5d892b468d1b3b2f7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeDA1B335A62C7FE079f5C507C64322aA246e3405)
 */
export const simulateDelegationAwareATokenTaikoInitialize =
  /*#__PURE__*/ createSimulateContract({
    abi: delegationAwareATokenTaikoAbi,
    address: delegationAwareATokenTaikoAddress,
    functionName: 'initialize',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link delegationAwareATokenTaikoAbi}__ and `functionName` set to `"mint"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd70510E4523658d77f9e7fD5d892b468d1b3b2f7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeDA1B335A62C7FE079f5C507C64322aA246e3405)
 */
export const simulateDelegationAwareATokenTaikoMint =
  /*#__PURE__*/ createSimulateContract({
    abi: delegationAwareATokenTaikoAbi,
    address: delegationAwareATokenTaikoAddress,
    functionName: 'mint',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link delegationAwareATokenTaikoAbi}__ and `functionName` set to `"mintToTreasury"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd70510E4523658d77f9e7fD5d892b468d1b3b2f7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeDA1B335A62C7FE079f5C507C64322aA246e3405)
 */
export const simulateDelegationAwareATokenTaikoMintToTreasury =
  /*#__PURE__*/ createSimulateContract({
    abi: delegationAwareATokenTaikoAbi,
    address: delegationAwareATokenTaikoAddress,
    functionName: 'mintToTreasury',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link delegationAwareATokenTaikoAbi}__ and `functionName` set to `"permit"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd70510E4523658d77f9e7fD5d892b468d1b3b2f7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeDA1B335A62C7FE079f5C507C64322aA246e3405)
 */
export const simulateDelegationAwareATokenTaikoPermit =
  /*#__PURE__*/ createSimulateContract({
    abi: delegationAwareATokenTaikoAbi,
    address: delegationAwareATokenTaikoAddress,
    functionName: 'permit',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link delegationAwareATokenTaikoAbi}__ and `functionName` set to `"rescueTokens"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd70510E4523658d77f9e7fD5d892b468d1b3b2f7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeDA1B335A62C7FE079f5C507C64322aA246e3405)
 */
export const simulateDelegationAwareATokenTaikoRescueTokens =
  /*#__PURE__*/ createSimulateContract({
    abi: delegationAwareATokenTaikoAbi,
    address: delegationAwareATokenTaikoAddress,
    functionName: 'rescueTokens',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link delegationAwareATokenTaikoAbi}__ and `functionName` set to `"setIncentivesController"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd70510E4523658d77f9e7fD5d892b468d1b3b2f7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeDA1B335A62C7FE079f5C507C64322aA246e3405)
 */
export const simulateDelegationAwareATokenTaikoSetIncentivesController =
  /*#__PURE__*/ createSimulateContract({
    abi: delegationAwareATokenTaikoAbi,
    address: delegationAwareATokenTaikoAddress,
    functionName: 'setIncentivesController',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link delegationAwareATokenTaikoAbi}__ and `functionName` set to `"transfer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd70510E4523658d77f9e7fD5d892b468d1b3b2f7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeDA1B335A62C7FE079f5C507C64322aA246e3405)
 */
export const simulateDelegationAwareATokenTaikoTransfer =
  /*#__PURE__*/ createSimulateContract({
    abi: delegationAwareATokenTaikoAbi,
    address: delegationAwareATokenTaikoAddress,
    functionName: 'transfer',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link delegationAwareATokenTaikoAbi}__ and `functionName` set to `"transferFrom"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd70510E4523658d77f9e7fD5d892b468d1b3b2f7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeDA1B335A62C7FE079f5C507C64322aA246e3405)
 */
export const simulateDelegationAwareATokenTaikoTransferFrom =
  /*#__PURE__*/ createSimulateContract({
    abi: delegationAwareATokenTaikoAbi,
    address: delegationAwareATokenTaikoAddress,
    functionName: 'transferFrom',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link delegationAwareATokenTaikoAbi}__ and `functionName` set to `"transferOnLiquidation"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd70510E4523658d77f9e7fD5d892b468d1b3b2f7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeDA1B335A62C7FE079f5C507C64322aA246e3405)
 */
export const simulateDelegationAwareATokenTaikoTransferOnLiquidation =
  /*#__PURE__*/ createSimulateContract({
    abi: delegationAwareATokenTaikoAbi,
    address: delegationAwareATokenTaikoAddress,
    functionName: 'transferOnLiquidation',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link delegationAwareATokenTaikoAbi}__ and `functionName` set to `"transferUnderlyingTo"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd70510E4523658d77f9e7fD5d892b468d1b3b2f7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeDA1B335A62C7FE079f5C507C64322aA246e3405)
 */
export const simulateDelegationAwareATokenTaikoTransferUnderlyingTo =
  /*#__PURE__*/ createSimulateContract({
    abi: delegationAwareATokenTaikoAbi,
    address: delegationAwareATokenTaikoAddress,
    functionName: 'transferUnderlyingTo',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link delegationAwareATokenTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd70510E4523658d77f9e7fD5d892b468d1b3b2f7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeDA1B335A62C7FE079f5C507C64322aA246e3405)
 */
export const watchDelegationAwareATokenTaikoEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: delegationAwareATokenTaikoAbi,
    address: delegationAwareATokenTaikoAddress,
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link delegationAwareATokenTaikoAbi}__ and `eventName` set to `"Approval"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd70510E4523658d77f9e7fD5d892b468d1b3b2f7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeDA1B335A62C7FE079f5C507C64322aA246e3405)
 */
export const watchDelegationAwareATokenTaikoApprovalEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: delegationAwareATokenTaikoAbi,
    address: delegationAwareATokenTaikoAddress,
    eventName: 'Approval',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link delegationAwareATokenTaikoAbi}__ and `eventName` set to `"BalanceTransfer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd70510E4523658d77f9e7fD5d892b468d1b3b2f7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeDA1B335A62C7FE079f5C507C64322aA246e3405)
 */
export const watchDelegationAwareATokenTaikoBalanceTransferEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: delegationAwareATokenTaikoAbi,
    address: delegationAwareATokenTaikoAddress,
    eventName: 'BalanceTransfer',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link delegationAwareATokenTaikoAbi}__ and `eventName` set to `"Burn"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd70510E4523658d77f9e7fD5d892b468d1b3b2f7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeDA1B335A62C7FE079f5C507C64322aA246e3405)
 */
export const watchDelegationAwareATokenTaikoBurnEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: delegationAwareATokenTaikoAbi,
    address: delegationAwareATokenTaikoAddress,
    eventName: 'Burn',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link delegationAwareATokenTaikoAbi}__ and `eventName` set to `"DelegateUnderlyingTo"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd70510E4523658d77f9e7fD5d892b468d1b3b2f7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeDA1B335A62C7FE079f5C507C64322aA246e3405)
 */
export const watchDelegationAwareATokenTaikoDelegateUnderlyingToEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: delegationAwareATokenTaikoAbi,
    address: delegationAwareATokenTaikoAddress,
    eventName: 'DelegateUnderlyingTo',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link delegationAwareATokenTaikoAbi}__ and `eventName` set to `"Initialized"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd70510E4523658d77f9e7fD5d892b468d1b3b2f7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeDA1B335A62C7FE079f5C507C64322aA246e3405)
 */
export const watchDelegationAwareATokenTaikoInitializedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: delegationAwareATokenTaikoAbi,
    address: delegationAwareATokenTaikoAddress,
    eventName: 'Initialized',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link delegationAwareATokenTaikoAbi}__ and `eventName` set to `"Mint"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd70510E4523658d77f9e7fD5d892b468d1b3b2f7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeDA1B335A62C7FE079f5C507C64322aA246e3405)
 */
export const watchDelegationAwareATokenTaikoMintEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: delegationAwareATokenTaikoAbi,
    address: delegationAwareATokenTaikoAddress,
    eventName: 'Mint',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link delegationAwareATokenTaikoAbi}__ and `eventName` set to `"Transfer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd70510E4523658d77f9e7fD5d892b468d1b3b2f7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeDA1B335A62C7FE079f5C507C64322aA246e3405)
 */
export const watchDelegationAwareATokenTaikoTransferEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: delegationAwareATokenTaikoAbi,
    address: delegationAwareATokenTaikoAddress,
    eventName: 'Transfer',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link eModeLogicAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x6Aa37b935CED6698BfBC79266dc26B6c339e5462)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x22A15ea811fbb16AEB7d76c22D993feA4574dBd4)
 */
export const watchEModeLogicEvent = /*#__PURE__*/ createWatchContractEvent({
  abi: eModeLogicAbi,
  address: eModeLogicAddress,
})

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link eModeLogicAbi}__ and `eventName` set to `"UserEModeSet"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x6Aa37b935CED6698BfBC79266dc26B6c339e5462)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x22A15ea811fbb16AEB7d76c22D993feA4574dBd4)
 */
export const watchEModeLogicUserEModeSetEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: eModeLogicAbi,
    address: eModeLogicAddress,
    eventName: 'UserEModeSet',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link emissionManagerAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x75A562F96c538cA6d7f6603b7b7B1d22eFd46fa7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9e64f07168E782f839d0f296aE6bc488Fdb45049)
 */
export const readEmissionManager = /*#__PURE__*/ createReadContract({
  abi: emissionManagerAbi,
  address: emissionManagerAddress,
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link emissionManagerAbi}__ and `functionName` set to `"getEmissionAdmin"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x75A562F96c538cA6d7f6603b7b7B1d22eFd46fa7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9e64f07168E782f839d0f296aE6bc488Fdb45049)
 */
export const readEmissionManagerGetEmissionAdmin =
  /*#__PURE__*/ createReadContract({
    abi: emissionManagerAbi,
    address: emissionManagerAddress,
    functionName: 'getEmissionAdmin',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link emissionManagerAbi}__ and `functionName` set to `"getRewardsController"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x75A562F96c538cA6d7f6603b7b7B1d22eFd46fa7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9e64f07168E782f839d0f296aE6bc488Fdb45049)
 */
export const readEmissionManagerGetRewardsController =
  /*#__PURE__*/ createReadContract({
    abi: emissionManagerAbi,
    address: emissionManagerAddress,
    functionName: 'getRewardsController',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link emissionManagerAbi}__ and `functionName` set to `"owner"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x75A562F96c538cA6d7f6603b7b7B1d22eFd46fa7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9e64f07168E782f839d0f296aE6bc488Fdb45049)
 */
export const readEmissionManagerOwner = /*#__PURE__*/ createReadContract({
  abi: emissionManagerAbi,
  address: emissionManagerAddress,
  functionName: 'owner',
})

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link emissionManagerAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x75A562F96c538cA6d7f6603b7b7B1d22eFd46fa7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9e64f07168E782f839d0f296aE6bc488Fdb45049)
 */
export const writeEmissionManager = /*#__PURE__*/ createWriteContract({
  abi: emissionManagerAbi,
  address: emissionManagerAddress,
})

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link emissionManagerAbi}__ and `functionName` set to `"configureAssets"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x75A562F96c538cA6d7f6603b7b7B1d22eFd46fa7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9e64f07168E782f839d0f296aE6bc488Fdb45049)
 */
export const writeEmissionManagerConfigureAssets =
  /*#__PURE__*/ createWriteContract({
    abi: emissionManagerAbi,
    address: emissionManagerAddress,
    functionName: 'configureAssets',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link emissionManagerAbi}__ and `functionName` set to `"renounceOwnership"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x75A562F96c538cA6d7f6603b7b7B1d22eFd46fa7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9e64f07168E782f839d0f296aE6bc488Fdb45049)
 */
export const writeEmissionManagerRenounceOwnership =
  /*#__PURE__*/ createWriteContract({
    abi: emissionManagerAbi,
    address: emissionManagerAddress,
    functionName: 'renounceOwnership',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link emissionManagerAbi}__ and `functionName` set to `"setClaimer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x75A562F96c538cA6d7f6603b7b7B1d22eFd46fa7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9e64f07168E782f839d0f296aE6bc488Fdb45049)
 */
export const writeEmissionManagerSetClaimer = /*#__PURE__*/ createWriteContract(
  {
    abi: emissionManagerAbi,
    address: emissionManagerAddress,
    functionName: 'setClaimer',
  },
)

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link emissionManagerAbi}__ and `functionName` set to `"setDistributionEnd"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x75A562F96c538cA6d7f6603b7b7B1d22eFd46fa7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9e64f07168E782f839d0f296aE6bc488Fdb45049)
 */
export const writeEmissionManagerSetDistributionEnd =
  /*#__PURE__*/ createWriteContract({
    abi: emissionManagerAbi,
    address: emissionManagerAddress,
    functionName: 'setDistributionEnd',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link emissionManagerAbi}__ and `functionName` set to `"setEmissionAdmin"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x75A562F96c538cA6d7f6603b7b7B1d22eFd46fa7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9e64f07168E782f839d0f296aE6bc488Fdb45049)
 */
export const writeEmissionManagerSetEmissionAdmin =
  /*#__PURE__*/ createWriteContract({
    abi: emissionManagerAbi,
    address: emissionManagerAddress,
    functionName: 'setEmissionAdmin',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link emissionManagerAbi}__ and `functionName` set to `"setEmissionPerSecond"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x75A562F96c538cA6d7f6603b7b7B1d22eFd46fa7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9e64f07168E782f839d0f296aE6bc488Fdb45049)
 */
export const writeEmissionManagerSetEmissionPerSecond =
  /*#__PURE__*/ createWriteContract({
    abi: emissionManagerAbi,
    address: emissionManagerAddress,
    functionName: 'setEmissionPerSecond',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link emissionManagerAbi}__ and `functionName` set to `"setRewardOracle"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x75A562F96c538cA6d7f6603b7b7B1d22eFd46fa7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9e64f07168E782f839d0f296aE6bc488Fdb45049)
 */
export const writeEmissionManagerSetRewardOracle =
  /*#__PURE__*/ createWriteContract({
    abi: emissionManagerAbi,
    address: emissionManagerAddress,
    functionName: 'setRewardOracle',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link emissionManagerAbi}__ and `functionName` set to `"setRewardsController"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x75A562F96c538cA6d7f6603b7b7B1d22eFd46fa7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9e64f07168E782f839d0f296aE6bc488Fdb45049)
 */
export const writeEmissionManagerSetRewardsController =
  /*#__PURE__*/ createWriteContract({
    abi: emissionManagerAbi,
    address: emissionManagerAddress,
    functionName: 'setRewardsController',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link emissionManagerAbi}__ and `functionName` set to `"setTransferStrategy"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x75A562F96c538cA6d7f6603b7b7B1d22eFd46fa7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9e64f07168E782f839d0f296aE6bc488Fdb45049)
 */
export const writeEmissionManagerSetTransferStrategy =
  /*#__PURE__*/ createWriteContract({
    abi: emissionManagerAbi,
    address: emissionManagerAddress,
    functionName: 'setTransferStrategy',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link emissionManagerAbi}__ and `functionName` set to `"transferOwnership"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x75A562F96c538cA6d7f6603b7b7B1d22eFd46fa7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9e64f07168E782f839d0f296aE6bc488Fdb45049)
 */
export const writeEmissionManagerTransferOwnership =
  /*#__PURE__*/ createWriteContract({
    abi: emissionManagerAbi,
    address: emissionManagerAddress,
    functionName: 'transferOwnership',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link emissionManagerAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x75A562F96c538cA6d7f6603b7b7B1d22eFd46fa7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9e64f07168E782f839d0f296aE6bc488Fdb45049)
 */
export const simulateEmissionManager = /*#__PURE__*/ createSimulateContract({
  abi: emissionManagerAbi,
  address: emissionManagerAddress,
})

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link emissionManagerAbi}__ and `functionName` set to `"configureAssets"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x75A562F96c538cA6d7f6603b7b7B1d22eFd46fa7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9e64f07168E782f839d0f296aE6bc488Fdb45049)
 */
export const simulateEmissionManagerConfigureAssets =
  /*#__PURE__*/ createSimulateContract({
    abi: emissionManagerAbi,
    address: emissionManagerAddress,
    functionName: 'configureAssets',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link emissionManagerAbi}__ and `functionName` set to `"renounceOwnership"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x75A562F96c538cA6d7f6603b7b7B1d22eFd46fa7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9e64f07168E782f839d0f296aE6bc488Fdb45049)
 */
export const simulateEmissionManagerRenounceOwnership =
  /*#__PURE__*/ createSimulateContract({
    abi: emissionManagerAbi,
    address: emissionManagerAddress,
    functionName: 'renounceOwnership',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link emissionManagerAbi}__ and `functionName` set to `"setClaimer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x75A562F96c538cA6d7f6603b7b7B1d22eFd46fa7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9e64f07168E782f839d0f296aE6bc488Fdb45049)
 */
export const simulateEmissionManagerSetClaimer =
  /*#__PURE__*/ createSimulateContract({
    abi: emissionManagerAbi,
    address: emissionManagerAddress,
    functionName: 'setClaimer',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link emissionManagerAbi}__ and `functionName` set to `"setDistributionEnd"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x75A562F96c538cA6d7f6603b7b7B1d22eFd46fa7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9e64f07168E782f839d0f296aE6bc488Fdb45049)
 */
export const simulateEmissionManagerSetDistributionEnd =
  /*#__PURE__*/ createSimulateContract({
    abi: emissionManagerAbi,
    address: emissionManagerAddress,
    functionName: 'setDistributionEnd',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link emissionManagerAbi}__ and `functionName` set to `"setEmissionAdmin"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x75A562F96c538cA6d7f6603b7b7B1d22eFd46fa7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9e64f07168E782f839d0f296aE6bc488Fdb45049)
 */
export const simulateEmissionManagerSetEmissionAdmin =
  /*#__PURE__*/ createSimulateContract({
    abi: emissionManagerAbi,
    address: emissionManagerAddress,
    functionName: 'setEmissionAdmin',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link emissionManagerAbi}__ and `functionName` set to `"setEmissionPerSecond"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x75A562F96c538cA6d7f6603b7b7B1d22eFd46fa7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9e64f07168E782f839d0f296aE6bc488Fdb45049)
 */
export const simulateEmissionManagerSetEmissionPerSecond =
  /*#__PURE__*/ createSimulateContract({
    abi: emissionManagerAbi,
    address: emissionManagerAddress,
    functionName: 'setEmissionPerSecond',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link emissionManagerAbi}__ and `functionName` set to `"setRewardOracle"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x75A562F96c538cA6d7f6603b7b7B1d22eFd46fa7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9e64f07168E782f839d0f296aE6bc488Fdb45049)
 */
export const simulateEmissionManagerSetRewardOracle =
  /*#__PURE__*/ createSimulateContract({
    abi: emissionManagerAbi,
    address: emissionManagerAddress,
    functionName: 'setRewardOracle',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link emissionManagerAbi}__ and `functionName` set to `"setRewardsController"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x75A562F96c538cA6d7f6603b7b7B1d22eFd46fa7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9e64f07168E782f839d0f296aE6bc488Fdb45049)
 */
export const simulateEmissionManagerSetRewardsController =
  /*#__PURE__*/ createSimulateContract({
    abi: emissionManagerAbi,
    address: emissionManagerAddress,
    functionName: 'setRewardsController',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link emissionManagerAbi}__ and `functionName` set to `"setTransferStrategy"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x75A562F96c538cA6d7f6603b7b7B1d22eFd46fa7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9e64f07168E782f839d0f296aE6bc488Fdb45049)
 */
export const simulateEmissionManagerSetTransferStrategy =
  /*#__PURE__*/ createSimulateContract({
    abi: emissionManagerAbi,
    address: emissionManagerAddress,
    functionName: 'setTransferStrategy',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link emissionManagerAbi}__ and `functionName` set to `"transferOwnership"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x75A562F96c538cA6d7f6603b7b7B1d22eFd46fa7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9e64f07168E782f839d0f296aE6bc488Fdb45049)
 */
export const simulateEmissionManagerTransferOwnership =
  /*#__PURE__*/ createSimulateContract({
    abi: emissionManagerAbi,
    address: emissionManagerAddress,
    functionName: 'transferOwnership',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link emissionManagerAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x75A562F96c538cA6d7f6603b7b7B1d22eFd46fa7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9e64f07168E782f839d0f296aE6bc488Fdb45049)
 */
export const watchEmissionManagerEvent = /*#__PURE__*/ createWatchContractEvent(
  { abi: emissionManagerAbi, address: emissionManagerAddress },
)

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link emissionManagerAbi}__ and `eventName` set to `"EmissionAdminUpdated"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x75A562F96c538cA6d7f6603b7b7B1d22eFd46fa7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9e64f07168E782f839d0f296aE6bc488Fdb45049)
 */
export const watchEmissionManagerEmissionAdminUpdatedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: emissionManagerAbi,
    address: emissionManagerAddress,
    eventName: 'EmissionAdminUpdated',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link emissionManagerAbi}__ and `eventName` set to `"OwnershipTransferred"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x75A562F96c538cA6d7f6603b7b7B1d22eFd46fa7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9e64f07168E782f839d0f296aE6bc488Fdb45049)
 */
export const watchEmissionManagerOwnershipTransferredEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: emissionManagerAbi,
    address: emissionManagerAddress,
    eventName: 'OwnershipTransferred',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link faucetTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x98c168B8677bf4A36f75169D22E8E3DfadDC2310)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4726A3aC8A62f8f58b3294E2D8f100E8123fFcbf)
 */
export const readFaucetTaiko = /*#__PURE__*/ createReadContract({
  abi: faucetTaikoAbi,
  address: faucetTaikoAddress,
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link faucetTaikoAbi}__ and `functionName` set to `"TTKOK"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x98c168B8677bf4A36f75169D22E8E3DfadDC2310)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4726A3aC8A62f8f58b3294E2D8f100E8123fFcbf)
 */
export const readFaucetTaikoTtkok = /*#__PURE__*/ createReadContract({
  abi: faucetTaikoAbi,
  address: faucetTaikoAddress,
  functionName: 'TTKOK',
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link faucetTaikoAbi}__ and `functionName` set to `"USDC"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x98c168B8677bf4A36f75169D22E8E3DfadDC2310)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4726A3aC8A62f8f58b3294E2D8f100E8123fFcbf)
 */
export const readFaucetTaikoUsdc = /*#__PURE__*/ createReadContract({
  abi: faucetTaikoAbi,
  address: faucetTaikoAddress,
  functionName: 'USDC',
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link faucetTaikoAbi}__ and `functionName` set to `"USDT"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x98c168B8677bf4A36f75169D22E8E3DfadDC2310)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4726A3aC8A62f8f58b3294E2D8f100E8123fFcbf)
 */
export const readFaucetTaikoUsdt = /*#__PURE__*/ createReadContract({
  abi: faucetTaikoAbi,
  address: faucetTaikoAddress,
  functionName: 'USDT',
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link faucetTaikoAbi}__ and `functionName` set to `"WAIT_TIME"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x98c168B8677bf4A36f75169D22E8E3DfadDC2310)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4726A3aC8A62f8f58b3294E2D8f100E8123fFcbf)
 */
export const readFaucetTaikoWaitTime = /*#__PURE__*/ createReadContract({
  abi: faucetTaikoAbi,
  address: faucetTaikoAddress,
  functionName: 'WAIT_TIME',
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link faucetTaikoAbi}__ and `functionName` set to `"WBTC"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x98c168B8677bf4A36f75169D22E8E3DfadDC2310)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4726A3aC8A62f8f58b3294E2D8f100E8123fFcbf)
 */
export const readFaucetTaikoWbtc = /*#__PURE__*/ createReadContract({
  abi: faucetTaikoAbi,
  address: faucetTaikoAddress,
  functionName: 'WBTC',
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link faucetTaikoAbi}__ and `functionName` set to `"lastDripTime"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x98c168B8677bf4A36f75169D22E8E3DfadDC2310)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4726A3aC8A62f8f58b3294E2D8f100E8123fFcbf)
 */
export const readFaucetTaikoLastDripTime = /*#__PURE__*/ createReadContract({
  abi: faucetTaikoAbi,
  address: faucetTaikoAddress,
  functionName: 'lastDripTime',
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link faucetTaikoAbi}__ and `functionName` set to `"nonceUsed"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x98c168B8677bf4A36f75169D22E8E3DfadDC2310)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4726A3aC8A62f8f58b3294E2D8f100E8123fFcbf)
 */
export const readFaucetTaikoNonceUsed = /*#__PURE__*/ createReadContract({
  abi: faucetTaikoAbi,
  address: faucetTaikoAddress,
  functionName: 'nonceUsed',
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link faucetTaikoAbi}__ and `functionName` set to `"owner"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x98c168B8677bf4A36f75169D22E8E3DfadDC2310)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4726A3aC8A62f8f58b3294E2D8f100E8123fFcbf)
 */
export const readFaucetTaikoOwner = /*#__PURE__*/ createReadContract({
  abi: faucetTaikoAbi,
  address: faucetTaikoAddress,
  functionName: 'owner',
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link faucetTaikoAbi}__ and `functionName` set to `"signerAddress"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x98c168B8677bf4A36f75169D22E8E3DfadDC2310)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4726A3aC8A62f8f58b3294E2D8f100E8123fFcbf)
 */
export const readFaucetTaikoSignerAddress = /*#__PURE__*/ createReadContract({
  abi: faucetTaikoAbi,
  address: faucetTaikoAddress,
  functionName: 'signerAddress',
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link faucetTaikoAbi}__ and `functionName` set to `"totalDrips"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x98c168B8677bf4A36f75169D22E8E3DfadDC2310)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4726A3aC8A62f8f58b3294E2D8f100E8123fFcbf)
 */
export const readFaucetTaikoTotalDrips = /*#__PURE__*/ createReadContract({
  abi: faucetTaikoAbi,
  address: faucetTaikoAddress,
  functionName: 'totalDrips',
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link faucetTaikoAbi}__ and `functionName` set to `"ttkokAmount"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x98c168B8677bf4A36f75169D22E8E3DfadDC2310)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4726A3aC8A62f8f58b3294E2D8f100E8123fFcbf)
 */
export const readFaucetTaikoTtkokAmount = /*#__PURE__*/ createReadContract({
  abi: faucetTaikoAbi,
  address: faucetTaikoAddress,
  functionName: 'ttkokAmount',
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link faucetTaikoAbi}__ and `functionName` set to `"usdcAmount"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x98c168B8677bf4A36f75169D22E8E3DfadDC2310)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4726A3aC8A62f8f58b3294E2D8f100E8123fFcbf)
 */
export const readFaucetTaikoUsdcAmount = /*#__PURE__*/ createReadContract({
  abi: faucetTaikoAbi,
  address: faucetTaikoAddress,
  functionName: 'usdcAmount',
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link faucetTaikoAbi}__ and `functionName` set to `"usdtAmount"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x98c168B8677bf4A36f75169D22E8E3DfadDC2310)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4726A3aC8A62f8f58b3294E2D8f100E8123fFcbf)
 */
export const readFaucetTaikoUsdtAmount = /*#__PURE__*/ createReadContract({
  abi: faucetTaikoAbi,
  address: faucetTaikoAddress,
  functionName: 'usdtAmount',
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link faucetTaikoAbi}__ and `functionName` set to `"wbtcAmount"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x98c168B8677bf4A36f75169D22E8E3DfadDC2310)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4726A3aC8A62f8f58b3294E2D8f100E8123fFcbf)
 */
export const readFaucetTaikoWbtcAmount = /*#__PURE__*/ createReadContract({
  abi: faucetTaikoAbi,
  address: faucetTaikoAddress,
  functionName: 'wbtcAmount',
})

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link faucetTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x98c168B8677bf4A36f75169D22E8E3DfadDC2310)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4726A3aC8A62f8f58b3294E2D8f100E8123fFcbf)
 */
export const writeFaucetTaiko = /*#__PURE__*/ createWriteContract({
  abi: faucetTaikoAbi,
  address: faucetTaikoAddress,
})

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link faucetTaikoAbi}__ and `functionName` set to `"drip"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x98c168B8677bf4A36f75169D22E8E3DfadDC2310)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4726A3aC8A62f8f58b3294E2D8f100E8123fFcbf)
 */
export const writeFaucetTaikoDrip = /*#__PURE__*/ createWriteContract({
  abi: faucetTaikoAbi,
  address: faucetTaikoAddress,
  functionName: 'drip',
})

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link faucetTaikoAbi}__ and `functionName` set to `"dripWithTko"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x98c168B8677bf4A36f75169D22E8E3DfadDC2310)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4726A3aC8A62f8f58b3294E2D8f100E8123fFcbf)
 */
export const writeFaucetTaikoDripWithTko = /*#__PURE__*/ createWriteContract({
  abi: faucetTaikoAbi,
  address: faucetTaikoAddress,
  functionName: 'dripWithTko',
})

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link faucetTaikoAbi}__ and `functionName` set to `"emergencyWithdraw"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x98c168B8677bf4A36f75169D22E8E3DfadDC2310)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4726A3aC8A62f8f58b3294E2D8f100E8123fFcbf)
 */
export const writeFaucetTaikoEmergencyWithdraw =
  /*#__PURE__*/ createWriteContract({
    abi: faucetTaikoAbi,
    address: faucetTaikoAddress,
    functionName: 'emergencyWithdraw',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link faucetTaikoAbi}__ and `functionName` set to `"renounceOwnership"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x98c168B8677bf4A36f75169D22E8E3DfadDC2310)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4726A3aC8A62f8f58b3294E2D8f100E8123fFcbf)
 */
export const writeFaucetTaikoRenounceOwnership =
  /*#__PURE__*/ createWriteContract({
    abi: faucetTaikoAbi,
    address: faucetTaikoAddress,
    functionName: 'renounceOwnership',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link faucetTaikoAbi}__ and `functionName` set to `"setDripAmounts"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x98c168B8677bf4A36f75169D22E8E3DfadDC2310)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4726A3aC8A62f8f58b3294E2D8f100E8123fFcbf)
 */
export const writeFaucetTaikoSetDripAmounts = /*#__PURE__*/ createWriteContract(
  {
    abi: faucetTaikoAbi,
    address: faucetTaikoAddress,
    functionName: 'setDripAmounts',
  },
)

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link faucetTaikoAbi}__ and `functionName` set to `"setTokenAddresses"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x98c168B8677bf4A36f75169D22E8E3DfadDC2310)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4726A3aC8A62f8f58b3294E2D8f100E8123fFcbf)
 */
export const writeFaucetTaikoSetTokenAddresses =
  /*#__PURE__*/ createWriteContract({
    abi: faucetTaikoAbi,
    address: faucetTaikoAddress,
    functionName: 'setTokenAddresses',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link faucetTaikoAbi}__ and `functionName` set to `"transferOwnership"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x98c168B8677bf4A36f75169D22E8E3DfadDC2310)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4726A3aC8A62f8f58b3294E2D8f100E8123fFcbf)
 */
export const writeFaucetTaikoTransferOwnership =
  /*#__PURE__*/ createWriteContract({
    abi: faucetTaikoAbi,
    address: faucetTaikoAddress,
    functionName: 'transferOwnership',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link faucetTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x98c168B8677bf4A36f75169D22E8E3DfadDC2310)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4726A3aC8A62f8f58b3294E2D8f100E8123fFcbf)
 */
export const simulateFaucetTaiko = /*#__PURE__*/ createSimulateContract({
  abi: faucetTaikoAbi,
  address: faucetTaikoAddress,
})

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link faucetTaikoAbi}__ and `functionName` set to `"drip"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x98c168B8677bf4A36f75169D22E8E3DfadDC2310)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4726A3aC8A62f8f58b3294E2D8f100E8123fFcbf)
 */
export const simulateFaucetTaikoDrip = /*#__PURE__*/ createSimulateContract({
  abi: faucetTaikoAbi,
  address: faucetTaikoAddress,
  functionName: 'drip',
})

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link faucetTaikoAbi}__ and `functionName` set to `"dripWithTko"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x98c168B8677bf4A36f75169D22E8E3DfadDC2310)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4726A3aC8A62f8f58b3294E2D8f100E8123fFcbf)
 */
export const simulateFaucetTaikoDripWithTko =
  /*#__PURE__*/ createSimulateContract({
    abi: faucetTaikoAbi,
    address: faucetTaikoAddress,
    functionName: 'dripWithTko',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link faucetTaikoAbi}__ and `functionName` set to `"emergencyWithdraw"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x98c168B8677bf4A36f75169D22E8E3DfadDC2310)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4726A3aC8A62f8f58b3294E2D8f100E8123fFcbf)
 */
export const simulateFaucetTaikoEmergencyWithdraw =
  /*#__PURE__*/ createSimulateContract({
    abi: faucetTaikoAbi,
    address: faucetTaikoAddress,
    functionName: 'emergencyWithdraw',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link faucetTaikoAbi}__ and `functionName` set to `"renounceOwnership"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x98c168B8677bf4A36f75169D22E8E3DfadDC2310)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4726A3aC8A62f8f58b3294E2D8f100E8123fFcbf)
 */
export const simulateFaucetTaikoRenounceOwnership =
  /*#__PURE__*/ createSimulateContract({
    abi: faucetTaikoAbi,
    address: faucetTaikoAddress,
    functionName: 'renounceOwnership',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link faucetTaikoAbi}__ and `functionName` set to `"setDripAmounts"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x98c168B8677bf4A36f75169D22E8E3DfadDC2310)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4726A3aC8A62f8f58b3294E2D8f100E8123fFcbf)
 */
export const simulateFaucetTaikoSetDripAmounts =
  /*#__PURE__*/ createSimulateContract({
    abi: faucetTaikoAbi,
    address: faucetTaikoAddress,
    functionName: 'setDripAmounts',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link faucetTaikoAbi}__ and `functionName` set to `"setTokenAddresses"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x98c168B8677bf4A36f75169D22E8E3DfadDC2310)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4726A3aC8A62f8f58b3294E2D8f100E8123fFcbf)
 */
export const simulateFaucetTaikoSetTokenAddresses =
  /*#__PURE__*/ createSimulateContract({
    abi: faucetTaikoAbi,
    address: faucetTaikoAddress,
    functionName: 'setTokenAddresses',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link faucetTaikoAbi}__ and `functionName` set to `"transferOwnership"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x98c168B8677bf4A36f75169D22E8E3DfadDC2310)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4726A3aC8A62f8f58b3294E2D8f100E8123fFcbf)
 */
export const simulateFaucetTaikoTransferOwnership =
  /*#__PURE__*/ createSimulateContract({
    abi: faucetTaikoAbi,
    address: faucetTaikoAddress,
    functionName: 'transferOwnership',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link faucetTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x98c168B8677bf4A36f75169D22E8E3DfadDC2310)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4726A3aC8A62f8f58b3294E2D8f100E8123fFcbf)
 */
export const watchFaucetTaikoEvent = /*#__PURE__*/ createWatchContractEvent({
  abi: faucetTaikoAbi,
  address: faucetTaikoAddress,
})

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link faucetTaikoAbi}__ and `eventName` set to `"OwnershipTransferred"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x98c168B8677bf4A36f75169D22E8E3DfadDC2310)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4726A3aC8A62f8f58b3294E2D8f100E8123fFcbf)
 */
export const watchFaucetTaikoOwnershipTransferredEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: faucetTaikoAbi,
    address: faucetTaikoAddress,
    eventName: 'OwnershipTransferred',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link flashLoanLogicAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x2ac33f53aB4e8AD624791CE698AE038fCD169000)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xCdeB8671fE2d5fC7c8d09C0824668D2063e253b2)
 */
export const watchFlashLoanLogicEvent = /*#__PURE__*/ createWatchContractEvent({
  abi: flashLoanLogicAbi,
  address: flashLoanLogicAddress,
})

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link flashLoanLogicAbi}__ and `eventName` set to `"FlashLoan"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x2ac33f53aB4e8AD624791CE698AE038fCD169000)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xCdeB8671fE2d5fC7c8d09C0824668D2063e253b2)
 */
export const watchFlashLoanLogicFlashLoanEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: flashLoanLogicAbi,
    address: flashLoanLogicAddress,
    eventName: 'FlashLoan',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link flashLoanLogicAbi}__ and `eventName` set to `"ReserveDataUpdated"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x2ac33f53aB4e8AD624791CE698AE038fCD169000)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xCdeB8671fE2d5fC7c8d09C0824668D2063e253b2)
 */
export const watchFlashLoanLogicReserveDataUpdatedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: flashLoanLogicAbi,
    address: flashLoanLogicAddress,
    eventName: 'ReserveDataUpdated',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link hanaTestnetMintableErc20RewardTaikoAbi}__
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7f4DEc9C71Cdb4b8b731dec592153B7f39049870)
 */
export const readHanaTestnetMintableErc20RewardTaiko =
  /*#__PURE__*/ createReadContract({
    abi: hanaTestnetMintableErc20RewardTaikoAbi,
    address: hanaTestnetMintableErc20RewardTaikoAddress,
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link hanaTestnetMintableErc20RewardTaikoAbi}__ and `functionName` set to `"allowance"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7f4DEc9C71Cdb4b8b731dec592153B7f39049870)
 */
export const readHanaTestnetMintableErc20RewardTaikoAllowance =
  /*#__PURE__*/ createReadContract({
    abi: hanaTestnetMintableErc20RewardTaikoAbi,
    address: hanaTestnetMintableErc20RewardTaikoAddress,
    functionName: 'allowance',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link hanaTestnetMintableErc20RewardTaikoAbi}__ and `functionName` set to `"balanceOf"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7f4DEc9C71Cdb4b8b731dec592153B7f39049870)
 */
export const readHanaTestnetMintableErc20RewardTaikoBalanceOf =
  /*#__PURE__*/ createReadContract({
    abi: hanaTestnetMintableErc20RewardTaikoAbi,
    address: hanaTestnetMintableErc20RewardTaikoAddress,
    functionName: 'balanceOf',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link hanaTestnetMintableErc20RewardTaikoAbi}__ and `functionName` set to `"decimals"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7f4DEc9C71Cdb4b8b731dec592153B7f39049870)
 */
export const readHanaTestnetMintableErc20RewardTaikoDecimals =
  /*#__PURE__*/ createReadContract({
    abi: hanaTestnetMintableErc20RewardTaikoAbi,
    address: hanaTestnetMintableErc20RewardTaikoAddress,
    functionName: 'decimals',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link hanaTestnetMintableErc20RewardTaikoAbi}__ and `functionName` set to `"name"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7f4DEc9C71Cdb4b8b731dec592153B7f39049870)
 */
export const readHanaTestnetMintableErc20RewardTaikoName =
  /*#__PURE__*/ createReadContract({
    abi: hanaTestnetMintableErc20RewardTaikoAbi,
    address: hanaTestnetMintableErc20RewardTaikoAddress,
    functionName: 'name',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link hanaTestnetMintableErc20RewardTaikoAbi}__ and `functionName` set to `"symbol"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7f4DEc9C71Cdb4b8b731dec592153B7f39049870)
 */
export const readHanaTestnetMintableErc20RewardTaikoSymbol =
  /*#__PURE__*/ createReadContract({
    abi: hanaTestnetMintableErc20RewardTaikoAbi,
    address: hanaTestnetMintableErc20RewardTaikoAddress,
    functionName: 'symbol',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link hanaTestnetMintableErc20RewardTaikoAbi}__ and `functionName` set to `"tokenDecimals"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7f4DEc9C71Cdb4b8b731dec592153B7f39049870)
 */
export const readHanaTestnetMintableErc20RewardTaikoTokenDecimals =
  /*#__PURE__*/ createReadContract({
    abi: hanaTestnetMintableErc20RewardTaikoAbi,
    address: hanaTestnetMintableErc20RewardTaikoAddress,
    functionName: 'tokenDecimals',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link hanaTestnetMintableErc20RewardTaikoAbi}__ and `functionName` set to `"totalSupply"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7f4DEc9C71Cdb4b8b731dec592153B7f39049870)
 */
export const readHanaTestnetMintableErc20RewardTaikoTotalSupply =
  /*#__PURE__*/ createReadContract({
    abi: hanaTestnetMintableErc20RewardTaikoAbi,
    address: hanaTestnetMintableErc20RewardTaikoAddress,
    functionName: 'totalSupply',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link hanaTestnetMintableErc20RewardTaikoAbi}__
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7f4DEc9C71Cdb4b8b731dec592153B7f39049870)
 */
export const writeHanaTestnetMintableErc20RewardTaiko =
  /*#__PURE__*/ createWriteContract({
    abi: hanaTestnetMintableErc20RewardTaikoAbi,
    address: hanaTestnetMintableErc20RewardTaikoAddress,
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link hanaTestnetMintableErc20RewardTaikoAbi}__ and `functionName` set to `"approve"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7f4DEc9C71Cdb4b8b731dec592153B7f39049870)
 */
export const writeHanaTestnetMintableErc20RewardTaikoApprove =
  /*#__PURE__*/ createWriteContract({
    abi: hanaTestnetMintableErc20RewardTaikoAbi,
    address: hanaTestnetMintableErc20RewardTaikoAddress,
    functionName: 'approve',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link hanaTestnetMintableErc20RewardTaikoAbi}__ and `functionName` set to `"decreaseAllowance"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7f4DEc9C71Cdb4b8b731dec592153B7f39049870)
 */
export const writeHanaTestnetMintableErc20RewardTaikoDecreaseAllowance =
  /*#__PURE__*/ createWriteContract({
    abi: hanaTestnetMintableErc20RewardTaikoAbi,
    address: hanaTestnetMintableErc20RewardTaikoAddress,
    functionName: 'decreaseAllowance',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link hanaTestnetMintableErc20RewardTaikoAbi}__ and `functionName` set to `"increaseAllowance"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7f4DEc9C71Cdb4b8b731dec592153B7f39049870)
 */
export const writeHanaTestnetMintableErc20RewardTaikoIncreaseAllowance =
  /*#__PURE__*/ createWriteContract({
    abi: hanaTestnetMintableErc20RewardTaikoAbi,
    address: hanaTestnetMintableErc20RewardTaikoAddress,
    functionName: 'increaseAllowance',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link hanaTestnetMintableErc20RewardTaikoAbi}__ and `functionName` set to `"transfer"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7f4DEc9C71Cdb4b8b731dec592153B7f39049870)
 */
export const writeHanaTestnetMintableErc20RewardTaikoTransfer =
  /*#__PURE__*/ createWriteContract({
    abi: hanaTestnetMintableErc20RewardTaikoAbi,
    address: hanaTestnetMintableErc20RewardTaikoAddress,
    functionName: 'transfer',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link hanaTestnetMintableErc20RewardTaikoAbi}__ and `functionName` set to `"transferFrom"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7f4DEc9C71Cdb4b8b731dec592153B7f39049870)
 */
export const writeHanaTestnetMintableErc20RewardTaikoTransferFrom =
  /*#__PURE__*/ createWriteContract({
    abi: hanaTestnetMintableErc20RewardTaikoAbi,
    address: hanaTestnetMintableErc20RewardTaikoAddress,
    functionName: 'transferFrom',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link hanaTestnetMintableErc20RewardTaikoAbi}__
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7f4DEc9C71Cdb4b8b731dec592153B7f39049870)
 */
export const simulateHanaTestnetMintableErc20RewardTaiko =
  /*#__PURE__*/ createSimulateContract({
    abi: hanaTestnetMintableErc20RewardTaikoAbi,
    address: hanaTestnetMintableErc20RewardTaikoAddress,
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link hanaTestnetMintableErc20RewardTaikoAbi}__ and `functionName` set to `"approve"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7f4DEc9C71Cdb4b8b731dec592153B7f39049870)
 */
export const simulateHanaTestnetMintableErc20RewardTaikoApprove =
  /*#__PURE__*/ createSimulateContract({
    abi: hanaTestnetMintableErc20RewardTaikoAbi,
    address: hanaTestnetMintableErc20RewardTaikoAddress,
    functionName: 'approve',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link hanaTestnetMintableErc20RewardTaikoAbi}__ and `functionName` set to `"decreaseAllowance"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7f4DEc9C71Cdb4b8b731dec592153B7f39049870)
 */
export const simulateHanaTestnetMintableErc20RewardTaikoDecreaseAllowance =
  /*#__PURE__*/ createSimulateContract({
    abi: hanaTestnetMintableErc20RewardTaikoAbi,
    address: hanaTestnetMintableErc20RewardTaikoAddress,
    functionName: 'decreaseAllowance',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link hanaTestnetMintableErc20RewardTaikoAbi}__ and `functionName` set to `"increaseAllowance"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7f4DEc9C71Cdb4b8b731dec592153B7f39049870)
 */
export const simulateHanaTestnetMintableErc20RewardTaikoIncreaseAllowance =
  /*#__PURE__*/ createSimulateContract({
    abi: hanaTestnetMintableErc20RewardTaikoAbi,
    address: hanaTestnetMintableErc20RewardTaikoAddress,
    functionName: 'increaseAllowance',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link hanaTestnetMintableErc20RewardTaikoAbi}__ and `functionName` set to `"transfer"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7f4DEc9C71Cdb4b8b731dec592153B7f39049870)
 */
export const simulateHanaTestnetMintableErc20RewardTaikoTransfer =
  /*#__PURE__*/ createSimulateContract({
    abi: hanaTestnetMintableErc20RewardTaikoAbi,
    address: hanaTestnetMintableErc20RewardTaikoAddress,
    functionName: 'transfer',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link hanaTestnetMintableErc20RewardTaikoAbi}__ and `functionName` set to `"transferFrom"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7f4DEc9C71Cdb4b8b731dec592153B7f39049870)
 */
export const simulateHanaTestnetMintableErc20RewardTaikoTransferFrom =
  /*#__PURE__*/ createSimulateContract({
    abi: hanaTestnetMintableErc20RewardTaikoAbi,
    address: hanaTestnetMintableErc20RewardTaikoAddress,
    functionName: 'transferFrom',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link hanaTestnetMintableErc20RewardTaikoAbi}__
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7f4DEc9C71Cdb4b8b731dec592153B7f39049870)
 */
export const watchHanaTestnetMintableErc20RewardTaikoEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: hanaTestnetMintableErc20RewardTaikoAbi,
    address: hanaTestnetMintableErc20RewardTaikoAddress,
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link hanaTestnetMintableErc20RewardTaikoAbi}__ and `eventName` set to `"Approval"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7f4DEc9C71Cdb4b8b731dec592153B7f39049870)
 */
export const watchHanaTestnetMintableErc20RewardTaikoApprovalEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: hanaTestnetMintableErc20RewardTaikoAbi,
    address: hanaTestnetMintableErc20RewardTaikoAddress,
    eventName: 'Approval',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link hanaTestnetMintableErc20RewardTaikoAbi}__ and `eventName` set to `"Transfer"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7f4DEc9C71Cdb4b8b731dec592153B7f39049870)
 */
export const watchHanaTestnetMintableErc20RewardTaikoTransferEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: hanaTestnetMintableErc20RewardTaikoAbi,
    address: hanaTestnetMintableErc20RewardTaikoAddress,
    eventName: 'Transfer',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link hanaTestnetPriceAggregatorTaikoAbi}__
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xe3473c9c941c6B0a4F9EC9101CD0d3338a2620B8)
 */
export const readHanaTestnetPriceAggregatorTaiko =
  /*#__PURE__*/ createReadContract({
    abi: hanaTestnetPriceAggregatorTaikoAbi,
    address: hanaTestnetPriceAggregatorTaikoAddress,
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link hanaTestnetPriceAggregatorTaikoAbi}__ and `functionName` set to `"decimals"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xe3473c9c941c6B0a4F9EC9101CD0d3338a2620B8)
 */
export const readHanaTestnetPriceAggregatorTaikoDecimals =
  /*#__PURE__*/ createReadContract({
    abi: hanaTestnetPriceAggregatorTaikoAbi,
    address: hanaTestnetPriceAggregatorTaikoAddress,
    functionName: 'decimals',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link hanaTestnetPriceAggregatorTaikoAbi}__ and `functionName` set to `"getTokenType"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xe3473c9c941c6B0a4F9EC9101CD0d3338a2620B8)
 */
export const readHanaTestnetPriceAggregatorTaikoGetTokenType =
  /*#__PURE__*/ createReadContract({
    abi: hanaTestnetPriceAggregatorTaikoAbi,
    address: hanaTestnetPriceAggregatorTaikoAddress,
    functionName: 'getTokenType',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link hanaTestnetPriceAggregatorTaikoAbi}__ and `functionName` set to `"latestAnswer"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xe3473c9c941c6B0a4F9EC9101CD0d3338a2620B8)
 */
export const readHanaTestnetPriceAggregatorTaikoLatestAnswer =
  /*#__PURE__*/ createReadContract({
    abi: hanaTestnetPriceAggregatorTaikoAbi,
    address: hanaTestnetPriceAggregatorTaikoAddress,
    functionName: 'latestAnswer',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link hanaTestnetPriceAggregatorTaikoAbi}__
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xe3473c9c941c6B0a4F9EC9101CD0d3338a2620B8)
 */
export const watchHanaTestnetPriceAggregatorTaikoEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: hanaTestnetPriceAggregatorTaikoAbi,
    address: hanaTestnetPriceAggregatorTaikoAddress,
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link hanaTestnetPriceAggregatorTaikoAbi}__ and `eventName` set to `"AnswerUpdated"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xe3473c9c941c6B0a4F9EC9101CD0d3338a2620B8)
 */
export const watchHanaTestnetPriceAggregatorTaikoAnswerUpdatedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: hanaTestnetPriceAggregatorTaikoAbi,
    address: hanaTestnetPriceAggregatorTaikoAddress,
    eventName: 'AnswerUpdated',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link hanaEacAggregatorProxyAbi}__
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x25e665B12406179565B97eFC17D55438fe83B823)
 */
export const readHanaEacAggregatorProxy = /*#__PURE__*/ createReadContract({
  abi: hanaEacAggregatorProxyAbi,
  address: hanaEacAggregatorProxyAddress,
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link hanaEacAggregatorProxyAbi}__ and `functionName` set to `"decimals"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x25e665B12406179565B97eFC17D55438fe83B823)
 */
export const readHanaEacAggregatorProxyDecimals =
  /*#__PURE__*/ createReadContract({
    abi: hanaEacAggregatorProxyAbi,
    address: hanaEacAggregatorProxyAddress,
    functionName: 'decimals',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link hanaEacAggregatorProxyAbi}__ and `functionName` set to `"getAnswer"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x25e665B12406179565B97eFC17D55438fe83B823)
 */
export const readHanaEacAggregatorProxyGetAnswer =
  /*#__PURE__*/ createReadContract({
    abi: hanaEacAggregatorProxyAbi,
    address: hanaEacAggregatorProxyAddress,
    functionName: 'getAnswer',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link hanaEacAggregatorProxyAbi}__ and `functionName` set to `"getTimestamp"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x25e665B12406179565B97eFC17D55438fe83B823)
 */
export const readHanaEacAggregatorProxyGetTimestamp =
  /*#__PURE__*/ createReadContract({
    abi: hanaEacAggregatorProxyAbi,
    address: hanaEacAggregatorProxyAddress,
    functionName: 'getTimestamp',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link hanaEacAggregatorProxyAbi}__ and `functionName` set to `"latestAnswer"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x25e665B12406179565B97eFC17D55438fe83B823)
 */
export const readHanaEacAggregatorProxyLatestAnswer =
  /*#__PURE__*/ createReadContract({
    abi: hanaEacAggregatorProxyAbi,
    address: hanaEacAggregatorProxyAddress,
    functionName: 'latestAnswer',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link hanaEacAggregatorProxyAbi}__ and `functionName` set to `"latestRound"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x25e665B12406179565B97eFC17D55438fe83B823)
 */
export const readHanaEacAggregatorProxyLatestRound =
  /*#__PURE__*/ createReadContract({
    abi: hanaEacAggregatorProxyAbi,
    address: hanaEacAggregatorProxyAddress,
    functionName: 'latestRound',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link hanaEacAggregatorProxyAbi}__ and `functionName` set to `"latestTimestamp"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x25e665B12406179565B97eFC17D55438fe83B823)
 */
export const readHanaEacAggregatorProxyLatestTimestamp =
  /*#__PURE__*/ createReadContract({
    abi: hanaEacAggregatorProxyAbi,
    address: hanaEacAggregatorProxyAddress,
    functionName: 'latestTimestamp',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link hanaEacAggregatorProxyAbi}__ and `functionName` set to `"oracle"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x25e665B12406179565B97eFC17D55438fe83B823)
 */
export const readHanaEacAggregatorProxyOracle =
  /*#__PURE__*/ createReadContract({
    abi: hanaEacAggregatorProxyAbi,
    address: hanaEacAggregatorProxyAddress,
    functionName: 'oracle',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link hanaEacAggregatorProxyAbi}__ and `functionName` set to `"reserveAddress"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x25e665B12406179565B97eFC17D55438fe83B823)
 */
export const readHanaEacAggregatorProxyReserveAddress =
  /*#__PURE__*/ createReadContract({
    abi: hanaEacAggregatorProxyAbi,
    address: hanaEacAggregatorProxyAddress,
    functionName: 'reserveAddress',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link hanaEacAggregatorProxyAbi}__
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x25e665B12406179565B97eFC17D55438fe83B823)
 */
export const watchHanaEacAggregatorProxyEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: hanaEacAggregatorProxyAbi,
    address: hanaEacAggregatorProxyAddress,
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link hanaEacAggregatorProxyAbi}__ and `eventName` set to `"AnswerUpdated"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x25e665B12406179565B97eFC17D55438fe83B823)
 */
export const watchHanaEacAggregatorProxyAnswerUpdatedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: hanaEacAggregatorProxyAbi,
    address: hanaEacAggregatorProxyAddress,
    eventName: 'AnswerUpdated',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link hanaEacAggregatorProxyAbi}__ and `eventName` set to `"NewRound"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x25e665B12406179565B97eFC17D55438fe83B823)
 */
export const watchHanaEacAggregatorProxyNewRoundEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: hanaEacAggregatorProxyAbi,
    address: hanaEacAggregatorProxyAddress,
    eventName: 'NewRound',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link hanaFallbackOracleTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xCaf827bA6B7f19487b04521F91A5890af7750E8c)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x604C6Db3cC11bBAef98F967496Ee10916c00E778)
 */
export const readHanaFallbackOracleTaiko = /*#__PURE__*/ createReadContract({
  abi: hanaFallbackOracleTaikoAbi,
  address: hanaFallbackOracleTaikoAddress,
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link hanaFallbackOracleTaikoAbi}__ and `functionName` set to `"BASE_CURRENCY"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xCaf827bA6B7f19487b04521F91A5890af7750E8c)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x604C6Db3cC11bBAef98F967496Ee10916c00E778)
 */
export const readHanaFallbackOracleTaikoBaseCurrency =
  /*#__PURE__*/ createReadContract({
    abi: hanaFallbackOracleTaikoAbi,
    address: hanaFallbackOracleTaikoAddress,
    functionName: 'BASE_CURRENCY',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link hanaFallbackOracleTaikoAbi}__ and `functionName` set to `"BASE_CURRENCY_UNIT"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xCaf827bA6B7f19487b04521F91A5890af7750E8c)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x604C6Db3cC11bBAef98F967496Ee10916c00E778)
 */
export const readHanaFallbackOracleTaikoBaseCurrencyUnit =
  /*#__PURE__*/ createReadContract({
    abi: hanaFallbackOracleTaikoAbi,
    address: hanaFallbackOracleTaikoAddress,
    functionName: 'BASE_CURRENCY_UNIT',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link hanaFallbackOracleTaikoAbi}__ and `functionName` set to `"assetToId"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xCaf827bA6B7f19487b04521F91A5890af7750E8c)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x604C6Db3cC11bBAef98F967496Ee10916c00E778)
 */
export const readHanaFallbackOracleTaikoAssetToId =
  /*#__PURE__*/ createReadContract({
    abi: hanaFallbackOracleTaikoAbi,
    address: hanaFallbackOracleTaikoAddress,
    functionName: 'assetToId',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link hanaFallbackOracleTaikoAbi}__ and `functionName` set to `"forceHanaOracle"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xCaf827bA6B7f19487b04521F91A5890af7750E8c)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x604C6Db3cC11bBAef98F967496Ee10916c00E778)
 */
export const readHanaFallbackOracleTaikoForceHanaOracle =
  /*#__PURE__*/ createReadContract({
    abi: hanaFallbackOracleTaikoAbi,
    address: hanaFallbackOracleTaikoAddress,
    functionName: 'forceHanaOracle',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link hanaFallbackOracleTaikoAbi}__ and `functionName` set to `"getAssetPrice"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xCaf827bA6B7f19487b04521F91A5890af7750E8c)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x604C6Db3cC11bBAef98F967496Ee10916c00E778)
 */
export const readHanaFallbackOracleTaikoGetAssetPrice =
  /*#__PURE__*/ createReadContract({
    abi: hanaFallbackOracleTaikoAbi,
    address: hanaFallbackOracleTaikoAddress,
    functionName: 'getAssetPrice',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link hanaFallbackOracleTaikoAbi}__ and `functionName` set to `"getDerivedSvalue"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xCaf827bA6B7f19487b04521F91A5890af7750E8c)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x604C6Db3cC11bBAef98F967496Ee10916c00E778)
 */
export const readHanaFallbackOracleTaikoGetDerivedSvalue =
  /*#__PURE__*/ createReadContract({
    abi: hanaFallbackOracleTaikoAbi,
    address: hanaFallbackOracleTaikoAddress,
    functionName: 'getDerivedSvalue',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link hanaFallbackOracleTaikoAbi}__ and `functionName` set to `"getDerivedValueOfPair"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xCaf827bA6B7f19487b04521F91A5890af7750E8c)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x604C6Db3cC11bBAef98F967496Ee10916c00E778)
 */
export const readHanaFallbackOracleTaikoGetDerivedValueOfPair =
  /*#__PURE__*/ createReadContract({
    abi: hanaFallbackOracleTaikoAbi,
    address: hanaFallbackOracleTaikoAddress,
    functionName: 'getDerivedValueOfPair',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link hanaFallbackOracleTaikoAbi}__ and `functionName` set to `"getPrice"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xCaf827bA6B7f19487b04521F91A5890af7750E8c)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x604C6Db3cC11bBAef98F967496Ee10916c00E778)
 */
export const readHanaFallbackOracleTaikoGetPrice =
  /*#__PURE__*/ createReadContract({
    abi: hanaFallbackOracleTaikoAbi,
    address: hanaFallbackOracleTaikoAddress,
    functionName: 'getPrice',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link hanaFallbackOracleTaikoAbi}__ and `functionName` set to `"getPriceForMultiplePair"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xCaf827bA6B7f19487b04521F91A5890af7750E8c)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x604C6Db3cC11bBAef98F967496Ee10916c00E778)
 */
export const readHanaFallbackOracleTaikoGetPriceForMultiplePair =
  /*#__PURE__*/ createReadContract({
    abi: hanaFallbackOracleTaikoAbi,
    address: hanaFallbackOracleTaikoAddress,
    functionName: 'getPriceForMultiplePair',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link hanaFallbackOracleTaikoAbi}__ and `functionName` set to `"getSvalue"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xCaf827bA6B7f19487b04521F91A5890af7750E8c)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x604C6Db3cC11bBAef98F967496Ee10916c00E778)
 */
export const readHanaFallbackOracleTaikoGetSvalue =
  /*#__PURE__*/ createReadContract({
    abi: hanaFallbackOracleTaikoAbi,
    address: hanaFallbackOracleTaikoAddress,
    functionName: 'getSvalue',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link hanaFallbackOracleTaikoAbi}__ and `functionName` set to `"getSvalues"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xCaf827bA6B7f19487b04521F91A5890af7750E8c)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x604C6Db3cC11bBAef98F967496Ee10916c00E778)
 */
export const readHanaFallbackOracleTaikoGetSvalues =
  /*#__PURE__*/ createReadContract({
    abi: hanaFallbackOracleTaikoAbi,
    address: hanaFallbackOracleTaikoAddress,
    functionName: 'getSvalues',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link hanaFallbackOracleTaikoAbi}__ and `functionName` set to `"getTimestamp"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xCaf827bA6B7f19487b04521F91A5890af7750E8c)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x604C6Db3cC11bBAef98F967496Ee10916c00E778)
 */
export const readHanaFallbackOracleTaikoGetTimestamp =
  /*#__PURE__*/ createReadContract({
    abi: hanaFallbackOracleTaikoAbi,
    address: hanaFallbackOracleTaikoAddress,
    functionName: 'getTimestamp',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link hanaFallbackOracleTaikoAbi}__ and `functionName` set to `"hanaController"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xCaf827bA6B7f19487b04521F91A5890af7750E8c)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x604C6Db3cC11bBAef98F967496Ee10916c00E778)
 */
export const readHanaFallbackOracleTaikoHanaController =
  /*#__PURE__*/ createReadContract({
    abi: hanaFallbackOracleTaikoAbi,
    address: hanaFallbackOracleTaikoAddress,
    functionName: 'hanaController',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link hanaFallbackOracleTaikoAbi}__ and `functionName` set to `"idToPrice"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xCaf827bA6B7f19487b04521F91A5890af7750E8c)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x604C6Db3cC11bBAef98F967496Ee10916c00E778)
 */
export const readHanaFallbackOracleTaikoIdToPrice =
  /*#__PURE__*/ createReadContract({
    abi: hanaFallbackOracleTaikoAbi,
    address: hanaFallbackOracleTaikoAddress,
    functionName: 'idToPrice',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link hanaFallbackOracleTaikoAbi}__ and `functionName` set to `"owner"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xCaf827bA6B7f19487b04521F91A5890af7750E8c)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x604C6Db3cC11bBAef98F967496Ee10916c00E778)
 */
export const readHanaFallbackOracleTaikoOwner =
  /*#__PURE__*/ createReadContract({
    abi: hanaFallbackOracleTaikoAbi,
    address: hanaFallbackOracleTaikoAddress,
    functionName: 'owner',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link hanaFallbackOracleTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xCaf827bA6B7f19487b04521F91A5890af7750E8c)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x604C6Db3cC11bBAef98F967496Ee10916c00E778)
 */
export const writeHanaFallbackOracleTaiko = /*#__PURE__*/ createWriteContract({
  abi: hanaFallbackOracleTaikoAbi,
  address: hanaFallbackOracleTaikoAddress,
})

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link hanaFallbackOracleTaikoAbi}__ and `functionName` set to `"renounceOwnership"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xCaf827bA6B7f19487b04521F91A5890af7750E8c)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x604C6Db3cC11bBAef98F967496Ee10916c00E778)
 */
export const writeHanaFallbackOracleTaikoRenounceOwnership =
  /*#__PURE__*/ createWriteContract({
    abi: hanaFallbackOracleTaikoAbi,
    address: hanaFallbackOracleTaikoAddress,
    functionName: 'renounceOwnership',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link hanaFallbackOracleTaikoAbi}__ and `functionName` set to `"restrictedMultiSetSupraStorage"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xCaf827bA6B7f19487b04521F91A5890af7750E8c)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x604C6Db3cC11bBAef98F967496Ee10916c00E778)
 */
export const writeHanaFallbackOracleTaikoRestrictedMultiSetSupraStorage =
  /*#__PURE__*/ createWriteContract({
    abi: hanaFallbackOracleTaikoAbi,
    address: hanaFallbackOracleTaikoAddress,
    functionName: 'restrictedMultiSetSupraStorage',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link hanaFallbackOracleTaikoAbi}__ and `functionName` set to `"restrictedSetSupraStorage"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xCaf827bA6B7f19487b04521F91A5890af7750E8c)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x604C6Db3cC11bBAef98F967496Ee10916c00E778)
 */
export const writeHanaFallbackOracleTaikoRestrictedSetSupraStorage =
  /*#__PURE__*/ createWriteContract({
    abi: hanaFallbackOracleTaikoAbi,
    address: hanaFallbackOracleTaikoAddress,
    functionName: 'restrictedSetSupraStorage',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link hanaFallbackOracleTaikoAbi}__ and `functionName` set to `"setforceHanaOracle"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xCaf827bA6B7f19487b04521F91A5890af7750E8c)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x604C6Db3cC11bBAef98F967496Ee10916c00E778)
 */
export const writeHanaFallbackOracleTaikoSetforceHanaOracle =
  /*#__PURE__*/ createWriteContract({
    abi: hanaFallbackOracleTaikoAbi,
    address: hanaFallbackOracleTaikoAddress,
    functionName: 'setforceHanaOracle',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link hanaFallbackOracleTaikoAbi}__ and `functionName` set to `"transferOwnership"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xCaf827bA6B7f19487b04521F91A5890af7750E8c)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x604C6Db3cC11bBAef98F967496Ee10916c00E778)
 */
export const writeHanaFallbackOracleTaikoTransferOwnership =
  /*#__PURE__*/ createWriteContract({
    abi: hanaFallbackOracleTaikoAbi,
    address: hanaFallbackOracleTaikoAddress,
    functionName: 'transferOwnership',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link hanaFallbackOracleTaikoAbi}__ and `functionName` set to `"updateSupraSValueFeedVerifier"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xCaf827bA6B7f19487b04521F91A5890af7750E8c)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x604C6Db3cC11bBAef98F967496Ee10916c00E778)
 */
export const writeHanaFallbackOracleTaikoUpdateSupraSValueFeedVerifier =
  /*#__PURE__*/ createWriteContract({
    abi: hanaFallbackOracleTaikoAbi,
    address: hanaFallbackOracleTaikoAddress,
    functionName: 'updateSupraSValueFeedVerifier',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link hanaFallbackOracleTaikoAbi}__ and `functionName` set to `"updateSupraSvalueFeed"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xCaf827bA6B7f19487b04521F91A5890af7750E8c)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x604C6Db3cC11bBAef98F967496Ee10916c00E778)
 */
export const writeHanaFallbackOracleTaikoUpdateSupraSvalueFeed =
  /*#__PURE__*/ createWriteContract({
    abi: hanaFallbackOracleTaikoAbi,
    address: hanaFallbackOracleTaikoAddress,
    functionName: 'updateSupraSvalueFeed',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link hanaFallbackOracleTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xCaf827bA6B7f19487b04521F91A5890af7750E8c)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x604C6Db3cC11bBAef98F967496Ee10916c00E778)
 */
export const simulateHanaFallbackOracleTaiko =
  /*#__PURE__*/ createSimulateContract({
    abi: hanaFallbackOracleTaikoAbi,
    address: hanaFallbackOracleTaikoAddress,
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link hanaFallbackOracleTaikoAbi}__ and `functionName` set to `"renounceOwnership"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xCaf827bA6B7f19487b04521F91A5890af7750E8c)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x604C6Db3cC11bBAef98F967496Ee10916c00E778)
 */
export const simulateHanaFallbackOracleTaikoRenounceOwnership =
  /*#__PURE__*/ createSimulateContract({
    abi: hanaFallbackOracleTaikoAbi,
    address: hanaFallbackOracleTaikoAddress,
    functionName: 'renounceOwnership',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link hanaFallbackOracleTaikoAbi}__ and `functionName` set to `"restrictedMultiSetSupraStorage"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xCaf827bA6B7f19487b04521F91A5890af7750E8c)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x604C6Db3cC11bBAef98F967496Ee10916c00E778)
 */
export const simulateHanaFallbackOracleTaikoRestrictedMultiSetSupraStorage =
  /*#__PURE__*/ createSimulateContract({
    abi: hanaFallbackOracleTaikoAbi,
    address: hanaFallbackOracleTaikoAddress,
    functionName: 'restrictedMultiSetSupraStorage',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link hanaFallbackOracleTaikoAbi}__ and `functionName` set to `"restrictedSetSupraStorage"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xCaf827bA6B7f19487b04521F91A5890af7750E8c)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x604C6Db3cC11bBAef98F967496Ee10916c00E778)
 */
export const simulateHanaFallbackOracleTaikoRestrictedSetSupraStorage =
  /*#__PURE__*/ createSimulateContract({
    abi: hanaFallbackOracleTaikoAbi,
    address: hanaFallbackOracleTaikoAddress,
    functionName: 'restrictedSetSupraStorage',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link hanaFallbackOracleTaikoAbi}__ and `functionName` set to `"setforceHanaOracle"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xCaf827bA6B7f19487b04521F91A5890af7750E8c)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x604C6Db3cC11bBAef98F967496Ee10916c00E778)
 */
export const simulateHanaFallbackOracleTaikoSetforceHanaOracle =
  /*#__PURE__*/ createSimulateContract({
    abi: hanaFallbackOracleTaikoAbi,
    address: hanaFallbackOracleTaikoAddress,
    functionName: 'setforceHanaOracle',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link hanaFallbackOracleTaikoAbi}__ and `functionName` set to `"transferOwnership"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xCaf827bA6B7f19487b04521F91A5890af7750E8c)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x604C6Db3cC11bBAef98F967496Ee10916c00E778)
 */
export const simulateHanaFallbackOracleTaikoTransferOwnership =
  /*#__PURE__*/ createSimulateContract({
    abi: hanaFallbackOracleTaikoAbi,
    address: hanaFallbackOracleTaikoAddress,
    functionName: 'transferOwnership',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link hanaFallbackOracleTaikoAbi}__ and `functionName` set to `"updateSupraSValueFeedVerifier"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xCaf827bA6B7f19487b04521F91A5890af7750E8c)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x604C6Db3cC11bBAef98F967496Ee10916c00E778)
 */
export const simulateHanaFallbackOracleTaikoUpdateSupraSValueFeedVerifier =
  /*#__PURE__*/ createSimulateContract({
    abi: hanaFallbackOracleTaikoAbi,
    address: hanaFallbackOracleTaikoAddress,
    functionName: 'updateSupraSValueFeedVerifier',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link hanaFallbackOracleTaikoAbi}__ and `functionName` set to `"updateSupraSvalueFeed"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xCaf827bA6B7f19487b04521F91A5890af7750E8c)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x604C6Db3cC11bBAef98F967496Ee10916c00E778)
 */
export const simulateHanaFallbackOracleTaikoUpdateSupraSvalueFeed =
  /*#__PURE__*/ createSimulateContract({
    abi: hanaFallbackOracleTaikoAbi,
    address: hanaFallbackOracleTaikoAddress,
    functionName: 'updateSupraSvalueFeed',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link hanaFallbackOracleTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xCaf827bA6B7f19487b04521F91A5890af7750E8c)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x604C6Db3cC11bBAef98F967496Ee10916c00E778)
 */
export const watchHanaFallbackOracleTaikoEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: hanaFallbackOracleTaikoAbi,
    address: hanaFallbackOracleTaikoAddress,
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link hanaFallbackOracleTaikoAbi}__ and `eventName` set to `"HanaControllerUpdated"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xCaf827bA6B7f19487b04521F91A5890af7750E8c)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x604C6Db3cC11bBAef98F967496Ee10916c00E778)
 */
export const watchHanaFallbackOracleTaikoHanaControllerUpdatedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: hanaFallbackOracleTaikoAbi,
    address: hanaFallbackOracleTaikoAddress,
    eventName: 'HanaControllerUpdated',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link hanaFallbackOracleTaikoAbi}__ and `eventName` set to `"OwnershipTransferred"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xCaf827bA6B7f19487b04521F91A5890af7750E8c)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x604C6Db3cC11bBAef98F967496Ee10916c00E778)
 */
export const watchHanaFallbackOracleTaikoOwnershipTransferredEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: hanaFallbackOracleTaikoAbi,
    address: hanaFallbackOracleTaikoAddress,
    eventName: 'OwnershipTransferred',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link hanaFallbackOracleTaikoAbi}__ and `eventName` set to `"SupraPullUpdated"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xCaf827bA6B7f19487b04521F91A5890af7750E8c)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x604C6Db3cC11bBAef98F967496Ee10916c00E778)
 */
export const watchHanaFallbackOracleTaikoSupraPullUpdatedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: hanaFallbackOracleTaikoAbi,
    address: hanaFallbackOracleTaikoAddress,
    eventName: 'SupraPullUpdated',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link henjinBtcAbi}__
 *
 * -
 * - [__View Contract on Taiko Katla Alpha 6 Testnet Blockscout__](https://explorer.katla.taiko.xyz/address/0x55C9FDc6dd65cbb9793B7b3327ec0723e778598E)
 */
export const readHenjinBtc = /*#__PURE__*/ createReadContract({
  abi: henjinBtcAbi,
  address: henjinBtcAddress,
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link henjinBtcAbi}__ and `functionName` set to `"decimals"`
 *
 * -
 * - [__View Contract on Taiko Katla Alpha 6 Testnet Blockscout__](https://explorer.katla.taiko.xyz/address/0x55C9FDc6dd65cbb9793B7b3327ec0723e778598E)
 */
export const readHenjinBtcDecimals = /*#__PURE__*/ createReadContract({
  abi: henjinBtcAbi,
  address: henjinBtcAddress,
  functionName: 'decimals',
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link henjinBtcAbi}__ and `functionName` set to `"name"`
 *
 * -
 * - [__View Contract on Taiko Katla Alpha 6 Testnet Blockscout__](https://explorer.katla.taiko.xyz/address/0x55C9FDc6dd65cbb9793B7b3327ec0723e778598E)
 */
export const readHenjinBtcName = /*#__PURE__*/ createReadContract({
  abi: henjinBtcAbi,
  address: henjinBtcAddress,
  functionName: 'name',
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link henjinBtcAbi}__ and `functionName` set to `"symbol"`
 *
 * -
 * - [__View Contract on Taiko Katla Alpha 6 Testnet Blockscout__](https://explorer.katla.taiko.xyz/address/0x55C9FDc6dd65cbb9793B7b3327ec0723e778598E)
 */
export const readHenjinBtcSymbol = /*#__PURE__*/ createReadContract({
  abi: henjinBtcAbi,
  address: henjinBtcAddress,
  functionName: 'symbol',
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link henjinUsdcAbi}__
 *
 * -
 * - [__View Contract on Taiko Katla Alpha 6 Testnet Blockscout__](https://explorer.katla.taiko.xyz/address/0x367F1F510036fD3feccBfa5eBD162e9dD244E5E8)
 */
export const readHenjinUsdc = /*#__PURE__*/ createReadContract({
  abi: henjinUsdcAbi,
  address: henjinUsdcAddress,
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link henjinUsdcAbi}__ and `functionName` set to `"decimals"`
 *
 * -
 * - [__View Contract on Taiko Katla Alpha 6 Testnet Blockscout__](https://explorer.katla.taiko.xyz/address/0x367F1F510036fD3feccBfa5eBD162e9dD244E5E8)
 */
export const readHenjinUsdcDecimals = /*#__PURE__*/ createReadContract({
  abi: henjinUsdcAbi,
  address: henjinUsdcAddress,
  functionName: 'decimals',
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link henjinUsdcAbi}__ and `functionName` set to `"name"`
 *
 * -
 * - [__View Contract on Taiko Katla Alpha 6 Testnet Blockscout__](https://explorer.katla.taiko.xyz/address/0x367F1F510036fD3feccBfa5eBD162e9dD244E5E8)
 */
export const readHenjinUsdcName = /*#__PURE__*/ createReadContract({
  abi: henjinUsdcAbi,
  address: henjinUsdcAddress,
  functionName: 'name',
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link henjinUsdcAbi}__ and `functionName` set to `"symbol"`
 *
 * -
 * - [__View Contract on Taiko Katla Alpha 6 Testnet Blockscout__](https://explorer.katla.taiko.xyz/address/0x367F1F510036fD3feccBfa5eBD162e9dD244E5E8)
 */
export const readHenjinUsdcSymbol = /*#__PURE__*/ createReadContract({
  abi: henjinUsdcAbi,
  address: henjinUsdcAddress,
  functionName: 'symbol',
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link henjinUsdtAbi}__
 *
 * -
 * - [__View Contract on Taiko Katla Alpha 6 Testnet Blockscout__](https://explorer.katla.taiko.xyz/address/0x80C459d9b36Acb9176C03577d9706E18d40cd193)
 */
export const readHenjinUsdt = /*#__PURE__*/ createReadContract({
  abi: henjinUsdtAbi,
  address: henjinUsdtAddress,
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link henjinUsdtAbi}__ and `functionName` set to `"decimals"`
 *
 * -
 * - [__View Contract on Taiko Katla Alpha 6 Testnet Blockscout__](https://explorer.katla.taiko.xyz/address/0x80C459d9b36Acb9176C03577d9706E18d40cd193)
 */
export const readHenjinUsdtDecimals = /*#__PURE__*/ createReadContract({
  abi: henjinUsdtAbi,
  address: henjinUsdtAddress,
  functionName: 'decimals',
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link henjinUsdtAbi}__ and `functionName` set to `"name"`
 *
 * -
 * - [__View Contract on Taiko Katla Alpha 6 Testnet Blockscout__](https://explorer.katla.taiko.xyz/address/0x80C459d9b36Acb9176C03577d9706E18d40cd193)
 */
export const readHenjinUsdtName = /*#__PURE__*/ createReadContract({
  abi: henjinUsdtAbi,
  address: henjinUsdtAddress,
  functionName: 'name',
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link henjinUsdtAbi}__ and `functionName` set to `"symbol"`
 *
 * -
 * - [__View Contract on Taiko Katla Alpha 6 Testnet Blockscout__](https://explorer.katla.taiko.xyz/address/0x80C459d9b36Acb9176C03577d9706E18d40cd193)
 */
export const readHenjinUsdtSymbol = /*#__PURE__*/ createReadContract({
  abi: henjinUsdtAbi,
  address: henjinUsdtAddress,
  functionName: 'symbol',
})

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link incentivesProxyAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE69A7CFC442770951377ad9Abec9C2264ad873f7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x36c3b7AEFbDec76E0E6C6BFB550af8472B2334B6)
 */
export const writeIncentivesProxy = /*#__PURE__*/ createWriteContract({
  abi: incentivesProxyAbi,
  address: incentivesProxyAddress,
})

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link incentivesProxyAbi}__ and `functionName` set to `"admin"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE69A7CFC442770951377ad9Abec9C2264ad873f7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x36c3b7AEFbDec76E0E6C6BFB550af8472B2334B6)
 */
export const writeIncentivesProxyAdmin = /*#__PURE__*/ createWriteContract({
  abi: incentivesProxyAbi,
  address: incentivesProxyAddress,
  functionName: 'admin',
})

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link incentivesProxyAbi}__ and `functionName` set to `"implementation"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE69A7CFC442770951377ad9Abec9C2264ad873f7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x36c3b7AEFbDec76E0E6C6BFB550af8472B2334B6)
 */
export const writeIncentivesProxyImplementation =
  /*#__PURE__*/ createWriteContract({
    abi: incentivesProxyAbi,
    address: incentivesProxyAddress,
    functionName: 'implementation',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link incentivesProxyAbi}__ and `functionName` set to `"initialize"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE69A7CFC442770951377ad9Abec9C2264ad873f7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x36c3b7AEFbDec76E0E6C6BFB550af8472B2334B6)
 */
export const writeIncentivesProxyInitialize = /*#__PURE__*/ createWriteContract(
  {
    abi: incentivesProxyAbi,
    address: incentivesProxyAddress,
    functionName: 'initialize',
  },
)

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link incentivesProxyAbi}__ and `functionName` set to `"upgradeTo"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE69A7CFC442770951377ad9Abec9C2264ad873f7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x36c3b7AEFbDec76E0E6C6BFB550af8472B2334B6)
 */
export const writeIncentivesProxyUpgradeTo = /*#__PURE__*/ createWriteContract({
  abi: incentivesProxyAbi,
  address: incentivesProxyAddress,
  functionName: 'upgradeTo',
})

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link incentivesProxyAbi}__ and `functionName` set to `"upgradeToAndCall"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE69A7CFC442770951377ad9Abec9C2264ad873f7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x36c3b7AEFbDec76E0E6C6BFB550af8472B2334B6)
 */
export const writeIncentivesProxyUpgradeToAndCall =
  /*#__PURE__*/ createWriteContract({
    abi: incentivesProxyAbi,
    address: incentivesProxyAddress,
    functionName: 'upgradeToAndCall',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link incentivesProxyAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE69A7CFC442770951377ad9Abec9C2264ad873f7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x36c3b7AEFbDec76E0E6C6BFB550af8472B2334B6)
 */
export const simulateIncentivesProxy = /*#__PURE__*/ createSimulateContract({
  abi: incentivesProxyAbi,
  address: incentivesProxyAddress,
})

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link incentivesProxyAbi}__ and `functionName` set to `"admin"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE69A7CFC442770951377ad9Abec9C2264ad873f7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x36c3b7AEFbDec76E0E6C6BFB550af8472B2334B6)
 */
export const simulateIncentivesProxyAdmin =
  /*#__PURE__*/ createSimulateContract({
    abi: incentivesProxyAbi,
    address: incentivesProxyAddress,
    functionName: 'admin',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link incentivesProxyAbi}__ and `functionName` set to `"implementation"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE69A7CFC442770951377ad9Abec9C2264ad873f7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x36c3b7AEFbDec76E0E6C6BFB550af8472B2334B6)
 */
export const simulateIncentivesProxyImplementation =
  /*#__PURE__*/ createSimulateContract({
    abi: incentivesProxyAbi,
    address: incentivesProxyAddress,
    functionName: 'implementation',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link incentivesProxyAbi}__ and `functionName` set to `"initialize"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE69A7CFC442770951377ad9Abec9C2264ad873f7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x36c3b7AEFbDec76E0E6C6BFB550af8472B2334B6)
 */
export const simulateIncentivesProxyInitialize =
  /*#__PURE__*/ createSimulateContract({
    abi: incentivesProxyAbi,
    address: incentivesProxyAddress,
    functionName: 'initialize',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link incentivesProxyAbi}__ and `functionName` set to `"upgradeTo"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE69A7CFC442770951377ad9Abec9C2264ad873f7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x36c3b7AEFbDec76E0E6C6BFB550af8472B2334B6)
 */
export const simulateIncentivesProxyUpgradeTo =
  /*#__PURE__*/ createSimulateContract({
    abi: incentivesProxyAbi,
    address: incentivesProxyAddress,
    functionName: 'upgradeTo',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link incentivesProxyAbi}__ and `functionName` set to `"upgradeToAndCall"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE69A7CFC442770951377ad9Abec9C2264ad873f7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x36c3b7AEFbDec76E0E6C6BFB550af8472B2334B6)
 */
export const simulateIncentivesProxyUpgradeToAndCall =
  /*#__PURE__*/ createSimulateContract({
    abi: incentivesProxyAbi,
    address: incentivesProxyAddress,
    functionName: 'upgradeToAndCall',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link incentivesProxyAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE69A7CFC442770951377ad9Abec9C2264ad873f7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x36c3b7AEFbDec76E0E6C6BFB550af8472B2334B6)
 */
export const watchIncentivesProxyEvent = /*#__PURE__*/ createWatchContractEvent(
  { abi: incentivesProxyAbi, address: incentivesProxyAddress },
)

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link incentivesProxyAbi}__ and `eventName` set to `"Upgraded"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE69A7CFC442770951377ad9Abec9C2264ad873f7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x36c3b7AEFbDec76E0E6C6BFB550af8472B2334B6)
 */
export const watchIncentivesProxyUpgradedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: incentivesProxyAbi,
    address: incentivesProxyAddress,
    eventName: 'Upgraded',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link incentivesV2ImplementationAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBA3Ce58a674f3097C9450E2c9ae04BaBBd60e3b3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7A13F9E2236C234907f53Ea60818f94928b5D540)
 */
export const readIncentivesV2Implementation = /*#__PURE__*/ createReadContract({
  abi: incentivesV2ImplementationAbi,
  address: incentivesV2ImplementationAddress,
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link incentivesV2ImplementationAbi}__ and `functionName` set to `"EMISSION_MANAGER"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBA3Ce58a674f3097C9450E2c9ae04BaBBd60e3b3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7A13F9E2236C234907f53Ea60818f94928b5D540)
 */
export const readIncentivesV2ImplementationEmissionManager =
  /*#__PURE__*/ createReadContract({
    abi: incentivesV2ImplementationAbi,
    address: incentivesV2ImplementationAddress,
    functionName: 'EMISSION_MANAGER',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link incentivesV2ImplementationAbi}__ and `functionName` set to `"REVISION"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBA3Ce58a674f3097C9450E2c9ae04BaBBd60e3b3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7A13F9E2236C234907f53Ea60818f94928b5D540)
 */
export const readIncentivesV2ImplementationRevision =
  /*#__PURE__*/ createReadContract({
    abi: incentivesV2ImplementationAbi,
    address: incentivesV2ImplementationAddress,
    functionName: 'REVISION',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link incentivesV2ImplementationAbi}__ and `functionName` set to `"getAllUserRewards"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBA3Ce58a674f3097C9450E2c9ae04BaBBd60e3b3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7A13F9E2236C234907f53Ea60818f94928b5D540)
 */
export const readIncentivesV2ImplementationGetAllUserRewards =
  /*#__PURE__*/ createReadContract({
    abi: incentivesV2ImplementationAbi,
    address: incentivesV2ImplementationAddress,
    functionName: 'getAllUserRewards',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link incentivesV2ImplementationAbi}__ and `functionName` set to `"getAssetDecimals"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBA3Ce58a674f3097C9450E2c9ae04BaBBd60e3b3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7A13F9E2236C234907f53Ea60818f94928b5D540)
 */
export const readIncentivesV2ImplementationGetAssetDecimals =
  /*#__PURE__*/ createReadContract({
    abi: incentivesV2ImplementationAbi,
    address: incentivesV2ImplementationAddress,
    functionName: 'getAssetDecimals',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link incentivesV2ImplementationAbi}__ and `functionName` set to `"getAssetIndex"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBA3Ce58a674f3097C9450E2c9ae04BaBBd60e3b3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7A13F9E2236C234907f53Ea60818f94928b5D540)
 */
export const readIncentivesV2ImplementationGetAssetIndex =
  /*#__PURE__*/ createReadContract({
    abi: incentivesV2ImplementationAbi,
    address: incentivesV2ImplementationAddress,
    functionName: 'getAssetIndex',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link incentivesV2ImplementationAbi}__ and `functionName` set to `"getClaimer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBA3Ce58a674f3097C9450E2c9ae04BaBBd60e3b3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7A13F9E2236C234907f53Ea60818f94928b5D540)
 */
export const readIncentivesV2ImplementationGetClaimer =
  /*#__PURE__*/ createReadContract({
    abi: incentivesV2ImplementationAbi,
    address: incentivesV2ImplementationAddress,
    functionName: 'getClaimer',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link incentivesV2ImplementationAbi}__ and `functionName` set to `"getDistributionEnd"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBA3Ce58a674f3097C9450E2c9ae04BaBBd60e3b3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7A13F9E2236C234907f53Ea60818f94928b5D540)
 */
export const readIncentivesV2ImplementationGetDistributionEnd =
  /*#__PURE__*/ createReadContract({
    abi: incentivesV2ImplementationAbi,
    address: incentivesV2ImplementationAddress,
    functionName: 'getDistributionEnd',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link incentivesV2ImplementationAbi}__ and `functionName` set to `"getEmissionManager"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBA3Ce58a674f3097C9450E2c9ae04BaBBd60e3b3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7A13F9E2236C234907f53Ea60818f94928b5D540)
 */
export const readIncentivesV2ImplementationGetEmissionManager =
  /*#__PURE__*/ createReadContract({
    abi: incentivesV2ImplementationAbi,
    address: incentivesV2ImplementationAddress,
    functionName: 'getEmissionManager',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link incentivesV2ImplementationAbi}__ and `functionName` set to `"getRewardOracle"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBA3Ce58a674f3097C9450E2c9ae04BaBBd60e3b3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7A13F9E2236C234907f53Ea60818f94928b5D540)
 */
export const readIncentivesV2ImplementationGetRewardOracle =
  /*#__PURE__*/ createReadContract({
    abi: incentivesV2ImplementationAbi,
    address: incentivesV2ImplementationAddress,
    functionName: 'getRewardOracle',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link incentivesV2ImplementationAbi}__ and `functionName` set to `"getRewardsByAsset"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBA3Ce58a674f3097C9450E2c9ae04BaBBd60e3b3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7A13F9E2236C234907f53Ea60818f94928b5D540)
 */
export const readIncentivesV2ImplementationGetRewardsByAsset =
  /*#__PURE__*/ createReadContract({
    abi: incentivesV2ImplementationAbi,
    address: incentivesV2ImplementationAddress,
    functionName: 'getRewardsByAsset',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link incentivesV2ImplementationAbi}__ and `functionName` set to `"getRewardsData"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBA3Ce58a674f3097C9450E2c9ae04BaBBd60e3b3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7A13F9E2236C234907f53Ea60818f94928b5D540)
 */
export const readIncentivesV2ImplementationGetRewardsData =
  /*#__PURE__*/ createReadContract({
    abi: incentivesV2ImplementationAbi,
    address: incentivesV2ImplementationAddress,
    functionName: 'getRewardsData',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link incentivesV2ImplementationAbi}__ and `functionName` set to `"getRewardsList"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBA3Ce58a674f3097C9450E2c9ae04BaBBd60e3b3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7A13F9E2236C234907f53Ea60818f94928b5D540)
 */
export const readIncentivesV2ImplementationGetRewardsList =
  /*#__PURE__*/ createReadContract({
    abi: incentivesV2ImplementationAbi,
    address: incentivesV2ImplementationAddress,
    functionName: 'getRewardsList',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link incentivesV2ImplementationAbi}__ and `functionName` set to `"getTransferStrategy"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBA3Ce58a674f3097C9450E2c9ae04BaBBd60e3b3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7A13F9E2236C234907f53Ea60818f94928b5D540)
 */
export const readIncentivesV2ImplementationGetTransferStrategy =
  /*#__PURE__*/ createReadContract({
    abi: incentivesV2ImplementationAbi,
    address: incentivesV2ImplementationAddress,
    functionName: 'getTransferStrategy',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link incentivesV2ImplementationAbi}__ and `functionName` set to `"getUserAccruedRewards"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBA3Ce58a674f3097C9450E2c9ae04BaBBd60e3b3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7A13F9E2236C234907f53Ea60818f94928b5D540)
 */
export const readIncentivesV2ImplementationGetUserAccruedRewards =
  /*#__PURE__*/ createReadContract({
    abi: incentivesV2ImplementationAbi,
    address: incentivesV2ImplementationAddress,
    functionName: 'getUserAccruedRewards',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link incentivesV2ImplementationAbi}__ and `functionName` set to `"getUserAssetIndex"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBA3Ce58a674f3097C9450E2c9ae04BaBBd60e3b3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7A13F9E2236C234907f53Ea60818f94928b5D540)
 */
export const readIncentivesV2ImplementationGetUserAssetIndex =
  /*#__PURE__*/ createReadContract({
    abi: incentivesV2ImplementationAbi,
    address: incentivesV2ImplementationAddress,
    functionName: 'getUserAssetIndex',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link incentivesV2ImplementationAbi}__ and `functionName` set to `"getUserRewards"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBA3Ce58a674f3097C9450E2c9ae04BaBBd60e3b3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7A13F9E2236C234907f53Ea60818f94928b5D540)
 */
export const readIncentivesV2ImplementationGetUserRewards =
  /*#__PURE__*/ createReadContract({
    abi: incentivesV2ImplementationAbi,
    address: incentivesV2ImplementationAddress,
    functionName: 'getUserRewards',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link incentivesV2ImplementationAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBA3Ce58a674f3097C9450E2c9ae04BaBBd60e3b3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7A13F9E2236C234907f53Ea60818f94928b5D540)
 */
export const writeIncentivesV2Implementation =
  /*#__PURE__*/ createWriteContract({
    abi: incentivesV2ImplementationAbi,
    address: incentivesV2ImplementationAddress,
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link incentivesV2ImplementationAbi}__ and `functionName` set to `"claimAllRewards"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBA3Ce58a674f3097C9450E2c9ae04BaBBd60e3b3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7A13F9E2236C234907f53Ea60818f94928b5D540)
 */
export const writeIncentivesV2ImplementationClaimAllRewards =
  /*#__PURE__*/ createWriteContract({
    abi: incentivesV2ImplementationAbi,
    address: incentivesV2ImplementationAddress,
    functionName: 'claimAllRewards',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link incentivesV2ImplementationAbi}__ and `functionName` set to `"claimAllRewardsOnBehalf"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBA3Ce58a674f3097C9450E2c9ae04BaBBd60e3b3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7A13F9E2236C234907f53Ea60818f94928b5D540)
 */
export const writeIncentivesV2ImplementationClaimAllRewardsOnBehalf =
  /*#__PURE__*/ createWriteContract({
    abi: incentivesV2ImplementationAbi,
    address: incentivesV2ImplementationAddress,
    functionName: 'claimAllRewardsOnBehalf',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link incentivesV2ImplementationAbi}__ and `functionName` set to `"claimAllRewardsToSelf"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBA3Ce58a674f3097C9450E2c9ae04BaBBd60e3b3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7A13F9E2236C234907f53Ea60818f94928b5D540)
 */
export const writeIncentivesV2ImplementationClaimAllRewardsToSelf =
  /*#__PURE__*/ createWriteContract({
    abi: incentivesV2ImplementationAbi,
    address: incentivesV2ImplementationAddress,
    functionName: 'claimAllRewardsToSelf',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link incentivesV2ImplementationAbi}__ and `functionName` set to `"claimRewards"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBA3Ce58a674f3097C9450E2c9ae04BaBBd60e3b3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7A13F9E2236C234907f53Ea60818f94928b5D540)
 */
export const writeIncentivesV2ImplementationClaimRewards =
  /*#__PURE__*/ createWriteContract({
    abi: incentivesV2ImplementationAbi,
    address: incentivesV2ImplementationAddress,
    functionName: 'claimRewards',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link incentivesV2ImplementationAbi}__ and `functionName` set to `"claimRewardsOnBehalf"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBA3Ce58a674f3097C9450E2c9ae04BaBBd60e3b3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7A13F9E2236C234907f53Ea60818f94928b5D540)
 */
export const writeIncentivesV2ImplementationClaimRewardsOnBehalf =
  /*#__PURE__*/ createWriteContract({
    abi: incentivesV2ImplementationAbi,
    address: incentivesV2ImplementationAddress,
    functionName: 'claimRewardsOnBehalf',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link incentivesV2ImplementationAbi}__ and `functionName` set to `"claimRewardsToSelf"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBA3Ce58a674f3097C9450E2c9ae04BaBBd60e3b3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7A13F9E2236C234907f53Ea60818f94928b5D540)
 */
export const writeIncentivesV2ImplementationClaimRewardsToSelf =
  /*#__PURE__*/ createWriteContract({
    abi: incentivesV2ImplementationAbi,
    address: incentivesV2ImplementationAddress,
    functionName: 'claimRewardsToSelf',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link incentivesV2ImplementationAbi}__ and `functionName` set to `"configureAssets"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBA3Ce58a674f3097C9450E2c9ae04BaBBd60e3b3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7A13F9E2236C234907f53Ea60818f94928b5D540)
 */
export const writeIncentivesV2ImplementationConfigureAssets =
  /*#__PURE__*/ createWriteContract({
    abi: incentivesV2ImplementationAbi,
    address: incentivesV2ImplementationAddress,
    functionName: 'configureAssets',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link incentivesV2ImplementationAbi}__ and `functionName` set to `"handleAction"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBA3Ce58a674f3097C9450E2c9ae04BaBBd60e3b3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7A13F9E2236C234907f53Ea60818f94928b5D540)
 */
export const writeIncentivesV2ImplementationHandleAction =
  /*#__PURE__*/ createWriteContract({
    abi: incentivesV2ImplementationAbi,
    address: incentivesV2ImplementationAddress,
    functionName: 'handleAction',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link incentivesV2ImplementationAbi}__ and `functionName` set to `"initialize"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBA3Ce58a674f3097C9450E2c9ae04BaBBd60e3b3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7A13F9E2236C234907f53Ea60818f94928b5D540)
 */
export const writeIncentivesV2ImplementationInitialize =
  /*#__PURE__*/ createWriteContract({
    abi: incentivesV2ImplementationAbi,
    address: incentivesV2ImplementationAddress,
    functionName: 'initialize',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link incentivesV2ImplementationAbi}__ and `functionName` set to `"setClaimer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBA3Ce58a674f3097C9450E2c9ae04BaBBd60e3b3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7A13F9E2236C234907f53Ea60818f94928b5D540)
 */
export const writeIncentivesV2ImplementationSetClaimer =
  /*#__PURE__*/ createWriteContract({
    abi: incentivesV2ImplementationAbi,
    address: incentivesV2ImplementationAddress,
    functionName: 'setClaimer',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link incentivesV2ImplementationAbi}__ and `functionName` set to `"setDistributionEnd"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBA3Ce58a674f3097C9450E2c9ae04BaBBd60e3b3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7A13F9E2236C234907f53Ea60818f94928b5D540)
 */
export const writeIncentivesV2ImplementationSetDistributionEnd =
  /*#__PURE__*/ createWriteContract({
    abi: incentivesV2ImplementationAbi,
    address: incentivesV2ImplementationAddress,
    functionName: 'setDistributionEnd',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link incentivesV2ImplementationAbi}__ and `functionName` set to `"setEmissionPerSecond"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBA3Ce58a674f3097C9450E2c9ae04BaBBd60e3b3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7A13F9E2236C234907f53Ea60818f94928b5D540)
 */
export const writeIncentivesV2ImplementationSetEmissionPerSecond =
  /*#__PURE__*/ createWriteContract({
    abi: incentivesV2ImplementationAbi,
    address: incentivesV2ImplementationAddress,
    functionName: 'setEmissionPerSecond',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link incentivesV2ImplementationAbi}__ and `functionName` set to `"setRewardOracle"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBA3Ce58a674f3097C9450E2c9ae04BaBBd60e3b3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7A13F9E2236C234907f53Ea60818f94928b5D540)
 */
export const writeIncentivesV2ImplementationSetRewardOracle =
  /*#__PURE__*/ createWriteContract({
    abi: incentivesV2ImplementationAbi,
    address: incentivesV2ImplementationAddress,
    functionName: 'setRewardOracle',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link incentivesV2ImplementationAbi}__ and `functionName` set to `"setTransferStrategy"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBA3Ce58a674f3097C9450E2c9ae04BaBBd60e3b3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7A13F9E2236C234907f53Ea60818f94928b5D540)
 */
export const writeIncentivesV2ImplementationSetTransferStrategy =
  /*#__PURE__*/ createWriteContract({
    abi: incentivesV2ImplementationAbi,
    address: incentivesV2ImplementationAddress,
    functionName: 'setTransferStrategy',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link incentivesV2ImplementationAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBA3Ce58a674f3097C9450E2c9ae04BaBBd60e3b3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7A13F9E2236C234907f53Ea60818f94928b5D540)
 */
export const simulateIncentivesV2Implementation =
  /*#__PURE__*/ createSimulateContract({
    abi: incentivesV2ImplementationAbi,
    address: incentivesV2ImplementationAddress,
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link incentivesV2ImplementationAbi}__ and `functionName` set to `"claimAllRewards"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBA3Ce58a674f3097C9450E2c9ae04BaBBd60e3b3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7A13F9E2236C234907f53Ea60818f94928b5D540)
 */
export const simulateIncentivesV2ImplementationClaimAllRewards =
  /*#__PURE__*/ createSimulateContract({
    abi: incentivesV2ImplementationAbi,
    address: incentivesV2ImplementationAddress,
    functionName: 'claimAllRewards',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link incentivesV2ImplementationAbi}__ and `functionName` set to `"claimAllRewardsOnBehalf"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBA3Ce58a674f3097C9450E2c9ae04BaBBd60e3b3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7A13F9E2236C234907f53Ea60818f94928b5D540)
 */
export const simulateIncentivesV2ImplementationClaimAllRewardsOnBehalf =
  /*#__PURE__*/ createSimulateContract({
    abi: incentivesV2ImplementationAbi,
    address: incentivesV2ImplementationAddress,
    functionName: 'claimAllRewardsOnBehalf',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link incentivesV2ImplementationAbi}__ and `functionName` set to `"claimAllRewardsToSelf"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBA3Ce58a674f3097C9450E2c9ae04BaBBd60e3b3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7A13F9E2236C234907f53Ea60818f94928b5D540)
 */
export const simulateIncentivesV2ImplementationClaimAllRewardsToSelf =
  /*#__PURE__*/ createSimulateContract({
    abi: incentivesV2ImplementationAbi,
    address: incentivesV2ImplementationAddress,
    functionName: 'claimAllRewardsToSelf',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link incentivesV2ImplementationAbi}__ and `functionName` set to `"claimRewards"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBA3Ce58a674f3097C9450E2c9ae04BaBBd60e3b3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7A13F9E2236C234907f53Ea60818f94928b5D540)
 */
export const simulateIncentivesV2ImplementationClaimRewards =
  /*#__PURE__*/ createSimulateContract({
    abi: incentivesV2ImplementationAbi,
    address: incentivesV2ImplementationAddress,
    functionName: 'claimRewards',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link incentivesV2ImplementationAbi}__ and `functionName` set to `"claimRewardsOnBehalf"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBA3Ce58a674f3097C9450E2c9ae04BaBBd60e3b3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7A13F9E2236C234907f53Ea60818f94928b5D540)
 */
export const simulateIncentivesV2ImplementationClaimRewardsOnBehalf =
  /*#__PURE__*/ createSimulateContract({
    abi: incentivesV2ImplementationAbi,
    address: incentivesV2ImplementationAddress,
    functionName: 'claimRewardsOnBehalf',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link incentivesV2ImplementationAbi}__ and `functionName` set to `"claimRewardsToSelf"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBA3Ce58a674f3097C9450E2c9ae04BaBBd60e3b3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7A13F9E2236C234907f53Ea60818f94928b5D540)
 */
export const simulateIncentivesV2ImplementationClaimRewardsToSelf =
  /*#__PURE__*/ createSimulateContract({
    abi: incentivesV2ImplementationAbi,
    address: incentivesV2ImplementationAddress,
    functionName: 'claimRewardsToSelf',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link incentivesV2ImplementationAbi}__ and `functionName` set to `"configureAssets"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBA3Ce58a674f3097C9450E2c9ae04BaBBd60e3b3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7A13F9E2236C234907f53Ea60818f94928b5D540)
 */
export const simulateIncentivesV2ImplementationConfigureAssets =
  /*#__PURE__*/ createSimulateContract({
    abi: incentivesV2ImplementationAbi,
    address: incentivesV2ImplementationAddress,
    functionName: 'configureAssets',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link incentivesV2ImplementationAbi}__ and `functionName` set to `"handleAction"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBA3Ce58a674f3097C9450E2c9ae04BaBBd60e3b3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7A13F9E2236C234907f53Ea60818f94928b5D540)
 */
export const simulateIncentivesV2ImplementationHandleAction =
  /*#__PURE__*/ createSimulateContract({
    abi: incentivesV2ImplementationAbi,
    address: incentivesV2ImplementationAddress,
    functionName: 'handleAction',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link incentivesV2ImplementationAbi}__ and `functionName` set to `"initialize"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBA3Ce58a674f3097C9450E2c9ae04BaBBd60e3b3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7A13F9E2236C234907f53Ea60818f94928b5D540)
 */
export const simulateIncentivesV2ImplementationInitialize =
  /*#__PURE__*/ createSimulateContract({
    abi: incentivesV2ImplementationAbi,
    address: incentivesV2ImplementationAddress,
    functionName: 'initialize',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link incentivesV2ImplementationAbi}__ and `functionName` set to `"setClaimer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBA3Ce58a674f3097C9450E2c9ae04BaBBd60e3b3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7A13F9E2236C234907f53Ea60818f94928b5D540)
 */
export const simulateIncentivesV2ImplementationSetClaimer =
  /*#__PURE__*/ createSimulateContract({
    abi: incentivesV2ImplementationAbi,
    address: incentivesV2ImplementationAddress,
    functionName: 'setClaimer',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link incentivesV2ImplementationAbi}__ and `functionName` set to `"setDistributionEnd"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBA3Ce58a674f3097C9450E2c9ae04BaBBd60e3b3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7A13F9E2236C234907f53Ea60818f94928b5D540)
 */
export const simulateIncentivesV2ImplementationSetDistributionEnd =
  /*#__PURE__*/ createSimulateContract({
    abi: incentivesV2ImplementationAbi,
    address: incentivesV2ImplementationAddress,
    functionName: 'setDistributionEnd',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link incentivesV2ImplementationAbi}__ and `functionName` set to `"setEmissionPerSecond"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBA3Ce58a674f3097C9450E2c9ae04BaBBd60e3b3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7A13F9E2236C234907f53Ea60818f94928b5D540)
 */
export const simulateIncentivesV2ImplementationSetEmissionPerSecond =
  /*#__PURE__*/ createSimulateContract({
    abi: incentivesV2ImplementationAbi,
    address: incentivesV2ImplementationAddress,
    functionName: 'setEmissionPerSecond',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link incentivesV2ImplementationAbi}__ and `functionName` set to `"setRewardOracle"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBA3Ce58a674f3097C9450E2c9ae04BaBBd60e3b3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7A13F9E2236C234907f53Ea60818f94928b5D540)
 */
export const simulateIncentivesV2ImplementationSetRewardOracle =
  /*#__PURE__*/ createSimulateContract({
    abi: incentivesV2ImplementationAbi,
    address: incentivesV2ImplementationAddress,
    functionName: 'setRewardOracle',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link incentivesV2ImplementationAbi}__ and `functionName` set to `"setTransferStrategy"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBA3Ce58a674f3097C9450E2c9ae04BaBBd60e3b3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7A13F9E2236C234907f53Ea60818f94928b5D540)
 */
export const simulateIncentivesV2ImplementationSetTransferStrategy =
  /*#__PURE__*/ createSimulateContract({
    abi: incentivesV2ImplementationAbi,
    address: incentivesV2ImplementationAddress,
    functionName: 'setTransferStrategy',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link incentivesV2ImplementationAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBA3Ce58a674f3097C9450E2c9ae04BaBBd60e3b3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7A13F9E2236C234907f53Ea60818f94928b5D540)
 */
export const watchIncentivesV2ImplementationEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: incentivesV2ImplementationAbi,
    address: incentivesV2ImplementationAddress,
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link incentivesV2ImplementationAbi}__ and `eventName` set to `"Accrued"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBA3Ce58a674f3097C9450E2c9ae04BaBBd60e3b3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7A13F9E2236C234907f53Ea60818f94928b5D540)
 */
export const watchIncentivesV2ImplementationAccruedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: incentivesV2ImplementationAbi,
    address: incentivesV2ImplementationAddress,
    eventName: 'Accrued',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link incentivesV2ImplementationAbi}__ and `eventName` set to `"AssetConfigUpdated"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBA3Ce58a674f3097C9450E2c9ae04BaBBd60e3b3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7A13F9E2236C234907f53Ea60818f94928b5D540)
 */
export const watchIncentivesV2ImplementationAssetConfigUpdatedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: incentivesV2ImplementationAbi,
    address: incentivesV2ImplementationAddress,
    eventName: 'AssetConfigUpdated',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link incentivesV2ImplementationAbi}__ and `eventName` set to `"ClaimerSet"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBA3Ce58a674f3097C9450E2c9ae04BaBBd60e3b3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7A13F9E2236C234907f53Ea60818f94928b5D540)
 */
export const watchIncentivesV2ImplementationClaimerSetEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: incentivesV2ImplementationAbi,
    address: incentivesV2ImplementationAddress,
    eventName: 'ClaimerSet',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link incentivesV2ImplementationAbi}__ and `eventName` set to `"RewardOracleUpdated"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBA3Ce58a674f3097C9450E2c9ae04BaBBd60e3b3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7A13F9E2236C234907f53Ea60818f94928b5D540)
 */
export const watchIncentivesV2ImplementationRewardOracleUpdatedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: incentivesV2ImplementationAbi,
    address: incentivesV2ImplementationAddress,
    eventName: 'RewardOracleUpdated',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link incentivesV2ImplementationAbi}__ and `eventName` set to `"RewardsClaimed"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBA3Ce58a674f3097C9450E2c9ae04BaBBd60e3b3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7A13F9E2236C234907f53Ea60818f94928b5D540)
 */
export const watchIncentivesV2ImplementationRewardsClaimedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: incentivesV2ImplementationAbi,
    address: incentivesV2ImplementationAddress,
    eventName: 'RewardsClaimed',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link incentivesV2ImplementationAbi}__ and `eventName` set to `"TransferStrategyInstalled"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBA3Ce58a674f3097C9450E2c9ae04BaBBd60e3b3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7A13F9E2236C234907f53Ea60818f94928b5D540)
 */
export const watchIncentivesV2ImplementationTransferStrategyInstalledEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: incentivesV2ImplementationAbi,
    address: incentivesV2ImplementationAddress,
    eventName: 'TransferStrategyInstalled',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link liquidationLogicAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xDf8B8Bf7dD0b9564dbE2251e4A253F0bD37a1824)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x8a24Ff16329BDe7fDF0caA9B0171a2acC4f64442)
 */
export const readLiquidationLogic = /*#__PURE__*/ createReadContract({
  abi: liquidationLogicAbi,
  address: liquidationLogicAddress,
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link liquidationLogicAbi}__ and `functionName` set to `"CLOSE_FACTOR_HF_THRESHOLD"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xDf8B8Bf7dD0b9564dbE2251e4A253F0bD37a1824)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x8a24Ff16329BDe7fDF0caA9B0171a2acC4f64442)
 */
export const readLiquidationLogicCloseFactorHfThreshold =
  /*#__PURE__*/ createReadContract({
    abi: liquidationLogicAbi,
    address: liquidationLogicAddress,
    functionName: 'CLOSE_FACTOR_HF_THRESHOLD',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link liquidationLogicAbi}__ and `functionName` set to `"MAX_LIQUIDATION_CLOSE_FACTOR"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xDf8B8Bf7dD0b9564dbE2251e4A253F0bD37a1824)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x8a24Ff16329BDe7fDF0caA9B0171a2acC4f64442)
 */
export const readLiquidationLogicMaxLiquidationCloseFactor =
  /*#__PURE__*/ createReadContract({
    abi: liquidationLogicAbi,
    address: liquidationLogicAddress,
    functionName: 'MAX_LIQUIDATION_CLOSE_FACTOR',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link liquidationLogicAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xDf8B8Bf7dD0b9564dbE2251e4A253F0bD37a1824)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x8a24Ff16329BDe7fDF0caA9B0171a2acC4f64442)
 */
export const watchLiquidationLogicEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: liquidationLogicAbi,
    address: liquidationLogicAddress,
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link liquidationLogicAbi}__ and `eventName` set to `"IsolationModeTotalDebtUpdated"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xDf8B8Bf7dD0b9564dbE2251e4A253F0bD37a1824)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x8a24Ff16329BDe7fDF0caA9B0171a2acC4f64442)
 */
export const watchLiquidationLogicIsolationModeTotalDebtUpdatedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: liquidationLogicAbi,
    address: liquidationLogicAddress,
    eventName: 'IsolationModeTotalDebtUpdated',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link liquidationLogicAbi}__ and `eventName` set to `"LiquidationCall"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xDf8B8Bf7dD0b9564dbE2251e4A253F0bD37a1824)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x8a24Ff16329BDe7fDF0caA9B0171a2acC4f64442)
 */
export const watchLiquidationLogicLiquidationCallEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: liquidationLogicAbi,
    address: liquidationLogicAddress,
    eventName: 'LiquidationCall',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link liquidationLogicAbi}__ and `eventName` set to `"ReserveDataUpdated"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xDf8B8Bf7dD0b9564dbE2251e4A253F0bD37a1824)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x8a24Ff16329BDe7fDF0caA9B0171a2acC4f64442)
 */
export const watchLiquidationLogicReserveDataUpdatedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: liquidationLogicAbi,
    address: liquidationLogicAddress,
    eventName: 'ReserveDataUpdated',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link liquidationLogicAbi}__ and `eventName` set to `"ReserveUsedAsCollateralDisabled"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xDf8B8Bf7dD0b9564dbE2251e4A253F0bD37a1824)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x8a24Ff16329BDe7fDF0caA9B0171a2acC4f64442)
 */
export const watchLiquidationLogicReserveUsedAsCollateralDisabledEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: liquidationLogicAbi,
    address: liquidationLogicAddress,
    eventName: 'ReserveUsedAsCollateralDisabled',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link liquidationLogicAbi}__ and `eventName` set to `"ReserveUsedAsCollateralEnabled"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xDf8B8Bf7dD0b9564dbE2251e4A253F0bD37a1824)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x8a24Ff16329BDe7fDF0caA9B0171a2acC4f64442)
 */
export const watchLiquidationLogicReserveUsedAsCollateralEnabledEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: liquidationLogicAbi,
    address: liquidationLogicAddress,
    eventName: 'ReserveUsedAsCollateralEnabled',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link mockFlashLoanReceiverAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x512132149bf29C4A64aD019BA8b4f45fEb6B00c7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2fBD9d72fc46f9Db7F6e7ed9c63723900971e256)
 */
export const readMockFlashLoanReceiver = /*#__PURE__*/ createReadContract({
  abi: mockFlashLoanReceiverAbi,
  address: mockFlashLoanReceiverAddress,
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link mockFlashLoanReceiverAbi}__ and `functionName` set to `"ADDRESSES_PROVIDER"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x512132149bf29C4A64aD019BA8b4f45fEb6B00c7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2fBD9d72fc46f9Db7F6e7ed9c63723900971e256)
 */
export const readMockFlashLoanReceiverAddressesProvider =
  /*#__PURE__*/ createReadContract({
    abi: mockFlashLoanReceiverAbi,
    address: mockFlashLoanReceiverAddress,
    functionName: 'ADDRESSES_PROVIDER',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link mockFlashLoanReceiverAbi}__ and `functionName` set to `"POOL"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x512132149bf29C4A64aD019BA8b4f45fEb6B00c7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2fBD9d72fc46f9Db7F6e7ed9c63723900971e256)
 */
export const readMockFlashLoanReceiverPool = /*#__PURE__*/ createReadContract({
  abi: mockFlashLoanReceiverAbi,
  address: mockFlashLoanReceiverAddress,
  functionName: 'POOL',
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link mockFlashLoanReceiverAbi}__ and `functionName` set to `"getAmountToApprove"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x512132149bf29C4A64aD019BA8b4f45fEb6B00c7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2fBD9d72fc46f9Db7F6e7ed9c63723900971e256)
 */
export const readMockFlashLoanReceiverGetAmountToApprove =
  /*#__PURE__*/ createReadContract({
    abi: mockFlashLoanReceiverAbi,
    address: mockFlashLoanReceiverAddress,
    functionName: 'getAmountToApprove',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link mockFlashLoanReceiverAbi}__ and `functionName` set to `"simulateEOA"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x512132149bf29C4A64aD019BA8b4f45fEb6B00c7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2fBD9d72fc46f9Db7F6e7ed9c63723900971e256)
 */
export const readMockFlashLoanReceiverSimulateEoa =
  /*#__PURE__*/ createReadContract({
    abi: mockFlashLoanReceiverAbi,
    address: mockFlashLoanReceiverAddress,
    functionName: 'simulateEOA',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link mockFlashLoanReceiverAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x512132149bf29C4A64aD019BA8b4f45fEb6B00c7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2fBD9d72fc46f9Db7F6e7ed9c63723900971e256)
 */
export const writeMockFlashLoanReceiver = /*#__PURE__*/ createWriteContract({
  abi: mockFlashLoanReceiverAbi,
  address: mockFlashLoanReceiverAddress,
})

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link mockFlashLoanReceiverAbi}__ and `functionName` set to `"executeOperation"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x512132149bf29C4A64aD019BA8b4f45fEb6B00c7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2fBD9d72fc46f9Db7F6e7ed9c63723900971e256)
 */
export const writeMockFlashLoanReceiverExecuteOperation =
  /*#__PURE__*/ createWriteContract({
    abi: mockFlashLoanReceiverAbi,
    address: mockFlashLoanReceiverAddress,
    functionName: 'executeOperation',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link mockFlashLoanReceiverAbi}__ and `functionName` set to `"setAmountToApprove"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x512132149bf29C4A64aD019BA8b4f45fEb6B00c7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2fBD9d72fc46f9Db7F6e7ed9c63723900971e256)
 */
export const writeMockFlashLoanReceiverSetAmountToApprove =
  /*#__PURE__*/ createWriteContract({
    abi: mockFlashLoanReceiverAbi,
    address: mockFlashLoanReceiverAddress,
    functionName: 'setAmountToApprove',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link mockFlashLoanReceiverAbi}__ and `functionName` set to `"setFailExecutionTransfer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x512132149bf29C4A64aD019BA8b4f45fEb6B00c7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2fBD9d72fc46f9Db7F6e7ed9c63723900971e256)
 */
export const writeMockFlashLoanReceiverSetFailExecutionTransfer =
  /*#__PURE__*/ createWriteContract({
    abi: mockFlashLoanReceiverAbi,
    address: mockFlashLoanReceiverAddress,
    functionName: 'setFailExecutionTransfer',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link mockFlashLoanReceiverAbi}__ and `functionName` set to `"setSimulateEOA"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x512132149bf29C4A64aD019BA8b4f45fEb6B00c7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2fBD9d72fc46f9Db7F6e7ed9c63723900971e256)
 */
export const writeMockFlashLoanReceiverSetSimulateEoa =
  /*#__PURE__*/ createWriteContract({
    abi: mockFlashLoanReceiverAbi,
    address: mockFlashLoanReceiverAddress,
    functionName: 'setSimulateEOA',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link mockFlashLoanReceiverAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x512132149bf29C4A64aD019BA8b4f45fEb6B00c7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2fBD9d72fc46f9Db7F6e7ed9c63723900971e256)
 */
export const simulateMockFlashLoanReceiver =
  /*#__PURE__*/ createSimulateContract({
    abi: mockFlashLoanReceiverAbi,
    address: mockFlashLoanReceiverAddress,
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link mockFlashLoanReceiverAbi}__ and `functionName` set to `"executeOperation"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x512132149bf29C4A64aD019BA8b4f45fEb6B00c7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2fBD9d72fc46f9Db7F6e7ed9c63723900971e256)
 */
export const simulateMockFlashLoanReceiverExecuteOperation =
  /*#__PURE__*/ createSimulateContract({
    abi: mockFlashLoanReceiverAbi,
    address: mockFlashLoanReceiverAddress,
    functionName: 'executeOperation',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link mockFlashLoanReceiverAbi}__ and `functionName` set to `"setAmountToApprove"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x512132149bf29C4A64aD019BA8b4f45fEb6B00c7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2fBD9d72fc46f9Db7F6e7ed9c63723900971e256)
 */
export const simulateMockFlashLoanReceiverSetAmountToApprove =
  /*#__PURE__*/ createSimulateContract({
    abi: mockFlashLoanReceiverAbi,
    address: mockFlashLoanReceiverAddress,
    functionName: 'setAmountToApprove',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link mockFlashLoanReceiverAbi}__ and `functionName` set to `"setFailExecutionTransfer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x512132149bf29C4A64aD019BA8b4f45fEb6B00c7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2fBD9d72fc46f9Db7F6e7ed9c63723900971e256)
 */
export const simulateMockFlashLoanReceiverSetFailExecutionTransfer =
  /*#__PURE__*/ createSimulateContract({
    abi: mockFlashLoanReceiverAbi,
    address: mockFlashLoanReceiverAddress,
    functionName: 'setFailExecutionTransfer',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link mockFlashLoanReceiverAbi}__ and `functionName` set to `"setSimulateEOA"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x512132149bf29C4A64aD019BA8b4f45fEb6B00c7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2fBD9d72fc46f9Db7F6e7ed9c63723900971e256)
 */
export const simulateMockFlashLoanReceiverSetSimulateEoa =
  /*#__PURE__*/ createSimulateContract({
    abi: mockFlashLoanReceiverAbi,
    address: mockFlashLoanReceiverAddress,
    functionName: 'setSimulateEOA',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link mockFlashLoanReceiverAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x512132149bf29C4A64aD019BA8b4f45fEb6B00c7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2fBD9d72fc46f9Db7F6e7ed9c63723900971e256)
 */
export const watchMockFlashLoanReceiverEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: mockFlashLoanReceiverAbi,
    address: mockFlashLoanReceiverAddress,
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link mockFlashLoanReceiverAbi}__ and `eventName` set to `"ExecutedWithFail"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x512132149bf29C4A64aD019BA8b4f45fEb6B00c7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2fBD9d72fc46f9Db7F6e7ed9c63723900971e256)
 */
export const watchMockFlashLoanReceiverExecutedWithFailEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: mockFlashLoanReceiverAbi,
    address: mockFlashLoanReceiverAddress,
    eventName: 'ExecutedWithFail',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link mockFlashLoanReceiverAbi}__ and `eventName` set to `"ExecutedWithSuccess"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x512132149bf29C4A64aD019BA8b4f45fEb6B00c7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2fBD9d72fc46f9Db7F6e7ed9c63723900971e256)
 */
export const watchMockFlashLoanReceiverExecutedWithSuccessEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: mockFlashLoanReceiverAbi,
    address: mockFlashLoanReceiverAddress,
    eventName: 'ExecutedWithSuccess',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link poolImplementationAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const readPoolImplementation = /*#__PURE__*/ createReadContract({
  abi: poolImplementationAbi,
  address: poolImplementationAddress,
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link poolImplementationAbi}__ and `functionName` set to `"ADDRESSES_PROVIDER"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const readPoolImplementationAddressesProvider =
  /*#__PURE__*/ createReadContract({
    abi: poolImplementationAbi,
    address: poolImplementationAddress,
    functionName: 'ADDRESSES_PROVIDER',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link poolImplementationAbi}__ and `functionName` set to `"BRIDGE_PROTOCOL_FEE"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const readPoolImplementationBridgeProtocolFee =
  /*#__PURE__*/ createReadContract({
    abi: poolImplementationAbi,
    address: poolImplementationAddress,
    functionName: 'BRIDGE_PROTOCOL_FEE',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link poolImplementationAbi}__ and `functionName` set to `"FLASHLOAN_PREMIUM_TOTAL"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const readPoolImplementationFlashloanPremiumTotal =
  /*#__PURE__*/ createReadContract({
    abi: poolImplementationAbi,
    address: poolImplementationAddress,
    functionName: 'FLASHLOAN_PREMIUM_TOTAL',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link poolImplementationAbi}__ and `functionName` set to `"FLASHLOAN_PREMIUM_TO_PROTOCOL"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const readPoolImplementationFlashloanPremiumToProtocol =
  /*#__PURE__*/ createReadContract({
    abi: poolImplementationAbi,
    address: poolImplementationAddress,
    functionName: 'FLASHLOAN_PREMIUM_TO_PROTOCOL',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link poolImplementationAbi}__ and `functionName` set to `"MAX_NUMBER_RESERVES"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const readPoolImplementationMaxNumberReserves =
  /*#__PURE__*/ createReadContract({
    abi: poolImplementationAbi,
    address: poolImplementationAddress,
    functionName: 'MAX_NUMBER_RESERVES',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link poolImplementationAbi}__ and `functionName` set to `"MAX_STABLE_RATE_BORROW_SIZE_PERCENT"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const readPoolImplementationMaxStableRateBorrowSizePercent =
  /*#__PURE__*/ createReadContract({
    abi: poolImplementationAbi,
    address: poolImplementationAddress,
    functionName: 'MAX_STABLE_RATE_BORROW_SIZE_PERCENT',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link poolImplementationAbi}__ and `functionName` set to `"POOL_REVISION"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const readPoolImplementationPoolRevision =
  /*#__PURE__*/ createReadContract({
    abi: poolImplementationAbi,
    address: poolImplementationAddress,
    functionName: 'POOL_REVISION',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link poolImplementationAbi}__ and `functionName` set to `"getConfiguration"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const readPoolImplementationGetConfiguration =
  /*#__PURE__*/ createReadContract({
    abi: poolImplementationAbi,
    address: poolImplementationAddress,
    functionName: 'getConfiguration',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link poolImplementationAbi}__ and `functionName` set to `"getEModeCategoryData"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const readPoolImplementationGetEModeCategoryData =
  /*#__PURE__*/ createReadContract({
    abi: poolImplementationAbi,
    address: poolImplementationAddress,
    functionName: 'getEModeCategoryData',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link poolImplementationAbi}__ and `functionName` set to `"getReserveAddressById"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const readPoolImplementationGetReserveAddressById =
  /*#__PURE__*/ createReadContract({
    abi: poolImplementationAbi,
    address: poolImplementationAddress,
    functionName: 'getReserveAddressById',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link poolImplementationAbi}__ and `functionName` set to `"getReserveData"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const readPoolImplementationGetReserveData =
  /*#__PURE__*/ createReadContract({
    abi: poolImplementationAbi,
    address: poolImplementationAddress,
    functionName: 'getReserveData',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link poolImplementationAbi}__ and `functionName` set to `"getReserveNormalizedIncome"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const readPoolImplementationGetReserveNormalizedIncome =
  /*#__PURE__*/ createReadContract({
    abi: poolImplementationAbi,
    address: poolImplementationAddress,
    functionName: 'getReserveNormalizedIncome',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link poolImplementationAbi}__ and `functionName` set to `"getReserveNormalizedVariableDebt"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const readPoolImplementationGetReserveNormalizedVariableDebt =
  /*#__PURE__*/ createReadContract({
    abi: poolImplementationAbi,
    address: poolImplementationAddress,
    functionName: 'getReserveNormalizedVariableDebt',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link poolImplementationAbi}__ and `functionName` set to `"getReservesList"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const readPoolImplementationGetReservesList =
  /*#__PURE__*/ createReadContract({
    abi: poolImplementationAbi,
    address: poolImplementationAddress,
    functionName: 'getReservesList',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link poolImplementationAbi}__ and `functionName` set to `"getUserAccountData"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const readPoolImplementationGetUserAccountData =
  /*#__PURE__*/ createReadContract({
    abi: poolImplementationAbi,
    address: poolImplementationAddress,
    functionName: 'getUserAccountData',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link poolImplementationAbi}__ and `functionName` set to `"getUserConfiguration"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const readPoolImplementationGetUserConfiguration =
  /*#__PURE__*/ createReadContract({
    abi: poolImplementationAbi,
    address: poolImplementationAddress,
    functionName: 'getUserConfiguration',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link poolImplementationAbi}__ and `functionName` set to `"getUserEMode"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const readPoolImplementationGetUserEMode =
  /*#__PURE__*/ createReadContract({
    abi: poolImplementationAbi,
    address: poolImplementationAddress,
    functionName: 'getUserEMode',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link poolImplementationAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const writePoolImplementation = /*#__PURE__*/ createWriteContract({
  abi: poolImplementationAbi,
  address: poolImplementationAddress,
})

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link poolImplementationAbi}__ and `functionName` set to `"backUnbacked"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const writePoolImplementationBackUnbacked =
  /*#__PURE__*/ createWriteContract({
    abi: poolImplementationAbi,
    address: poolImplementationAddress,
    functionName: 'backUnbacked',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link poolImplementationAbi}__ and `functionName` set to `"borrow"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const writePoolImplementationBorrow = /*#__PURE__*/ createWriteContract({
  abi: poolImplementationAbi,
  address: poolImplementationAddress,
  functionName: 'borrow',
})

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link poolImplementationAbi}__ and `functionName` set to `"configureEModeCategory"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const writePoolImplementationConfigureEModeCategory =
  /*#__PURE__*/ createWriteContract({
    abi: poolImplementationAbi,
    address: poolImplementationAddress,
    functionName: 'configureEModeCategory',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link poolImplementationAbi}__ and `functionName` set to `"deposit"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const writePoolImplementationDeposit = /*#__PURE__*/ createWriteContract(
  {
    abi: poolImplementationAbi,
    address: poolImplementationAddress,
    functionName: 'deposit',
  },
)

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link poolImplementationAbi}__ and `functionName` set to `"dropReserve"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const writePoolImplementationDropReserve =
  /*#__PURE__*/ createWriteContract({
    abi: poolImplementationAbi,
    address: poolImplementationAddress,
    functionName: 'dropReserve',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link poolImplementationAbi}__ and `functionName` set to `"finalizeTransfer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const writePoolImplementationFinalizeTransfer =
  /*#__PURE__*/ createWriteContract({
    abi: poolImplementationAbi,
    address: poolImplementationAddress,
    functionName: 'finalizeTransfer',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link poolImplementationAbi}__ and `functionName` set to `"flashLoan"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const writePoolImplementationFlashLoan =
  /*#__PURE__*/ createWriteContract({
    abi: poolImplementationAbi,
    address: poolImplementationAddress,
    functionName: 'flashLoan',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link poolImplementationAbi}__ and `functionName` set to `"flashLoanSimple"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const writePoolImplementationFlashLoanSimple =
  /*#__PURE__*/ createWriteContract({
    abi: poolImplementationAbi,
    address: poolImplementationAddress,
    functionName: 'flashLoanSimple',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link poolImplementationAbi}__ and `functionName` set to `"initReserve"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const writePoolImplementationInitReserve =
  /*#__PURE__*/ createWriteContract({
    abi: poolImplementationAbi,
    address: poolImplementationAddress,
    functionName: 'initReserve',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link poolImplementationAbi}__ and `functionName` set to `"initialize"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const writePoolImplementationInitialize =
  /*#__PURE__*/ createWriteContract({
    abi: poolImplementationAbi,
    address: poolImplementationAddress,
    functionName: 'initialize',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link poolImplementationAbi}__ and `functionName` set to `"liquidationCall"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const writePoolImplementationLiquidationCall =
  /*#__PURE__*/ createWriteContract({
    abi: poolImplementationAbi,
    address: poolImplementationAddress,
    functionName: 'liquidationCall',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link poolImplementationAbi}__ and `functionName` set to `"mintToTreasury"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const writePoolImplementationMintToTreasury =
  /*#__PURE__*/ createWriteContract({
    abi: poolImplementationAbi,
    address: poolImplementationAddress,
    functionName: 'mintToTreasury',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link poolImplementationAbi}__ and `functionName` set to `"mintUnbacked"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const writePoolImplementationMintUnbacked =
  /*#__PURE__*/ createWriteContract({
    abi: poolImplementationAbi,
    address: poolImplementationAddress,
    functionName: 'mintUnbacked',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link poolImplementationAbi}__ and `functionName` set to `"rebalanceStableBorrowRate"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const writePoolImplementationRebalanceStableBorrowRate =
  /*#__PURE__*/ createWriteContract({
    abi: poolImplementationAbi,
    address: poolImplementationAddress,
    functionName: 'rebalanceStableBorrowRate',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link poolImplementationAbi}__ and `functionName` set to `"repay"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const writePoolImplementationRepay = /*#__PURE__*/ createWriteContract({
  abi: poolImplementationAbi,
  address: poolImplementationAddress,
  functionName: 'repay',
})

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link poolImplementationAbi}__ and `functionName` set to `"repayWithATokens"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const writePoolImplementationRepayWithATokens =
  /*#__PURE__*/ createWriteContract({
    abi: poolImplementationAbi,
    address: poolImplementationAddress,
    functionName: 'repayWithATokens',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link poolImplementationAbi}__ and `functionName` set to `"repayWithPermit"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const writePoolImplementationRepayWithPermit =
  /*#__PURE__*/ createWriteContract({
    abi: poolImplementationAbi,
    address: poolImplementationAddress,
    functionName: 'repayWithPermit',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link poolImplementationAbi}__ and `functionName` set to `"rescueTokens"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const writePoolImplementationRescueTokens =
  /*#__PURE__*/ createWriteContract({
    abi: poolImplementationAbi,
    address: poolImplementationAddress,
    functionName: 'rescueTokens',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link poolImplementationAbi}__ and `functionName` set to `"resetIsolationModeTotalDebt"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const writePoolImplementationResetIsolationModeTotalDebt =
  /*#__PURE__*/ createWriteContract({
    abi: poolImplementationAbi,
    address: poolImplementationAddress,
    functionName: 'resetIsolationModeTotalDebt',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link poolImplementationAbi}__ and `functionName` set to `"setConfiguration"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const writePoolImplementationSetConfiguration =
  /*#__PURE__*/ createWriteContract({
    abi: poolImplementationAbi,
    address: poolImplementationAddress,
    functionName: 'setConfiguration',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link poolImplementationAbi}__ and `functionName` set to `"setReserveInterestRateStrategyAddress"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const writePoolImplementationSetReserveInterestRateStrategyAddress =
  /*#__PURE__*/ createWriteContract({
    abi: poolImplementationAbi,
    address: poolImplementationAddress,
    functionName: 'setReserveInterestRateStrategyAddress',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link poolImplementationAbi}__ and `functionName` set to `"setUserEMode"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const writePoolImplementationSetUserEMode =
  /*#__PURE__*/ createWriteContract({
    abi: poolImplementationAbi,
    address: poolImplementationAddress,
    functionName: 'setUserEMode',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link poolImplementationAbi}__ and `functionName` set to `"setUserUseReserveAsCollateral"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const writePoolImplementationSetUserUseReserveAsCollateral =
  /*#__PURE__*/ createWriteContract({
    abi: poolImplementationAbi,
    address: poolImplementationAddress,
    functionName: 'setUserUseReserveAsCollateral',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link poolImplementationAbi}__ and `functionName` set to `"supply"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const writePoolImplementationSupply = /*#__PURE__*/ createWriteContract({
  abi: poolImplementationAbi,
  address: poolImplementationAddress,
  functionName: 'supply',
})

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link poolImplementationAbi}__ and `functionName` set to `"supplyWithPermit"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const writePoolImplementationSupplyWithPermit =
  /*#__PURE__*/ createWriteContract({
    abi: poolImplementationAbi,
    address: poolImplementationAddress,
    functionName: 'supplyWithPermit',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link poolImplementationAbi}__ and `functionName` set to `"swapBorrowRateMode"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const writePoolImplementationSwapBorrowRateMode =
  /*#__PURE__*/ createWriteContract({
    abi: poolImplementationAbi,
    address: poolImplementationAddress,
    functionName: 'swapBorrowRateMode',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link poolImplementationAbi}__ and `functionName` set to `"updateBridgeProtocolFee"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const writePoolImplementationUpdateBridgeProtocolFee =
  /*#__PURE__*/ createWriteContract({
    abi: poolImplementationAbi,
    address: poolImplementationAddress,
    functionName: 'updateBridgeProtocolFee',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link poolImplementationAbi}__ and `functionName` set to `"updateFlashloanPremiums"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const writePoolImplementationUpdateFlashloanPremiums =
  /*#__PURE__*/ createWriteContract({
    abi: poolImplementationAbi,
    address: poolImplementationAddress,
    functionName: 'updateFlashloanPremiums',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link poolImplementationAbi}__ and `functionName` set to `"withdraw"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const writePoolImplementationWithdraw =
  /*#__PURE__*/ createWriteContract({
    abi: poolImplementationAbi,
    address: poolImplementationAddress,
    functionName: 'withdraw',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link poolImplementationAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const simulatePoolImplementation = /*#__PURE__*/ createSimulateContract({
  abi: poolImplementationAbi,
  address: poolImplementationAddress,
})

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link poolImplementationAbi}__ and `functionName` set to `"backUnbacked"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const simulatePoolImplementationBackUnbacked =
  /*#__PURE__*/ createSimulateContract({
    abi: poolImplementationAbi,
    address: poolImplementationAddress,
    functionName: 'backUnbacked',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link poolImplementationAbi}__ and `functionName` set to `"borrow"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const simulatePoolImplementationBorrow =
  /*#__PURE__*/ createSimulateContract({
    abi: poolImplementationAbi,
    address: poolImplementationAddress,
    functionName: 'borrow',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link poolImplementationAbi}__ and `functionName` set to `"configureEModeCategory"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const simulatePoolImplementationConfigureEModeCategory =
  /*#__PURE__*/ createSimulateContract({
    abi: poolImplementationAbi,
    address: poolImplementationAddress,
    functionName: 'configureEModeCategory',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link poolImplementationAbi}__ and `functionName` set to `"deposit"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const simulatePoolImplementationDeposit =
  /*#__PURE__*/ createSimulateContract({
    abi: poolImplementationAbi,
    address: poolImplementationAddress,
    functionName: 'deposit',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link poolImplementationAbi}__ and `functionName` set to `"dropReserve"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const simulatePoolImplementationDropReserve =
  /*#__PURE__*/ createSimulateContract({
    abi: poolImplementationAbi,
    address: poolImplementationAddress,
    functionName: 'dropReserve',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link poolImplementationAbi}__ and `functionName` set to `"finalizeTransfer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const simulatePoolImplementationFinalizeTransfer =
  /*#__PURE__*/ createSimulateContract({
    abi: poolImplementationAbi,
    address: poolImplementationAddress,
    functionName: 'finalizeTransfer',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link poolImplementationAbi}__ and `functionName` set to `"flashLoan"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const simulatePoolImplementationFlashLoan =
  /*#__PURE__*/ createSimulateContract({
    abi: poolImplementationAbi,
    address: poolImplementationAddress,
    functionName: 'flashLoan',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link poolImplementationAbi}__ and `functionName` set to `"flashLoanSimple"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const simulatePoolImplementationFlashLoanSimple =
  /*#__PURE__*/ createSimulateContract({
    abi: poolImplementationAbi,
    address: poolImplementationAddress,
    functionName: 'flashLoanSimple',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link poolImplementationAbi}__ and `functionName` set to `"initReserve"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const simulatePoolImplementationInitReserve =
  /*#__PURE__*/ createSimulateContract({
    abi: poolImplementationAbi,
    address: poolImplementationAddress,
    functionName: 'initReserve',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link poolImplementationAbi}__ and `functionName` set to `"initialize"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const simulatePoolImplementationInitialize =
  /*#__PURE__*/ createSimulateContract({
    abi: poolImplementationAbi,
    address: poolImplementationAddress,
    functionName: 'initialize',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link poolImplementationAbi}__ and `functionName` set to `"liquidationCall"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const simulatePoolImplementationLiquidationCall =
  /*#__PURE__*/ createSimulateContract({
    abi: poolImplementationAbi,
    address: poolImplementationAddress,
    functionName: 'liquidationCall',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link poolImplementationAbi}__ and `functionName` set to `"mintToTreasury"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const simulatePoolImplementationMintToTreasury =
  /*#__PURE__*/ createSimulateContract({
    abi: poolImplementationAbi,
    address: poolImplementationAddress,
    functionName: 'mintToTreasury',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link poolImplementationAbi}__ and `functionName` set to `"mintUnbacked"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const simulatePoolImplementationMintUnbacked =
  /*#__PURE__*/ createSimulateContract({
    abi: poolImplementationAbi,
    address: poolImplementationAddress,
    functionName: 'mintUnbacked',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link poolImplementationAbi}__ and `functionName` set to `"rebalanceStableBorrowRate"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const simulatePoolImplementationRebalanceStableBorrowRate =
  /*#__PURE__*/ createSimulateContract({
    abi: poolImplementationAbi,
    address: poolImplementationAddress,
    functionName: 'rebalanceStableBorrowRate',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link poolImplementationAbi}__ and `functionName` set to `"repay"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const simulatePoolImplementationRepay =
  /*#__PURE__*/ createSimulateContract({
    abi: poolImplementationAbi,
    address: poolImplementationAddress,
    functionName: 'repay',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link poolImplementationAbi}__ and `functionName` set to `"repayWithATokens"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const simulatePoolImplementationRepayWithATokens =
  /*#__PURE__*/ createSimulateContract({
    abi: poolImplementationAbi,
    address: poolImplementationAddress,
    functionName: 'repayWithATokens',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link poolImplementationAbi}__ and `functionName` set to `"repayWithPermit"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const simulatePoolImplementationRepayWithPermit =
  /*#__PURE__*/ createSimulateContract({
    abi: poolImplementationAbi,
    address: poolImplementationAddress,
    functionName: 'repayWithPermit',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link poolImplementationAbi}__ and `functionName` set to `"rescueTokens"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const simulatePoolImplementationRescueTokens =
  /*#__PURE__*/ createSimulateContract({
    abi: poolImplementationAbi,
    address: poolImplementationAddress,
    functionName: 'rescueTokens',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link poolImplementationAbi}__ and `functionName` set to `"resetIsolationModeTotalDebt"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const simulatePoolImplementationResetIsolationModeTotalDebt =
  /*#__PURE__*/ createSimulateContract({
    abi: poolImplementationAbi,
    address: poolImplementationAddress,
    functionName: 'resetIsolationModeTotalDebt',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link poolImplementationAbi}__ and `functionName` set to `"setConfiguration"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const simulatePoolImplementationSetConfiguration =
  /*#__PURE__*/ createSimulateContract({
    abi: poolImplementationAbi,
    address: poolImplementationAddress,
    functionName: 'setConfiguration',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link poolImplementationAbi}__ and `functionName` set to `"setReserveInterestRateStrategyAddress"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const simulatePoolImplementationSetReserveInterestRateStrategyAddress =
  /*#__PURE__*/ createSimulateContract({
    abi: poolImplementationAbi,
    address: poolImplementationAddress,
    functionName: 'setReserveInterestRateStrategyAddress',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link poolImplementationAbi}__ and `functionName` set to `"setUserEMode"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const simulatePoolImplementationSetUserEMode =
  /*#__PURE__*/ createSimulateContract({
    abi: poolImplementationAbi,
    address: poolImplementationAddress,
    functionName: 'setUserEMode',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link poolImplementationAbi}__ and `functionName` set to `"setUserUseReserveAsCollateral"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const simulatePoolImplementationSetUserUseReserveAsCollateral =
  /*#__PURE__*/ createSimulateContract({
    abi: poolImplementationAbi,
    address: poolImplementationAddress,
    functionName: 'setUserUseReserveAsCollateral',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link poolImplementationAbi}__ and `functionName` set to `"supply"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const simulatePoolImplementationSupply =
  /*#__PURE__*/ createSimulateContract({
    abi: poolImplementationAbi,
    address: poolImplementationAddress,
    functionName: 'supply',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link poolImplementationAbi}__ and `functionName` set to `"supplyWithPermit"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const simulatePoolImplementationSupplyWithPermit =
  /*#__PURE__*/ createSimulateContract({
    abi: poolImplementationAbi,
    address: poolImplementationAddress,
    functionName: 'supplyWithPermit',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link poolImplementationAbi}__ and `functionName` set to `"swapBorrowRateMode"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const simulatePoolImplementationSwapBorrowRateMode =
  /*#__PURE__*/ createSimulateContract({
    abi: poolImplementationAbi,
    address: poolImplementationAddress,
    functionName: 'swapBorrowRateMode',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link poolImplementationAbi}__ and `functionName` set to `"updateBridgeProtocolFee"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const simulatePoolImplementationUpdateBridgeProtocolFee =
  /*#__PURE__*/ createSimulateContract({
    abi: poolImplementationAbi,
    address: poolImplementationAddress,
    functionName: 'updateBridgeProtocolFee',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link poolImplementationAbi}__ and `functionName` set to `"updateFlashloanPremiums"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const simulatePoolImplementationUpdateFlashloanPremiums =
  /*#__PURE__*/ createSimulateContract({
    abi: poolImplementationAbi,
    address: poolImplementationAddress,
    functionName: 'updateFlashloanPremiums',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link poolImplementationAbi}__ and `functionName` set to `"withdraw"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const simulatePoolImplementationWithdraw =
  /*#__PURE__*/ createSimulateContract({
    abi: poolImplementationAbi,
    address: poolImplementationAddress,
    functionName: 'withdraw',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link poolImplementationAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const watchPoolImplementationEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: poolImplementationAbi,
    address: poolImplementationAddress,
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link poolImplementationAbi}__ and `eventName` set to `"BackUnbacked"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const watchPoolImplementationBackUnbackedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: poolImplementationAbi,
    address: poolImplementationAddress,
    eventName: 'BackUnbacked',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link poolImplementationAbi}__ and `eventName` set to `"Borrow"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const watchPoolImplementationBorrowEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: poolImplementationAbi,
    address: poolImplementationAddress,
    eventName: 'Borrow',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link poolImplementationAbi}__ and `eventName` set to `"FlashLoan"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const watchPoolImplementationFlashLoanEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: poolImplementationAbi,
    address: poolImplementationAddress,
    eventName: 'FlashLoan',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link poolImplementationAbi}__ and `eventName` set to `"IsolationModeTotalDebtUpdated"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const watchPoolImplementationIsolationModeTotalDebtUpdatedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: poolImplementationAbi,
    address: poolImplementationAddress,
    eventName: 'IsolationModeTotalDebtUpdated',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link poolImplementationAbi}__ and `eventName` set to `"LiquidationCall"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const watchPoolImplementationLiquidationCallEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: poolImplementationAbi,
    address: poolImplementationAddress,
    eventName: 'LiquidationCall',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link poolImplementationAbi}__ and `eventName` set to `"MintUnbacked"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const watchPoolImplementationMintUnbackedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: poolImplementationAbi,
    address: poolImplementationAddress,
    eventName: 'MintUnbacked',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link poolImplementationAbi}__ and `eventName` set to `"MintedToTreasury"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const watchPoolImplementationMintedToTreasuryEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: poolImplementationAbi,
    address: poolImplementationAddress,
    eventName: 'MintedToTreasury',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link poolImplementationAbi}__ and `eventName` set to `"RebalanceStableBorrowRate"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const watchPoolImplementationRebalanceStableBorrowRateEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: poolImplementationAbi,
    address: poolImplementationAddress,
    eventName: 'RebalanceStableBorrowRate',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link poolImplementationAbi}__ and `eventName` set to `"Repay"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const watchPoolImplementationRepayEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: poolImplementationAbi,
    address: poolImplementationAddress,
    eventName: 'Repay',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link poolImplementationAbi}__ and `eventName` set to `"ReserveDataUpdated"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const watchPoolImplementationReserveDataUpdatedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: poolImplementationAbi,
    address: poolImplementationAddress,
    eventName: 'ReserveDataUpdated',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link poolImplementationAbi}__ and `eventName` set to `"ReserveUsedAsCollateralDisabled"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const watchPoolImplementationReserveUsedAsCollateralDisabledEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: poolImplementationAbi,
    address: poolImplementationAddress,
    eventName: 'ReserveUsedAsCollateralDisabled',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link poolImplementationAbi}__ and `eventName` set to `"ReserveUsedAsCollateralEnabled"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const watchPoolImplementationReserveUsedAsCollateralEnabledEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: poolImplementationAbi,
    address: poolImplementationAddress,
    eventName: 'ReserveUsedAsCollateralEnabled',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link poolImplementationAbi}__ and `eventName` set to `"Supply"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const watchPoolImplementationSupplyEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: poolImplementationAbi,
    address: poolImplementationAddress,
    eventName: 'Supply',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link poolImplementationAbi}__ and `eventName` set to `"SwapBorrowRateMode"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const watchPoolImplementationSwapBorrowRateModeEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: poolImplementationAbi,
    address: poolImplementationAddress,
    eventName: 'SwapBorrowRateMode',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link poolImplementationAbi}__ and `eventName` set to `"UserEModeSet"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const watchPoolImplementationUserEModeSetEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: poolImplementationAbi,
    address: poolImplementationAddress,
    eventName: 'UserEModeSet',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link poolImplementationAbi}__ and `eventName` set to `"Withdraw"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xF32fc8E3DF99A76112381568abf860bE3cc4D11C)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9DdbeD6817466F31E8f5A578e62a0fc295CA2420)
 */
export const watchPoolImplementationWithdrawEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: poolImplementationAbi,
    address: poolImplementationAddress,
    eventName: 'Withdraw',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link poolProxyTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xC67c87a333E33d934d831AE8c6CE4Da47C3809fA)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x625B9FAefF9A9c843ba3fDe62C6E3bAb1a48eE78)
 */
export const writePoolProxyTaiko = /*#__PURE__*/ createWriteContract({
  abi: poolProxyTaikoAbi,
  address: poolProxyTaikoAddress,
})

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link poolProxyTaikoAbi}__ and `functionName` set to `"admin"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xC67c87a333E33d934d831AE8c6CE4Da47C3809fA)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x625B9FAefF9A9c843ba3fDe62C6E3bAb1a48eE78)
 */
export const writePoolProxyTaikoAdmin = /*#__PURE__*/ createWriteContract({
  abi: poolProxyTaikoAbi,
  address: poolProxyTaikoAddress,
  functionName: 'admin',
})

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link poolProxyTaikoAbi}__ and `functionName` set to `"implementation"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xC67c87a333E33d934d831AE8c6CE4Da47C3809fA)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x625B9FAefF9A9c843ba3fDe62C6E3bAb1a48eE78)
 */
export const writePoolProxyTaikoImplementation =
  /*#__PURE__*/ createWriteContract({
    abi: poolProxyTaikoAbi,
    address: poolProxyTaikoAddress,
    functionName: 'implementation',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link poolProxyTaikoAbi}__ and `functionName` set to `"initialize"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xC67c87a333E33d934d831AE8c6CE4Da47C3809fA)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x625B9FAefF9A9c843ba3fDe62C6E3bAb1a48eE78)
 */
export const writePoolProxyTaikoInitialize = /*#__PURE__*/ createWriteContract({
  abi: poolProxyTaikoAbi,
  address: poolProxyTaikoAddress,
  functionName: 'initialize',
})

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link poolProxyTaikoAbi}__ and `functionName` set to `"upgradeTo"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xC67c87a333E33d934d831AE8c6CE4Da47C3809fA)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x625B9FAefF9A9c843ba3fDe62C6E3bAb1a48eE78)
 */
export const writePoolProxyTaikoUpgradeTo = /*#__PURE__*/ createWriteContract({
  abi: poolProxyTaikoAbi,
  address: poolProxyTaikoAddress,
  functionName: 'upgradeTo',
})

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link poolProxyTaikoAbi}__ and `functionName` set to `"upgradeToAndCall"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xC67c87a333E33d934d831AE8c6CE4Da47C3809fA)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x625B9FAefF9A9c843ba3fDe62C6E3bAb1a48eE78)
 */
export const writePoolProxyTaikoUpgradeToAndCall =
  /*#__PURE__*/ createWriteContract({
    abi: poolProxyTaikoAbi,
    address: poolProxyTaikoAddress,
    functionName: 'upgradeToAndCall',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link poolProxyTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xC67c87a333E33d934d831AE8c6CE4Da47C3809fA)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x625B9FAefF9A9c843ba3fDe62C6E3bAb1a48eE78)
 */
export const simulatePoolProxyTaiko = /*#__PURE__*/ createSimulateContract({
  abi: poolProxyTaikoAbi,
  address: poolProxyTaikoAddress,
})

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link poolProxyTaikoAbi}__ and `functionName` set to `"admin"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xC67c87a333E33d934d831AE8c6CE4Da47C3809fA)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x625B9FAefF9A9c843ba3fDe62C6E3bAb1a48eE78)
 */
export const simulatePoolProxyTaikoAdmin = /*#__PURE__*/ createSimulateContract(
  {
    abi: poolProxyTaikoAbi,
    address: poolProxyTaikoAddress,
    functionName: 'admin',
  },
)

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link poolProxyTaikoAbi}__ and `functionName` set to `"implementation"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xC67c87a333E33d934d831AE8c6CE4Da47C3809fA)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x625B9FAefF9A9c843ba3fDe62C6E3bAb1a48eE78)
 */
export const simulatePoolProxyTaikoImplementation =
  /*#__PURE__*/ createSimulateContract({
    abi: poolProxyTaikoAbi,
    address: poolProxyTaikoAddress,
    functionName: 'implementation',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link poolProxyTaikoAbi}__ and `functionName` set to `"initialize"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xC67c87a333E33d934d831AE8c6CE4Da47C3809fA)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x625B9FAefF9A9c843ba3fDe62C6E3bAb1a48eE78)
 */
export const simulatePoolProxyTaikoInitialize =
  /*#__PURE__*/ createSimulateContract({
    abi: poolProxyTaikoAbi,
    address: poolProxyTaikoAddress,
    functionName: 'initialize',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link poolProxyTaikoAbi}__ and `functionName` set to `"upgradeTo"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xC67c87a333E33d934d831AE8c6CE4Da47C3809fA)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x625B9FAefF9A9c843ba3fDe62C6E3bAb1a48eE78)
 */
export const simulatePoolProxyTaikoUpgradeTo =
  /*#__PURE__*/ createSimulateContract({
    abi: poolProxyTaikoAbi,
    address: poolProxyTaikoAddress,
    functionName: 'upgradeTo',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link poolProxyTaikoAbi}__ and `functionName` set to `"upgradeToAndCall"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xC67c87a333E33d934d831AE8c6CE4Da47C3809fA)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x625B9FAefF9A9c843ba3fDe62C6E3bAb1a48eE78)
 */
export const simulatePoolProxyTaikoUpgradeToAndCall =
  /*#__PURE__*/ createSimulateContract({
    abi: poolProxyTaikoAbi,
    address: poolProxyTaikoAddress,
    functionName: 'upgradeToAndCall',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link poolProxyTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xC67c87a333E33d934d831AE8c6CE4Da47C3809fA)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x625B9FAefF9A9c843ba3fDe62C6E3bAb1a48eE78)
 */
export const watchPoolProxyTaikoEvent = /*#__PURE__*/ createWatchContractEvent({
  abi: poolProxyTaikoAbi,
  address: poolProxyTaikoAddress,
})

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link poolProxyTaikoAbi}__ and `eventName` set to `"Upgraded"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xC67c87a333E33d934d831AE8c6CE4Da47C3809fA)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x625B9FAefF9A9c843ba3fDe62C6E3bAb1a48eE78)
 */
export const watchPoolProxyTaikoUpgradedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: poolProxyTaikoAbi,
    address: poolProxyTaikoAddress,
    eventName: 'Upgraded',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link poolAddressesProviderTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xAb31CA5C925921d92750190732FdC347C23F9987)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa357E6d3Fdea67F4F2D60fC22F037551682AAd95)
 */
export const readPoolAddressesProviderTaiko = /*#__PURE__*/ createReadContract({
  abi: poolAddressesProviderTaikoAbi,
  address: poolAddressesProviderTaikoAddress,
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link poolAddressesProviderTaikoAbi}__ and `functionName` set to `"getACLAdmin"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xAb31CA5C925921d92750190732FdC347C23F9987)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa357E6d3Fdea67F4F2D60fC22F037551682AAd95)
 */
export const readPoolAddressesProviderTaikoGetAclAdmin =
  /*#__PURE__*/ createReadContract({
    abi: poolAddressesProviderTaikoAbi,
    address: poolAddressesProviderTaikoAddress,
    functionName: 'getACLAdmin',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link poolAddressesProviderTaikoAbi}__ and `functionName` set to `"getACLManager"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xAb31CA5C925921d92750190732FdC347C23F9987)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa357E6d3Fdea67F4F2D60fC22F037551682AAd95)
 */
export const readPoolAddressesProviderTaikoGetAclManager =
  /*#__PURE__*/ createReadContract({
    abi: poolAddressesProviderTaikoAbi,
    address: poolAddressesProviderTaikoAddress,
    functionName: 'getACLManager',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link poolAddressesProviderTaikoAbi}__ and `functionName` set to `"getAddress"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xAb31CA5C925921d92750190732FdC347C23F9987)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa357E6d3Fdea67F4F2D60fC22F037551682AAd95)
 */
export const readPoolAddressesProviderTaikoGetAddress =
  /*#__PURE__*/ createReadContract({
    abi: poolAddressesProviderTaikoAbi,
    address: poolAddressesProviderTaikoAddress,
    functionName: 'getAddress',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link poolAddressesProviderTaikoAbi}__ and `functionName` set to `"getMarketId"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xAb31CA5C925921d92750190732FdC347C23F9987)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa357E6d3Fdea67F4F2D60fC22F037551682AAd95)
 */
export const readPoolAddressesProviderTaikoGetMarketId =
  /*#__PURE__*/ createReadContract({
    abi: poolAddressesProviderTaikoAbi,
    address: poolAddressesProviderTaikoAddress,
    functionName: 'getMarketId',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link poolAddressesProviderTaikoAbi}__ and `functionName` set to `"getPool"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xAb31CA5C925921d92750190732FdC347C23F9987)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa357E6d3Fdea67F4F2D60fC22F037551682AAd95)
 */
export const readPoolAddressesProviderTaikoGetPool =
  /*#__PURE__*/ createReadContract({
    abi: poolAddressesProviderTaikoAbi,
    address: poolAddressesProviderTaikoAddress,
    functionName: 'getPool',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link poolAddressesProviderTaikoAbi}__ and `functionName` set to `"getPoolConfigurator"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xAb31CA5C925921d92750190732FdC347C23F9987)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa357E6d3Fdea67F4F2D60fC22F037551682AAd95)
 */
export const readPoolAddressesProviderTaikoGetPoolConfigurator =
  /*#__PURE__*/ createReadContract({
    abi: poolAddressesProviderTaikoAbi,
    address: poolAddressesProviderTaikoAddress,
    functionName: 'getPoolConfigurator',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link poolAddressesProviderTaikoAbi}__ and `functionName` set to `"getPoolDataProvider"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xAb31CA5C925921d92750190732FdC347C23F9987)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa357E6d3Fdea67F4F2D60fC22F037551682AAd95)
 */
export const readPoolAddressesProviderTaikoGetPoolDataProvider =
  /*#__PURE__*/ createReadContract({
    abi: poolAddressesProviderTaikoAbi,
    address: poolAddressesProviderTaikoAddress,
    functionName: 'getPoolDataProvider',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link poolAddressesProviderTaikoAbi}__ and `functionName` set to `"getPriceOracle"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xAb31CA5C925921d92750190732FdC347C23F9987)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa357E6d3Fdea67F4F2D60fC22F037551682AAd95)
 */
export const readPoolAddressesProviderTaikoGetPriceOracle =
  /*#__PURE__*/ createReadContract({
    abi: poolAddressesProviderTaikoAbi,
    address: poolAddressesProviderTaikoAddress,
    functionName: 'getPriceOracle',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link poolAddressesProviderTaikoAbi}__ and `functionName` set to `"getPriceOracleSentinel"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xAb31CA5C925921d92750190732FdC347C23F9987)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa357E6d3Fdea67F4F2D60fC22F037551682AAd95)
 */
export const readPoolAddressesProviderTaikoGetPriceOracleSentinel =
  /*#__PURE__*/ createReadContract({
    abi: poolAddressesProviderTaikoAbi,
    address: poolAddressesProviderTaikoAddress,
    functionName: 'getPriceOracleSentinel',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link poolAddressesProviderTaikoAbi}__ and `functionName` set to `"owner"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xAb31CA5C925921d92750190732FdC347C23F9987)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa357E6d3Fdea67F4F2D60fC22F037551682AAd95)
 */
export const readPoolAddressesProviderTaikoOwner =
  /*#__PURE__*/ createReadContract({
    abi: poolAddressesProviderTaikoAbi,
    address: poolAddressesProviderTaikoAddress,
    functionName: 'owner',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link poolAddressesProviderTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xAb31CA5C925921d92750190732FdC347C23F9987)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa357E6d3Fdea67F4F2D60fC22F037551682AAd95)
 */
export const writePoolAddressesProviderTaiko =
  /*#__PURE__*/ createWriteContract({
    abi: poolAddressesProviderTaikoAbi,
    address: poolAddressesProviderTaikoAddress,
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link poolAddressesProviderTaikoAbi}__ and `functionName` set to `"renounceOwnership"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xAb31CA5C925921d92750190732FdC347C23F9987)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa357E6d3Fdea67F4F2D60fC22F037551682AAd95)
 */
export const writePoolAddressesProviderTaikoRenounceOwnership =
  /*#__PURE__*/ createWriteContract({
    abi: poolAddressesProviderTaikoAbi,
    address: poolAddressesProviderTaikoAddress,
    functionName: 'renounceOwnership',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link poolAddressesProviderTaikoAbi}__ and `functionName` set to `"setACLAdmin"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xAb31CA5C925921d92750190732FdC347C23F9987)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa357E6d3Fdea67F4F2D60fC22F037551682AAd95)
 */
export const writePoolAddressesProviderTaikoSetAclAdmin =
  /*#__PURE__*/ createWriteContract({
    abi: poolAddressesProviderTaikoAbi,
    address: poolAddressesProviderTaikoAddress,
    functionName: 'setACLAdmin',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link poolAddressesProviderTaikoAbi}__ and `functionName` set to `"setACLManager"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xAb31CA5C925921d92750190732FdC347C23F9987)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa357E6d3Fdea67F4F2D60fC22F037551682AAd95)
 */
export const writePoolAddressesProviderTaikoSetAclManager =
  /*#__PURE__*/ createWriteContract({
    abi: poolAddressesProviderTaikoAbi,
    address: poolAddressesProviderTaikoAddress,
    functionName: 'setACLManager',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link poolAddressesProviderTaikoAbi}__ and `functionName` set to `"setAddress"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xAb31CA5C925921d92750190732FdC347C23F9987)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa357E6d3Fdea67F4F2D60fC22F037551682AAd95)
 */
export const writePoolAddressesProviderTaikoSetAddress =
  /*#__PURE__*/ createWriteContract({
    abi: poolAddressesProviderTaikoAbi,
    address: poolAddressesProviderTaikoAddress,
    functionName: 'setAddress',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link poolAddressesProviderTaikoAbi}__ and `functionName` set to `"setAddressAsProxy"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xAb31CA5C925921d92750190732FdC347C23F9987)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa357E6d3Fdea67F4F2D60fC22F037551682AAd95)
 */
export const writePoolAddressesProviderTaikoSetAddressAsProxy =
  /*#__PURE__*/ createWriteContract({
    abi: poolAddressesProviderTaikoAbi,
    address: poolAddressesProviderTaikoAddress,
    functionName: 'setAddressAsProxy',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link poolAddressesProviderTaikoAbi}__ and `functionName` set to `"setMarketId"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xAb31CA5C925921d92750190732FdC347C23F9987)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa357E6d3Fdea67F4F2D60fC22F037551682AAd95)
 */
export const writePoolAddressesProviderTaikoSetMarketId =
  /*#__PURE__*/ createWriteContract({
    abi: poolAddressesProviderTaikoAbi,
    address: poolAddressesProviderTaikoAddress,
    functionName: 'setMarketId',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link poolAddressesProviderTaikoAbi}__ and `functionName` set to `"setPoolConfiguratorImpl"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xAb31CA5C925921d92750190732FdC347C23F9987)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa357E6d3Fdea67F4F2D60fC22F037551682AAd95)
 */
export const writePoolAddressesProviderTaikoSetPoolConfiguratorImpl =
  /*#__PURE__*/ createWriteContract({
    abi: poolAddressesProviderTaikoAbi,
    address: poolAddressesProviderTaikoAddress,
    functionName: 'setPoolConfiguratorImpl',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link poolAddressesProviderTaikoAbi}__ and `functionName` set to `"setPoolDataProvider"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xAb31CA5C925921d92750190732FdC347C23F9987)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa357E6d3Fdea67F4F2D60fC22F037551682AAd95)
 */
export const writePoolAddressesProviderTaikoSetPoolDataProvider =
  /*#__PURE__*/ createWriteContract({
    abi: poolAddressesProviderTaikoAbi,
    address: poolAddressesProviderTaikoAddress,
    functionName: 'setPoolDataProvider',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link poolAddressesProviderTaikoAbi}__ and `functionName` set to `"setPoolImpl"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xAb31CA5C925921d92750190732FdC347C23F9987)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa357E6d3Fdea67F4F2D60fC22F037551682AAd95)
 */
export const writePoolAddressesProviderTaikoSetPoolImpl =
  /*#__PURE__*/ createWriteContract({
    abi: poolAddressesProviderTaikoAbi,
    address: poolAddressesProviderTaikoAddress,
    functionName: 'setPoolImpl',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link poolAddressesProviderTaikoAbi}__ and `functionName` set to `"setPriceOracle"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xAb31CA5C925921d92750190732FdC347C23F9987)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa357E6d3Fdea67F4F2D60fC22F037551682AAd95)
 */
export const writePoolAddressesProviderTaikoSetPriceOracle =
  /*#__PURE__*/ createWriteContract({
    abi: poolAddressesProviderTaikoAbi,
    address: poolAddressesProviderTaikoAddress,
    functionName: 'setPriceOracle',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link poolAddressesProviderTaikoAbi}__ and `functionName` set to `"setPriceOracleSentinel"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xAb31CA5C925921d92750190732FdC347C23F9987)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa357E6d3Fdea67F4F2D60fC22F037551682AAd95)
 */
export const writePoolAddressesProviderTaikoSetPriceOracleSentinel =
  /*#__PURE__*/ createWriteContract({
    abi: poolAddressesProviderTaikoAbi,
    address: poolAddressesProviderTaikoAddress,
    functionName: 'setPriceOracleSentinel',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link poolAddressesProviderTaikoAbi}__ and `functionName` set to `"transferOwnership"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xAb31CA5C925921d92750190732FdC347C23F9987)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa357E6d3Fdea67F4F2D60fC22F037551682AAd95)
 */
export const writePoolAddressesProviderTaikoTransferOwnership =
  /*#__PURE__*/ createWriteContract({
    abi: poolAddressesProviderTaikoAbi,
    address: poolAddressesProviderTaikoAddress,
    functionName: 'transferOwnership',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link poolAddressesProviderTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xAb31CA5C925921d92750190732FdC347C23F9987)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa357E6d3Fdea67F4F2D60fC22F037551682AAd95)
 */
export const simulatePoolAddressesProviderTaiko =
  /*#__PURE__*/ createSimulateContract({
    abi: poolAddressesProviderTaikoAbi,
    address: poolAddressesProviderTaikoAddress,
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link poolAddressesProviderTaikoAbi}__ and `functionName` set to `"renounceOwnership"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xAb31CA5C925921d92750190732FdC347C23F9987)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa357E6d3Fdea67F4F2D60fC22F037551682AAd95)
 */
export const simulatePoolAddressesProviderTaikoRenounceOwnership =
  /*#__PURE__*/ createSimulateContract({
    abi: poolAddressesProviderTaikoAbi,
    address: poolAddressesProviderTaikoAddress,
    functionName: 'renounceOwnership',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link poolAddressesProviderTaikoAbi}__ and `functionName` set to `"setACLAdmin"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xAb31CA5C925921d92750190732FdC347C23F9987)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa357E6d3Fdea67F4F2D60fC22F037551682AAd95)
 */
export const simulatePoolAddressesProviderTaikoSetAclAdmin =
  /*#__PURE__*/ createSimulateContract({
    abi: poolAddressesProviderTaikoAbi,
    address: poolAddressesProviderTaikoAddress,
    functionName: 'setACLAdmin',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link poolAddressesProviderTaikoAbi}__ and `functionName` set to `"setACLManager"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xAb31CA5C925921d92750190732FdC347C23F9987)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa357E6d3Fdea67F4F2D60fC22F037551682AAd95)
 */
export const simulatePoolAddressesProviderTaikoSetAclManager =
  /*#__PURE__*/ createSimulateContract({
    abi: poolAddressesProviderTaikoAbi,
    address: poolAddressesProviderTaikoAddress,
    functionName: 'setACLManager',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link poolAddressesProviderTaikoAbi}__ and `functionName` set to `"setAddress"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xAb31CA5C925921d92750190732FdC347C23F9987)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa357E6d3Fdea67F4F2D60fC22F037551682AAd95)
 */
export const simulatePoolAddressesProviderTaikoSetAddress =
  /*#__PURE__*/ createSimulateContract({
    abi: poolAddressesProviderTaikoAbi,
    address: poolAddressesProviderTaikoAddress,
    functionName: 'setAddress',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link poolAddressesProviderTaikoAbi}__ and `functionName` set to `"setAddressAsProxy"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xAb31CA5C925921d92750190732FdC347C23F9987)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa357E6d3Fdea67F4F2D60fC22F037551682AAd95)
 */
export const simulatePoolAddressesProviderTaikoSetAddressAsProxy =
  /*#__PURE__*/ createSimulateContract({
    abi: poolAddressesProviderTaikoAbi,
    address: poolAddressesProviderTaikoAddress,
    functionName: 'setAddressAsProxy',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link poolAddressesProviderTaikoAbi}__ and `functionName` set to `"setMarketId"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xAb31CA5C925921d92750190732FdC347C23F9987)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa357E6d3Fdea67F4F2D60fC22F037551682AAd95)
 */
export const simulatePoolAddressesProviderTaikoSetMarketId =
  /*#__PURE__*/ createSimulateContract({
    abi: poolAddressesProviderTaikoAbi,
    address: poolAddressesProviderTaikoAddress,
    functionName: 'setMarketId',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link poolAddressesProviderTaikoAbi}__ and `functionName` set to `"setPoolConfiguratorImpl"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xAb31CA5C925921d92750190732FdC347C23F9987)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa357E6d3Fdea67F4F2D60fC22F037551682AAd95)
 */
export const simulatePoolAddressesProviderTaikoSetPoolConfiguratorImpl =
  /*#__PURE__*/ createSimulateContract({
    abi: poolAddressesProviderTaikoAbi,
    address: poolAddressesProviderTaikoAddress,
    functionName: 'setPoolConfiguratorImpl',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link poolAddressesProviderTaikoAbi}__ and `functionName` set to `"setPoolDataProvider"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xAb31CA5C925921d92750190732FdC347C23F9987)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa357E6d3Fdea67F4F2D60fC22F037551682AAd95)
 */
export const simulatePoolAddressesProviderTaikoSetPoolDataProvider =
  /*#__PURE__*/ createSimulateContract({
    abi: poolAddressesProviderTaikoAbi,
    address: poolAddressesProviderTaikoAddress,
    functionName: 'setPoolDataProvider',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link poolAddressesProviderTaikoAbi}__ and `functionName` set to `"setPoolImpl"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xAb31CA5C925921d92750190732FdC347C23F9987)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa357E6d3Fdea67F4F2D60fC22F037551682AAd95)
 */
export const simulatePoolAddressesProviderTaikoSetPoolImpl =
  /*#__PURE__*/ createSimulateContract({
    abi: poolAddressesProviderTaikoAbi,
    address: poolAddressesProviderTaikoAddress,
    functionName: 'setPoolImpl',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link poolAddressesProviderTaikoAbi}__ and `functionName` set to `"setPriceOracle"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xAb31CA5C925921d92750190732FdC347C23F9987)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa357E6d3Fdea67F4F2D60fC22F037551682AAd95)
 */
export const simulatePoolAddressesProviderTaikoSetPriceOracle =
  /*#__PURE__*/ createSimulateContract({
    abi: poolAddressesProviderTaikoAbi,
    address: poolAddressesProviderTaikoAddress,
    functionName: 'setPriceOracle',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link poolAddressesProviderTaikoAbi}__ and `functionName` set to `"setPriceOracleSentinel"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xAb31CA5C925921d92750190732FdC347C23F9987)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa357E6d3Fdea67F4F2D60fC22F037551682AAd95)
 */
export const simulatePoolAddressesProviderTaikoSetPriceOracleSentinel =
  /*#__PURE__*/ createSimulateContract({
    abi: poolAddressesProviderTaikoAbi,
    address: poolAddressesProviderTaikoAddress,
    functionName: 'setPriceOracleSentinel',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link poolAddressesProviderTaikoAbi}__ and `functionName` set to `"transferOwnership"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xAb31CA5C925921d92750190732FdC347C23F9987)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa357E6d3Fdea67F4F2D60fC22F037551682AAd95)
 */
export const simulatePoolAddressesProviderTaikoTransferOwnership =
  /*#__PURE__*/ createSimulateContract({
    abi: poolAddressesProviderTaikoAbi,
    address: poolAddressesProviderTaikoAddress,
    functionName: 'transferOwnership',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link poolAddressesProviderTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xAb31CA5C925921d92750190732FdC347C23F9987)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa357E6d3Fdea67F4F2D60fC22F037551682AAd95)
 */
export const watchPoolAddressesProviderTaikoEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: poolAddressesProviderTaikoAbi,
    address: poolAddressesProviderTaikoAddress,
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link poolAddressesProviderTaikoAbi}__ and `eventName` set to `"ACLAdminUpdated"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xAb31CA5C925921d92750190732FdC347C23F9987)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa357E6d3Fdea67F4F2D60fC22F037551682AAd95)
 */
export const watchPoolAddressesProviderTaikoAclAdminUpdatedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: poolAddressesProviderTaikoAbi,
    address: poolAddressesProviderTaikoAddress,
    eventName: 'ACLAdminUpdated',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link poolAddressesProviderTaikoAbi}__ and `eventName` set to `"ACLManagerUpdated"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xAb31CA5C925921d92750190732FdC347C23F9987)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa357E6d3Fdea67F4F2D60fC22F037551682AAd95)
 */
export const watchPoolAddressesProviderTaikoAclManagerUpdatedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: poolAddressesProviderTaikoAbi,
    address: poolAddressesProviderTaikoAddress,
    eventName: 'ACLManagerUpdated',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link poolAddressesProviderTaikoAbi}__ and `eventName` set to `"AddressSet"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xAb31CA5C925921d92750190732FdC347C23F9987)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa357E6d3Fdea67F4F2D60fC22F037551682AAd95)
 */
export const watchPoolAddressesProviderTaikoAddressSetEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: poolAddressesProviderTaikoAbi,
    address: poolAddressesProviderTaikoAddress,
    eventName: 'AddressSet',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link poolAddressesProviderTaikoAbi}__ and `eventName` set to `"AddressSetAsProxy"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xAb31CA5C925921d92750190732FdC347C23F9987)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa357E6d3Fdea67F4F2D60fC22F037551682AAd95)
 */
export const watchPoolAddressesProviderTaikoAddressSetAsProxyEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: poolAddressesProviderTaikoAbi,
    address: poolAddressesProviderTaikoAddress,
    eventName: 'AddressSetAsProxy',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link poolAddressesProviderTaikoAbi}__ and `eventName` set to `"MarketIdSet"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xAb31CA5C925921d92750190732FdC347C23F9987)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa357E6d3Fdea67F4F2D60fC22F037551682AAd95)
 */
export const watchPoolAddressesProviderTaikoMarketIdSetEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: poolAddressesProviderTaikoAbi,
    address: poolAddressesProviderTaikoAddress,
    eventName: 'MarketIdSet',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link poolAddressesProviderTaikoAbi}__ and `eventName` set to `"OwnershipTransferred"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xAb31CA5C925921d92750190732FdC347C23F9987)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa357E6d3Fdea67F4F2D60fC22F037551682AAd95)
 */
export const watchPoolAddressesProviderTaikoOwnershipTransferredEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: poolAddressesProviderTaikoAbi,
    address: poolAddressesProviderTaikoAddress,
    eventName: 'OwnershipTransferred',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link poolAddressesProviderTaikoAbi}__ and `eventName` set to `"PoolConfiguratorUpdated"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xAb31CA5C925921d92750190732FdC347C23F9987)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa357E6d3Fdea67F4F2D60fC22F037551682AAd95)
 */
export const watchPoolAddressesProviderTaikoPoolConfiguratorUpdatedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: poolAddressesProviderTaikoAbi,
    address: poolAddressesProviderTaikoAddress,
    eventName: 'PoolConfiguratorUpdated',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link poolAddressesProviderTaikoAbi}__ and `eventName` set to `"PoolDataProviderUpdated"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xAb31CA5C925921d92750190732FdC347C23F9987)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa357E6d3Fdea67F4F2D60fC22F037551682AAd95)
 */
export const watchPoolAddressesProviderTaikoPoolDataProviderUpdatedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: poolAddressesProviderTaikoAbi,
    address: poolAddressesProviderTaikoAddress,
    eventName: 'PoolDataProviderUpdated',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link poolAddressesProviderTaikoAbi}__ and `eventName` set to `"PoolUpdated"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xAb31CA5C925921d92750190732FdC347C23F9987)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa357E6d3Fdea67F4F2D60fC22F037551682AAd95)
 */
export const watchPoolAddressesProviderTaikoPoolUpdatedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: poolAddressesProviderTaikoAbi,
    address: poolAddressesProviderTaikoAddress,
    eventName: 'PoolUpdated',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link poolAddressesProviderTaikoAbi}__ and `eventName` set to `"PriceOracleSentinelUpdated"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xAb31CA5C925921d92750190732FdC347C23F9987)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa357E6d3Fdea67F4F2D60fC22F037551682AAd95)
 */
export const watchPoolAddressesProviderTaikoPriceOracleSentinelUpdatedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: poolAddressesProviderTaikoAbi,
    address: poolAddressesProviderTaikoAddress,
    eventName: 'PriceOracleSentinelUpdated',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link poolAddressesProviderTaikoAbi}__ and `eventName` set to `"PriceOracleUpdated"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xAb31CA5C925921d92750190732FdC347C23F9987)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa357E6d3Fdea67F4F2D60fC22F037551682AAd95)
 */
export const watchPoolAddressesProviderTaikoPriceOracleUpdatedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: poolAddressesProviderTaikoAbi,
    address: poolAddressesProviderTaikoAddress,
    eventName: 'PriceOracleUpdated',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link poolAddressesProviderTaikoAbi}__ and `eventName` set to `"ProxyCreated"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xAb31CA5C925921d92750190732FdC347C23F9987)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa357E6d3Fdea67F4F2D60fC22F037551682AAd95)
 */
export const watchPoolAddressesProviderTaikoProxyCreatedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: poolAddressesProviderTaikoAbi,
    address: poolAddressesProviderTaikoAddress,
    eventName: 'ProxyCreated',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link poolAddressesProviderRegistryAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x79DD82A3f64a91F084dc22ceBa3138e75F573319)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7B354b408A11fD09b1Cf275d83DC05A8A3b2eE52)
 */
export const readPoolAddressesProviderRegistry =
  /*#__PURE__*/ createReadContract({
    abi: poolAddressesProviderRegistryAbi,
    address: poolAddressesProviderRegistryAddress,
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link poolAddressesProviderRegistryAbi}__ and `functionName` set to `"getAddressesProviderAddressById"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x79DD82A3f64a91F084dc22ceBa3138e75F573319)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7B354b408A11fD09b1Cf275d83DC05A8A3b2eE52)
 */
export const readPoolAddressesProviderRegistryGetAddressesProviderAddressById =
  /*#__PURE__*/ createReadContract({
    abi: poolAddressesProviderRegistryAbi,
    address: poolAddressesProviderRegistryAddress,
    functionName: 'getAddressesProviderAddressById',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link poolAddressesProviderRegistryAbi}__ and `functionName` set to `"getAddressesProviderIdByAddress"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x79DD82A3f64a91F084dc22ceBa3138e75F573319)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7B354b408A11fD09b1Cf275d83DC05A8A3b2eE52)
 */
export const readPoolAddressesProviderRegistryGetAddressesProviderIdByAddress =
  /*#__PURE__*/ createReadContract({
    abi: poolAddressesProviderRegistryAbi,
    address: poolAddressesProviderRegistryAddress,
    functionName: 'getAddressesProviderIdByAddress',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link poolAddressesProviderRegistryAbi}__ and `functionName` set to `"getAddressesProvidersList"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x79DD82A3f64a91F084dc22ceBa3138e75F573319)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7B354b408A11fD09b1Cf275d83DC05A8A3b2eE52)
 */
export const readPoolAddressesProviderRegistryGetAddressesProvidersList =
  /*#__PURE__*/ createReadContract({
    abi: poolAddressesProviderRegistryAbi,
    address: poolAddressesProviderRegistryAddress,
    functionName: 'getAddressesProvidersList',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link poolAddressesProviderRegistryAbi}__ and `functionName` set to `"owner"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x79DD82A3f64a91F084dc22ceBa3138e75F573319)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7B354b408A11fD09b1Cf275d83DC05A8A3b2eE52)
 */
export const readPoolAddressesProviderRegistryOwner =
  /*#__PURE__*/ createReadContract({
    abi: poolAddressesProviderRegistryAbi,
    address: poolAddressesProviderRegistryAddress,
    functionName: 'owner',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link poolAddressesProviderRegistryAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x79DD82A3f64a91F084dc22ceBa3138e75F573319)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7B354b408A11fD09b1Cf275d83DC05A8A3b2eE52)
 */
export const writePoolAddressesProviderRegistry =
  /*#__PURE__*/ createWriteContract({
    abi: poolAddressesProviderRegistryAbi,
    address: poolAddressesProviderRegistryAddress,
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link poolAddressesProviderRegistryAbi}__ and `functionName` set to `"registerAddressesProvider"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x79DD82A3f64a91F084dc22ceBa3138e75F573319)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7B354b408A11fD09b1Cf275d83DC05A8A3b2eE52)
 */
export const writePoolAddressesProviderRegistryRegisterAddressesProvider =
  /*#__PURE__*/ createWriteContract({
    abi: poolAddressesProviderRegistryAbi,
    address: poolAddressesProviderRegistryAddress,
    functionName: 'registerAddressesProvider',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link poolAddressesProviderRegistryAbi}__ and `functionName` set to `"renounceOwnership"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x79DD82A3f64a91F084dc22ceBa3138e75F573319)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7B354b408A11fD09b1Cf275d83DC05A8A3b2eE52)
 */
export const writePoolAddressesProviderRegistryRenounceOwnership =
  /*#__PURE__*/ createWriteContract({
    abi: poolAddressesProviderRegistryAbi,
    address: poolAddressesProviderRegistryAddress,
    functionName: 'renounceOwnership',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link poolAddressesProviderRegistryAbi}__ and `functionName` set to `"transferOwnership"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x79DD82A3f64a91F084dc22ceBa3138e75F573319)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7B354b408A11fD09b1Cf275d83DC05A8A3b2eE52)
 */
export const writePoolAddressesProviderRegistryTransferOwnership =
  /*#__PURE__*/ createWriteContract({
    abi: poolAddressesProviderRegistryAbi,
    address: poolAddressesProviderRegistryAddress,
    functionName: 'transferOwnership',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link poolAddressesProviderRegistryAbi}__ and `functionName` set to `"unregisterAddressesProvider"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x79DD82A3f64a91F084dc22ceBa3138e75F573319)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7B354b408A11fD09b1Cf275d83DC05A8A3b2eE52)
 */
export const writePoolAddressesProviderRegistryUnregisterAddressesProvider =
  /*#__PURE__*/ createWriteContract({
    abi: poolAddressesProviderRegistryAbi,
    address: poolAddressesProviderRegistryAddress,
    functionName: 'unregisterAddressesProvider',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link poolAddressesProviderRegistryAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x79DD82A3f64a91F084dc22ceBa3138e75F573319)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7B354b408A11fD09b1Cf275d83DC05A8A3b2eE52)
 */
export const simulatePoolAddressesProviderRegistry =
  /*#__PURE__*/ createSimulateContract({
    abi: poolAddressesProviderRegistryAbi,
    address: poolAddressesProviderRegistryAddress,
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link poolAddressesProviderRegistryAbi}__ and `functionName` set to `"registerAddressesProvider"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x79DD82A3f64a91F084dc22ceBa3138e75F573319)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7B354b408A11fD09b1Cf275d83DC05A8A3b2eE52)
 */
export const simulatePoolAddressesProviderRegistryRegisterAddressesProvider =
  /*#__PURE__*/ createSimulateContract({
    abi: poolAddressesProviderRegistryAbi,
    address: poolAddressesProviderRegistryAddress,
    functionName: 'registerAddressesProvider',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link poolAddressesProviderRegistryAbi}__ and `functionName` set to `"renounceOwnership"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x79DD82A3f64a91F084dc22ceBa3138e75F573319)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7B354b408A11fD09b1Cf275d83DC05A8A3b2eE52)
 */
export const simulatePoolAddressesProviderRegistryRenounceOwnership =
  /*#__PURE__*/ createSimulateContract({
    abi: poolAddressesProviderRegistryAbi,
    address: poolAddressesProviderRegistryAddress,
    functionName: 'renounceOwnership',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link poolAddressesProviderRegistryAbi}__ and `functionName` set to `"transferOwnership"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x79DD82A3f64a91F084dc22ceBa3138e75F573319)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7B354b408A11fD09b1Cf275d83DC05A8A3b2eE52)
 */
export const simulatePoolAddressesProviderRegistryTransferOwnership =
  /*#__PURE__*/ createSimulateContract({
    abi: poolAddressesProviderRegistryAbi,
    address: poolAddressesProviderRegistryAddress,
    functionName: 'transferOwnership',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link poolAddressesProviderRegistryAbi}__ and `functionName` set to `"unregisterAddressesProvider"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x79DD82A3f64a91F084dc22ceBa3138e75F573319)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7B354b408A11fD09b1Cf275d83DC05A8A3b2eE52)
 */
export const simulatePoolAddressesProviderRegistryUnregisterAddressesProvider =
  /*#__PURE__*/ createSimulateContract({
    abi: poolAddressesProviderRegistryAbi,
    address: poolAddressesProviderRegistryAddress,
    functionName: 'unregisterAddressesProvider',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link poolAddressesProviderRegistryAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x79DD82A3f64a91F084dc22ceBa3138e75F573319)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7B354b408A11fD09b1Cf275d83DC05A8A3b2eE52)
 */
export const watchPoolAddressesProviderRegistryEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: poolAddressesProviderRegistryAbi,
    address: poolAddressesProviderRegistryAddress,
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link poolAddressesProviderRegistryAbi}__ and `eventName` set to `"AddressesProviderRegistered"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x79DD82A3f64a91F084dc22ceBa3138e75F573319)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7B354b408A11fD09b1Cf275d83DC05A8A3b2eE52)
 */
export const watchPoolAddressesProviderRegistryAddressesProviderRegisteredEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: poolAddressesProviderRegistryAbi,
    address: poolAddressesProviderRegistryAddress,
    eventName: 'AddressesProviderRegistered',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link poolAddressesProviderRegistryAbi}__ and `eventName` set to `"AddressesProviderUnregistered"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x79DD82A3f64a91F084dc22ceBa3138e75F573319)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7B354b408A11fD09b1Cf275d83DC05A8A3b2eE52)
 */
export const watchPoolAddressesProviderRegistryAddressesProviderUnregisteredEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: poolAddressesProviderRegistryAbi,
    address: poolAddressesProviderRegistryAddress,
    eventName: 'AddressesProviderUnregistered',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link poolAddressesProviderRegistryAbi}__ and `eventName` set to `"OwnershipTransferred"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x79DD82A3f64a91F084dc22ceBa3138e75F573319)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7B354b408A11fD09b1Cf275d83DC05A8A3b2eE52)
 */
export const watchPoolAddressesProviderRegistryOwnershipTransferredEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: poolAddressesProviderRegistryAbi,
    address: poolAddressesProviderRegistryAddress,
    eventName: 'OwnershipTransferred',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link poolConfiguratorImplementationAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x841df6066adc8b81b1EA401294Dc051e0E43EeBc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA6F7AAcb380B07aE906a1C77873256525718Ed1a)
 */
export const readPoolConfiguratorImplementation =
  /*#__PURE__*/ createReadContract({
    abi: poolConfiguratorImplementationAbi,
    address: poolConfiguratorImplementationAddress,
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link poolConfiguratorImplementationAbi}__ and `functionName` set to `"CONFIGURATOR_REVISION"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x841df6066adc8b81b1EA401294Dc051e0E43EeBc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA6F7AAcb380B07aE906a1C77873256525718Ed1a)
 */
export const readPoolConfiguratorImplementationConfiguratorRevision =
  /*#__PURE__*/ createReadContract({
    abi: poolConfiguratorImplementationAbi,
    address: poolConfiguratorImplementationAddress,
    functionName: 'CONFIGURATOR_REVISION',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link poolConfiguratorImplementationAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x841df6066adc8b81b1EA401294Dc051e0E43EeBc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA6F7AAcb380B07aE906a1C77873256525718Ed1a)
 */
export const writePoolConfiguratorImplementation =
  /*#__PURE__*/ createWriteContract({
    abi: poolConfiguratorImplementationAbi,
    address: poolConfiguratorImplementationAddress,
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link poolConfiguratorImplementationAbi}__ and `functionName` set to `"configureReserveAsCollateral"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x841df6066adc8b81b1EA401294Dc051e0E43EeBc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA6F7AAcb380B07aE906a1C77873256525718Ed1a)
 */
export const writePoolConfiguratorImplementationConfigureReserveAsCollateral =
  /*#__PURE__*/ createWriteContract({
    abi: poolConfiguratorImplementationAbi,
    address: poolConfiguratorImplementationAddress,
    functionName: 'configureReserveAsCollateral',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link poolConfiguratorImplementationAbi}__ and `functionName` set to `"dropReserve"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x841df6066adc8b81b1EA401294Dc051e0E43EeBc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA6F7AAcb380B07aE906a1C77873256525718Ed1a)
 */
export const writePoolConfiguratorImplementationDropReserve =
  /*#__PURE__*/ createWriteContract({
    abi: poolConfiguratorImplementationAbi,
    address: poolConfiguratorImplementationAddress,
    functionName: 'dropReserve',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link poolConfiguratorImplementationAbi}__ and `functionName` set to `"initReserves"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x841df6066adc8b81b1EA401294Dc051e0E43EeBc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA6F7AAcb380B07aE906a1C77873256525718Ed1a)
 */
export const writePoolConfiguratorImplementationInitReserves =
  /*#__PURE__*/ createWriteContract({
    abi: poolConfiguratorImplementationAbi,
    address: poolConfiguratorImplementationAddress,
    functionName: 'initReserves',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link poolConfiguratorImplementationAbi}__ and `functionName` set to `"initialize"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x841df6066adc8b81b1EA401294Dc051e0E43EeBc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA6F7AAcb380B07aE906a1C77873256525718Ed1a)
 */
export const writePoolConfiguratorImplementationInitialize =
  /*#__PURE__*/ createWriteContract({
    abi: poolConfiguratorImplementationAbi,
    address: poolConfiguratorImplementationAddress,
    functionName: 'initialize',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link poolConfiguratorImplementationAbi}__ and `functionName` set to `"setAssetEModeCategory"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x841df6066adc8b81b1EA401294Dc051e0E43EeBc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA6F7AAcb380B07aE906a1C77873256525718Ed1a)
 */
export const writePoolConfiguratorImplementationSetAssetEModeCategory =
  /*#__PURE__*/ createWriteContract({
    abi: poolConfiguratorImplementationAbi,
    address: poolConfiguratorImplementationAddress,
    functionName: 'setAssetEModeCategory',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link poolConfiguratorImplementationAbi}__ and `functionName` set to `"setBorrowCap"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x841df6066adc8b81b1EA401294Dc051e0E43EeBc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA6F7AAcb380B07aE906a1C77873256525718Ed1a)
 */
export const writePoolConfiguratorImplementationSetBorrowCap =
  /*#__PURE__*/ createWriteContract({
    abi: poolConfiguratorImplementationAbi,
    address: poolConfiguratorImplementationAddress,
    functionName: 'setBorrowCap',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link poolConfiguratorImplementationAbi}__ and `functionName` set to `"setBorrowableInIsolation"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x841df6066adc8b81b1EA401294Dc051e0E43EeBc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA6F7AAcb380B07aE906a1C77873256525718Ed1a)
 */
export const writePoolConfiguratorImplementationSetBorrowableInIsolation =
  /*#__PURE__*/ createWriteContract({
    abi: poolConfiguratorImplementationAbi,
    address: poolConfiguratorImplementationAddress,
    functionName: 'setBorrowableInIsolation',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link poolConfiguratorImplementationAbi}__ and `functionName` set to `"setDebtCeiling"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x841df6066adc8b81b1EA401294Dc051e0E43EeBc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA6F7AAcb380B07aE906a1C77873256525718Ed1a)
 */
export const writePoolConfiguratorImplementationSetDebtCeiling =
  /*#__PURE__*/ createWriteContract({
    abi: poolConfiguratorImplementationAbi,
    address: poolConfiguratorImplementationAddress,
    functionName: 'setDebtCeiling',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link poolConfiguratorImplementationAbi}__ and `functionName` set to `"setEModeCategory"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x841df6066adc8b81b1EA401294Dc051e0E43EeBc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA6F7AAcb380B07aE906a1C77873256525718Ed1a)
 */
export const writePoolConfiguratorImplementationSetEModeCategory =
  /*#__PURE__*/ createWriteContract({
    abi: poolConfiguratorImplementationAbi,
    address: poolConfiguratorImplementationAddress,
    functionName: 'setEModeCategory',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link poolConfiguratorImplementationAbi}__ and `functionName` set to `"setLiquidationProtocolFee"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x841df6066adc8b81b1EA401294Dc051e0E43EeBc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA6F7AAcb380B07aE906a1C77873256525718Ed1a)
 */
export const writePoolConfiguratorImplementationSetLiquidationProtocolFee =
  /*#__PURE__*/ createWriteContract({
    abi: poolConfiguratorImplementationAbi,
    address: poolConfiguratorImplementationAddress,
    functionName: 'setLiquidationProtocolFee',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link poolConfiguratorImplementationAbi}__ and `functionName` set to `"setPoolPause"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x841df6066adc8b81b1EA401294Dc051e0E43EeBc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA6F7AAcb380B07aE906a1C77873256525718Ed1a)
 */
export const writePoolConfiguratorImplementationSetPoolPause =
  /*#__PURE__*/ createWriteContract({
    abi: poolConfiguratorImplementationAbi,
    address: poolConfiguratorImplementationAddress,
    functionName: 'setPoolPause',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link poolConfiguratorImplementationAbi}__ and `functionName` set to `"setReserveActive"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x841df6066adc8b81b1EA401294Dc051e0E43EeBc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA6F7AAcb380B07aE906a1C77873256525718Ed1a)
 */
export const writePoolConfiguratorImplementationSetReserveActive =
  /*#__PURE__*/ createWriteContract({
    abi: poolConfiguratorImplementationAbi,
    address: poolConfiguratorImplementationAddress,
    functionName: 'setReserveActive',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link poolConfiguratorImplementationAbi}__ and `functionName` set to `"setReserveBorrowing"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x841df6066adc8b81b1EA401294Dc051e0E43EeBc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA6F7AAcb380B07aE906a1C77873256525718Ed1a)
 */
export const writePoolConfiguratorImplementationSetReserveBorrowing =
  /*#__PURE__*/ createWriteContract({
    abi: poolConfiguratorImplementationAbi,
    address: poolConfiguratorImplementationAddress,
    functionName: 'setReserveBorrowing',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link poolConfiguratorImplementationAbi}__ and `functionName` set to `"setReserveFactor"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x841df6066adc8b81b1EA401294Dc051e0E43EeBc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA6F7AAcb380B07aE906a1C77873256525718Ed1a)
 */
export const writePoolConfiguratorImplementationSetReserveFactor =
  /*#__PURE__*/ createWriteContract({
    abi: poolConfiguratorImplementationAbi,
    address: poolConfiguratorImplementationAddress,
    functionName: 'setReserveFactor',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link poolConfiguratorImplementationAbi}__ and `functionName` set to `"setReserveFlashLoaning"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x841df6066adc8b81b1EA401294Dc051e0E43EeBc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA6F7AAcb380B07aE906a1C77873256525718Ed1a)
 */
export const writePoolConfiguratorImplementationSetReserveFlashLoaning =
  /*#__PURE__*/ createWriteContract({
    abi: poolConfiguratorImplementationAbi,
    address: poolConfiguratorImplementationAddress,
    functionName: 'setReserveFlashLoaning',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link poolConfiguratorImplementationAbi}__ and `functionName` set to `"setReserveFreeze"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x841df6066adc8b81b1EA401294Dc051e0E43EeBc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA6F7AAcb380B07aE906a1C77873256525718Ed1a)
 */
export const writePoolConfiguratorImplementationSetReserveFreeze =
  /*#__PURE__*/ createWriteContract({
    abi: poolConfiguratorImplementationAbi,
    address: poolConfiguratorImplementationAddress,
    functionName: 'setReserveFreeze',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link poolConfiguratorImplementationAbi}__ and `functionName` set to `"setReserveInterestRateStrategyAddress"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x841df6066adc8b81b1EA401294Dc051e0E43EeBc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA6F7AAcb380B07aE906a1C77873256525718Ed1a)
 */
export const writePoolConfiguratorImplementationSetReserveInterestRateStrategyAddress =
  /*#__PURE__*/ createWriteContract({
    abi: poolConfiguratorImplementationAbi,
    address: poolConfiguratorImplementationAddress,
    functionName: 'setReserveInterestRateStrategyAddress',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link poolConfiguratorImplementationAbi}__ and `functionName` set to `"setReservePause"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x841df6066adc8b81b1EA401294Dc051e0E43EeBc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA6F7AAcb380B07aE906a1C77873256525718Ed1a)
 */
export const writePoolConfiguratorImplementationSetReservePause =
  /*#__PURE__*/ createWriteContract({
    abi: poolConfiguratorImplementationAbi,
    address: poolConfiguratorImplementationAddress,
    functionName: 'setReservePause',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link poolConfiguratorImplementationAbi}__ and `functionName` set to `"setReserveStableRateBorrowing"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x841df6066adc8b81b1EA401294Dc051e0E43EeBc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA6F7AAcb380B07aE906a1C77873256525718Ed1a)
 */
export const writePoolConfiguratorImplementationSetReserveStableRateBorrowing =
  /*#__PURE__*/ createWriteContract({
    abi: poolConfiguratorImplementationAbi,
    address: poolConfiguratorImplementationAddress,
    functionName: 'setReserveStableRateBorrowing',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link poolConfiguratorImplementationAbi}__ and `functionName` set to `"setSiloedBorrowing"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x841df6066adc8b81b1EA401294Dc051e0E43EeBc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA6F7AAcb380B07aE906a1C77873256525718Ed1a)
 */
export const writePoolConfiguratorImplementationSetSiloedBorrowing =
  /*#__PURE__*/ createWriteContract({
    abi: poolConfiguratorImplementationAbi,
    address: poolConfiguratorImplementationAddress,
    functionName: 'setSiloedBorrowing',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link poolConfiguratorImplementationAbi}__ and `functionName` set to `"setSupplyCap"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x841df6066adc8b81b1EA401294Dc051e0E43EeBc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA6F7AAcb380B07aE906a1C77873256525718Ed1a)
 */
export const writePoolConfiguratorImplementationSetSupplyCap =
  /*#__PURE__*/ createWriteContract({
    abi: poolConfiguratorImplementationAbi,
    address: poolConfiguratorImplementationAddress,
    functionName: 'setSupplyCap',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link poolConfiguratorImplementationAbi}__ and `functionName` set to `"setUnbackedMintCap"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x841df6066adc8b81b1EA401294Dc051e0E43EeBc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA6F7AAcb380B07aE906a1C77873256525718Ed1a)
 */
export const writePoolConfiguratorImplementationSetUnbackedMintCap =
  /*#__PURE__*/ createWriteContract({
    abi: poolConfiguratorImplementationAbi,
    address: poolConfiguratorImplementationAddress,
    functionName: 'setUnbackedMintCap',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link poolConfiguratorImplementationAbi}__ and `functionName` set to `"updateAToken"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x841df6066adc8b81b1EA401294Dc051e0E43EeBc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA6F7AAcb380B07aE906a1C77873256525718Ed1a)
 */
export const writePoolConfiguratorImplementationUpdateAToken =
  /*#__PURE__*/ createWriteContract({
    abi: poolConfiguratorImplementationAbi,
    address: poolConfiguratorImplementationAddress,
    functionName: 'updateAToken',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link poolConfiguratorImplementationAbi}__ and `functionName` set to `"updateBridgeProtocolFee"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x841df6066adc8b81b1EA401294Dc051e0E43EeBc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA6F7AAcb380B07aE906a1C77873256525718Ed1a)
 */
export const writePoolConfiguratorImplementationUpdateBridgeProtocolFee =
  /*#__PURE__*/ createWriteContract({
    abi: poolConfiguratorImplementationAbi,
    address: poolConfiguratorImplementationAddress,
    functionName: 'updateBridgeProtocolFee',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link poolConfiguratorImplementationAbi}__ and `functionName` set to `"updateFlashloanPremiumToProtocol"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x841df6066adc8b81b1EA401294Dc051e0E43EeBc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA6F7AAcb380B07aE906a1C77873256525718Ed1a)
 */
export const writePoolConfiguratorImplementationUpdateFlashloanPremiumToProtocol =
  /*#__PURE__*/ createWriteContract({
    abi: poolConfiguratorImplementationAbi,
    address: poolConfiguratorImplementationAddress,
    functionName: 'updateFlashloanPremiumToProtocol',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link poolConfiguratorImplementationAbi}__ and `functionName` set to `"updateFlashloanPremiumTotal"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x841df6066adc8b81b1EA401294Dc051e0E43EeBc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA6F7AAcb380B07aE906a1C77873256525718Ed1a)
 */
export const writePoolConfiguratorImplementationUpdateFlashloanPremiumTotal =
  /*#__PURE__*/ createWriteContract({
    abi: poolConfiguratorImplementationAbi,
    address: poolConfiguratorImplementationAddress,
    functionName: 'updateFlashloanPremiumTotal',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link poolConfiguratorImplementationAbi}__ and `functionName` set to `"updateStableDebtToken"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x841df6066adc8b81b1EA401294Dc051e0E43EeBc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA6F7AAcb380B07aE906a1C77873256525718Ed1a)
 */
export const writePoolConfiguratorImplementationUpdateStableDebtToken =
  /*#__PURE__*/ createWriteContract({
    abi: poolConfiguratorImplementationAbi,
    address: poolConfiguratorImplementationAddress,
    functionName: 'updateStableDebtToken',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link poolConfiguratorImplementationAbi}__ and `functionName` set to `"updateVariableDebtToken"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x841df6066adc8b81b1EA401294Dc051e0E43EeBc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA6F7AAcb380B07aE906a1C77873256525718Ed1a)
 */
export const writePoolConfiguratorImplementationUpdateVariableDebtToken =
  /*#__PURE__*/ createWriteContract({
    abi: poolConfiguratorImplementationAbi,
    address: poolConfiguratorImplementationAddress,
    functionName: 'updateVariableDebtToken',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link poolConfiguratorImplementationAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x841df6066adc8b81b1EA401294Dc051e0E43EeBc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA6F7AAcb380B07aE906a1C77873256525718Ed1a)
 */
export const simulatePoolConfiguratorImplementation =
  /*#__PURE__*/ createSimulateContract({
    abi: poolConfiguratorImplementationAbi,
    address: poolConfiguratorImplementationAddress,
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link poolConfiguratorImplementationAbi}__ and `functionName` set to `"configureReserveAsCollateral"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x841df6066adc8b81b1EA401294Dc051e0E43EeBc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA6F7AAcb380B07aE906a1C77873256525718Ed1a)
 */
export const simulatePoolConfiguratorImplementationConfigureReserveAsCollateral =
  /*#__PURE__*/ createSimulateContract({
    abi: poolConfiguratorImplementationAbi,
    address: poolConfiguratorImplementationAddress,
    functionName: 'configureReserveAsCollateral',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link poolConfiguratorImplementationAbi}__ and `functionName` set to `"dropReserve"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x841df6066adc8b81b1EA401294Dc051e0E43EeBc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA6F7AAcb380B07aE906a1C77873256525718Ed1a)
 */
export const simulatePoolConfiguratorImplementationDropReserve =
  /*#__PURE__*/ createSimulateContract({
    abi: poolConfiguratorImplementationAbi,
    address: poolConfiguratorImplementationAddress,
    functionName: 'dropReserve',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link poolConfiguratorImplementationAbi}__ and `functionName` set to `"initReserves"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x841df6066adc8b81b1EA401294Dc051e0E43EeBc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA6F7AAcb380B07aE906a1C77873256525718Ed1a)
 */
export const simulatePoolConfiguratorImplementationInitReserves =
  /*#__PURE__*/ createSimulateContract({
    abi: poolConfiguratorImplementationAbi,
    address: poolConfiguratorImplementationAddress,
    functionName: 'initReserves',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link poolConfiguratorImplementationAbi}__ and `functionName` set to `"initialize"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x841df6066adc8b81b1EA401294Dc051e0E43EeBc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA6F7AAcb380B07aE906a1C77873256525718Ed1a)
 */
export const simulatePoolConfiguratorImplementationInitialize =
  /*#__PURE__*/ createSimulateContract({
    abi: poolConfiguratorImplementationAbi,
    address: poolConfiguratorImplementationAddress,
    functionName: 'initialize',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link poolConfiguratorImplementationAbi}__ and `functionName` set to `"setAssetEModeCategory"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x841df6066adc8b81b1EA401294Dc051e0E43EeBc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA6F7AAcb380B07aE906a1C77873256525718Ed1a)
 */
export const simulatePoolConfiguratorImplementationSetAssetEModeCategory =
  /*#__PURE__*/ createSimulateContract({
    abi: poolConfiguratorImplementationAbi,
    address: poolConfiguratorImplementationAddress,
    functionName: 'setAssetEModeCategory',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link poolConfiguratorImplementationAbi}__ and `functionName` set to `"setBorrowCap"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x841df6066adc8b81b1EA401294Dc051e0E43EeBc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA6F7AAcb380B07aE906a1C77873256525718Ed1a)
 */
export const simulatePoolConfiguratorImplementationSetBorrowCap =
  /*#__PURE__*/ createSimulateContract({
    abi: poolConfiguratorImplementationAbi,
    address: poolConfiguratorImplementationAddress,
    functionName: 'setBorrowCap',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link poolConfiguratorImplementationAbi}__ and `functionName` set to `"setBorrowableInIsolation"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x841df6066adc8b81b1EA401294Dc051e0E43EeBc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA6F7AAcb380B07aE906a1C77873256525718Ed1a)
 */
export const simulatePoolConfiguratorImplementationSetBorrowableInIsolation =
  /*#__PURE__*/ createSimulateContract({
    abi: poolConfiguratorImplementationAbi,
    address: poolConfiguratorImplementationAddress,
    functionName: 'setBorrowableInIsolation',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link poolConfiguratorImplementationAbi}__ and `functionName` set to `"setDebtCeiling"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x841df6066adc8b81b1EA401294Dc051e0E43EeBc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA6F7AAcb380B07aE906a1C77873256525718Ed1a)
 */
export const simulatePoolConfiguratorImplementationSetDebtCeiling =
  /*#__PURE__*/ createSimulateContract({
    abi: poolConfiguratorImplementationAbi,
    address: poolConfiguratorImplementationAddress,
    functionName: 'setDebtCeiling',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link poolConfiguratorImplementationAbi}__ and `functionName` set to `"setEModeCategory"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x841df6066adc8b81b1EA401294Dc051e0E43EeBc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA6F7AAcb380B07aE906a1C77873256525718Ed1a)
 */
export const simulatePoolConfiguratorImplementationSetEModeCategory =
  /*#__PURE__*/ createSimulateContract({
    abi: poolConfiguratorImplementationAbi,
    address: poolConfiguratorImplementationAddress,
    functionName: 'setEModeCategory',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link poolConfiguratorImplementationAbi}__ and `functionName` set to `"setLiquidationProtocolFee"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x841df6066adc8b81b1EA401294Dc051e0E43EeBc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA6F7AAcb380B07aE906a1C77873256525718Ed1a)
 */
export const simulatePoolConfiguratorImplementationSetLiquidationProtocolFee =
  /*#__PURE__*/ createSimulateContract({
    abi: poolConfiguratorImplementationAbi,
    address: poolConfiguratorImplementationAddress,
    functionName: 'setLiquidationProtocolFee',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link poolConfiguratorImplementationAbi}__ and `functionName` set to `"setPoolPause"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x841df6066adc8b81b1EA401294Dc051e0E43EeBc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA6F7AAcb380B07aE906a1C77873256525718Ed1a)
 */
export const simulatePoolConfiguratorImplementationSetPoolPause =
  /*#__PURE__*/ createSimulateContract({
    abi: poolConfiguratorImplementationAbi,
    address: poolConfiguratorImplementationAddress,
    functionName: 'setPoolPause',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link poolConfiguratorImplementationAbi}__ and `functionName` set to `"setReserveActive"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x841df6066adc8b81b1EA401294Dc051e0E43EeBc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA6F7AAcb380B07aE906a1C77873256525718Ed1a)
 */
export const simulatePoolConfiguratorImplementationSetReserveActive =
  /*#__PURE__*/ createSimulateContract({
    abi: poolConfiguratorImplementationAbi,
    address: poolConfiguratorImplementationAddress,
    functionName: 'setReserveActive',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link poolConfiguratorImplementationAbi}__ and `functionName` set to `"setReserveBorrowing"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x841df6066adc8b81b1EA401294Dc051e0E43EeBc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA6F7AAcb380B07aE906a1C77873256525718Ed1a)
 */
export const simulatePoolConfiguratorImplementationSetReserveBorrowing =
  /*#__PURE__*/ createSimulateContract({
    abi: poolConfiguratorImplementationAbi,
    address: poolConfiguratorImplementationAddress,
    functionName: 'setReserveBorrowing',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link poolConfiguratorImplementationAbi}__ and `functionName` set to `"setReserveFactor"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x841df6066adc8b81b1EA401294Dc051e0E43EeBc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA6F7AAcb380B07aE906a1C77873256525718Ed1a)
 */
export const simulatePoolConfiguratorImplementationSetReserveFactor =
  /*#__PURE__*/ createSimulateContract({
    abi: poolConfiguratorImplementationAbi,
    address: poolConfiguratorImplementationAddress,
    functionName: 'setReserveFactor',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link poolConfiguratorImplementationAbi}__ and `functionName` set to `"setReserveFlashLoaning"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x841df6066adc8b81b1EA401294Dc051e0E43EeBc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA6F7AAcb380B07aE906a1C77873256525718Ed1a)
 */
export const simulatePoolConfiguratorImplementationSetReserveFlashLoaning =
  /*#__PURE__*/ createSimulateContract({
    abi: poolConfiguratorImplementationAbi,
    address: poolConfiguratorImplementationAddress,
    functionName: 'setReserveFlashLoaning',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link poolConfiguratorImplementationAbi}__ and `functionName` set to `"setReserveFreeze"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x841df6066adc8b81b1EA401294Dc051e0E43EeBc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA6F7AAcb380B07aE906a1C77873256525718Ed1a)
 */
export const simulatePoolConfiguratorImplementationSetReserveFreeze =
  /*#__PURE__*/ createSimulateContract({
    abi: poolConfiguratorImplementationAbi,
    address: poolConfiguratorImplementationAddress,
    functionName: 'setReserveFreeze',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link poolConfiguratorImplementationAbi}__ and `functionName` set to `"setReserveInterestRateStrategyAddress"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x841df6066adc8b81b1EA401294Dc051e0E43EeBc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA6F7AAcb380B07aE906a1C77873256525718Ed1a)
 */
export const simulatePoolConfiguratorImplementationSetReserveInterestRateStrategyAddress =
  /*#__PURE__*/ createSimulateContract({
    abi: poolConfiguratorImplementationAbi,
    address: poolConfiguratorImplementationAddress,
    functionName: 'setReserveInterestRateStrategyAddress',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link poolConfiguratorImplementationAbi}__ and `functionName` set to `"setReservePause"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x841df6066adc8b81b1EA401294Dc051e0E43EeBc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA6F7AAcb380B07aE906a1C77873256525718Ed1a)
 */
export const simulatePoolConfiguratorImplementationSetReservePause =
  /*#__PURE__*/ createSimulateContract({
    abi: poolConfiguratorImplementationAbi,
    address: poolConfiguratorImplementationAddress,
    functionName: 'setReservePause',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link poolConfiguratorImplementationAbi}__ and `functionName` set to `"setReserveStableRateBorrowing"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x841df6066adc8b81b1EA401294Dc051e0E43EeBc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA6F7AAcb380B07aE906a1C77873256525718Ed1a)
 */
export const simulatePoolConfiguratorImplementationSetReserveStableRateBorrowing =
  /*#__PURE__*/ createSimulateContract({
    abi: poolConfiguratorImplementationAbi,
    address: poolConfiguratorImplementationAddress,
    functionName: 'setReserveStableRateBorrowing',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link poolConfiguratorImplementationAbi}__ and `functionName` set to `"setSiloedBorrowing"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x841df6066adc8b81b1EA401294Dc051e0E43EeBc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA6F7AAcb380B07aE906a1C77873256525718Ed1a)
 */
export const simulatePoolConfiguratorImplementationSetSiloedBorrowing =
  /*#__PURE__*/ createSimulateContract({
    abi: poolConfiguratorImplementationAbi,
    address: poolConfiguratorImplementationAddress,
    functionName: 'setSiloedBorrowing',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link poolConfiguratorImplementationAbi}__ and `functionName` set to `"setSupplyCap"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x841df6066adc8b81b1EA401294Dc051e0E43EeBc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA6F7AAcb380B07aE906a1C77873256525718Ed1a)
 */
export const simulatePoolConfiguratorImplementationSetSupplyCap =
  /*#__PURE__*/ createSimulateContract({
    abi: poolConfiguratorImplementationAbi,
    address: poolConfiguratorImplementationAddress,
    functionName: 'setSupplyCap',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link poolConfiguratorImplementationAbi}__ and `functionName` set to `"setUnbackedMintCap"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x841df6066adc8b81b1EA401294Dc051e0E43EeBc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA6F7AAcb380B07aE906a1C77873256525718Ed1a)
 */
export const simulatePoolConfiguratorImplementationSetUnbackedMintCap =
  /*#__PURE__*/ createSimulateContract({
    abi: poolConfiguratorImplementationAbi,
    address: poolConfiguratorImplementationAddress,
    functionName: 'setUnbackedMintCap',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link poolConfiguratorImplementationAbi}__ and `functionName` set to `"updateAToken"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x841df6066adc8b81b1EA401294Dc051e0E43EeBc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA6F7AAcb380B07aE906a1C77873256525718Ed1a)
 */
export const simulatePoolConfiguratorImplementationUpdateAToken =
  /*#__PURE__*/ createSimulateContract({
    abi: poolConfiguratorImplementationAbi,
    address: poolConfiguratorImplementationAddress,
    functionName: 'updateAToken',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link poolConfiguratorImplementationAbi}__ and `functionName` set to `"updateBridgeProtocolFee"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x841df6066adc8b81b1EA401294Dc051e0E43EeBc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA6F7AAcb380B07aE906a1C77873256525718Ed1a)
 */
export const simulatePoolConfiguratorImplementationUpdateBridgeProtocolFee =
  /*#__PURE__*/ createSimulateContract({
    abi: poolConfiguratorImplementationAbi,
    address: poolConfiguratorImplementationAddress,
    functionName: 'updateBridgeProtocolFee',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link poolConfiguratorImplementationAbi}__ and `functionName` set to `"updateFlashloanPremiumToProtocol"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x841df6066adc8b81b1EA401294Dc051e0E43EeBc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA6F7AAcb380B07aE906a1C77873256525718Ed1a)
 */
export const simulatePoolConfiguratorImplementationUpdateFlashloanPremiumToProtocol =
  /*#__PURE__*/ createSimulateContract({
    abi: poolConfiguratorImplementationAbi,
    address: poolConfiguratorImplementationAddress,
    functionName: 'updateFlashloanPremiumToProtocol',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link poolConfiguratorImplementationAbi}__ and `functionName` set to `"updateFlashloanPremiumTotal"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x841df6066adc8b81b1EA401294Dc051e0E43EeBc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA6F7AAcb380B07aE906a1C77873256525718Ed1a)
 */
export const simulatePoolConfiguratorImplementationUpdateFlashloanPremiumTotal =
  /*#__PURE__*/ createSimulateContract({
    abi: poolConfiguratorImplementationAbi,
    address: poolConfiguratorImplementationAddress,
    functionName: 'updateFlashloanPremiumTotal',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link poolConfiguratorImplementationAbi}__ and `functionName` set to `"updateStableDebtToken"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x841df6066adc8b81b1EA401294Dc051e0E43EeBc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA6F7AAcb380B07aE906a1C77873256525718Ed1a)
 */
export const simulatePoolConfiguratorImplementationUpdateStableDebtToken =
  /*#__PURE__*/ createSimulateContract({
    abi: poolConfiguratorImplementationAbi,
    address: poolConfiguratorImplementationAddress,
    functionName: 'updateStableDebtToken',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link poolConfiguratorImplementationAbi}__ and `functionName` set to `"updateVariableDebtToken"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x841df6066adc8b81b1EA401294Dc051e0E43EeBc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA6F7AAcb380B07aE906a1C77873256525718Ed1a)
 */
export const simulatePoolConfiguratorImplementationUpdateVariableDebtToken =
  /*#__PURE__*/ createSimulateContract({
    abi: poolConfiguratorImplementationAbi,
    address: poolConfiguratorImplementationAddress,
    functionName: 'updateVariableDebtToken',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link poolConfiguratorImplementationAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x841df6066adc8b81b1EA401294Dc051e0E43EeBc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA6F7AAcb380B07aE906a1C77873256525718Ed1a)
 */
export const watchPoolConfiguratorImplementationEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: poolConfiguratorImplementationAbi,
    address: poolConfiguratorImplementationAddress,
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link poolConfiguratorImplementationAbi}__ and `eventName` set to `"ATokenUpgraded"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x841df6066adc8b81b1EA401294Dc051e0E43EeBc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA6F7AAcb380B07aE906a1C77873256525718Ed1a)
 */
export const watchPoolConfiguratorImplementationATokenUpgradedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: poolConfiguratorImplementationAbi,
    address: poolConfiguratorImplementationAddress,
    eventName: 'ATokenUpgraded',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link poolConfiguratorImplementationAbi}__ and `eventName` set to `"BorrowCapChanged"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x841df6066adc8b81b1EA401294Dc051e0E43EeBc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA6F7AAcb380B07aE906a1C77873256525718Ed1a)
 */
export const watchPoolConfiguratorImplementationBorrowCapChangedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: poolConfiguratorImplementationAbi,
    address: poolConfiguratorImplementationAddress,
    eventName: 'BorrowCapChanged',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link poolConfiguratorImplementationAbi}__ and `eventName` set to `"BorrowableInIsolationChanged"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x841df6066adc8b81b1EA401294Dc051e0E43EeBc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA6F7AAcb380B07aE906a1C77873256525718Ed1a)
 */
export const watchPoolConfiguratorImplementationBorrowableInIsolationChangedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: poolConfiguratorImplementationAbi,
    address: poolConfiguratorImplementationAddress,
    eventName: 'BorrowableInIsolationChanged',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link poolConfiguratorImplementationAbi}__ and `eventName` set to `"BridgeProtocolFeeUpdated"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x841df6066adc8b81b1EA401294Dc051e0E43EeBc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA6F7AAcb380B07aE906a1C77873256525718Ed1a)
 */
export const watchPoolConfiguratorImplementationBridgeProtocolFeeUpdatedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: poolConfiguratorImplementationAbi,
    address: poolConfiguratorImplementationAddress,
    eventName: 'BridgeProtocolFeeUpdated',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link poolConfiguratorImplementationAbi}__ and `eventName` set to `"CollateralConfigurationChanged"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x841df6066adc8b81b1EA401294Dc051e0E43EeBc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA6F7AAcb380B07aE906a1C77873256525718Ed1a)
 */
export const watchPoolConfiguratorImplementationCollateralConfigurationChangedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: poolConfiguratorImplementationAbi,
    address: poolConfiguratorImplementationAddress,
    eventName: 'CollateralConfigurationChanged',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link poolConfiguratorImplementationAbi}__ and `eventName` set to `"DebtCeilingChanged"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x841df6066adc8b81b1EA401294Dc051e0E43EeBc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA6F7AAcb380B07aE906a1C77873256525718Ed1a)
 */
export const watchPoolConfiguratorImplementationDebtCeilingChangedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: poolConfiguratorImplementationAbi,
    address: poolConfiguratorImplementationAddress,
    eventName: 'DebtCeilingChanged',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link poolConfiguratorImplementationAbi}__ and `eventName` set to `"EModeAssetCategoryChanged"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x841df6066adc8b81b1EA401294Dc051e0E43EeBc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA6F7AAcb380B07aE906a1C77873256525718Ed1a)
 */
export const watchPoolConfiguratorImplementationEModeAssetCategoryChangedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: poolConfiguratorImplementationAbi,
    address: poolConfiguratorImplementationAddress,
    eventName: 'EModeAssetCategoryChanged',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link poolConfiguratorImplementationAbi}__ and `eventName` set to `"EModeCategoryAdded"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x841df6066adc8b81b1EA401294Dc051e0E43EeBc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA6F7AAcb380B07aE906a1C77873256525718Ed1a)
 */
export const watchPoolConfiguratorImplementationEModeCategoryAddedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: poolConfiguratorImplementationAbi,
    address: poolConfiguratorImplementationAddress,
    eventName: 'EModeCategoryAdded',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link poolConfiguratorImplementationAbi}__ and `eventName` set to `"FlashloanPremiumToProtocolUpdated"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x841df6066adc8b81b1EA401294Dc051e0E43EeBc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA6F7AAcb380B07aE906a1C77873256525718Ed1a)
 */
export const watchPoolConfiguratorImplementationFlashloanPremiumToProtocolUpdatedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: poolConfiguratorImplementationAbi,
    address: poolConfiguratorImplementationAddress,
    eventName: 'FlashloanPremiumToProtocolUpdated',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link poolConfiguratorImplementationAbi}__ and `eventName` set to `"FlashloanPremiumTotalUpdated"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x841df6066adc8b81b1EA401294Dc051e0E43EeBc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA6F7AAcb380B07aE906a1C77873256525718Ed1a)
 */
export const watchPoolConfiguratorImplementationFlashloanPremiumTotalUpdatedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: poolConfiguratorImplementationAbi,
    address: poolConfiguratorImplementationAddress,
    eventName: 'FlashloanPremiumTotalUpdated',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link poolConfiguratorImplementationAbi}__ and `eventName` set to `"LiquidationProtocolFeeChanged"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x841df6066adc8b81b1EA401294Dc051e0E43EeBc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA6F7AAcb380B07aE906a1C77873256525718Ed1a)
 */
export const watchPoolConfiguratorImplementationLiquidationProtocolFeeChangedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: poolConfiguratorImplementationAbi,
    address: poolConfiguratorImplementationAddress,
    eventName: 'LiquidationProtocolFeeChanged',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link poolConfiguratorImplementationAbi}__ and `eventName` set to `"ReserveActive"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x841df6066adc8b81b1EA401294Dc051e0E43EeBc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA6F7AAcb380B07aE906a1C77873256525718Ed1a)
 */
export const watchPoolConfiguratorImplementationReserveActiveEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: poolConfiguratorImplementationAbi,
    address: poolConfiguratorImplementationAddress,
    eventName: 'ReserveActive',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link poolConfiguratorImplementationAbi}__ and `eventName` set to `"ReserveBorrowing"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x841df6066adc8b81b1EA401294Dc051e0E43EeBc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA6F7AAcb380B07aE906a1C77873256525718Ed1a)
 */
export const watchPoolConfiguratorImplementationReserveBorrowingEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: poolConfiguratorImplementationAbi,
    address: poolConfiguratorImplementationAddress,
    eventName: 'ReserveBorrowing',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link poolConfiguratorImplementationAbi}__ and `eventName` set to `"ReserveDropped"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x841df6066adc8b81b1EA401294Dc051e0E43EeBc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA6F7AAcb380B07aE906a1C77873256525718Ed1a)
 */
export const watchPoolConfiguratorImplementationReserveDroppedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: poolConfiguratorImplementationAbi,
    address: poolConfiguratorImplementationAddress,
    eventName: 'ReserveDropped',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link poolConfiguratorImplementationAbi}__ and `eventName` set to `"ReserveFactorChanged"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x841df6066adc8b81b1EA401294Dc051e0E43EeBc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA6F7AAcb380B07aE906a1C77873256525718Ed1a)
 */
export const watchPoolConfiguratorImplementationReserveFactorChangedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: poolConfiguratorImplementationAbi,
    address: poolConfiguratorImplementationAddress,
    eventName: 'ReserveFactorChanged',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link poolConfiguratorImplementationAbi}__ and `eventName` set to `"ReserveFlashLoaning"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x841df6066adc8b81b1EA401294Dc051e0E43EeBc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA6F7AAcb380B07aE906a1C77873256525718Ed1a)
 */
export const watchPoolConfiguratorImplementationReserveFlashLoaningEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: poolConfiguratorImplementationAbi,
    address: poolConfiguratorImplementationAddress,
    eventName: 'ReserveFlashLoaning',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link poolConfiguratorImplementationAbi}__ and `eventName` set to `"ReserveFrozen"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x841df6066adc8b81b1EA401294Dc051e0E43EeBc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA6F7AAcb380B07aE906a1C77873256525718Ed1a)
 */
export const watchPoolConfiguratorImplementationReserveFrozenEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: poolConfiguratorImplementationAbi,
    address: poolConfiguratorImplementationAddress,
    eventName: 'ReserveFrozen',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link poolConfiguratorImplementationAbi}__ and `eventName` set to `"ReserveInitialized"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x841df6066adc8b81b1EA401294Dc051e0E43EeBc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA6F7AAcb380B07aE906a1C77873256525718Ed1a)
 */
export const watchPoolConfiguratorImplementationReserveInitializedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: poolConfiguratorImplementationAbi,
    address: poolConfiguratorImplementationAddress,
    eventName: 'ReserveInitialized',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link poolConfiguratorImplementationAbi}__ and `eventName` set to `"ReserveInterestRateStrategyChanged"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x841df6066adc8b81b1EA401294Dc051e0E43EeBc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA6F7AAcb380B07aE906a1C77873256525718Ed1a)
 */
export const watchPoolConfiguratorImplementationReserveInterestRateStrategyChangedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: poolConfiguratorImplementationAbi,
    address: poolConfiguratorImplementationAddress,
    eventName: 'ReserveInterestRateStrategyChanged',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link poolConfiguratorImplementationAbi}__ and `eventName` set to `"ReservePaused"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x841df6066adc8b81b1EA401294Dc051e0E43EeBc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA6F7AAcb380B07aE906a1C77873256525718Ed1a)
 */
export const watchPoolConfiguratorImplementationReservePausedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: poolConfiguratorImplementationAbi,
    address: poolConfiguratorImplementationAddress,
    eventName: 'ReservePaused',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link poolConfiguratorImplementationAbi}__ and `eventName` set to `"ReserveStableRateBorrowing"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x841df6066adc8b81b1EA401294Dc051e0E43EeBc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA6F7AAcb380B07aE906a1C77873256525718Ed1a)
 */
export const watchPoolConfiguratorImplementationReserveStableRateBorrowingEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: poolConfiguratorImplementationAbi,
    address: poolConfiguratorImplementationAddress,
    eventName: 'ReserveStableRateBorrowing',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link poolConfiguratorImplementationAbi}__ and `eventName` set to `"SiloedBorrowingChanged"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x841df6066adc8b81b1EA401294Dc051e0E43EeBc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA6F7AAcb380B07aE906a1C77873256525718Ed1a)
 */
export const watchPoolConfiguratorImplementationSiloedBorrowingChangedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: poolConfiguratorImplementationAbi,
    address: poolConfiguratorImplementationAddress,
    eventName: 'SiloedBorrowingChanged',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link poolConfiguratorImplementationAbi}__ and `eventName` set to `"StableDebtTokenUpgraded"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x841df6066adc8b81b1EA401294Dc051e0E43EeBc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA6F7AAcb380B07aE906a1C77873256525718Ed1a)
 */
export const watchPoolConfiguratorImplementationStableDebtTokenUpgradedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: poolConfiguratorImplementationAbi,
    address: poolConfiguratorImplementationAddress,
    eventName: 'StableDebtTokenUpgraded',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link poolConfiguratorImplementationAbi}__ and `eventName` set to `"SupplyCapChanged"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x841df6066adc8b81b1EA401294Dc051e0E43EeBc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA6F7AAcb380B07aE906a1C77873256525718Ed1a)
 */
export const watchPoolConfiguratorImplementationSupplyCapChangedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: poolConfiguratorImplementationAbi,
    address: poolConfiguratorImplementationAddress,
    eventName: 'SupplyCapChanged',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link poolConfiguratorImplementationAbi}__ and `eventName` set to `"UnbackedMintCapChanged"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x841df6066adc8b81b1EA401294Dc051e0E43EeBc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA6F7AAcb380B07aE906a1C77873256525718Ed1a)
 */
export const watchPoolConfiguratorImplementationUnbackedMintCapChangedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: poolConfiguratorImplementationAbi,
    address: poolConfiguratorImplementationAddress,
    eventName: 'UnbackedMintCapChanged',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link poolConfiguratorImplementationAbi}__ and `eventName` set to `"VariableDebtTokenUpgraded"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x841df6066adc8b81b1EA401294Dc051e0E43EeBc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA6F7AAcb380B07aE906a1C77873256525718Ed1a)
 */
export const watchPoolConfiguratorImplementationVariableDebtTokenUpgradedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: poolConfiguratorImplementationAbi,
    address: poolConfiguratorImplementationAddress,
    eventName: 'VariableDebtTokenUpgraded',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link poolConfiguratorProxyTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x9aDFE6F23FD709e1be5C6213531213b2789563B3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x617c6dB48B462541aB84F12f7696346f33473F90)
 */
export const writePoolConfiguratorProxyTaiko =
  /*#__PURE__*/ createWriteContract({
    abi: poolConfiguratorProxyTaikoAbi,
    address: poolConfiguratorProxyTaikoAddress,
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link poolConfiguratorProxyTaikoAbi}__ and `functionName` set to `"admin"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x9aDFE6F23FD709e1be5C6213531213b2789563B3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x617c6dB48B462541aB84F12f7696346f33473F90)
 */
export const writePoolConfiguratorProxyTaikoAdmin =
  /*#__PURE__*/ createWriteContract({
    abi: poolConfiguratorProxyTaikoAbi,
    address: poolConfiguratorProxyTaikoAddress,
    functionName: 'admin',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link poolConfiguratorProxyTaikoAbi}__ and `functionName` set to `"implementation"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x9aDFE6F23FD709e1be5C6213531213b2789563B3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x617c6dB48B462541aB84F12f7696346f33473F90)
 */
export const writePoolConfiguratorProxyTaikoImplementation =
  /*#__PURE__*/ createWriteContract({
    abi: poolConfiguratorProxyTaikoAbi,
    address: poolConfiguratorProxyTaikoAddress,
    functionName: 'implementation',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link poolConfiguratorProxyTaikoAbi}__ and `functionName` set to `"initialize"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x9aDFE6F23FD709e1be5C6213531213b2789563B3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x617c6dB48B462541aB84F12f7696346f33473F90)
 */
export const writePoolConfiguratorProxyTaikoInitialize =
  /*#__PURE__*/ createWriteContract({
    abi: poolConfiguratorProxyTaikoAbi,
    address: poolConfiguratorProxyTaikoAddress,
    functionName: 'initialize',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link poolConfiguratorProxyTaikoAbi}__ and `functionName` set to `"upgradeTo"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x9aDFE6F23FD709e1be5C6213531213b2789563B3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x617c6dB48B462541aB84F12f7696346f33473F90)
 */
export const writePoolConfiguratorProxyTaikoUpgradeTo =
  /*#__PURE__*/ createWriteContract({
    abi: poolConfiguratorProxyTaikoAbi,
    address: poolConfiguratorProxyTaikoAddress,
    functionName: 'upgradeTo',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link poolConfiguratorProxyTaikoAbi}__ and `functionName` set to `"upgradeToAndCall"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x9aDFE6F23FD709e1be5C6213531213b2789563B3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x617c6dB48B462541aB84F12f7696346f33473F90)
 */
export const writePoolConfiguratorProxyTaikoUpgradeToAndCall =
  /*#__PURE__*/ createWriteContract({
    abi: poolConfiguratorProxyTaikoAbi,
    address: poolConfiguratorProxyTaikoAddress,
    functionName: 'upgradeToAndCall',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link poolConfiguratorProxyTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x9aDFE6F23FD709e1be5C6213531213b2789563B3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x617c6dB48B462541aB84F12f7696346f33473F90)
 */
export const simulatePoolConfiguratorProxyTaiko =
  /*#__PURE__*/ createSimulateContract({
    abi: poolConfiguratorProxyTaikoAbi,
    address: poolConfiguratorProxyTaikoAddress,
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link poolConfiguratorProxyTaikoAbi}__ and `functionName` set to `"admin"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x9aDFE6F23FD709e1be5C6213531213b2789563B3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x617c6dB48B462541aB84F12f7696346f33473F90)
 */
export const simulatePoolConfiguratorProxyTaikoAdmin =
  /*#__PURE__*/ createSimulateContract({
    abi: poolConfiguratorProxyTaikoAbi,
    address: poolConfiguratorProxyTaikoAddress,
    functionName: 'admin',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link poolConfiguratorProxyTaikoAbi}__ and `functionName` set to `"implementation"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x9aDFE6F23FD709e1be5C6213531213b2789563B3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x617c6dB48B462541aB84F12f7696346f33473F90)
 */
export const simulatePoolConfiguratorProxyTaikoImplementation =
  /*#__PURE__*/ createSimulateContract({
    abi: poolConfiguratorProxyTaikoAbi,
    address: poolConfiguratorProxyTaikoAddress,
    functionName: 'implementation',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link poolConfiguratorProxyTaikoAbi}__ and `functionName` set to `"initialize"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x9aDFE6F23FD709e1be5C6213531213b2789563B3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x617c6dB48B462541aB84F12f7696346f33473F90)
 */
export const simulatePoolConfiguratorProxyTaikoInitialize =
  /*#__PURE__*/ createSimulateContract({
    abi: poolConfiguratorProxyTaikoAbi,
    address: poolConfiguratorProxyTaikoAddress,
    functionName: 'initialize',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link poolConfiguratorProxyTaikoAbi}__ and `functionName` set to `"upgradeTo"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x9aDFE6F23FD709e1be5C6213531213b2789563B3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x617c6dB48B462541aB84F12f7696346f33473F90)
 */
export const simulatePoolConfiguratorProxyTaikoUpgradeTo =
  /*#__PURE__*/ createSimulateContract({
    abi: poolConfiguratorProxyTaikoAbi,
    address: poolConfiguratorProxyTaikoAddress,
    functionName: 'upgradeTo',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link poolConfiguratorProxyTaikoAbi}__ and `functionName` set to `"upgradeToAndCall"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x9aDFE6F23FD709e1be5C6213531213b2789563B3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x617c6dB48B462541aB84F12f7696346f33473F90)
 */
export const simulatePoolConfiguratorProxyTaikoUpgradeToAndCall =
  /*#__PURE__*/ createSimulateContract({
    abi: poolConfiguratorProxyTaikoAbi,
    address: poolConfiguratorProxyTaikoAddress,
    functionName: 'upgradeToAndCall',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link poolConfiguratorProxyTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x9aDFE6F23FD709e1be5C6213531213b2789563B3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x617c6dB48B462541aB84F12f7696346f33473F90)
 */
export const watchPoolConfiguratorProxyTaikoEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: poolConfiguratorProxyTaikoAbi,
    address: poolConfiguratorProxyTaikoAddress,
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link poolConfiguratorProxyTaikoAbi}__ and `eventName` set to `"Upgraded"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x9aDFE6F23FD709e1be5C6213531213b2789563B3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x617c6dB48B462541aB84F12f7696346f33473F90)
 */
export const watchPoolConfiguratorProxyTaikoUpgradedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: poolConfiguratorProxyTaikoAbi,
    address: poolConfiguratorProxyTaikoAddress,
    eventName: 'Upgraded',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link poolDataProviderTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE0c692f5e3003DD91e9ddd405cda309D15056Dc5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x3bD8FC1d1998A3fA7c80C9BAc2dA7986B1c97771)
 */
export const readPoolDataProviderTaiko = /*#__PURE__*/ createReadContract({
  abi: poolDataProviderTaikoAbi,
  address: poolDataProviderTaikoAddress,
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link poolDataProviderTaikoAbi}__ and `functionName` set to `"ADDRESSES_PROVIDER"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE0c692f5e3003DD91e9ddd405cda309D15056Dc5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x3bD8FC1d1998A3fA7c80C9BAc2dA7986B1c97771)
 */
export const readPoolDataProviderTaikoAddressesProvider =
  /*#__PURE__*/ createReadContract({
    abi: poolDataProviderTaikoAbi,
    address: poolDataProviderTaikoAddress,
    functionName: 'ADDRESSES_PROVIDER',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link poolDataProviderTaikoAbi}__ and `functionName` set to `"getATokenTotalSupply"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE0c692f5e3003DD91e9ddd405cda309D15056Dc5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x3bD8FC1d1998A3fA7c80C9BAc2dA7986B1c97771)
 */
export const readPoolDataProviderTaikoGetATokenTotalSupply =
  /*#__PURE__*/ createReadContract({
    abi: poolDataProviderTaikoAbi,
    address: poolDataProviderTaikoAddress,
    functionName: 'getATokenTotalSupply',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link poolDataProviderTaikoAbi}__ and `functionName` set to `"getAllATokens"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE0c692f5e3003DD91e9ddd405cda309D15056Dc5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x3bD8FC1d1998A3fA7c80C9BAc2dA7986B1c97771)
 */
export const readPoolDataProviderTaikoGetAllATokens =
  /*#__PURE__*/ createReadContract({
    abi: poolDataProviderTaikoAbi,
    address: poolDataProviderTaikoAddress,
    functionName: 'getAllATokens',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link poolDataProviderTaikoAbi}__ and `functionName` set to `"getAllReservesTokens"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE0c692f5e3003DD91e9ddd405cda309D15056Dc5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x3bD8FC1d1998A3fA7c80C9BAc2dA7986B1c97771)
 */
export const readPoolDataProviderTaikoGetAllReservesTokens =
  /*#__PURE__*/ createReadContract({
    abi: poolDataProviderTaikoAbi,
    address: poolDataProviderTaikoAddress,
    functionName: 'getAllReservesTokens',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link poolDataProviderTaikoAbi}__ and `functionName` set to `"getDebtCeiling"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE0c692f5e3003DD91e9ddd405cda309D15056Dc5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x3bD8FC1d1998A3fA7c80C9BAc2dA7986B1c97771)
 */
export const readPoolDataProviderTaikoGetDebtCeiling =
  /*#__PURE__*/ createReadContract({
    abi: poolDataProviderTaikoAbi,
    address: poolDataProviderTaikoAddress,
    functionName: 'getDebtCeiling',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link poolDataProviderTaikoAbi}__ and `functionName` set to `"getDebtCeilingDecimals"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE0c692f5e3003DD91e9ddd405cda309D15056Dc5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x3bD8FC1d1998A3fA7c80C9BAc2dA7986B1c97771)
 */
export const readPoolDataProviderTaikoGetDebtCeilingDecimals =
  /*#__PURE__*/ createReadContract({
    abi: poolDataProviderTaikoAbi,
    address: poolDataProviderTaikoAddress,
    functionName: 'getDebtCeilingDecimals',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link poolDataProviderTaikoAbi}__ and `functionName` set to `"getFlashLoanEnabled"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE0c692f5e3003DD91e9ddd405cda309D15056Dc5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x3bD8FC1d1998A3fA7c80C9BAc2dA7986B1c97771)
 */
export const readPoolDataProviderTaikoGetFlashLoanEnabled =
  /*#__PURE__*/ createReadContract({
    abi: poolDataProviderTaikoAbi,
    address: poolDataProviderTaikoAddress,
    functionName: 'getFlashLoanEnabled',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link poolDataProviderTaikoAbi}__ and `functionName` set to `"getInterestRateStrategyAddress"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE0c692f5e3003DD91e9ddd405cda309D15056Dc5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x3bD8FC1d1998A3fA7c80C9BAc2dA7986B1c97771)
 */
export const readPoolDataProviderTaikoGetInterestRateStrategyAddress =
  /*#__PURE__*/ createReadContract({
    abi: poolDataProviderTaikoAbi,
    address: poolDataProviderTaikoAddress,
    functionName: 'getInterestRateStrategyAddress',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link poolDataProviderTaikoAbi}__ and `functionName` set to `"getLiquidationProtocolFee"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE0c692f5e3003DD91e9ddd405cda309D15056Dc5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x3bD8FC1d1998A3fA7c80C9BAc2dA7986B1c97771)
 */
export const readPoolDataProviderTaikoGetLiquidationProtocolFee =
  /*#__PURE__*/ createReadContract({
    abi: poolDataProviderTaikoAbi,
    address: poolDataProviderTaikoAddress,
    functionName: 'getLiquidationProtocolFee',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link poolDataProviderTaikoAbi}__ and `functionName` set to `"getPaused"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE0c692f5e3003DD91e9ddd405cda309D15056Dc5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x3bD8FC1d1998A3fA7c80C9BAc2dA7986B1c97771)
 */
export const readPoolDataProviderTaikoGetPaused =
  /*#__PURE__*/ createReadContract({
    abi: poolDataProviderTaikoAbi,
    address: poolDataProviderTaikoAddress,
    functionName: 'getPaused',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link poolDataProviderTaikoAbi}__ and `functionName` set to `"getReserveCaps"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE0c692f5e3003DD91e9ddd405cda309D15056Dc5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x3bD8FC1d1998A3fA7c80C9BAc2dA7986B1c97771)
 */
export const readPoolDataProviderTaikoGetReserveCaps =
  /*#__PURE__*/ createReadContract({
    abi: poolDataProviderTaikoAbi,
    address: poolDataProviderTaikoAddress,
    functionName: 'getReserveCaps',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link poolDataProviderTaikoAbi}__ and `functionName` set to `"getReserveConfigurationData"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE0c692f5e3003DD91e9ddd405cda309D15056Dc5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x3bD8FC1d1998A3fA7c80C9BAc2dA7986B1c97771)
 */
export const readPoolDataProviderTaikoGetReserveConfigurationData =
  /*#__PURE__*/ createReadContract({
    abi: poolDataProviderTaikoAbi,
    address: poolDataProviderTaikoAddress,
    functionName: 'getReserveConfigurationData',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link poolDataProviderTaikoAbi}__ and `functionName` set to `"getReserveData"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE0c692f5e3003DD91e9ddd405cda309D15056Dc5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x3bD8FC1d1998A3fA7c80C9BAc2dA7986B1c97771)
 */
export const readPoolDataProviderTaikoGetReserveData =
  /*#__PURE__*/ createReadContract({
    abi: poolDataProviderTaikoAbi,
    address: poolDataProviderTaikoAddress,
    functionName: 'getReserveData',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link poolDataProviderTaikoAbi}__ and `functionName` set to `"getReserveEModeCategory"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE0c692f5e3003DD91e9ddd405cda309D15056Dc5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x3bD8FC1d1998A3fA7c80C9BAc2dA7986B1c97771)
 */
export const readPoolDataProviderTaikoGetReserveEModeCategory =
  /*#__PURE__*/ createReadContract({
    abi: poolDataProviderTaikoAbi,
    address: poolDataProviderTaikoAddress,
    functionName: 'getReserveEModeCategory',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link poolDataProviderTaikoAbi}__ and `functionName` set to `"getReserveTokensAddresses"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE0c692f5e3003DD91e9ddd405cda309D15056Dc5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x3bD8FC1d1998A3fA7c80C9BAc2dA7986B1c97771)
 */
export const readPoolDataProviderTaikoGetReserveTokensAddresses =
  /*#__PURE__*/ createReadContract({
    abi: poolDataProviderTaikoAbi,
    address: poolDataProviderTaikoAddress,
    functionName: 'getReserveTokensAddresses',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link poolDataProviderTaikoAbi}__ and `functionName` set to `"getSiloedBorrowing"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE0c692f5e3003DD91e9ddd405cda309D15056Dc5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x3bD8FC1d1998A3fA7c80C9BAc2dA7986B1c97771)
 */
export const readPoolDataProviderTaikoGetSiloedBorrowing =
  /*#__PURE__*/ createReadContract({
    abi: poolDataProviderTaikoAbi,
    address: poolDataProviderTaikoAddress,
    functionName: 'getSiloedBorrowing',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link poolDataProviderTaikoAbi}__ and `functionName` set to `"getTotalDebt"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE0c692f5e3003DD91e9ddd405cda309D15056Dc5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x3bD8FC1d1998A3fA7c80C9BAc2dA7986B1c97771)
 */
export const readPoolDataProviderTaikoGetTotalDebt =
  /*#__PURE__*/ createReadContract({
    abi: poolDataProviderTaikoAbi,
    address: poolDataProviderTaikoAddress,
    functionName: 'getTotalDebt',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link poolDataProviderTaikoAbi}__ and `functionName` set to `"getUnbackedMintCap"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE0c692f5e3003DD91e9ddd405cda309D15056Dc5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x3bD8FC1d1998A3fA7c80C9BAc2dA7986B1c97771)
 */
export const readPoolDataProviderTaikoGetUnbackedMintCap =
  /*#__PURE__*/ createReadContract({
    abi: poolDataProviderTaikoAbi,
    address: poolDataProviderTaikoAddress,
    functionName: 'getUnbackedMintCap',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link poolDataProviderTaikoAbi}__ and `functionName` set to `"getUserReserveData"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE0c692f5e3003DD91e9ddd405cda309D15056Dc5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x3bD8FC1d1998A3fA7c80C9BAc2dA7986B1c97771)
 */
export const readPoolDataProviderTaikoGetUserReserveData =
  /*#__PURE__*/ createReadContract({
    abi: poolDataProviderTaikoAbi,
    address: poolDataProviderTaikoAddress,
    functionName: 'getUserReserveData',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link poolLogicAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x108122C4E3df0F087Ddc41d8FA15F6390c7125D7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xF3d84dba7c4ac5FeBc53286c7E5A3F4fEd5F2Bae)
 */
export const watchPoolLogicEvent = /*#__PURE__*/ createWatchContractEvent({
  abi: poolLogicAbi,
  address: poolLogicAddress,
})

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link poolLogicAbi}__ and `eventName` set to `"IsolationModeTotalDebtUpdated"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x108122C4E3df0F087Ddc41d8FA15F6390c7125D7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xF3d84dba7c4ac5FeBc53286c7E5A3F4fEd5F2Bae)
 */
export const watchPoolLogicIsolationModeTotalDebtUpdatedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: poolLogicAbi,
    address: poolLogicAddress,
    eventName: 'IsolationModeTotalDebtUpdated',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link poolLogicAbi}__ and `eventName` set to `"MintedToTreasury"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x108122C4E3df0F087Ddc41d8FA15F6390c7125D7)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xF3d84dba7c4ac5FeBc53286c7E5A3F4fEd5F2Bae)
 */
export const watchPoolLogicMintedToTreasuryEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: poolLogicAbi,
    address: poolLogicAddress,
    eventName: 'MintedToTreasury',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link pullRewardsTransferStrategyAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xcDa727FC3ab1B502D8ffb92dDA7A6F2aCF040107)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa382c7147A7c9847e38b7D236DFB572Ff3e6576F)
 */
export const readPullRewardsTransferStrategy = /*#__PURE__*/ createReadContract(
  {
    abi: pullRewardsTransferStrategyAbi,
    address: pullRewardsTransferStrategyAddress,
  },
)

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link pullRewardsTransferStrategyAbi}__ and `functionName` set to `"getIncentivesController"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xcDa727FC3ab1B502D8ffb92dDA7A6F2aCF040107)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa382c7147A7c9847e38b7D236DFB572Ff3e6576F)
 */
export const readPullRewardsTransferStrategyGetIncentivesController =
  /*#__PURE__*/ createReadContract({
    abi: pullRewardsTransferStrategyAbi,
    address: pullRewardsTransferStrategyAddress,
    functionName: 'getIncentivesController',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link pullRewardsTransferStrategyAbi}__ and `functionName` set to `"getRewardsAdmin"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xcDa727FC3ab1B502D8ffb92dDA7A6F2aCF040107)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa382c7147A7c9847e38b7D236DFB572Ff3e6576F)
 */
export const readPullRewardsTransferStrategyGetRewardsAdmin =
  /*#__PURE__*/ createReadContract({
    abi: pullRewardsTransferStrategyAbi,
    address: pullRewardsTransferStrategyAddress,
    functionName: 'getRewardsAdmin',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link pullRewardsTransferStrategyAbi}__ and `functionName` set to `"getRewardsVault"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xcDa727FC3ab1B502D8ffb92dDA7A6F2aCF040107)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa382c7147A7c9847e38b7D236DFB572Ff3e6576F)
 */
export const readPullRewardsTransferStrategyGetRewardsVault =
  /*#__PURE__*/ createReadContract({
    abi: pullRewardsTransferStrategyAbi,
    address: pullRewardsTransferStrategyAddress,
    functionName: 'getRewardsVault',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link pullRewardsTransferStrategyAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xcDa727FC3ab1B502D8ffb92dDA7A6F2aCF040107)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa382c7147A7c9847e38b7D236DFB572Ff3e6576F)
 */
export const writePullRewardsTransferStrategy =
  /*#__PURE__*/ createWriteContract({
    abi: pullRewardsTransferStrategyAbi,
    address: pullRewardsTransferStrategyAddress,
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link pullRewardsTransferStrategyAbi}__ and `functionName` set to `"emergencyWithdrawal"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xcDa727FC3ab1B502D8ffb92dDA7A6F2aCF040107)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa382c7147A7c9847e38b7D236DFB572Ff3e6576F)
 */
export const writePullRewardsTransferStrategyEmergencyWithdrawal =
  /*#__PURE__*/ createWriteContract({
    abi: pullRewardsTransferStrategyAbi,
    address: pullRewardsTransferStrategyAddress,
    functionName: 'emergencyWithdrawal',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link pullRewardsTransferStrategyAbi}__ and `functionName` set to `"performTransfer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xcDa727FC3ab1B502D8ffb92dDA7A6F2aCF040107)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa382c7147A7c9847e38b7D236DFB572Ff3e6576F)
 */
export const writePullRewardsTransferStrategyPerformTransfer =
  /*#__PURE__*/ createWriteContract({
    abi: pullRewardsTransferStrategyAbi,
    address: pullRewardsTransferStrategyAddress,
    functionName: 'performTransfer',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link pullRewardsTransferStrategyAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xcDa727FC3ab1B502D8ffb92dDA7A6F2aCF040107)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa382c7147A7c9847e38b7D236DFB572Ff3e6576F)
 */
export const simulatePullRewardsTransferStrategy =
  /*#__PURE__*/ createSimulateContract({
    abi: pullRewardsTransferStrategyAbi,
    address: pullRewardsTransferStrategyAddress,
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link pullRewardsTransferStrategyAbi}__ and `functionName` set to `"emergencyWithdrawal"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xcDa727FC3ab1B502D8ffb92dDA7A6F2aCF040107)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa382c7147A7c9847e38b7D236DFB572Ff3e6576F)
 */
export const simulatePullRewardsTransferStrategyEmergencyWithdrawal =
  /*#__PURE__*/ createSimulateContract({
    abi: pullRewardsTransferStrategyAbi,
    address: pullRewardsTransferStrategyAddress,
    functionName: 'emergencyWithdrawal',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link pullRewardsTransferStrategyAbi}__ and `functionName` set to `"performTransfer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xcDa727FC3ab1B502D8ffb92dDA7A6F2aCF040107)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa382c7147A7c9847e38b7D236DFB572Ff3e6576F)
 */
export const simulatePullRewardsTransferStrategyPerformTransfer =
  /*#__PURE__*/ createSimulateContract({
    abi: pullRewardsTransferStrategyAbi,
    address: pullRewardsTransferStrategyAddress,
    functionName: 'performTransfer',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link pullRewardsTransferStrategyAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xcDa727FC3ab1B502D8ffb92dDA7A6F2aCF040107)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa382c7147A7c9847e38b7D236DFB572Ff3e6576F)
 */
export const watchPullRewardsTransferStrategyEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: pullRewardsTransferStrategyAbi,
    address: pullRewardsTransferStrategyAddress,
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link pullRewardsTransferStrategyAbi}__ and `eventName` set to `"EmergencyWithdrawal"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xcDa727FC3ab1B502D8ffb92dDA7A6F2aCF040107)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa382c7147A7c9847e38b7D236DFB572Ff3e6576F)
 */
export const watchPullRewardsTransferStrategyEmergencyWithdrawalEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: pullRewardsTransferStrategyAbi,
    address: pullRewardsTransferStrategyAddress,
    eventName: 'EmergencyWithdrawal',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyStableOneAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xc1Bc62b5E91Db9cBb4055F4DC9B2983d4cbc32f6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x3E4260a74E2EAc5DCdb983BCB99FafEdF215e4e5)
 */
export const readReserveStrategyRateStrategyStableOne =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyStableOneAbi,
    address: reserveStrategyRateStrategyStableOneAddress,
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyStableOneAbi}__ and `functionName` set to `"ADDRESSES_PROVIDER"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xc1Bc62b5E91Db9cBb4055F4DC9B2983d4cbc32f6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x3E4260a74E2EAc5DCdb983BCB99FafEdF215e4e5)
 */
export const readReserveStrategyRateStrategyStableOneAddressesProvider =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyStableOneAbi,
    address: reserveStrategyRateStrategyStableOneAddress,
    functionName: 'ADDRESSES_PROVIDER',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyStableOneAbi}__ and `functionName` set to `"MAX_EXCESS_STABLE_TO_TOTAL_DEBT_RATIO"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xc1Bc62b5E91Db9cBb4055F4DC9B2983d4cbc32f6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x3E4260a74E2EAc5DCdb983BCB99FafEdF215e4e5)
 */
export const readReserveStrategyRateStrategyStableOneMaxExcessStableToTotalDebtRatio =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyStableOneAbi,
    address: reserveStrategyRateStrategyStableOneAddress,
    functionName: 'MAX_EXCESS_STABLE_TO_TOTAL_DEBT_RATIO',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyStableOneAbi}__ and `functionName` set to `"MAX_EXCESS_USAGE_RATIO"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xc1Bc62b5E91Db9cBb4055F4DC9B2983d4cbc32f6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x3E4260a74E2EAc5DCdb983BCB99FafEdF215e4e5)
 */
export const readReserveStrategyRateStrategyStableOneMaxExcessUsageRatio =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyStableOneAbi,
    address: reserveStrategyRateStrategyStableOneAddress,
    functionName: 'MAX_EXCESS_USAGE_RATIO',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyStableOneAbi}__ and `functionName` set to `"OPTIMAL_STABLE_TO_TOTAL_DEBT_RATIO"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xc1Bc62b5E91Db9cBb4055F4DC9B2983d4cbc32f6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x3E4260a74E2EAc5DCdb983BCB99FafEdF215e4e5)
 */
export const readReserveStrategyRateStrategyStableOneOptimalStableToTotalDebtRatio =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyStableOneAbi,
    address: reserveStrategyRateStrategyStableOneAddress,
    functionName: 'OPTIMAL_STABLE_TO_TOTAL_DEBT_RATIO',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyStableOneAbi}__ and `functionName` set to `"OPTIMAL_USAGE_RATIO"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xc1Bc62b5E91Db9cBb4055F4DC9B2983d4cbc32f6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x3E4260a74E2EAc5DCdb983BCB99FafEdF215e4e5)
 */
export const readReserveStrategyRateStrategyStableOneOptimalUsageRatio =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyStableOneAbi,
    address: reserveStrategyRateStrategyStableOneAddress,
    functionName: 'OPTIMAL_USAGE_RATIO',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyStableOneAbi}__ and `functionName` set to `"calculateInterestRates"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xc1Bc62b5E91Db9cBb4055F4DC9B2983d4cbc32f6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x3E4260a74E2EAc5DCdb983BCB99FafEdF215e4e5)
 */
export const readReserveStrategyRateStrategyStableOneCalculateInterestRates =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyStableOneAbi,
    address: reserveStrategyRateStrategyStableOneAddress,
    functionName: 'calculateInterestRates',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyStableOneAbi}__ and `functionName` set to `"getBaseStableBorrowRate"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xc1Bc62b5E91Db9cBb4055F4DC9B2983d4cbc32f6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x3E4260a74E2EAc5DCdb983BCB99FafEdF215e4e5)
 */
export const readReserveStrategyRateStrategyStableOneGetBaseStableBorrowRate =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyStableOneAbi,
    address: reserveStrategyRateStrategyStableOneAddress,
    functionName: 'getBaseStableBorrowRate',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyStableOneAbi}__ and `functionName` set to `"getBaseVariableBorrowRate"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xc1Bc62b5E91Db9cBb4055F4DC9B2983d4cbc32f6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x3E4260a74E2EAc5DCdb983BCB99FafEdF215e4e5)
 */
export const readReserveStrategyRateStrategyStableOneGetBaseVariableBorrowRate =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyStableOneAbi,
    address: reserveStrategyRateStrategyStableOneAddress,
    functionName: 'getBaseVariableBorrowRate',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyStableOneAbi}__ and `functionName` set to `"getMaxVariableBorrowRate"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xc1Bc62b5E91Db9cBb4055F4DC9B2983d4cbc32f6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x3E4260a74E2EAc5DCdb983BCB99FafEdF215e4e5)
 */
export const readReserveStrategyRateStrategyStableOneGetMaxVariableBorrowRate =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyStableOneAbi,
    address: reserveStrategyRateStrategyStableOneAddress,
    functionName: 'getMaxVariableBorrowRate',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyStableOneAbi}__ and `functionName` set to `"getStableRateExcessOffset"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xc1Bc62b5E91Db9cBb4055F4DC9B2983d4cbc32f6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x3E4260a74E2EAc5DCdb983BCB99FafEdF215e4e5)
 */
export const readReserveStrategyRateStrategyStableOneGetStableRateExcessOffset =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyStableOneAbi,
    address: reserveStrategyRateStrategyStableOneAddress,
    functionName: 'getStableRateExcessOffset',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyStableOneAbi}__ and `functionName` set to `"getStableRateSlope1"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xc1Bc62b5E91Db9cBb4055F4DC9B2983d4cbc32f6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x3E4260a74E2EAc5DCdb983BCB99FafEdF215e4e5)
 */
export const readReserveStrategyRateStrategyStableOneGetStableRateSlope1 =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyStableOneAbi,
    address: reserveStrategyRateStrategyStableOneAddress,
    functionName: 'getStableRateSlope1',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyStableOneAbi}__ and `functionName` set to `"getStableRateSlope2"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xc1Bc62b5E91Db9cBb4055F4DC9B2983d4cbc32f6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x3E4260a74E2EAc5DCdb983BCB99FafEdF215e4e5)
 */
export const readReserveStrategyRateStrategyStableOneGetStableRateSlope2 =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyStableOneAbi,
    address: reserveStrategyRateStrategyStableOneAddress,
    functionName: 'getStableRateSlope2',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyStableOneAbi}__ and `functionName` set to `"getVariableRateSlope1"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xc1Bc62b5E91Db9cBb4055F4DC9B2983d4cbc32f6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x3E4260a74E2EAc5DCdb983BCB99FafEdF215e4e5)
 */
export const readReserveStrategyRateStrategyStableOneGetVariableRateSlope1 =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyStableOneAbi,
    address: reserveStrategyRateStrategyStableOneAddress,
    functionName: 'getVariableRateSlope1',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyStableOneAbi}__ and `functionName` set to `"getVariableRateSlope2"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xc1Bc62b5E91Db9cBb4055F4DC9B2983d4cbc32f6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x3E4260a74E2EAc5DCdb983BCB99FafEdF215e4e5)
 */
export const readReserveStrategyRateStrategyStableOneGetVariableRateSlope2 =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyStableOneAbi,
    address: reserveStrategyRateStrategyStableOneAddress,
    functionName: 'getVariableRateSlope2',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyStableTwoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBC19Ef2e78472a986BB78B09D467f4D61F9F35f3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7bBbD2a37226928d1E67CC3079aFd40204FC4531)
 */
export const readReserveStrategyRateStrategyStableTwo =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyStableTwoAbi,
    address: reserveStrategyRateStrategyStableTwoAddress,
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyStableTwoAbi}__ and `functionName` set to `"ADDRESSES_PROVIDER"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBC19Ef2e78472a986BB78B09D467f4D61F9F35f3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7bBbD2a37226928d1E67CC3079aFd40204FC4531)
 */
export const readReserveStrategyRateStrategyStableTwoAddressesProvider =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyStableTwoAbi,
    address: reserveStrategyRateStrategyStableTwoAddress,
    functionName: 'ADDRESSES_PROVIDER',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyStableTwoAbi}__ and `functionName` set to `"MAX_EXCESS_STABLE_TO_TOTAL_DEBT_RATIO"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBC19Ef2e78472a986BB78B09D467f4D61F9F35f3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7bBbD2a37226928d1E67CC3079aFd40204FC4531)
 */
export const readReserveStrategyRateStrategyStableTwoMaxExcessStableToTotalDebtRatio =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyStableTwoAbi,
    address: reserveStrategyRateStrategyStableTwoAddress,
    functionName: 'MAX_EXCESS_STABLE_TO_TOTAL_DEBT_RATIO',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyStableTwoAbi}__ and `functionName` set to `"MAX_EXCESS_USAGE_RATIO"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBC19Ef2e78472a986BB78B09D467f4D61F9F35f3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7bBbD2a37226928d1E67CC3079aFd40204FC4531)
 */
export const readReserveStrategyRateStrategyStableTwoMaxExcessUsageRatio =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyStableTwoAbi,
    address: reserveStrategyRateStrategyStableTwoAddress,
    functionName: 'MAX_EXCESS_USAGE_RATIO',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyStableTwoAbi}__ and `functionName` set to `"OPTIMAL_STABLE_TO_TOTAL_DEBT_RATIO"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBC19Ef2e78472a986BB78B09D467f4D61F9F35f3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7bBbD2a37226928d1E67CC3079aFd40204FC4531)
 */
export const readReserveStrategyRateStrategyStableTwoOptimalStableToTotalDebtRatio =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyStableTwoAbi,
    address: reserveStrategyRateStrategyStableTwoAddress,
    functionName: 'OPTIMAL_STABLE_TO_TOTAL_DEBT_RATIO',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyStableTwoAbi}__ and `functionName` set to `"OPTIMAL_USAGE_RATIO"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBC19Ef2e78472a986BB78B09D467f4D61F9F35f3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7bBbD2a37226928d1E67CC3079aFd40204FC4531)
 */
export const readReserveStrategyRateStrategyStableTwoOptimalUsageRatio =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyStableTwoAbi,
    address: reserveStrategyRateStrategyStableTwoAddress,
    functionName: 'OPTIMAL_USAGE_RATIO',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyStableTwoAbi}__ and `functionName` set to `"calculateInterestRates"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBC19Ef2e78472a986BB78B09D467f4D61F9F35f3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7bBbD2a37226928d1E67CC3079aFd40204FC4531)
 */
export const readReserveStrategyRateStrategyStableTwoCalculateInterestRates =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyStableTwoAbi,
    address: reserveStrategyRateStrategyStableTwoAddress,
    functionName: 'calculateInterestRates',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyStableTwoAbi}__ and `functionName` set to `"getBaseStableBorrowRate"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBC19Ef2e78472a986BB78B09D467f4D61F9F35f3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7bBbD2a37226928d1E67CC3079aFd40204FC4531)
 */
export const readReserveStrategyRateStrategyStableTwoGetBaseStableBorrowRate =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyStableTwoAbi,
    address: reserveStrategyRateStrategyStableTwoAddress,
    functionName: 'getBaseStableBorrowRate',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyStableTwoAbi}__ and `functionName` set to `"getBaseVariableBorrowRate"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBC19Ef2e78472a986BB78B09D467f4D61F9F35f3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7bBbD2a37226928d1E67CC3079aFd40204FC4531)
 */
export const readReserveStrategyRateStrategyStableTwoGetBaseVariableBorrowRate =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyStableTwoAbi,
    address: reserveStrategyRateStrategyStableTwoAddress,
    functionName: 'getBaseVariableBorrowRate',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyStableTwoAbi}__ and `functionName` set to `"getMaxVariableBorrowRate"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBC19Ef2e78472a986BB78B09D467f4D61F9F35f3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7bBbD2a37226928d1E67CC3079aFd40204FC4531)
 */
export const readReserveStrategyRateStrategyStableTwoGetMaxVariableBorrowRate =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyStableTwoAbi,
    address: reserveStrategyRateStrategyStableTwoAddress,
    functionName: 'getMaxVariableBorrowRate',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyStableTwoAbi}__ and `functionName` set to `"getStableRateExcessOffset"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBC19Ef2e78472a986BB78B09D467f4D61F9F35f3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7bBbD2a37226928d1E67CC3079aFd40204FC4531)
 */
export const readReserveStrategyRateStrategyStableTwoGetStableRateExcessOffset =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyStableTwoAbi,
    address: reserveStrategyRateStrategyStableTwoAddress,
    functionName: 'getStableRateExcessOffset',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyStableTwoAbi}__ and `functionName` set to `"getStableRateSlope1"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBC19Ef2e78472a986BB78B09D467f4D61F9F35f3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7bBbD2a37226928d1E67CC3079aFd40204FC4531)
 */
export const readReserveStrategyRateStrategyStableTwoGetStableRateSlope1 =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyStableTwoAbi,
    address: reserveStrategyRateStrategyStableTwoAddress,
    functionName: 'getStableRateSlope1',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyStableTwoAbi}__ and `functionName` set to `"getStableRateSlope2"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBC19Ef2e78472a986BB78B09D467f4D61F9F35f3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7bBbD2a37226928d1E67CC3079aFd40204FC4531)
 */
export const readReserveStrategyRateStrategyStableTwoGetStableRateSlope2 =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyStableTwoAbi,
    address: reserveStrategyRateStrategyStableTwoAddress,
    functionName: 'getStableRateSlope2',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyStableTwoAbi}__ and `functionName` set to `"getVariableRateSlope1"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBC19Ef2e78472a986BB78B09D467f4D61F9F35f3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7bBbD2a37226928d1E67CC3079aFd40204FC4531)
 */
export const readReserveStrategyRateStrategyStableTwoGetVariableRateSlope1 =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyStableTwoAbi,
    address: reserveStrategyRateStrategyStableTwoAddress,
    functionName: 'getVariableRateSlope1',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyStableTwoAbi}__ and `functionName` set to `"getVariableRateSlope2"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBC19Ef2e78472a986BB78B09D467f4D61F9F35f3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7bBbD2a37226928d1E67CC3079aFd40204FC4531)
 */
export const readReserveStrategyRateStrategyStableTwoGetVariableRateSlope2 =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyStableTwoAbi,
    address: reserveStrategyRateStrategyStableTwoAddress,
    functionName: 'getVariableRateSlope2',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyVolatileOneAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x7CE156823Dec1A2106285308296E11B97e9356a4)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x3e8Be7364FE6dE5B5B54F6e6E2739A8aB7157d0a)
 */
export const readReserveStrategyRateStrategyVolatileOne =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyVolatileOneAbi,
    address: reserveStrategyRateStrategyVolatileOneAddress,
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyVolatileOneAbi}__ and `functionName` set to `"ADDRESSES_PROVIDER"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x7CE156823Dec1A2106285308296E11B97e9356a4)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x3e8Be7364FE6dE5B5B54F6e6E2739A8aB7157d0a)
 */
export const readReserveStrategyRateStrategyVolatileOneAddressesProvider =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyVolatileOneAbi,
    address: reserveStrategyRateStrategyVolatileOneAddress,
    functionName: 'ADDRESSES_PROVIDER',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyVolatileOneAbi}__ and `functionName` set to `"MAX_EXCESS_STABLE_TO_TOTAL_DEBT_RATIO"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x7CE156823Dec1A2106285308296E11B97e9356a4)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x3e8Be7364FE6dE5B5B54F6e6E2739A8aB7157d0a)
 */
export const readReserveStrategyRateStrategyVolatileOneMaxExcessStableToTotalDebtRatio =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyVolatileOneAbi,
    address: reserveStrategyRateStrategyVolatileOneAddress,
    functionName: 'MAX_EXCESS_STABLE_TO_TOTAL_DEBT_RATIO',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyVolatileOneAbi}__ and `functionName` set to `"MAX_EXCESS_USAGE_RATIO"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x7CE156823Dec1A2106285308296E11B97e9356a4)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x3e8Be7364FE6dE5B5B54F6e6E2739A8aB7157d0a)
 */
export const readReserveStrategyRateStrategyVolatileOneMaxExcessUsageRatio =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyVolatileOneAbi,
    address: reserveStrategyRateStrategyVolatileOneAddress,
    functionName: 'MAX_EXCESS_USAGE_RATIO',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyVolatileOneAbi}__ and `functionName` set to `"OPTIMAL_STABLE_TO_TOTAL_DEBT_RATIO"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x7CE156823Dec1A2106285308296E11B97e9356a4)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x3e8Be7364FE6dE5B5B54F6e6E2739A8aB7157d0a)
 */
export const readReserveStrategyRateStrategyVolatileOneOptimalStableToTotalDebtRatio =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyVolatileOneAbi,
    address: reserveStrategyRateStrategyVolatileOneAddress,
    functionName: 'OPTIMAL_STABLE_TO_TOTAL_DEBT_RATIO',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyVolatileOneAbi}__ and `functionName` set to `"OPTIMAL_USAGE_RATIO"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x7CE156823Dec1A2106285308296E11B97e9356a4)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x3e8Be7364FE6dE5B5B54F6e6E2739A8aB7157d0a)
 */
export const readReserveStrategyRateStrategyVolatileOneOptimalUsageRatio =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyVolatileOneAbi,
    address: reserveStrategyRateStrategyVolatileOneAddress,
    functionName: 'OPTIMAL_USAGE_RATIO',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyVolatileOneAbi}__ and `functionName` set to `"calculateInterestRates"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x7CE156823Dec1A2106285308296E11B97e9356a4)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x3e8Be7364FE6dE5B5B54F6e6E2739A8aB7157d0a)
 */
export const readReserveStrategyRateStrategyVolatileOneCalculateInterestRates =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyVolatileOneAbi,
    address: reserveStrategyRateStrategyVolatileOneAddress,
    functionName: 'calculateInterestRates',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyVolatileOneAbi}__ and `functionName` set to `"getBaseStableBorrowRate"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x7CE156823Dec1A2106285308296E11B97e9356a4)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x3e8Be7364FE6dE5B5B54F6e6E2739A8aB7157d0a)
 */
export const readReserveStrategyRateStrategyVolatileOneGetBaseStableBorrowRate =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyVolatileOneAbi,
    address: reserveStrategyRateStrategyVolatileOneAddress,
    functionName: 'getBaseStableBorrowRate',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyVolatileOneAbi}__ and `functionName` set to `"getBaseVariableBorrowRate"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x7CE156823Dec1A2106285308296E11B97e9356a4)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x3e8Be7364FE6dE5B5B54F6e6E2739A8aB7157d0a)
 */
export const readReserveStrategyRateStrategyVolatileOneGetBaseVariableBorrowRate =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyVolatileOneAbi,
    address: reserveStrategyRateStrategyVolatileOneAddress,
    functionName: 'getBaseVariableBorrowRate',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyVolatileOneAbi}__ and `functionName` set to `"getMaxVariableBorrowRate"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x7CE156823Dec1A2106285308296E11B97e9356a4)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x3e8Be7364FE6dE5B5B54F6e6E2739A8aB7157d0a)
 */
export const readReserveStrategyRateStrategyVolatileOneGetMaxVariableBorrowRate =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyVolatileOneAbi,
    address: reserveStrategyRateStrategyVolatileOneAddress,
    functionName: 'getMaxVariableBorrowRate',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyVolatileOneAbi}__ and `functionName` set to `"getStableRateExcessOffset"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x7CE156823Dec1A2106285308296E11B97e9356a4)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x3e8Be7364FE6dE5B5B54F6e6E2739A8aB7157d0a)
 */
export const readReserveStrategyRateStrategyVolatileOneGetStableRateExcessOffset =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyVolatileOneAbi,
    address: reserveStrategyRateStrategyVolatileOneAddress,
    functionName: 'getStableRateExcessOffset',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyVolatileOneAbi}__ and `functionName` set to `"getStableRateSlope1"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x7CE156823Dec1A2106285308296E11B97e9356a4)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x3e8Be7364FE6dE5B5B54F6e6E2739A8aB7157d0a)
 */
export const readReserveStrategyRateStrategyVolatileOneGetStableRateSlope1 =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyVolatileOneAbi,
    address: reserveStrategyRateStrategyVolatileOneAddress,
    functionName: 'getStableRateSlope1',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyVolatileOneAbi}__ and `functionName` set to `"getStableRateSlope2"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x7CE156823Dec1A2106285308296E11B97e9356a4)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x3e8Be7364FE6dE5B5B54F6e6E2739A8aB7157d0a)
 */
export const readReserveStrategyRateStrategyVolatileOneGetStableRateSlope2 =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyVolatileOneAbi,
    address: reserveStrategyRateStrategyVolatileOneAddress,
    functionName: 'getStableRateSlope2',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyVolatileOneAbi}__ and `functionName` set to `"getVariableRateSlope1"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x7CE156823Dec1A2106285308296E11B97e9356a4)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x3e8Be7364FE6dE5B5B54F6e6E2739A8aB7157d0a)
 */
export const readReserveStrategyRateStrategyVolatileOneGetVariableRateSlope1 =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyVolatileOneAbi,
    address: reserveStrategyRateStrategyVolatileOneAddress,
    functionName: 'getVariableRateSlope1',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyVolatileOneAbi}__ and `functionName` set to `"getVariableRateSlope2"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x7CE156823Dec1A2106285308296E11B97e9356a4)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x3e8Be7364FE6dE5B5B54F6e6E2739A8aB7157d0a)
 */
export const readReserveStrategyRateStrategyVolatileOneGetVariableRateSlope2 =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyVolatileOneAbi,
    address: reserveStrategyRateStrategyVolatileOneAddress,
    functionName: 'getVariableRateSlope2',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyVolatileTkoAbi}__
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x620d0e1371c1E0B44867E04E17d166EbfeAF5759)
 */
export const readReserveStrategyRateStrategyVolatileTko =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyVolatileTkoAbi,
    address: reserveStrategyRateStrategyVolatileTkoAddress,
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyVolatileTkoAbi}__ and `functionName` set to `"ADDRESSES_PROVIDER"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x620d0e1371c1E0B44867E04E17d166EbfeAF5759)
 */
export const readReserveStrategyRateStrategyVolatileTkoAddressesProvider =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyVolatileTkoAbi,
    address: reserveStrategyRateStrategyVolatileTkoAddress,
    functionName: 'ADDRESSES_PROVIDER',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyVolatileTkoAbi}__ and `functionName` set to `"MAX_EXCESS_STABLE_TO_TOTAL_DEBT_RATIO"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x620d0e1371c1E0B44867E04E17d166EbfeAF5759)
 */
export const readReserveStrategyRateStrategyVolatileTkoMaxExcessStableToTotalDebtRatio =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyVolatileTkoAbi,
    address: reserveStrategyRateStrategyVolatileTkoAddress,
    functionName: 'MAX_EXCESS_STABLE_TO_TOTAL_DEBT_RATIO',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyVolatileTkoAbi}__ and `functionName` set to `"MAX_EXCESS_USAGE_RATIO"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x620d0e1371c1E0B44867E04E17d166EbfeAF5759)
 */
export const readReserveStrategyRateStrategyVolatileTkoMaxExcessUsageRatio =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyVolatileTkoAbi,
    address: reserveStrategyRateStrategyVolatileTkoAddress,
    functionName: 'MAX_EXCESS_USAGE_RATIO',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyVolatileTkoAbi}__ and `functionName` set to `"OPTIMAL_STABLE_TO_TOTAL_DEBT_RATIO"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x620d0e1371c1E0B44867E04E17d166EbfeAF5759)
 */
export const readReserveStrategyRateStrategyVolatileTkoOptimalStableToTotalDebtRatio =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyVolatileTkoAbi,
    address: reserveStrategyRateStrategyVolatileTkoAddress,
    functionName: 'OPTIMAL_STABLE_TO_TOTAL_DEBT_RATIO',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyVolatileTkoAbi}__ and `functionName` set to `"OPTIMAL_USAGE_RATIO"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x620d0e1371c1E0B44867E04E17d166EbfeAF5759)
 */
export const readReserveStrategyRateStrategyVolatileTkoOptimalUsageRatio =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyVolatileTkoAbi,
    address: reserveStrategyRateStrategyVolatileTkoAddress,
    functionName: 'OPTIMAL_USAGE_RATIO',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyVolatileTkoAbi}__ and `functionName` set to `"calculateInterestRates"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x620d0e1371c1E0B44867E04E17d166EbfeAF5759)
 */
export const readReserveStrategyRateStrategyVolatileTkoCalculateInterestRates =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyVolatileTkoAbi,
    address: reserveStrategyRateStrategyVolatileTkoAddress,
    functionName: 'calculateInterestRates',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyVolatileTkoAbi}__ and `functionName` set to `"getBaseStableBorrowRate"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x620d0e1371c1E0B44867E04E17d166EbfeAF5759)
 */
export const readReserveStrategyRateStrategyVolatileTkoGetBaseStableBorrowRate =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyVolatileTkoAbi,
    address: reserveStrategyRateStrategyVolatileTkoAddress,
    functionName: 'getBaseStableBorrowRate',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyVolatileTkoAbi}__ and `functionName` set to `"getBaseVariableBorrowRate"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x620d0e1371c1E0B44867E04E17d166EbfeAF5759)
 */
export const readReserveStrategyRateStrategyVolatileTkoGetBaseVariableBorrowRate =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyVolatileTkoAbi,
    address: reserveStrategyRateStrategyVolatileTkoAddress,
    functionName: 'getBaseVariableBorrowRate',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyVolatileTkoAbi}__ and `functionName` set to `"getMaxVariableBorrowRate"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x620d0e1371c1E0B44867E04E17d166EbfeAF5759)
 */
export const readReserveStrategyRateStrategyVolatileTkoGetMaxVariableBorrowRate =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyVolatileTkoAbi,
    address: reserveStrategyRateStrategyVolatileTkoAddress,
    functionName: 'getMaxVariableBorrowRate',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyVolatileTkoAbi}__ and `functionName` set to `"getStableRateExcessOffset"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x620d0e1371c1E0B44867E04E17d166EbfeAF5759)
 */
export const readReserveStrategyRateStrategyVolatileTkoGetStableRateExcessOffset =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyVolatileTkoAbi,
    address: reserveStrategyRateStrategyVolatileTkoAddress,
    functionName: 'getStableRateExcessOffset',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyVolatileTkoAbi}__ and `functionName` set to `"getStableRateSlope1"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x620d0e1371c1E0B44867E04E17d166EbfeAF5759)
 */
export const readReserveStrategyRateStrategyVolatileTkoGetStableRateSlope1 =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyVolatileTkoAbi,
    address: reserveStrategyRateStrategyVolatileTkoAddress,
    functionName: 'getStableRateSlope1',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyVolatileTkoAbi}__ and `functionName` set to `"getStableRateSlope2"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x620d0e1371c1E0B44867E04E17d166EbfeAF5759)
 */
export const readReserveStrategyRateStrategyVolatileTkoGetStableRateSlope2 =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyVolatileTkoAbi,
    address: reserveStrategyRateStrategyVolatileTkoAddress,
    functionName: 'getStableRateSlope2',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyVolatileTkoAbi}__ and `functionName` set to `"getVariableRateSlope1"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x620d0e1371c1E0B44867E04E17d166EbfeAF5759)
 */
export const readReserveStrategyRateStrategyVolatileTkoGetVariableRateSlope1 =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyVolatileTkoAbi,
    address: reserveStrategyRateStrategyVolatileTkoAddress,
    functionName: 'getVariableRateSlope1',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyVolatileTkoAbi}__ and `functionName` set to `"getVariableRateSlope2"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x620d0e1371c1E0B44867E04E17d166EbfeAF5759)
 */
export const readReserveStrategyRateStrategyVolatileTkoGetVariableRateSlope2 =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyVolatileTkoAbi,
    address: reserveStrategyRateStrategyVolatileTkoAddress,
    functionName: 'getVariableRateSlope2',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyVolatileUsdcAbi}__
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9611eb463e34dCCd09bEEDFBF9C6a6039cB6Ec15)
 */
export const readReserveStrategyRateStrategyVolatileUsdc =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyVolatileUsdcAbi,
    address: reserveStrategyRateStrategyVolatileUsdcAddress,
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyVolatileUsdcAbi}__ and `functionName` set to `"ADDRESSES_PROVIDER"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9611eb463e34dCCd09bEEDFBF9C6a6039cB6Ec15)
 */
export const readReserveStrategyRateStrategyVolatileUsdcAddressesProvider =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyVolatileUsdcAbi,
    address: reserveStrategyRateStrategyVolatileUsdcAddress,
    functionName: 'ADDRESSES_PROVIDER',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyVolatileUsdcAbi}__ and `functionName` set to `"MAX_EXCESS_STABLE_TO_TOTAL_DEBT_RATIO"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9611eb463e34dCCd09bEEDFBF9C6a6039cB6Ec15)
 */
export const readReserveStrategyRateStrategyVolatileUsdcMaxExcessStableToTotalDebtRatio =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyVolatileUsdcAbi,
    address: reserveStrategyRateStrategyVolatileUsdcAddress,
    functionName: 'MAX_EXCESS_STABLE_TO_TOTAL_DEBT_RATIO',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyVolatileUsdcAbi}__ and `functionName` set to `"MAX_EXCESS_USAGE_RATIO"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9611eb463e34dCCd09bEEDFBF9C6a6039cB6Ec15)
 */
export const readReserveStrategyRateStrategyVolatileUsdcMaxExcessUsageRatio =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyVolatileUsdcAbi,
    address: reserveStrategyRateStrategyVolatileUsdcAddress,
    functionName: 'MAX_EXCESS_USAGE_RATIO',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyVolatileUsdcAbi}__ and `functionName` set to `"OPTIMAL_STABLE_TO_TOTAL_DEBT_RATIO"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9611eb463e34dCCd09bEEDFBF9C6a6039cB6Ec15)
 */
export const readReserveStrategyRateStrategyVolatileUsdcOptimalStableToTotalDebtRatio =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyVolatileUsdcAbi,
    address: reserveStrategyRateStrategyVolatileUsdcAddress,
    functionName: 'OPTIMAL_STABLE_TO_TOTAL_DEBT_RATIO',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyVolatileUsdcAbi}__ and `functionName` set to `"OPTIMAL_USAGE_RATIO"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9611eb463e34dCCd09bEEDFBF9C6a6039cB6Ec15)
 */
export const readReserveStrategyRateStrategyVolatileUsdcOptimalUsageRatio =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyVolatileUsdcAbi,
    address: reserveStrategyRateStrategyVolatileUsdcAddress,
    functionName: 'OPTIMAL_USAGE_RATIO',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyVolatileUsdcAbi}__ and `functionName` set to `"calculateInterestRates"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9611eb463e34dCCd09bEEDFBF9C6a6039cB6Ec15)
 */
export const readReserveStrategyRateStrategyVolatileUsdcCalculateInterestRates =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyVolatileUsdcAbi,
    address: reserveStrategyRateStrategyVolatileUsdcAddress,
    functionName: 'calculateInterestRates',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyVolatileUsdcAbi}__ and `functionName` set to `"getBaseStableBorrowRate"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9611eb463e34dCCd09bEEDFBF9C6a6039cB6Ec15)
 */
export const readReserveStrategyRateStrategyVolatileUsdcGetBaseStableBorrowRate =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyVolatileUsdcAbi,
    address: reserveStrategyRateStrategyVolatileUsdcAddress,
    functionName: 'getBaseStableBorrowRate',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyVolatileUsdcAbi}__ and `functionName` set to `"getBaseVariableBorrowRate"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9611eb463e34dCCd09bEEDFBF9C6a6039cB6Ec15)
 */
export const readReserveStrategyRateStrategyVolatileUsdcGetBaseVariableBorrowRate =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyVolatileUsdcAbi,
    address: reserveStrategyRateStrategyVolatileUsdcAddress,
    functionName: 'getBaseVariableBorrowRate',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyVolatileUsdcAbi}__ and `functionName` set to `"getMaxVariableBorrowRate"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9611eb463e34dCCd09bEEDFBF9C6a6039cB6Ec15)
 */
export const readReserveStrategyRateStrategyVolatileUsdcGetMaxVariableBorrowRate =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyVolatileUsdcAbi,
    address: reserveStrategyRateStrategyVolatileUsdcAddress,
    functionName: 'getMaxVariableBorrowRate',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyVolatileUsdcAbi}__ and `functionName` set to `"getStableRateExcessOffset"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9611eb463e34dCCd09bEEDFBF9C6a6039cB6Ec15)
 */
export const readReserveStrategyRateStrategyVolatileUsdcGetStableRateExcessOffset =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyVolatileUsdcAbi,
    address: reserveStrategyRateStrategyVolatileUsdcAddress,
    functionName: 'getStableRateExcessOffset',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyVolatileUsdcAbi}__ and `functionName` set to `"getStableRateSlope1"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9611eb463e34dCCd09bEEDFBF9C6a6039cB6Ec15)
 */
export const readReserveStrategyRateStrategyVolatileUsdcGetStableRateSlope1 =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyVolatileUsdcAbi,
    address: reserveStrategyRateStrategyVolatileUsdcAddress,
    functionName: 'getStableRateSlope1',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyVolatileUsdcAbi}__ and `functionName` set to `"getStableRateSlope2"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9611eb463e34dCCd09bEEDFBF9C6a6039cB6Ec15)
 */
export const readReserveStrategyRateStrategyVolatileUsdcGetStableRateSlope2 =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyVolatileUsdcAbi,
    address: reserveStrategyRateStrategyVolatileUsdcAddress,
    functionName: 'getStableRateSlope2',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyVolatileUsdcAbi}__ and `functionName` set to `"getVariableRateSlope1"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9611eb463e34dCCd09bEEDFBF9C6a6039cB6Ec15)
 */
export const readReserveStrategyRateStrategyVolatileUsdcGetVariableRateSlope1 =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyVolatileUsdcAbi,
    address: reserveStrategyRateStrategyVolatileUsdcAddress,
    functionName: 'getVariableRateSlope1',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyVolatileUsdcAbi}__ and `functionName` set to `"getVariableRateSlope2"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9611eb463e34dCCd09bEEDFBF9C6a6039cB6Ec15)
 */
export const readReserveStrategyRateStrategyVolatileUsdcGetVariableRateSlope2 =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyVolatileUsdcAbi,
    address: reserveStrategyRateStrategyVolatileUsdcAddress,
    functionName: 'getVariableRateSlope2',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyVolatileUsdtAbi}__
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xDAa306d7bdC7f465030506F47aaDE074787960B3)
 */
export const readReserveStrategyRateStrategyVolatileUsdt =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyVolatileUsdtAbi,
    address: reserveStrategyRateStrategyVolatileUsdtAddress,
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyVolatileUsdtAbi}__ and `functionName` set to `"ADDRESSES_PROVIDER"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xDAa306d7bdC7f465030506F47aaDE074787960B3)
 */
export const readReserveStrategyRateStrategyVolatileUsdtAddressesProvider =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyVolatileUsdtAbi,
    address: reserveStrategyRateStrategyVolatileUsdtAddress,
    functionName: 'ADDRESSES_PROVIDER',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyVolatileUsdtAbi}__ and `functionName` set to `"MAX_EXCESS_STABLE_TO_TOTAL_DEBT_RATIO"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xDAa306d7bdC7f465030506F47aaDE074787960B3)
 */
export const readReserveStrategyRateStrategyVolatileUsdtMaxExcessStableToTotalDebtRatio =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyVolatileUsdtAbi,
    address: reserveStrategyRateStrategyVolatileUsdtAddress,
    functionName: 'MAX_EXCESS_STABLE_TO_TOTAL_DEBT_RATIO',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyVolatileUsdtAbi}__ and `functionName` set to `"MAX_EXCESS_USAGE_RATIO"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xDAa306d7bdC7f465030506F47aaDE074787960B3)
 */
export const readReserveStrategyRateStrategyVolatileUsdtMaxExcessUsageRatio =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyVolatileUsdtAbi,
    address: reserveStrategyRateStrategyVolatileUsdtAddress,
    functionName: 'MAX_EXCESS_USAGE_RATIO',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyVolatileUsdtAbi}__ and `functionName` set to `"OPTIMAL_STABLE_TO_TOTAL_DEBT_RATIO"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xDAa306d7bdC7f465030506F47aaDE074787960B3)
 */
export const readReserveStrategyRateStrategyVolatileUsdtOptimalStableToTotalDebtRatio =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyVolatileUsdtAbi,
    address: reserveStrategyRateStrategyVolatileUsdtAddress,
    functionName: 'OPTIMAL_STABLE_TO_TOTAL_DEBT_RATIO',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyVolatileUsdtAbi}__ and `functionName` set to `"OPTIMAL_USAGE_RATIO"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xDAa306d7bdC7f465030506F47aaDE074787960B3)
 */
export const readReserveStrategyRateStrategyVolatileUsdtOptimalUsageRatio =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyVolatileUsdtAbi,
    address: reserveStrategyRateStrategyVolatileUsdtAddress,
    functionName: 'OPTIMAL_USAGE_RATIO',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyVolatileUsdtAbi}__ and `functionName` set to `"calculateInterestRates"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xDAa306d7bdC7f465030506F47aaDE074787960B3)
 */
export const readReserveStrategyRateStrategyVolatileUsdtCalculateInterestRates =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyVolatileUsdtAbi,
    address: reserveStrategyRateStrategyVolatileUsdtAddress,
    functionName: 'calculateInterestRates',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyVolatileUsdtAbi}__ and `functionName` set to `"getBaseStableBorrowRate"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xDAa306d7bdC7f465030506F47aaDE074787960B3)
 */
export const readReserveStrategyRateStrategyVolatileUsdtGetBaseStableBorrowRate =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyVolatileUsdtAbi,
    address: reserveStrategyRateStrategyVolatileUsdtAddress,
    functionName: 'getBaseStableBorrowRate',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyVolatileUsdtAbi}__ and `functionName` set to `"getBaseVariableBorrowRate"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xDAa306d7bdC7f465030506F47aaDE074787960B3)
 */
export const readReserveStrategyRateStrategyVolatileUsdtGetBaseVariableBorrowRate =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyVolatileUsdtAbi,
    address: reserveStrategyRateStrategyVolatileUsdtAddress,
    functionName: 'getBaseVariableBorrowRate',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyVolatileUsdtAbi}__ and `functionName` set to `"getMaxVariableBorrowRate"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xDAa306d7bdC7f465030506F47aaDE074787960B3)
 */
export const readReserveStrategyRateStrategyVolatileUsdtGetMaxVariableBorrowRate =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyVolatileUsdtAbi,
    address: reserveStrategyRateStrategyVolatileUsdtAddress,
    functionName: 'getMaxVariableBorrowRate',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyVolatileUsdtAbi}__ and `functionName` set to `"getStableRateExcessOffset"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xDAa306d7bdC7f465030506F47aaDE074787960B3)
 */
export const readReserveStrategyRateStrategyVolatileUsdtGetStableRateExcessOffset =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyVolatileUsdtAbi,
    address: reserveStrategyRateStrategyVolatileUsdtAddress,
    functionName: 'getStableRateExcessOffset',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyVolatileUsdtAbi}__ and `functionName` set to `"getStableRateSlope1"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xDAa306d7bdC7f465030506F47aaDE074787960B3)
 */
export const readReserveStrategyRateStrategyVolatileUsdtGetStableRateSlope1 =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyVolatileUsdtAbi,
    address: reserveStrategyRateStrategyVolatileUsdtAddress,
    functionName: 'getStableRateSlope1',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyVolatileUsdtAbi}__ and `functionName` set to `"getStableRateSlope2"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xDAa306d7bdC7f465030506F47aaDE074787960B3)
 */
export const readReserveStrategyRateStrategyVolatileUsdtGetStableRateSlope2 =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyVolatileUsdtAbi,
    address: reserveStrategyRateStrategyVolatileUsdtAddress,
    functionName: 'getStableRateSlope2',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyVolatileUsdtAbi}__ and `functionName` set to `"getVariableRateSlope1"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xDAa306d7bdC7f465030506F47aaDE074787960B3)
 */
export const readReserveStrategyRateStrategyVolatileUsdtGetVariableRateSlope1 =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyVolatileUsdtAbi,
    address: reserveStrategyRateStrategyVolatileUsdtAddress,
    functionName: 'getVariableRateSlope1',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyVolatileUsdtAbi}__ and `functionName` set to `"getVariableRateSlope2"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xDAa306d7bdC7f465030506F47aaDE074787960B3)
 */
export const readReserveStrategyRateStrategyVolatileUsdtGetVariableRateSlope2 =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyVolatileUsdtAbi,
    address: reserveStrategyRateStrategyVolatileUsdtAddress,
    functionName: 'getVariableRateSlope2',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyVolatileWbtcAbi}__
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xae87cbb46dBAf6657a09db02DE78b477317224D8)
 */
export const readReserveStrategyRateStrategyVolatileWbtc =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyVolatileWbtcAbi,
    address: reserveStrategyRateStrategyVolatileWbtcAddress,
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyVolatileWbtcAbi}__ and `functionName` set to `"ADDRESSES_PROVIDER"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xae87cbb46dBAf6657a09db02DE78b477317224D8)
 */
export const readReserveStrategyRateStrategyVolatileWbtcAddressesProvider =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyVolatileWbtcAbi,
    address: reserveStrategyRateStrategyVolatileWbtcAddress,
    functionName: 'ADDRESSES_PROVIDER',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyVolatileWbtcAbi}__ and `functionName` set to `"MAX_EXCESS_STABLE_TO_TOTAL_DEBT_RATIO"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xae87cbb46dBAf6657a09db02DE78b477317224D8)
 */
export const readReserveStrategyRateStrategyVolatileWbtcMaxExcessStableToTotalDebtRatio =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyVolatileWbtcAbi,
    address: reserveStrategyRateStrategyVolatileWbtcAddress,
    functionName: 'MAX_EXCESS_STABLE_TO_TOTAL_DEBT_RATIO',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyVolatileWbtcAbi}__ and `functionName` set to `"MAX_EXCESS_USAGE_RATIO"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xae87cbb46dBAf6657a09db02DE78b477317224D8)
 */
export const readReserveStrategyRateStrategyVolatileWbtcMaxExcessUsageRatio =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyVolatileWbtcAbi,
    address: reserveStrategyRateStrategyVolatileWbtcAddress,
    functionName: 'MAX_EXCESS_USAGE_RATIO',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyVolatileWbtcAbi}__ and `functionName` set to `"OPTIMAL_STABLE_TO_TOTAL_DEBT_RATIO"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xae87cbb46dBAf6657a09db02DE78b477317224D8)
 */
export const readReserveStrategyRateStrategyVolatileWbtcOptimalStableToTotalDebtRatio =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyVolatileWbtcAbi,
    address: reserveStrategyRateStrategyVolatileWbtcAddress,
    functionName: 'OPTIMAL_STABLE_TO_TOTAL_DEBT_RATIO',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyVolatileWbtcAbi}__ and `functionName` set to `"OPTIMAL_USAGE_RATIO"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xae87cbb46dBAf6657a09db02DE78b477317224D8)
 */
export const readReserveStrategyRateStrategyVolatileWbtcOptimalUsageRatio =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyVolatileWbtcAbi,
    address: reserveStrategyRateStrategyVolatileWbtcAddress,
    functionName: 'OPTIMAL_USAGE_RATIO',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyVolatileWbtcAbi}__ and `functionName` set to `"calculateInterestRates"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xae87cbb46dBAf6657a09db02DE78b477317224D8)
 */
export const readReserveStrategyRateStrategyVolatileWbtcCalculateInterestRates =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyVolatileWbtcAbi,
    address: reserveStrategyRateStrategyVolatileWbtcAddress,
    functionName: 'calculateInterestRates',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyVolatileWbtcAbi}__ and `functionName` set to `"getBaseStableBorrowRate"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xae87cbb46dBAf6657a09db02DE78b477317224D8)
 */
export const readReserveStrategyRateStrategyVolatileWbtcGetBaseStableBorrowRate =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyVolatileWbtcAbi,
    address: reserveStrategyRateStrategyVolatileWbtcAddress,
    functionName: 'getBaseStableBorrowRate',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyVolatileWbtcAbi}__ and `functionName` set to `"getBaseVariableBorrowRate"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xae87cbb46dBAf6657a09db02DE78b477317224D8)
 */
export const readReserveStrategyRateStrategyVolatileWbtcGetBaseVariableBorrowRate =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyVolatileWbtcAbi,
    address: reserveStrategyRateStrategyVolatileWbtcAddress,
    functionName: 'getBaseVariableBorrowRate',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyVolatileWbtcAbi}__ and `functionName` set to `"getMaxVariableBorrowRate"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xae87cbb46dBAf6657a09db02DE78b477317224D8)
 */
export const readReserveStrategyRateStrategyVolatileWbtcGetMaxVariableBorrowRate =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyVolatileWbtcAbi,
    address: reserveStrategyRateStrategyVolatileWbtcAddress,
    functionName: 'getMaxVariableBorrowRate',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyVolatileWbtcAbi}__ and `functionName` set to `"getStableRateExcessOffset"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xae87cbb46dBAf6657a09db02DE78b477317224D8)
 */
export const readReserveStrategyRateStrategyVolatileWbtcGetStableRateExcessOffset =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyVolatileWbtcAbi,
    address: reserveStrategyRateStrategyVolatileWbtcAddress,
    functionName: 'getStableRateExcessOffset',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyVolatileWbtcAbi}__ and `functionName` set to `"getStableRateSlope1"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xae87cbb46dBAf6657a09db02DE78b477317224D8)
 */
export const readReserveStrategyRateStrategyVolatileWbtcGetStableRateSlope1 =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyVolatileWbtcAbi,
    address: reserveStrategyRateStrategyVolatileWbtcAddress,
    functionName: 'getStableRateSlope1',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyVolatileWbtcAbi}__ and `functionName` set to `"getStableRateSlope2"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xae87cbb46dBAf6657a09db02DE78b477317224D8)
 */
export const readReserveStrategyRateStrategyVolatileWbtcGetStableRateSlope2 =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyVolatileWbtcAbi,
    address: reserveStrategyRateStrategyVolatileWbtcAddress,
    functionName: 'getStableRateSlope2',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyVolatileWbtcAbi}__ and `functionName` set to `"getVariableRateSlope1"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xae87cbb46dBAf6657a09db02DE78b477317224D8)
 */
export const readReserveStrategyRateStrategyVolatileWbtcGetVariableRateSlope1 =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyVolatileWbtcAbi,
    address: reserveStrategyRateStrategyVolatileWbtcAddress,
    functionName: 'getVariableRateSlope1',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyVolatileWbtcAbi}__ and `functionName` set to `"getVariableRateSlope2"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xae87cbb46dBAf6657a09db02DE78b477317224D8)
 */
export const readReserveStrategyRateStrategyVolatileWbtcGetVariableRateSlope2 =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyVolatileWbtcAbi,
    address: reserveStrategyRateStrategyVolatileWbtcAddress,
    functionName: 'getVariableRateSlope2',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyVolatileWethAbi}__
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa32455dF66E7b580133fb7d3aa50D600791e73a0)
 */
export const readReserveStrategyRateStrategyVolatileWeth =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyVolatileWethAbi,
    address: reserveStrategyRateStrategyVolatileWethAddress,
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyVolatileWethAbi}__ and `functionName` set to `"ADDRESSES_PROVIDER"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa32455dF66E7b580133fb7d3aa50D600791e73a0)
 */
export const readReserveStrategyRateStrategyVolatileWethAddressesProvider =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyVolatileWethAbi,
    address: reserveStrategyRateStrategyVolatileWethAddress,
    functionName: 'ADDRESSES_PROVIDER',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyVolatileWethAbi}__ and `functionName` set to `"MAX_EXCESS_STABLE_TO_TOTAL_DEBT_RATIO"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa32455dF66E7b580133fb7d3aa50D600791e73a0)
 */
export const readReserveStrategyRateStrategyVolatileWethMaxExcessStableToTotalDebtRatio =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyVolatileWethAbi,
    address: reserveStrategyRateStrategyVolatileWethAddress,
    functionName: 'MAX_EXCESS_STABLE_TO_TOTAL_DEBT_RATIO',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyVolatileWethAbi}__ and `functionName` set to `"MAX_EXCESS_USAGE_RATIO"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa32455dF66E7b580133fb7d3aa50D600791e73a0)
 */
export const readReserveStrategyRateStrategyVolatileWethMaxExcessUsageRatio =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyVolatileWethAbi,
    address: reserveStrategyRateStrategyVolatileWethAddress,
    functionName: 'MAX_EXCESS_USAGE_RATIO',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyVolatileWethAbi}__ and `functionName` set to `"OPTIMAL_STABLE_TO_TOTAL_DEBT_RATIO"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa32455dF66E7b580133fb7d3aa50D600791e73a0)
 */
export const readReserveStrategyRateStrategyVolatileWethOptimalStableToTotalDebtRatio =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyVolatileWethAbi,
    address: reserveStrategyRateStrategyVolatileWethAddress,
    functionName: 'OPTIMAL_STABLE_TO_TOTAL_DEBT_RATIO',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyVolatileWethAbi}__ and `functionName` set to `"OPTIMAL_USAGE_RATIO"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa32455dF66E7b580133fb7d3aa50D600791e73a0)
 */
export const readReserveStrategyRateStrategyVolatileWethOptimalUsageRatio =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyVolatileWethAbi,
    address: reserveStrategyRateStrategyVolatileWethAddress,
    functionName: 'OPTIMAL_USAGE_RATIO',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyVolatileWethAbi}__ and `functionName` set to `"calculateInterestRates"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa32455dF66E7b580133fb7d3aa50D600791e73a0)
 */
export const readReserveStrategyRateStrategyVolatileWethCalculateInterestRates =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyVolatileWethAbi,
    address: reserveStrategyRateStrategyVolatileWethAddress,
    functionName: 'calculateInterestRates',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyVolatileWethAbi}__ and `functionName` set to `"getBaseStableBorrowRate"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa32455dF66E7b580133fb7d3aa50D600791e73a0)
 */
export const readReserveStrategyRateStrategyVolatileWethGetBaseStableBorrowRate =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyVolatileWethAbi,
    address: reserveStrategyRateStrategyVolatileWethAddress,
    functionName: 'getBaseStableBorrowRate',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyVolatileWethAbi}__ and `functionName` set to `"getBaseVariableBorrowRate"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa32455dF66E7b580133fb7d3aa50D600791e73a0)
 */
export const readReserveStrategyRateStrategyVolatileWethGetBaseVariableBorrowRate =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyVolatileWethAbi,
    address: reserveStrategyRateStrategyVolatileWethAddress,
    functionName: 'getBaseVariableBorrowRate',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyVolatileWethAbi}__ and `functionName` set to `"getMaxVariableBorrowRate"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa32455dF66E7b580133fb7d3aa50D600791e73a0)
 */
export const readReserveStrategyRateStrategyVolatileWethGetMaxVariableBorrowRate =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyVolatileWethAbi,
    address: reserveStrategyRateStrategyVolatileWethAddress,
    functionName: 'getMaxVariableBorrowRate',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyVolatileWethAbi}__ and `functionName` set to `"getStableRateExcessOffset"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa32455dF66E7b580133fb7d3aa50D600791e73a0)
 */
export const readReserveStrategyRateStrategyVolatileWethGetStableRateExcessOffset =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyVolatileWethAbi,
    address: reserveStrategyRateStrategyVolatileWethAddress,
    functionName: 'getStableRateExcessOffset',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyVolatileWethAbi}__ and `functionName` set to `"getStableRateSlope1"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa32455dF66E7b580133fb7d3aa50D600791e73a0)
 */
export const readReserveStrategyRateStrategyVolatileWethGetStableRateSlope1 =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyVolatileWethAbi,
    address: reserveStrategyRateStrategyVolatileWethAddress,
    functionName: 'getStableRateSlope1',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyVolatileWethAbi}__ and `functionName` set to `"getStableRateSlope2"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa32455dF66E7b580133fb7d3aa50D600791e73a0)
 */
export const readReserveStrategyRateStrategyVolatileWethGetStableRateSlope2 =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyVolatileWethAbi,
    address: reserveStrategyRateStrategyVolatileWethAddress,
    functionName: 'getStableRateSlope2',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyVolatileWethAbi}__ and `functionName` set to `"getVariableRateSlope1"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa32455dF66E7b580133fb7d3aa50D600791e73a0)
 */
export const readReserveStrategyRateStrategyVolatileWethGetVariableRateSlope1 =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyVolatileWethAbi,
    address: reserveStrategyRateStrategyVolatileWethAddress,
    functionName: 'getVariableRateSlope1',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reserveStrategyRateStrategyVolatileWethAbi}__ and `functionName` set to `"getVariableRateSlope2"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa32455dF66E7b580133fb7d3aa50D600791e73a0)
 */
export const readReserveStrategyRateStrategyVolatileWethGetVariableRateSlope2 =
  /*#__PURE__*/ createReadContract({
    abi: reserveStrategyRateStrategyVolatileWethAbi,
    address: reserveStrategyRateStrategyVolatileWethAddress,
    functionName: 'getVariableRateSlope2',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reservesSetupHelperAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x7E433415DaBBc7E8791369EEc827E3FD860Fe6d8)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x614F3E4318F57E9B2cc840Ad5f6CD3979fC83A86)
 */
export const readReservesSetupHelper = /*#__PURE__*/ createReadContract({
  abi: reservesSetupHelperAbi,
  address: reservesSetupHelperAddress,
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link reservesSetupHelperAbi}__ and `functionName` set to `"owner"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x7E433415DaBBc7E8791369EEc827E3FD860Fe6d8)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x614F3E4318F57E9B2cc840Ad5f6CD3979fC83A86)
 */
export const readReservesSetupHelperOwner = /*#__PURE__*/ createReadContract({
  abi: reservesSetupHelperAbi,
  address: reservesSetupHelperAddress,
  functionName: 'owner',
})

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link reservesSetupHelperAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x7E433415DaBBc7E8791369EEc827E3FD860Fe6d8)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x614F3E4318F57E9B2cc840Ad5f6CD3979fC83A86)
 */
export const writeReservesSetupHelper = /*#__PURE__*/ createWriteContract({
  abi: reservesSetupHelperAbi,
  address: reservesSetupHelperAddress,
})

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link reservesSetupHelperAbi}__ and `functionName` set to `"configureReserves"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x7E433415DaBBc7E8791369EEc827E3FD860Fe6d8)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x614F3E4318F57E9B2cc840Ad5f6CD3979fC83A86)
 */
export const writeReservesSetupHelperConfigureReserves =
  /*#__PURE__*/ createWriteContract({
    abi: reservesSetupHelperAbi,
    address: reservesSetupHelperAddress,
    functionName: 'configureReserves',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link reservesSetupHelperAbi}__ and `functionName` set to `"renounceOwnership"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x7E433415DaBBc7E8791369EEc827E3FD860Fe6d8)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x614F3E4318F57E9B2cc840Ad5f6CD3979fC83A86)
 */
export const writeReservesSetupHelperRenounceOwnership =
  /*#__PURE__*/ createWriteContract({
    abi: reservesSetupHelperAbi,
    address: reservesSetupHelperAddress,
    functionName: 'renounceOwnership',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link reservesSetupHelperAbi}__ and `functionName` set to `"transferOwnership"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x7E433415DaBBc7E8791369EEc827E3FD860Fe6d8)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x614F3E4318F57E9B2cc840Ad5f6CD3979fC83A86)
 */
export const writeReservesSetupHelperTransferOwnership =
  /*#__PURE__*/ createWriteContract({
    abi: reservesSetupHelperAbi,
    address: reservesSetupHelperAddress,
    functionName: 'transferOwnership',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link reservesSetupHelperAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x7E433415DaBBc7E8791369EEc827E3FD860Fe6d8)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x614F3E4318F57E9B2cc840Ad5f6CD3979fC83A86)
 */
export const simulateReservesSetupHelper = /*#__PURE__*/ createSimulateContract(
  { abi: reservesSetupHelperAbi, address: reservesSetupHelperAddress },
)

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link reservesSetupHelperAbi}__ and `functionName` set to `"configureReserves"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x7E433415DaBBc7E8791369EEc827E3FD860Fe6d8)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x614F3E4318F57E9B2cc840Ad5f6CD3979fC83A86)
 */
export const simulateReservesSetupHelperConfigureReserves =
  /*#__PURE__*/ createSimulateContract({
    abi: reservesSetupHelperAbi,
    address: reservesSetupHelperAddress,
    functionName: 'configureReserves',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link reservesSetupHelperAbi}__ and `functionName` set to `"renounceOwnership"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x7E433415DaBBc7E8791369EEc827E3FD860Fe6d8)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x614F3E4318F57E9B2cc840Ad5f6CD3979fC83A86)
 */
export const simulateReservesSetupHelperRenounceOwnership =
  /*#__PURE__*/ createSimulateContract({
    abi: reservesSetupHelperAbi,
    address: reservesSetupHelperAddress,
    functionName: 'renounceOwnership',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link reservesSetupHelperAbi}__ and `functionName` set to `"transferOwnership"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x7E433415DaBBc7E8791369EEc827E3FD860Fe6d8)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x614F3E4318F57E9B2cc840Ad5f6CD3979fC83A86)
 */
export const simulateReservesSetupHelperTransferOwnership =
  /*#__PURE__*/ createSimulateContract({
    abi: reservesSetupHelperAbi,
    address: reservesSetupHelperAddress,
    functionName: 'transferOwnership',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link reservesSetupHelperAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x7E433415DaBBc7E8791369EEc827E3FD860Fe6d8)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x614F3E4318F57E9B2cc840Ad5f6CD3979fC83A86)
 */
export const watchReservesSetupHelperEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: reservesSetupHelperAbi,
    address: reservesSetupHelperAddress,
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link reservesSetupHelperAbi}__ and `eventName` set to `"OwnershipTransferred"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x7E433415DaBBc7E8791369EEc827E3FD860Fe6d8)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x614F3E4318F57E9B2cc840Ad5f6CD3979fC83A86)
 */
export const watchReservesSetupHelperOwnershipTransferredEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: reservesSetupHelperAbi,
    address: reservesSetupHelperAddress,
    eventName: 'OwnershipTransferred',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link stableDebtTokenTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE49F0a33a206e89ba09B54188b42702E8C560AE3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x039D11D56527a9Bd9BbCc9c0cAF73c32bd18866A)
 */
export const readStableDebtTokenTaiko = /*#__PURE__*/ createReadContract({
  abi: stableDebtTokenTaikoAbi,
  address: stableDebtTokenTaikoAddress,
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link stableDebtTokenTaikoAbi}__ and `functionName` set to `"DEBT_TOKEN_REVISION"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE49F0a33a206e89ba09B54188b42702E8C560AE3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x039D11D56527a9Bd9BbCc9c0cAF73c32bd18866A)
 */
export const readStableDebtTokenTaikoDebtTokenRevision =
  /*#__PURE__*/ createReadContract({
    abi: stableDebtTokenTaikoAbi,
    address: stableDebtTokenTaikoAddress,
    functionName: 'DEBT_TOKEN_REVISION',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link stableDebtTokenTaikoAbi}__ and `functionName` set to `"DELEGATION_WITH_SIG_TYPEHASH"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE49F0a33a206e89ba09B54188b42702E8C560AE3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x039D11D56527a9Bd9BbCc9c0cAF73c32bd18866A)
 */
export const readStableDebtTokenTaikoDelegationWithSigTypehash =
  /*#__PURE__*/ createReadContract({
    abi: stableDebtTokenTaikoAbi,
    address: stableDebtTokenTaikoAddress,
    functionName: 'DELEGATION_WITH_SIG_TYPEHASH',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link stableDebtTokenTaikoAbi}__ and `functionName` set to `"DOMAIN_SEPARATOR"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE49F0a33a206e89ba09B54188b42702E8C560AE3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x039D11D56527a9Bd9BbCc9c0cAF73c32bd18866A)
 */
export const readStableDebtTokenTaikoDomainSeparator =
  /*#__PURE__*/ createReadContract({
    abi: stableDebtTokenTaikoAbi,
    address: stableDebtTokenTaikoAddress,
    functionName: 'DOMAIN_SEPARATOR',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link stableDebtTokenTaikoAbi}__ and `functionName` set to `"EIP712_REVISION"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE49F0a33a206e89ba09B54188b42702E8C560AE3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x039D11D56527a9Bd9BbCc9c0cAF73c32bd18866A)
 */
export const readStableDebtTokenTaikoEip712Revision =
  /*#__PURE__*/ createReadContract({
    abi: stableDebtTokenTaikoAbi,
    address: stableDebtTokenTaikoAddress,
    functionName: 'EIP712_REVISION',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link stableDebtTokenTaikoAbi}__ and `functionName` set to `"POOL"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE49F0a33a206e89ba09B54188b42702E8C560AE3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x039D11D56527a9Bd9BbCc9c0cAF73c32bd18866A)
 */
export const readStableDebtTokenTaikoPool = /*#__PURE__*/ createReadContract({
  abi: stableDebtTokenTaikoAbi,
  address: stableDebtTokenTaikoAddress,
  functionName: 'POOL',
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link stableDebtTokenTaikoAbi}__ and `functionName` set to `"UNDERLYING_ASSET_ADDRESS"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE49F0a33a206e89ba09B54188b42702E8C560AE3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x039D11D56527a9Bd9BbCc9c0cAF73c32bd18866A)
 */
export const readStableDebtTokenTaikoUnderlyingAssetAddress =
  /*#__PURE__*/ createReadContract({
    abi: stableDebtTokenTaikoAbi,
    address: stableDebtTokenTaikoAddress,
    functionName: 'UNDERLYING_ASSET_ADDRESS',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link stableDebtTokenTaikoAbi}__ and `functionName` set to `"allowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE49F0a33a206e89ba09B54188b42702E8C560AE3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x039D11D56527a9Bd9BbCc9c0cAF73c32bd18866A)
 */
export const readStableDebtTokenTaikoAllowance =
  /*#__PURE__*/ createReadContract({
    abi: stableDebtTokenTaikoAbi,
    address: stableDebtTokenTaikoAddress,
    functionName: 'allowance',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link stableDebtTokenTaikoAbi}__ and `functionName` set to `"balanceOf"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE49F0a33a206e89ba09B54188b42702E8C560AE3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x039D11D56527a9Bd9BbCc9c0cAF73c32bd18866A)
 */
export const readStableDebtTokenTaikoBalanceOf =
  /*#__PURE__*/ createReadContract({
    abi: stableDebtTokenTaikoAbi,
    address: stableDebtTokenTaikoAddress,
    functionName: 'balanceOf',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link stableDebtTokenTaikoAbi}__ and `functionName` set to `"borrowAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE49F0a33a206e89ba09B54188b42702E8C560AE3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x039D11D56527a9Bd9BbCc9c0cAF73c32bd18866A)
 */
export const readStableDebtTokenTaikoBorrowAllowance =
  /*#__PURE__*/ createReadContract({
    abi: stableDebtTokenTaikoAbi,
    address: stableDebtTokenTaikoAddress,
    functionName: 'borrowAllowance',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link stableDebtTokenTaikoAbi}__ and `functionName` set to `"decimals"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE49F0a33a206e89ba09B54188b42702E8C560AE3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x039D11D56527a9Bd9BbCc9c0cAF73c32bd18866A)
 */
export const readStableDebtTokenTaikoDecimals =
  /*#__PURE__*/ createReadContract({
    abi: stableDebtTokenTaikoAbi,
    address: stableDebtTokenTaikoAddress,
    functionName: 'decimals',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link stableDebtTokenTaikoAbi}__ and `functionName` set to `"getAverageStableRate"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE49F0a33a206e89ba09B54188b42702E8C560AE3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x039D11D56527a9Bd9BbCc9c0cAF73c32bd18866A)
 */
export const readStableDebtTokenTaikoGetAverageStableRate =
  /*#__PURE__*/ createReadContract({
    abi: stableDebtTokenTaikoAbi,
    address: stableDebtTokenTaikoAddress,
    functionName: 'getAverageStableRate',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link stableDebtTokenTaikoAbi}__ and `functionName` set to `"getIncentivesController"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE49F0a33a206e89ba09B54188b42702E8C560AE3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x039D11D56527a9Bd9BbCc9c0cAF73c32bd18866A)
 */
export const readStableDebtTokenTaikoGetIncentivesController =
  /*#__PURE__*/ createReadContract({
    abi: stableDebtTokenTaikoAbi,
    address: stableDebtTokenTaikoAddress,
    functionName: 'getIncentivesController',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link stableDebtTokenTaikoAbi}__ and `functionName` set to `"getSupplyData"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE49F0a33a206e89ba09B54188b42702E8C560AE3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x039D11D56527a9Bd9BbCc9c0cAF73c32bd18866A)
 */
export const readStableDebtTokenTaikoGetSupplyData =
  /*#__PURE__*/ createReadContract({
    abi: stableDebtTokenTaikoAbi,
    address: stableDebtTokenTaikoAddress,
    functionName: 'getSupplyData',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link stableDebtTokenTaikoAbi}__ and `functionName` set to `"getTotalSupplyAndAvgRate"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE49F0a33a206e89ba09B54188b42702E8C560AE3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x039D11D56527a9Bd9BbCc9c0cAF73c32bd18866A)
 */
export const readStableDebtTokenTaikoGetTotalSupplyAndAvgRate =
  /*#__PURE__*/ createReadContract({
    abi: stableDebtTokenTaikoAbi,
    address: stableDebtTokenTaikoAddress,
    functionName: 'getTotalSupplyAndAvgRate',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link stableDebtTokenTaikoAbi}__ and `functionName` set to `"getTotalSupplyLastUpdated"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE49F0a33a206e89ba09B54188b42702E8C560AE3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x039D11D56527a9Bd9BbCc9c0cAF73c32bd18866A)
 */
export const readStableDebtTokenTaikoGetTotalSupplyLastUpdated =
  /*#__PURE__*/ createReadContract({
    abi: stableDebtTokenTaikoAbi,
    address: stableDebtTokenTaikoAddress,
    functionName: 'getTotalSupplyLastUpdated',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link stableDebtTokenTaikoAbi}__ and `functionName` set to `"getUserLastUpdated"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE49F0a33a206e89ba09B54188b42702E8C560AE3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x039D11D56527a9Bd9BbCc9c0cAF73c32bd18866A)
 */
export const readStableDebtTokenTaikoGetUserLastUpdated =
  /*#__PURE__*/ createReadContract({
    abi: stableDebtTokenTaikoAbi,
    address: stableDebtTokenTaikoAddress,
    functionName: 'getUserLastUpdated',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link stableDebtTokenTaikoAbi}__ and `functionName` set to `"getUserStableRate"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE49F0a33a206e89ba09B54188b42702E8C560AE3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x039D11D56527a9Bd9BbCc9c0cAF73c32bd18866A)
 */
export const readStableDebtTokenTaikoGetUserStableRate =
  /*#__PURE__*/ createReadContract({
    abi: stableDebtTokenTaikoAbi,
    address: stableDebtTokenTaikoAddress,
    functionName: 'getUserStableRate',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link stableDebtTokenTaikoAbi}__ and `functionName` set to `"name"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE49F0a33a206e89ba09B54188b42702E8C560AE3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x039D11D56527a9Bd9BbCc9c0cAF73c32bd18866A)
 */
export const readStableDebtTokenTaikoName = /*#__PURE__*/ createReadContract({
  abi: stableDebtTokenTaikoAbi,
  address: stableDebtTokenTaikoAddress,
  functionName: 'name',
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link stableDebtTokenTaikoAbi}__ and `functionName` set to `"nonces"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE49F0a33a206e89ba09B54188b42702E8C560AE3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x039D11D56527a9Bd9BbCc9c0cAF73c32bd18866A)
 */
export const readStableDebtTokenTaikoNonces = /*#__PURE__*/ createReadContract({
  abi: stableDebtTokenTaikoAbi,
  address: stableDebtTokenTaikoAddress,
  functionName: 'nonces',
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link stableDebtTokenTaikoAbi}__ and `functionName` set to `"principalBalanceOf"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE49F0a33a206e89ba09B54188b42702E8C560AE3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x039D11D56527a9Bd9BbCc9c0cAF73c32bd18866A)
 */
export const readStableDebtTokenTaikoPrincipalBalanceOf =
  /*#__PURE__*/ createReadContract({
    abi: stableDebtTokenTaikoAbi,
    address: stableDebtTokenTaikoAddress,
    functionName: 'principalBalanceOf',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link stableDebtTokenTaikoAbi}__ and `functionName` set to `"symbol"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE49F0a33a206e89ba09B54188b42702E8C560AE3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x039D11D56527a9Bd9BbCc9c0cAF73c32bd18866A)
 */
export const readStableDebtTokenTaikoSymbol = /*#__PURE__*/ createReadContract({
  abi: stableDebtTokenTaikoAbi,
  address: stableDebtTokenTaikoAddress,
  functionName: 'symbol',
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link stableDebtTokenTaikoAbi}__ and `functionName` set to `"totalSupply"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE49F0a33a206e89ba09B54188b42702E8C560AE3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x039D11D56527a9Bd9BbCc9c0cAF73c32bd18866A)
 */
export const readStableDebtTokenTaikoTotalSupply =
  /*#__PURE__*/ createReadContract({
    abi: stableDebtTokenTaikoAbi,
    address: stableDebtTokenTaikoAddress,
    functionName: 'totalSupply',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link stableDebtTokenTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE49F0a33a206e89ba09B54188b42702E8C560AE3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x039D11D56527a9Bd9BbCc9c0cAF73c32bd18866A)
 */
export const writeStableDebtTokenTaiko = /*#__PURE__*/ createWriteContract({
  abi: stableDebtTokenTaikoAbi,
  address: stableDebtTokenTaikoAddress,
})

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link stableDebtTokenTaikoAbi}__ and `functionName` set to `"approve"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE49F0a33a206e89ba09B54188b42702E8C560AE3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x039D11D56527a9Bd9BbCc9c0cAF73c32bd18866A)
 */
export const writeStableDebtTokenTaikoApprove =
  /*#__PURE__*/ createWriteContract({
    abi: stableDebtTokenTaikoAbi,
    address: stableDebtTokenTaikoAddress,
    functionName: 'approve',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link stableDebtTokenTaikoAbi}__ and `functionName` set to `"approveDelegation"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE49F0a33a206e89ba09B54188b42702E8C560AE3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x039D11D56527a9Bd9BbCc9c0cAF73c32bd18866A)
 */
export const writeStableDebtTokenTaikoApproveDelegation =
  /*#__PURE__*/ createWriteContract({
    abi: stableDebtTokenTaikoAbi,
    address: stableDebtTokenTaikoAddress,
    functionName: 'approveDelegation',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link stableDebtTokenTaikoAbi}__ and `functionName` set to `"burn"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE49F0a33a206e89ba09B54188b42702E8C560AE3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x039D11D56527a9Bd9BbCc9c0cAF73c32bd18866A)
 */
export const writeStableDebtTokenTaikoBurn = /*#__PURE__*/ createWriteContract({
  abi: stableDebtTokenTaikoAbi,
  address: stableDebtTokenTaikoAddress,
  functionName: 'burn',
})

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link stableDebtTokenTaikoAbi}__ and `functionName` set to `"decreaseAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE49F0a33a206e89ba09B54188b42702E8C560AE3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x039D11D56527a9Bd9BbCc9c0cAF73c32bd18866A)
 */
export const writeStableDebtTokenTaikoDecreaseAllowance =
  /*#__PURE__*/ createWriteContract({
    abi: stableDebtTokenTaikoAbi,
    address: stableDebtTokenTaikoAddress,
    functionName: 'decreaseAllowance',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link stableDebtTokenTaikoAbi}__ and `functionName` set to `"delegationWithSig"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE49F0a33a206e89ba09B54188b42702E8C560AE3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x039D11D56527a9Bd9BbCc9c0cAF73c32bd18866A)
 */
export const writeStableDebtTokenTaikoDelegationWithSig =
  /*#__PURE__*/ createWriteContract({
    abi: stableDebtTokenTaikoAbi,
    address: stableDebtTokenTaikoAddress,
    functionName: 'delegationWithSig',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link stableDebtTokenTaikoAbi}__ and `functionName` set to `"increaseAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE49F0a33a206e89ba09B54188b42702E8C560AE3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x039D11D56527a9Bd9BbCc9c0cAF73c32bd18866A)
 */
export const writeStableDebtTokenTaikoIncreaseAllowance =
  /*#__PURE__*/ createWriteContract({
    abi: stableDebtTokenTaikoAbi,
    address: stableDebtTokenTaikoAddress,
    functionName: 'increaseAllowance',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link stableDebtTokenTaikoAbi}__ and `functionName` set to `"initialize"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE49F0a33a206e89ba09B54188b42702E8C560AE3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x039D11D56527a9Bd9BbCc9c0cAF73c32bd18866A)
 */
export const writeStableDebtTokenTaikoInitialize =
  /*#__PURE__*/ createWriteContract({
    abi: stableDebtTokenTaikoAbi,
    address: stableDebtTokenTaikoAddress,
    functionName: 'initialize',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link stableDebtTokenTaikoAbi}__ and `functionName` set to `"mint"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE49F0a33a206e89ba09B54188b42702E8C560AE3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x039D11D56527a9Bd9BbCc9c0cAF73c32bd18866A)
 */
export const writeStableDebtTokenTaikoMint = /*#__PURE__*/ createWriteContract({
  abi: stableDebtTokenTaikoAbi,
  address: stableDebtTokenTaikoAddress,
  functionName: 'mint',
})

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link stableDebtTokenTaikoAbi}__ and `functionName` set to `"setIncentivesController"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE49F0a33a206e89ba09B54188b42702E8C560AE3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x039D11D56527a9Bd9BbCc9c0cAF73c32bd18866A)
 */
export const writeStableDebtTokenTaikoSetIncentivesController =
  /*#__PURE__*/ createWriteContract({
    abi: stableDebtTokenTaikoAbi,
    address: stableDebtTokenTaikoAddress,
    functionName: 'setIncentivesController',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link stableDebtTokenTaikoAbi}__ and `functionName` set to `"transfer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE49F0a33a206e89ba09B54188b42702E8C560AE3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x039D11D56527a9Bd9BbCc9c0cAF73c32bd18866A)
 */
export const writeStableDebtTokenTaikoTransfer =
  /*#__PURE__*/ createWriteContract({
    abi: stableDebtTokenTaikoAbi,
    address: stableDebtTokenTaikoAddress,
    functionName: 'transfer',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link stableDebtTokenTaikoAbi}__ and `functionName` set to `"transferFrom"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE49F0a33a206e89ba09B54188b42702E8C560AE3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x039D11D56527a9Bd9BbCc9c0cAF73c32bd18866A)
 */
export const writeStableDebtTokenTaikoTransferFrom =
  /*#__PURE__*/ createWriteContract({
    abi: stableDebtTokenTaikoAbi,
    address: stableDebtTokenTaikoAddress,
    functionName: 'transferFrom',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link stableDebtTokenTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE49F0a33a206e89ba09B54188b42702E8C560AE3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x039D11D56527a9Bd9BbCc9c0cAF73c32bd18866A)
 */
export const simulateStableDebtTokenTaiko =
  /*#__PURE__*/ createSimulateContract({
    abi: stableDebtTokenTaikoAbi,
    address: stableDebtTokenTaikoAddress,
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link stableDebtTokenTaikoAbi}__ and `functionName` set to `"approve"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE49F0a33a206e89ba09B54188b42702E8C560AE3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x039D11D56527a9Bd9BbCc9c0cAF73c32bd18866A)
 */
export const simulateStableDebtTokenTaikoApprove =
  /*#__PURE__*/ createSimulateContract({
    abi: stableDebtTokenTaikoAbi,
    address: stableDebtTokenTaikoAddress,
    functionName: 'approve',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link stableDebtTokenTaikoAbi}__ and `functionName` set to `"approveDelegation"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE49F0a33a206e89ba09B54188b42702E8C560AE3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x039D11D56527a9Bd9BbCc9c0cAF73c32bd18866A)
 */
export const simulateStableDebtTokenTaikoApproveDelegation =
  /*#__PURE__*/ createSimulateContract({
    abi: stableDebtTokenTaikoAbi,
    address: stableDebtTokenTaikoAddress,
    functionName: 'approveDelegation',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link stableDebtTokenTaikoAbi}__ and `functionName` set to `"burn"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE49F0a33a206e89ba09B54188b42702E8C560AE3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x039D11D56527a9Bd9BbCc9c0cAF73c32bd18866A)
 */
export const simulateStableDebtTokenTaikoBurn =
  /*#__PURE__*/ createSimulateContract({
    abi: stableDebtTokenTaikoAbi,
    address: stableDebtTokenTaikoAddress,
    functionName: 'burn',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link stableDebtTokenTaikoAbi}__ and `functionName` set to `"decreaseAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE49F0a33a206e89ba09B54188b42702E8C560AE3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x039D11D56527a9Bd9BbCc9c0cAF73c32bd18866A)
 */
export const simulateStableDebtTokenTaikoDecreaseAllowance =
  /*#__PURE__*/ createSimulateContract({
    abi: stableDebtTokenTaikoAbi,
    address: stableDebtTokenTaikoAddress,
    functionName: 'decreaseAllowance',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link stableDebtTokenTaikoAbi}__ and `functionName` set to `"delegationWithSig"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE49F0a33a206e89ba09B54188b42702E8C560AE3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x039D11D56527a9Bd9BbCc9c0cAF73c32bd18866A)
 */
export const simulateStableDebtTokenTaikoDelegationWithSig =
  /*#__PURE__*/ createSimulateContract({
    abi: stableDebtTokenTaikoAbi,
    address: stableDebtTokenTaikoAddress,
    functionName: 'delegationWithSig',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link stableDebtTokenTaikoAbi}__ and `functionName` set to `"increaseAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE49F0a33a206e89ba09B54188b42702E8C560AE3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x039D11D56527a9Bd9BbCc9c0cAF73c32bd18866A)
 */
export const simulateStableDebtTokenTaikoIncreaseAllowance =
  /*#__PURE__*/ createSimulateContract({
    abi: stableDebtTokenTaikoAbi,
    address: stableDebtTokenTaikoAddress,
    functionName: 'increaseAllowance',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link stableDebtTokenTaikoAbi}__ and `functionName` set to `"initialize"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE49F0a33a206e89ba09B54188b42702E8C560AE3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x039D11D56527a9Bd9BbCc9c0cAF73c32bd18866A)
 */
export const simulateStableDebtTokenTaikoInitialize =
  /*#__PURE__*/ createSimulateContract({
    abi: stableDebtTokenTaikoAbi,
    address: stableDebtTokenTaikoAddress,
    functionName: 'initialize',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link stableDebtTokenTaikoAbi}__ and `functionName` set to `"mint"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE49F0a33a206e89ba09B54188b42702E8C560AE3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x039D11D56527a9Bd9BbCc9c0cAF73c32bd18866A)
 */
export const simulateStableDebtTokenTaikoMint =
  /*#__PURE__*/ createSimulateContract({
    abi: stableDebtTokenTaikoAbi,
    address: stableDebtTokenTaikoAddress,
    functionName: 'mint',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link stableDebtTokenTaikoAbi}__ and `functionName` set to `"setIncentivesController"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE49F0a33a206e89ba09B54188b42702E8C560AE3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x039D11D56527a9Bd9BbCc9c0cAF73c32bd18866A)
 */
export const simulateStableDebtTokenTaikoSetIncentivesController =
  /*#__PURE__*/ createSimulateContract({
    abi: stableDebtTokenTaikoAbi,
    address: stableDebtTokenTaikoAddress,
    functionName: 'setIncentivesController',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link stableDebtTokenTaikoAbi}__ and `functionName` set to `"transfer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE49F0a33a206e89ba09B54188b42702E8C560AE3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x039D11D56527a9Bd9BbCc9c0cAF73c32bd18866A)
 */
export const simulateStableDebtTokenTaikoTransfer =
  /*#__PURE__*/ createSimulateContract({
    abi: stableDebtTokenTaikoAbi,
    address: stableDebtTokenTaikoAddress,
    functionName: 'transfer',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link stableDebtTokenTaikoAbi}__ and `functionName` set to `"transferFrom"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE49F0a33a206e89ba09B54188b42702E8C560AE3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x039D11D56527a9Bd9BbCc9c0cAF73c32bd18866A)
 */
export const simulateStableDebtTokenTaikoTransferFrom =
  /*#__PURE__*/ createSimulateContract({
    abi: stableDebtTokenTaikoAbi,
    address: stableDebtTokenTaikoAddress,
    functionName: 'transferFrom',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link stableDebtTokenTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE49F0a33a206e89ba09B54188b42702E8C560AE3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x039D11D56527a9Bd9BbCc9c0cAF73c32bd18866A)
 */
export const watchStableDebtTokenTaikoEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: stableDebtTokenTaikoAbi,
    address: stableDebtTokenTaikoAddress,
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link stableDebtTokenTaikoAbi}__ and `eventName` set to `"Approval"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE49F0a33a206e89ba09B54188b42702E8C560AE3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x039D11D56527a9Bd9BbCc9c0cAF73c32bd18866A)
 */
export const watchStableDebtTokenTaikoApprovalEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: stableDebtTokenTaikoAbi,
    address: stableDebtTokenTaikoAddress,
    eventName: 'Approval',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link stableDebtTokenTaikoAbi}__ and `eventName` set to `"BorrowAllowanceDelegated"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE49F0a33a206e89ba09B54188b42702E8C560AE3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x039D11D56527a9Bd9BbCc9c0cAF73c32bd18866A)
 */
export const watchStableDebtTokenTaikoBorrowAllowanceDelegatedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: stableDebtTokenTaikoAbi,
    address: stableDebtTokenTaikoAddress,
    eventName: 'BorrowAllowanceDelegated',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link stableDebtTokenTaikoAbi}__ and `eventName` set to `"Burn"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE49F0a33a206e89ba09B54188b42702E8C560AE3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x039D11D56527a9Bd9BbCc9c0cAF73c32bd18866A)
 */
export const watchStableDebtTokenTaikoBurnEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: stableDebtTokenTaikoAbi,
    address: stableDebtTokenTaikoAddress,
    eventName: 'Burn',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link stableDebtTokenTaikoAbi}__ and `eventName` set to `"Initialized"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE49F0a33a206e89ba09B54188b42702E8C560AE3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x039D11D56527a9Bd9BbCc9c0cAF73c32bd18866A)
 */
export const watchStableDebtTokenTaikoInitializedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: stableDebtTokenTaikoAbi,
    address: stableDebtTokenTaikoAddress,
    eventName: 'Initialized',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link stableDebtTokenTaikoAbi}__ and `eventName` set to `"Mint"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE49F0a33a206e89ba09B54188b42702E8C560AE3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x039D11D56527a9Bd9BbCc9c0cAF73c32bd18866A)
 */
export const watchStableDebtTokenTaikoMintEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: stableDebtTokenTaikoAbi,
    address: stableDebtTokenTaikoAddress,
    eventName: 'Mint',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link stableDebtTokenTaikoAbi}__ and `eventName` set to `"Transfer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xE49F0a33a206e89ba09B54188b42702E8C560AE3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x039D11D56527a9Bd9BbCc9c0cAF73c32bd18866A)
 */
export const watchStableDebtTokenTaikoTransferEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: stableDebtTokenTaikoAbi,
    address: stableDebtTokenTaikoAddress,
    eventName: 'Transfer',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link stkAaveTestnetMintableErc20RewardTaikoAbi}__
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD7b74D0C6830F4A34DC971E9524698771B9f9B59)
 */
export const readStkAaveTestnetMintableErc20RewardTaiko =
  /*#__PURE__*/ createReadContract({
    abi: stkAaveTestnetMintableErc20RewardTaikoAbi,
    address: stkAaveTestnetMintableErc20RewardTaikoAddress,
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link stkAaveTestnetMintableErc20RewardTaikoAbi}__ and `functionName` set to `"allowance"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD7b74D0C6830F4A34DC971E9524698771B9f9B59)
 */
export const readStkAaveTestnetMintableErc20RewardTaikoAllowance =
  /*#__PURE__*/ createReadContract({
    abi: stkAaveTestnetMintableErc20RewardTaikoAbi,
    address: stkAaveTestnetMintableErc20RewardTaikoAddress,
    functionName: 'allowance',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link stkAaveTestnetMintableErc20RewardTaikoAbi}__ and `functionName` set to `"balanceOf"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD7b74D0C6830F4A34DC971E9524698771B9f9B59)
 */
export const readStkAaveTestnetMintableErc20RewardTaikoBalanceOf =
  /*#__PURE__*/ createReadContract({
    abi: stkAaveTestnetMintableErc20RewardTaikoAbi,
    address: stkAaveTestnetMintableErc20RewardTaikoAddress,
    functionName: 'balanceOf',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link stkAaveTestnetMintableErc20RewardTaikoAbi}__ and `functionName` set to `"decimals"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD7b74D0C6830F4A34DC971E9524698771B9f9B59)
 */
export const readStkAaveTestnetMintableErc20RewardTaikoDecimals =
  /*#__PURE__*/ createReadContract({
    abi: stkAaveTestnetMintableErc20RewardTaikoAbi,
    address: stkAaveTestnetMintableErc20RewardTaikoAddress,
    functionName: 'decimals',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link stkAaveTestnetMintableErc20RewardTaikoAbi}__ and `functionName` set to `"name"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD7b74D0C6830F4A34DC971E9524698771B9f9B59)
 */
export const readStkAaveTestnetMintableErc20RewardTaikoName =
  /*#__PURE__*/ createReadContract({
    abi: stkAaveTestnetMintableErc20RewardTaikoAbi,
    address: stkAaveTestnetMintableErc20RewardTaikoAddress,
    functionName: 'name',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link stkAaveTestnetMintableErc20RewardTaikoAbi}__ and `functionName` set to `"symbol"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD7b74D0C6830F4A34DC971E9524698771B9f9B59)
 */
export const readStkAaveTestnetMintableErc20RewardTaikoSymbol =
  /*#__PURE__*/ createReadContract({
    abi: stkAaveTestnetMintableErc20RewardTaikoAbi,
    address: stkAaveTestnetMintableErc20RewardTaikoAddress,
    functionName: 'symbol',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link stkAaveTestnetMintableErc20RewardTaikoAbi}__ and `functionName` set to `"tokenDecimals"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD7b74D0C6830F4A34DC971E9524698771B9f9B59)
 */
export const readStkAaveTestnetMintableErc20RewardTaikoTokenDecimals =
  /*#__PURE__*/ createReadContract({
    abi: stkAaveTestnetMintableErc20RewardTaikoAbi,
    address: stkAaveTestnetMintableErc20RewardTaikoAddress,
    functionName: 'tokenDecimals',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link stkAaveTestnetMintableErc20RewardTaikoAbi}__ and `functionName` set to `"totalSupply"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD7b74D0C6830F4A34DC971E9524698771B9f9B59)
 */
export const readStkAaveTestnetMintableErc20RewardTaikoTotalSupply =
  /*#__PURE__*/ createReadContract({
    abi: stkAaveTestnetMintableErc20RewardTaikoAbi,
    address: stkAaveTestnetMintableErc20RewardTaikoAddress,
    functionName: 'totalSupply',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link stkAaveTestnetMintableErc20RewardTaikoAbi}__
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD7b74D0C6830F4A34DC971E9524698771B9f9B59)
 */
export const writeStkAaveTestnetMintableErc20RewardTaiko =
  /*#__PURE__*/ createWriteContract({
    abi: stkAaveTestnetMintableErc20RewardTaikoAbi,
    address: stkAaveTestnetMintableErc20RewardTaikoAddress,
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link stkAaveTestnetMintableErc20RewardTaikoAbi}__ and `functionName` set to `"approve"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD7b74D0C6830F4A34DC971E9524698771B9f9B59)
 */
export const writeStkAaveTestnetMintableErc20RewardTaikoApprove =
  /*#__PURE__*/ createWriteContract({
    abi: stkAaveTestnetMintableErc20RewardTaikoAbi,
    address: stkAaveTestnetMintableErc20RewardTaikoAddress,
    functionName: 'approve',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link stkAaveTestnetMintableErc20RewardTaikoAbi}__ and `functionName` set to `"decreaseAllowance"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD7b74D0C6830F4A34DC971E9524698771B9f9B59)
 */
export const writeStkAaveTestnetMintableErc20RewardTaikoDecreaseAllowance =
  /*#__PURE__*/ createWriteContract({
    abi: stkAaveTestnetMintableErc20RewardTaikoAbi,
    address: stkAaveTestnetMintableErc20RewardTaikoAddress,
    functionName: 'decreaseAllowance',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link stkAaveTestnetMintableErc20RewardTaikoAbi}__ and `functionName` set to `"increaseAllowance"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD7b74D0C6830F4A34DC971E9524698771B9f9B59)
 */
export const writeStkAaveTestnetMintableErc20RewardTaikoIncreaseAllowance =
  /*#__PURE__*/ createWriteContract({
    abi: stkAaveTestnetMintableErc20RewardTaikoAbi,
    address: stkAaveTestnetMintableErc20RewardTaikoAddress,
    functionName: 'increaseAllowance',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link stkAaveTestnetMintableErc20RewardTaikoAbi}__ and `functionName` set to `"transfer"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD7b74D0C6830F4A34DC971E9524698771B9f9B59)
 */
export const writeStkAaveTestnetMintableErc20RewardTaikoTransfer =
  /*#__PURE__*/ createWriteContract({
    abi: stkAaveTestnetMintableErc20RewardTaikoAbi,
    address: stkAaveTestnetMintableErc20RewardTaikoAddress,
    functionName: 'transfer',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link stkAaveTestnetMintableErc20RewardTaikoAbi}__ and `functionName` set to `"transferFrom"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD7b74D0C6830F4A34DC971E9524698771B9f9B59)
 */
export const writeStkAaveTestnetMintableErc20RewardTaikoTransferFrom =
  /*#__PURE__*/ createWriteContract({
    abi: stkAaveTestnetMintableErc20RewardTaikoAbi,
    address: stkAaveTestnetMintableErc20RewardTaikoAddress,
    functionName: 'transferFrom',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link stkAaveTestnetMintableErc20RewardTaikoAbi}__
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD7b74D0C6830F4A34DC971E9524698771B9f9B59)
 */
export const simulateStkAaveTestnetMintableErc20RewardTaiko =
  /*#__PURE__*/ createSimulateContract({
    abi: stkAaveTestnetMintableErc20RewardTaikoAbi,
    address: stkAaveTestnetMintableErc20RewardTaikoAddress,
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link stkAaveTestnetMintableErc20RewardTaikoAbi}__ and `functionName` set to `"approve"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD7b74D0C6830F4A34DC971E9524698771B9f9B59)
 */
export const simulateStkAaveTestnetMintableErc20RewardTaikoApprove =
  /*#__PURE__*/ createSimulateContract({
    abi: stkAaveTestnetMintableErc20RewardTaikoAbi,
    address: stkAaveTestnetMintableErc20RewardTaikoAddress,
    functionName: 'approve',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link stkAaveTestnetMintableErc20RewardTaikoAbi}__ and `functionName` set to `"decreaseAllowance"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD7b74D0C6830F4A34DC971E9524698771B9f9B59)
 */
export const simulateStkAaveTestnetMintableErc20RewardTaikoDecreaseAllowance =
  /*#__PURE__*/ createSimulateContract({
    abi: stkAaveTestnetMintableErc20RewardTaikoAbi,
    address: stkAaveTestnetMintableErc20RewardTaikoAddress,
    functionName: 'decreaseAllowance',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link stkAaveTestnetMintableErc20RewardTaikoAbi}__ and `functionName` set to `"increaseAllowance"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD7b74D0C6830F4A34DC971E9524698771B9f9B59)
 */
export const simulateStkAaveTestnetMintableErc20RewardTaikoIncreaseAllowance =
  /*#__PURE__*/ createSimulateContract({
    abi: stkAaveTestnetMintableErc20RewardTaikoAbi,
    address: stkAaveTestnetMintableErc20RewardTaikoAddress,
    functionName: 'increaseAllowance',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link stkAaveTestnetMintableErc20RewardTaikoAbi}__ and `functionName` set to `"transfer"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD7b74D0C6830F4A34DC971E9524698771B9f9B59)
 */
export const simulateStkAaveTestnetMintableErc20RewardTaikoTransfer =
  /*#__PURE__*/ createSimulateContract({
    abi: stkAaveTestnetMintableErc20RewardTaikoAbi,
    address: stkAaveTestnetMintableErc20RewardTaikoAddress,
    functionName: 'transfer',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link stkAaveTestnetMintableErc20RewardTaikoAbi}__ and `functionName` set to `"transferFrom"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD7b74D0C6830F4A34DC971E9524698771B9f9B59)
 */
export const simulateStkAaveTestnetMintableErc20RewardTaikoTransferFrom =
  /*#__PURE__*/ createSimulateContract({
    abi: stkAaveTestnetMintableErc20RewardTaikoAbi,
    address: stkAaveTestnetMintableErc20RewardTaikoAddress,
    functionName: 'transferFrom',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link stkAaveTestnetMintableErc20RewardTaikoAbi}__
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD7b74D0C6830F4A34DC971E9524698771B9f9B59)
 */
export const watchStkAaveTestnetMintableErc20RewardTaikoEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: stkAaveTestnetMintableErc20RewardTaikoAbi,
    address: stkAaveTestnetMintableErc20RewardTaikoAddress,
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link stkAaveTestnetMintableErc20RewardTaikoAbi}__ and `eventName` set to `"Approval"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD7b74D0C6830F4A34DC971E9524698771B9f9B59)
 */
export const watchStkAaveTestnetMintableErc20RewardTaikoApprovalEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: stkAaveTestnetMintableErc20RewardTaikoAbi,
    address: stkAaveTestnetMintableErc20RewardTaikoAddress,
    eventName: 'Approval',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link stkAaveTestnetMintableErc20RewardTaikoAbi}__ and `eventName` set to `"Transfer"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD7b74D0C6830F4A34DC971E9524698771B9f9B59)
 */
export const watchStkAaveTestnetMintableErc20RewardTaikoTransferEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: stkAaveTestnetMintableErc20RewardTaikoAbi,
    address: stkAaveTestnetMintableErc20RewardTaikoAddress,
    eventName: 'Transfer',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link stkAaveTestnetPriceAggregatorTaikoAbi}__
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x8567F4386C117166Cbc14FBAd9ED4E6E74e6393B)
 */
export const readStkAaveTestnetPriceAggregatorTaiko =
  /*#__PURE__*/ createReadContract({
    abi: stkAaveTestnetPriceAggregatorTaikoAbi,
    address: stkAaveTestnetPriceAggregatorTaikoAddress,
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link stkAaveTestnetPriceAggregatorTaikoAbi}__ and `functionName` set to `"decimals"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x8567F4386C117166Cbc14FBAd9ED4E6E74e6393B)
 */
export const readStkAaveTestnetPriceAggregatorTaikoDecimals =
  /*#__PURE__*/ createReadContract({
    abi: stkAaveTestnetPriceAggregatorTaikoAbi,
    address: stkAaveTestnetPriceAggregatorTaikoAddress,
    functionName: 'decimals',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link stkAaveTestnetPriceAggregatorTaikoAbi}__ and `functionName` set to `"getTokenType"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x8567F4386C117166Cbc14FBAd9ED4E6E74e6393B)
 */
export const readStkAaveTestnetPriceAggregatorTaikoGetTokenType =
  /*#__PURE__*/ createReadContract({
    abi: stkAaveTestnetPriceAggregatorTaikoAbi,
    address: stkAaveTestnetPriceAggregatorTaikoAddress,
    functionName: 'getTokenType',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link stkAaveTestnetPriceAggregatorTaikoAbi}__ and `functionName` set to `"latestAnswer"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x8567F4386C117166Cbc14FBAd9ED4E6E74e6393B)
 */
export const readStkAaveTestnetPriceAggregatorTaikoLatestAnswer =
  /*#__PURE__*/ createReadContract({
    abi: stkAaveTestnetPriceAggregatorTaikoAbi,
    address: stkAaveTestnetPriceAggregatorTaikoAddress,
    functionName: 'latestAnswer',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link stkAaveTestnetPriceAggregatorTaikoAbi}__
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x8567F4386C117166Cbc14FBAd9ED4E6E74e6393B)
 */
export const watchStkAaveTestnetPriceAggregatorTaikoEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: stkAaveTestnetPriceAggregatorTaikoAbi,
    address: stkAaveTestnetPriceAggregatorTaikoAddress,
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link stkAaveTestnetPriceAggregatorTaikoAbi}__ and `eventName` set to `"AnswerUpdated"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x8567F4386C117166Cbc14FBAd9ED4E6E74e6393B)
 */
export const watchStkAaveTestnetPriceAggregatorTaikoAnswerUpdatedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: stkAaveTestnetPriceAggregatorTaikoAbi,
    address: stkAaveTestnetPriceAggregatorTaikoAddress,
    eventName: 'AnswerUpdated',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link supplyLogicAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x825708dF3Ff36465D1115B14918D5bF23EC5bfa2)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x60701aD1Cf7ad0aE0b607f03Aa2b08Ba48B63d2F)
 */
export const watchSupplyLogicEvent = /*#__PURE__*/ createWatchContractEvent({
  abi: supplyLogicAbi,
  address: supplyLogicAddress,
})

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link supplyLogicAbi}__ and `eventName` set to `"ReserveDataUpdated"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x825708dF3Ff36465D1115B14918D5bF23EC5bfa2)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x60701aD1Cf7ad0aE0b607f03Aa2b08Ba48B63d2F)
 */
export const watchSupplyLogicReserveDataUpdatedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: supplyLogicAbi,
    address: supplyLogicAddress,
    eventName: 'ReserveDataUpdated',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link supplyLogicAbi}__ and `eventName` set to `"ReserveUsedAsCollateralDisabled"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x825708dF3Ff36465D1115B14918D5bF23EC5bfa2)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x60701aD1Cf7ad0aE0b607f03Aa2b08Ba48B63d2F)
 */
export const watchSupplyLogicReserveUsedAsCollateralDisabledEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: supplyLogicAbi,
    address: supplyLogicAddress,
    eventName: 'ReserveUsedAsCollateralDisabled',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link supplyLogicAbi}__ and `eventName` set to `"ReserveUsedAsCollateralEnabled"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x825708dF3Ff36465D1115B14918D5bF23EC5bfa2)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x60701aD1Cf7ad0aE0b607f03Aa2b08Ba48B63d2F)
 */
export const watchSupplyLogicReserveUsedAsCollateralEnabledEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: supplyLogicAbi,
    address: supplyLogicAddress,
    eventName: 'ReserveUsedAsCollateralEnabled',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link supplyLogicAbi}__ and `eventName` set to `"Supply"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x825708dF3Ff36465D1115B14918D5bF23EC5bfa2)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x60701aD1Cf7ad0aE0b607f03Aa2b08Ba48B63d2F)
 */
export const watchSupplyLogicSupplyEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: supplyLogicAbi,
    address: supplyLogicAddress,
    eventName: 'Supply',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link supplyLogicAbi}__ and `eventName` set to `"Withdraw"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x825708dF3Ff36465D1115B14918D5bF23EC5bfa2)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x60701aD1Cf7ad0aE0b607f03Aa2b08Ba48B63d2F)
 */
export const watchSupplyLogicWithdrawEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: supplyLogicAbi,
    address: supplyLogicAddress,
    eventName: 'Withdraw',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link tkoATokenTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xad29323BC72FBaa6379602237b2Ae76265804f81)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x1474467995939740B68E4A66cEd94c2824d8CE7b)
 */
export const readTkoATokenTaiko = /*#__PURE__*/ createReadContract({
  abi: tkoATokenTaikoAbi,
  address: tkoATokenTaikoAddress,
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link tkoATokenTaikoAbi}__ and `functionName` set to `"ATOKEN_REVISION"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xad29323BC72FBaa6379602237b2Ae76265804f81)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x1474467995939740B68E4A66cEd94c2824d8CE7b)
 */
export const readTkoATokenTaikoAtokenRevision =
  /*#__PURE__*/ createReadContract({
    abi: tkoATokenTaikoAbi,
    address: tkoATokenTaikoAddress,
    functionName: 'ATOKEN_REVISION',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link tkoATokenTaikoAbi}__ and `functionName` set to `"DOMAIN_SEPARATOR"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xad29323BC72FBaa6379602237b2Ae76265804f81)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x1474467995939740B68E4A66cEd94c2824d8CE7b)
 */
export const readTkoATokenTaikoDomainSeparator =
  /*#__PURE__*/ createReadContract({
    abi: tkoATokenTaikoAbi,
    address: tkoATokenTaikoAddress,
    functionName: 'DOMAIN_SEPARATOR',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link tkoATokenTaikoAbi}__ and `functionName` set to `"EIP712_REVISION"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xad29323BC72FBaa6379602237b2Ae76265804f81)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x1474467995939740B68E4A66cEd94c2824d8CE7b)
 */
export const readTkoATokenTaikoEip712Revision =
  /*#__PURE__*/ createReadContract({
    abi: tkoATokenTaikoAbi,
    address: tkoATokenTaikoAddress,
    functionName: 'EIP712_REVISION',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link tkoATokenTaikoAbi}__ and `functionName` set to `"PERMIT_TYPEHASH"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xad29323BC72FBaa6379602237b2Ae76265804f81)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x1474467995939740B68E4A66cEd94c2824d8CE7b)
 */
export const readTkoATokenTaikoPermitTypehash =
  /*#__PURE__*/ createReadContract({
    abi: tkoATokenTaikoAbi,
    address: tkoATokenTaikoAddress,
    functionName: 'PERMIT_TYPEHASH',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link tkoATokenTaikoAbi}__ and `functionName` set to `"POOL"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xad29323BC72FBaa6379602237b2Ae76265804f81)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x1474467995939740B68E4A66cEd94c2824d8CE7b)
 */
export const readTkoATokenTaikoPool = /*#__PURE__*/ createReadContract({
  abi: tkoATokenTaikoAbi,
  address: tkoATokenTaikoAddress,
  functionName: 'POOL',
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link tkoATokenTaikoAbi}__ and `functionName` set to `"RESERVE_TREASURY_ADDRESS"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xad29323BC72FBaa6379602237b2Ae76265804f81)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x1474467995939740B68E4A66cEd94c2824d8CE7b)
 */
export const readTkoATokenTaikoReserveTreasuryAddress =
  /*#__PURE__*/ createReadContract({
    abi: tkoATokenTaikoAbi,
    address: tkoATokenTaikoAddress,
    functionName: 'RESERVE_TREASURY_ADDRESS',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link tkoATokenTaikoAbi}__ and `functionName` set to `"UNDERLYING_ASSET_ADDRESS"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xad29323BC72FBaa6379602237b2Ae76265804f81)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x1474467995939740B68E4A66cEd94c2824d8CE7b)
 */
export const readTkoATokenTaikoUnderlyingAssetAddress =
  /*#__PURE__*/ createReadContract({
    abi: tkoATokenTaikoAbi,
    address: tkoATokenTaikoAddress,
    functionName: 'UNDERLYING_ASSET_ADDRESS',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link tkoATokenTaikoAbi}__ and `functionName` set to `"allowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xad29323BC72FBaa6379602237b2Ae76265804f81)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x1474467995939740B68E4A66cEd94c2824d8CE7b)
 */
export const readTkoATokenTaikoAllowance = /*#__PURE__*/ createReadContract({
  abi: tkoATokenTaikoAbi,
  address: tkoATokenTaikoAddress,
  functionName: 'allowance',
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link tkoATokenTaikoAbi}__ and `functionName` set to `"balanceOf"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xad29323BC72FBaa6379602237b2Ae76265804f81)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x1474467995939740B68E4A66cEd94c2824d8CE7b)
 */
export const readTkoATokenTaikoBalanceOf = /*#__PURE__*/ createReadContract({
  abi: tkoATokenTaikoAbi,
  address: tkoATokenTaikoAddress,
  functionName: 'balanceOf',
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link tkoATokenTaikoAbi}__ and `functionName` set to `"decimals"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xad29323BC72FBaa6379602237b2Ae76265804f81)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x1474467995939740B68E4A66cEd94c2824d8CE7b)
 */
export const readTkoATokenTaikoDecimals = /*#__PURE__*/ createReadContract({
  abi: tkoATokenTaikoAbi,
  address: tkoATokenTaikoAddress,
  functionName: 'decimals',
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link tkoATokenTaikoAbi}__ and `functionName` set to `"getIncentivesController"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xad29323BC72FBaa6379602237b2Ae76265804f81)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x1474467995939740B68E4A66cEd94c2824d8CE7b)
 */
export const readTkoATokenTaikoGetIncentivesController =
  /*#__PURE__*/ createReadContract({
    abi: tkoATokenTaikoAbi,
    address: tkoATokenTaikoAddress,
    functionName: 'getIncentivesController',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link tkoATokenTaikoAbi}__ and `functionName` set to `"getPreviousIndex"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xad29323BC72FBaa6379602237b2Ae76265804f81)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x1474467995939740B68E4A66cEd94c2824d8CE7b)
 */
export const readTkoATokenTaikoGetPreviousIndex =
  /*#__PURE__*/ createReadContract({
    abi: tkoATokenTaikoAbi,
    address: tkoATokenTaikoAddress,
    functionName: 'getPreviousIndex',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link tkoATokenTaikoAbi}__ and `functionName` set to `"getScaledUserBalanceAndSupply"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xad29323BC72FBaa6379602237b2Ae76265804f81)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x1474467995939740B68E4A66cEd94c2824d8CE7b)
 */
export const readTkoATokenTaikoGetScaledUserBalanceAndSupply =
  /*#__PURE__*/ createReadContract({
    abi: tkoATokenTaikoAbi,
    address: tkoATokenTaikoAddress,
    functionName: 'getScaledUserBalanceAndSupply',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link tkoATokenTaikoAbi}__ and `functionName` set to `"name"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xad29323BC72FBaa6379602237b2Ae76265804f81)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x1474467995939740B68E4A66cEd94c2824d8CE7b)
 */
export const readTkoATokenTaikoName = /*#__PURE__*/ createReadContract({
  abi: tkoATokenTaikoAbi,
  address: tkoATokenTaikoAddress,
  functionName: 'name',
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link tkoATokenTaikoAbi}__ and `functionName` set to `"nonces"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xad29323BC72FBaa6379602237b2Ae76265804f81)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x1474467995939740B68E4A66cEd94c2824d8CE7b)
 */
export const readTkoATokenTaikoNonces = /*#__PURE__*/ createReadContract({
  abi: tkoATokenTaikoAbi,
  address: tkoATokenTaikoAddress,
  functionName: 'nonces',
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link tkoATokenTaikoAbi}__ and `functionName` set to `"scaledBalanceOf"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xad29323BC72FBaa6379602237b2Ae76265804f81)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x1474467995939740B68E4A66cEd94c2824d8CE7b)
 */
export const readTkoATokenTaikoScaledBalanceOf =
  /*#__PURE__*/ createReadContract({
    abi: tkoATokenTaikoAbi,
    address: tkoATokenTaikoAddress,
    functionName: 'scaledBalanceOf',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link tkoATokenTaikoAbi}__ and `functionName` set to `"scaledTotalSupply"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xad29323BC72FBaa6379602237b2Ae76265804f81)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x1474467995939740B68E4A66cEd94c2824d8CE7b)
 */
export const readTkoATokenTaikoScaledTotalSupply =
  /*#__PURE__*/ createReadContract({
    abi: tkoATokenTaikoAbi,
    address: tkoATokenTaikoAddress,
    functionName: 'scaledTotalSupply',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link tkoATokenTaikoAbi}__ and `functionName` set to `"symbol"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xad29323BC72FBaa6379602237b2Ae76265804f81)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x1474467995939740B68E4A66cEd94c2824d8CE7b)
 */
export const readTkoATokenTaikoSymbol = /*#__PURE__*/ createReadContract({
  abi: tkoATokenTaikoAbi,
  address: tkoATokenTaikoAddress,
  functionName: 'symbol',
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link tkoATokenTaikoAbi}__ and `functionName` set to `"totalSupply"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xad29323BC72FBaa6379602237b2Ae76265804f81)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x1474467995939740B68E4A66cEd94c2824d8CE7b)
 */
export const readTkoATokenTaikoTotalSupply = /*#__PURE__*/ createReadContract({
  abi: tkoATokenTaikoAbi,
  address: tkoATokenTaikoAddress,
  functionName: 'totalSupply',
})

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link tkoATokenTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xad29323BC72FBaa6379602237b2Ae76265804f81)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x1474467995939740B68E4A66cEd94c2824d8CE7b)
 */
export const writeTkoATokenTaiko = /*#__PURE__*/ createWriteContract({
  abi: tkoATokenTaikoAbi,
  address: tkoATokenTaikoAddress,
})

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link tkoATokenTaikoAbi}__ and `functionName` set to `"approve"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xad29323BC72FBaa6379602237b2Ae76265804f81)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x1474467995939740B68E4A66cEd94c2824d8CE7b)
 */
export const writeTkoATokenTaikoApprove = /*#__PURE__*/ createWriteContract({
  abi: tkoATokenTaikoAbi,
  address: tkoATokenTaikoAddress,
  functionName: 'approve',
})

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link tkoATokenTaikoAbi}__ and `functionName` set to `"burn"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xad29323BC72FBaa6379602237b2Ae76265804f81)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x1474467995939740B68E4A66cEd94c2824d8CE7b)
 */
export const writeTkoATokenTaikoBurn = /*#__PURE__*/ createWriteContract({
  abi: tkoATokenTaikoAbi,
  address: tkoATokenTaikoAddress,
  functionName: 'burn',
})

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link tkoATokenTaikoAbi}__ and `functionName` set to `"decreaseAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xad29323BC72FBaa6379602237b2Ae76265804f81)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x1474467995939740B68E4A66cEd94c2824d8CE7b)
 */
export const writeTkoATokenTaikoDecreaseAllowance =
  /*#__PURE__*/ createWriteContract({
    abi: tkoATokenTaikoAbi,
    address: tkoATokenTaikoAddress,
    functionName: 'decreaseAllowance',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link tkoATokenTaikoAbi}__ and `functionName` set to `"handleRepayment"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xad29323BC72FBaa6379602237b2Ae76265804f81)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x1474467995939740B68E4A66cEd94c2824d8CE7b)
 */
export const writeTkoATokenTaikoHandleRepayment =
  /*#__PURE__*/ createWriteContract({
    abi: tkoATokenTaikoAbi,
    address: tkoATokenTaikoAddress,
    functionName: 'handleRepayment',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link tkoATokenTaikoAbi}__ and `functionName` set to `"increaseAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xad29323BC72FBaa6379602237b2Ae76265804f81)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x1474467995939740B68E4A66cEd94c2824d8CE7b)
 */
export const writeTkoATokenTaikoIncreaseAllowance =
  /*#__PURE__*/ createWriteContract({
    abi: tkoATokenTaikoAbi,
    address: tkoATokenTaikoAddress,
    functionName: 'increaseAllowance',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link tkoATokenTaikoAbi}__ and `functionName` set to `"initialize"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xad29323BC72FBaa6379602237b2Ae76265804f81)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x1474467995939740B68E4A66cEd94c2824d8CE7b)
 */
export const writeTkoATokenTaikoInitialize = /*#__PURE__*/ createWriteContract({
  abi: tkoATokenTaikoAbi,
  address: tkoATokenTaikoAddress,
  functionName: 'initialize',
})

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link tkoATokenTaikoAbi}__ and `functionName` set to `"mint"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xad29323BC72FBaa6379602237b2Ae76265804f81)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x1474467995939740B68E4A66cEd94c2824d8CE7b)
 */
export const writeTkoATokenTaikoMint = /*#__PURE__*/ createWriteContract({
  abi: tkoATokenTaikoAbi,
  address: tkoATokenTaikoAddress,
  functionName: 'mint',
})

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link tkoATokenTaikoAbi}__ and `functionName` set to `"mintToTreasury"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xad29323BC72FBaa6379602237b2Ae76265804f81)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x1474467995939740B68E4A66cEd94c2824d8CE7b)
 */
export const writeTkoATokenTaikoMintToTreasury =
  /*#__PURE__*/ createWriteContract({
    abi: tkoATokenTaikoAbi,
    address: tkoATokenTaikoAddress,
    functionName: 'mintToTreasury',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link tkoATokenTaikoAbi}__ and `functionName` set to `"permit"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xad29323BC72FBaa6379602237b2Ae76265804f81)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x1474467995939740B68E4A66cEd94c2824d8CE7b)
 */
export const writeTkoATokenTaikoPermit = /*#__PURE__*/ createWriteContract({
  abi: tkoATokenTaikoAbi,
  address: tkoATokenTaikoAddress,
  functionName: 'permit',
})

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link tkoATokenTaikoAbi}__ and `functionName` set to `"rescueTokens"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xad29323BC72FBaa6379602237b2Ae76265804f81)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x1474467995939740B68E4A66cEd94c2824d8CE7b)
 */
export const writeTkoATokenTaikoRescueTokens =
  /*#__PURE__*/ createWriteContract({
    abi: tkoATokenTaikoAbi,
    address: tkoATokenTaikoAddress,
    functionName: 'rescueTokens',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link tkoATokenTaikoAbi}__ and `functionName` set to `"setIncentivesController"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xad29323BC72FBaa6379602237b2Ae76265804f81)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x1474467995939740B68E4A66cEd94c2824d8CE7b)
 */
export const writeTkoATokenTaikoSetIncentivesController =
  /*#__PURE__*/ createWriteContract({
    abi: tkoATokenTaikoAbi,
    address: tkoATokenTaikoAddress,
    functionName: 'setIncentivesController',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link tkoATokenTaikoAbi}__ and `functionName` set to `"transfer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xad29323BC72FBaa6379602237b2Ae76265804f81)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x1474467995939740B68E4A66cEd94c2824d8CE7b)
 */
export const writeTkoATokenTaikoTransfer = /*#__PURE__*/ createWriteContract({
  abi: tkoATokenTaikoAbi,
  address: tkoATokenTaikoAddress,
  functionName: 'transfer',
})

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link tkoATokenTaikoAbi}__ and `functionName` set to `"transferFrom"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xad29323BC72FBaa6379602237b2Ae76265804f81)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x1474467995939740B68E4A66cEd94c2824d8CE7b)
 */
export const writeTkoATokenTaikoTransferFrom =
  /*#__PURE__*/ createWriteContract({
    abi: tkoATokenTaikoAbi,
    address: tkoATokenTaikoAddress,
    functionName: 'transferFrom',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link tkoATokenTaikoAbi}__ and `functionName` set to `"transferOnLiquidation"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xad29323BC72FBaa6379602237b2Ae76265804f81)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x1474467995939740B68E4A66cEd94c2824d8CE7b)
 */
export const writeTkoATokenTaikoTransferOnLiquidation =
  /*#__PURE__*/ createWriteContract({
    abi: tkoATokenTaikoAbi,
    address: tkoATokenTaikoAddress,
    functionName: 'transferOnLiquidation',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link tkoATokenTaikoAbi}__ and `functionName` set to `"transferUnderlyingTo"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xad29323BC72FBaa6379602237b2Ae76265804f81)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x1474467995939740B68E4A66cEd94c2824d8CE7b)
 */
export const writeTkoATokenTaikoTransferUnderlyingTo =
  /*#__PURE__*/ createWriteContract({
    abi: tkoATokenTaikoAbi,
    address: tkoATokenTaikoAddress,
    functionName: 'transferUnderlyingTo',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link tkoATokenTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xad29323BC72FBaa6379602237b2Ae76265804f81)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x1474467995939740B68E4A66cEd94c2824d8CE7b)
 */
export const simulateTkoATokenTaiko = /*#__PURE__*/ createSimulateContract({
  abi: tkoATokenTaikoAbi,
  address: tkoATokenTaikoAddress,
})

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link tkoATokenTaikoAbi}__ and `functionName` set to `"approve"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xad29323BC72FBaa6379602237b2Ae76265804f81)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x1474467995939740B68E4A66cEd94c2824d8CE7b)
 */
export const simulateTkoATokenTaikoApprove =
  /*#__PURE__*/ createSimulateContract({
    abi: tkoATokenTaikoAbi,
    address: tkoATokenTaikoAddress,
    functionName: 'approve',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link tkoATokenTaikoAbi}__ and `functionName` set to `"burn"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xad29323BC72FBaa6379602237b2Ae76265804f81)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x1474467995939740B68E4A66cEd94c2824d8CE7b)
 */
export const simulateTkoATokenTaikoBurn = /*#__PURE__*/ createSimulateContract({
  abi: tkoATokenTaikoAbi,
  address: tkoATokenTaikoAddress,
  functionName: 'burn',
})

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link tkoATokenTaikoAbi}__ and `functionName` set to `"decreaseAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xad29323BC72FBaa6379602237b2Ae76265804f81)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x1474467995939740B68E4A66cEd94c2824d8CE7b)
 */
export const simulateTkoATokenTaikoDecreaseAllowance =
  /*#__PURE__*/ createSimulateContract({
    abi: tkoATokenTaikoAbi,
    address: tkoATokenTaikoAddress,
    functionName: 'decreaseAllowance',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link tkoATokenTaikoAbi}__ and `functionName` set to `"handleRepayment"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xad29323BC72FBaa6379602237b2Ae76265804f81)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x1474467995939740B68E4A66cEd94c2824d8CE7b)
 */
export const simulateTkoATokenTaikoHandleRepayment =
  /*#__PURE__*/ createSimulateContract({
    abi: tkoATokenTaikoAbi,
    address: tkoATokenTaikoAddress,
    functionName: 'handleRepayment',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link tkoATokenTaikoAbi}__ and `functionName` set to `"increaseAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xad29323BC72FBaa6379602237b2Ae76265804f81)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x1474467995939740B68E4A66cEd94c2824d8CE7b)
 */
export const simulateTkoATokenTaikoIncreaseAllowance =
  /*#__PURE__*/ createSimulateContract({
    abi: tkoATokenTaikoAbi,
    address: tkoATokenTaikoAddress,
    functionName: 'increaseAllowance',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link tkoATokenTaikoAbi}__ and `functionName` set to `"initialize"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xad29323BC72FBaa6379602237b2Ae76265804f81)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x1474467995939740B68E4A66cEd94c2824d8CE7b)
 */
export const simulateTkoATokenTaikoInitialize =
  /*#__PURE__*/ createSimulateContract({
    abi: tkoATokenTaikoAbi,
    address: tkoATokenTaikoAddress,
    functionName: 'initialize',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link tkoATokenTaikoAbi}__ and `functionName` set to `"mint"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xad29323BC72FBaa6379602237b2Ae76265804f81)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x1474467995939740B68E4A66cEd94c2824d8CE7b)
 */
export const simulateTkoATokenTaikoMint = /*#__PURE__*/ createSimulateContract({
  abi: tkoATokenTaikoAbi,
  address: tkoATokenTaikoAddress,
  functionName: 'mint',
})

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link tkoATokenTaikoAbi}__ and `functionName` set to `"mintToTreasury"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xad29323BC72FBaa6379602237b2Ae76265804f81)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x1474467995939740B68E4A66cEd94c2824d8CE7b)
 */
export const simulateTkoATokenTaikoMintToTreasury =
  /*#__PURE__*/ createSimulateContract({
    abi: tkoATokenTaikoAbi,
    address: tkoATokenTaikoAddress,
    functionName: 'mintToTreasury',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link tkoATokenTaikoAbi}__ and `functionName` set to `"permit"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xad29323BC72FBaa6379602237b2Ae76265804f81)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x1474467995939740B68E4A66cEd94c2824d8CE7b)
 */
export const simulateTkoATokenTaikoPermit =
  /*#__PURE__*/ createSimulateContract({
    abi: tkoATokenTaikoAbi,
    address: tkoATokenTaikoAddress,
    functionName: 'permit',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link tkoATokenTaikoAbi}__ and `functionName` set to `"rescueTokens"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xad29323BC72FBaa6379602237b2Ae76265804f81)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x1474467995939740B68E4A66cEd94c2824d8CE7b)
 */
export const simulateTkoATokenTaikoRescueTokens =
  /*#__PURE__*/ createSimulateContract({
    abi: tkoATokenTaikoAbi,
    address: tkoATokenTaikoAddress,
    functionName: 'rescueTokens',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link tkoATokenTaikoAbi}__ and `functionName` set to `"setIncentivesController"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xad29323BC72FBaa6379602237b2Ae76265804f81)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x1474467995939740B68E4A66cEd94c2824d8CE7b)
 */
export const simulateTkoATokenTaikoSetIncentivesController =
  /*#__PURE__*/ createSimulateContract({
    abi: tkoATokenTaikoAbi,
    address: tkoATokenTaikoAddress,
    functionName: 'setIncentivesController',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link tkoATokenTaikoAbi}__ and `functionName` set to `"transfer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xad29323BC72FBaa6379602237b2Ae76265804f81)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x1474467995939740B68E4A66cEd94c2824d8CE7b)
 */
export const simulateTkoATokenTaikoTransfer =
  /*#__PURE__*/ createSimulateContract({
    abi: tkoATokenTaikoAbi,
    address: tkoATokenTaikoAddress,
    functionName: 'transfer',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link tkoATokenTaikoAbi}__ and `functionName` set to `"transferFrom"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xad29323BC72FBaa6379602237b2Ae76265804f81)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x1474467995939740B68E4A66cEd94c2824d8CE7b)
 */
export const simulateTkoATokenTaikoTransferFrom =
  /*#__PURE__*/ createSimulateContract({
    abi: tkoATokenTaikoAbi,
    address: tkoATokenTaikoAddress,
    functionName: 'transferFrom',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link tkoATokenTaikoAbi}__ and `functionName` set to `"transferOnLiquidation"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xad29323BC72FBaa6379602237b2Ae76265804f81)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x1474467995939740B68E4A66cEd94c2824d8CE7b)
 */
export const simulateTkoATokenTaikoTransferOnLiquidation =
  /*#__PURE__*/ createSimulateContract({
    abi: tkoATokenTaikoAbi,
    address: tkoATokenTaikoAddress,
    functionName: 'transferOnLiquidation',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link tkoATokenTaikoAbi}__ and `functionName` set to `"transferUnderlyingTo"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xad29323BC72FBaa6379602237b2Ae76265804f81)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x1474467995939740B68E4A66cEd94c2824d8CE7b)
 */
export const simulateTkoATokenTaikoTransferUnderlyingTo =
  /*#__PURE__*/ createSimulateContract({
    abi: tkoATokenTaikoAbi,
    address: tkoATokenTaikoAddress,
    functionName: 'transferUnderlyingTo',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link tkoATokenTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xad29323BC72FBaa6379602237b2Ae76265804f81)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x1474467995939740B68E4A66cEd94c2824d8CE7b)
 */
export const watchTkoATokenTaikoEvent = /*#__PURE__*/ createWatchContractEvent({
  abi: tkoATokenTaikoAbi,
  address: tkoATokenTaikoAddress,
})

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link tkoATokenTaikoAbi}__ and `eventName` set to `"Approval"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xad29323BC72FBaa6379602237b2Ae76265804f81)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x1474467995939740B68E4A66cEd94c2824d8CE7b)
 */
export const watchTkoATokenTaikoApprovalEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: tkoATokenTaikoAbi,
    address: tkoATokenTaikoAddress,
    eventName: 'Approval',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link tkoATokenTaikoAbi}__ and `eventName` set to `"BalanceTransfer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xad29323BC72FBaa6379602237b2Ae76265804f81)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x1474467995939740B68E4A66cEd94c2824d8CE7b)
 */
export const watchTkoATokenTaikoBalanceTransferEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: tkoATokenTaikoAbi,
    address: tkoATokenTaikoAddress,
    eventName: 'BalanceTransfer',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link tkoATokenTaikoAbi}__ and `eventName` set to `"Burn"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xad29323BC72FBaa6379602237b2Ae76265804f81)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x1474467995939740B68E4A66cEd94c2824d8CE7b)
 */
export const watchTkoATokenTaikoBurnEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: tkoATokenTaikoAbi,
    address: tkoATokenTaikoAddress,
    eventName: 'Burn',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link tkoATokenTaikoAbi}__ and `eventName` set to `"Initialized"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xad29323BC72FBaa6379602237b2Ae76265804f81)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x1474467995939740B68E4A66cEd94c2824d8CE7b)
 */
export const watchTkoATokenTaikoInitializedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: tkoATokenTaikoAbi,
    address: tkoATokenTaikoAddress,
    eventName: 'Initialized',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link tkoATokenTaikoAbi}__ and `eventName` set to `"Mint"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xad29323BC72FBaa6379602237b2Ae76265804f81)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x1474467995939740B68E4A66cEd94c2824d8CE7b)
 */
export const watchTkoATokenTaikoMintEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: tkoATokenTaikoAbi,
    address: tkoATokenTaikoAddress,
    eventName: 'Mint',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link tkoATokenTaikoAbi}__ and `eventName` set to `"Transfer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xad29323BC72FBaa6379602237b2Ae76265804f81)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x1474467995939740B68E4A66cEd94c2824d8CE7b)
 */
export const watchTkoATokenTaikoTransferEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: tkoATokenTaikoAbi,
    address: tkoATokenTaikoAddress,
    eventName: 'Transfer',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link tkoStableDebtTokenTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x659c695e2E56b27EA9BC4eF9083039D207bffF18)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x17C6748e4445d7ef7a8ebBe89C640c83D4D896e1)
 */
export const readTkoStableDebtTokenTaiko = /*#__PURE__*/ createReadContract({
  abi: tkoStableDebtTokenTaikoAbi,
  address: tkoStableDebtTokenTaikoAddress,
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link tkoStableDebtTokenTaikoAbi}__ and `functionName` set to `"DEBT_TOKEN_REVISION"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x659c695e2E56b27EA9BC4eF9083039D207bffF18)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x17C6748e4445d7ef7a8ebBe89C640c83D4D896e1)
 */
export const readTkoStableDebtTokenTaikoDebtTokenRevision =
  /*#__PURE__*/ createReadContract({
    abi: tkoStableDebtTokenTaikoAbi,
    address: tkoStableDebtTokenTaikoAddress,
    functionName: 'DEBT_TOKEN_REVISION',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link tkoStableDebtTokenTaikoAbi}__ and `functionName` set to `"DELEGATION_WITH_SIG_TYPEHASH"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x659c695e2E56b27EA9BC4eF9083039D207bffF18)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x17C6748e4445d7ef7a8ebBe89C640c83D4D896e1)
 */
export const readTkoStableDebtTokenTaikoDelegationWithSigTypehash =
  /*#__PURE__*/ createReadContract({
    abi: tkoStableDebtTokenTaikoAbi,
    address: tkoStableDebtTokenTaikoAddress,
    functionName: 'DELEGATION_WITH_SIG_TYPEHASH',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link tkoStableDebtTokenTaikoAbi}__ and `functionName` set to `"DOMAIN_SEPARATOR"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x659c695e2E56b27EA9BC4eF9083039D207bffF18)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x17C6748e4445d7ef7a8ebBe89C640c83D4D896e1)
 */
export const readTkoStableDebtTokenTaikoDomainSeparator =
  /*#__PURE__*/ createReadContract({
    abi: tkoStableDebtTokenTaikoAbi,
    address: tkoStableDebtTokenTaikoAddress,
    functionName: 'DOMAIN_SEPARATOR',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link tkoStableDebtTokenTaikoAbi}__ and `functionName` set to `"EIP712_REVISION"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x659c695e2E56b27EA9BC4eF9083039D207bffF18)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x17C6748e4445d7ef7a8ebBe89C640c83D4D896e1)
 */
export const readTkoStableDebtTokenTaikoEip712Revision =
  /*#__PURE__*/ createReadContract({
    abi: tkoStableDebtTokenTaikoAbi,
    address: tkoStableDebtTokenTaikoAddress,
    functionName: 'EIP712_REVISION',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link tkoStableDebtTokenTaikoAbi}__ and `functionName` set to `"POOL"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x659c695e2E56b27EA9BC4eF9083039D207bffF18)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x17C6748e4445d7ef7a8ebBe89C640c83D4D896e1)
 */
export const readTkoStableDebtTokenTaikoPool = /*#__PURE__*/ createReadContract(
  {
    abi: tkoStableDebtTokenTaikoAbi,
    address: tkoStableDebtTokenTaikoAddress,
    functionName: 'POOL',
  },
)

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link tkoStableDebtTokenTaikoAbi}__ and `functionName` set to `"UNDERLYING_ASSET_ADDRESS"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x659c695e2E56b27EA9BC4eF9083039D207bffF18)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x17C6748e4445d7ef7a8ebBe89C640c83D4D896e1)
 */
export const readTkoStableDebtTokenTaikoUnderlyingAssetAddress =
  /*#__PURE__*/ createReadContract({
    abi: tkoStableDebtTokenTaikoAbi,
    address: tkoStableDebtTokenTaikoAddress,
    functionName: 'UNDERLYING_ASSET_ADDRESS',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link tkoStableDebtTokenTaikoAbi}__ and `functionName` set to `"allowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x659c695e2E56b27EA9BC4eF9083039D207bffF18)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x17C6748e4445d7ef7a8ebBe89C640c83D4D896e1)
 */
export const readTkoStableDebtTokenTaikoAllowance =
  /*#__PURE__*/ createReadContract({
    abi: tkoStableDebtTokenTaikoAbi,
    address: tkoStableDebtTokenTaikoAddress,
    functionName: 'allowance',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link tkoStableDebtTokenTaikoAbi}__ and `functionName` set to `"balanceOf"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x659c695e2E56b27EA9BC4eF9083039D207bffF18)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x17C6748e4445d7ef7a8ebBe89C640c83D4D896e1)
 */
export const readTkoStableDebtTokenTaikoBalanceOf =
  /*#__PURE__*/ createReadContract({
    abi: tkoStableDebtTokenTaikoAbi,
    address: tkoStableDebtTokenTaikoAddress,
    functionName: 'balanceOf',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link tkoStableDebtTokenTaikoAbi}__ and `functionName` set to `"borrowAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x659c695e2E56b27EA9BC4eF9083039D207bffF18)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x17C6748e4445d7ef7a8ebBe89C640c83D4D896e1)
 */
export const readTkoStableDebtTokenTaikoBorrowAllowance =
  /*#__PURE__*/ createReadContract({
    abi: tkoStableDebtTokenTaikoAbi,
    address: tkoStableDebtTokenTaikoAddress,
    functionName: 'borrowAllowance',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link tkoStableDebtTokenTaikoAbi}__ and `functionName` set to `"decimals"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x659c695e2E56b27EA9BC4eF9083039D207bffF18)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x17C6748e4445d7ef7a8ebBe89C640c83D4D896e1)
 */
export const readTkoStableDebtTokenTaikoDecimals =
  /*#__PURE__*/ createReadContract({
    abi: tkoStableDebtTokenTaikoAbi,
    address: tkoStableDebtTokenTaikoAddress,
    functionName: 'decimals',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link tkoStableDebtTokenTaikoAbi}__ and `functionName` set to `"getAverageStableRate"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x659c695e2E56b27EA9BC4eF9083039D207bffF18)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x17C6748e4445d7ef7a8ebBe89C640c83D4D896e1)
 */
export const readTkoStableDebtTokenTaikoGetAverageStableRate =
  /*#__PURE__*/ createReadContract({
    abi: tkoStableDebtTokenTaikoAbi,
    address: tkoStableDebtTokenTaikoAddress,
    functionName: 'getAverageStableRate',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link tkoStableDebtTokenTaikoAbi}__ and `functionName` set to `"getIncentivesController"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x659c695e2E56b27EA9BC4eF9083039D207bffF18)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x17C6748e4445d7ef7a8ebBe89C640c83D4D896e1)
 */
export const readTkoStableDebtTokenTaikoGetIncentivesController =
  /*#__PURE__*/ createReadContract({
    abi: tkoStableDebtTokenTaikoAbi,
    address: tkoStableDebtTokenTaikoAddress,
    functionName: 'getIncentivesController',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link tkoStableDebtTokenTaikoAbi}__ and `functionName` set to `"getSupplyData"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x659c695e2E56b27EA9BC4eF9083039D207bffF18)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x17C6748e4445d7ef7a8ebBe89C640c83D4D896e1)
 */
export const readTkoStableDebtTokenTaikoGetSupplyData =
  /*#__PURE__*/ createReadContract({
    abi: tkoStableDebtTokenTaikoAbi,
    address: tkoStableDebtTokenTaikoAddress,
    functionName: 'getSupplyData',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link tkoStableDebtTokenTaikoAbi}__ and `functionName` set to `"getTotalSupplyAndAvgRate"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x659c695e2E56b27EA9BC4eF9083039D207bffF18)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x17C6748e4445d7ef7a8ebBe89C640c83D4D896e1)
 */
export const readTkoStableDebtTokenTaikoGetTotalSupplyAndAvgRate =
  /*#__PURE__*/ createReadContract({
    abi: tkoStableDebtTokenTaikoAbi,
    address: tkoStableDebtTokenTaikoAddress,
    functionName: 'getTotalSupplyAndAvgRate',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link tkoStableDebtTokenTaikoAbi}__ and `functionName` set to `"getTotalSupplyLastUpdated"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x659c695e2E56b27EA9BC4eF9083039D207bffF18)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x17C6748e4445d7ef7a8ebBe89C640c83D4D896e1)
 */
export const readTkoStableDebtTokenTaikoGetTotalSupplyLastUpdated =
  /*#__PURE__*/ createReadContract({
    abi: tkoStableDebtTokenTaikoAbi,
    address: tkoStableDebtTokenTaikoAddress,
    functionName: 'getTotalSupplyLastUpdated',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link tkoStableDebtTokenTaikoAbi}__ and `functionName` set to `"getUserLastUpdated"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x659c695e2E56b27EA9BC4eF9083039D207bffF18)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x17C6748e4445d7ef7a8ebBe89C640c83D4D896e1)
 */
export const readTkoStableDebtTokenTaikoGetUserLastUpdated =
  /*#__PURE__*/ createReadContract({
    abi: tkoStableDebtTokenTaikoAbi,
    address: tkoStableDebtTokenTaikoAddress,
    functionName: 'getUserLastUpdated',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link tkoStableDebtTokenTaikoAbi}__ and `functionName` set to `"getUserStableRate"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x659c695e2E56b27EA9BC4eF9083039D207bffF18)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x17C6748e4445d7ef7a8ebBe89C640c83D4D896e1)
 */
export const readTkoStableDebtTokenTaikoGetUserStableRate =
  /*#__PURE__*/ createReadContract({
    abi: tkoStableDebtTokenTaikoAbi,
    address: tkoStableDebtTokenTaikoAddress,
    functionName: 'getUserStableRate',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link tkoStableDebtTokenTaikoAbi}__ and `functionName` set to `"name"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x659c695e2E56b27EA9BC4eF9083039D207bffF18)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x17C6748e4445d7ef7a8ebBe89C640c83D4D896e1)
 */
export const readTkoStableDebtTokenTaikoName = /*#__PURE__*/ createReadContract(
  {
    abi: tkoStableDebtTokenTaikoAbi,
    address: tkoStableDebtTokenTaikoAddress,
    functionName: 'name',
  },
)

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link tkoStableDebtTokenTaikoAbi}__ and `functionName` set to `"nonces"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x659c695e2E56b27EA9BC4eF9083039D207bffF18)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x17C6748e4445d7ef7a8ebBe89C640c83D4D896e1)
 */
export const readTkoStableDebtTokenTaikoNonces =
  /*#__PURE__*/ createReadContract({
    abi: tkoStableDebtTokenTaikoAbi,
    address: tkoStableDebtTokenTaikoAddress,
    functionName: 'nonces',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link tkoStableDebtTokenTaikoAbi}__ and `functionName` set to `"principalBalanceOf"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x659c695e2E56b27EA9BC4eF9083039D207bffF18)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x17C6748e4445d7ef7a8ebBe89C640c83D4D896e1)
 */
export const readTkoStableDebtTokenTaikoPrincipalBalanceOf =
  /*#__PURE__*/ createReadContract({
    abi: tkoStableDebtTokenTaikoAbi,
    address: tkoStableDebtTokenTaikoAddress,
    functionName: 'principalBalanceOf',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link tkoStableDebtTokenTaikoAbi}__ and `functionName` set to `"symbol"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x659c695e2E56b27EA9BC4eF9083039D207bffF18)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x17C6748e4445d7ef7a8ebBe89C640c83D4D896e1)
 */
export const readTkoStableDebtTokenTaikoSymbol =
  /*#__PURE__*/ createReadContract({
    abi: tkoStableDebtTokenTaikoAbi,
    address: tkoStableDebtTokenTaikoAddress,
    functionName: 'symbol',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link tkoStableDebtTokenTaikoAbi}__ and `functionName` set to `"totalSupply"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x659c695e2E56b27EA9BC4eF9083039D207bffF18)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x17C6748e4445d7ef7a8ebBe89C640c83D4D896e1)
 */
export const readTkoStableDebtTokenTaikoTotalSupply =
  /*#__PURE__*/ createReadContract({
    abi: tkoStableDebtTokenTaikoAbi,
    address: tkoStableDebtTokenTaikoAddress,
    functionName: 'totalSupply',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link tkoStableDebtTokenTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x659c695e2E56b27EA9BC4eF9083039D207bffF18)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x17C6748e4445d7ef7a8ebBe89C640c83D4D896e1)
 */
export const writeTkoStableDebtTokenTaiko = /*#__PURE__*/ createWriteContract({
  abi: tkoStableDebtTokenTaikoAbi,
  address: tkoStableDebtTokenTaikoAddress,
})

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link tkoStableDebtTokenTaikoAbi}__ and `functionName` set to `"approve"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x659c695e2E56b27EA9BC4eF9083039D207bffF18)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x17C6748e4445d7ef7a8ebBe89C640c83D4D896e1)
 */
export const writeTkoStableDebtTokenTaikoApprove =
  /*#__PURE__*/ createWriteContract({
    abi: tkoStableDebtTokenTaikoAbi,
    address: tkoStableDebtTokenTaikoAddress,
    functionName: 'approve',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link tkoStableDebtTokenTaikoAbi}__ and `functionName` set to `"approveDelegation"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x659c695e2E56b27EA9BC4eF9083039D207bffF18)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x17C6748e4445d7ef7a8ebBe89C640c83D4D896e1)
 */
export const writeTkoStableDebtTokenTaikoApproveDelegation =
  /*#__PURE__*/ createWriteContract({
    abi: tkoStableDebtTokenTaikoAbi,
    address: tkoStableDebtTokenTaikoAddress,
    functionName: 'approveDelegation',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link tkoStableDebtTokenTaikoAbi}__ and `functionName` set to `"burn"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x659c695e2E56b27EA9BC4eF9083039D207bffF18)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x17C6748e4445d7ef7a8ebBe89C640c83D4D896e1)
 */
export const writeTkoStableDebtTokenTaikoBurn =
  /*#__PURE__*/ createWriteContract({
    abi: tkoStableDebtTokenTaikoAbi,
    address: tkoStableDebtTokenTaikoAddress,
    functionName: 'burn',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link tkoStableDebtTokenTaikoAbi}__ and `functionName` set to `"decreaseAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x659c695e2E56b27EA9BC4eF9083039D207bffF18)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x17C6748e4445d7ef7a8ebBe89C640c83D4D896e1)
 */
export const writeTkoStableDebtTokenTaikoDecreaseAllowance =
  /*#__PURE__*/ createWriteContract({
    abi: tkoStableDebtTokenTaikoAbi,
    address: tkoStableDebtTokenTaikoAddress,
    functionName: 'decreaseAllowance',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link tkoStableDebtTokenTaikoAbi}__ and `functionName` set to `"delegationWithSig"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x659c695e2E56b27EA9BC4eF9083039D207bffF18)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x17C6748e4445d7ef7a8ebBe89C640c83D4D896e1)
 */
export const writeTkoStableDebtTokenTaikoDelegationWithSig =
  /*#__PURE__*/ createWriteContract({
    abi: tkoStableDebtTokenTaikoAbi,
    address: tkoStableDebtTokenTaikoAddress,
    functionName: 'delegationWithSig',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link tkoStableDebtTokenTaikoAbi}__ and `functionName` set to `"increaseAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x659c695e2E56b27EA9BC4eF9083039D207bffF18)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x17C6748e4445d7ef7a8ebBe89C640c83D4D896e1)
 */
export const writeTkoStableDebtTokenTaikoIncreaseAllowance =
  /*#__PURE__*/ createWriteContract({
    abi: tkoStableDebtTokenTaikoAbi,
    address: tkoStableDebtTokenTaikoAddress,
    functionName: 'increaseAllowance',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link tkoStableDebtTokenTaikoAbi}__ and `functionName` set to `"initialize"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x659c695e2E56b27EA9BC4eF9083039D207bffF18)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x17C6748e4445d7ef7a8ebBe89C640c83D4D896e1)
 */
export const writeTkoStableDebtTokenTaikoInitialize =
  /*#__PURE__*/ createWriteContract({
    abi: tkoStableDebtTokenTaikoAbi,
    address: tkoStableDebtTokenTaikoAddress,
    functionName: 'initialize',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link tkoStableDebtTokenTaikoAbi}__ and `functionName` set to `"mint"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x659c695e2E56b27EA9BC4eF9083039D207bffF18)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x17C6748e4445d7ef7a8ebBe89C640c83D4D896e1)
 */
export const writeTkoStableDebtTokenTaikoMint =
  /*#__PURE__*/ createWriteContract({
    abi: tkoStableDebtTokenTaikoAbi,
    address: tkoStableDebtTokenTaikoAddress,
    functionName: 'mint',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link tkoStableDebtTokenTaikoAbi}__ and `functionName` set to `"setIncentivesController"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x659c695e2E56b27EA9BC4eF9083039D207bffF18)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x17C6748e4445d7ef7a8ebBe89C640c83D4D896e1)
 */
export const writeTkoStableDebtTokenTaikoSetIncentivesController =
  /*#__PURE__*/ createWriteContract({
    abi: tkoStableDebtTokenTaikoAbi,
    address: tkoStableDebtTokenTaikoAddress,
    functionName: 'setIncentivesController',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link tkoStableDebtTokenTaikoAbi}__ and `functionName` set to `"transfer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x659c695e2E56b27EA9BC4eF9083039D207bffF18)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x17C6748e4445d7ef7a8ebBe89C640c83D4D896e1)
 */
export const writeTkoStableDebtTokenTaikoTransfer =
  /*#__PURE__*/ createWriteContract({
    abi: tkoStableDebtTokenTaikoAbi,
    address: tkoStableDebtTokenTaikoAddress,
    functionName: 'transfer',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link tkoStableDebtTokenTaikoAbi}__ and `functionName` set to `"transferFrom"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x659c695e2E56b27EA9BC4eF9083039D207bffF18)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x17C6748e4445d7ef7a8ebBe89C640c83D4D896e1)
 */
export const writeTkoStableDebtTokenTaikoTransferFrom =
  /*#__PURE__*/ createWriteContract({
    abi: tkoStableDebtTokenTaikoAbi,
    address: tkoStableDebtTokenTaikoAddress,
    functionName: 'transferFrom',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link tkoStableDebtTokenTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x659c695e2E56b27EA9BC4eF9083039D207bffF18)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x17C6748e4445d7ef7a8ebBe89C640c83D4D896e1)
 */
export const simulateTkoStableDebtTokenTaiko =
  /*#__PURE__*/ createSimulateContract({
    abi: tkoStableDebtTokenTaikoAbi,
    address: tkoStableDebtTokenTaikoAddress,
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link tkoStableDebtTokenTaikoAbi}__ and `functionName` set to `"approve"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x659c695e2E56b27EA9BC4eF9083039D207bffF18)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x17C6748e4445d7ef7a8ebBe89C640c83D4D896e1)
 */
export const simulateTkoStableDebtTokenTaikoApprove =
  /*#__PURE__*/ createSimulateContract({
    abi: tkoStableDebtTokenTaikoAbi,
    address: tkoStableDebtTokenTaikoAddress,
    functionName: 'approve',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link tkoStableDebtTokenTaikoAbi}__ and `functionName` set to `"approveDelegation"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x659c695e2E56b27EA9BC4eF9083039D207bffF18)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x17C6748e4445d7ef7a8ebBe89C640c83D4D896e1)
 */
export const simulateTkoStableDebtTokenTaikoApproveDelegation =
  /*#__PURE__*/ createSimulateContract({
    abi: tkoStableDebtTokenTaikoAbi,
    address: tkoStableDebtTokenTaikoAddress,
    functionName: 'approveDelegation',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link tkoStableDebtTokenTaikoAbi}__ and `functionName` set to `"burn"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x659c695e2E56b27EA9BC4eF9083039D207bffF18)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x17C6748e4445d7ef7a8ebBe89C640c83D4D896e1)
 */
export const simulateTkoStableDebtTokenTaikoBurn =
  /*#__PURE__*/ createSimulateContract({
    abi: tkoStableDebtTokenTaikoAbi,
    address: tkoStableDebtTokenTaikoAddress,
    functionName: 'burn',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link tkoStableDebtTokenTaikoAbi}__ and `functionName` set to `"decreaseAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x659c695e2E56b27EA9BC4eF9083039D207bffF18)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x17C6748e4445d7ef7a8ebBe89C640c83D4D896e1)
 */
export const simulateTkoStableDebtTokenTaikoDecreaseAllowance =
  /*#__PURE__*/ createSimulateContract({
    abi: tkoStableDebtTokenTaikoAbi,
    address: tkoStableDebtTokenTaikoAddress,
    functionName: 'decreaseAllowance',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link tkoStableDebtTokenTaikoAbi}__ and `functionName` set to `"delegationWithSig"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x659c695e2E56b27EA9BC4eF9083039D207bffF18)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x17C6748e4445d7ef7a8ebBe89C640c83D4D896e1)
 */
export const simulateTkoStableDebtTokenTaikoDelegationWithSig =
  /*#__PURE__*/ createSimulateContract({
    abi: tkoStableDebtTokenTaikoAbi,
    address: tkoStableDebtTokenTaikoAddress,
    functionName: 'delegationWithSig',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link tkoStableDebtTokenTaikoAbi}__ and `functionName` set to `"increaseAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x659c695e2E56b27EA9BC4eF9083039D207bffF18)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x17C6748e4445d7ef7a8ebBe89C640c83D4D896e1)
 */
export const simulateTkoStableDebtTokenTaikoIncreaseAllowance =
  /*#__PURE__*/ createSimulateContract({
    abi: tkoStableDebtTokenTaikoAbi,
    address: tkoStableDebtTokenTaikoAddress,
    functionName: 'increaseAllowance',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link tkoStableDebtTokenTaikoAbi}__ and `functionName` set to `"initialize"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x659c695e2E56b27EA9BC4eF9083039D207bffF18)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x17C6748e4445d7ef7a8ebBe89C640c83D4D896e1)
 */
export const simulateTkoStableDebtTokenTaikoInitialize =
  /*#__PURE__*/ createSimulateContract({
    abi: tkoStableDebtTokenTaikoAbi,
    address: tkoStableDebtTokenTaikoAddress,
    functionName: 'initialize',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link tkoStableDebtTokenTaikoAbi}__ and `functionName` set to `"mint"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x659c695e2E56b27EA9BC4eF9083039D207bffF18)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x17C6748e4445d7ef7a8ebBe89C640c83D4D896e1)
 */
export const simulateTkoStableDebtTokenTaikoMint =
  /*#__PURE__*/ createSimulateContract({
    abi: tkoStableDebtTokenTaikoAbi,
    address: tkoStableDebtTokenTaikoAddress,
    functionName: 'mint',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link tkoStableDebtTokenTaikoAbi}__ and `functionName` set to `"setIncentivesController"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x659c695e2E56b27EA9BC4eF9083039D207bffF18)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x17C6748e4445d7ef7a8ebBe89C640c83D4D896e1)
 */
export const simulateTkoStableDebtTokenTaikoSetIncentivesController =
  /*#__PURE__*/ createSimulateContract({
    abi: tkoStableDebtTokenTaikoAbi,
    address: tkoStableDebtTokenTaikoAddress,
    functionName: 'setIncentivesController',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link tkoStableDebtTokenTaikoAbi}__ and `functionName` set to `"transfer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x659c695e2E56b27EA9BC4eF9083039D207bffF18)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x17C6748e4445d7ef7a8ebBe89C640c83D4D896e1)
 */
export const simulateTkoStableDebtTokenTaikoTransfer =
  /*#__PURE__*/ createSimulateContract({
    abi: tkoStableDebtTokenTaikoAbi,
    address: tkoStableDebtTokenTaikoAddress,
    functionName: 'transfer',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link tkoStableDebtTokenTaikoAbi}__ and `functionName` set to `"transferFrom"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x659c695e2E56b27EA9BC4eF9083039D207bffF18)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x17C6748e4445d7ef7a8ebBe89C640c83D4D896e1)
 */
export const simulateTkoStableDebtTokenTaikoTransferFrom =
  /*#__PURE__*/ createSimulateContract({
    abi: tkoStableDebtTokenTaikoAbi,
    address: tkoStableDebtTokenTaikoAddress,
    functionName: 'transferFrom',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link tkoStableDebtTokenTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x659c695e2E56b27EA9BC4eF9083039D207bffF18)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x17C6748e4445d7ef7a8ebBe89C640c83D4D896e1)
 */
export const watchTkoStableDebtTokenTaikoEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: tkoStableDebtTokenTaikoAbi,
    address: tkoStableDebtTokenTaikoAddress,
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link tkoStableDebtTokenTaikoAbi}__ and `eventName` set to `"Approval"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x659c695e2E56b27EA9BC4eF9083039D207bffF18)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x17C6748e4445d7ef7a8ebBe89C640c83D4D896e1)
 */
export const watchTkoStableDebtTokenTaikoApprovalEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: tkoStableDebtTokenTaikoAbi,
    address: tkoStableDebtTokenTaikoAddress,
    eventName: 'Approval',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link tkoStableDebtTokenTaikoAbi}__ and `eventName` set to `"BorrowAllowanceDelegated"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x659c695e2E56b27EA9BC4eF9083039D207bffF18)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x17C6748e4445d7ef7a8ebBe89C640c83D4D896e1)
 */
export const watchTkoStableDebtTokenTaikoBorrowAllowanceDelegatedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: tkoStableDebtTokenTaikoAbi,
    address: tkoStableDebtTokenTaikoAddress,
    eventName: 'BorrowAllowanceDelegated',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link tkoStableDebtTokenTaikoAbi}__ and `eventName` set to `"Burn"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x659c695e2E56b27EA9BC4eF9083039D207bffF18)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x17C6748e4445d7ef7a8ebBe89C640c83D4D896e1)
 */
export const watchTkoStableDebtTokenTaikoBurnEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: tkoStableDebtTokenTaikoAbi,
    address: tkoStableDebtTokenTaikoAddress,
    eventName: 'Burn',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link tkoStableDebtTokenTaikoAbi}__ and `eventName` set to `"Initialized"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x659c695e2E56b27EA9BC4eF9083039D207bffF18)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x17C6748e4445d7ef7a8ebBe89C640c83D4D896e1)
 */
export const watchTkoStableDebtTokenTaikoInitializedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: tkoStableDebtTokenTaikoAbi,
    address: tkoStableDebtTokenTaikoAddress,
    eventName: 'Initialized',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link tkoStableDebtTokenTaikoAbi}__ and `eventName` set to `"Mint"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x659c695e2E56b27EA9BC4eF9083039D207bffF18)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x17C6748e4445d7ef7a8ebBe89C640c83D4D896e1)
 */
export const watchTkoStableDebtTokenTaikoMintEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: tkoStableDebtTokenTaikoAbi,
    address: tkoStableDebtTokenTaikoAddress,
    eventName: 'Mint',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link tkoStableDebtTokenTaikoAbi}__ and `eventName` set to `"Transfer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x659c695e2E56b27EA9BC4eF9083039D207bffF18)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x17C6748e4445d7ef7a8ebBe89C640c83D4D896e1)
 */
export const watchTkoStableDebtTokenTaikoTransferEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: tkoStableDebtTokenTaikoAbi,
    address: tkoStableDebtTokenTaikoAddress,
    eventName: 'Transfer',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link tkoTestnetMintableErc20TaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd4Ce092363B0B4d8F6E508CF37dBc94b299c0bD8)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x46c0AE0f2e52425C3e5Ea0D05e94B87ACC381CAe)
 */
export const readTkoTestnetMintableErc20Taiko =
  /*#__PURE__*/ createReadContract({
    abi: tkoTestnetMintableErc20TaikoAbi,
    address: tkoTestnetMintableErc20TaikoAddress,
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link tkoTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"allowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd4Ce092363B0B4d8F6E508CF37dBc94b299c0bD8)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x46c0AE0f2e52425C3e5Ea0D05e94B87ACC381CAe)
 */
export const readTkoTestnetMintableErc20TaikoAllowance =
  /*#__PURE__*/ createReadContract({
    abi: tkoTestnetMintableErc20TaikoAbi,
    address: tkoTestnetMintableErc20TaikoAddress,
    functionName: 'allowance',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link tkoTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"balanceOf"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd4Ce092363B0B4d8F6E508CF37dBc94b299c0bD8)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x46c0AE0f2e52425C3e5Ea0D05e94B87ACC381CAe)
 */
export const readTkoTestnetMintableErc20TaikoBalanceOf =
  /*#__PURE__*/ createReadContract({
    abi: tkoTestnetMintableErc20TaikoAbi,
    address: tkoTestnetMintableErc20TaikoAddress,
    functionName: 'balanceOf',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link tkoTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"decimals"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd4Ce092363B0B4d8F6E508CF37dBc94b299c0bD8)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x46c0AE0f2e52425C3e5Ea0D05e94B87ACC381CAe)
 */
export const readTkoTestnetMintableErc20TaikoDecimals =
  /*#__PURE__*/ createReadContract({
    abi: tkoTestnetMintableErc20TaikoAbi,
    address: tkoTestnetMintableErc20TaikoAddress,
    functionName: 'decimals',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link tkoTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"name"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd4Ce092363B0B4d8F6E508CF37dBc94b299c0bD8)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x46c0AE0f2e52425C3e5Ea0D05e94B87ACC381CAe)
 */
export const readTkoTestnetMintableErc20TaikoName =
  /*#__PURE__*/ createReadContract({
    abi: tkoTestnetMintableErc20TaikoAbi,
    address: tkoTestnetMintableErc20TaikoAddress,
    functionName: 'name',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link tkoTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"symbol"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd4Ce092363B0B4d8F6E508CF37dBc94b299c0bD8)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x46c0AE0f2e52425C3e5Ea0D05e94B87ACC381CAe)
 */
export const readTkoTestnetMintableErc20TaikoSymbol =
  /*#__PURE__*/ createReadContract({
    abi: tkoTestnetMintableErc20TaikoAbi,
    address: tkoTestnetMintableErc20TaikoAddress,
    functionName: 'symbol',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link tkoTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"tokenDecimals"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd4Ce092363B0B4d8F6E508CF37dBc94b299c0bD8)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x46c0AE0f2e52425C3e5Ea0D05e94B87ACC381CAe)
 */
export const readTkoTestnetMintableErc20TaikoTokenDecimals =
  /*#__PURE__*/ createReadContract({
    abi: tkoTestnetMintableErc20TaikoAbi,
    address: tkoTestnetMintableErc20TaikoAddress,
    functionName: 'tokenDecimals',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link tkoTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"totalSupply"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd4Ce092363B0B4d8F6E508CF37dBc94b299c0bD8)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x46c0AE0f2e52425C3e5Ea0D05e94B87ACC381CAe)
 */
export const readTkoTestnetMintableErc20TaikoTotalSupply =
  /*#__PURE__*/ createReadContract({
    abi: tkoTestnetMintableErc20TaikoAbi,
    address: tkoTestnetMintableErc20TaikoAddress,
    functionName: 'totalSupply',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link tkoTestnetMintableErc20TaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd4Ce092363B0B4d8F6E508CF37dBc94b299c0bD8)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x46c0AE0f2e52425C3e5Ea0D05e94B87ACC381CAe)
 */
export const writeTkoTestnetMintableErc20Taiko =
  /*#__PURE__*/ createWriteContract({
    abi: tkoTestnetMintableErc20TaikoAbi,
    address: tkoTestnetMintableErc20TaikoAddress,
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link tkoTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"approve"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd4Ce092363B0B4d8F6E508CF37dBc94b299c0bD8)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x46c0AE0f2e52425C3e5Ea0D05e94B87ACC381CAe)
 */
export const writeTkoTestnetMintableErc20TaikoApprove =
  /*#__PURE__*/ createWriteContract({
    abi: tkoTestnetMintableErc20TaikoAbi,
    address: tkoTestnetMintableErc20TaikoAddress,
    functionName: 'approve',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link tkoTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"decreaseAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd4Ce092363B0B4d8F6E508CF37dBc94b299c0bD8)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x46c0AE0f2e52425C3e5Ea0D05e94B87ACC381CAe)
 */
export const writeTkoTestnetMintableErc20TaikoDecreaseAllowance =
  /*#__PURE__*/ createWriteContract({
    abi: tkoTestnetMintableErc20TaikoAbi,
    address: tkoTestnetMintableErc20TaikoAddress,
    functionName: 'decreaseAllowance',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link tkoTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"increaseAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd4Ce092363B0B4d8F6E508CF37dBc94b299c0bD8)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x46c0AE0f2e52425C3e5Ea0D05e94B87ACC381CAe)
 */
export const writeTkoTestnetMintableErc20TaikoIncreaseAllowance =
  /*#__PURE__*/ createWriteContract({
    abi: tkoTestnetMintableErc20TaikoAbi,
    address: tkoTestnetMintableErc20TaikoAddress,
    functionName: 'increaseAllowance',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link tkoTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"transfer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd4Ce092363B0B4d8F6E508CF37dBc94b299c0bD8)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x46c0AE0f2e52425C3e5Ea0D05e94B87ACC381CAe)
 */
export const writeTkoTestnetMintableErc20TaikoTransfer =
  /*#__PURE__*/ createWriteContract({
    abi: tkoTestnetMintableErc20TaikoAbi,
    address: tkoTestnetMintableErc20TaikoAddress,
    functionName: 'transfer',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link tkoTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"transferFrom"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd4Ce092363B0B4d8F6E508CF37dBc94b299c0bD8)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x46c0AE0f2e52425C3e5Ea0D05e94B87ACC381CAe)
 */
export const writeTkoTestnetMintableErc20TaikoTransferFrom =
  /*#__PURE__*/ createWriteContract({
    abi: tkoTestnetMintableErc20TaikoAbi,
    address: tkoTestnetMintableErc20TaikoAddress,
    functionName: 'transferFrom',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link tkoTestnetMintableErc20TaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd4Ce092363B0B4d8F6E508CF37dBc94b299c0bD8)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x46c0AE0f2e52425C3e5Ea0D05e94B87ACC381CAe)
 */
export const simulateTkoTestnetMintableErc20Taiko =
  /*#__PURE__*/ createSimulateContract({
    abi: tkoTestnetMintableErc20TaikoAbi,
    address: tkoTestnetMintableErc20TaikoAddress,
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link tkoTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"approve"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd4Ce092363B0B4d8F6E508CF37dBc94b299c0bD8)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x46c0AE0f2e52425C3e5Ea0D05e94B87ACC381CAe)
 */
export const simulateTkoTestnetMintableErc20TaikoApprove =
  /*#__PURE__*/ createSimulateContract({
    abi: tkoTestnetMintableErc20TaikoAbi,
    address: tkoTestnetMintableErc20TaikoAddress,
    functionName: 'approve',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link tkoTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"decreaseAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd4Ce092363B0B4d8F6E508CF37dBc94b299c0bD8)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x46c0AE0f2e52425C3e5Ea0D05e94B87ACC381CAe)
 */
export const simulateTkoTestnetMintableErc20TaikoDecreaseAllowance =
  /*#__PURE__*/ createSimulateContract({
    abi: tkoTestnetMintableErc20TaikoAbi,
    address: tkoTestnetMintableErc20TaikoAddress,
    functionName: 'decreaseAllowance',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link tkoTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"increaseAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd4Ce092363B0B4d8F6E508CF37dBc94b299c0bD8)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x46c0AE0f2e52425C3e5Ea0D05e94B87ACC381CAe)
 */
export const simulateTkoTestnetMintableErc20TaikoIncreaseAllowance =
  /*#__PURE__*/ createSimulateContract({
    abi: tkoTestnetMintableErc20TaikoAbi,
    address: tkoTestnetMintableErc20TaikoAddress,
    functionName: 'increaseAllowance',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link tkoTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"transfer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd4Ce092363B0B4d8F6E508CF37dBc94b299c0bD8)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x46c0AE0f2e52425C3e5Ea0D05e94B87ACC381CAe)
 */
export const simulateTkoTestnetMintableErc20TaikoTransfer =
  /*#__PURE__*/ createSimulateContract({
    abi: tkoTestnetMintableErc20TaikoAbi,
    address: tkoTestnetMintableErc20TaikoAddress,
    functionName: 'transfer',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link tkoTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"transferFrom"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd4Ce092363B0B4d8F6E508CF37dBc94b299c0bD8)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x46c0AE0f2e52425C3e5Ea0D05e94B87ACC381CAe)
 */
export const simulateTkoTestnetMintableErc20TaikoTransferFrom =
  /*#__PURE__*/ createSimulateContract({
    abi: tkoTestnetMintableErc20TaikoAbi,
    address: tkoTestnetMintableErc20TaikoAddress,
    functionName: 'transferFrom',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link tkoTestnetMintableErc20TaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd4Ce092363B0B4d8F6E508CF37dBc94b299c0bD8)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x46c0AE0f2e52425C3e5Ea0D05e94B87ACC381CAe)
 */
export const watchTkoTestnetMintableErc20TaikoEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: tkoTestnetMintableErc20TaikoAbi,
    address: tkoTestnetMintableErc20TaikoAddress,
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link tkoTestnetMintableErc20TaikoAbi}__ and `eventName` set to `"Approval"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd4Ce092363B0B4d8F6E508CF37dBc94b299c0bD8)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x46c0AE0f2e52425C3e5Ea0D05e94B87ACC381CAe)
 */
export const watchTkoTestnetMintableErc20TaikoApprovalEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: tkoTestnetMintableErc20TaikoAbi,
    address: tkoTestnetMintableErc20TaikoAddress,
    eventName: 'Approval',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link tkoTestnetMintableErc20TaikoAbi}__ and `eventName` set to `"Transfer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd4Ce092363B0B4d8F6E508CF37dBc94b299c0bD8)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x46c0AE0f2e52425C3e5Ea0D05e94B87ACC381CAe)
 */
export const watchTkoTestnetMintableErc20TaikoTransferEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: tkoTestnetMintableErc20TaikoAbi,
    address: tkoTestnetMintableErc20TaikoAddress,
    eventName: 'Transfer',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link tkoTestnetPriceAggregatorTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBb1822FBc419a9A4b7Bd19C717442f067CF5CcBE)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7444F0465d29190835f71F1fc1a9c1E23e14d2d0)
 */
export const readTkoTestnetPriceAggregatorTaiko =
  /*#__PURE__*/ createReadContract({
    abi: tkoTestnetPriceAggregatorTaikoAbi,
    address: tkoTestnetPriceAggregatorTaikoAddress,
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link tkoTestnetPriceAggregatorTaikoAbi}__ and `functionName` set to `"decimals"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBb1822FBc419a9A4b7Bd19C717442f067CF5CcBE)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7444F0465d29190835f71F1fc1a9c1E23e14d2d0)
 */
export const readTkoTestnetPriceAggregatorTaikoDecimals =
  /*#__PURE__*/ createReadContract({
    abi: tkoTestnetPriceAggregatorTaikoAbi,
    address: tkoTestnetPriceAggregatorTaikoAddress,
    functionName: 'decimals',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link tkoTestnetPriceAggregatorTaikoAbi}__ and `functionName` set to `"getTokenType"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBb1822FBc419a9A4b7Bd19C717442f067CF5CcBE)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7444F0465d29190835f71F1fc1a9c1E23e14d2d0)
 */
export const readTkoTestnetPriceAggregatorTaikoGetTokenType =
  /*#__PURE__*/ createReadContract({
    abi: tkoTestnetPriceAggregatorTaikoAbi,
    address: tkoTestnetPriceAggregatorTaikoAddress,
    functionName: 'getTokenType',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link tkoTestnetPriceAggregatorTaikoAbi}__ and `functionName` set to `"latestAnswer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBb1822FBc419a9A4b7Bd19C717442f067CF5CcBE)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7444F0465d29190835f71F1fc1a9c1E23e14d2d0)
 */
export const readTkoTestnetPriceAggregatorTaikoLatestAnswer =
  /*#__PURE__*/ createReadContract({
    abi: tkoTestnetPriceAggregatorTaikoAbi,
    address: tkoTestnetPriceAggregatorTaikoAddress,
    functionName: 'latestAnswer',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link tkoTestnetPriceAggregatorTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBb1822FBc419a9A4b7Bd19C717442f067CF5CcBE)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7444F0465d29190835f71F1fc1a9c1E23e14d2d0)
 */
export const watchTkoTestnetPriceAggregatorTaikoEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: tkoTestnetPriceAggregatorTaikoAbi,
    address: tkoTestnetPriceAggregatorTaikoAddress,
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link tkoTestnetPriceAggregatorTaikoAbi}__ and `eventName` set to `"AnswerUpdated"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBb1822FBc419a9A4b7Bd19C717442f067CF5CcBE)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7444F0465d29190835f71F1fc1a9c1E23e14d2d0)
 */
export const watchTkoTestnetPriceAggregatorTaikoAnswerUpdatedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: tkoTestnetPriceAggregatorTaikoAbi,
    address: tkoTestnetPriceAggregatorTaikoAddress,
    eventName: 'AnswerUpdated',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link tkoVariableDebtTokenTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x54cE8BA483EE93098f58737f7068181aaa136DEe)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2bD5240967ea526892CaAeEEA2Dc9A871374e8ec)
 */
export const readTkoVariableDebtTokenTaiko = /*#__PURE__*/ createReadContract({
  abi: tkoVariableDebtTokenTaikoAbi,
  address: tkoVariableDebtTokenTaikoAddress,
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link tkoVariableDebtTokenTaikoAbi}__ and `functionName` set to `"DEBT_TOKEN_REVISION"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x54cE8BA483EE93098f58737f7068181aaa136DEe)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2bD5240967ea526892CaAeEEA2Dc9A871374e8ec)
 */
export const readTkoVariableDebtTokenTaikoDebtTokenRevision =
  /*#__PURE__*/ createReadContract({
    abi: tkoVariableDebtTokenTaikoAbi,
    address: tkoVariableDebtTokenTaikoAddress,
    functionName: 'DEBT_TOKEN_REVISION',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link tkoVariableDebtTokenTaikoAbi}__ and `functionName` set to `"DELEGATION_WITH_SIG_TYPEHASH"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x54cE8BA483EE93098f58737f7068181aaa136DEe)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2bD5240967ea526892CaAeEEA2Dc9A871374e8ec)
 */
export const readTkoVariableDebtTokenTaikoDelegationWithSigTypehash =
  /*#__PURE__*/ createReadContract({
    abi: tkoVariableDebtTokenTaikoAbi,
    address: tkoVariableDebtTokenTaikoAddress,
    functionName: 'DELEGATION_WITH_SIG_TYPEHASH',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link tkoVariableDebtTokenTaikoAbi}__ and `functionName` set to `"DOMAIN_SEPARATOR"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x54cE8BA483EE93098f58737f7068181aaa136DEe)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2bD5240967ea526892CaAeEEA2Dc9A871374e8ec)
 */
export const readTkoVariableDebtTokenTaikoDomainSeparator =
  /*#__PURE__*/ createReadContract({
    abi: tkoVariableDebtTokenTaikoAbi,
    address: tkoVariableDebtTokenTaikoAddress,
    functionName: 'DOMAIN_SEPARATOR',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link tkoVariableDebtTokenTaikoAbi}__ and `functionName` set to `"EIP712_REVISION"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x54cE8BA483EE93098f58737f7068181aaa136DEe)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2bD5240967ea526892CaAeEEA2Dc9A871374e8ec)
 */
export const readTkoVariableDebtTokenTaikoEip712Revision =
  /*#__PURE__*/ createReadContract({
    abi: tkoVariableDebtTokenTaikoAbi,
    address: tkoVariableDebtTokenTaikoAddress,
    functionName: 'EIP712_REVISION',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link tkoVariableDebtTokenTaikoAbi}__ and `functionName` set to `"POOL"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x54cE8BA483EE93098f58737f7068181aaa136DEe)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2bD5240967ea526892CaAeEEA2Dc9A871374e8ec)
 */
export const readTkoVariableDebtTokenTaikoPool =
  /*#__PURE__*/ createReadContract({
    abi: tkoVariableDebtTokenTaikoAbi,
    address: tkoVariableDebtTokenTaikoAddress,
    functionName: 'POOL',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link tkoVariableDebtTokenTaikoAbi}__ and `functionName` set to `"UNDERLYING_ASSET_ADDRESS"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x54cE8BA483EE93098f58737f7068181aaa136DEe)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2bD5240967ea526892CaAeEEA2Dc9A871374e8ec)
 */
export const readTkoVariableDebtTokenTaikoUnderlyingAssetAddress =
  /*#__PURE__*/ createReadContract({
    abi: tkoVariableDebtTokenTaikoAbi,
    address: tkoVariableDebtTokenTaikoAddress,
    functionName: 'UNDERLYING_ASSET_ADDRESS',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link tkoVariableDebtTokenTaikoAbi}__ and `functionName` set to `"allowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x54cE8BA483EE93098f58737f7068181aaa136DEe)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2bD5240967ea526892CaAeEEA2Dc9A871374e8ec)
 */
export const readTkoVariableDebtTokenTaikoAllowance =
  /*#__PURE__*/ createReadContract({
    abi: tkoVariableDebtTokenTaikoAbi,
    address: tkoVariableDebtTokenTaikoAddress,
    functionName: 'allowance',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link tkoVariableDebtTokenTaikoAbi}__ and `functionName` set to `"balanceOf"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x54cE8BA483EE93098f58737f7068181aaa136DEe)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2bD5240967ea526892CaAeEEA2Dc9A871374e8ec)
 */
export const readTkoVariableDebtTokenTaikoBalanceOf =
  /*#__PURE__*/ createReadContract({
    abi: tkoVariableDebtTokenTaikoAbi,
    address: tkoVariableDebtTokenTaikoAddress,
    functionName: 'balanceOf',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link tkoVariableDebtTokenTaikoAbi}__ and `functionName` set to `"borrowAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x54cE8BA483EE93098f58737f7068181aaa136DEe)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2bD5240967ea526892CaAeEEA2Dc9A871374e8ec)
 */
export const readTkoVariableDebtTokenTaikoBorrowAllowance =
  /*#__PURE__*/ createReadContract({
    abi: tkoVariableDebtTokenTaikoAbi,
    address: tkoVariableDebtTokenTaikoAddress,
    functionName: 'borrowAllowance',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link tkoVariableDebtTokenTaikoAbi}__ and `functionName` set to `"decimals"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x54cE8BA483EE93098f58737f7068181aaa136DEe)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2bD5240967ea526892CaAeEEA2Dc9A871374e8ec)
 */
export const readTkoVariableDebtTokenTaikoDecimals =
  /*#__PURE__*/ createReadContract({
    abi: tkoVariableDebtTokenTaikoAbi,
    address: tkoVariableDebtTokenTaikoAddress,
    functionName: 'decimals',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link tkoVariableDebtTokenTaikoAbi}__ and `functionName` set to `"getIncentivesController"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x54cE8BA483EE93098f58737f7068181aaa136DEe)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2bD5240967ea526892CaAeEEA2Dc9A871374e8ec)
 */
export const readTkoVariableDebtTokenTaikoGetIncentivesController =
  /*#__PURE__*/ createReadContract({
    abi: tkoVariableDebtTokenTaikoAbi,
    address: tkoVariableDebtTokenTaikoAddress,
    functionName: 'getIncentivesController',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link tkoVariableDebtTokenTaikoAbi}__ and `functionName` set to `"getPreviousIndex"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x54cE8BA483EE93098f58737f7068181aaa136DEe)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2bD5240967ea526892CaAeEEA2Dc9A871374e8ec)
 */
export const readTkoVariableDebtTokenTaikoGetPreviousIndex =
  /*#__PURE__*/ createReadContract({
    abi: tkoVariableDebtTokenTaikoAbi,
    address: tkoVariableDebtTokenTaikoAddress,
    functionName: 'getPreviousIndex',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link tkoVariableDebtTokenTaikoAbi}__ and `functionName` set to `"getScaledUserBalanceAndSupply"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x54cE8BA483EE93098f58737f7068181aaa136DEe)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2bD5240967ea526892CaAeEEA2Dc9A871374e8ec)
 */
export const readTkoVariableDebtTokenTaikoGetScaledUserBalanceAndSupply =
  /*#__PURE__*/ createReadContract({
    abi: tkoVariableDebtTokenTaikoAbi,
    address: tkoVariableDebtTokenTaikoAddress,
    functionName: 'getScaledUserBalanceAndSupply',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link tkoVariableDebtTokenTaikoAbi}__ and `functionName` set to `"name"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x54cE8BA483EE93098f58737f7068181aaa136DEe)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2bD5240967ea526892CaAeEEA2Dc9A871374e8ec)
 */
export const readTkoVariableDebtTokenTaikoName =
  /*#__PURE__*/ createReadContract({
    abi: tkoVariableDebtTokenTaikoAbi,
    address: tkoVariableDebtTokenTaikoAddress,
    functionName: 'name',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link tkoVariableDebtTokenTaikoAbi}__ and `functionName` set to `"nonces"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x54cE8BA483EE93098f58737f7068181aaa136DEe)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2bD5240967ea526892CaAeEEA2Dc9A871374e8ec)
 */
export const readTkoVariableDebtTokenTaikoNonces =
  /*#__PURE__*/ createReadContract({
    abi: tkoVariableDebtTokenTaikoAbi,
    address: tkoVariableDebtTokenTaikoAddress,
    functionName: 'nonces',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link tkoVariableDebtTokenTaikoAbi}__ and `functionName` set to `"scaledBalanceOf"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x54cE8BA483EE93098f58737f7068181aaa136DEe)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2bD5240967ea526892CaAeEEA2Dc9A871374e8ec)
 */
export const readTkoVariableDebtTokenTaikoScaledBalanceOf =
  /*#__PURE__*/ createReadContract({
    abi: tkoVariableDebtTokenTaikoAbi,
    address: tkoVariableDebtTokenTaikoAddress,
    functionName: 'scaledBalanceOf',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link tkoVariableDebtTokenTaikoAbi}__ and `functionName` set to `"scaledTotalSupply"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x54cE8BA483EE93098f58737f7068181aaa136DEe)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2bD5240967ea526892CaAeEEA2Dc9A871374e8ec)
 */
export const readTkoVariableDebtTokenTaikoScaledTotalSupply =
  /*#__PURE__*/ createReadContract({
    abi: tkoVariableDebtTokenTaikoAbi,
    address: tkoVariableDebtTokenTaikoAddress,
    functionName: 'scaledTotalSupply',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link tkoVariableDebtTokenTaikoAbi}__ and `functionName` set to `"symbol"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x54cE8BA483EE93098f58737f7068181aaa136DEe)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2bD5240967ea526892CaAeEEA2Dc9A871374e8ec)
 */
export const readTkoVariableDebtTokenTaikoSymbol =
  /*#__PURE__*/ createReadContract({
    abi: tkoVariableDebtTokenTaikoAbi,
    address: tkoVariableDebtTokenTaikoAddress,
    functionName: 'symbol',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link tkoVariableDebtTokenTaikoAbi}__ and `functionName` set to `"totalSupply"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x54cE8BA483EE93098f58737f7068181aaa136DEe)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2bD5240967ea526892CaAeEEA2Dc9A871374e8ec)
 */
export const readTkoVariableDebtTokenTaikoTotalSupply =
  /*#__PURE__*/ createReadContract({
    abi: tkoVariableDebtTokenTaikoAbi,
    address: tkoVariableDebtTokenTaikoAddress,
    functionName: 'totalSupply',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link tkoVariableDebtTokenTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x54cE8BA483EE93098f58737f7068181aaa136DEe)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2bD5240967ea526892CaAeEEA2Dc9A871374e8ec)
 */
export const writeTkoVariableDebtTokenTaiko = /*#__PURE__*/ createWriteContract(
  {
    abi: tkoVariableDebtTokenTaikoAbi,
    address: tkoVariableDebtTokenTaikoAddress,
  },
)

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link tkoVariableDebtTokenTaikoAbi}__ and `functionName` set to `"approve"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x54cE8BA483EE93098f58737f7068181aaa136DEe)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2bD5240967ea526892CaAeEEA2Dc9A871374e8ec)
 */
export const writeTkoVariableDebtTokenTaikoApprove =
  /*#__PURE__*/ createWriteContract({
    abi: tkoVariableDebtTokenTaikoAbi,
    address: tkoVariableDebtTokenTaikoAddress,
    functionName: 'approve',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link tkoVariableDebtTokenTaikoAbi}__ and `functionName` set to `"approveDelegation"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x54cE8BA483EE93098f58737f7068181aaa136DEe)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2bD5240967ea526892CaAeEEA2Dc9A871374e8ec)
 */
export const writeTkoVariableDebtTokenTaikoApproveDelegation =
  /*#__PURE__*/ createWriteContract({
    abi: tkoVariableDebtTokenTaikoAbi,
    address: tkoVariableDebtTokenTaikoAddress,
    functionName: 'approveDelegation',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link tkoVariableDebtTokenTaikoAbi}__ and `functionName` set to `"burn"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x54cE8BA483EE93098f58737f7068181aaa136DEe)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2bD5240967ea526892CaAeEEA2Dc9A871374e8ec)
 */
export const writeTkoVariableDebtTokenTaikoBurn =
  /*#__PURE__*/ createWriteContract({
    abi: tkoVariableDebtTokenTaikoAbi,
    address: tkoVariableDebtTokenTaikoAddress,
    functionName: 'burn',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link tkoVariableDebtTokenTaikoAbi}__ and `functionName` set to `"decreaseAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x54cE8BA483EE93098f58737f7068181aaa136DEe)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2bD5240967ea526892CaAeEEA2Dc9A871374e8ec)
 */
export const writeTkoVariableDebtTokenTaikoDecreaseAllowance =
  /*#__PURE__*/ createWriteContract({
    abi: tkoVariableDebtTokenTaikoAbi,
    address: tkoVariableDebtTokenTaikoAddress,
    functionName: 'decreaseAllowance',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link tkoVariableDebtTokenTaikoAbi}__ and `functionName` set to `"delegationWithSig"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x54cE8BA483EE93098f58737f7068181aaa136DEe)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2bD5240967ea526892CaAeEEA2Dc9A871374e8ec)
 */
export const writeTkoVariableDebtTokenTaikoDelegationWithSig =
  /*#__PURE__*/ createWriteContract({
    abi: tkoVariableDebtTokenTaikoAbi,
    address: tkoVariableDebtTokenTaikoAddress,
    functionName: 'delegationWithSig',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link tkoVariableDebtTokenTaikoAbi}__ and `functionName` set to `"increaseAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x54cE8BA483EE93098f58737f7068181aaa136DEe)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2bD5240967ea526892CaAeEEA2Dc9A871374e8ec)
 */
export const writeTkoVariableDebtTokenTaikoIncreaseAllowance =
  /*#__PURE__*/ createWriteContract({
    abi: tkoVariableDebtTokenTaikoAbi,
    address: tkoVariableDebtTokenTaikoAddress,
    functionName: 'increaseAllowance',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link tkoVariableDebtTokenTaikoAbi}__ and `functionName` set to `"initialize"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x54cE8BA483EE93098f58737f7068181aaa136DEe)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2bD5240967ea526892CaAeEEA2Dc9A871374e8ec)
 */
export const writeTkoVariableDebtTokenTaikoInitialize =
  /*#__PURE__*/ createWriteContract({
    abi: tkoVariableDebtTokenTaikoAbi,
    address: tkoVariableDebtTokenTaikoAddress,
    functionName: 'initialize',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link tkoVariableDebtTokenTaikoAbi}__ and `functionName` set to `"mint"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x54cE8BA483EE93098f58737f7068181aaa136DEe)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2bD5240967ea526892CaAeEEA2Dc9A871374e8ec)
 */
export const writeTkoVariableDebtTokenTaikoMint =
  /*#__PURE__*/ createWriteContract({
    abi: tkoVariableDebtTokenTaikoAbi,
    address: tkoVariableDebtTokenTaikoAddress,
    functionName: 'mint',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link tkoVariableDebtTokenTaikoAbi}__ and `functionName` set to `"setIncentivesController"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x54cE8BA483EE93098f58737f7068181aaa136DEe)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2bD5240967ea526892CaAeEEA2Dc9A871374e8ec)
 */
export const writeTkoVariableDebtTokenTaikoSetIncentivesController =
  /*#__PURE__*/ createWriteContract({
    abi: tkoVariableDebtTokenTaikoAbi,
    address: tkoVariableDebtTokenTaikoAddress,
    functionName: 'setIncentivesController',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link tkoVariableDebtTokenTaikoAbi}__ and `functionName` set to `"transfer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x54cE8BA483EE93098f58737f7068181aaa136DEe)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2bD5240967ea526892CaAeEEA2Dc9A871374e8ec)
 */
export const writeTkoVariableDebtTokenTaikoTransfer =
  /*#__PURE__*/ createWriteContract({
    abi: tkoVariableDebtTokenTaikoAbi,
    address: tkoVariableDebtTokenTaikoAddress,
    functionName: 'transfer',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link tkoVariableDebtTokenTaikoAbi}__ and `functionName` set to `"transferFrom"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x54cE8BA483EE93098f58737f7068181aaa136DEe)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2bD5240967ea526892CaAeEEA2Dc9A871374e8ec)
 */
export const writeTkoVariableDebtTokenTaikoTransferFrom =
  /*#__PURE__*/ createWriteContract({
    abi: tkoVariableDebtTokenTaikoAbi,
    address: tkoVariableDebtTokenTaikoAddress,
    functionName: 'transferFrom',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link tkoVariableDebtTokenTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x54cE8BA483EE93098f58737f7068181aaa136DEe)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2bD5240967ea526892CaAeEEA2Dc9A871374e8ec)
 */
export const simulateTkoVariableDebtTokenTaiko =
  /*#__PURE__*/ createSimulateContract({
    abi: tkoVariableDebtTokenTaikoAbi,
    address: tkoVariableDebtTokenTaikoAddress,
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link tkoVariableDebtTokenTaikoAbi}__ and `functionName` set to `"approve"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x54cE8BA483EE93098f58737f7068181aaa136DEe)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2bD5240967ea526892CaAeEEA2Dc9A871374e8ec)
 */
export const simulateTkoVariableDebtTokenTaikoApprove =
  /*#__PURE__*/ createSimulateContract({
    abi: tkoVariableDebtTokenTaikoAbi,
    address: tkoVariableDebtTokenTaikoAddress,
    functionName: 'approve',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link tkoVariableDebtTokenTaikoAbi}__ and `functionName` set to `"approveDelegation"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x54cE8BA483EE93098f58737f7068181aaa136DEe)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2bD5240967ea526892CaAeEEA2Dc9A871374e8ec)
 */
export const simulateTkoVariableDebtTokenTaikoApproveDelegation =
  /*#__PURE__*/ createSimulateContract({
    abi: tkoVariableDebtTokenTaikoAbi,
    address: tkoVariableDebtTokenTaikoAddress,
    functionName: 'approveDelegation',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link tkoVariableDebtTokenTaikoAbi}__ and `functionName` set to `"burn"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x54cE8BA483EE93098f58737f7068181aaa136DEe)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2bD5240967ea526892CaAeEEA2Dc9A871374e8ec)
 */
export const simulateTkoVariableDebtTokenTaikoBurn =
  /*#__PURE__*/ createSimulateContract({
    abi: tkoVariableDebtTokenTaikoAbi,
    address: tkoVariableDebtTokenTaikoAddress,
    functionName: 'burn',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link tkoVariableDebtTokenTaikoAbi}__ and `functionName` set to `"decreaseAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x54cE8BA483EE93098f58737f7068181aaa136DEe)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2bD5240967ea526892CaAeEEA2Dc9A871374e8ec)
 */
export const simulateTkoVariableDebtTokenTaikoDecreaseAllowance =
  /*#__PURE__*/ createSimulateContract({
    abi: tkoVariableDebtTokenTaikoAbi,
    address: tkoVariableDebtTokenTaikoAddress,
    functionName: 'decreaseAllowance',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link tkoVariableDebtTokenTaikoAbi}__ and `functionName` set to `"delegationWithSig"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x54cE8BA483EE93098f58737f7068181aaa136DEe)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2bD5240967ea526892CaAeEEA2Dc9A871374e8ec)
 */
export const simulateTkoVariableDebtTokenTaikoDelegationWithSig =
  /*#__PURE__*/ createSimulateContract({
    abi: tkoVariableDebtTokenTaikoAbi,
    address: tkoVariableDebtTokenTaikoAddress,
    functionName: 'delegationWithSig',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link tkoVariableDebtTokenTaikoAbi}__ and `functionName` set to `"increaseAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x54cE8BA483EE93098f58737f7068181aaa136DEe)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2bD5240967ea526892CaAeEEA2Dc9A871374e8ec)
 */
export const simulateTkoVariableDebtTokenTaikoIncreaseAllowance =
  /*#__PURE__*/ createSimulateContract({
    abi: tkoVariableDebtTokenTaikoAbi,
    address: tkoVariableDebtTokenTaikoAddress,
    functionName: 'increaseAllowance',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link tkoVariableDebtTokenTaikoAbi}__ and `functionName` set to `"initialize"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x54cE8BA483EE93098f58737f7068181aaa136DEe)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2bD5240967ea526892CaAeEEA2Dc9A871374e8ec)
 */
export const simulateTkoVariableDebtTokenTaikoInitialize =
  /*#__PURE__*/ createSimulateContract({
    abi: tkoVariableDebtTokenTaikoAbi,
    address: tkoVariableDebtTokenTaikoAddress,
    functionName: 'initialize',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link tkoVariableDebtTokenTaikoAbi}__ and `functionName` set to `"mint"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x54cE8BA483EE93098f58737f7068181aaa136DEe)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2bD5240967ea526892CaAeEEA2Dc9A871374e8ec)
 */
export const simulateTkoVariableDebtTokenTaikoMint =
  /*#__PURE__*/ createSimulateContract({
    abi: tkoVariableDebtTokenTaikoAbi,
    address: tkoVariableDebtTokenTaikoAddress,
    functionName: 'mint',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link tkoVariableDebtTokenTaikoAbi}__ and `functionName` set to `"setIncentivesController"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x54cE8BA483EE93098f58737f7068181aaa136DEe)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2bD5240967ea526892CaAeEEA2Dc9A871374e8ec)
 */
export const simulateTkoVariableDebtTokenTaikoSetIncentivesController =
  /*#__PURE__*/ createSimulateContract({
    abi: tkoVariableDebtTokenTaikoAbi,
    address: tkoVariableDebtTokenTaikoAddress,
    functionName: 'setIncentivesController',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link tkoVariableDebtTokenTaikoAbi}__ and `functionName` set to `"transfer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x54cE8BA483EE93098f58737f7068181aaa136DEe)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2bD5240967ea526892CaAeEEA2Dc9A871374e8ec)
 */
export const simulateTkoVariableDebtTokenTaikoTransfer =
  /*#__PURE__*/ createSimulateContract({
    abi: tkoVariableDebtTokenTaikoAbi,
    address: tkoVariableDebtTokenTaikoAddress,
    functionName: 'transfer',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link tkoVariableDebtTokenTaikoAbi}__ and `functionName` set to `"transferFrom"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x54cE8BA483EE93098f58737f7068181aaa136DEe)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2bD5240967ea526892CaAeEEA2Dc9A871374e8ec)
 */
export const simulateTkoVariableDebtTokenTaikoTransferFrom =
  /*#__PURE__*/ createSimulateContract({
    abi: tkoVariableDebtTokenTaikoAbi,
    address: tkoVariableDebtTokenTaikoAddress,
    functionName: 'transferFrom',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link tkoVariableDebtTokenTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x54cE8BA483EE93098f58737f7068181aaa136DEe)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2bD5240967ea526892CaAeEEA2Dc9A871374e8ec)
 */
export const watchTkoVariableDebtTokenTaikoEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: tkoVariableDebtTokenTaikoAbi,
    address: tkoVariableDebtTokenTaikoAddress,
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link tkoVariableDebtTokenTaikoAbi}__ and `eventName` set to `"Approval"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x54cE8BA483EE93098f58737f7068181aaa136DEe)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2bD5240967ea526892CaAeEEA2Dc9A871374e8ec)
 */
export const watchTkoVariableDebtTokenTaikoApprovalEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: tkoVariableDebtTokenTaikoAbi,
    address: tkoVariableDebtTokenTaikoAddress,
    eventName: 'Approval',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link tkoVariableDebtTokenTaikoAbi}__ and `eventName` set to `"BorrowAllowanceDelegated"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x54cE8BA483EE93098f58737f7068181aaa136DEe)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2bD5240967ea526892CaAeEEA2Dc9A871374e8ec)
 */
export const watchTkoVariableDebtTokenTaikoBorrowAllowanceDelegatedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: tkoVariableDebtTokenTaikoAbi,
    address: tkoVariableDebtTokenTaikoAddress,
    eventName: 'BorrowAllowanceDelegated',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link tkoVariableDebtTokenTaikoAbi}__ and `eventName` set to `"Burn"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x54cE8BA483EE93098f58737f7068181aaa136DEe)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2bD5240967ea526892CaAeEEA2Dc9A871374e8ec)
 */
export const watchTkoVariableDebtTokenTaikoBurnEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: tkoVariableDebtTokenTaikoAbi,
    address: tkoVariableDebtTokenTaikoAddress,
    eventName: 'Burn',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link tkoVariableDebtTokenTaikoAbi}__ and `eventName` set to `"Initialized"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x54cE8BA483EE93098f58737f7068181aaa136DEe)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2bD5240967ea526892CaAeEEA2Dc9A871374e8ec)
 */
export const watchTkoVariableDebtTokenTaikoInitializedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: tkoVariableDebtTokenTaikoAbi,
    address: tkoVariableDebtTokenTaikoAddress,
    eventName: 'Initialized',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link tkoVariableDebtTokenTaikoAbi}__ and `eventName` set to `"Mint"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x54cE8BA483EE93098f58737f7068181aaa136DEe)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2bD5240967ea526892CaAeEEA2Dc9A871374e8ec)
 */
export const watchTkoVariableDebtTokenTaikoMintEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: tkoVariableDebtTokenTaikoAbi,
    address: tkoVariableDebtTokenTaikoAddress,
    eventName: 'Mint',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link tkoVariableDebtTokenTaikoAbi}__ and `eventName` set to `"Transfer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x54cE8BA483EE93098f58737f7068181aaa136DEe)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2bD5240967ea526892CaAeEEA2Dc9A871374e8ec)
 */
export const watchTkoVariableDebtTokenTaikoTransferEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: tkoVariableDebtTokenTaikoAbi,
    address: tkoVariableDebtTokenTaikoAddress,
    eventName: 'Transfer',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link treasuryControllerAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xcEdBa84E998e1A6b5Fd3F3539FE43475bAa2a068)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x919E20cE5949a7106e06F34aE9eAAF1fc32E658a)
 */
export const readTreasuryController = /*#__PURE__*/ createReadContract({
  abi: treasuryControllerAbi,
  address: treasuryControllerAddress,
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link treasuryControllerAbi}__ and `functionName` set to `"owner"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xcEdBa84E998e1A6b5Fd3F3539FE43475bAa2a068)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x919E20cE5949a7106e06F34aE9eAAF1fc32E658a)
 */
export const readTreasuryControllerOwner = /*#__PURE__*/ createReadContract({
  abi: treasuryControllerAbi,
  address: treasuryControllerAddress,
  functionName: 'owner',
})

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link treasuryControllerAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xcEdBa84E998e1A6b5Fd3F3539FE43475bAa2a068)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x919E20cE5949a7106e06F34aE9eAAF1fc32E658a)
 */
export const writeTreasuryController = /*#__PURE__*/ createWriteContract({
  abi: treasuryControllerAbi,
  address: treasuryControllerAddress,
})

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link treasuryControllerAbi}__ and `functionName` set to `"approve"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xcEdBa84E998e1A6b5Fd3F3539FE43475bAa2a068)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x919E20cE5949a7106e06F34aE9eAAF1fc32E658a)
 */
export const writeTreasuryControllerApprove = /*#__PURE__*/ createWriteContract(
  {
    abi: treasuryControllerAbi,
    address: treasuryControllerAddress,
    functionName: 'approve',
  },
)

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link treasuryControllerAbi}__ and `functionName` set to `"cancelStream"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xcEdBa84E998e1A6b5Fd3F3539FE43475bAa2a068)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x919E20cE5949a7106e06F34aE9eAAF1fc32E658a)
 */
export const writeTreasuryControllerCancelStream =
  /*#__PURE__*/ createWriteContract({
    abi: treasuryControllerAbi,
    address: treasuryControllerAddress,
    functionName: 'cancelStream',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link treasuryControllerAbi}__ and `functionName` set to `"createStream"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xcEdBa84E998e1A6b5Fd3F3539FE43475bAa2a068)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x919E20cE5949a7106e06F34aE9eAAF1fc32E658a)
 */
export const writeTreasuryControllerCreateStream =
  /*#__PURE__*/ createWriteContract({
    abi: treasuryControllerAbi,
    address: treasuryControllerAddress,
    functionName: 'createStream',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link treasuryControllerAbi}__ and `functionName` set to `"renounceOwnership"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xcEdBa84E998e1A6b5Fd3F3539FE43475bAa2a068)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x919E20cE5949a7106e06F34aE9eAAF1fc32E658a)
 */
export const writeTreasuryControllerRenounceOwnership =
  /*#__PURE__*/ createWriteContract({
    abi: treasuryControllerAbi,
    address: treasuryControllerAddress,
    functionName: 'renounceOwnership',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link treasuryControllerAbi}__ and `functionName` set to `"transfer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xcEdBa84E998e1A6b5Fd3F3539FE43475bAa2a068)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x919E20cE5949a7106e06F34aE9eAAF1fc32E658a)
 */
export const writeTreasuryControllerTransfer =
  /*#__PURE__*/ createWriteContract({
    abi: treasuryControllerAbi,
    address: treasuryControllerAddress,
    functionName: 'transfer',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link treasuryControllerAbi}__ and `functionName` set to `"transferOwnership"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xcEdBa84E998e1A6b5Fd3F3539FE43475bAa2a068)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x919E20cE5949a7106e06F34aE9eAAF1fc32E658a)
 */
export const writeTreasuryControllerTransferOwnership =
  /*#__PURE__*/ createWriteContract({
    abi: treasuryControllerAbi,
    address: treasuryControllerAddress,
    functionName: 'transferOwnership',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link treasuryControllerAbi}__ and `functionName` set to `"withdrawFromStream"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xcEdBa84E998e1A6b5Fd3F3539FE43475bAa2a068)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x919E20cE5949a7106e06F34aE9eAAF1fc32E658a)
 */
export const writeTreasuryControllerWithdrawFromStream =
  /*#__PURE__*/ createWriteContract({
    abi: treasuryControllerAbi,
    address: treasuryControllerAddress,
    functionName: 'withdrawFromStream',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link treasuryControllerAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xcEdBa84E998e1A6b5Fd3F3539FE43475bAa2a068)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x919E20cE5949a7106e06F34aE9eAAF1fc32E658a)
 */
export const simulateTreasuryController = /*#__PURE__*/ createSimulateContract({
  abi: treasuryControllerAbi,
  address: treasuryControllerAddress,
})

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link treasuryControllerAbi}__ and `functionName` set to `"approve"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xcEdBa84E998e1A6b5Fd3F3539FE43475bAa2a068)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x919E20cE5949a7106e06F34aE9eAAF1fc32E658a)
 */
export const simulateTreasuryControllerApprove =
  /*#__PURE__*/ createSimulateContract({
    abi: treasuryControllerAbi,
    address: treasuryControllerAddress,
    functionName: 'approve',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link treasuryControllerAbi}__ and `functionName` set to `"cancelStream"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xcEdBa84E998e1A6b5Fd3F3539FE43475bAa2a068)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x919E20cE5949a7106e06F34aE9eAAF1fc32E658a)
 */
export const simulateTreasuryControllerCancelStream =
  /*#__PURE__*/ createSimulateContract({
    abi: treasuryControllerAbi,
    address: treasuryControllerAddress,
    functionName: 'cancelStream',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link treasuryControllerAbi}__ and `functionName` set to `"createStream"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xcEdBa84E998e1A6b5Fd3F3539FE43475bAa2a068)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x919E20cE5949a7106e06F34aE9eAAF1fc32E658a)
 */
export const simulateTreasuryControllerCreateStream =
  /*#__PURE__*/ createSimulateContract({
    abi: treasuryControllerAbi,
    address: treasuryControllerAddress,
    functionName: 'createStream',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link treasuryControllerAbi}__ and `functionName` set to `"renounceOwnership"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xcEdBa84E998e1A6b5Fd3F3539FE43475bAa2a068)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x919E20cE5949a7106e06F34aE9eAAF1fc32E658a)
 */
export const simulateTreasuryControllerRenounceOwnership =
  /*#__PURE__*/ createSimulateContract({
    abi: treasuryControllerAbi,
    address: treasuryControllerAddress,
    functionName: 'renounceOwnership',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link treasuryControllerAbi}__ and `functionName` set to `"transfer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xcEdBa84E998e1A6b5Fd3F3539FE43475bAa2a068)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x919E20cE5949a7106e06F34aE9eAAF1fc32E658a)
 */
export const simulateTreasuryControllerTransfer =
  /*#__PURE__*/ createSimulateContract({
    abi: treasuryControllerAbi,
    address: treasuryControllerAddress,
    functionName: 'transfer',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link treasuryControllerAbi}__ and `functionName` set to `"transferOwnership"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xcEdBa84E998e1A6b5Fd3F3539FE43475bAa2a068)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x919E20cE5949a7106e06F34aE9eAAF1fc32E658a)
 */
export const simulateTreasuryControllerTransferOwnership =
  /*#__PURE__*/ createSimulateContract({
    abi: treasuryControllerAbi,
    address: treasuryControllerAddress,
    functionName: 'transferOwnership',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link treasuryControllerAbi}__ and `functionName` set to `"withdrawFromStream"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xcEdBa84E998e1A6b5Fd3F3539FE43475bAa2a068)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x919E20cE5949a7106e06F34aE9eAAF1fc32E658a)
 */
export const simulateTreasuryControllerWithdrawFromStream =
  /*#__PURE__*/ createSimulateContract({
    abi: treasuryControllerAbi,
    address: treasuryControllerAddress,
    functionName: 'withdrawFromStream',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link treasuryControllerAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xcEdBa84E998e1A6b5Fd3F3539FE43475bAa2a068)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x919E20cE5949a7106e06F34aE9eAAF1fc32E658a)
 */
export const watchTreasuryControllerEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: treasuryControllerAbi,
    address: treasuryControllerAddress,
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link treasuryControllerAbi}__ and `eventName` set to `"OwnershipTransferred"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xcEdBa84E998e1A6b5Fd3F3539FE43475bAa2a068)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x919E20cE5949a7106e06F34aE9eAAF1fc32E658a)
 */
export const watchTreasuryControllerOwnershipTransferredEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: treasuryControllerAbi,
    address: treasuryControllerAddress,
    eventName: 'OwnershipTransferred',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link treasuryImplementationAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xbC5E4723E7b3C8E9f454C8790919ee637006d630)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x44E02c96bD227500B2a5D999f9313c6957E0B1c9)
 */
export const readTreasuryImplementation = /*#__PURE__*/ createReadContract({
  abi: treasuryImplementationAbi,
  address: treasuryImplementationAddress,
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link treasuryImplementationAbi}__ and `functionName` set to `"ETH_MOCK_ADDRESS"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xbC5E4723E7b3C8E9f454C8790919ee637006d630)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x44E02c96bD227500B2a5D999f9313c6957E0B1c9)
 */
export const readTreasuryImplementationEthMockAddress =
  /*#__PURE__*/ createReadContract({
    abi: treasuryImplementationAbi,
    address: treasuryImplementationAddress,
    functionName: 'ETH_MOCK_ADDRESS',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link treasuryImplementationAbi}__ and `functionName` set to `"REVISION"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xbC5E4723E7b3C8E9f454C8790919ee637006d630)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x44E02c96bD227500B2a5D999f9313c6957E0B1c9)
 */
export const readTreasuryImplementationRevision =
  /*#__PURE__*/ createReadContract({
    abi: treasuryImplementationAbi,
    address: treasuryImplementationAddress,
    functionName: 'REVISION',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link treasuryImplementationAbi}__ and `functionName` set to `"balanceOf"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xbC5E4723E7b3C8E9f454C8790919ee637006d630)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x44E02c96bD227500B2a5D999f9313c6957E0B1c9)
 */
export const readTreasuryImplementationBalanceOf =
  /*#__PURE__*/ createReadContract({
    abi: treasuryImplementationAbi,
    address: treasuryImplementationAddress,
    functionName: 'balanceOf',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link treasuryImplementationAbi}__ and `functionName` set to `"deltaOf"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xbC5E4723E7b3C8E9f454C8790919ee637006d630)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x44E02c96bD227500B2a5D999f9313c6957E0B1c9)
 */
export const readTreasuryImplementationDeltaOf =
  /*#__PURE__*/ createReadContract({
    abi: treasuryImplementationAbi,
    address: treasuryImplementationAddress,
    functionName: 'deltaOf',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link treasuryImplementationAbi}__ and `functionName` set to `"getFundsAdmin"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xbC5E4723E7b3C8E9f454C8790919ee637006d630)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x44E02c96bD227500B2a5D999f9313c6957E0B1c9)
 */
export const readTreasuryImplementationGetFundsAdmin =
  /*#__PURE__*/ createReadContract({
    abi: treasuryImplementationAbi,
    address: treasuryImplementationAddress,
    functionName: 'getFundsAdmin',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link treasuryImplementationAbi}__ and `functionName` set to `"getNextStreamId"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xbC5E4723E7b3C8E9f454C8790919ee637006d630)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x44E02c96bD227500B2a5D999f9313c6957E0B1c9)
 */
export const readTreasuryImplementationGetNextStreamId =
  /*#__PURE__*/ createReadContract({
    abi: treasuryImplementationAbi,
    address: treasuryImplementationAddress,
    functionName: 'getNextStreamId',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link treasuryImplementationAbi}__ and `functionName` set to `"getStream"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xbC5E4723E7b3C8E9f454C8790919ee637006d630)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x44E02c96bD227500B2a5D999f9313c6957E0B1c9)
 */
export const readTreasuryImplementationGetStream =
  /*#__PURE__*/ createReadContract({
    abi: treasuryImplementationAbi,
    address: treasuryImplementationAddress,
    functionName: 'getStream',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link treasuryImplementationAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xbC5E4723E7b3C8E9f454C8790919ee637006d630)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x44E02c96bD227500B2a5D999f9313c6957E0B1c9)
 */
export const writeTreasuryImplementation = /*#__PURE__*/ createWriteContract({
  abi: treasuryImplementationAbi,
  address: treasuryImplementationAddress,
})

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link treasuryImplementationAbi}__ and `functionName` set to `"approve"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xbC5E4723E7b3C8E9f454C8790919ee637006d630)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x44E02c96bD227500B2a5D999f9313c6957E0B1c9)
 */
export const writeTreasuryImplementationApprove =
  /*#__PURE__*/ createWriteContract({
    abi: treasuryImplementationAbi,
    address: treasuryImplementationAddress,
    functionName: 'approve',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link treasuryImplementationAbi}__ and `functionName` set to `"cancelStream"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xbC5E4723E7b3C8E9f454C8790919ee637006d630)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x44E02c96bD227500B2a5D999f9313c6957E0B1c9)
 */
export const writeTreasuryImplementationCancelStream =
  /*#__PURE__*/ createWriteContract({
    abi: treasuryImplementationAbi,
    address: treasuryImplementationAddress,
    functionName: 'cancelStream',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link treasuryImplementationAbi}__ and `functionName` set to `"createStream"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xbC5E4723E7b3C8E9f454C8790919ee637006d630)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x44E02c96bD227500B2a5D999f9313c6957E0B1c9)
 */
export const writeTreasuryImplementationCreateStream =
  /*#__PURE__*/ createWriteContract({
    abi: treasuryImplementationAbi,
    address: treasuryImplementationAddress,
    functionName: 'createStream',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link treasuryImplementationAbi}__ and `functionName` set to `"initialize"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xbC5E4723E7b3C8E9f454C8790919ee637006d630)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x44E02c96bD227500B2a5D999f9313c6957E0B1c9)
 */
export const writeTreasuryImplementationInitialize =
  /*#__PURE__*/ createWriteContract({
    abi: treasuryImplementationAbi,
    address: treasuryImplementationAddress,
    functionName: 'initialize',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link treasuryImplementationAbi}__ and `functionName` set to `"transfer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xbC5E4723E7b3C8E9f454C8790919ee637006d630)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x44E02c96bD227500B2a5D999f9313c6957E0B1c9)
 */
export const writeTreasuryImplementationTransfer =
  /*#__PURE__*/ createWriteContract({
    abi: treasuryImplementationAbi,
    address: treasuryImplementationAddress,
    functionName: 'transfer',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link treasuryImplementationAbi}__ and `functionName` set to `"withdrawFromStream"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xbC5E4723E7b3C8E9f454C8790919ee637006d630)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x44E02c96bD227500B2a5D999f9313c6957E0B1c9)
 */
export const writeTreasuryImplementationWithdrawFromStream =
  /*#__PURE__*/ createWriteContract({
    abi: treasuryImplementationAbi,
    address: treasuryImplementationAddress,
    functionName: 'withdrawFromStream',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link treasuryImplementationAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xbC5E4723E7b3C8E9f454C8790919ee637006d630)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x44E02c96bD227500B2a5D999f9313c6957E0B1c9)
 */
export const simulateTreasuryImplementation =
  /*#__PURE__*/ createSimulateContract({
    abi: treasuryImplementationAbi,
    address: treasuryImplementationAddress,
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link treasuryImplementationAbi}__ and `functionName` set to `"approve"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xbC5E4723E7b3C8E9f454C8790919ee637006d630)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x44E02c96bD227500B2a5D999f9313c6957E0B1c9)
 */
export const simulateTreasuryImplementationApprove =
  /*#__PURE__*/ createSimulateContract({
    abi: treasuryImplementationAbi,
    address: treasuryImplementationAddress,
    functionName: 'approve',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link treasuryImplementationAbi}__ and `functionName` set to `"cancelStream"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xbC5E4723E7b3C8E9f454C8790919ee637006d630)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x44E02c96bD227500B2a5D999f9313c6957E0B1c9)
 */
export const simulateTreasuryImplementationCancelStream =
  /*#__PURE__*/ createSimulateContract({
    abi: treasuryImplementationAbi,
    address: treasuryImplementationAddress,
    functionName: 'cancelStream',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link treasuryImplementationAbi}__ and `functionName` set to `"createStream"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xbC5E4723E7b3C8E9f454C8790919ee637006d630)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x44E02c96bD227500B2a5D999f9313c6957E0B1c9)
 */
export const simulateTreasuryImplementationCreateStream =
  /*#__PURE__*/ createSimulateContract({
    abi: treasuryImplementationAbi,
    address: treasuryImplementationAddress,
    functionName: 'createStream',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link treasuryImplementationAbi}__ and `functionName` set to `"initialize"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xbC5E4723E7b3C8E9f454C8790919ee637006d630)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x44E02c96bD227500B2a5D999f9313c6957E0B1c9)
 */
export const simulateTreasuryImplementationInitialize =
  /*#__PURE__*/ createSimulateContract({
    abi: treasuryImplementationAbi,
    address: treasuryImplementationAddress,
    functionName: 'initialize',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link treasuryImplementationAbi}__ and `functionName` set to `"transfer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xbC5E4723E7b3C8E9f454C8790919ee637006d630)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x44E02c96bD227500B2a5D999f9313c6957E0B1c9)
 */
export const simulateTreasuryImplementationTransfer =
  /*#__PURE__*/ createSimulateContract({
    abi: treasuryImplementationAbi,
    address: treasuryImplementationAddress,
    functionName: 'transfer',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link treasuryImplementationAbi}__ and `functionName` set to `"withdrawFromStream"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xbC5E4723E7b3C8E9f454C8790919ee637006d630)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x44E02c96bD227500B2a5D999f9313c6957E0B1c9)
 */
export const simulateTreasuryImplementationWithdrawFromStream =
  /*#__PURE__*/ createSimulateContract({
    abi: treasuryImplementationAbi,
    address: treasuryImplementationAddress,
    functionName: 'withdrawFromStream',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link treasuryImplementationAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xbC5E4723E7b3C8E9f454C8790919ee637006d630)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x44E02c96bD227500B2a5D999f9313c6957E0B1c9)
 */
export const watchTreasuryImplementationEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: treasuryImplementationAbi,
    address: treasuryImplementationAddress,
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link treasuryImplementationAbi}__ and `eventName` set to `"CancelStream"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xbC5E4723E7b3C8E9f454C8790919ee637006d630)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x44E02c96bD227500B2a5D999f9313c6957E0B1c9)
 */
export const watchTreasuryImplementationCancelStreamEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: treasuryImplementationAbi,
    address: treasuryImplementationAddress,
    eventName: 'CancelStream',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link treasuryImplementationAbi}__ and `eventName` set to `"CreateStream"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xbC5E4723E7b3C8E9f454C8790919ee637006d630)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x44E02c96bD227500B2a5D999f9313c6957E0B1c9)
 */
export const watchTreasuryImplementationCreateStreamEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: treasuryImplementationAbi,
    address: treasuryImplementationAddress,
    eventName: 'CreateStream',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link treasuryImplementationAbi}__ and `eventName` set to `"NewFundsAdmin"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xbC5E4723E7b3C8E9f454C8790919ee637006d630)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x44E02c96bD227500B2a5D999f9313c6957E0B1c9)
 */
export const watchTreasuryImplementationNewFundsAdminEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: treasuryImplementationAbi,
    address: treasuryImplementationAddress,
    eventName: 'NewFundsAdmin',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link treasuryImplementationAbi}__ and `eventName` set to `"WithdrawFromStream"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xbC5E4723E7b3C8E9f454C8790919ee637006d630)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x44E02c96bD227500B2a5D999f9313c6957E0B1c9)
 */
export const watchTreasuryImplementationWithdrawFromStreamEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: treasuryImplementationAbi,
    address: treasuryImplementationAddress,
    eventName: 'WithdrawFromStream',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link treasuryProxyAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x262EF110b0537459d39c476857Ed72634193bf14)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2bcD314Ce1D4aBAD0F0A17102e15C9FF2eAC5fC2)
 */
export const writeTreasuryProxy = /*#__PURE__*/ createWriteContract({
  abi: treasuryProxyAbi,
  address: treasuryProxyAddress,
})

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link treasuryProxyAbi}__ and `functionName` set to `"admin"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x262EF110b0537459d39c476857Ed72634193bf14)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2bcD314Ce1D4aBAD0F0A17102e15C9FF2eAC5fC2)
 */
export const writeTreasuryProxyAdmin = /*#__PURE__*/ createWriteContract({
  abi: treasuryProxyAbi,
  address: treasuryProxyAddress,
  functionName: 'admin',
})

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link treasuryProxyAbi}__ and `functionName` set to `"changeAdmin"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x262EF110b0537459d39c476857Ed72634193bf14)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2bcD314Ce1D4aBAD0F0A17102e15C9FF2eAC5fC2)
 */
export const writeTreasuryProxyChangeAdmin = /*#__PURE__*/ createWriteContract({
  abi: treasuryProxyAbi,
  address: treasuryProxyAddress,
  functionName: 'changeAdmin',
})

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link treasuryProxyAbi}__ and `functionName` set to `"implementation"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x262EF110b0537459d39c476857Ed72634193bf14)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2bcD314Ce1D4aBAD0F0A17102e15C9FF2eAC5fC2)
 */
export const writeTreasuryProxyImplementation =
  /*#__PURE__*/ createWriteContract({
    abi: treasuryProxyAbi,
    address: treasuryProxyAddress,
    functionName: 'implementation',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link treasuryProxyAbi}__ and `functionName` set to `"initialize"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x262EF110b0537459d39c476857Ed72634193bf14)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2bcD314Ce1D4aBAD0F0A17102e15C9FF2eAC5fC2)
 */
export const writeTreasuryProxyInitialize = /*#__PURE__*/ createWriteContract({
  abi: treasuryProxyAbi,
  address: treasuryProxyAddress,
  functionName: 'initialize',
})

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link treasuryProxyAbi}__ and `functionName` set to `"upgradeTo"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x262EF110b0537459d39c476857Ed72634193bf14)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2bcD314Ce1D4aBAD0F0A17102e15C9FF2eAC5fC2)
 */
export const writeTreasuryProxyUpgradeTo = /*#__PURE__*/ createWriteContract({
  abi: treasuryProxyAbi,
  address: treasuryProxyAddress,
  functionName: 'upgradeTo',
})

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link treasuryProxyAbi}__ and `functionName` set to `"upgradeToAndCall"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x262EF110b0537459d39c476857Ed72634193bf14)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2bcD314Ce1D4aBAD0F0A17102e15C9FF2eAC5fC2)
 */
export const writeTreasuryProxyUpgradeToAndCall =
  /*#__PURE__*/ createWriteContract({
    abi: treasuryProxyAbi,
    address: treasuryProxyAddress,
    functionName: 'upgradeToAndCall',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link treasuryProxyAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x262EF110b0537459d39c476857Ed72634193bf14)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2bcD314Ce1D4aBAD0F0A17102e15C9FF2eAC5fC2)
 */
export const simulateTreasuryProxy = /*#__PURE__*/ createSimulateContract({
  abi: treasuryProxyAbi,
  address: treasuryProxyAddress,
})

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link treasuryProxyAbi}__ and `functionName` set to `"admin"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x262EF110b0537459d39c476857Ed72634193bf14)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2bcD314Ce1D4aBAD0F0A17102e15C9FF2eAC5fC2)
 */
export const simulateTreasuryProxyAdmin = /*#__PURE__*/ createSimulateContract({
  abi: treasuryProxyAbi,
  address: treasuryProxyAddress,
  functionName: 'admin',
})

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link treasuryProxyAbi}__ and `functionName` set to `"changeAdmin"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x262EF110b0537459d39c476857Ed72634193bf14)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2bcD314Ce1D4aBAD0F0A17102e15C9FF2eAC5fC2)
 */
export const simulateTreasuryProxyChangeAdmin =
  /*#__PURE__*/ createSimulateContract({
    abi: treasuryProxyAbi,
    address: treasuryProxyAddress,
    functionName: 'changeAdmin',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link treasuryProxyAbi}__ and `functionName` set to `"implementation"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x262EF110b0537459d39c476857Ed72634193bf14)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2bcD314Ce1D4aBAD0F0A17102e15C9FF2eAC5fC2)
 */
export const simulateTreasuryProxyImplementation =
  /*#__PURE__*/ createSimulateContract({
    abi: treasuryProxyAbi,
    address: treasuryProxyAddress,
    functionName: 'implementation',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link treasuryProxyAbi}__ and `functionName` set to `"initialize"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x262EF110b0537459d39c476857Ed72634193bf14)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2bcD314Ce1D4aBAD0F0A17102e15C9FF2eAC5fC2)
 */
export const simulateTreasuryProxyInitialize =
  /*#__PURE__*/ createSimulateContract({
    abi: treasuryProxyAbi,
    address: treasuryProxyAddress,
    functionName: 'initialize',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link treasuryProxyAbi}__ and `functionName` set to `"upgradeTo"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x262EF110b0537459d39c476857Ed72634193bf14)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2bcD314Ce1D4aBAD0F0A17102e15C9FF2eAC5fC2)
 */
export const simulateTreasuryProxyUpgradeTo =
  /*#__PURE__*/ createSimulateContract({
    abi: treasuryProxyAbi,
    address: treasuryProxyAddress,
    functionName: 'upgradeTo',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link treasuryProxyAbi}__ and `functionName` set to `"upgradeToAndCall"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x262EF110b0537459d39c476857Ed72634193bf14)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2bcD314Ce1D4aBAD0F0A17102e15C9FF2eAC5fC2)
 */
export const simulateTreasuryProxyUpgradeToAndCall =
  /*#__PURE__*/ createSimulateContract({
    abi: treasuryProxyAbi,
    address: treasuryProxyAddress,
    functionName: 'upgradeToAndCall',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link treasuryProxyAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x262EF110b0537459d39c476857Ed72634193bf14)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2bcD314Ce1D4aBAD0F0A17102e15C9FF2eAC5fC2)
 */
export const watchTreasuryProxyEvent = /*#__PURE__*/ createWatchContractEvent({
  abi: treasuryProxyAbi,
  address: treasuryProxyAddress,
})

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link treasuryProxyAbi}__ and `eventName` set to `"AdminChanged"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x262EF110b0537459d39c476857Ed72634193bf14)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2bcD314Ce1D4aBAD0F0A17102e15C9FF2eAC5fC2)
 */
export const watchTreasuryProxyAdminChangedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: treasuryProxyAbi,
    address: treasuryProxyAddress,
    eventName: 'AdminChanged',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link treasuryProxyAbi}__ and `eventName` set to `"Upgraded"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x262EF110b0537459d39c476857Ed72634193bf14)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2bcD314Ce1D4aBAD0F0A17102e15C9FF2eAC5fC2)
 */
export const watchTreasuryProxyUpgradedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: treasuryProxyAbi,
    address: treasuryProxyAddress,
    eventName: 'Upgraded',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdcATokenTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa1741a827c35250c437187406fDe16d3581232e6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeC0B304fB75eEf2d83305070e14E4ed914E4FCe0)
 */
export const readUsdcATokenTaiko = /*#__PURE__*/ createReadContract({
  abi: usdcATokenTaikoAbi,
  address: usdcATokenTaikoAddress,
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdcATokenTaikoAbi}__ and `functionName` set to `"ATOKEN_REVISION"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa1741a827c35250c437187406fDe16d3581232e6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeC0B304fB75eEf2d83305070e14E4ed914E4FCe0)
 */
export const readUsdcATokenTaikoAtokenRevision =
  /*#__PURE__*/ createReadContract({
    abi: usdcATokenTaikoAbi,
    address: usdcATokenTaikoAddress,
    functionName: 'ATOKEN_REVISION',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdcATokenTaikoAbi}__ and `functionName` set to `"DOMAIN_SEPARATOR"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa1741a827c35250c437187406fDe16d3581232e6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeC0B304fB75eEf2d83305070e14E4ed914E4FCe0)
 */
export const readUsdcATokenTaikoDomainSeparator =
  /*#__PURE__*/ createReadContract({
    abi: usdcATokenTaikoAbi,
    address: usdcATokenTaikoAddress,
    functionName: 'DOMAIN_SEPARATOR',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdcATokenTaikoAbi}__ and `functionName` set to `"EIP712_REVISION"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa1741a827c35250c437187406fDe16d3581232e6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeC0B304fB75eEf2d83305070e14E4ed914E4FCe0)
 */
export const readUsdcATokenTaikoEip712Revision =
  /*#__PURE__*/ createReadContract({
    abi: usdcATokenTaikoAbi,
    address: usdcATokenTaikoAddress,
    functionName: 'EIP712_REVISION',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdcATokenTaikoAbi}__ and `functionName` set to `"PERMIT_TYPEHASH"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa1741a827c35250c437187406fDe16d3581232e6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeC0B304fB75eEf2d83305070e14E4ed914E4FCe0)
 */
export const readUsdcATokenTaikoPermitTypehash =
  /*#__PURE__*/ createReadContract({
    abi: usdcATokenTaikoAbi,
    address: usdcATokenTaikoAddress,
    functionName: 'PERMIT_TYPEHASH',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdcATokenTaikoAbi}__ and `functionName` set to `"POOL"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa1741a827c35250c437187406fDe16d3581232e6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeC0B304fB75eEf2d83305070e14E4ed914E4FCe0)
 */
export const readUsdcATokenTaikoPool = /*#__PURE__*/ createReadContract({
  abi: usdcATokenTaikoAbi,
  address: usdcATokenTaikoAddress,
  functionName: 'POOL',
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdcATokenTaikoAbi}__ and `functionName` set to `"RESERVE_TREASURY_ADDRESS"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa1741a827c35250c437187406fDe16d3581232e6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeC0B304fB75eEf2d83305070e14E4ed914E4FCe0)
 */
export const readUsdcATokenTaikoReserveTreasuryAddress =
  /*#__PURE__*/ createReadContract({
    abi: usdcATokenTaikoAbi,
    address: usdcATokenTaikoAddress,
    functionName: 'RESERVE_TREASURY_ADDRESS',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdcATokenTaikoAbi}__ and `functionName` set to `"UNDERLYING_ASSET_ADDRESS"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa1741a827c35250c437187406fDe16d3581232e6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeC0B304fB75eEf2d83305070e14E4ed914E4FCe0)
 */
export const readUsdcATokenTaikoUnderlyingAssetAddress =
  /*#__PURE__*/ createReadContract({
    abi: usdcATokenTaikoAbi,
    address: usdcATokenTaikoAddress,
    functionName: 'UNDERLYING_ASSET_ADDRESS',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdcATokenTaikoAbi}__ and `functionName` set to `"allowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa1741a827c35250c437187406fDe16d3581232e6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeC0B304fB75eEf2d83305070e14E4ed914E4FCe0)
 */
export const readUsdcATokenTaikoAllowance = /*#__PURE__*/ createReadContract({
  abi: usdcATokenTaikoAbi,
  address: usdcATokenTaikoAddress,
  functionName: 'allowance',
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdcATokenTaikoAbi}__ and `functionName` set to `"balanceOf"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa1741a827c35250c437187406fDe16d3581232e6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeC0B304fB75eEf2d83305070e14E4ed914E4FCe0)
 */
export const readUsdcATokenTaikoBalanceOf = /*#__PURE__*/ createReadContract({
  abi: usdcATokenTaikoAbi,
  address: usdcATokenTaikoAddress,
  functionName: 'balanceOf',
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdcATokenTaikoAbi}__ and `functionName` set to `"decimals"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa1741a827c35250c437187406fDe16d3581232e6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeC0B304fB75eEf2d83305070e14E4ed914E4FCe0)
 */
export const readUsdcATokenTaikoDecimals = /*#__PURE__*/ createReadContract({
  abi: usdcATokenTaikoAbi,
  address: usdcATokenTaikoAddress,
  functionName: 'decimals',
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdcATokenTaikoAbi}__ and `functionName` set to `"getIncentivesController"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa1741a827c35250c437187406fDe16d3581232e6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeC0B304fB75eEf2d83305070e14E4ed914E4FCe0)
 */
export const readUsdcATokenTaikoGetIncentivesController =
  /*#__PURE__*/ createReadContract({
    abi: usdcATokenTaikoAbi,
    address: usdcATokenTaikoAddress,
    functionName: 'getIncentivesController',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdcATokenTaikoAbi}__ and `functionName` set to `"getPreviousIndex"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa1741a827c35250c437187406fDe16d3581232e6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeC0B304fB75eEf2d83305070e14E4ed914E4FCe0)
 */
export const readUsdcATokenTaikoGetPreviousIndex =
  /*#__PURE__*/ createReadContract({
    abi: usdcATokenTaikoAbi,
    address: usdcATokenTaikoAddress,
    functionName: 'getPreviousIndex',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdcATokenTaikoAbi}__ and `functionName` set to `"getScaledUserBalanceAndSupply"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa1741a827c35250c437187406fDe16d3581232e6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeC0B304fB75eEf2d83305070e14E4ed914E4FCe0)
 */
export const readUsdcATokenTaikoGetScaledUserBalanceAndSupply =
  /*#__PURE__*/ createReadContract({
    abi: usdcATokenTaikoAbi,
    address: usdcATokenTaikoAddress,
    functionName: 'getScaledUserBalanceAndSupply',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdcATokenTaikoAbi}__ and `functionName` set to `"name"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa1741a827c35250c437187406fDe16d3581232e6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeC0B304fB75eEf2d83305070e14E4ed914E4FCe0)
 */
export const readUsdcATokenTaikoName = /*#__PURE__*/ createReadContract({
  abi: usdcATokenTaikoAbi,
  address: usdcATokenTaikoAddress,
  functionName: 'name',
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdcATokenTaikoAbi}__ and `functionName` set to `"nonces"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa1741a827c35250c437187406fDe16d3581232e6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeC0B304fB75eEf2d83305070e14E4ed914E4FCe0)
 */
export const readUsdcATokenTaikoNonces = /*#__PURE__*/ createReadContract({
  abi: usdcATokenTaikoAbi,
  address: usdcATokenTaikoAddress,
  functionName: 'nonces',
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdcATokenTaikoAbi}__ and `functionName` set to `"scaledBalanceOf"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa1741a827c35250c437187406fDe16d3581232e6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeC0B304fB75eEf2d83305070e14E4ed914E4FCe0)
 */
export const readUsdcATokenTaikoScaledBalanceOf =
  /*#__PURE__*/ createReadContract({
    abi: usdcATokenTaikoAbi,
    address: usdcATokenTaikoAddress,
    functionName: 'scaledBalanceOf',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdcATokenTaikoAbi}__ and `functionName` set to `"scaledTotalSupply"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa1741a827c35250c437187406fDe16d3581232e6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeC0B304fB75eEf2d83305070e14E4ed914E4FCe0)
 */
export const readUsdcATokenTaikoScaledTotalSupply =
  /*#__PURE__*/ createReadContract({
    abi: usdcATokenTaikoAbi,
    address: usdcATokenTaikoAddress,
    functionName: 'scaledTotalSupply',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdcATokenTaikoAbi}__ and `functionName` set to `"symbol"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa1741a827c35250c437187406fDe16d3581232e6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeC0B304fB75eEf2d83305070e14E4ed914E4FCe0)
 */
export const readUsdcATokenTaikoSymbol = /*#__PURE__*/ createReadContract({
  abi: usdcATokenTaikoAbi,
  address: usdcATokenTaikoAddress,
  functionName: 'symbol',
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdcATokenTaikoAbi}__ and `functionName` set to `"totalSupply"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa1741a827c35250c437187406fDe16d3581232e6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeC0B304fB75eEf2d83305070e14E4ed914E4FCe0)
 */
export const readUsdcATokenTaikoTotalSupply = /*#__PURE__*/ createReadContract({
  abi: usdcATokenTaikoAbi,
  address: usdcATokenTaikoAddress,
  functionName: 'totalSupply',
})

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link usdcATokenTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa1741a827c35250c437187406fDe16d3581232e6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeC0B304fB75eEf2d83305070e14E4ed914E4FCe0)
 */
export const writeUsdcATokenTaiko = /*#__PURE__*/ createWriteContract({
  abi: usdcATokenTaikoAbi,
  address: usdcATokenTaikoAddress,
})

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link usdcATokenTaikoAbi}__ and `functionName` set to `"approve"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa1741a827c35250c437187406fDe16d3581232e6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeC0B304fB75eEf2d83305070e14E4ed914E4FCe0)
 */
export const writeUsdcATokenTaikoApprove = /*#__PURE__*/ createWriteContract({
  abi: usdcATokenTaikoAbi,
  address: usdcATokenTaikoAddress,
  functionName: 'approve',
})

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link usdcATokenTaikoAbi}__ and `functionName` set to `"burn"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa1741a827c35250c437187406fDe16d3581232e6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeC0B304fB75eEf2d83305070e14E4ed914E4FCe0)
 */
export const writeUsdcATokenTaikoBurn = /*#__PURE__*/ createWriteContract({
  abi: usdcATokenTaikoAbi,
  address: usdcATokenTaikoAddress,
  functionName: 'burn',
})

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link usdcATokenTaikoAbi}__ and `functionName` set to `"decreaseAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa1741a827c35250c437187406fDe16d3581232e6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeC0B304fB75eEf2d83305070e14E4ed914E4FCe0)
 */
export const writeUsdcATokenTaikoDecreaseAllowance =
  /*#__PURE__*/ createWriteContract({
    abi: usdcATokenTaikoAbi,
    address: usdcATokenTaikoAddress,
    functionName: 'decreaseAllowance',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link usdcATokenTaikoAbi}__ and `functionName` set to `"handleRepayment"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa1741a827c35250c437187406fDe16d3581232e6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeC0B304fB75eEf2d83305070e14E4ed914E4FCe0)
 */
export const writeUsdcATokenTaikoHandleRepayment =
  /*#__PURE__*/ createWriteContract({
    abi: usdcATokenTaikoAbi,
    address: usdcATokenTaikoAddress,
    functionName: 'handleRepayment',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link usdcATokenTaikoAbi}__ and `functionName` set to `"increaseAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa1741a827c35250c437187406fDe16d3581232e6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeC0B304fB75eEf2d83305070e14E4ed914E4FCe0)
 */
export const writeUsdcATokenTaikoIncreaseAllowance =
  /*#__PURE__*/ createWriteContract({
    abi: usdcATokenTaikoAbi,
    address: usdcATokenTaikoAddress,
    functionName: 'increaseAllowance',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link usdcATokenTaikoAbi}__ and `functionName` set to `"initialize"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa1741a827c35250c437187406fDe16d3581232e6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeC0B304fB75eEf2d83305070e14E4ed914E4FCe0)
 */
export const writeUsdcATokenTaikoInitialize = /*#__PURE__*/ createWriteContract(
  {
    abi: usdcATokenTaikoAbi,
    address: usdcATokenTaikoAddress,
    functionName: 'initialize',
  },
)

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link usdcATokenTaikoAbi}__ and `functionName` set to `"mint"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa1741a827c35250c437187406fDe16d3581232e6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeC0B304fB75eEf2d83305070e14E4ed914E4FCe0)
 */
export const writeUsdcATokenTaikoMint = /*#__PURE__*/ createWriteContract({
  abi: usdcATokenTaikoAbi,
  address: usdcATokenTaikoAddress,
  functionName: 'mint',
})

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link usdcATokenTaikoAbi}__ and `functionName` set to `"mintToTreasury"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa1741a827c35250c437187406fDe16d3581232e6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeC0B304fB75eEf2d83305070e14E4ed914E4FCe0)
 */
export const writeUsdcATokenTaikoMintToTreasury =
  /*#__PURE__*/ createWriteContract({
    abi: usdcATokenTaikoAbi,
    address: usdcATokenTaikoAddress,
    functionName: 'mintToTreasury',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link usdcATokenTaikoAbi}__ and `functionName` set to `"permit"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa1741a827c35250c437187406fDe16d3581232e6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeC0B304fB75eEf2d83305070e14E4ed914E4FCe0)
 */
export const writeUsdcATokenTaikoPermit = /*#__PURE__*/ createWriteContract({
  abi: usdcATokenTaikoAbi,
  address: usdcATokenTaikoAddress,
  functionName: 'permit',
})

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link usdcATokenTaikoAbi}__ and `functionName` set to `"rescueTokens"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa1741a827c35250c437187406fDe16d3581232e6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeC0B304fB75eEf2d83305070e14E4ed914E4FCe0)
 */
export const writeUsdcATokenTaikoRescueTokens =
  /*#__PURE__*/ createWriteContract({
    abi: usdcATokenTaikoAbi,
    address: usdcATokenTaikoAddress,
    functionName: 'rescueTokens',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link usdcATokenTaikoAbi}__ and `functionName` set to `"setIncentivesController"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa1741a827c35250c437187406fDe16d3581232e6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeC0B304fB75eEf2d83305070e14E4ed914E4FCe0)
 */
export const writeUsdcATokenTaikoSetIncentivesController =
  /*#__PURE__*/ createWriteContract({
    abi: usdcATokenTaikoAbi,
    address: usdcATokenTaikoAddress,
    functionName: 'setIncentivesController',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link usdcATokenTaikoAbi}__ and `functionName` set to `"transfer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa1741a827c35250c437187406fDe16d3581232e6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeC0B304fB75eEf2d83305070e14E4ed914E4FCe0)
 */
export const writeUsdcATokenTaikoTransfer = /*#__PURE__*/ createWriteContract({
  abi: usdcATokenTaikoAbi,
  address: usdcATokenTaikoAddress,
  functionName: 'transfer',
})

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link usdcATokenTaikoAbi}__ and `functionName` set to `"transferFrom"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa1741a827c35250c437187406fDe16d3581232e6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeC0B304fB75eEf2d83305070e14E4ed914E4FCe0)
 */
export const writeUsdcATokenTaikoTransferFrom =
  /*#__PURE__*/ createWriteContract({
    abi: usdcATokenTaikoAbi,
    address: usdcATokenTaikoAddress,
    functionName: 'transferFrom',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link usdcATokenTaikoAbi}__ and `functionName` set to `"transferOnLiquidation"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa1741a827c35250c437187406fDe16d3581232e6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeC0B304fB75eEf2d83305070e14E4ed914E4FCe0)
 */
export const writeUsdcATokenTaikoTransferOnLiquidation =
  /*#__PURE__*/ createWriteContract({
    abi: usdcATokenTaikoAbi,
    address: usdcATokenTaikoAddress,
    functionName: 'transferOnLiquidation',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link usdcATokenTaikoAbi}__ and `functionName` set to `"transferUnderlyingTo"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa1741a827c35250c437187406fDe16d3581232e6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeC0B304fB75eEf2d83305070e14E4ed914E4FCe0)
 */
export const writeUsdcATokenTaikoTransferUnderlyingTo =
  /*#__PURE__*/ createWriteContract({
    abi: usdcATokenTaikoAbi,
    address: usdcATokenTaikoAddress,
    functionName: 'transferUnderlyingTo',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link usdcATokenTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa1741a827c35250c437187406fDe16d3581232e6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeC0B304fB75eEf2d83305070e14E4ed914E4FCe0)
 */
export const simulateUsdcATokenTaiko = /*#__PURE__*/ createSimulateContract({
  abi: usdcATokenTaikoAbi,
  address: usdcATokenTaikoAddress,
})

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link usdcATokenTaikoAbi}__ and `functionName` set to `"approve"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa1741a827c35250c437187406fDe16d3581232e6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeC0B304fB75eEf2d83305070e14E4ed914E4FCe0)
 */
export const simulateUsdcATokenTaikoApprove =
  /*#__PURE__*/ createSimulateContract({
    abi: usdcATokenTaikoAbi,
    address: usdcATokenTaikoAddress,
    functionName: 'approve',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link usdcATokenTaikoAbi}__ and `functionName` set to `"burn"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa1741a827c35250c437187406fDe16d3581232e6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeC0B304fB75eEf2d83305070e14E4ed914E4FCe0)
 */
export const simulateUsdcATokenTaikoBurn = /*#__PURE__*/ createSimulateContract(
  {
    abi: usdcATokenTaikoAbi,
    address: usdcATokenTaikoAddress,
    functionName: 'burn',
  },
)

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link usdcATokenTaikoAbi}__ and `functionName` set to `"decreaseAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa1741a827c35250c437187406fDe16d3581232e6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeC0B304fB75eEf2d83305070e14E4ed914E4FCe0)
 */
export const simulateUsdcATokenTaikoDecreaseAllowance =
  /*#__PURE__*/ createSimulateContract({
    abi: usdcATokenTaikoAbi,
    address: usdcATokenTaikoAddress,
    functionName: 'decreaseAllowance',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link usdcATokenTaikoAbi}__ and `functionName` set to `"handleRepayment"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa1741a827c35250c437187406fDe16d3581232e6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeC0B304fB75eEf2d83305070e14E4ed914E4FCe0)
 */
export const simulateUsdcATokenTaikoHandleRepayment =
  /*#__PURE__*/ createSimulateContract({
    abi: usdcATokenTaikoAbi,
    address: usdcATokenTaikoAddress,
    functionName: 'handleRepayment',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link usdcATokenTaikoAbi}__ and `functionName` set to `"increaseAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa1741a827c35250c437187406fDe16d3581232e6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeC0B304fB75eEf2d83305070e14E4ed914E4FCe0)
 */
export const simulateUsdcATokenTaikoIncreaseAllowance =
  /*#__PURE__*/ createSimulateContract({
    abi: usdcATokenTaikoAbi,
    address: usdcATokenTaikoAddress,
    functionName: 'increaseAllowance',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link usdcATokenTaikoAbi}__ and `functionName` set to `"initialize"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa1741a827c35250c437187406fDe16d3581232e6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeC0B304fB75eEf2d83305070e14E4ed914E4FCe0)
 */
export const simulateUsdcATokenTaikoInitialize =
  /*#__PURE__*/ createSimulateContract({
    abi: usdcATokenTaikoAbi,
    address: usdcATokenTaikoAddress,
    functionName: 'initialize',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link usdcATokenTaikoAbi}__ and `functionName` set to `"mint"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa1741a827c35250c437187406fDe16d3581232e6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeC0B304fB75eEf2d83305070e14E4ed914E4FCe0)
 */
export const simulateUsdcATokenTaikoMint = /*#__PURE__*/ createSimulateContract(
  {
    abi: usdcATokenTaikoAbi,
    address: usdcATokenTaikoAddress,
    functionName: 'mint',
  },
)

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link usdcATokenTaikoAbi}__ and `functionName` set to `"mintToTreasury"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa1741a827c35250c437187406fDe16d3581232e6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeC0B304fB75eEf2d83305070e14E4ed914E4FCe0)
 */
export const simulateUsdcATokenTaikoMintToTreasury =
  /*#__PURE__*/ createSimulateContract({
    abi: usdcATokenTaikoAbi,
    address: usdcATokenTaikoAddress,
    functionName: 'mintToTreasury',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link usdcATokenTaikoAbi}__ and `functionName` set to `"permit"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa1741a827c35250c437187406fDe16d3581232e6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeC0B304fB75eEf2d83305070e14E4ed914E4FCe0)
 */
export const simulateUsdcATokenTaikoPermit =
  /*#__PURE__*/ createSimulateContract({
    abi: usdcATokenTaikoAbi,
    address: usdcATokenTaikoAddress,
    functionName: 'permit',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link usdcATokenTaikoAbi}__ and `functionName` set to `"rescueTokens"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa1741a827c35250c437187406fDe16d3581232e6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeC0B304fB75eEf2d83305070e14E4ed914E4FCe0)
 */
export const simulateUsdcATokenTaikoRescueTokens =
  /*#__PURE__*/ createSimulateContract({
    abi: usdcATokenTaikoAbi,
    address: usdcATokenTaikoAddress,
    functionName: 'rescueTokens',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link usdcATokenTaikoAbi}__ and `functionName` set to `"setIncentivesController"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa1741a827c35250c437187406fDe16d3581232e6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeC0B304fB75eEf2d83305070e14E4ed914E4FCe0)
 */
export const simulateUsdcATokenTaikoSetIncentivesController =
  /*#__PURE__*/ createSimulateContract({
    abi: usdcATokenTaikoAbi,
    address: usdcATokenTaikoAddress,
    functionName: 'setIncentivesController',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link usdcATokenTaikoAbi}__ and `functionName` set to `"transfer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa1741a827c35250c437187406fDe16d3581232e6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeC0B304fB75eEf2d83305070e14E4ed914E4FCe0)
 */
export const simulateUsdcATokenTaikoTransfer =
  /*#__PURE__*/ createSimulateContract({
    abi: usdcATokenTaikoAbi,
    address: usdcATokenTaikoAddress,
    functionName: 'transfer',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link usdcATokenTaikoAbi}__ and `functionName` set to `"transferFrom"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa1741a827c35250c437187406fDe16d3581232e6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeC0B304fB75eEf2d83305070e14E4ed914E4FCe0)
 */
export const simulateUsdcATokenTaikoTransferFrom =
  /*#__PURE__*/ createSimulateContract({
    abi: usdcATokenTaikoAbi,
    address: usdcATokenTaikoAddress,
    functionName: 'transferFrom',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link usdcATokenTaikoAbi}__ and `functionName` set to `"transferOnLiquidation"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa1741a827c35250c437187406fDe16d3581232e6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeC0B304fB75eEf2d83305070e14E4ed914E4FCe0)
 */
export const simulateUsdcATokenTaikoTransferOnLiquidation =
  /*#__PURE__*/ createSimulateContract({
    abi: usdcATokenTaikoAbi,
    address: usdcATokenTaikoAddress,
    functionName: 'transferOnLiquidation',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link usdcATokenTaikoAbi}__ and `functionName` set to `"transferUnderlyingTo"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa1741a827c35250c437187406fDe16d3581232e6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeC0B304fB75eEf2d83305070e14E4ed914E4FCe0)
 */
export const simulateUsdcATokenTaikoTransferUnderlyingTo =
  /*#__PURE__*/ createSimulateContract({
    abi: usdcATokenTaikoAbi,
    address: usdcATokenTaikoAddress,
    functionName: 'transferUnderlyingTo',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link usdcATokenTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa1741a827c35250c437187406fDe16d3581232e6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeC0B304fB75eEf2d83305070e14E4ed914E4FCe0)
 */
export const watchUsdcATokenTaikoEvent = /*#__PURE__*/ createWatchContractEvent(
  { abi: usdcATokenTaikoAbi, address: usdcATokenTaikoAddress },
)

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link usdcATokenTaikoAbi}__ and `eventName` set to `"Approval"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa1741a827c35250c437187406fDe16d3581232e6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeC0B304fB75eEf2d83305070e14E4ed914E4FCe0)
 */
export const watchUsdcATokenTaikoApprovalEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: usdcATokenTaikoAbi,
    address: usdcATokenTaikoAddress,
    eventName: 'Approval',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link usdcATokenTaikoAbi}__ and `eventName` set to `"BalanceTransfer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa1741a827c35250c437187406fDe16d3581232e6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeC0B304fB75eEf2d83305070e14E4ed914E4FCe0)
 */
export const watchUsdcATokenTaikoBalanceTransferEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: usdcATokenTaikoAbi,
    address: usdcATokenTaikoAddress,
    eventName: 'BalanceTransfer',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link usdcATokenTaikoAbi}__ and `eventName` set to `"Burn"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa1741a827c35250c437187406fDe16d3581232e6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeC0B304fB75eEf2d83305070e14E4ed914E4FCe0)
 */
export const watchUsdcATokenTaikoBurnEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: usdcATokenTaikoAbi,
    address: usdcATokenTaikoAddress,
    eventName: 'Burn',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link usdcATokenTaikoAbi}__ and `eventName` set to `"Initialized"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa1741a827c35250c437187406fDe16d3581232e6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeC0B304fB75eEf2d83305070e14E4ed914E4FCe0)
 */
export const watchUsdcATokenTaikoInitializedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: usdcATokenTaikoAbi,
    address: usdcATokenTaikoAddress,
    eventName: 'Initialized',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link usdcATokenTaikoAbi}__ and `eventName` set to `"Mint"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa1741a827c35250c437187406fDe16d3581232e6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeC0B304fB75eEf2d83305070e14E4ed914E4FCe0)
 */
export const watchUsdcATokenTaikoMintEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: usdcATokenTaikoAbi,
    address: usdcATokenTaikoAddress,
    eventName: 'Mint',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link usdcATokenTaikoAbi}__ and `eventName` set to `"Transfer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa1741a827c35250c437187406fDe16d3581232e6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xeC0B304fB75eEf2d83305070e14E4ed914E4FCe0)
 */
export const watchUsdcATokenTaikoTransferEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: usdcATokenTaikoAbi,
    address: usdcATokenTaikoAddress,
    eventName: 'Transfer',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdcStableDebtTokenTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xB612eE4d4C5F59ae4e974993177d0ff3EFA5E35f)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x0d42DD8d1979fE6c4a5F79094e648c5e788e5F27)
 */
export const readUsdcStableDebtTokenTaiko = /*#__PURE__*/ createReadContract({
  abi: usdcStableDebtTokenTaikoAbi,
  address: usdcStableDebtTokenTaikoAddress,
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdcStableDebtTokenTaikoAbi}__ and `functionName` set to `"DEBT_TOKEN_REVISION"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xB612eE4d4C5F59ae4e974993177d0ff3EFA5E35f)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x0d42DD8d1979fE6c4a5F79094e648c5e788e5F27)
 */
export const readUsdcStableDebtTokenTaikoDebtTokenRevision =
  /*#__PURE__*/ createReadContract({
    abi: usdcStableDebtTokenTaikoAbi,
    address: usdcStableDebtTokenTaikoAddress,
    functionName: 'DEBT_TOKEN_REVISION',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdcStableDebtTokenTaikoAbi}__ and `functionName` set to `"DELEGATION_WITH_SIG_TYPEHASH"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xB612eE4d4C5F59ae4e974993177d0ff3EFA5E35f)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x0d42DD8d1979fE6c4a5F79094e648c5e788e5F27)
 */
export const readUsdcStableDebtTokenTaikoDelegationWithSigTypehash =
  /*#__PURE__*/ createReadContract({
    abi: usdcStableDebtTokenTaikoAbi,
    address: usdcStableDebtTokenTaikoAddress,
    functionName: 'DELEGATION_WITH_SIG_TYPEHASH',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdcStableDebtTokenTaikoAbi}__ and `functionName` set to `"DOMAIN_SEPARATOR"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xB612eE4d4C5F59ae4e974993177d0ff3EFA5E35f)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x0d42DD8d1979fE6c4a5F79094e648c5e788e5F27)
 */
export const readUsdcStableDebtTokenTaikoDomainSeparator =
  /*#__PURE__*/ createReadContract({
    abi: usdcStableDebtTokenTaikoAbi,
    address: usdcStableDebtTokenTaikoAddress,
    functionName: 'DOMAIN_SEPARATOR',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdcStableDebtTokenTaikoAbi}__ and `functionName` set to `"EIP712_REVISION"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xB612eE4d4C5F59ae4e974993177d0ff3EFA5E35f)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x0d42DD8d1979fE6c4a5F79094e648c5e788e5F27)
 */
export const readUsdcStableDebtTokenTaikoEip712Revision =
  /*#__PURE__*/ createReadContract({
    abi: usdcStableDebtTokenTaikoAbi,
    address: usdcStableDebtTokenTaikoAddress,
    functionName: 'EIP712_REVISION',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdcStableDebtTokenTaikoAbi}__ and `functionName` set to `"POOL"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xB612eE4d4C5F59ae4e974993177d0ff3EFA5E35f)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x0d42DD8d1979fE6c4a5F79094e648c5e788e5F27)
 */
export const readUsdcStableDebtTokenTaikoPool =
  /*#__PURE__*/ createReadContract({
    abi: usdcStableDebtTokenTaikoAbi,
    address: usdcStableDebtTokenTaikoAddress,
    functionName: 'POOL',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdcStableDebtTokenTaikoAbi}__ and `functionName` set to `"UNDERLYING_ASSET_ADDRESS"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xB612eE4d4C5F59ae4e974993177d0ff3EFA5E35f)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x0d42DD8d1979fE6c4a5F79094e648c5e788e5F27)
 */
export const readUsdcStableDebtTokenTaikoUnderlyingAssetAddress =
  /*#__PURE__*/ createReadContract({
    abi: usdcStableDebtTokenTaikoAbi,
    address: usdcStableDebtTokenTaikoAddress,
    functionName: 'UNDERLYING_ASSET_ADDRESS',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdcStableDebtTokenTaikoAbi}__ and `functionName` set to `"allowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xB612eE4d4C5F59ae4e974993177d0ff3EFA5E35f)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x0d42DD8d1979fE6c4a5F79094e648c5e788e5F27)
 */
export const readUsdcStableDebtTokenTaikoAllowance =
  /*#__PURE__*/ createReadContract({
    abi: usdcStableDebtTokenTaikoAbi,
    address: usdcStableDebtTokenTaikoAddress,
    functionName: 'allowance',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdcStableDebtTokenTaikoAbi}__ and `functionName` set to `"balanceOf"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xB612eE4d4C5F59ae4e974993177d0ff3EFA5E35f)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x0d42DD8d1979fE6c4a5F79094e648c5e788e5F27)
 */
export const readUsdcStableDebtTokenTaikoBalanceOf =
  /*#__PURE__*/ createReadContract({
    abi: usdcStableDebtTokenTaikoAbi,
    address: usdcStableDebtTokenTaikoAddress,
    functionName: 'balanceOf',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdcStableDebtTokenTaikoAbi}__ and `functionName` set to `"borrowAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xB612eE4d4C5F59ae4e974993177d0ff3EFA5E35f)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x0d42DD8d1979fE6c4a5F79094e648c5e788e5F27)
 */
export const readUsdcStableDebtTokenTaikoBorrowAllowance =
  /*#__PURE__*/ createReadContract({
    abi: usdcStableDebtTokenTaikoAbi,
    address: usdcStableDebtTokenTaikoAddress,
    functionName: 'borrowAllowance',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdcStableDebtTokenTaikoAbi}__ and `functionName` set to `"decimals"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xB612eE4d4C5F59ae4e974993177d0ff3EFA5E35f)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x0d42DD8d1979fE6c4a5F79094e648c5e788e5F27)
 */
export const readUsdcStableDebtTokenTaikoDecimals =
  /*#__PURE__*/ createReadContract({
    abi: usdcStableDebtTokenTaikoAbi,
    address: usdcStableDebtTokenTaikoAddress,
    functionName: 'decimals',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdcStableDebtTokenTaikoAbi}__ and `functionName` set to `"getAverageStableRate"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xB612eE4d4C5F59ae4e974993177d0ff3EFA5E35f)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x0d42DD8d1979fE6c4a5F79094e648c5e788e5F27)
 */
export const readUsdcStableDebtTokenTaikoGetAverageStableRate =
  /*#__PURE__*/ createReadContract({
    abi: usdcStableDebtTokenTaikoAbi,
    address: usdcStableDebtTokenTaikoAddress,
    functionName: 'getAverageStableRate',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdcStableDebtTokenTaikoAbi}__ and `functionName` set to `"getIncentivesController"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xB612eE4d4C5F59ae4e974993177d0ff3EFA5E35f)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x0d42DD8d1979fE6c4a5F79094e648c5e788e5F27)
 */
export const readUsdcStableDebtTokenTaikoGetIncentivesController =
  /*#__PURE__*/ createReadContract({
    abi: usdcStableDebtTokenTaikoAbi,
    address: usdcStableDebtTokenTaikoAddress,
    functionName: 'getIncentivesController',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdcStableDebtTokenTaikoAbi}__ and `functionName` set to `"getSupplyData"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xB612eE4d4C5F59ae4e974993177d0ff3EFA5E35f)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x0d42DD8d1979fE6c4a5F79094e648c5e788e5F27)
 */
export const readUsdcStableDebtTokenTaikoGetSupplyData =
  /*#__PURE__*/ createReadContract({
    abi: usdcStableDebtTokenTaikoAbi,
    address: usdcStableDebtTokenTaikoAddress,
    functionName: 'getSupplyData',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdcStableDebtTokenTaikoAbi}__ and `functionName` set to `"getTotalSupplyAndAvgRate"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xB612eE4d4C5F59ae4e974993177d0ff3EFA5E35f)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x0d42DD8d1979fE6c4a5F79094e648c5e788e5F27)
 */
export const readUsdcStableDebtTokenTaikoGetTotalSupplyAndAvgRate =
  /*#__PURE__*/ createReadContract({
    abi: usdcStableDebtTokenTaikoAbi,
    address: usdcStableDebtTokenTaikoAddress,
    functionName: 'getTotalSupplyAndAvgRate',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdcStableDebtTokenTaikoAbi}__ and `functionName` set to `"getTotalSupplyLastUpdated"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xB612eE4d4C5F59ae4e974993177d0ff3EFA5E35f)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x0d42DD8d1979fE6c4a5F79094e648c5e788e5F27)
 */
export const readUsdcStableDebtTokenTaikoGetTotalSupplyLastUpdated =
  /*#__PURE__*/ createReadContract({
    abi: usdcStableDebtTokenTaikoAbi,
    address: usdcStableDebtTokenTaikoAddress,
    functionName: 'getTotalSupplyLastUpdated',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdcStableDebtTokenTaikoAbi}__ and `functionName` set to `"getUserLastUpdated"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xB612eE4d4C5F59ae4e974993177d0ff3EFA5E35f)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x0d42DD8d1979fE6c4a5F79094e648c5e788e5F27)
 */
export const readUsdcStableDebtTokenTaikoGetUserLastUpdated =
  /*#__PURE__*/ createReadContract({
    abi: usdcStableDebtTokenTaikoAbi,
    address: usdcStableDebtTokenTaikoAddress,
    functionName: 'getUserLastUpdated',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdcStableDebtTokenTaikoAbi}__ and `functionName` set to `"getUserStableRate"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xB612eE4d4C5F59ae4e974993177d0ff3EFA5E35f)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x0d42DD8d1979fE6c4a5F79094e648c5e788e5F27)
 */
export const readUsdcStableDebtTokenTaikoGetUserStableRate =
  /*#__PURE__*/ createReadContract({
    abi: usdcStableDebtTokenTaikoAbi,
    address: usdcStableDebtTokenTaikoAddress,
    functionName: 'getUserStableRate',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdcStableDebtTokenTaikoAbi}__ and `functionName` set to `"name"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xB612eE4d4C5F59ae4e974993177d0ff3EFA5E35f)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x0d42DD8d1979fE6c4a5F79094e648c5e788e5F27)
 */
export const readUsdcStableDebtTokenTaikoName =
  /*#__PURE__*/ createReadContract({
    abi: usdcStableDebtTokenTaikoAbi,
    address: usdcStableDebtTokenTaikoAddress,
    functionName: 'name',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdcStableDebtTokenTaikoAbi}__ and `functionName` set to `"nonces"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xB612eE4d4C5F59ae4e974993177d0ff3EFA5E35f)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x0d42DD8d1979fE6c4a5F79094e648c5e788e5F27)
 */
export const readUsdcStableDebtTokenTaikoNonces =
  /*#__PURE__*/ createReadContract({
    abi: usdcStableDebtTokenTaikoAbi,
    address: usdcStableDebtTokenTaikoAddress,
    functionName: 'nonces',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdcStableDebtTokenTaikoAbi}__ and `functionName` set to `"principalBalanceOf"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xB612eE4d4C5F59ae4e974993177d0ff3EFA5E35f)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x0d42DD8d1979fE6c4a5F79094e648c5e788e5F27)
 */
export const readUsdcStableDebtTokenTaikoPrincipalBalanceOf =
  /*#__PURE__*/ createReadContract({
    abi: usdcStableDebtTokenTaikoAbi,
    address: usdcStableDebtTokenTaikoAddress,
    functionName: 'principalBalanceOf',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdcStableDebtTokenTaikoAbi}__ and `functionName` set to `"symbol"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xB612eE4d4C5F59ae4e974993177d0ff3EFA5E35f)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x0d42DD8d1979fE6c4a5F79094e648c5e788e5F27)
 */
export const readUsdcStableDebtTokenTaikoSymbol =
  /*#__PURE__*/ createReadContract({
    abi: usdcStableDebtTokenTaikoAbi,
    address: usdcStableDebtTokenTaikoAddress,
    functionName: 'symbol',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdcStableDebtTokenTaikoAbi}__ and `functionName` set to `"totalSupply"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xB612eE4d4C5F59ae4e974993177d0ff3EFA5E35f)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x0d42DD8d1979fE6c4a5F79094e648c5e788e5F27)
 */
export const readUsdcStableDebtTokenTaikoTotalSupply =
  /*#__PURE__*/ createReadContract({
    abi: usdcStableDebtTokenTaikoAbi,
    address: usdcStableDebtTokenTaikoAddress,
    functionName: 'totalSupply',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link usdcStableDebtTokenTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xB612eE4d4C5F59ae4e974993177d0ff3EFA5E35f)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x0d42DD8d1979fE6c4a5F79094e648c5e788e5F27)
 */
export const writeUsdcStableDebtTokenTaiko = /*#__PURE__*/ createWriteContract({
  abi: usdcStableDebtTokenTaikoAbi,
  address: usdcStableDebtTokenTaikoAddress,
})

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link usdcStableDebtTokenTaikoAbi}__ and `functionName` set to `"approve"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xB612eE4d4C5F59ae4e974993177d0ff3EFA5E35f)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x0d42DD8d1979fE6c4a5F79094e648c5e788e5F27)
 */
export const writeUsdcStableDebtTokenTaikoApprove =
  /*#__PURE__*/ createWriteContract({
    abi: usdcStableDebtTokenTaikoAbi,
    address: usdcStableDebtTokenTaikoAddress,
    functionName: 'approve',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link usdcStableDebtTokenTaikoAbi}__ and `functionName` set to `"approveDelegation"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xB612eE4d4C5F59ae4e974993177d0ff3EFA5E35f)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x0d42DD8d1979fE6c4a5F79094e648c5e788e5F27)
 */
export const writeUsdcStableDebtTokenTaikoApproveDelegation =
  /*#__PURE__*/ createWriteContract({
    abi: usdcStableDebtTokenTaikoAbi,
    address: usdcStableDebtTokenTaikoAddress,
    functionName: 'approveDelegation',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link usdcStableDebtTokenTaikoAbi}__ and `functionName` set to `"burn"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xB612eE4d4C5F59ae4e974993177d0ff3EFA5E35f)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x0d42DD8d1979fE6c4a5F79094e648c5e788e5F27)
 */
export const writeUsdcStableDebtTokenTaikoBurn =
  /*#__PURE__*/ createWriteContract({
    abi: usdcStableDebtTokenTaikoAbi,
    address: usdcStableDebtTokenTaikoAddress,
    functionName: 'burn',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link usdcStableDebtTokenTaikoAbi}__ and `functionName` set to `"decreaseAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xB612eE4d4C5F59ae4e974993177d0ff3EFA5E35f)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x0d42DD8d1979fE6c4a5F79094e648c5e788e5F27)
 */
export const writeUsdcStableDebtTokenTaikoDecreaseAllowance =
  /*#__PURE__*/ createWriteContract({
    abi: usdcStableDebtTokenTaikoAbi,
    address: usdcStableDebtTokenTaikoAddress,
    functionName: 'decreaseAllowance',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link usdcStableDebtTokenTaikoAbi}__ and `functionName` set to `"delegationWithSig"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xB612eE4d4C5F59ae4e974993177d0ff3EFA5E35f)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x0d42DD8d1979fE6c4a5F79094e648c5e788e5F27)
 */
export const writeUsdcStableDebtTokenTaikoDelegationWithSig =
  /*#__PURE__*/ createWriteContract({
    abi: usdcStableDebtTokenTaikoAbi,
    address: usdcStableDebtTokenTaikoAddress,
    functionName: 'delegationWithSig',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link usdcStableDebtTokenTaikoAbi}__ and `functionName` set to `"increaseAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xB612eE4d4C5F59ae4e974993177d0ff3EFA5E35f)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x0d42DD8d1979fE6c4a5F79094e648c5e788e5F27)
 */
export const writeUsdcStableDebtTokenTaikoIncreaseAllowance =
  /*#__PURE__*/ createWriteContract({
    abi: usdcStableDebtTokenTaikoAbi,
    address: usdcStableDebtTokenTaikoAddress,
    functionName: 'increaseAllowance',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link usdcStableDebtTokenTaikoAbi}__ and `functionName` set to `"initialize"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xB612eE4d4C5F59ae4e974993177d0ff3EFA5E35f)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x0d42DD8d1979fE6c4a5F79094e648c5e788e5F27)
 */
export const writeUsdcStableDebtTokenTaikoInitialize =
  /*#__PURE__*/ createWriteContract({
    abi: usdcStableDebtTokenTaikoAbi,
    address: usdcStableDebtTokenTaikoAddress,
    functionName: 'initialize',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link usdcStableDebtTokenTaikoAbi}__ and `functionName` set to `"mint"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xB612eE4d4C5F59ae4e974993177d0ff3EFA5E35f)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x0d42DD8d1979fE6c4a5F79094e648c5e788e5F27)
 */
export const writeUsdcStableDebtTokenTaikoMint =
  /*#__PURE__*/ createWriteContract({
    abi: usdcStableDebtTokenTaikoAbi,
    address: usdcStableDebtTokenTaikoAddress,
    functionName: 'mint',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link usdcStableDebtTokenTaikoAbi}__ and `functionName` set to `"setIncentivesController"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xB612eE4d4C5F59ae4e974993177d0ff3EFA5E35f)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x0d42DD8d1979fE6c4a5F79094e648c5e788e5F27)
 */
export const writeUsdcStableDebtTokenTaikoSetIncentivesController =
  /*#__PURE__*/ createWriteContract({
    abi: usdcStableDebtTokenTaikoAbi,
    address: usdcStableDebtTokenTaikoAddress,
    functionName: 'setIncentivesController',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link usdcStableDebtTokenTaikoAbi}__ and `functionName` set to `"transfer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xB612eE4d4C5F59ae4e974993177d0ff3EFA5E35f)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x0d42DD8d1979fE6c4a5F79094e648c5e788e5F27)
 */
export const writeUsdcStableDebtTokenTaikoTransfer =
  /*#__PURE__*/ createWriteContract({
    abi: usdcStableDebtTokenTaikoAbi,
    address: usdcStableDebtTokenTaikoAddress,
    functionName: 'transfer',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link usdcStableDebtTokenTaikoAbi}__ and `functionName` set to `"transferFrom"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xB612eE4d4C5F59ae4e974993177d0ff3EFA5E35f)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x0d42DD8d1979fE6c4a5F79094e648c5e788e5F27)
 */
export const writeUsdcStableDebtTokenTaikoTransferFrom =
  /*#__PURE__*/ createWriteContract({
    abi: usdcStableDebtTokenTaikoAbi,
    address: usdcStableDebtTokenTaikoAddress,
    functionName: 'transferFrom',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link usdcStableDebtTokenTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xB612eE4d4C5F59ae4e974993177d0ff3EFA5E35f)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x0d42DD8d1979fE6c4a5F79094e648c5e788e5F27)
 */
export const simulateUsdcStableDebtTokenTaiko =
  /*#__PURE__*/ createSimulateContract({
    abi: usdcStableDebtTokenTaikoAbi,
    address: usdcStableDebtTokenTaikoAddress,
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link usdcStableDebtTokenTaikoAbi}__ and `functionName` set to `"approve"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xB612eE4d4C5F59ae4e974993177d0ff3EFA5E35f)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x0d42DD8d1979fE6c4a5F79094e648c5e788e5F27)
 */
export const simulateUsdcStableDebtTokenTaikoApprove =
  /*#__PURE__*/ createSimulateContract({
    abi: usdcStableDebtTokenTaikoAbi,
    address: usdcStableDebtTokenTaikoAddress,
    functionName: 'approve',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link usdcStableDebtTokenTaikoAbi}__ and `functionName` set to `"approveDelegation"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xB612eE4d4C5F59ae4e974993177d0ff3EFA5E35f)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x0d42DD8d1979fE6c4a5F79094e648c5e788e5F27)
 */
export const simulateUsdcStableDebtTokenTaikoApproveDelegation =
  /*#__PURE__*/ createSimulateContract({
    abi: usdcStableDebtTokenTaikoAbi,
    address: usdcStableDebtTokenTaikoAddress,
    functionName: 'approveDelegation',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link usdcStableDebtTokenTaikoAbi}__ and `functionName` set to `"burn"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xB612eE4d4C5F59ae4e974993177d0ff3EFA5E35f)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x0d42DD8d1979fE6c4a5F79094e648c5e788e5F27)
 */
export const simulateUsdcStableDebtTokenTaikoBurn =
  /*#__PURE__*/ createSimulateContract({
    abi: usdcStableDebtTokenTaikoAbi,
    address: usdcStableDebtTokenTaikoAddress,
    functionName: 'burn',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link usdcStableDebtTokenTaikoAbi}__ and `functionName` set to `"decreaseAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xB612eE4d4C5F59ae4e974993177d0ff3EFA5E35f)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x0d42DD8d1979fE6c4a5F79094e648c5e788e5F27)
 */
export const simulateUsdcStableDebtTokenTaikoDecreaseAllowance =
  /*#__PURE__*/ createSimulateContract({
    abi: usdcStableDebtTokenTaikoAbi,
    address: usdcStableDebtTokenTaikoAddress,
    functionName: 'decreaseAllowance',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link usdcStableDebtTokenTaikoAbi}__ and `functionName` set to `"delegationWithSig"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xB612eE4d4C5F59ae4e974993177d0ff3EFA5E35f)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x0d42DD8d1979fE6c4a5F79094e648c5e788e5F27)
 */
export const simulateUsdcStableDebtTokenTaikoDelegationWithSig =
  /*#__PURE__*/ createSimulateContract({
    abi: usdcStableDebtTokenTaikoAbi,
    address: usdcStableDebtTokenTaikoAddress,
    functionName: 'delegationWithSig',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link usdcStableDebtTokenTaikoAbi}__ and `functionName` set to `"increaseAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xB612eE4d4C5F59ae4e974993177d0ff3EFA5E35f)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x0d42DD8d1979fE6c4a5F79094e648c5e788e5F27)
 */
export const simulateUsdcStableDebtTokenTaikoIncreaseAllowance =
  /*#__PURE__*/ createSimulateContract({
    abi: usdcStableDebtTokenTaikoAbi,
    address: usdcStableDebtTokenTaikoAddress,
    functionName: 'increaseAllowance',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link usdcStableDebtTokenTaikoAbi}__ and `functionName` set to `"initialize"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xB612eE4d4C5F59ae4e974993177d0ff3EFA5E35f)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x0d42DD8d1979fE6c4a5F79094e648c5e788e5F27)
 */
export const simulateUsdcStableDebtTokenTaikoInitialize =
  /*#__PURE__*/ createSimulateContract({
    abi: usdcStableDebtTokenTaikoAbi,
    address: usdcStableDebtTokenTaikoAddress,
    functionName: 'initialize',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link usdcStableDebtTokenTaikoAbi}__ and `functionName` set to `"mint"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xB612eE4d4C5F59ae4e974993177d0ff3EFA5E35f)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x0d42DD8d1979fE6c4a5F79094e648c5e788e5F27)
 */
export const simulateUsdcStableDebtTokenTaikoMint =
  /*#__PURE__*/ createSimulateContract({
    abi: usdcStableDebtTokenTaikoAbi,
    address: usdcStableDebtTokenTaikoAddress,
    functionName: 'mint',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link usdcStableDebtTokenTaikoAbi}__ and `functionName` set to `"setIncentivesController"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xB612eE4d4C5F59ae4e974993177d0ff3EFA5E35f)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x0d42DD8d1979fE6c4a5F79094e648c5e788e5F27)
 */
export const simulateUsdcStableDebtTokenTaikoSetIncentivesController =
  /*#__PURE__*/ createSimulateContract({
    abi: usdcStableDebtTokenTaikoAbi,
    address: usdcStableDebtTokenTaikoAddress,
    functionName: 'setIncentivesController',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link usdcStableDebtTokenTaikoAbi}__ and `functionName` set to `"transfer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xB612eE4d4C5F59ae4e974993177d0ff3EFA5E35f)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x0d42DD8d1979fE6c4a5F79094e648c5e788e5F27)
 */
export const simulateUsdcStableDebtTokenTaikoTransfer =
  /*#__PURE__*/ createSimulateContract({
    abi: usdcStableDebtTokenTaikoAbi,
    address: usdcStableDebtTokenTaikoAddress,
    functionName: 'transfer',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link usdcStableDebtTokenTaikoAbi}__ and `functionName` set to `"transferFrom"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xB612eE4d4C5F59ae4e974993177d0ff3EFA5E35f)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x0d42DD8d1979fE6c4a5F79094e648c5e788e5F27)
 */
export const simulateUsdcStableDebtTokenTaikoTransferFrom =
  /*#__PURE__*/ createSimulateContract({
    abi: usdcStableDebtTokenTaikoAbi,
    address: usdcStableDebtTokenTaikoAddress,
    functionName: 'transferFrom',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link usdcStableDebtTokenTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xB612eE4d4C5F59ae4e974993177d0ff3EFA5E35f)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x0d42DD8d1979fE6c4a5F79094e648c5e788e5F27)
 */
export const watchUsdcStableDebtTokenTaikoEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: usdcStableDebtTokenTaikoAbi,
    address: usdcStableDebtTokenTaikoAddress,
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link usdcStableDebtTokenTaikoAbi}__ and `eventName` set to `"Approval"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xB612eE4d4C5F59ae4e974993177d0ff3EFA5E35f)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x0d42DD8d1979fE6c4a5F79094e648c5e788e5F27)
 */
export const watchUsdcStableDebtTokenTaikoApprovalEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: usdcStableDebtTokenTaikoAbi,
    address: usdcStableDebtTokenTaikoAddress,
    eventName: 'Approval',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link usdcStableDebtTokenTaikoAbi}__ and `eventName` set to `"BorrowAllowanceDelegated"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xB612eE4d4C5F59ae4e974993177d0ff3EFA5E35f)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x0d42DD8d1979fE6c4a5F79094e648c5e788e5F27)
 */
export const watchUsdcStableDebtTokenTaikoBorrowAllowanceDelegatedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: usdcStableDebtTokenTaikoAbi,
    address: usdcStableDebtTokenTaikoAddress,
    eventName: 'BorrowAllowanceDelegated',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link usdcStableDebtTokenTaikoAbi}__ and `eventName` set to `"Burn"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xB612eE4d4C5F59ae4e974993177d0ff3EFA5E35f)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x0d42DD8d1979fE6c4a5F79094e648c5e788e5F27)
 */
export const watchUsdcStableDebtTokenTaikoBurnEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: usdcStableDebtTokenTaikoAbi,
    address: usdcStableDebtTokenTaikoAddress,
    eventName: 'Burn',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link usdcStableDebtTokenTaikoAbi}__ and `eventName` set to `"Initialized"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xB612eE4d4C5F59ae4e974993177d0ff3EFA5E35f)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x0d42DD8d1979fE6c4a5F79094e648c5e788e5F27)
 */
export const watchUsdcStableDebtTokenTaikoInitializedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: usdcStableDebtTokenTaikoAbi,
    address: usdcStableDebtTokenTaikoAddress,
    eventName: 'Initialized',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link usdcStableDebtTokenTaikoAbi}__ and `eventName` set to `"Mint"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xB612eE4d4C5F59ae4e974993177d0ff3EFA5E35f)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x0d42DD8d1979fE6c4a5F79094e648c5e788e5F27)
 */
export const watchUsdcStableDebtTokenTaikoMintEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: usdcStableDebtTokenTaikoAbi,
    address: usdcStableDebtTokenTaikoAddress,
    eventName: 'Mint',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link usdcStableDebtTokenTaikoAbi}__ and `eventName` set to `"Transfer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xB612eE4d4C5F59ae4e974993177d0ff3EFA5E35f)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x0d42DD8d1979fE6c4a5F79094e648c5e788e5F27)
 */
export const watchUsdcStableDebtTokenTaikoTransferEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: usdcStableDebtTokenTaikoAbi,
    address: usdcStableDebtTokenTaikoAddress,
    eventName: 'Transfer',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdcTestnetMintableErc20TaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBB54E2B6C5Cb9513B46D5E6EC20E59568cD26b3f)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x3faCa18a990b2b06878f1E4b0ea594758e114812)
 */
export const readUsdcTestnetMintableErc20Taiko =
  /*#__PURE__*/ createReadContract({
    abi: usdcTestnetMintableErc20TaikoAbi,
    address: usdcTestnetMintableErc20TaikoAddress,
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdcTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"allowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBB54E2B6C5Cb9513B46D5E6EC20E59568cD26b3f)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x3faCa18a990b2b06878f1E4b0ea594758e114812)
 */
export const readUsdcTestnetMintableErc20TaikoAllowance =
  /*#__PURE__*/ createReadContract({
    abi: usdcTestnetMintableErc20TaikoAbi,
    address: usdcTestnetMintableErc20TaikoAddress,
    functionName: 'allowance',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdcTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"balanceOf"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBB54E2B6C5Cb9513B46D5E6EC20E59568cD26b3f)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x3faCa18a990b2b06878f1E4b0ea594758e114812)
 */
export const readUsdcTestnetMintableErc20TaikoBalanceOf =
  /*#__PURE__*/ createReadContract({
    abi: usdcTestnetMintableErc20TaikoAbi,
    address: usdcTestnetMintableErc20TaikoAddress,
    functionName: 'balanceOf',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdcTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"decimals"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBB54E2B6C5Cb9513B46D5E6EC20E59568cD26b3f)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x3faCa18a990b2b06878f1E4b0ea594758e114812)
 */
export const readUsdcTestnetMintableErc20TaikoDecimals =
  /*#__PURE__*/ createReadContract({
    abi: usdcTestnetMintableErc20TaikoAbi,
    address: usdcTestnetMintableErc20TaikoAddress,
    functionName: 'decimals',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdcTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"name"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBB54E2B6C5Cb9513B46D5E6EC20E59568cD26b3f)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x3faCa18a990b2b06878f1E4b0ea594758e114812)
 */
export const readUsdcTestnetMintableErc20TaikoName =
  /*#__PURE__*/ createReadContract({
    abi: usdcTestnetMintableErc20TaikoAbi,
    address: usdcTestnetMintableErc20TaikoAddress,
    functionName: 'name',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdcTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"symbol"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBB54E2B6C5Cb9513B46D5E6EC20E59568cD26b3f)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x3faCa18a990b2b06878f1E4b0ea594758e114812)
 */
export const readUsdcTestnetMintableErc20TaikoSymbol =
  /*#__PURE__*/ createReadContract({
    abi: usdcTestnetMintableErc20TaikoAbi,
    address: usdcTestnetMintableErc20TaikoAddress,
    functionName: 'symbol',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdcTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"tokenDecimals"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBB54E2B6C5Cb9513B46D5E6EC20E59568cD26b3f)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x3faCa18a990b2b06878f1E4b0ea594758e114812)
 */
export const readUsdcTestnetMintableErc20TaikoTokenDecimals =
  /*#__PURE__*/ createReadContract({
    abi: usdcTestnetMintableErc20TaikoAbi,
    address: usdcTestnetMintableErc20TaikoAddress,
    functionName: 'tokenDecimals',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdcTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"totalSupply"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBB54E2B6C5Cb9513B46D5E6EC20E59568cD26b3f)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x3faCa18a990b2b06878f1E4b0ea594758e114812)
 */
export const readUsdcTestnetMintableErc20TaikoTotalSupply =
  /*#__PURE__*/ createReadContract({
    abi: usdcTestnetMintableErc20TaikoAbi,
    address: usdcTestnetMintableErc20TaikoAddress,
    functionName: 'totalSupply',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link usdcTestnetMintableErc20TaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBB54E2B6C5Cb9513B46D5E6EC20E59568cD26b3f)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x3faCa18a990b2b06878f1E4b0ea594758e114812)
 */
export const writeUsdcTestnetMintableErc20Taiko =
  /*#__PURE__*/ createWriteContract({
    abi: usdcTestnetMintableErc20TaikoAbi,
    address: usdcTestnetMintableErc20TaikoAddress,
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link usdcTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"approve"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBB54E2B6C5Cb9513B46D5E6EC20E59568cD26b3f)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x3faCa18a990b2b06878f1E4b0ea594758e114812)
 */
export const writeUsdcTestnetMintableErc20TaikoApprove =
  /*#__PURE__*/ createWriteContract({
    abi: usdcTestnetMintableErc20TaikoAbi,
    address: usdcTestnetMintableErc20TaikoAddress,
    functionName: 'approve',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link usdcTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"decreaseAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBB54E2B6C5Cb9513B46D5E6EC20E59568cD26b3f)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x3faCa18a990b2b06878f1E4b0ea594758e114812)
 */
export const writeUsdcTestnetMintableErc20TaikoDecreaseAllowance =
  /*#__PURE__*/ createWriteContract({
    abi: usdcTestnetMintableErc20TaikoAbi,
    address: usdcTestnetMintableErc20TaikoAddress,
    functionName: 'decreaseAllowance',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link usdcTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"increaseAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBB54E2B6C5Cb9513B46D5E6EC20E59568cD26b3f)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x3faCa18a990b2b06878f1E4b0ea594758e114812)
 */
export const writeUsdcTestnetMintableErc20TaikoIncreaseAllowance =
  /*#__PURE__*/ createWriteContract({
    abi: usdcTestnetMintableErc20TaikoAbi,
    address: usdcTestnetMintableErc20TaikoAddress,
    functionName: 'increaseAllowance',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link usdcTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"transfer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBB54E2B6C5Cb9513B46D5E6EC20E59568cD26b3f)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x3faCa18a990b2b06878f1E4b0ea594758e114812)
 */
export const writeUsdcTestnetMintableErc20TaikoTransfer =
  /*#__PURE__*/ createWriteContract({
    abi: usdcTestnetMintableErc20TaikoAbi,
    address: usdcTestnetMintableErc20TaikoAddress,
    functionName: 'transfer',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link usdcTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"transferFrom"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBB54E2B6C5Cb9513B46D5E6EC20E59568cD26b3f)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x3faCa18a990b2b06878f1E4b0ea594758e114812)
 */
export const writeUsdcTestnetMintableErc20TaikoTransferFrom =
  /*#__PURE__*/ createWriteContract({
    abi: usdcTestnetMintableErc20TaikoAbi,
    address: usdcTestnetMintableErc20TaikoAddress,
    functionName: 'transferFrom',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link usdcTestnetMintableErc20TaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBB54E2B6C5Cb9513B46D5E6EC20E59568cD26b3f)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x3faCa18a990b2b06878f1E4b0ea594758e114812)
 */
export const simulateUsdcTestnetMintableErc20Taiko =
  /*#__PURE__*/ createSimulateContract({
    abi: usdcTestnetMintableErc20TaikoAbi,
    address: usdcTestnetMintableErc20TaikoAddress,
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link usdcTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"approve"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBB54E2B6C5Cb9513B46D5E6EC20E59568cD26b3f)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x3faCa18a990b2b06878f1E4b0ea594758e114812)
 */
export const simulateUsdcTestnetMintableErc20TaikoApprove =
  /*#__PURE__*/ createSimulateContract({
    abi: usdcTestnetMintableErc20TaikoAbi,
    address: usdcTestnetMintableErc20TaikoAddress,
    functionName: 'approve',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link usdcTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"decreaseAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBB54E2B6C5Cb9513B46D5E6EC20E59568cD26b3f)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x3faCa18a990b2b06878f1E4b0ea594758e114812)
 */
export const simulateUsdcTestnetMintableErc20TaikoDecreaseAllowance =
  /*#__PURE__*/ createSimulateContract({
    abi: usdcTestnetMintableErc20TaikoAbi,
    address: usdcTestnetMintableErc20TaikoAddress,
    functionName: 'decreaseAllowance',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link usdcTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"increaseAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBB54E2B6C5Cb9513B46D5E6EC20E59568cD26b3f)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x3faCa18a990b2b06878f1E4b0ea594758e114812)
 */
export const simulateUsdcTestnetMintableErc20TaikoIncreaseAllowance =
  /*#__PURE__*/ createSimulateContract({
    abi: usdcTestnetMintableErc20TaikoAbi,
    address: usdcTestnetMintableErc20TaikoAddress,
    functionName: 'increaseAllowance',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link usdcTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"transfer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBB54E2B6C5Cb9513B46D5E6EC20E59568cD26b3f)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x3faCa18a990b2b06878f1E4b0ea594758e114812)
 */
export const simulateUsdcTestnetMintableErc20TaikoTransfer =
  /*#__PURE__*/ createSimulateContract({
    abi: usdcTestnetMintableErc20TaikoAbi,
    address: usdcTestnetMintableErc20TaikoAddress,
    functionName: 'transfer',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link usdcTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"transferFrom"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBB54E2B6C5Cb9513B46D5E6EC20E59568cD26b3f)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x3faCa18a990b2b06878f1E4b0ea594758e114812)
 */
export const simulateUsdcTestnetMintableErc20TaikoTransferFrom =
  /*#__PURE__*/ createSimulateContract({
    abi: usdcTestnetMintableErc20TaikoAbi,
    address: usdcTestnetMintableErc20TaikoAddress,
    functionName: 'transferFrom',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link usdcTestnetMintableErc20TaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBB54E2B6C5Cb9513B46D5E6EC20E59568cD26b3f)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x3faCa18a990b2b06878f1E4b0ea594758e114812)
 */
export const watchUsdcTestnetMintableErc20TaikoEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: usdcTestnetMintableErc20TaikoAbi,
    address: usdcTestnetMintableErc20TaikoAddress,
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link usdcTestnetMintableErc20TaikoAbi}__ and `eventName` set to `"Approval"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBB54E2B6C5Cb9513B46D5E6EC20E59568cD26b3f)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x3faCa18a990b2b06878f1E4b0ea594758e114812)
 */
export const watchUsdcTestnetMintableErc20TaikoApprovalEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: usdcTestnetMintableErc20TaikoAbi,
    address: usdcTestnetMintableErc20TaikoAddress,
    eventName: 'Approval',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link usdcTestnetMintableErc20TaikoAbi}__ and `eventName` set to `"Transfer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xBB54E2B6C5Cb9513B46D5E6EC20E59568cD26b3f)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x3faCa18a990b2b06878f1E4b0ea594758e114812)
 */
export const watchUsdcTestnetMintableErc20TaikoTransferEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: usdcTestnetMintableErc20TaikoAbi,
    address: usdcTestnetMintableErc20TaikoAddress,
    eventName: 'Transfer',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdcTestnetPriceAggregatorTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xB227D89B288fB2e84D1103493A7aC35215c7F817)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xe70c7A48C27b6b5D56D768f9494CA9CAb73bE86E)
 */
export const readUsdcTestnetPriceAggregatorTaiko =
  /*#__PURE__*/ createReadContract({
    abi: usdcTestnetPriceAggregatorTaikoAbi,
    address: usdcTestnetPriceAggregatorTaikoAddress,
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdcTestnetPriceAggregatorTaikoAbi}__ and `functionName` set to `"decimals"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xB227D89B288fB2e84D1103493A7aC35215c7F817)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xe70c7A48C27b6b5D56D768f9494CA9CAb73bE86E)
 */
export const readUsdcTestnetPriceAggregatorTaikoDecimals =
  /*#__PURE__*/ createReadContract({
    abi: usdcTestnetPriceAggregatorTaikoAbi,
    address: usdcTestnetPriceAggregatorTaikoAddress,
    functionName: 'decimals',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdcTestnetPriceAggregatorTaikoAbi}__ and `functionName` set to `"getTokenType"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xB227D89B288fB2e84D1103493A7aC35215c7F817)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xe70c7A48C27b6b5D56D768f9494CA9CAb73bE86E)
 */
export const readUsdcTestnetPriceAggregatorTaikoGetTokenType =
  /*#__PURE__*/ createReadContract({
    abi: usdcTestnetPriceAggregatorTaikoAbi,
    address: usdcTestnetPriceAggregatorTaikoAddress,
    functionName: 'getTokenType',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdcTestnetPriceAggregatorTaikoAbi}__ and `functionName` set to `"latestAnswer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xB227D89B288fB2e84D1103493A7aC35215c7F817)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xe70c7A48C27b6b5D56D768f9494CA9CAb73bE86E)
 */
export const readUsdcTestnetPriceAggregatorTaikoLatestAnswer =
  /*#__PURE__*/ createReadContract({
    abi: usdcTestnetPriceAggregatorTaikoAbi,
    address: usdcTestnetPriceAggregatorTaikoAddress,
    functionName: 'latestAnswer',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link usdcTestnetPriceAggregatorTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xB227D89B288fB2e84D1103493A7aC35215c7F817)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xe70c7A48C27b6b5D56D768f9494CA9CAb73bE86E)
 */
export const watchUsdcTestnetPriceAggregatorTaikoEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: usdcTestnetPriceAggregatorTaikoAbi,
    address: usdcTestnetPriceAggregatorTaikoAddress,
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link usdcTestnetPriceAggregatorTaikoAbi}__ and `eventName` set to `"AnswerUpdated"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xB227D89B288fB2e84D1103493A7aC35215c7F817)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xe70c7A48C27b6b5D56D768f9494CA9CAb73bE86E)
 */
export const watchUsdcTestnetPriceAggregatorTaikoAnswerUpdatedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: usdcTestnetPriceAggregatorTaikoAbi,
    address: usdcTestnetPriceAggregatorTaikoAddress,
    eventName: 'AnswerUpdated',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdcVariableDebtTokenTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x3b0B993247C9D9EF4e92817380b1A16D0f55813b)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xdf50fE60bFc34bC034e40E05C0Ef8EB2DFb0B181)
 */
export const readUsdcVariableDebtTokenTaiko = /*#__PURE__*/ createReadContract({
  abi: usdcVariableDebtTokenTaikoAbi,
  address: usdcVariableDebtTokenTaikoAddress,
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdcVariableDebtTokenTaikoAbi}__ and `functionName` set to `"DEBT_TOKEN_REVISION"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x3b0B993247C9D9EF4e92817380b1A16D0f55813b)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xdf50fE60bFc34bC034e40E05C0Ef8EB2DFb0B181)
 */
export const readUsdcVariableDebtTokenTaikoDebtTokenRevision =
  /*#__PURE__*/ createReadContract({
    abi: usdcVariableDebtTokenTaikoAbi,
    address: usdcVariableDebtTokenTaikoAddress,
    functionName: 'DEBT_TOKEN_REVISION',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdcVariableDebtTokenTaikoAbi}__ and `functionName` set to `"DELEGATION_WITH_SIG_TYPEHASH"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x3b0B993247C9D9EF4e92817380b1A16D0f55813b)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xdf50fE60bFc34bC034e40E05C0Ef8EB2DFb0B181)
 */
export const readUsdcVariableDebtTokenTaikoDelegationWithSigTypehash =
  /*#__PURE__*/ createReadContract({
    abi: usdcVariableDebtTokenTaikoAbi,
    address: usdcVariableDebtTokenTaikoAddress,
    functionName: 'DELEGATION_WITH_SIG_TYPEHASH',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdcVariableDebtTokenTaikoAbi}__ and `functionName` set to `"DOMAIN_SEPARATOR"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x3b0B993247C9D9EF4e92817380b1A16D0f55813b)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xdf50fE60bFc34bC034e40E05C0Ef8EB2DFb0B181)
 */
export const readUsdcVariableDebtTokenTaikoDomainSeparator =
  /*#__PURE__*/ createReadContract({
    abi: usdcVariableDebtTokenTaikoAbi,
    address: usdcVariableDebtTokenTaikoAddress,
    functionName: 'DOMAIN_SEPARATOR',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdcVariableDebtTokenTaikoAbi}__ and `functionName` set to `"EIP712_REVISION"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x3b0B993247C9D9EF4e92817380b1A16D0f55813b)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xdf50fE60bFc34bC034e40E05C0Ef8EB2DFb0B181)
 */
export const readUsdcVariableDebtTokenTaikoEip712Revision =
  /*#__PURE__*/ createReadContract({
    abi: usdcVariableDebtTokenTaikoAbi,
    address: usdcVariableDebtTokenTaikoAddress,
    functionName: 'EIP712_REVISION',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdcVariableDebtTokenTaikoAbi}__ and `functionName` set to `"POOL"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x3b0B993247C9D9EF4e92817380b1A16D0f55813b)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xdf50fE60bFc34bC034e40E05C0Ef8EB2DFb0B181)
 */
export const readUsdcVariableDebtTokenTaikoPool =
  /*#__PURE__*/ createReadContract({
    abi: usdcVariableDebtTokenTaikoAbi,
    address: usdcVariableDebtTokenTaikoAddress,
    functionName: 'POOL',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdcVariableDebtTokenTaikoAbi}__ and `functionName` set to `"UNDERLYING_ASSET_ADDRESS"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x3b0B993247C9D9EF4e92817380b1A16D0f55813b)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xdf50fE60bFc34bC034e40E05C0Ef8EB2DFb0B181)
 */
export const readUsdcVariableDebtTokenTaikoUnderlyingAssetAddress =
  /*#__PURE__*/ createReadContract({
    abi: usdcVariableDebtTokenTaikoAbi,
    address: usdcVariableDebtTokenTaikoAddress,
    functionName: 'UNDERLYING_ASSET_ADDRESS',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdcVariableDebtTokenTaikoAbi}__ and `functionName` set to `"allowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x3b0B993247C9D9EF4e92817380b1A16D0f55813b)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xdf50fE60bFc34bC034e40E05C0Ef8EB2DFb0B181)
 */
export const readUsdcVariableDebtTokenTaikoAllowance =
  /*#__PURE__*/ createReadContract({
    abi: usdcVariableDebtTokenTaikoAbi,
    address: usdcVariableDebtTokenTaikoAddress,
    functionName: 'allowance',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdcVariableDebtTokenTaikoAbi}__ and `functionName` set to `"balanceOf"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x3b0B993247C9D9EF4e92817380b1A16D0f55813b)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xdf50fE60bFc34bC034e40E05C0Ef8EB2DFb0B181)
 */
export const readUsdcVariableDebtTokenTaikoBalanceOf =
  /*#__PURE__*/ createReadContract({
    abi: usdcVariableDebtTokenTaikoAbi,
    address: usdcVariableDebtTokenTaikoAddress,
    functionName: 'balanceOf',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdcVariableDebtTokenTaikoAbi}__ and `functionName` set to `"borrowAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x3b0B993247C9D9EF4e92817380b1A16D0f55813b)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xdf50fE60bFc34bC034e40E05C0Ef8EB2DFb0B181)
 */
export const readUsdcVariableDebtTokenTaikoBorrowAllowance =
  /*#__PURE__*/ createReadContract({
    abi: usdcVariableDebtTokenTaikoAbi,
    address: usdcVariableDebtTokenTaikoAddress,
    functionName: 'borrowAllowance',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdcVariableDebtTokenTaikoAbi}__ and `functionName` set to `"decimals"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x3b0B993247C9D9EF4e92817380b1A16D0f55813b)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xdf50fE60bFc34bC034e40E05C0Ef8EB2DFb0B181)
 */
export const readUsdcVariableDebtTokenTaikoDecimals =
  /*#__PURE__*/ createReadContract({
    abi: usdcVariableDebtTokenTaikoAbi,
    address: usdcVariableDebtTokenTaikoAddress,
    functionName: 'decimals',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdcVariableDebtTokenTaikoAbi}__ and `functionName` set to `"getIncentivesController"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x3b0B993247C9D9EF4e92817380b1A16D0f55813b)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xdf50fE60bFc34bC034e40E05C0Ef8EB2DFb0B181)
 */
export const readUsdcVariableDebtTokenTaikoGetIncentivesController =
  /*#__PURE__*/ createReadContract({
    abi: usdcVariableDebtTokenTaikoAbi,
    address: usdcVariableDebtTokenTaikoAddress,
    functionName: 'getIncentivesController',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdcVariableDebtTokenTaikoAbi}__ and `functionName` set to `"getPreviousIndex"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x3b0B993247C9D9EF4e92817380b1A16D0f55813b)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xdf50fE60bFc34bC034e40E05C0Ef8EB2DFb0B181)
 */
export const readUsdcVariableDebtTokenTaikoGetPreviousIndex =
  /*#__PURE__*/ createReadContract({
    abi: usdcVariableDebtTokenTaikoAbi,
    address: usdcVariableDebtTokenTaikoAddress,
    functionName: 'getPreviousIndex',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdcVariableDebtTokenTaikoAbi}__ and `functionName` set to `"getScaledUserBalanceAndSupply"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x3b0B993247C9D9EF4e92817380b1A16D0f55813b)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xdf50fE60bFc34bC034e40E05C0Ef8EB2DFb0B181)
 */
export const readUsdcVariableDebtTokenTaikoGetScaledUserBalanceAndSupply =
  /*#__PURE__*/ createReadContract({
    abi: usdcVariableDebtTokenTaikoAbi,
    address: usdcVariableDebtTokenTaikoAddress,
    functionName: 'getScaledUserBalanceAndSupply',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdcVariableDebtTokenTaikoAbi}__ and `functionName` set to `"name"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x3b0B993247C9D9EF4e92817380b1A16D0f55813b)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xdf50fE60bFc34bC034e40E05C0Ef8EB2DFb0B181)
 */
export const readUsdcVariableDebtTokenTaikoName =
  /*#__PURE__*/ createReadContract({
    abi: usdcVariableDebtTokenTaikoAbi,
    address: usdcVariableDebtTokenTaikoAddress,
    functionName: 'name',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdcVariableDebtTokenTaikoAbi}__ and `functionName` set to `"nonces"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x3b0B993247C9D9EF4e92817380b1A16D0f55813b)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xdf50fE60bFc34bC034e40E05C0Ef8EB2DFb0B181)
 */
export const readUsdcVariableDebtTokenTaikoNonces =
  /*#__PURE__*/ createReadContract({
    abi: usdcVariableDebtTokenTaikoAbi,
    address: usdcVariableDebtTokenTaikoAddress,
    functionName: 'nonces',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdcVariableDebtTokenTaikoAbi}__ and `functionName` set to `"scaledBalanceOf"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x3b0B993247C9D9EF4e92817380b1A16D0f55813b)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xdf50fE60bFc34bC034e40E05C0Ef8EB2DFb0B181)
 */
export const readUsdcVariableDebtTokenTaikoScaledBalanceOf =
  /*#__PURE__*/ createReadContract({
    abi: usdcVariableDebtTokenTaikoAbi,
    address: usdcVariableDebtTokenTaikoAddress,
    functionName: 'scaledBalanceOf',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdcVariableDebtTokenTaikoAbi}__ and `functionName` set to `"scaledTotalSupply"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x3b0B993247C9D9EF4e92817380b1A16D0f55813b)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xdf50fE60bFc34bC034e40E05C0Ef8EB2DFb0B181)
 */
export const readUsdcVariableDebtTokenTaikoScaledTotalSupply =
  /*#__PURE__*/ createReadContract({
    abi: usdcVariableDebtTokenTaikoAbi,
    address: usdcVariableDebtTokenTaikoAddress,
    functionName: 'scaledTotalSupply',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdcVariableDebtTokenTaikoAbi}__ and `functionName` set to `"symbol"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x3b0B993247C9D9EF4e92817380b1A16D0f55813b)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xdf50fE60bFc34bC034e40E05C0Ef8EB2DFb0B181)
 */
export const readUsdcVariableDebtTokenTaikoSymbol =
  /*#__PURE__*/ createReadContract({
    abi: usdcVariableDebtTokenTaikoAbi,
    address: usdcVariableDebtTokenTaikoAddress,
    functionName: 'symbol',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdcVariableDebtTokenTaikoAbi}__ and `functionName` set to `"totalSupply"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x3b0B993247C9D9EF4e92817380b1A16D0f55813b)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xdf50fE60bFc34bC034e40E05C0Ef8EB2DFb0B181)
 */
export const readUsdcVariableDebtTokenTaikoTotalSupply =
  /*#__PURE__*/ createReadContract({
    abi: usdcVariableDebtTokenTaikoAbi,
    address: usdcVariableDebtTokenTaikoAddress,
    functionName: 'totalSupply',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link usdcVariableDebtTokenTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x3b0B993247C9D9EF4e92817380b1A16D0f55813b)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xdf50fE60bFc34bC034e40E05C0Ef8EB2DFb0B181)
 */
export const writeUsdcVariableDebtTokenTaiko =
  /*#__PURE__*/ createWriteContract({
    abi: usdcVariableDebtTokenTaikoAbi,
    address: usdcVariableDebtTokenTaikoAddress,
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link usdcVariableDebtTokenTaikoAbi}__ and `functionName` set to `"approve"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x3b0B993247C9D9EF4e92817380b1A16D0f55813b)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xdf50fE60bFc34bC034e40E05C0Ef8EB2DFb0B181)
 */
export const writeUsdcVariableDebtTokenTaikoApprove =
  /*#__PURE__*/ createWriteContract({
    abi: usdcVariableDebtTokenTaikoAbi,
    address: usdcVariableDebtTokenTaikoAddress,
    functionName: 'approve',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link usdcVariableDebtTokenTaikoAbi}__ and `functionName` set to `"approveDelegation"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x3b0B993247C9D9EF4e92817380b1A16D0f55813b)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xdf50fE60bFc34bC034e40E05C0Ef8EB2DFb0B181)
 */
export const writeUsdcVariableDebtTokenTaikoApproveDelegation =
  /*#__PURE__*/ createWriteContract({
    abi: usdcVariableDebtTokenTaikoAbi,
    address: usdcVariableDebtTokenTaikoAddress,
    functionName: 'approveDelegation',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link usdcVariableDebtTokenTaikoAbi}__ and `functionName` set to `"burn"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x3b0B993247C9D9EF4e92817380b1A16D0f55813b)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xdf50fE60bFc34bC034e40E05C0Ef8EB2DFb0B181)
 */
export const writeUsdcVariableDebtTokenTaikoBurn =
  /*#__PURE__*/ createWriteContract({
    abi: usdcVariableDebtTokenTaikoAbi,
    address: usdcVariableDebtTokenTaikoAddress,
    functionName: 'burn',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link usdcVariableDebtTokenTaikoAbi}__ and `functionName` set to `"decreaseAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x3b0B993247C9D9EF4e92817380b1A16D0f55813b)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xdf50fE60bFc34bC034e40E05C0Ef8EB2DFb0B181)
 */
export const writeUsdcVariableDebtTokenTaikoDecreaseAllowance =
  /*#__PURE__*/ createWriteContract({
    abi: usdcVariableDebtTokenTaikoAbi,
    address: usdcVariableDebtTokenTaikoAddress,
    functionName: 'decreaseAllowance',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link usdcVariableDebtTokenTaikoAbi}__ and `functionName` set to `"delegationWithSig"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x3b0B993247C9D9EF4e92817380b1A16D0f55813b)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xdf50fE60bFc34bC034e40E05C0Ef8EB2DFb0B181)
 */
export const writeUsdcVariableDebtTokenTaikoDelegationWithSig =
  /*#__PURE__*/ createWriteContract({
    abi: usdcVariableDebtTokenTaikoAbi,
    address: usdcVariableDebtTokenTaikoAddress,
    functionName: 'delegationWithSig',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link usdcVariableDebtTokenTaikoAbi}__ and `functionName` set to `"increaseAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x3b0B993247C9D9EF4e92817380b1A16D0f55813b)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xdf50fE60bFc34bC034e40E05C0Ef8EB2DFb0B181)
 */
export const writeUsdcVariableDebtTokenTaikoIncreaseAllowance =
  /*#__PURE__*/ createWriteContract({
    abi: usdcVariableDebtTokenTaikoAbi,
    address: usdcVariableDebtTokenTaikoAddress,
    functionName: 'increaseAllowance',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link usdcVariableDebtTokenTaikoAbi}__ and `functionName` set to `"initialize"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x3b0B993247C9D9EF4e92817380b1A16D0f55813b)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xdf50fE60bFc34bC034e40E05C0Ef8EB2DFb0B181)
 */
export const writeUsdcVariableDebtTokenTaikoInitialize =
  /*#__PURE__*/ createWriteContract({
    abi: usdcVariableDebtTokenTaikoAbi,
    address: usdcVariableDebtTokenTaikoAddress,
    functionName: 'initialize',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link usdcVariableDebtTokenTaikoAbi}__ and `functionName` set to `"mint"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x3b0B993247C9D9EF4e92817380b1A16D0f55813b)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xdf50fE60bFc34bC034e40E05C0Ef8EB2DFb0B181)
 */
export const writeUsdcVariableDebtTokenTaikoMint =
  /*#__PURE__*/ createWriteContract({
    abi: usdcVariableDebtTokenTaikoAbi,
    address: usdcVariableDebtTokenTaikoAddress,
    functionName: 'mint',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link usdcVariableDebtTokenTaikoAbi}__ and `functionName` set to `"setIncentivesController"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x3b0B993247C9D9EF4e92817380b1A16D0f55813b)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xdf50fE60bFc34bC034e40E05C0Ef8EB2DFb0B181)
 */
export const writeUsdcVariableDebtTokenTaikoSetIncentivesController =
  /*#__PURE__*/ createWriteContract({
    abi: usdcVariableDebtTokenTaikoAbi,
    address: usdcVariableDebtTokenTaikoAddress,
    functionName: 'setIncentivesController',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link usdcVariableDebtTokenTaikoAbi}__ and `functionName` set to `"transfer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x3b0B993247C9D9EF4e92817380b1A16D0f55813b)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xdf50fE60bFc34bC034e40E05C0Ef8EB2DFb0B181)
 */
export const writeUsdcVariableDebtTokenTaikoTransfer =
  /*#__PURE__*/ createWriteContract({
    abi: usdcVariableDebtTokenTaikoAbi,
    address: usdcVariableDebtTokenTaikoAddress,
    functionName: 'transfer',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link usdcVariableDebtTokenTaikoAbi}__ and `functionName` set to `"transferFrom"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x3b0B993247C9D9EF4e92817380b1A16D0f55813b)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xdf50fE60bFc34bC034e40E05C0Ef8EB2DFb0B181)
 */
export const writeUsdcVariableDebtTokenTaikoTransferFrom =
  /*#__PURE__*/ createWriteContract({
    abi: usdcVariableDebtTokenTaikoAbi,
    address: usdcVariableDebtTokenTaikoAddress,
    functionName: 'transferFrom',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link usdcVariableDebtTokenTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x3b0B993247C9D9EF4e92817380b1A16D0f55813b)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xdf50fE60bFc34bC034e40E05C0Ef8EB2DFb0B181)
 */
export const simulateUsdcVariableDebtTokenTaiko =
  /*#__PURE__*/ createSimulateContract({
    abi: usdcVariableDebtTokenTaikoAbi,
    address: usdcVariableDebtTokenTaikoAddress,
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link usdcVariableDebtTokenTaikoAbi}__ and `functionName` set to `"approve"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x3b0B993247C9D9EF4e92817380b1A16D0f55813b)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xdf50fE60bFc34bC034e40E05C0Ef8EB2DFb0B181)
 */
export const simulateUsdcVariableDebtTokenTaikoApprove =
  /*#__PURE__*/ createSimulateContract({
    abi: usdcVariableDebtTokenTaikoAbi,
    address: usdcVariableDebtTokenTaikoAddress,
    functionName: 'approve',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link usdcVariableDebtTokenTaikoAbi}__ and `functionName` set to `"approveDelegation"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x3b0B993247C9D9EF4e92817380b1A16D0f55813b)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xdf50fE60bFc34bC034e40E05C0Ef8EB2DFb0B181)
 */
export const simulateUsdcVariableDebtTokenTaikoApproveDelegation =
  /*#__PURE__*/ createSimulateContract({
    abi: usdcVariableDebtTokenTaikoAbi,
    address: usdcVariableDebtTokenTaikoAddress,
    functionName: 'approveDelegation',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link usdcVariableDebtTokenTaikoAbi}__ and `functionName` set to `"burn"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x3b0B993247C9D9EF4e92817380b1A16D0f55813b)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xdf50fE60bFc34bC034e40E05C0Ef8EB2DFb0B181)
 */
export const simulateUsdcVariableDebtTokenTaikoBurn =
  /*#__PURE__*/ createSimulateContract({
    abi: usdcVariableDebtTokenTaikoAbi,
    address: usdcVariableDebtTokenTaikoAddress,
    functionName: 'burn',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link usdcVariableDebtTokenTaikoAbi}__ and `functionName` set to `"decreaseAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x3b0B993247C9D9EF4e92817380b1A16D0f55813b)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xdf50fE60bFc34bC034e40E05C0Ef8EB2DFb0B181)
 */
export const simulateUsdcVariableDebtTokenTaikoDecreaseAllowance =
  /*#__PURE__*/ createSimulateContract({
    abi: usdcVariableDebtTokenTaikoAbi,
    address: usdcVariableDebtTokenTaikoAddress,
    functionName: 'decreaseAllowance',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link usdcVariableDebtTokenTaikoAbi}__ and `functionName` set to `"delegationWithSig"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x3b0B993247C9D9EF4e92817380b1A16D0f55813b)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xdf50fE60bFc34bC034e40E05C0Ef8EB2DFb0B181)
 */
export const simulateUsdcVariableDebtTokenTaikoDelegationWithSig =
  /*#__PURE__*/ createSimulateContract({
    abi: usdcVariableDebtTokenTaikoAbi,
    address: usdcVariableDebtTokenTaikoAddress,
    functionName: 'delegationWithSig',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link usdcVariableDebtTokenTaikoAbi}__ and `functionName` set to `"increaseAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x3b0B993247C9D9EF4e92817380b1A16D0f55813b)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xdf50fE60bFc34bC034e40E05C0Ef8EB2DFb0B181)
 */
export const simulateUsdcVariableDebtTokenTaikoIncreaseAllowance =
  /*#__PURE__*/ createSimulateContract({
    abi: usdcVariableDebtTokenTaikoAbi,
    address: usdcVariableDebtTokenTaikoAddress,
    functionName: 'increaseAllowance',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link usdcVariableDebtTokenTaikoAbi}__ and `functionName` set to `"initialize"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x3b0B993247C9D9EF4e92817380b1A16D0f55813b)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xdf50fE60bFc34bC034e40E05C0Ef8EB2DFb0B181)
 */
export const simulateUsdcVariableDebtTokenTaikoInitialize =
  /*#__PURE__*/ createSimulateContract({
    abi: usdcVariableDebtTokenTaikoAbi,
    address: usdcVariableDebtTokenTaikoAddress,
    functionName: 'initialize',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link usdcVariableDebtTokenTaikoAbi}__ and `functionName` set to `"mint"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x3b0B993247C9D9EF4e92817380b1A16D0f55813b)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xdf50fE60bFc34bC034e40E05C0Ef8EB2DFb0B181)
 */
export const simulateUsdcVariableDebtTokenTaikoMint =
  /*#__PURE__*/ createSimulateContract({
    abi: usdcVariableDebtTokenTaikoAbi,
    address: usdcVariableDebtTokenTaikoAddress,
    functionName: 'mint',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link usdcVariableDebtTokenTaikoAbi}__ and `functionName` set to `"setIncentivesController"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x3b0B993247C9D9EF4e92817380b1A16D0f55813b)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xdf50fE60bFc34bC034e40E05C0Ef8EB2DFb0B181)
 */
export const simulateUsdcVariableDebtTokenTaikoSetIncentivesController =
  /*#__PURE__*/ createSimulateContract({
    abi: usdcVariableDebtTokenTaikoAbi,
    address: usdcVariableDebtTokenTaikoAddress,
    functionName: 'setIncentivesController',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link usdcVariableDebtTokenTaikoAbi}__ and `functionName` set to `"transfer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x3b0B993247C9D9EF4e92817380b1A16D0f55813b)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xdf50fE60bFc34bC034e40E05C0Ef8EB2DFb0B181)
 */
export const simulateUsdcVariableDebtTokenTaikoTransfer =
  /*#__PURE__*/ createSimulateContract({
    abi: usdcVariableDebtTokenTaikoAbi,
    address: usdcVariableDebtTokenTaikoAddress,
    functionName: 'transfer',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link usdcVariableDebtTokenTaikoAbi}__ and `functionName` set to `"transferFrom"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x3b0B993247C9D9EF4e92817380b1A16D0f55813b)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xdf50fE60bFc34bC034e40E05C0Ef8EB2DFb0B181)
 */
export const simulateUsdcVariableDebtTokenTaikoTransferFrom =
  /*#__PURE__*/ createSimulateContract({
    abi: usdcVariableDebtTokenTaikoAbi,
    address: usdcVariableDebtTokenTaikoAddress,
    functionName: 'transferFrom',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link usdcVariableDebtTokenTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x3b0B993247C9D9EF4e92817380b1A16D0f55813b)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xdf50fE60bFc34bC034e40E05C0Ef8EB2DFb0B181)
 */
export const watchUsdcVariableDebtTokenTaikoEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: usdcVariableDebtTokenTaikoAbi,
    address: usdcVariableDebtTokenTaikoAddress,
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link usdcVariableDebtTokenTaikoAbi}__ and `eventName` set to `"Approval"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x3b0B993247C9D9EF4e92817380b1A16D0f55813b)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xdf50fE60bFc34bC034e40E05C0Ef8EB2DFb0B181)
 */
export const watchUsdcVariableDebtTokenTaikoApprovalEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: usdcVariableDebtTokenTaikoAbi,
    address: usdcVariableDebtTokenTaikoAddress,
    eventName: 'Approval',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link usdcVariableDebtTokenTaikoAbi}__ and `eventName` set to `"BorrowAllowanceDelegated"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x3b0B993247C9D9EF4e92817380b1A16D0f55813b)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xdf50fE60bFc34bC034e40E05C0Ef8EB2DFb0B181)
 */
export const watchUsdcVariableDebtTokenTaikoBorrowAllowanceDelegatedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: usdcVariableDebtTokenTaikoAbi,
    address: usdcVariableDebtTokenTaikoAddress,
    eventName: 'BorrowAllowanceDelegated',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link usdcVariableDebtTokenTaikoAbi}__ and `eventName` set to `"Burn"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x3b0B993247C9D9EF4e92817380b1A16D0f55813b)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xdf50fE60bFc34bC034e40E05C0Ef8EB2DFb0B181)
 */
export const watchUsdcVariableDebtTokenTaikoBurnEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: usdcVariableDebtTokenTaikoAbi,
    address: usdcVariableDebtTokenTaikoAddress,
    eventName: 'Burn',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link usdcVariableDebtTokenTaikoAbi}__ and `eventName` set to `"Initialized"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x3b0B993247C9D9EF4e92817380b1A16D0f55813b)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xdf50fE60bFc34bC034e40E05C0Ef8EB2DFb0B181)
 */
export const watchUsdcVariableDebtTokenTaikoInitializedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: usdcVariableDebtTokenTaikoAbi,
    address: usdcVariableDebtTokenTaikoAddress,
    eventName: 'Initialized',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link usdcVariableDebtTokenTaikoAbi}__ and `eventName` set to `"Mint"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x3b0B993247C9D9EF4e92817380b1A16D0f55813b)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xdf50fE60bFc34bC034e40E05C0Ef8EB2DFb0B181)
 */
export const watchUsdcVariableDebtTokenTaikoMintEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: usdcVariableDebtTokenTaikoAbi,
    address: usdcVariableDebtTokenTaikoAddress,
    eventName: 'Mint',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link usdcVariableDebtTokenTaikoAbi}__ and `eventName` set to `"Transfer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x3b0B993247C9D9EF4e92817380b1A16D0f55813b)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xdf50fE60bFc34bC034e40E05C0Ef8EB2DFb0B181)
 */
export const watchUsdcVariableDebtTokenTaikoTransferEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: usdcVariableDebtTokenTaikoAbi,
    address: usdcVariableDebtTokenTaikoAddress,
    eventName: 'Transfer',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdtATokenTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x745E25edB9D10391A288b28ae1385f82F6B1CaCc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x58e3db70e6Ee1a1D192650Da34bcBFEa705da09E)
 */
export const readUsdtATokenTaiko = /*#__PURE__*/ createReadContract({
  abi: usdtATokenTaikoAbi,
  address: usdtATokenTaikoAddress,
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdtATokenTaikoAbi}__ and `functionName` set to `"ATOKEN_REVISION"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x745E25edB9D10391A288b28ae1385f82F6B1CaCc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x58e3db70e6Ee1a1D192650Da34bcBFEa705da09E)
 */
export const readUsdtATokenTaikoAtokenRevision =
  /*#__PURE__*/ createReadContract({
    abi: usdtATokenTaikoAbi,
    address: usdtATokenTaikoAddress,
    functionName: 'ATOKEN_REVISION',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdtATokenTaikoAbi}__ and `functionName` set to `"DOMAIN_SEPARATOR"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x745E25edB9D10391A288b28ae1385f82F6B1CaCc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x58e3db70e6Ee1a1D192650Da34bcBFEa705da09E)
 */
export const readUsdtATokenTaikoDomainSeparator =
  /*#__PURE__*/ createReadContract({
    abi: usdtATokenTaikoAbi,
    address: usdtATokenTaikoAddress,
    functionName: 'DOMAIN_SEPARATOR',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdtATokenTaikoAbi}__ and `functionName` set to `"EIP712_REVISION"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x745E25edB9D10391A288b28ae1385f82F6B1CaCc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x58e3db70e6Ee1a1D192650Da34bcBFEa705da09E)
 */
export const readUsdtATokenTaikoEip712Revision =
  /*#__PURE__*/ createReadContract({
    abi: usdtATokenTaikoAbi,
    address: usdtATokenTaikoAddress,
    functionName: 'EIP712_REVISION',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdtATokenTaikoAbi}__ and `functionName` set to `"PERMIT_TYPEHASH"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x745E25edB9D10391A288b28ae1385f82F6B1CaCc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x58e3db70e6Ee1a1D192650Da34bcBFEa705da09E)
 */
export const readUsdtATokenTaikoPermitTypehash =
  /*#__PURE__*/ createReadContract({
    abi: usdtATokenTaikoAbi,
    address: usdtATokenTaikoAddress,
    functionName: 'PERMIT_TYPEHASH',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdtATokenTaikoAbi}__ and `functionName` set to `"POOL"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x745E25edB9D10391A288b28ae1385f82F6B1CaCc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x58e3db70e6Ee1a1D192650Da34bcBFEa705da09E)
 */
export const readUsdtATokenTaikoPool = /*#__PURE__*/ createReadContract({
  abi: usdtATokenTaikoAbi,
  address: usdtATokenTaikoAddress,
  functionName: 'POOL',
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdtATokenTaikoAbi}__ and `functionName` set to `"RESERVE_TREASURY_ADDRESS"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x745E25edB9D10391A288b28ae1385f82F6B1CaCc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x58e3db70e6Ee1a1D192650Da34bcBFEa705da09E)
 */
export const readUsdtATokenTaikoReserveTreasuryAddress =
  /*#__PURE__*/ createReadContract({
    abi: usdtATokenTaikoAbi,
    address: usdtATokenTaikoAddress,
    functionName: 'RESERVE_TREASURY_ADDRESS',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdtATokenTaikoAbi}__ and `functionName` set to `"UNDERLYING_ASSET_ADDRESS"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x745E25edB9D10391A288b28ae1385f82F6B1CaCc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x58e3db70e6Ee1a1D192650Da34bcBFEa705da09E)
 */
export const readUsdtATokenTaikoUnderlyingAssetAddress =
  /*#__PURE__*/ createReadContract({
    abi: usdtATokenTaikoAbi,
    address: usdtATokenTaikoAddress,
    functionName: 'UNDERLYING_ASSET_ADDRESS',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdtATokenTaikoAbi}__ and `functionName` set to `"allowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x745E25edB9D10391A288b28ae1385f82F6B1CaCc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x58e3db70e6Ee1a1D192650Da34bcBFEa705da09E)
 */
export const readUsdtATokenTaikoAllowance = /*#__PURE__*/ createReadContract({
  abi: usdtATokenTaikoAbi,
  address: usdtATokenTaikoAddress,
  functionName: 'allowance',
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdtATokenTaikoAbi}__ and `functionName` set to `"balanceOf"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x745E25edB9D10391A288b28ae1385f82F6B1CaCc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x58e3db70e6Ee1a1D192650Da34bcBFEa705da09E)
 */
export const readUsdtATokenTaikoBalanceOf = /*#__PURE__*/ createReadContract({
  abi: usdtATokenTaikoAbi,
  address: usdtATokenTaikoAddress,
  functionName: 'balanceOf',
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdtATokenTaikoAbi}__ and `functionName` set to `"decimals"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x745E25edB9D10391A288b28ae1385f82F6B1CaCc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x58e3db70e6Ee1a1D192650Da34bcBFEa705da09E)
 */
export const readUsdtATokenTaikoDecimals = /*#__PURE__*/ createReadContract({
  abi: usdtATokenTaikoAbi,
  address: usdtATokenTaikoAddress,
  functionName: 'decimals',
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdtATokenTaikoAbi}__ and `functionName` set to `"getIncentivesController"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x745E25edB9D10391A288b28ae1385f82F6B1CaCc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x58e3db70e6Ee1a1D192650Da34bcBFEa705da09E)
 */
export const readUsdtATokenTaikoGetIncentivesController =
  /*#__PURE__*/ createReadContract({
    abi: usdtATokenTaikoAbi,
    address: usdtATokenTaikoAddress,
    functionName: 'getIncentivesController',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdtATokenTaikoAbi}__ and `functionName` set to `"getPreviousIndex"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x745E25edB9D10391A288b28ae1385f82F6B1CaCc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x58e3db70e6Ee1a1D192650Da34bcBFEa705da09E)
 */
export const readUsdtATokenTaikoGetPreviousIndex =
  /*#__PURE__*/ createReadContract({
    abi: usdtATokenTaikoAbi,
    address: usdtATokenTaikoAddress,
    functionName: 'getPreviousIndex',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdtATokenTaikoAbi}__ and `functionName` set to `"getScaledUserBalanceAndSupply"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x745E25edB9D10391A288b28ae1385f82F6B1CaCc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x58e3db70e6Ee1a1D192650Da34bcBFEa705da09E)
 */
export const readUsdtATokenTaikoGetScaledUserBalanceAndSupply =
  /*#__PURE__*/ createReadContract({
    abi: usdtATokenTaikoAbi,
    address: usdtATokenTaikoAddress,
    functionName: 'getScaledUserBalanceAndSupply',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdtATokenTaikoAbi}__ and `functionName` set to `"name"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x745E25edB9D10391A288b28ae1385f82F6B1CaCc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x58e3db70e6Ee1a1D192650Da34bcBFEa705da09E)
 */
export const readUsdtATokenTaikoName = /*#__PURE__*/ createReadContract({
  abi: usdtATokenTaikoAbi,
  address: usdtATokenTaikoAddress,
  functionName: 'name',
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdtATokenTaikoAbi}__ and `functionName` set to `"nonces"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x745E25edB9D10391A288b28ae1385f82F6B1CaCc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x58e3db70e6Ee1a1D192650Da34bcBFEa705da09E)
 */
export const readUsdtATokenTaikoNonces = /*#__PURE__*/ createReadContract({
  abi: usdtATokenTaikoAbi,
  address: usdtATokenTaikoAddress,
  functionName: 'nonces',
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdtATokenTaikoAbi}__ and `functionName` set to `"scaledBalanceOf"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x745E25edB9D10391A288b28ae1385f82F6B1CaCc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x58e3db70e6Ee1a1D192650Da34bcBFEa705da09E)
 */
export const readUsdtATokenTaikoScaledBalanceOf =
  /*#__PURE__*/ createReadContract({
    abi: usdtATokenTaikoAbi,
    address: usdtATokenTaikoAddress,
    functionName: 'scaledBalanceOf',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdtATokenTaikoAbi}__ and `functionName` set to `"scaledTotalSupply"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x745E25edB9D10391A288b28ae1385f82F6B1CaCc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x58e3db70e6Ee1a1D192650Da34bcBFEa705da09E)
 */
export const readUsdtATokenTaikoScaledTotalSupply =
  /*#__PURE__*/ createReadContract({
    abi: usdtATokenTaikoAbi,
    address: usdtATokenTaikoAddress,
    functionName: 'scaledTotalSupply',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdtATokenTaikoAbi}__ and `functionName` set to `"symbol"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x745E25edB9D10391A288b28ae1385f82F6B1CaCc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x58e3db70e6Ee1a1D192650Da34bcBFEa705da09E)
 */
export const readUsdtATokenTaikoSymbol = /*#__PURE__*/ createReadContract({
  abi: usdtATokenTaikoAbi,
  address: usdtATokenTaikoAddress,
  functionName: 'symbol',
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdtATokenTaikoAbi}__ and `functionName` set to `"totalSupply"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x745E25edB9D10391A288b28ae1385f82F6B1CaCc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x58e3db70e6Ee1a1D192650Da34bcBFEa705da09E)
 */
export const readUsdtATokenTaikoTotalSupply = /*#__PURE__*/ createReadContract({
  abi: usdtATokenTaikoAbi,
  address: usdtATokenTaikoAddress,
  functionName: 'totalSupply',
})

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link usdtATokenTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x745E25edB9D10391A288b28ae1385f82F6B1CaCc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x58e3db70e6Ee1a1D192650Da34bcBFEa705da09E)
 */
export const writeUsdtATokenTaiko = /*#__PURE__*/ createWriteContract({
  abi: usdtATokenTaikoAbi,
  address: usdtATokenTaikoAddress,
})

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link usdtATokenTaikoAbi}__ and `functionName` set to `"approve"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x745E25edB9D10391A288b28ae1385f82F6B1CaCc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x58e3db70e6Ee1a1D192650Da34bcBFEa705da09E)
 */
export const writeUsdtATokenTaikoApprove = /*#__PURE__*/ createWriteContract({
  abi: usdtATokenTaikoAbi,
  address: usdtATokenTaikoAddress,
  functionName: 'approve',
})

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link usdtATokenTaikoAbi}__ and `functionName` set to `"burn"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x745E25edB9D10391A288b28ae1385f82F6B1CaCc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x58e3db70e6Ee1a1D192650Da34bcBFEa705da09E)
 */
export const writeUsdtATokenTaikoBurn = /*#__PURE__*/ createWriteContract({
  abi: usdtATokenTaikoAbi,
  address: usdtATokenTaikoAddress,
  functionName: 'burn',
})

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link usdtATokenTaikoAbi}__ and `functionName` set to `"decreaseAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x745E25edB9D10391A288b28ae1385f82F6B1CaCc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x58e3db70e6Ee1a1D192650Da34bcBFEa705da09E)
 */
export const writeUsdtATokenTaikoDecreaseAllowance =
  /*#__PURE__*/ createWriteContract({
    abi: usdtATokenTaikoAbi,
    address: usdtATokenTaikoAddress,
    functionName: 'decreaseAllowance',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link usdtATokenTaikoAbi}__ and `functionName` set to `"handleRepayment"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x745E25edB9D10391A288b28ae1385f82F6B1CaCc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x58e3db70e6Ee1a1D192650Da34bcBFEa705da09E)
 */
export const writeUsdtATokenTaikoHandleRepayment =
  /*#__PURE__*/ createWriteContract({
    abi: usdtATokenTaikoAbi,
    address: usdtATokenTaikoAddress,
    functionName: 'handleRepayment',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link usdtATokenTaikoAbi}__ and `functionName` set to `"increaseAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x745E25edB9D10391A288b28ae1385f82F6B1CaCc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x58e3db70e6Ee1a1D192650Da34bcBFEa705da09E)
 */
export const writeUsdtATokenTaikoIncreaseAllowance =
  /*#__PURE__*/ createWriteContract({
    abi: usdtATokenTaikoAbi,
    address: usdtATokenTaikoAddress,
    functionName: 'increaseAllowance',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link usdtATokenTaikoAbi}__ and `functionName` set to `"initialize"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x745E25edB9D10391A288b28ae1385f82F6B1CaCc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x58e3db70e6Ee1a1D192650Da34bcBFEa705da09E)
 */
export const writeUsdtATokenTaikoInitialize = /*#__PURE__*/ createWriteContract(
  {
    abi: usdtATokenTaikoAbi,
    address: usdtATokenTaikoAddress,
    functionName: 'initialize',
  },
)

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link usdtATokenTaikoAbi}__ and `functionName` set to `"mint"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x745E25edB9D10391A288b28ae1385f82F6B1CaCc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x58e3db70e6Ee1a1D192650Da34bcBFEa705da09E)
 */
export const writeUsdtATokenTaikoMint = /*#__PURE__*/ createWriteContract({
  abi: usdtATokenTaikoAbi,
  address: usdtATokenTaikoAddress,
  functionName: 'mint',
})

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link usdtATokenTaikoAbi}__ and `functionName` set to `"mintToTreasury"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x745E25edB9D10391A288b28ae1385f82F6B1CaCc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x58e3db70e6Ee1a1D192650Da34bcBFEa705da09E)
 */
export const writeUsdtATokenTaikoMintToTreasury =
  /*#__PURE__*/ createWriteContract({
    abi: usdtATokenTaikoAbi,
    address: usdtATokenTaikoAddress,
    functionName: 'mintToTreasury',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link usdtATokenTaikoAbi}__ and `functionName` set to `"permit"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x745E25edB9D10391A288b28ae1385f82F6B1CaCc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x58e3db70e6Ee1a1D192650Da34bcBFEa705da09E)
 */
export const writeUsdtATokenTaikoPermit = /*#__PURE__*/ createWriteContract({
  abi: usdtATokenTaikoAbi,
  address: usdtATokenTaikoAddress,
  functionName: 'permit',
})

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link usdtATokenTaikoAbi}__ and `functionName` set to `"rescueTokens"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x745E25edB9D10391A288b28ae1385f82F6B1CaCc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x58e3db70e6Ee1a1D192650Da34bcBFEa705da09E)
 */
export const writeUsdtATokenTaikoRescueTokens =
  /*#__PURE__*/ createWriteContract({
    abi: usdtATokenTaikoAbi,
    address: usdtATokenTaikoAddress,
    functionName: 'rescueTokens',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link usdtATokenTaikoAbi}__ and `functionName` set to `"setIncentivesController"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x745E25edB9D10391A288b28ae1385f82F6B1CaCc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x58e3db70e6Ee1a1D192650Da34bcBFEa705da09E)
 */
export const writeUsdtATokenTaikoSetIncentivesController =
  /*#__PURE__*/ createWriteContract({
    abi: usdtATokenTaikoAbi,
    address: usdtATokenTaikoAddress,
    functionName: 'setIncentivesController',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link usdtATokenTaikoAbi}__ and `functionName` set to `"transfer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x745E25edB9D10391A288b28ae1385f82F6B1CaCc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x58e3db70e6Ee1a1D192650Da34bcBFEa705da09E)
 */
export const writeUsdtATokenTaikoTransfer = /*#__PURE__*/ createWriteContract({
  abi: usdtATokenTaikoAbi,
  address: usdtATokenTaikoAddress,
  functionName: 'transfer',
})

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link usdtATokenTaikoAbi}__ and `functionName` set to `"transferFrom"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x745E25edB9D10391A288b28ae1385f82F6B1CaCc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x58e3db70e6Ee1a1D192650Da34bcBFEa705da09E)
 */
export const writeUsdtATokenTaikoTransferFrom =
  /*#__PURE__*/ createWriteContract({
    abi: usdtATokenTaikoAbi,
    address: usdtATokenTaikoAddress,
    functionName: 'transferFrom',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link usdtATokenTaikoAbi}__ and `functionName` set to `"transferOnLiquidation"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x745E25edB9D10391A288b28ae1385f82F6B1CaCc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x58e3db70e6Ee1a1D192650Da34bcBFEa705da09E)
 */
export const writeUsdtATokenTaikoTransferOnLiquidation =
  /*#__PURE__*/ createWriteContract({
    abi: usdtATokenTaikoAbi,
    address: usdtATokenTaikoAddress,
    functionName: 'transferOnLiquidation',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link usdtATokenTaikoAbi}__ and `functionName` set to `"transferUnderlyingTo"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x745E25edB9D10391A288b28ae1385f82F6B1CaCc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x58e3db70e6Ee1a1D192650Da34bcBFEa705da09E)
 */
export const writeUsdtATokenTaikoTransferUnderlyingTo =
  /*#__PURE__*/ createWriteContract({
    abi: usdtATokenTaikoAbi,
    address: usdtATokenTaikoAddress,
    functionName: 'transferUnderlyingTo',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link usdtATokenTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x745E25edB9D10391A288b28ae1385f82F6B1CaCc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x58e3db70e6Ee1a1D192650Da34bcBFEa705da09E)
 */
export const simulateUsdtATokenTaiko = /*#__PURE__*/ createSimulateContract({
  abi: usdtATokenTaikoAbi,
  address: usdtATokenTaikoAddress,
})

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link usdtATokenTaikoAbi}__ and `functionName` set to `"approve"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x745E25edB9D10391A288b28ae1385f82F6B1CaCc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x58e3db70e6Ee1a1D192650Da34bcBFEa705da09E)
 */
export const simulateUsdtATokenTaikoApprove =
  /*#__PURE__*/ createSimulateContract({
    abi: usdtATokenTaikoAbi,
    address: usdtATokenTaikoAddress,
    functionName: 'approve',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link usdtATokenTaikoAbi}__ and `functionName` set to `"burn"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x745E25edB9D10391A288b28ae1385f82F6B1CaCc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x58e3db70e6Ee1a1D192650Da34bcBFEa705da09E)
 */
export const simulateUsdtATokenTaikoBurn = /*#__PURE__*/ createSimulateContract(
  {
    abi: usdtATokenTaikoAbi,
    address: usdtATokenTaikoAddress,
    functionName: 'burn',
  },
)

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link usdtATokenTaikoAbi}__ and `functionName` set to `"decreaseAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x745E25edB9D10391A288b28ae1385f82F6B1CaCc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x58e3db70e6Ee1a1D192650Da34bcBFEa705da09E)
 */
export const simulateUsdtATokenTaikoDecreaseAllowance =
  /*#__PURE__*/ createSimulateContract({
    abi: usdtATokenTaikoAbi,
    address: usdtATokenTaikoAddress,
    functionName: 'decreaseAllowance',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link usdtATokenTaikoAbi}__ and `functionName` set to `"handleRepayment"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x745E25edB9D10391A288b28ae1385f82F6B1CaCc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x58e3db70e6Ee1a1D192650Da34bcBFEa705da09E)
 */
export const simulateUsdtATokenTaikoHandleRepayment =
  /*#__PURE__*/ createSimulateContract({
    abi: usdtATokenTaikoAbi,
    address: usdtATokenTaikoAddress,
    functionName: 'handleRepayment',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link usdtATokenTaikoAbi}__ and `functionName` set to `"increaseAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x745E25edB9D10391A288b28ae1385f82F6B1CaCc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x58e3db70e6Ee1a1D192650Da34bcBFEa705da09E)
 */
export const simulateUsdtATokenTaikoIncreaseAllowance =
  /*#__PURE__*/ createSimulateContract({
    abi: usdtATokenTaikoAbi,
    address: usdtATokenTaikoAddress,
    functionName: 'increaseAllowance',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link usdtATokenTaikoAbi}__ and `functionName` set to `"initialize"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x745E25edB9D10391A288b28ae1385f82F6B1CaCc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x58e3db70e6Ee1a1D192650Da34bcBFEa705da09E)
 */
export const simulateUsdtATokenTaikoInitialize =
  /*#__PURE__*/ createSimulateContract({
    abi: usdtATokenTaikoAbi,
    address: usdtATokenTaikoAddress,
    functionName: 'initialize',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link usdtATokenTaikoAbi}__ and `functionName` set to `"mint"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x745E25edB9D10391A288b28ae1385f82F6B1CaCc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x58e3db70e6Ee1a1D192650Da34bcBFEa705da09E)
 */
export const simulateUsdtATokenTaikoMint = /*#__PURE__*/ createSimulateContract(
  {
    abi: usdtATokenTaikoAbi,
    address: usdtATokenTaikoAddress,
    functionName: 'mint',
  },
)

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link usdtATokenTaikoAbi}__ and `functionName` set to `"mintToTreasury"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x745E25edB9D10391A288b28ae1385f82F6B1CaCc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x58e3db70e6Ee1a1D192650Da34bcBFEa705da09E)
 */
export const simulateUsdtATokenTaikoMintToTreasury =
  /*#__PURE__*/ createSimulateContract({
    abi: usdtATokenTaikoAbi,
    address: usdtATokenTaikoAddress,
    functionName: 'mintToTreasury',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link usdtATokenTaikoAbi}__ and `functionName` set to `"permit"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x745E25edB9D10391A288b28ae1385f82F6B1CaCc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x58e3db70e6Ee1a1D192650Da34bcBFEa705da09E)
 */
export const simulateUsdtATokenTaikoPermit =
  /*#__PURE__*/ createSimulateContract({
    abi: usdtATokenTaikoAbi,
    address: usdtATokenTaikoAddress,
    functionName: 'permit',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link usdtATokenTaikoAbi}__ and `functionName` set to `"rescueTokens"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x745E25edB9D10391A288b28ae1385f82F6B1CaCc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x58e3db70e6Ee1a1D192650Da34bcBFEa705da09E)
 */
export const simulateUsdtATokenTaikoRescueTokens =
  /*#__PURE__*/ createSimulateContract({
    abi: usdtATokenTaikoAbi,
    address: usdtATokenTaikoAddress,
    functionName: 'rescueTokens',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link usdtATokenTaikoAbi}__ and `functionName` set to `"setIncentivesController"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x745E25edB9D10391A288b28ae1385f82F6B1CaCc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x58e3db70e6Ee1a1D192650Da34bcBFEa705da09E)
 */
export const simulateUsdtATokenTaikoSetIncentivesController =
  /*#__PURE__*/ createSimulateContract({
    abi: usdtATokenTaikoAbi,
    address: usdtATokenTaikoAddress,
    functionName: 'setIncentivesController',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link usdtATokenTaikoAbi}__ and `functionName` set to `"transfer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x745E25edB9D10391A288b28ae1385f82F6B1CaCc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x58e3db70e6Ee1a1D192650Da34bcBFEa705da09E)
 */
export const simulateUsdtATokenTaikoTransfer =
  /*#__PURE__*/ createSimulateContract({
    abi: usdtATokenTaikoAbi,
    address: usdtATokenTaikoAddress,
    functionName: 'transfer',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link usdtATokenTaikoAbi}__ and `functionName` set to `"transferFrom"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x745E25edB9D10391A288b28ae1385f82F6B1CaCc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x58e3db70e6Ee1a1D192650Da34bcBFEa705da09E)
 */
export const simulateUsdtATokenTaikoTransferFrom =
  /*#__PURE__*/ createSimulateContract({
    abi: usdtATokenTaikoAbi,
    address: usdtATokenTaikoAddress,
    functionName: 'transferFrom',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link usdtATokenTaikoAbi}__ and `functionName` set to `"transferOnLiquidation"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x745E25edB9D10391A288b28ae1385f82F6B1CaCc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x58e3db70e6Ee1a1D192650Da34bcBFEa705da09E)
 */
export const simulateUsdtATokenTaikoTransferOnLiquidation =
  /*#__PURE__*/ createSimulateContract({
    abi: usdtATokenTaikoAbi,
    address: usdtATokenTaikoAddress,
    functionName: 'transferOnLiquidation',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link usdtATokenTaikoAbi}__ and `functionName` set to `"transferUnderlyingTo"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x745E25edB9D10391A288b28ae1385f82F6B1CaCc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x58e3db70e6Ee1a1D192650Da34bcBFEa705da09E)
 */
export const simulateUsdtATokenTaikoTransferUnderlyingTo =
  /*#__PURE__*/ createSimulateContract({
    abi: usdtATokenTaikoAbi,
    address: usdtATokenTaikoAddress,
    functionName: 'transferUnderlyingTo',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link usdtATokenTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x745E25edB9D10391A288b28ae1385f82F6B1CaCc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x58e3db70e6Ee1a1D192650Da34bcBFEa705da09E)
 */
export const watchUsdtATokenTaikoEvent = /*#__PURE__*/ createWatchContractEvent(
  { abi: usdtATokenTaikoAbi, address: usdtATokenTaikoAddress },
)

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link usdtATokenTaikoAbi}__ and `eventName` set to `"Approval"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x745E25edB9D10391A288b28ae1385f82F6B1CaCc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x58e3db70e6Ee1a1D192650Da34bcBFEa705da09E)
 */
export const watchUsdtATokenTaikoApprovalEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: usdtATokenTaikoAbi,
    address: usdtATokenTaikoAddress,
    eventName: 'Approval',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link usdtATokenTaikoAbi}__ and `eventName` set to `"BalanceTransfer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x745E25edB9D10391A288b28ae1385f82F6B1CaCc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x58e3db70e6Ee1a1D192650Da34bcBFEa705da09E)
 */
export const watchUsdtATokenTaikoBalanceTransferEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: usdtATokenTaikoAbi,
    address: usdtATokenTaikoAddress,
    eventName: 'BalanceTransfer',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link usdtATokenTaikoAbi}__ and `eventName` set to `"Burn"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x745E25edB9D10391A288b28ae1385f82F6B1CaCc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x58e3db70e6Ee1a1D192650Da34bcBFEa705da09E)
 */
export const watchUsdtATokenTaikoBurnEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: usdtATokenTaikoAbi,
    address: usdtATokenTaikoAddress,
    eventName: 'Burn',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link usdtATokenTaikoAbi}__ and `eventName` set to `"Initialized"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x745E25edB9D10391A288b28ae1385f82F6B1CaCc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x58e3db70e6Ee1a1D192650Da34bcBFEa705da09E)
 */
export const watchUsdtATokenTaikoInitializedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: usdtATokenTaikoAbi,
    address: usdtATokenTaikoAddress,
    eventName: 'Initialized',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link usdtATokenTaikoAbi}__ and `eventName` set to `"Mint"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x745E25edB9D10391A288b28ae1385f82F6B1CaCc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x58e3db70e6Ee1a1D192650Da34bcBFEa705da09E)
 */
export const watchUsdtATokenTaikoMintEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: usdtATokenTaikoAbi,
    address: usdtATokenTaikoAddress,
    eventName: 'Mint',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link usdtATokenTaikoAbi}__ and `eventName` set to `"Transfer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x745E25edB9D10391A288b28ae1385f82F6B1CaCc)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x58e3db70e6Ee1a1D192650Da34bcBFEa705da09E)
 */
export const watchUsdtATokenTaikoTransferEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: usdtATokenTaikoAbi,
    address: usdtATokenTaikoAddress,
    eventName: 'Transfer',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdtStableDebtTokenTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xA436Ebde4FdBf95DDc419b2BB378f91eb2196972)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7B2974f5f356Dc6516716a4BBCc06AB0230aCC77)
 */
export const readUsdtStableDebtTokenTaiko = /*#__PURE__*/ createReadContract({
  abi: usdtStableDebtTokenTaikoAbi,
  address: usdtStableDebtTokenTaikoAddress,
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdtStableDebtTokenTaikoAbi}__ and `functionName` set to `"DEBT_TOKEN_REVISION"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xA436Ebde4FdBf95DDc419b2BB378f91eb2196972)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7B2974f5f356Dc6516716a4BBCc06AB0230aCC77)
 */
export const readUsdtStableDebtTokenTaikoDebtTokenRevision =
  /*#__PURE__*/ createReadContract({
    abi: usdtStableDebtTokenTaikoAbi,
    address: usdtStableDebtTokenTaikoAddress,
    functionName: 'DEBT_TOKEN_REVISION',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdtStableDebtTokenTaikoAbi}__ and `functionName` set to `"DELEGATION_WITH_SIG_TYPEHASH"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xA436Ebde4FdBf95DDc419b2BB378f91eb2196972)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7B2974f5f356Dc6516716a4BBCc06AB0230aCC77)
 */
export const readUsdtStableDebtTokenTaikoDelegationWithSigTypehash =
  /*#__PURE__*/ createReadContract({
    abi: usdtStableDebtTokenTaikoAbi,
    address: usdtStableDebtTokenTaikoAddress,
    functionName: 'DELEGATION_WITH_SIG_TYPEHASH',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdtStableDebtTokenTaikoAbi}__ and `functionName` set to `"DOMAIN_SEPARATOR"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xA436Ebde4FdBf95DDc419b2BB378f91eb2196972)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7B2974f5f356Dc6516716a4BBCc06AB0230aCC77)
 */
export const readUsdtStableDebtTokenTaikoDomainSeparator =
  /*#__PURE__*/ createReadContract({
    abi: usdtStableDebtTokenTaikoAbi,
    address: usdtStableDebtTokenTaikoAddress,
    functionName: 'DOMAIN_SEPARATOR',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdtStableDebtTokenTaikoAbi}__ and `functionName` set to `"EIP712_REVISION"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xA436Ebde4FdBf95DDc419b2BB378f91eb2196972)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7B2974f5f356Dc6516716a4BBCc06AB0230aCC77)
 */
export const readUsdtStableDebtTokenTaikoEip712Revision =
  /*#__PURE__*/ createReadContract({
    abi: usdtStableDebtTokenTaikoAbi,
    address: usdtStableDebtTokenTaikoAddress,
    functionName: 'EIP712_REVISION',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdtStableDebtTokenTaikoAbi}__ and `functionName` set to `"POOL"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xA436Ebde4FdBf95DDc419b2BB378f91eb2196972)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7B2974f5f356Dc6516716a4BBCc06AB0230aCC77)
 */
export const readUsdtStableDebtTokenTaikoPool =
  /*#__PURE__*/ createReadContract({
    abi: usdtStableDebtTokenTaikoAbi,
    address: usdtStableDebtTokenTaikoAddress,
    functionName: 'POOL',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdtStableDebtTokenTaikoAbi}__ and `functionName` set to `"UNDERLYING_ASSET_ADDRESS"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xA436Ebde4FdBf95DDc419b2BB378f91eb2196972)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7B2974f5f356Dc6516716a4BBCc06AB0230aCC77)
 */
export const readUsdtStableDebtTokenTaikoUnderlyingAssetAddress =
  /*#__PURE__*/ createReadContract({
    abi: usdtStableDebtTokenTaikoAbi,
    address: usdtStableDebtTokenTaikoAddress,
    functionName: 'UNDERLYING_ASSET_ADDRESS',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdtStableDebtTokenTaikoAbi}__ and `functionName` set to `"allowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xA436Ebde4FdBf95DDc419b2BB378f91eb2196972)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7B2974f5f356Dc6516716a4BBCc06AB0230aCC77)
 */
export const readUsdtStableDebtTokenTaikoAllowance =
  /*#__PURE__*/ createReadContract({
    abi: usdtStableDebtTokenTaikoAbi,
    address: usdtStableDebtTokenTaikoAddress,
    functionName: 'allowance',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdtStableDebtTokenTaikoAbi}__ and `functionName` set to `"balanceOf"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xA436Ebde4FdBf95DDc419b2BB378f91eb2196972)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7B2974f5f356Dc6516716a4BBCc06AB0230aCC77)
 */
export const readUsdtStableDebtTokenTaikoBalanceOf =
  /*#__PURE__*/ createReadContract({
    abi: usdtStableDebtTokenTaikoAbi,
    address: usdtStableDebtTokenTaikoAddress,
    functionName: 'balanceOf',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdtStableDebtTokenTaikoAbi}__ and `functionName` set to `"borrowAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xA436Ebde4FdBf95DDc419b2BB378f91eb2196972)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7B2974f5f356Dc6516716a4BBCc06AB0230aCC77)
 */
export const readUsdtStableDebtTokenTaikoBorrowAllowance =
  /*#__PURE__*/ createReadContract({
    abi: usdtStableDebtTokenTaikoAbi,
    address: usdtStableDebtTokenTaikoAddress,
    functionName: 'borrowAllowance',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdtStableDebtTokenTaikoAbi}__ and `functionName` set to `"decimals"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xA436Ebde4FdBf95DDc419b2BB378f91eb2196972)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7B2974f5f356Dc6516716a4BBCc06AB0230aCC77)
 */
export const readUsdtStableDebtTokenTaikoDecimals =
  /*#__PURE__*/ createReadContract({
    abi: usdtStableDebtTokenTaikoAbi,
    address: usdtStableDebtTokenTaikoAddress,
    functionName: 'decimals',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdtStableDebtTokenTaikoAbi}__ and `functionName` set to `"getAverageStableRate"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xA436Ebde4FdBf95DDc419b2BB378f91eb2196972)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7B2974f5f356Dc6516716a4BBCc06AB0230aCC77)
 */
export const readUsdtStableDebtTokenTaikoGetAverageStableRate =
  /*#__PURE__*/ createReadContract({
    abi: usdtStableDebtTokenTaikoAbi,
    address: usdtStableDebtTokenTaikoAddress,
    functionName: 'getAverageStableRate',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdtStableDebtTokenTaikoAbi}__ and `functionName` set to `"getIncentivesController"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xA436Ebde4FdBf95DDc419b2BB378f91eb2196972)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7B2974f5f356Dc6516716a4BBCc06AB0230aCC77)
 */
export const readUsdtStableDebtTokenTaikoGetIncentivesController =
  /*#__PURE__*/ createReadContract({
    abi: usdtStableDebtTokenTaikoAbi,
    address: usdtStableDebtTokenTaikoAddress,
    functionName: 'getIncentivesController',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdtStableDebtTokenTaikoAbi}__ and `functionName` set to `"getSupplyData"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xA436Ebde4FdBf95DDc419b2BB378f91eb2196972)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7B2974f5f356Dc6516716a4BBCc06AB0230aCC77)
 */
export const readUsdtStableDebtTokenTaikoGetSupplyData =
  /*#__PURE__*/ createReadContract({
    abi: usdtStableDebtTokenTaikoAbi,
    address: usdtStableDebtTokenTaikoAddress,
    functionName: 'getSupplyData',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdtStableDebtTokenTaikoAbi}__ and `functionName` set to `"getTotalSupplyAndAvgRate"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xA436Ebde4FdBf95DDc419b2BB378f91eb2196972)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7B2974f5f356Dc6516716a4BBCc06AB0230aCC77)
 */
export const readUsdtStableDebtTokenTaikoGetTotalSupplyAndAvgRate =
  /*#__PURE__*/ createReadContract({
    abi: usdtStableDebtTokenTaikoAbi,
    address: usdtStableDebtTokenTaikoAddress,
    functionName: 'getTotalSupplyAndAvgRate',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdtStableDebtTokenTaikoAbi}__ and `functionName` set to `"getTotalSupplyLastUpdated"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xA436Ebde4FdBf95DDc419b2BB378f91eb2196972)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7B2974f5f356Dc6516716a4BBCc06AB0230aCC77)
 */
export const readUsdtStableDebtTokenTaikoGetTotalSupplyLastUpdated =
  /*#__PURE__*/ createReadContract({
    abi: usdtStableDebtTokenTaikoAbi,
    address: usdtStableDebtTokenTaikoAddress,
    functionName: 'getTotalSupplyLastUpdated',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdtStableDebtTokenTaikoAbi}__ and `functionName` set to `"getUserLastUpdated"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xA436Ebde4FdBf95DDc419b2BB378f91eb2196972)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7B2974f5f356Dc6516716a4BBCc06AB0230aCC77)
 */
export const readUsdtStableDebtTokenTaikoGetUserLastUpdated =
  /*#__PURE__*/ createReadContract({
    abi: usdtStableDebtTokenTaikoAbi,
    address: usdtStableDebtTokenTaikoAddress,
    functionName: 'getUserLastUpdated',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdtStableDebtTokenTaikoAbi}__ and `functionName` set to `"getUserStableRate"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xA436Ebde4FdBf95DDc419b2BB378f91eb2196972)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7B2974f5f356Dc6516716a4BBCc06AB0230aCC77)
 */
export const readUsdtStableDebtTokenTaikoGetUserStableRate =
  /*#__PURE__*/ createReadContract({
    abi: usdtStableDebtTokenTaikoAbi,
    address: usdtStableDebtTokenTaikoAddress,
    functionName: 'getUserStableRate',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdtStableDebtTokenTaikoAbi}__ and `functionName` set to `"name"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xA436Ebde4FdBf95DDc419b2BB378f91eb2196972)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7B2974f5f356Dc6516716a4BBCc06AB0230aCC77)
 */
export const readUsdtStableDebtTokenTaikoName =
  /*#__PURE__*/ createReadContract({
    abi: usdtStableDebtTokenTaikoAbi,
    address: usdtStableDebtTokenTaikoAddress,
    functionName: 'name',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdtStableDebtTokenTaikoAbi}__ and `functionName` set to `"nonces"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xA436Ebde4FdBf95DDc419b2BB378f91eb2196972)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7B2974f5f356Dc6516716a4BBCc06AB0230aCC77)
 */
export const readUsdtStableDebtTokenTaikoNonces =
  /*#__PURE__*/ createReadContract({
    abi: usdtStableDebtTokenTaikoAbi,
    address: usdtStableDebtTokenTaikoAddress,
    functionName: 'nonces',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdtStableDebtTokenTaikoAbi}__ and `functionName` set to `"principalBalanceOf"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xA436Ebde4FdBf95DDc419b2BB378f91eb2196972)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7B2974f5f356Dc6516716a4BBCc06AB0230aCC77)
 */
export const readUsdtStableDebtTokenTaikoPrincipalBalanceOf =
  /*#__PURE__*/ createReadContract({
    abi: usdtStableDebtTokenTaikoAbi,
    address: usdtStableDebtTokenTaikoAddress,
    functionName: 'principalBalanceOf',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdtStableDebtTokenTaikoAbi}__ and `functionName` set to `"symbol"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xA436Ebde4FdBf95DDc419b2BB378f91eb2196972)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7B2974f5f356Dc6516716a4BBCc06AB0230aCC77)
 */
export const readUsdtStableDebtTokenTaikoSymbol =
  /*#__PURE__*/ createReadContract({
    abi: usdtStableDebtTokenTaikoAbi,
    address: usdtStableDebtTokenTaikoAddress,
    functionName: 'symbol',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdtStableDebtTokenTaikoAbi}__ and `functionName` set to `"totalSupply"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xA436Ebde4FdBf95DDc419b2BB378f91eb2196972)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7B2974f5f356Dc6516716a4BBCc06AB0230aCC77)
 */
export const readUsdtStableDebtTokenTaikoTotalSupply =
  /*#__PURE__*/ createReadContract({
    abi: usdtStableDebtTokenTaikoAbi,
    address: usdtStableDebtTokenTaikoAddress,
    functionName: 'totalSupply',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link usdtStableDebtTokenTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xA436Ebde4FdBf95DDc419b2BB378f91eb2196972)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7B2974f5f356Dc6516716a4BBCc06AB0230aCC77)
 */
export const writeUsdtStableDebtTokenTaiko = /*#__PURE__*/ createWriteContract({
  abi: usdtStableDebtTokenTaikoAbi,
  address: usdtStableDebtTokenTaikoAddress,
})

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link usdtStableDebtTokenTaikoAbi}__ and `functionName` set to `"approve"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xA436Ebde4FdBf95DDc419b2BB378f91eb2196972)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7B2974f5f356Dc6516716a4BBCc06AB0230aCC77)
 */
export const writeUsdtStableDebtTokenTaikoApprove =
  /*#__PURE__*/ createWriteContract({
    abi: usdtStableDebtTokenTaikoAbi,
    address: usdtStableDebtTokenTaikoAddress,
    functionName: 'approve',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link usdtStableDebtTokenTaikoAbi}__ and `functionName` set to `"approveDelegation"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xA436Ebde4FdBf95DDc419b2BB378f91eb2196972)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7B2974f5f356Dc6516716a4BBCc06AB0230aCC77)
 */
export const writeUsdtStableDebtTokenTaikoApproveDelegation =
  /*#__PURE__*/ createWriteContract({
    abi: usdtStableDebtTokenTaikoAbi,
    address: usdtStableDebtTokenTaikoAddress,
    functionName: 'approveDelegation',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link usdtStableDebtTokenTaikoAbi}__ and `functionName` set to `"burn"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xA436Ebde4FdBf95DDc419b2BB378f91eb2196972)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7B2974f5f356Dc6516716a4BBCc06AB0230aCC77)
 */
export const writeUsdtStableDebtTokenTaikoBurn =
  /*#__PURE__*/ createWriteContract({
    abi: usdtStableDebtTokenTaikoAbi,
    address: usdtStableDebtTokenTaikoAddress,
    functionName: 'burn',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link usdtStableDebtTokenTaikoAbi}__ and `functionName` set to `"decreaseAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xA436Ebde4FdBf95DDc419b2BB378f91eb2196972)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7B2974f5f356Dc6516716a4BBCc06AB0230aCC77)
 */
export const writeUsdtStableDebtTokenTaikoDecreaseAllowance =
  /*#__PURE__*/ createWriteContract({
    abi: usdtStableDebtTokenTaikoAbi,
    address: usdtStableDebtTokenTaikoAddress,
    functionName: 'decreaseAllowance',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link usdtStableDebtTokenTaikoAbi}__ and `functionName` set to `"delegationWithSig"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xA436Ebde4FdBf95DDc419b2BB378f91eb2196972)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7B2974f5f356Dc6516716a4BBCc06AB0230aCC77)
 */
export const writeUsdtStableDebtTokenTaikoDelegationWithSig =
  /*#__PURE__*/ createWriteContract({
    abi: usdtStableDebtTokenTaikoAbi,
    address: usdtStableDebtTokenTaikoAddress,
    functionName: 'delegationWithSig',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link usdtStableDebtTokenTaikoAbi}__ and `functionName` set to `"increaseAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xA436Ebde4FdBf95DDc419b2BB378f91eb2196972)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7B2974f5f356Dc6516716a4BBCc06AB0230aCC77)
 */
export const writeUsdtStableDebtTokenTaikoIncreaseAllowance =
  /*#__PURE__*/ createWriteContract({
    abi: usdtStableDebtTokenTaikoAbi,
    address: usdtStableDebtTokenTaikoAddress,
    functionName: 'increaseAllowance',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link usdtStableDebtTokenTaikoAbi}__ and `functionName` set to `"initialize"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xA436Ebde4FdBf95DDc419b2BB378f91eb2196972)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7B2974f5f356Dc6516716a4BBCc06AB0230aCC77)
 */
export const writeUsdtStableDebtTokenTaikoInitialize =
  /*#__PURE__*/ createWriteContract({
    abi: usdtStableDebtTokenTaikoAbi,
    address: usdtStableDebtTokenTaikoAddress,
    functionName: 'initialize',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link usdtStableDebtTokenTaikoAbi}__ and `functionName` set to `"mint"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xA436Ebde4FdBf95DDc419b2BB378f91eb2196972)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7B2974f5f356Dc6516716a4BBCc06AB0230aCC77)
 */
export const writeUsdtStableDebtTokenTaikoMint =
  /*#__PURE__*/ createWriteContract({
    abi: usdtStableDebtTokenTaikoAbi,
    address: usdtStableDebtTokenTaikoAddress,
    functionName: 'mint',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link usdtStableDebtTokenTaikoAbi}__ and `functionName` set to `"setIncentivesController"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xA436Ebde4FdBf95DDc419b2BB378f91eb2196972)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7B2974f5f356Dc6516716a4BBCc06AB0230aCC77)
 */
export const writeUsdtStableDebtTokenTaikoSetIncentivesController =
  /*#__PURE__*/ createWriteContract({
    abi: usdtStableDebtTokenTaikoAbi,
    address: usdtStableDebtTokenTaikoAddress,
    functionName: 'setIncentivesController',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link usdtStableDebtTokenTaikoAbi}__ and `functionName` set to `"transfer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xA436Ebde4FdBf95DDc419b2BB378f91eb2196972)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7B2974f5f356Dc6516716a4BBCc06AB0230aCC77)
 */
export const writeUsdtStableDebtTokenTaikoTransfer =
  /*#__PURE__*/ createWriteContract({
    abi: usdtStableDebtTokenTaikoAbi,
    address: usdtStableDebtTokenTaikoAddress,
    functionName: 'transfer',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link usdtStableDebtTokenTaikoAbi}__ and `functionName` set to `"transferFrom"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xA436Ebde4FdBf95DDc419b2BB378f91eb2196972)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7B2974f5f356Dc6516716a4BBCc06AB0230aCC77)
 */
export const writeUsdtStableDebtTokenTaikoTransferFrom =
  /*#__PURE__*/ createWriteContract({
    abi: usdtStableDebtTokenTaikoAbi,
    address: usdtStableDebtTokenTaikoAddress,
    functionName: 'transferFrom',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link usdtStableDebtTokenTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xA436Ebde4FdBf95DDc419b2BB378f91eb2196972)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7B2974f5f356Dc6516716a4BBCc06AB0230aCC77)
 */
export const simulateUsdtStableDebtTokenTaiko =
  /*#__PURE__*/ createSimulateContract({
    abi: usdtStableDebtTokenTaikoAbi,
    address: usdtStableDebtTokenTaikoAddress,
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link usdtStableDebtTokenTaikoAbi}__ and `functionName` set to `"approve"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xA436Ebde4FdBf95DDc419b2BB378f91eb2196972)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7B2974f5f356Dc6516716a4BBCc06AB0230aCC77)
 */
export const simulateUsdtStableDebtTokenTaikoApprove =
  /*#__PURE__*/ createSimulateContract({
    abi: usdtStableDebtTokenTaikoAbi,
    address: usdtStableDebtTokenTaikoAddress,
    functionName: 'approve',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link usdtStableDebtTokenTaikoAbi}__ and `functionName` set to `"approveDelegation"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xA436Ebde4FdBf95DDc419b2BB378f91eb2196972)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7B2974f5f356Dc6516716a4BBCc06AB0230aCC77)
 */
export const simulateUsdtStableDebtTokenTaikoApproveDelegation =
  /*#__PURE__*/ createSimulateContract({
    abi: usdtStableDebtTokenTaikoAbi,
    address: usdtStableDebtTokenTaikoAddress,
    functionName: 'approveDelegation',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link usdtStableDebtTokenTaikoAbi}__ and `functionName` set to `"burn"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xA436Ebde4FdBf95DDc419b2BB378f91eb2196972)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7B2974f5f356Dc6516716a4BBCc06AB0230aCC77)
 */
export const simulateUsdtStableDebtTokenTaikoBurn =
  /*#__PURE__*/ createSimulateContract({
    abi: usdtStableDebtTokenTaikoAbi,
    address: usdtStableDebtTokenTaikoAddress,
    functionName: 'burn',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link usdtStableDebtTokenTaikoAbi}__ and `functionName` set to `"decreaseAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xA436Ebde4FdBf95DDc419b2BB378f91eb2196972)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7B2974f5f356Dc6516716a4BBCc06AB0230aCC77)
 */
export const simulateUsdtStableDebtTokenTaikoDecreaseAllowance =
  /*#__PURE__*/ createSimulateContract({
    abi: usdtStableDebtTokenTaikoAbi,
    address: usdtStableDebtTokenTaikoAddress,
    functionName: 'decreaseAllowance',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link usdtStableDebtTokenTaikoAbi}__ and `functionName` set to `"delegationWithSig"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xA436Ebde4FdBf95DDc419b2BB378f91eb2196972)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7B2974f5f356Dc6516716a4BBCc06AB0230aCC77)
 */
export const simulateUsdtStableDebtTokenTaikoDelegationWithSig =
  /*#__PURE__*/ createSimulateContract({
    abi: usdtStableDebtTokenTaikoAbi,
    address: usdtStableDebtTokenTaikoAddress,
    functionName: 'delegationWithSig',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link usdtStableDebtTokenTaikoAbi}__ and `functionName` set to `"increaseAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xA436Ebde4FdBf95DDc419b2BB378f91eb2196972)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7B2974f5f356Dc6516716a4BBCc06AB0230aCC77)
 */
export const simulateUsdtStableDebtTokenTaikoIncreaseAllowance =
  /*#__PURE__*/ createSimulateContract({
    abi: usdtStableDebtTokenTaikoAbi,
    address: usdtStableDebtTokenTaikoAddress,
    functionName: 'increaseAllowance',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link usdtStableDebtTokenTaikoAbi}__ and `functionName` set to `"initialize"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xA436Ebde4FdBf95DDc419b2BB378f91eb2196972)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7B2974f5f356Dc6516716a4BBCc06AB0230aCC77)
 */
export const simulateUsdtStableDebtTokenTaikoInitialize =
  /*#__PURE__*/ createSimulateContract({
    abi: usdtStableDebtTokenTaikoAbi,
    address: usdtStableDebtTokenTaikoAddress,
    functionName: 'initialize',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link usdtStableDebtTokenTaikoAbi}__ and `functionName` set to `"mint"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xA436Ebde4FdBf95DDc419b2BB378f91eb2196972)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7B2974f5f356Dc6516716a4BBCc06AB0230aCC77)
 */
export const simulateUsdtStableDebtTokenTaikoMint =
  /*#__PURE__*/ createSimulateContract({
    abi: usdtStableDebtTokenTaikoAbi,
    address: usdtStableDebtTokenTaikoAddress,
    functionName: 'mint',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link usdtStableDebtTokenTaikoAbi}__ and `functionName` set to `"setIncentivesController"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xA436Ebde4FdBf95DDc419b2BB378f91eb2196972)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7B2974f5f356Dc6516716a4BBCc06AB0230aCC77)
 */
export const simulateUsdtStableDebtTokenTaikoSetIncentivesController =
  /*#__PURE__*/ createSimulateContract({
    abi: usdtStableDebtTokenTaikoAbi,
    address: usdtStableDebtTokenTaikoAddress,
    functionName: 'setIncentivesController',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link usdtStableDebtTokenTaikoAbi}__ and `functionName` set to `"transfer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xA436Ebde4FdBf95DDc419b2BB378f91eb2196972)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7B2974f5f356Dc6516716a4BBCc06AB0230aCC77)
 */
export const simulateUsdtStableDebtTokenTaikoTransfer =
  /*#__PURE__*/ createSimulateContract({
    abi: usdtStableDebtTokenTaikoAbi,
    address: usdtStableDebtTokenTaikoAddress,
    functionName: 'transfer',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link usdtStableDebtTokenTaikoAbi}__ and `functionName` set to `"transferFrom"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xA436Ebde4FdBf95DDc419b2BB378f91eb2196972)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7B2974f5f356Dc6516716a4BBCc06AB0230aCC77)
 */
export const simulateUsdtStableDebtTokenTaikoTransferFrom =
  /*#__PURE__*/ createSimulateContract({
    abi: usdtStableDebtTokenTaikoAbi,
    address: usdtStableDebtTokenTaikoAddress,
    functionName: 'transferFrom',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link usdtStableDebtTokenTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xA436Ebde4FdBf95DDc419b2BB378f91eb2196972)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7B2974f5f356Dc6516716a4BBCc06AB0230aCC77)
 */
export const watchUsdtStableDebtTokenTaikoEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: usdtStableDebtTokenTaikoAbi,
    address: usdtStableDebtTokenTaikoAddress,
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link usdtStableDebtTokenTaikoAbi}__ and `eventName` set to `"Approval"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xA436Ebde4FdBf95DDc419b2BB378f91eb2196972)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7B2974f5f356Dc6516716a4BBCc06AB0230aCC77)
 */
export const watchUsdtStableDebtTokenTaikoApprovalEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: usdtStableDebtTokenTaikoAbi,
    address: usdtStableDebtTokenTaikoAddress,
    eventName: 'Approval',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link usdtStableDebtTokenTaikoAbi}__ and `eventName` set to `"BorrowAllowanceDelegated"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xA436Ebde4FdBf95DDc419b2BB378f91eb2196972)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7B2974f5f356Dc6516716a4BBCc06AB0230aCC77)
 */
export const watchUsdtStableDebtTokenTaikoBorrowAllowanceDelegatedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: usdtStableDebtTokenTaikoAbi,
    address: usdtStableDebtTokenTaikoAddress,
    eventName: 'BorrowAllowanceDelegated',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link usdtStableDebtTokenTaikoAbi}__ and `eventName` set to `"Burn"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xA436Ebde4FdBf95DDc419b2BB378f91eb2196972)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7B2974f5f356Dc6516716a4BBCc06AB0230aCC77)
 */
export const watchUsdtStableDebtTokenTaikoBurnEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: usdtStableDebtTokenTaikoAbi,
    address: usdtStableDebtTokenTaikoAddress,
    eventName: 'Burn',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link usdtStableDebtTokenTaikoAbi}__ and `eventName` set to `"Initialized"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xA436Ebde4FdBf95DDc419b2BB378f91eb2196972)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7B2974f5f356Dc6516716a4BBCc06AB0230aCC77)
 */
export const watchUsdtStableDebtTokenTaikoInitializedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: usdtStableDebtTokenTaikoAbi,
    address: usdtStableDebtTokenTaikoAddress,
    eventName: 'Initialized',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link usdtStableDebtTokenTaikoAbi}__ and `eventName` set to `"Mint"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xA436Ebde4FdBf95DDc419b2BB378f91eb2196972)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7B2974f5f356Dc6516716a4BBCc06AB0230aCC77)
 */
export const watchUsdtStableDebtTokenTaikoMintEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: usdtStableDebtTokenTaikoAbi,
    address: usdtStableDebtTokenTaikoAddress,
    eventName: 'Mint',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link usdtStableDebtTokenTaikoAbi}__ and `eventName` set to `"Transfer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xA436Ebde4FdBf95DDc419b2BB378f91eb2196972)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x7B2974f5f356Dc6516716a4BBCc06AB0230aCC77)
 */
export const watchUsdtStableDebtTokenTaikoTransferEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: usdtStableDebtTokenTaikoAbi,
    address: usdtStableDebtTokenTaikoAddress,
    eventName: 'Transfer',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdtTestnetMintableErc20TaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x3E6FA96c2188d15739B17174cb6c824758FeC3e2)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x15642042D7e71C662b1963fF70760495b39259d5)
 */
export const readUsdtTestnetMintableErc20Taiko =
  /*#__PURE__*/ createReadContract({
    abi: usdtTestnetMintableErc20TaikoAbi,
    address: usdtTestnetMintableErc20TaikoAddress,
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdtTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"allowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x3E6FA96c2188d15739B17174cb6c824758FeC3e2)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x15642042D7e71C662b1963fF70760495b39259d5)
 */
export const readUsdtTestnetMintableErc20TaikoAllowance =
  /*#__PURE__*/ createReadContract({
    abi: usdtTestnetMintableErc20TaikoAbi,
    address: usdtTestnetMintableErc20TaikoAddress,
    functionName: 'allowance',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdtTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"balanceOf"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x3E6FA96c2188d15739B17174cb6c824758FeC3e2)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x15642042D7e71C662b1963fF70760495b39259d5)
 */
export const readUsdtTestnetMintableErc20TaikoBalanceOf =
  /*#__PURE__*/ createReadContract({
    abi: usdtTestnetMintableErc20TaikoAbi,
    address: usdtTestnetMintableErc20TaikoAddress,
    functionName: 'balanceOf',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdtTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"decimals"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x3E6FA96c2188d15739B17174cb6c824758FeC3e2)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x15642042D7e71C662b1963fF70760495b39259d5)
 */
export const readUsdtTestnetMintableErc20TaikoDecimals =
  /*#__PURE__*/ createReadContract({
    abi: usdtTestnetMintableErc20TaikoAbi,
    address: usdtTestnetMintableErc20TaikoAddress,
    functionName: 'decimals',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdtTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"name"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x3E6FA96c2188d15739B17174cb6c824758FeC3e2)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x15642042D7e71C662b1963fF70760495b39259d5)
 */
export const readUsdtTestnetMintableErc20TaikoName =
  /*#__PURE__*/ createReadContract({
    abi: usdtTestnetMintableErc20TaikoAbi,
    address: usdtTestnetMintableErc20TaikoAddress,
    functionName: 'name',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdtTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"symbol"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x3E6FA96c2188d15739B17174cb6c824758FeC3e2)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x15642042D7e71C662b1963fF70760495b39259d5)
 */
export const readUsdtTestnetMintableErc20TaikoSymbol =
  /*#__PURE__*/ createReadContract({
    abi: usdtTestnetMintableErc20TaikoAbi,
    address: usdtTestnetMintableErc20TaikoAddress,
    functionName: 'symbol',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdtTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"tokenDecimals"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x3E6FA96c2188d15739B17174cb6c824758FeC3e2)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x15642042D7e71C662b1963fF70760495b39259d5)
 */
export const readUsdtTestnetMintableErc20TaikoTokenDecimals =
  /*#__PURE__*/ createReadContract({
    abi: usdtTestnetMintableErc20TaikoAbi,
    address: usdtTestnetMintableErc20TaikoAddress,
    functionName: 'tokenDecimals',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdtTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"totalSupply"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x3E6FA96c2188d15739B17174cb6c824758FeC3e2)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x15642042D7e71C662b1963fF70760495b39259d5)
 */
export const readUsdtTestnetMintableErc20TaikoTotalSupply =
  /*#__PURE__*/ createReadContract({
    abi: usdtTestnetMintableErc20TaikoAbi,
    address: usdtTestnetMintableErc20TaikoAddress,
    functionName: 'totalSupply',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link usdtTestnetMintableErc20TaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x3E6FA96c2188d15739B17174cb6c824758FeC3e2)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x15642042D7e71C662b1963fF70760495b39259d5)
 */
export const writeUsdtTestnetMintableErc20Taiko =
  /*#__PURE__*/ createWriteContract({
    abi: usdtTestnetMintableErc20TaikoAbi,
    address: usdtTestnetMintableErc20TaikoAddress,
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link usdtTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"approve"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x3E6FA96c2188d15739B17174cb6c824758FeC3e2)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x15642042D7e71C662b1963fF70760495b39259d5)
 */
export const writeUsdtTestnetMintableErc20TaikoApprove =
  /*#__PURE__*/ createWriteContract({
    abi: usdtTestnetMintableErc20TaikoAbi,
    address: usdtTestnetMintableErc20TaikoAddress,
    functionName: 'approve',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link usdtTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"decreaseAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x3E6FA96c2188d15739B17174cb6c824758FeC3e2)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x15642042D7e71C662b1963fF70760495b39259d5)
 */
export const writeUsdtTestnetMintableErc20TaikoDecreaseAllowance =
  /*#__PURE__*/ createWriteContract({
    abi: usdtTestnetMintableErc20TaikoAbi,
    address: usdtTestnetMintableErc20TaikoAddress,
    functionName: 'decreaseAllowance',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link usdtTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"increaseAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x3E6FA96c2188d15739B17174cb6c824758FeC3e2)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x15642042D7e71C662b1963fF70760495b39259d5)
 */
export const writeUsdtTestnetMintableErc20TaikoIncreaseAllowance =
  /*#__PURE__*/ createWriteContract({
    abi: usdtTestnetMintableErc20TaikoAbi,
    address: usdtTestnetMintableErc20TaikoAddress,
    functionName: 'increaseAllowance',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link usdtTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"transfer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x3E6FA96c2188d15739B17174cb6c824758FeC3e2)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x15642042D7e71C662b1963fF70760495b39259d5)
 */
export const writeUsdtTestnetMintableErc20TaikoTransfer =
  /*#__PURE__*/ createWriteContract({
    abi: usdtTestnetMintableErc20TaikoAbi,
    address: usdtTestnetMintableErc20TaikoAddress,
    functionName: 'transfer',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link usdtTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"transferFrom"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x3E6FA96c2188d15739B17174cb6c824758FeC3e2)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x15642042D7e71C662b1963fF70760495b39259d5)
 */
export const writeUsdtTestnetMintableErc20TaikoTransferFrom =
  /*#__PURE__*/ createWriteContract({
    abi: usdtTestnetMintableErc20TaikoAbi,
    address: usdtTestnetMintableErc20TaikoAddress,
    functionName: 'transferFrom',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link usdtTestnetMintableErc20TaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x3E6FA96c2188d15739B17174cb6c824758FeC3e2)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x15642042D7e71C662b1963fF70760495b39259d5)
 */
export const simulateUsdtTestnetMintableErc20Taiko =
  /*#__PURE__*/ createSimulateContract({
    abi: usdtTestnetMintableErc20TaikoAbi,
    address: usdtTestnetMintableErc20TaikoAddress,
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link usdtTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"approve"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x3E6FA96c2188d15739B17174cb6c824758FeC3e2)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x15642042D7e71C662b1963fF70760495b39259d5)
 */
export const simulateUsdtTestnetMintableErc20TaikoApprove =
  /*#__PURE__*/ createSimulateContract({
    abi: usdtTestnetMintableErc20TaikoAbi,
    address: usdtTestnetMintableErc20TaikoAddress,
    functionName: 'approve',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link usdtTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"decreaseAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x3E6FA96c2188d15739B17174cb6c824758FeC3e2)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x15642042D7e71C662b1963fF70760495b39259d5)
 */
export const simulateUsdtTestnetMintableErc20TaikoDecreaseAllowance =
  /*#__PURE__*/ createSimulateContract({
    abi: usdtTestnetMintableErc20TaikoAbi,
    address: usdtTestnetMintableErc20TaikoAddress,
    functionName: 'decreaseAllowance',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link usdtTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"increaseAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x3E6FA96c2188d15739B17174cb6c824758FeC3e2)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x15642042D7e71C662b1963fF70760495b39259d5)
 */
export const simulateUsdtTestnetMintableErc20TaikoIncreaseAllowance =
  /*#__PURE__*/ createSimulateContract({
    abi: usdtTestnetMintableErc20TaikoAbi,
    address: usdtTestnetMintableErc20TaikoAddress,
    functionName: 'increaseAllowance',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link usdtTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"transfer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x3E6FA96c2188d15739B17174cb6c824758FeC3e2)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x15642042D7e71C662b1963fF70760495b39259d5)
 */
export const simulateUsdtTestnetMintableErc20TaikoTransfer =
  /*#__PURE__*/ createSimulateContract({
    abi: usdtTestnetMintableErc20TaikoAbi,
    address: usdtTestnetMintableErc20TaikoAddress,
    functionName: 'transfer',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link usdtTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"transferFrom"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x3E6FA96c2188d15739B17174cb6c824758FeC3e2)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x15642042D7e71C662b1963fF70760495b39259d5)
 */
export const simulateUsdtTestnetMintableErc20TaikoTransferFrom =
  /*#__PURE__*/ createSimulateContract({
    abi: usdtTestnetMintableErc20TaikoAbi,
    address: usdtTestnetMintableErc20TaikoAddress,
    functionName: 'transferFrom',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link usdtTestnetMintableErc20TaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x3E6FA96c2188d15739B17174cb6c824758FeC3e2)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x15642042D7e71C662b1963fF70760495b39259d5)
 */
export const watchUsdtTestnetMintableErc20TaikoEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: usdtTestnetMintableErc20TaikoAbi,
    address: usdtTestnetMintableErc20TaikoAddress,
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link usdtTestnetMintableErc20TaikoAbi}__ and `eventName` set to `"Approval"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x3E6FA96c2188d15739B17174cb6c824758FeC3e2)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x15642042D7e71C662b1963fF70760495b39259d5)
 */
export const watchUsdtTestnetMintableErc20TaikoApprovalEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: usdtTestnetMintableErc20TaikoAbi,
    address: usdtTestnetMintableErc20TaikoAddress,
    eventName: 'Approval',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link usdtTestnetMintableErc20TaikoAbi}__ and `eventName` set to `"Transfer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x3E6FA96c2188d15739B17174cb6c824758FeC3e2)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x15642042D7e71C662b1963fF70760495b39259d5)
 */
export const watchUsdtTestnetMintableErc20TaikoTransferEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: usdtTestnetMintableErc20TaikoAbi,
    address: usdtTestnetMintableErc20TaikoAddress,
    eventName: 'Transfer',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdtTestnetPriceAggregatorTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xC292D916A9E49e5BbA779aBc0977ECCA4a245eA3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4CB7ba14e4c0207479d058C40ee5e102D2d4fD06)
 */
export const readUsdtTestnetPriceAggregatorTaiko =
  /*#__PURE__*/ createReadContract({
    abi: usdtTestnetPriceAggregatorTaikoAbi,
    address: usdtTestnetPriceAggregatorTaikoAddress,
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdtTestnetPriceAggregatorTaikoAbi}__ and `functionName` set to `"decimals"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xC292D916A9E49e5BbA779aBc0977ECCA4a245eA3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4CB7ba14e4c0207479d058C40ee5e102D2d4fD06)
 */
export const readUsdtTestnetPriceAggregatorTaikoDecimals =
  /*#__PURE__*/ createReadContract({
    abi: usdtTestnetPriceAggregatorTaikoAbi,
    address: usdtTestnetPriceAggregatorTaikoAddress,
    functionName: 'decimals',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdtTestnetPriceAggregatorTaikoAbi}__ and `functionName` set to `"getTokenType"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xC292D916A9E49e5BbA779aBc0977ECCA4a245eA3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4CB7ba14e4c0207479d058C40ee5e102D2d4fD06)
 */
export const readUsdtTestnetPriceAggregatorTaikoGetTokenType =
  /*#__PURE__*/ createReadContract({
    abi: usdtTestnetPriceAggregatorTaikoAbi,
    address: usdtTestnetPriceAggregatorTaikoAddress,
    functionName: 'getTokenType',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdtTestnetPriceAggregatorTaikoAbi}__ and `functionName` set to `"latestAnswer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xC292D916A9E49e5BbA779aBc0977ECCA4a245eA3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4CB7ba14e4c0207479d058C40ee5e102D2d4fD06)
 */
export const readUsdtTestnetPriceAggregatorTaikoLatestAnswer =
  /*#__PURE__*/ createReadContract({
    abi: usdtTestnetPriceAggregatorTaikoAbi,
    address: usdtTestnetPriceAggregatorTaikoAddress,
    functionName: 'latestAnswer',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link usdtTestnetPriceAggregatorTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xC292D916A9E49e5BbA779aBc0977ECCA4a245eA3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4CB7ba14e4c0207479d058C40ee5e102D2d4fD06)
 */
export const watchUsdtTestnetPriceAggregatorTaikoEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: usdtTestnetPriceAggregatorTaikoAbi,
    address: usdtTestnetPriceAggregatorTaikoAddress,
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link usdtTestnetPriceAggregatorTaikoAbi}__ and `eventName` set to `"AnswerUpdated"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xC292D916A9E49e5BbA779aBc0977ECCA4a245eA3)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4CB7ba14e4c0207479d058C40ee5e102D2d4fD06)
 */
export const watchUsdtTestnetPriceAggregatorTaikoAnswerUpdatedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: usdtTestnetPriceAggregatorTaikoAbi,
    address: usdtTestnetPriceAggregatorTaikoAddress,
    eventName: 'AnswerUpdated',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdtVariableDebtTokenTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa6738aC9F9176b51dB5A19D75A9a2F6315EE8a58)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x6adc80126542a27Fb76051B1bbb43E1F2F11cD9F)
 */
export const readUsdtVariableDebtTokenTaiko = /*#__PURE__*/ createReadContract({
  abi: usdtVariableDebtTokenTaikoAbi,
  address: usdtVariableDebtTokenTaikoAddress,
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdtVariableDebtTokenTaikoAbi}__ and `functionName` set to `"DEBT_TOKEN_REVISION"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa6738aC9F9176b51dB5A19D75A9a2F6315EE8a58)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x6adc80126542a27Fb76051B1bbb43E1F2F11cD9F)
 */
export const readUsdtVariableDebtTokenTaikoDebtTokenRevision =
  /*#__PURE__*/ createReadContract({
    abi: usdtVariableDebtTokenTaikoAbi,
    address: usdtVariableDebtTokenTaikoAddress,
    functionName: 'DEBT_TOKEN_REVISION',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdtVariableDebtTokenTaikoAbi}__ and `functionName` set to `"DELEGATION_WITH_SIG_TYPEHASH"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa6738aC9F9176b51dB5A19D75A9a2F6315EE8a58)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x6adc80126542a27Fb76051B1bbb43E1F2F11cD9F)
 */
export const readUsdtVariableDebtTokenTaikoDelegationWithSigTypehash =
  /*#__PURE__*/ createReadContract({
    abi: usdtVariableDebtTokenTaikoAbi,
    address: usdtVariableDebtTokenTaikoAddress,
    functionName: 'DELEGATION_WITH_SIG_TYPEHASH',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdtVariableDebtTokenTaikoAbi}__ and `functionName` set to `"DOMAIN_SEPARATOR"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa6738aC9F9176b51dB5A19D75A9a2F6315EE8a58)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x6adc80126542a27Fb76051B1bbb43E1F2F11cD9F)
 */
export const readUsdtVariableDebtTokenTaikoDomainSeparator =
  /*#__PURE__*/ createReadContract({
    abi: usdtVariableDebtTokenTaikoAbi,
    address: usdtVariableDebtTokenTaikoAddress,
    functionName: 'DOMAIN_SEPARATOR',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdtVariableDebtTokenTaikoAbi}__ and `functionName` set to `"EIP712_REVISION"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa6738aC9F9176b51dB5A19D75A9a2F6315EE8a58)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x6adc80126542a27Fb76051B1bbb43E1F2F11cD9F)
 */
export const readUsdtVariableDebtTokenTaikoEip712Revision =
  /*#__PURE__*/ createReadContract({
    abi: usdtVariableDebtTokenTaikoAbi,
    address: usdtVariableDebtTokenTaikoAddress,
    functionName: 'EIP712_REVISION',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdtVariableDebtTokenTaikoAbi}__ and `functionName` set to `"POOL"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa6738aC9F9176b51dB5A19D75A9a2F6315EE8a58)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x6adc80126542a27Fb76051B1bbb43E1F2F11cD9F)
 */
export const readUsdtVariableDebtTokenTaikoPool =
  /*#__PURE__*/ createReadContract({
    abi: usdtVariableDebtTokenTaikoAbi,
    address: usdtVariableDebtTokenTaikoAddress,
    functionName: 'POOL',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdtVariableDebtTokenTaikoAbi}__ and `functionName` set to `"UNDERLYING_ASSET_ADDRESS"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa6738aC9F9176b51dB5A19D75A9a2F6315EE8a58)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x6adc80126542a27Fb76051B1bbb43E1F2F11cD9F)
 */
export const readUsdtVariableDebtTokenTaikoUnderlyingAssetAddress =
  /*#__PURE__*/ createReadContract({
    abi: usdtVariableDebtTokenTaikoAbi,
    address: usdtVariableDebtTokenTaikoAddress,
    functionName: 'UNDERLYING_ASSET_ADDRESS',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdtVariableDebtTokenTaikoAbi}__ and `functionName` set to `"allowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa6738aC9F9176b51dB5A19D75A9a2F6315EE8a58)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x6adc80126542a27Fb76051B1bbb43E1F2F11cD9F)
 */
export const readUsdtVariableDebtTokenTaikoAllowance =
  /*#__PURE__*/ createReadContract({
    abi: usdtVariableDebtTokenTaikoAbi,
    address: usdtVariableDebtTokenTaikoAddress,
    functionName: 'allowance',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdtVariableDebtTokenTaikoAbi}__ and `functionName` set to `"balanceOf"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa6738aC9F9176b51dB5A19D75A9a2F6315EE8a58)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x6adc80126542a27Fb76051B1bbb43E1F2F11cD9F)
 */
export const readUsdtVariableDebtTokenTaikoBalanceOf =
  /*#__PURE__*/ createReadContract({
    abi: usdtVariableDebtTokenTaikoAbi,
    address: usdtVariableDebtTokenTaikoAddress,
    functionName: 'balanceOf',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdtVariableDebtTokenTaikoAbi}__ and `functionName` set to `"borrowAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa6738aC9F9176b51dB5A19D75A9a2F6315EE8a58)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x6adc80126542a27Fb76051B1bbb43E1F2F11cD9F)
 */
export const readUsdtVariableDebtTokenTaikoBorrowAllowance =
  /*#__PURE__*/ createReadContract({
    abi: usdtVariableDebtTokenTaikoAbi,
    address: usdtVariableDebtTokenTaikoAddress,
    functionName: 'borrowAllowance',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdtVariableDebtTokenTaikoAbi}__ and `functionName` set to `"decimals"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa6738aC9F9176b51dB5A19D75A9a2F6315EE8a58)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x6adc80126542a27Fb76051B1bbb43E1F2F11cD9F)
 */
export const readUsdtVariableDebtTokenTaikoDecimals =
  /*#__PURE__*/ createReadContract({
    abi: usdtVariableDebtTokenTaikoAbi,
    address: usdtVariableDebtTokenTaikoAddress,
    functionName: 'decimals',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdtVariableDebtTokenTaikoAbi}__ and `functionName` set to `"getIncentivesController"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa6738aC9F9176b51dB5A19D75A9a2F6315EE8a58)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x6adc80126542a27Fb76051B1bbb43E1F2F11cD9F)
 */
export const readUsdtVariableDebtTokenTaikoGetIncentivesController =
  /*#__PURE__*/ createReadContract({
    abi: usdtVariableDebtTokenTaikoAbi,
    address: usdtVariableDebtTokenTaikoAddress,
    functionName: 'getIncentivesController',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdtVariableDebtTokenTaikoAbi}__ and `functionName` set to `"getPreviousIndex"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa6738aC9F9176b51dB5A19D75A9a2F6315EE8a58)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x6adc80126542a27Fb76051B1bbb43E1F2F11cD9F)
 */
export const readUsdtVariableDebtTokenTaikoGetPreviousIndex =
  /*#__PURE__*/ createReadContract({
    abi: usdtVariableDebtTokenTaikoAbi,
    address: usdtVariableDebtTokenTaikoAddress,
    functionName: 'getPreviousIndex',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdtVariableDebtTokenTaikoAbi}__ and `functionName` set to `"getScaledUserBalanceAndSupply"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa6738aC9F9176b51dB5A19D75A9a2F6315EE8a58)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x6adc80126542a27Fb76051B1bbb43E1F2F11cD9F)
 */
export const readUsdtVariableDebtTokenTaikoGetScaledUserBalanceAndSupply =
  /*#__PURE__*/ createReadContract({
    abi: usdtVariableDebtTokenTaikoAbi,
    address: usdtVariableDebtTokenTaikoAddress,
    functionName: 'getScaledUserBalanceAndSupply',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdtVariableDebtTokenTaikoAbi}__ and `functionName` set to `"name"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa6738aC9F9176b51dB5A19D75A9a2F6315EE8a58)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x6adc80126542a27Fb76051B1bbb43E1F2F11cD9F)
 */
export const readUsdtVariableDebtTokenTaikoName =
  /*#__PURE__*/ createReadContract({
    abi: usdtVariableDebtTokenTaikoAbi,
    address: usdtVariableDebtTokenTaikoAddress,
    functionName: 'name',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdtVariableDebtTokenTaikoAbi}__ and `functionName` set to `"nonces"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa6738aC9F9176b51dB5A19D75A9a2F6315EE8a58)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x6adc80126542a27Fb76051B1bbb43E1F2F11cD9F)
 */
export const readUsdtVariableDebtTokenTaikoNonces =
  /*#__PURE__*/ createReadContract({
    abi: usdtVariableDebtTokenTaikoAbi,
    address: usdtVariableDebtTokenTaikoAddress,
    functionName: 'nonces',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdtVariableDebtTokenTaikoAbi}__ and `functionName` set to `"scaledBalanceOf"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa6738aC9F9176b51dB5A19D75A9a2F6315EE8a58)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x6adc80126542a27Fb76051B1bbb43E1F2F11cD9F)
 */
export const readUsdtVariableDebtTokenTaikoScaledBalanceOf =
  /*#__PURE__*/ createReadContract({
    abi: usdtVariableDebtTokenTaikoAbi,
    address: usdtVariableDebtTokenTaikoAddress,
    functionName: 'scaledBalanceOf',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdtVariableDebtTokenTaikoAbi}__ and `functionName` set to `"scaledTotalSupply"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa6738aC9F9176b51dB5A19D75A9a2F6315EE8a58)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x6adc80126542a27Fb76051B1bbb43E1F2F11cD9F)
 */
export const readUsdtVariableDebtTokenTaikoScaledTotalSupply =
  /*#__PURE__*/ createReadContract({
    abi: usdtVariableDebtTokenTaikoAbi,
    address: usdtVariableDebtTokenTaikoAddress,
    functionName: 'scaledTotalSupply',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdtVariableDebtTokenTaikoAbi}__ and `functionName` set to `"symbol"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa6738aC9F9176b51dB5A19D75A9a2F6315EE8a58)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x6adc80126542a27Fb76051B1bbb43E1F2F11cD9F)
 */
export const readUsdtVariableDebtTokenTaikoSymbol =
  /*#__PURE__*/ createReadContract({
    abi: usdtVariableDebtTokenTaikoAbi,
    address: usdtVariableDebtTokenTaikoAddress,
    functionName: 'symbol',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link usdtVariableDebtTokenTaikoAbi}__ and `functionName` set to `"totalSupply"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa6738aC9F9176b51dB5A19D75A9a2F6315EE8a58)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x6adc80126542a27Fb76051B1bbb43E1F2F11cD9F)
 */
export const readUsdtVariableDebtTokenTaikoTotalSupply =
  /*#__PURE__*/ createReadContract({
    abi: usdtVariableDebtTokenTaikoAbi,
    address: usdtVariableDebtTokenTaikoAddress,
    functionName: 'totalSupply',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link usdtVariableDebtTokenTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa6738aC9F9176b51dB5A19D75A9a2F6315EE8a58)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x6adc80126542a27Fb76051B1bbb43E1F2F11cD9F)
 */
export const writeUsdtVariableDebtTokenTaiko =
  /*#__PURE__*/ createWriteContract({
    abi: usdtVariableDebtTokenTaikoAbi,
    address: usdtVariableDebtTokenTaikoAddress,
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link usdtVariableDebtTokenTaikoAbi}__ and `functionName` set to `"approve"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa6738aC9F9176b51dB5A19D75A9a2F6315EE8a58)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x6adc80126542a27Fb76051B1bbb43E1F2F11cD9F)
 */
export const writeUsdtVariableDebtTokenTaikoApprove =
  /*#__PURE__*/ createWriteContract({
    abi: usdtVariableDebtTokenTaikoAbi,
    address: usdtVariableDebtTokenTaikoAddress,
    functionName: 'approve',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link usdtVariableDebtTokenTaikoAbi}__ and `functionName` set to `"approveDelegation"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa6738aC9F9176b51dB5A19D75A9a2F6315EE8a58)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x6adc80126542a27Fb76051B1bbb43E1F2F11cD9F)
 */
export const writeUsdtVariableDebtTokenTaikoApproveDelegation =
  /*#__PURE__*/ createWriteContract({
    abi: usdtVariableDebtTokenTaikoAbi,
    address: usdtVariableDebtTokenTaikoAddress,
    functionName: 'approveDelegation',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link usdtVariableDebtTokenTaikoAbi}__ and `functionName` set to `"burn"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa6738aC9F9176b51dB5A19D75A9a2F6315EE8a58)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x6adc80126542a27Fb76051B1bbb43E1F2F11cD9F)
 */
export const writeUsdtVariableDebtTokenTaikoBurn =
  /*#__PURE__*/ createWriteContract({
    abi: usdtVariableDebtTokenTaikoAbi,
    address: usdtVariableDebtTokenTaikoAddress,
    functionName: 'burn',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link usdtVariableDebtTokenTaikoAbi}__ and `functionName` set to `"decreaseAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa6738aC9F9176b51dB5A19D75A9a2F6315EE8a58)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x6adc80126542a27Fb76051B1bbb43E1F2F11cD9F)
 */
export const writeUsdtVariableDebtTokenTaikoDecreaseAllowance =
  /*#__PURE__*/ createWriteContract({
    abi: usdtVariableDebtTokenTaikoAbi,
    address: usdtVariableDebtTokenTaikoAddress,
    functionName: 'decreaseAllowance',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link usdtVariableDebtTokenTaikoAbi}__ and `functionName` set to `"delegationWithSig"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa6738aC9F9176b51dB5A19D75A9a2F6315EE8a58)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x6adc80126542a27Fb76051B1bbb43E1F2F11cD9F)
 */
export const writeUsdtVariableDebtTokenTaikoDelegationWithSig =
  /*#__PURE__*/ createWriteContract({
    abi: usdtVariableDebtTokenTaikoAbi,
    address: usdtVariableDebtTokenTaikoAddress,
    functionName: 'delegationWithSig',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link usdtVariableDebtTokenTaikoAbi}__ and `functionName` set to `"increaseAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa6738aC9F9176b51dB5A19D75A9a2F6315EE8a58)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x6adc80126542a27Fb76051B1bbb43E1F2F11cD9F)
 */
export const writeUsdtVariableDebtTokenTaikoIncreaseAllowance =
  /*#__PURE__*/ createWriteContract({
    abi: usdtVariableDebtTokenTaikoAbi,
    address: usdtVariableDebtTokenTaikoAddress,
    functionName: 'increaseAllowance',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link usdtVariableDebtTokenTaikoAbi}__ and `functionName` set to `"initialize"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa6738aC9F9176b51dB5A19D75A9a2F6315EE8a58)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x6adc80126542a27Fb76051B1bbb43E1F2F11cD9F)
 */
export const writeUsdtVariableDebtTokenTaikoInitialize =
  /*#__PURE__*/ createWriteContract({
    abi: usdtVariableDebtTokenTaikoAbi,
    address: usdtVariableDebtTokenTaikoAddress,
    functionName: 'initialize',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link usdtVariableDebtTokenTaikoAbi}__ and `functionName` set to `"mint"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa6738aC9F9176b51dB5A19D75A9a2F6315EE8a58)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x6adc80126542a27Fb76051B1bbb43E1F2F11cD9F)
 */
export const writeUsdtVariableDebtTokenTaikoMint =
  /*#__PURE__*/ createWriteContract({
    abi: usdtVariableDebtTokenTaikoAbi,
    address: usdtVariableDebtTokenTaikoAddress,
    functionName: 'mint',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link usdtVariableDebtTokenTaikoAbi}__ and `functionName` set to `"setIncentivesController"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa6738aC9F9176b51dB5A19D75A9a2F6315EE8a58)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x6adc80126542a27Fb76051B1bbb43E1F2F11cD9F)
 */
export const writeUsdtVariableDebtTokenTaikoSetIncentivesController =
  /*#__PURE__*/ createWriteContract({
    abi: usdtVariableDebtTokenTaikoAbi,
    address: usdtVariableDebtTokenTaikoAddress,
    functionName: 'setIncentivesController',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link usdtVariableDebtTokenTaikoAbi}__ and `functionName` set to `"transfer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa6738aC9F9176b51dB5A19D75A9a2F6315EE8a58)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x6adc80126542a27Fb76051B1bbb43E1F2F11cD9F)
 */
export const writeUsdtVariableDebtTokenTaikoTransfer =
  /*#__PURE__*/ createWriteContract({
    abi: usdtVariableDebtTokenTaikoAbi,
    address: usdtVariableDebtTokenTaikoAddress,
    functionName: 'transfer',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link usdtVariableDebtTokenTaikoAbi}__ and `functionName` set to `"transferFrom"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa6738aC9F9176b51dB5A19D75A9a2F6315EE8a58)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x6adc80126542a27Fb76051B1bbb43E1F2F11cD9F)
 */
export const writeUsdtVariableDebtTokenTaikoTransferFrom =
  /*#__PURE__*/ createWriteContract({
    abi: usdtVariableDebtTokenTaikoAbi,
    address: usdtVariableDebtTokenTaikoAddress,
    functionName: 'transferFrom',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link usdtVariableDebtTokenTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa6738aC9F9176b51dB5A19D75A9a2F6315EE8a58)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x6adc80126542a27Fb76051B1bbb43E1F2F11cD9F)
 */
export const simulateUsdtVariableDebtTokenTaiko =
  /*#__PURE__*/ createSimulateContract({
    abi: usdtVariableDebtTokenTaikoAbi,
    address: usdtVariableDebtTokenTaikoAddress,
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link usdtVariableDebtTokenTaikoAbi}__ and `functionName` set to `"approve"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa6738aC9F9176b51dB5A19D75A9a2F6315EE8a58)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x6adc80126542a27Fb76051B1bbb43E1F2F11cD9F)
 */
export const simulateUsdtVariableDebtTokenTaikoApprove =
  /*#__PURE__*/ createSimulateContract({
    abi: usdtVariableDebtTokenTaikoAbi,
    address: usdtVariableDebtTokenTaikoAddress,
    functionName: 'approve',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link usdtVariableDebtTokenTaikoAbi}__ and `functionName` set to `"approveDelegation"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa6738aC9F9176b51dB5A19D75A9a2F6315EE8a58)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x6adc80126542a27Fb76051B1bbb43E1F2F11cD9F)
 */
export const simulateUsdtVariableDebtTokenTaikoApproveDelegation =
  /*#__PURE__*/ createSimulateContract({
    abi: usdtVariableDebtTokenTaikoAbi,
    address: usdtVariableDebtTokenTaikoAddress,
    functionName: 'approveDelegation',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link usdtVariableDebtTokenTaikoAbi}__ and `functionName` set to `"burn"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa6738aC9F9176b51dB5A19D75A9a2F6315EE8a58)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x6adc80126542a27Fb76051B1bbb43E1F2F11cD9F)
 */
export const simulateUsdtVariableDebtTokenTaikoBurn =
  /*#__PURE__*/ createSimulateContract({
    abi: usdtVariableDebtTokenTaikoAbi,
    address: usdtVariableDebtTokenTaikoAddress,
    functionName: 'burn',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link usdtVariableDebtTokenTaikoAbi}__ and `functionName` set to `"decreaseAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa6738aC9F9176b51dB5A19D75A9a2F6315EE8a58)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x6adc80126542a27Fb76051B1bbb43E1F2F11cD9F)
 */
export const simulateUsdtVariableDebtTokenTaikoDecreaseAllowance =
  /*#__PURE__*/ createSimulateContract({
    abi: usdtVariableDebtTokenTaikoAbi,
    address: usdtVariableDebtTokenTaikoAddress,
    functionName: 'decreaseAllowance',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link usdtVariableDebtTokenTaikoAbi}__ and `functionName` set to `"delegationWithSig"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa6738aC9F9176b51dB5A19D75A9a2F6315EE8a58)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x6adc80126542a27Fb76051B1bbb43E1F2F11cD9F)
 */
export const simulateUsdtVariableDebtTokenTaikoDelegationWithSig =
  /*#__PURE__*/ createSimulateContract({
    abi: usdtVariableDebtTokenTaikoAbi,
    address: usdtVariableDebtTokenTaikoAddress,
    functionName: 'delegationWithSig',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link usdtVariableDebtTokenTaikoAbi}__ and `functionName` set to `"increaseAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa6738aC9F9176b51dB5A19D75A9a2F6315EE8a58)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x6adc80126542a27Fb76051B1bbb43E1F2F11cD9F)
 */
export const simulateUsdtVariableDebtTokenTaikoIncreaseAllowance =
  /*#__PURE__*/ createSimulateContract({
    abi: usdtVariableDebtTokenTaikoAbi,
    address: usdtVariableDebtTokenTaikoAddress,
    functionName: 'increaseAllowance',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link usdtVariableDebtTokenTaikoAbi}__ and `functionName` set to `"initialize"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa6738aC9F9176b51dB5A19D75A9a2F6315EE8a58)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x6adc80126542a27Fb76051B1bbb43E1F2F11cD9F)
 */
export const simulateUsdtVariableDebtTokenTaikoInitialize =
  /*#__PURE__*/ createSimulateContract({
    abi: usdtVariableDebtTokenTaikoAbi,
    address: usdtVariableDebtTokenTaikoAddress,
    functionName: 'initialize',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link usdtVariableDebtTokenTaikoAbi}__ and `functionName` set to `"mint"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa6738aC9F9176b51dB5A19D75A9a2F6315EE8a58)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x6adc80126542a27Fb76051B1bbb43E1F2F11cD9F)
 */
export const simulateUsdtVariableDebtTokenTaikoMint =
  /*#__PURE__*/ createSimulateContract({
    abi: usdtVariableDebtTokenTaikoAbi,
    address: usdtVariableDebtTokenTaikoAddress,
    functionName: 'mint',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link usdtVariableDebtTokenTaikoAbi}__ and `functionName` set to `"setIncentivesController"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa6738aC9F9176b51dB5A19D75A9a2F6315EE8a58)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x6adc80126542a27Fb76051B1bbb43E1F2F11cD9F)
 */
export const simulateUsdtVariableDebtTokenTaikoSetIncentivesController =
  /*#__PURE__*/ createSimulateContract({
    abi: usdtVariableDebtTokenTaikoAbi,
    address: usdtVariableDebtTokenTaikoAddress,
    functionName: 'setIncentivesController',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link usdtVariableDebtTokenTaikoAbi}__ and `functionName` set to `"transfer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa6738aC9F9176b51dB5A19D75A9a2F6315EE8a58)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x6adc80126542a27Fb76051B1bbb43E1F2F11cD9F)
 */
export const simulateUsdtVariableDebtTokenTaikoTransfer =
  /*#__PURE__*/ createSimulateContract({
    abi: usdtVariableDebtTokenTaikoAbi,
    address: usdtVariableDebtTokenTaikoAddress,
    functionName: 'transfer',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link usdtVariableDebtTokenTaikoAbi}__ and `functionName` set to `"transferFrom"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa6738aC9F9176b51dB5A19D75A9a2F6315EE8a58)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x6adc80126542a27Fb76051B1bbb43E1F2F11cD9F)
 */
export const simulateUsdtVariableDebtTokenTaikoTransferFrom =
  /*#__PURE__*/ createSimulateContract({
    abi: usdtVariableDebtTokenTaikoAbi,
    address: usdtVariableDebtTokenTaikoAddress,
    functionName: 'transferFrom',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link usdtVariableDebtTokenTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa6738aC9F9176b51dB5A19D75A9a2F6315EE8a58)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x6adc80126542a27Fb76051B1bbb43E1F2F11cD9F)
 */
export const watchUsdtVariableDebtTokenTaikoEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: usdtVariableDebtTokenTaikoAbi,
    address: usdtVariableDebtTokenTaikoAddress,
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link usdtVariableDebtTokenTaikoAbi}__ and `eventName` set to `"Approval"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa6738aC9F9176b51dB5A19D75A9a2F6315EE8a58)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x6adc80126542a27Fb76051B1bbb43E1F2F11cD9F)
 */
export const watchUsdtVariableDebtTokenTaikoApprovalEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: usdtVariableDebtTokenTaikoAbi,
    address: usdtVariableDebtTokenTaikoAddress,
    eventName: 'Approval',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link usdtVariableDebtTokenTaikoAbi}__ and `eventName` set to `"BorrowAllowanceDelegated"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa6738aC9F9176b51dB5A19D75A9a2F6315EE8a58)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x6adc80126542a27Fb76051B1bbb43E1F2F11cD9F)
 */
export const watchUsdtVariableDebtTokenTaikoBorrowAllowanceDelegatedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: usdtVariableDebtTokenTaikoAbi,
    address: usdtVariableDebtTokenTaikoAddress,
    eventName: 'BorrowAllowanceDelegated',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link usdtVariableDebtTokenTaikoAbi}__ and `eventName` set to `"Burn"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa6738aC9F9176b51dB5A19D75A9a2F6315EE8a58)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x6adc80126542a27Fb76051B1bbb43E1F2F11cD9F)
 */
export const watchUsdtVariableDebtTokenTaikoBurnEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: usdtVariableDebtTokenTaikoAbi,
    address: usdtVariableDebtTokenTaikoAddress,
    eventName: 'Burn',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link usdtVariableDebtTokenTaikoAbi}__ and `eventName` set to `"Initialized"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa6738aC9F9176b51dB5A19D75A9a2F6315EE8a58)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x6adc80126542a27Fb76051B1bbb43E1F2F11cD9F)
 */
export const watchUsdtVariableDebtTokenTaikoInitializedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: usdtVariableDebtTokenTaikoAbi,
    address: usdtVariableDebtTokenTaikoAddress,
    eventName: 'Initialized',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link usdtVariableDebtTokenTaikoAbi}__ and `eventName` set to `"Mint"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa6738aC9F9176b51dB5A19D75A9a2F6315EE8a58)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x6adc80126542a27Fb76051B1bbb43E1F2F11cD9F)
 */
export const watchUsdtVariableDebtTokenTaikoMintEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: usdtVariableDebtTokenTaikoAbi,
    address: usdtVariableDebtTokenTaikoAddress,
    eventName: 'Mint',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link usdtVariableDebtTokenTaikoAbi}__ and `eventName` set to `"Transfer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xa6738aC9F9176b51dB5A19D75A9a2F6315EE8a58)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x6adc80126542a27Fb76051B1bbb43E1F2F11cD9F)
 */
export const watchUsdtVariableDebtTokenTaikoTransferEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: usdtVariableDebtTokenTaikoAbi,
    address: usdtVariableDebtTokenTaikoAddress,
    eventName: 'Transfer',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link uiIncentiveDataProviderV3Abi}__
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x520A3776050B4bbE4CD30c2303c123DeF90671fD)
 */
export const readUiIncentiveDataProviderV3 = /*#__PURE__*/ createReadContract({
  abi: uiIncentiveDataProviderV3Abi,
  address: uiIncentiveDataProviderV3Address,
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link uiIncentiveDataProviderV3Abi}__ and `functionName` set to `"getFullReservesIncentiveData"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x520A3776050B4bbE4CD30c2303c123DeF90671fD)
 */
export const readUiIncentiveDataProviderV3GetFullReservesIncentiveData =
  /*#__PURE__*/ createReadContract({
    abi: uiIncentiveDataProviderV3Abi,
    address: uiIncentiveDataProviderV3Address,
    functionName: 'getFullReservesIncentiveData',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link uiIncentiveDataProviderV3Abi}__ and `functionName` set to `"getReservesIncentivesData"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x520A3776050B4bbE4CD30c2303c123DeF90671fD)
 */
export const readUiIncentiveDataProviderV3GetReservesIncentivesData =
  /*#__PURE__*/ createReadContract({
    abi: uiIncentiveDataProviderV3Abi,
    address: uiIncentiveDataProviderV3Address,
    functionName: 'getReservesIncentivesData',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link uiIncentiveDataProviderV3Abi}__ and `functionName` set to `"getUserReservesIncentivesData"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x520A3776050B4bbE4CD30c2303c123DeF90671fD)
 */
export const readUiIncentiveDataProviderV3GetUserReservesIncentivesData =
  /*#__PURE__*/ createReadContract({
    abi: uiIncentiveDataProviderV3Abi,
    address: uiIncentiveDataProviderV3Address,
    functionName: 'getUserReservesIncentivesData',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link uiPoolDataProviderV3Abi}__
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9877f86A83825B6900aDcb27978C073FaEAD55Dd)
 */
export const readUiPoolDataProviderV3 = /*#__PURE__*/ createReadContract({
  abi: uiPoolDataProviderV3Abi,
  address: uiPoolDataProviderV3Address,
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link uiPoolDataProviderV3Abi}__ and `functionName` set to `"ETH_CURRENCY_UNIT"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9877f86A83825B6900aDcb27978C073FaEAD55Dd)
 */
export const readUiPoolDataProviderV3EthCurrencyUnit =
  /*#__PURE__*/ createReadContract({
    abi: uiPoolDataProviderV3Abi,
    address: uiPoolDataProviderV3Address,
    functionName: 'ETH_CURRENCY_UNIT',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link uiPoolDataProviderV3Abi}__ and `functionName` set to `"MKR_ADDRESS"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9877f86A83825B6900aDcb27978C073FaEAD55Dd)
 */
export const readUiPoolDataProviderV3MkrAddress =
  /*#__PURE__*/ createReadContract({
    abi: uiPoolDataProviderV3Abi,
    address: uiPoolDataProviderV3Address,
    functionName: 'MKR_ADDRESS',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link uiPoolDataProviderV3Abi}__ and `functionName` set to `"bytes32ToString"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9877f86A83825B6900aDcb27978C073FaEAD55Dd)
 */
export const readUiPoolDataProviderV3Bytes32ToString =
  /*#__PURE__*/ createReadContract({
    abi: uiPoolDataProviderV3Abi,
    address: uiPoolDataProviderV3Address,
    functionName: 'bytes32ToString',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link uiPoolDataProviderV3Abi}__ and `functionName` set to `"getReservesData"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9877f86A83825B6900aDcb27978C073FaEAD55Dd)
 */
export const readUiPoolDataProviderV3GetReservesData =
  /*#__PURE__*/ createReadContract({
    abi: uiPoolDataProviderV3Abi,
    address: uiPoolDataProviderV3Address,
    functionName: 'getReservesData',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link uiPoolDataProviderV3Abi}__ and `functionName` set to `"getReservesList"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9877f86A83825B6900aDcb27978C073FaEAD55Dd)
 */
export const readUiPoolDataProviderV3GetReservesList =
  /*#__PURE__*/ createReadContract({
    abi: uiPoolDataProviderV3Abi,
    address: uiPoolDataProviderV3Address,
    functionName: 'getReservesList',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link uiPoolDataProviderV3Abi}__ and `functionName` set to `"getUserReservesData"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9877f86A83825B6900aDcb27978C073FaEAD55Dd)
 */
export const readUiPoolDataProviderV3GetUserReservesData =
  /*#__PURE__*/ createReadContract({
    abi: uiPoolDataProviderV3Abi,
    address: uiPoolDataProviderV3Address,
    functionName: 'getUserReservesData',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link uiPoolDataProviderV3Abi}__ and `functionName` set to `"marketReferenceCurrencyPriceInUsdProxyAggregator"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9877f86A83825B6900aDcb27978C073FaEAD55Dd)
 */
export const readUiPoolDataProviderV3MarketReferenceCurrencyPriceInUsdProxyAggregator =
  /*#__PURE__*/ createReadContract({
    abi: uiPoolDataProviderV3Abi,
    address: uiPoolDataProviderV3Address,
    functionName: 'marketReferenceCurrencyPriceInUsdProxyAggregator',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link uiPoolDataProviderV3Abi}__ and `functionName` set to `"networkBaseTokenPriceInUsdProxyAggregator"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x9877f86A83825B6900aDcb27978C073FaEAD55Dd)
 */
export const readUiPoolDataProviderV3NetworkBaseTokenPriceInUsdProxyAggregator =
  /*#__PURE__*/ createReadContract({
    abi: uiPoolDataProviderV3Abi,
    address: uiPoolDataProviderV3Address,
    functionName: 'networkBaseTokenPriceInUsdProxyAggregator',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link variableDebtTokenTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xb4055dF6337c84e2e1Ae8d938DF0E0f8CAd242c6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD3ac76c5eE3765d465Ec77664F3Afc6C21Ce09DD)
 */
export const readVariableDebtTokenTaiko = /*#__PURE__*/ createReadContract({
  abi: variableDebtTokenTaikoAbi,
  address: variableDebtTokenTaikoAddress,
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link variableDebtTokenTaikoAbi}__ and `functionName` set to `"DEBT_TOKEN_REVISION"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xb4055dF6337c84e2e1Ae8d938DF0E0f8CAd242c6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD3ac76c5eE3765d465Ec77664F3Afc6C21Ce09DD)
 */
export const readVariableDebtTokenTaikoDebtTokenRevision =
  /*#__PURE__*/ createReadContract({
    abi: variableDebtTokenTaikoAbi,
    address: variableDebtTokenTaikoAddress,
    functionName: 'DEBT_TOKEN_REVISION',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link variableDebtTokenTaikoAbi}__ and `functionName` set to `"DELEGATION_WITH_SIG_TYPEHASH"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xb4055dF6337c84e2e1Ae8d938DF0E0f8CAd242c6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD3ac76c5eE3765d465Ec77664F3Afc6C21Ce09DD)
 */
export const readVariableDebtTokenTaikoDelegationWithSigTypehash =
  /*#__PURE__*/ createReadContract({
    abi: variableDebtTokenTaikoAbi,
    address: variableDebtTokenTaikoAddress,
    functionName: 'DELEGATION_WITH_SIG_TYPEHASH',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link variableDebtTokenTaikoAbi}__ and `functionName` set to `"DOMAIN_SEPARATOR"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xb4055dF6337c84e2e1Ae8d938DF0E0f8CAd242c6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD3ac76c5eE3765d465Ec77664F3Afc6C21Ce09DD)
 */
export const readVariableDebtTokenTaikoDomainSeparator =
  /*#__PURE__*/ createReadContract({
    abi: variableDebtTokenTaikoAbi,
    address: variableDebtTokenTaikoAddress,
    functionName: 'DOMAIN_SEPARATOR',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link variableDebtTokenTaikoAbi}__ and `functionName` set to `"EIP712_REVISION"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xb4055dF6337c84e2e1Ae8d938DF0E0f8CAd242c6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD3ac76c5eE3765d465Ec77664F3Afc6C21Ce09DD)
 */
export const readVariableDebtTokenTaikoEip712Revision =
  /*#__PURE__*/ createReadContract({
    abi: variableDebtTokenTaikoAbi,
    address: variableDebtTokenTaikoAddress,
    functionName: 'EIP712_REVISION',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link variableDebtTokenTaikoAbi}__ and `functionName` set to `"POOL"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xb4055dF6337c84e2e1Ae8d938DF0E0f8CAd242c6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD3ac76c5eE3765d465Ec77664F3Afc6C21Ce09DD)
 */
export const readVariableDebtTokenTaikoPool = /*#__PURE__*/ createReadContract({
  abi: variableDebtTokenTaikoAbi,
  address: variableDebtTokenTaikoAddress,
  functionName: 'POOL',
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link variableDebtTokenTaikoAbi}__ and `functionName` set to `"UNDERLYING_ASSET_ADDRESS"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xb4055dF6337c84e2e1Ae8d938DF0E0f8CAd242c6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD3ac76c5eE3765d465Ec77664F3Afc6C21Ce09DD)
 */
export const readVariableDebtTokenTaikoUnderlyingAssetAddress =
  /*#__PURE__*/ createReadContract({
    abi: variableDebtTokenTaikoAbi,
    address: variableDebtTokenTaikoAddress,
    functionName: 'UNDERLYING_ASSET_ADDRESS',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link variableDebtTokenTaikoAbi}__ and `functionName` set to `"allowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xb4055dF6337c84e2e1Ae8d938DF0E0f8CAd242c6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD3ac76c5eE3765d465Ec77664F3Afc6C21Ce09DD)
 */
export const readVariableDebtTokenTaikoAllowance =
  /*#__PURE__*/ createReadContract({
    abi: variableDebtTokenTaikoAbi,
    address: variableDebtTokenTaikoAddress,
    functionName: 'allowance',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link variableDebtTokenTaikoAbi}__ and `functionName` set to `"balanceOf"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xb4055dF6337c84e2e1Ae8d938DF0E0f8CAd242c6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD3ac76c5eE3765d465Ec77664F3Afc6C21Ce09DD)
 */
export const readVariableDebtTokenTaikoBalanceOf =
  /*#__PURE__*/ createReadContract({
    abi: variableDebtTokenTaikoAbi,
    address: variableDebtTokenTaikoAddress,
    functionName: 'balanceOf',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link variableDebtTokenTaikoAbi}__ and `functionName` set to `"borrowAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xb4055dF6337c84e2e1Ae8d938DF0E0f8CAd242c6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD3ac76c5eE3765d465Ec77664F3Afc6C21Ce09DD)
 */
export const readVariableDebtTokenTaikoBorrowAllowance =
  /*#__PURE__*/ createReadContract({
    abi: variableDebtTokenTaikoAbi,
    address: variableDebtTokenTaikoAddress,
    functionName: 'borrowAllowance',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link variableDebtTokenTaikoAbi}__ and `functionName` set to `"decimals"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xb4055dF6337c84e2e1Ae8d938DF0E0f8CAd242c6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD3ac76c5eE3765d465Ec77664F3Afc6C21Ce09DD)
 */
export const readVariableDebtTokenTaikoDecimals =
  /*#__PURE__*/ createReadContract({
    abi: variableDebtTokenTaikoAbi,
    address: variableDebtTokenTaikoAddress,
    functionName: 'decimals',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link variableDebtTokenTaikoAbi}__ and `functionName` set to `"getIncentivesController"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xb4055dF6337c84e2e1Ae8d938DF0E0f8CAd242c6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD3ac76c5eE3765d465Ec77664F3Afc6C21Ce09DD)
 */
export const readVariableDebtTokenTaikoGetIncentivesController =
  /*#__PURE__*/ createReadContract({
    abi: variableDebtTokenTaikoAbi,
    address: variableDebtTokenTaikoAddress,
    functionName: 'getIncentivesController',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link variableDebtTokenTaikoAbi}__ and `functionName` set to `"getPreviousIndex"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xb4055dF6337c84e2e1Ae8d938DF0E0f8CAd242c6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD3ac76c5eE3765d465Ec77664F3Afc6C21Ce09DD)
 */
export const readVariableDebtTokenTaikoGetPreviousIndex =
  /*#__PURE__*/ createReadContract({
    abi: variableDebtTokenTaikoAbi,
    address: variableDebtTokenTaikoAddress,
    functionName: 'getPreviousIndex',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link variableDebtTokenTaikoAbi}__ and `functionName` set to `"getScaledUserBalanceAndSupply"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xb4055dF6337c84e2e1Ae8d938DF0E0f8CAd242c6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD3ac76c5eE3765d465Ec77664F3Afc6C21Ce09DD)
 */
export const readVariableDebtTokenTaikoGetScaledUserBalanceAndSupply =
  /*#__PURE__*/ createReadContract({
    abi: variableDebtTokenTaikoAbi,
    address: variableDebtTokenTaikoAddress,
    functionName: 'getScaledUserBalanceAndSupply',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link variableDebtTokenTaikoAbi}__ and `functionName` set to `"name"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xb4055dF6337c84e2e1Ae8d938DF0E0f8CAd242c6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD3ac76c5eE3765d465Ec77664F3Afc6C21Ce09DD)
 */
export const readVariableDebtTokenTaikoName = /*#__PURE__*/ createReadContract({
  abi: variableDebtTokenTaikoAbi,
  address: variableDebtTokenTaikoAddress,
  functionName: 'name',
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link variableDebtTokenTaikoAbi}__ and `functionName` set to `"nonces"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xb4055dF6337c84e2e1Ae8d938DF0E0f8CAd242c6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD3ac76c5eE3765d465Ec77664F3Afc6C21Ce09DD)
 */
export const readVariableDebtTokenTaikoNonces =
  /*#__PURE__*/ createReadContract({
    abi: variableDebtTokenTaikoAbi,
    address: variableDebtTokenTaikoAddress,
    functionName: 'nonces',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link variableDebtTokenTaikoAbi}__ and `functionName` set to `"scaledBalanceOf"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xb4055dF6337c84e2e1Ae8d938DF0E0f8CAd242c6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD3ac76c5eE3765d465Ec77664F3Afc6C21Ce09DD)
 */
export const readVariableDebtTokenTaikoScaledBalanceOf =
  /*#__PURE__*/ createReadContract({
    abi: variableDebtTokenTaikoAbi,
    address: variableDebtTokenTaikoAddress,
    functionName: 'scaledBalanceOf',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link variableDebtTokenTaikoAbi}__ and `functionName` set to `"scaledTotalSupply"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xb4055dF6337c84e2e1Ae8d938DF0E0f8CAd242c6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD3ac76c5eE3765d465Ec77664F3Afc6C21Ce09DD)
 */
export const readVariableDebtTokenTaikoScaledTotalSupply =
  /*#__PURE__*/ createReadContract({
    abi: variableDebtTokenTaikoAbi,
    address: variableDebtTokenTaikoAddress,
    functionName: 'scaledTotalSupply',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link variableDebtTokenTaikoAbi}__ and `functionName` set to `"symbol"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xb4055dF6337c84e2e1Ae8d938DF0E0f8CAd242c6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD3ac76c5eE3765d465Ec77664F3Afc6C21Ce09DD)
 */
export const readVariableDebtTokenTaikoSymbol =
  /*#__PURE__*/ createReadContract({
    abi: variableDebtTokenTaikoAbi,
    address: variableDebtTokenTaikoAddress,
    functionName: 'symbol',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link variableDebtTokenTaikoAbi}__ and `functionName` set to `"totalSupply"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xb4055dF6337c84e2e1Ae8d938DF0E0f8CAd242c6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD3ac76c5eE3765d465Ec77664F3Afc6C21Ce09DD)
 */
export const readVariableDebtTokenTaikoTotalSupply =
  /*#__PURE__*/ createReadContract({
    abi: variableDebtTokenTaikoAbi,
    address: variableDebtTokenTaikoAddress,
    functionName: 'totalSupply',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link variableDebtTokenTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xb4055dF6337c84e2e1Ae8d938DF0E0f8CAd242c6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD3ac76c5eE3765d465Ec77664F3Afc6C21Ce09DD)
 */
export const writeVariableDebtTokenTaiko = /*#__PURE__*/ createWriteContract({
  abi: variableDebtTokenTaikoAbi,
  address: variableDebtTokenTaikoAddress,
})

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link variableDebtTokenTaikoAbi}__ and `functionName` set to `"approve"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xb4055dF6337c84e2e1Ae8d938DF0E0f8CAd242c6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD3ac76c5eE3765d465Ec77664F3Afc6C21Ce09DD)
 */
export const writeVariableDebtTokenTaikoApprove =
  /*#__PURE__*/ createWriteContract({
    abi: variableDebtTokenTaikoAbi,
    address: variableDebtTokenTaikoAddress,
    functionName: 'approve',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link variableDebtTokenTaikoAbi}__ and `functionName` set to `"approveDelegation"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xb4055dF6337c84e2e1Ae8d938DF0E0f8CAd242c6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD3ac76c5eE3765d465Ec77664F3Afc6C21Ce09DD)
 */
export const writeVariableDebtTokenTaikoApproveDelegation =
  /*#__PURE__*/ createWriteContract({
    abi: variableDebtTokenTaikoAbi,
    address: variableDebtTokenTaikoAddress,
    functionName: 'approveDelegation',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link variableDebtTokenTaikoAbi}__ and `functionName` set to `"burn"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xb4055dF6337c84e2e1Ae8d938DF0E0f8CAd242c6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD3ac76c5eE3765d465Ec77664F3Afc6C21Ce09DD)
 */
export const writeVariableDebtTokenTaikoBurn =
  /*#__PURE__*/ createWriteContract({
    abi: variableDebtTokenTaikoAbi,
    address: variableDebtTokenTaikoAddress,
    functionName: 'burn',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link variableDebtTokenTaikoAbi}__ and `functionName` set to `"decreaseAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xb4055dF6337c84e2e1Ae8d938DF0E0f8CAd242c6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD3ac76c5eE3765d465Ec77664F3Afc6C21Ce09DD)
 */
export const writeVariableDebtTokenTaikoDecreaseAllowance =
  /*#__PURE__*/ createWriteContract({
    abi: variableDebtTokenTaikoAbi,
    address: variableDebtTokenTaikoAddress,
    functionName: 'decreaseAllowance',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link variableDebtTokenTaikoAbi}__ and `functionName` set to `"delegationWithSig"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xb4055dF6337c84e2e1Ae8d938DF0E0f8CAd242c6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD3ac76c5eE3765d465Ec77664F3Afc6C21Ce09DD)
 */
export const writeVariableDebtTokenTaikoDelegationWithSig =
  /*#__PURE__*/ createWriteContract({
    abi: variableDebtTokenTaikoAbi,
    address: variableDebtTokenTaikoAddress,
    functionName: 'delegationWithSig',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link variableDebtTokenTaikoAbi}__ and `functionName` set to `"increaseAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xb4055dF6337c84e2e1Ae8d938DF0E0f8CAd242c6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD3ac76c5eE3765d465Ec77664F3Afc6C21Ce09DD)
 */
export const writeVariableDebtTokenTaikoIncreaseAllowance =
  /*#__PURE__*/ createWriteContract({
    abi: variableDebtTokenTaikoAbi,
    address: variableDebtTokenTaikoAddress,
    functionName: 'increaseAllowance',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link variableDebtTokenTaikoAbi}__ and `functionName` set to `"initialize"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xb4055dF6337c84e2e1Ae8d938DF0E0f8CAd242c6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD3ac76c5eE3765d465Ec77664F3Afc6C21Ce09DD)
 */
export const writeVariableDebtTokenTaikoInitialize =
  /*#__PURE__*/ createWriteContract({
    abi: variableDebtTokenTaikoAbi,
    address: variableDebtTokenTaikoAddress,
    functionName: 'initialize',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link variableDebtTokenTaikoAbi}__ and `functionName` set to `"mint"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xb4055dF6337c84e2e1Ae8d938DF0E0f8CAd242c6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD3ac76c5eE3765d465Ec77664F3Afc6C21Ce09DD)
 */
export const writeVariableDebtTokenTaikoMint =
  /*#__PURE__*/ createWriteContract({
    abi: variableDebtTokenTaikoAbi,
    address: variableDebtTokenTaikoAddress,
    functionName: 'mint',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link variableDebtTokenTaikoAbi}__ and `functionName` set to `"setIncentivesController"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xb4055dF6337c84e2e1Ae8d938DF0E0f8CAd242c6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD3ac76c5eE3765d465Ec77664F3Afc6C21Ce09DD)
 */
export const writeVariableDebtTokenTaikoSetIncentivesController =
  /*#__PURE__*/ createWriteContract({
    abi: variableDebtTokenTaikoAbi,
    address: variableDebtTokenTaikoAddress,
    functionName: 'setIncentivesController',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link variableDebtTokenTaikoAbi}__ and `functionName` set to `"transfer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xb4055dF6337c84e2e1Ae8d938DF0E0f8CAd242c6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD3ac76c5eE3765d465Ec77664F3Afc6C21Ce09DD)
 */
export const writeVariableDebtTokenTaikoTransfer =
  /*#__PURE__*/ createWriteContract({
    abi: variableDebtTokenTaikoAbi,
    address: variableDebtTokenTaikoAddress,
    functionName: 'transfer',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link variableDebtTokenTaikoAbi}__ and `functionName` set to `"transferFrom"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xb4055dF6337c84e2e1Ae8d938DF0E0f8CAd242c6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD3ac76c5eE3765d465Ec77664F3Afc6C21Ce09DD)
 */
export const writeVariableDebtTokenTaikoTransferFrom =
  /*#__PURE__*/ createWriteContract({
    abi: variableDebtTokenTaikoAbi,
    address: variableDebtTokenTaikoAddress,
    functionName: 'transferFrom',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link variableDebtTokenTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xb4055dF6337c84e2e1Ae8d938DF0E0f8CAd242c6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD3ac76c5eE3765d465Ec77664F3Afc6C21Ce09DD)
 */
export const simulateVariableDebtTokenTaiko =
  /*#__PURE__*/ createSimulateContract({
    abi: variableDebtTokenTaikoAbi,
    address: variableDebtTokenTaikoAddress,
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link variableDebtTokenTaikoAbi}__ and `functionName` set to `"approve"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xb4055dF6337c84e2e1Ae8d938DF0E0f8CAd242c6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD3ac76c5eE3765d465Ec77664F3Afc6C21Ce09DD)
 */
export const simulateVariableDebtTokenTaikoApprove =
  /*#__PURE__*/ createSimulateContract({
    abi: variableDebtTokenTaikoAbi,
    address: variableDebtTokenTaikoAddress,
    functionName: 'approve',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link variableDebtTokenTaikoAbi}__ and `functionName` set to `"approveDelegation"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xb4055dF6337c84e2e1Ae8d938DF0E0f8CAd242c6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD3ac76c5eE3765d465Ec77664F3Afc6C21Ce09DD)
 */
export const simulateVariableDebtTokenTaikoApproveDelegation =
  /*#__PURE__*/ createSimulateContract({
    abi: variableDebtTokenTaikoAbi,
    address: variableDebtTokenTaikoAddress,
    functionName: 'approveDelegation',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link variableDebtTokenTaikoAbi}__ and `functionName` set to `"burn"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xb4055dF6337c84e2e1Ae8d938DF0E0f8CAd242c6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD3ac76c5eE3765d465Ec77664F3Afc6C21Ce09DD)
 */
export const simulateVariableDebtTokenTaikoBurn =
  /*#__PURE__*/ createSimulateContract({
    abi: variableDebtTokenTaikoAbi,
    address: variableDebtTokenTaikoAddress,
    functionName: 'burn',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link variableDebtTokenTaikoAbi}__ and `functionName` set to `"decreaseAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xb4055dF6337c84e2e1Ae8d938DF0E0f8CAd242c6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD3ac76c5eE3765d465Ec77664F3Afc6C21Ce09DD)
 */
export const simulateVariableDebtTokenTaikoDecreaseAllowance =
  /*#__PURE__*/ createSimulateContract({
    abi: variableDebtTokenTaikoAbi,
    address: variableDebtTokenTaikoAddress,
    functionName: 'decreaseAllowance',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link variableDebtTokenTaikoAbi}__ and `functionName` set to `"delegationWithSig"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xb4055dF6337c84e2e1Ae8d938DF0E0f8CAd242c6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD3ac76c5eE3765d465Ec77664F3Afc6C21Ce09DD)
 */
export const simulateVariableDebtTokenTaikoDelegationWithSig =
  /*#__PURE__*/ createSimulateContract({
    abi: variableDebtTokenTaikoAbi,
    address: variableDebtTokenTaikoAddress,
    functionName: 'delegationWithSig',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link variableDebtTokenTaikoAbi}__ and `functionName` set to `"increaseAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xb4055dF6337c84e2e1Ae8d938DF0E0f8CAd242c6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD3ac76c5eE3765d465Ec77664F3Afc6C21Ce09DD)
 */
export const simulateVariableDebtTokenTaikoIncreaseAllowance =
  /*#__PURE__*/ createSimulateContract({
    abi: variableDebtTokenTaikoAbi,
    address: variableDebtTokenTaikoAddress,
    functionName: 'increaseAllowance',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link variableDebtTokenTaikoAbi}__ and `functionName` set to `"initialize"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xb4055dF6337c84e2e1Ae8d938DF0E0f8CAd242c6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD3ac76c5eE3765d465Ec77664F3Afc6C21Ce09DD)
 */
export const simulateVariableDebtTokenTaikoInitialize =
  /*#__PURE__*/ createSimulateContract({
    abi: variableDebtTokenTaikoAbi,
    address: variableDebtTokenTaikoAddress,
    functionName: 'initialize',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link variableDebtTokenTaikoAbi}__ and `functionName` set to `"mint"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xb4055dF6337c84e2e1Ae8d938DF0E0f8CAd242c6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD3ac76c5eE3765d465Ec77664F3Afc6C21Ce09DD)
 */
export const simulateVariableDebtTokenTaikoMint =
  /*#__PURE__*/ createSimulateContract({
    abi: variableDebtTokenTaikoAbi,
    address: variableDebtTokenTaikoAddress,
    functionName: 'mint',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link variableDebtTokenTaikoAbi}__ and `functionName` set to `"setIncentivesController"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xb4055dF6337c84e2e1Ae8d938DF0E0f8CAd242c6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD3ac76c5eE3765d465Ec77664F3Afc6C21Ce09DD)
 */
export const simulateVariableDebtTokenTaikoSetIncentivesController =
  /*#__PURE__*/ createSimulateContract({
    abi: variableDebtTokenTaikoAbi,
    address: variableDebtTokenTaikoAddress,
    functionName: 'setIncentivesController',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link variableDebtTokenTaikoAbi}__ and `functionName` set to `"transfer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xb4055dF6337c84e2e1Ae8d938DF0E0f8CAd242c6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD3ac76c5eE3765d465Ec77664F3Afc6C21Ce09DD)
 */
export const simulateVariableDebtTokenTaikoTransfer =
  /*#__PURE__*/ createSimulateContract({
    abi: variableDebtTokenTaikoAbi,
    address: variableDebtTokenTaikoAddress,
    functionName: 'transfer',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link variableDebtTokenTaikoAbi}__ and `functionName` set to `"transferFrom"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xb4055dF6337c84e2e1Ae8d938DF0E0f8CAd242c6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD3ac76c5eE3765d465Ec77664F3Afc6C21Ce09DD)
 */
export const simulateVariableDebtTokenTaikoTransferFrom =
  /*#__PURE__*/ createSimulateContract({
    abi: variableDebtTokenTaikoAbi,
    address: variableDebtTokenTaikoAddress,
    functionName: 'transferFrom',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link variableDebtTokenTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xb4055dF6337c84e2e1Ae8d938DF0E0f8CAd242c6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD3ac76c5eE3765d465Ec77664F3Afc6C21Ce09DD)
 */
export const watchVariableDebtTokenTaikoEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: variableDebtTokenTaikoAbi,
    address: variableDebtTokenTaikoAddress,
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link variableDebtTokenTaikoAbi}__ and `eventName` set to `"Approval"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xb4055dF6337c84e2e1Ae8d938DF0E0f8CAd242c6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD3ac76c5eE3765d465Ec77664F3Afc6C21Ce09DD)
 */
export const watchVariableDebtTokenTaikoApprovalEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: variableDebtTokenTaikoAbi,
    address: variableDebtTokenTaikoAddress,
    eventName: 'Approval',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link variableDebtTokenTaikoAbi}__ and `eventName` set to `"BorrowAllowanceDelegated"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xb4055dF6337c84e2e1Ae8d938DF0E0f8CAd242c6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD3ac76c5eE3765d465Ec77664F3Afc6C21Ce09DD)
 */
export const watchVariableDebtTokenTaikoBorrowAllowanceDelegatedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: variableDebtTokenTaikoAbi,
    address: variableDebtTokenTaikoAddress,
    eventName: 'BorrowAllowanceDelegated',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link variableDebtTokenTaikoAbi}__ and `eventName` set to `"Burn"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xb4055dF6337c84e2e1Ae8d938DF0E0f8CAd242c6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD3ac76c5eE3765d465Ec77664F3Afc6C21Ce09DD)
 */
export const watchVariableDebtTokenTaikoBurnEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: variableDebtTokenTaikoAbi,
    address: variableDebtTokenTaikoAddress,
    eventName: 'Burn',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link variableDebtTokenTaikoAbi}__ and `eventName` set to `"Initialized"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xb4055dF6337c84e2e1Ae8d938DF0E0f8CAd242c6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD3ac76c5eE3765d465Ec77664F3Afc6C21Ce09DD)
 */
export const watchVariableDebtTokenTaikoInitializedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: variableDebtTokenTaikoAbi,
    address: variableDebtTokenTaikoAddress,
    eventName: 'Initialized',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link variableDebtTokenTaikoAbi}__ and `eventName` set to `"Mint"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xb4055dF6337c84e2e1Ae8d938DF0E0f8CAd242c6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD3ac76c5eE3765d465Ec77664F3Afc6C21Ce09DD)
 */
export const watchVariableDebtTokenTaikoMintEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: variableDebtTokenTaikoAbi,
    address: variableDebtTokenTaikoAddress,
    eventName: 'Mint',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link variableDebtTokenTaikoAbi}__ and `eventName` set to `"Transfer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xb4055dF6337c84e2e1Ae8d938DF0E0f8CAd242c6)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD3ac76c5eE3765d465Ec77664F3Afc6C21Ce09DD)
 */
export const watchVariableDebtTokenTaikoTransferEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: variableDebtTokenTaikoAbi,
    address: variableDebtTokenTaikoAddress,
    eventName: 'Transfer',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wbtcATokenTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x2319E98b2E8CdBF09CbBE0764E363A4d5b3414Fd)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4B91BB1816973B4A4A6F19091964C89ED57238a3)
 */
export const readWbtcATokenTaiko = /*#__PURE__*/ createReadContract({
  abi: wbtcATokenTaikoAbi,
  address: wbtcATokenTaikoAddress,
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wbtcATokenTaikoAbi}__ and `functionName` set to `"ATOKEN_REVISION"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x2319E98b2E8CdBF09CbBE0764E363A4d5b3414Fd)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4B91BB1816973B4A4A6F19091964C89ED57238a3)
 */
export const readWbtcATokenTaikoAtokenRevision =
  /*#__PURE__*/ createReadContract({
    abi: wbtcATokenTaikoAbi,
    address: wbtcATokenTaikoAddress,
    functionName: 'ATOKEN_REVISION',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wbtcATokenTaikoAbi}__ and `functionName` set to `"DOMAIN_SEPARATOR"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x2319E98b2E8CdBF09CbBE0764E363A4d5b3414Fd)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4B91BB1816973B4A4A6F19091964C89ED57238a3)
 */
export const readWbtcATokenTaikoDomainSeparator =
  /*#__PURE__*/ createReadContract({
    abi: wbtcATokenTaikoAbi,
    address: wbtcATokenTaikoAddress,
    functionName: 'DOMAIN_SEPARATOR',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wbtcATokenTaikoAbi}__ and `functionName` set to `"EIP712_REVISION"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x2319E98b2E8CdBF09CbBE0764E363A4d5b3414Fd)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4B91BB1816973B4A4A6F19091964C89ED57238a3)
 */
export const readWbtcATokenTaikoEip712Revision =
  /*#__PURE__*/ createReadContract({
    abi: wbtcATokenTaikoAbi,
    address: wbtcATokenTaikoAddress,
    functionName: 'EIP712_REVISION',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wbtcATokenTaikoAbi}__ and `functionName` set to `"PERMIT_TYPEHASH"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x2319E98b2E8CdBF09CbBE0764E363A4d5b3414Fd)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4B91BB1816973B4A4A6F19091964C89ED57238a3)
 */
export const readWbtcATokenTaikoPermitTypehash =
  /*#__PURE__*/ createReadContract({
    abi: wbtcATokenTaikoAbi,
    address: wbtcATokenTaikoAddress,
    functionName: 'PERMIT_TYPEHASH',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wbtcATokenTaikoAbi}__ and `functionName` set to `"POOL"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x2319E98b2E8CdBF09CbBE0764E363A4d5b3414Fd)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4B91BB1816973B4A4A6F19091964C89ED57238a3)
 */
export const readWbtcATokenTaikoPool = /*#__PURE__*/ createReadContract({
  abi: wbtcATokenTaikoAbi,
  address: wbtcATokenTaikoAddress,
  functionName: 'POOL',
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wbtcATokenTaikoAbi}__ and `functionName` set to `"RESERVE_TREASURY_ADDRESS"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x2319E98b2E8CdBF09CbBE0764E363A4d5b3414Fd)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4B91BB1816973B4A4A6F19091964C89ED57238a3)
 */
export const readWbtcATokenTaikoReserveTreasuryAddress =
  /*#__PURE__*/ createReadContract({
    abi: wbtcATokenTaikoAbi,
    address: wbtcATokenTaikoAddress,
    functionName: 'RESERVE_TREASURY_ADDRESS',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wbtcATokenTaikoAbi}__ and `functionName` set to `"UNDERLYING_ASSET_ADDRESS"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x2319E98b2E8CdBF09CbBE0764E363A4d5b3414Fd)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4B91BB1816973B4A4A6F19091964C89ED57238a3)
 */
export const readWbtcATokenTaikoUnderlyingAssetAddress =
  /*#__PURE__*/ createReadContract({
    abi: wbtcATokenTaikoAbi,
    address: wbtcATokenTaikoAddress,
    functionName: 'UNDERLYING_ASSET_ADDRESS',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wbtcATokenTaikoAbi}__ and `functionName` set to `"allowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x2319E98b2E8CdBF09CbBE0764E363A4d5b3414Fd)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4B91BB1816973B4A4A6F19091964C89ED57238a3)
 */
export const readWbtcATokenTaikoAllowance = /*#__PURE__*/ createReadContract({
  abi: wbtcATokenTaikoAbi,
  address: wbtcATokenTaikoAddress,
  functionName: 'allowance',
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wbtcATokenTaikoAbi}__ and `functionName` set to `"balanceOf"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x2319E98b2E8CdBF09CbBE0764E363A4d5b3414Fd)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4B91BB1816973B4A4A6F19091964C89ED57238a3)
 */
export const readWbtcATokenTaikoBalanceOf = /*#__PURE__*/ createReadContract({
  abi: wbtcATokenTaikoAbi,
  address: wbtcATokenTaikoAddress,
  functionName: 'balanceOf',
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wbtcATokenTaikoAbi}__ and `functionName` set to `"decimals"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x2319E98b2E8CdBF09CbBE0764E363A4d5b3414Fd)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4B91BB1816973B4A4A6F19091964C89ED57238a3)
 */
export const readWbtcATokenTaikoDecimals = /*#__PURE__*/ createReadContract({
  abi: wbtcATokenTaikoAbi,
  address: wbtcATokenTaikoAddress,
  functionName: 'decimals',
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wbtcATokenTaikoAbi}__ and `functionName` set to `"getIncentivesController"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x2319E98b2E8CdBF09CbBE0764E363A4d5b3414Fd)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4B91BB1816973B4A4A6F19091964C89ED57238a3)
 */
export const readWbtcATokenTaikoGetIncentivesController =
  /*#__PURE__*/ createReadContract({
    abi: wbtcATokenTaikoAbi,
    address: wbtcATokenTaikoAddress,
    functionName: 'getIncentivesController',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wbtcATokenTaikoAbi}__ and `functionName` set to `"getPreviousIndex"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x2319E98b2E8CdBF09CbBE0764E363A4d5b3414Fd)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4B91BB1816973B4A4A6F19091964C89ED57238a3)
 */
export const readWbtcATokenTaikoGetPreviousIndex =
  /*#__PURE__*/ createReadContract({
    abi: wbtcATokenTaikoAbi,
    address: wbtcATokenTaikoAddress,
    functionName: 'getPreviousIndex',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wbtcATokenTaikoAbi}__ and `functionName` set to `"getScaledUserBalanceAndSupply"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x2319E98b2E8CdBF09CbBE0764E363A4d5b3414Fd)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4B91BB1816973B4A4A6F19091964C89ED57238a3)
 */
export const readWbtcATokenTaikoGetScaledUserBalanceAndSupply =
  /*#__PURE__*/ createReadContract({
    abi: wbtcATokenTaikoAbi,
    address: wbtcATokenTaikoAddress,
    functionName: 'getScaledUserBalanceAndSupply',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wbtcATokenTaikoAbi}__ and `functionName` set to `"name"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x2319E98b2E8CdBF09CbBE0764E363A4d5b3414Fd)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4B91BB1816973B4A4A6F19091964C89ED57238a3)
 */
export const readWbtcATokenTaikoName = /*#__PURE__*/ createReadContract({
  abi: wbtcATokenTaikoAbi,
  address: wbtcATokenTaikoAddress,
  functionName: 'name',
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wbtcATokenTaikoAbi}__ and `functionName` set to `"nonces"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x2319E98b2E8CdBF09CbBE0764E363A4d5b3414Fd)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4B91BB1816973B4A4A6F19091964C89ED57238a3)
 */
export const readWbtcATokenTaikoNonces = /*#__PURE__*/ createReadContract({
  abi: wbtcATokenTaikoAbi,
  address: wbtcATokenTaikoAddress,
  functionName: 'nonces',
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wbtcATokenTaikoAbi}__ and `functionName` set to `"scaledBalanceOf"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x2319E98b2E8CdBF09CbBE0764E363A4d5b3414Fd)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4B91BB1816973B4A4A6F19091964C89ED57238a3)
 */
export const readWbtcATokenTaikoScaledBalanceOf =
  /*#__PURE__*/ createReadContract({
    abi: wbtcATokenTaikoAbi,
    address: wbtcATokenTaikoAddress,
    functionName: 'scaledBalanceOf',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wbtcATokenTaikoAbi}__ and `functionName` set to `"scaledTotalSupply"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x2319E98b2E8CdBF09CbBE0764E363A4d5b3414Fd)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4B91BB1816973B4A4A6F19091964C89ED57238a3)
 */
export const readWbtcATokenTaikoScaledTotalSupply =
  /*#__PURE__*/ createReadContract({
    abi: wbtcATokenTaikoAbi,
    address: wbtcATokenTaikoAddress,
    functionName: 'scaledTotalSupply',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wbtcATokenTaikoAbi}__ and `functionName` set to `"symbol"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x2319E98b2E8CdBF09CbBE0764E363A4d5b3414Fd)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4B91BB1816973B4A4A6F19091964C89ED57238a3)
 */
export const readWbtcATokenTaikoSymbol = /*#__PURE__*/ createReadContract({
  abi: wbtcATokenTaikoAbi,
  address: wbtcATokenTaikoAddress,
  functionName: 'symbol',
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wbtcATokenTaikoAbi}__ and `functionName` set to `"totalSupply"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x2319E98b2E8CdBF09CbBE0764E363A4d5b3414Fd)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4B91BB1816973B4A4A6F19091964C89ED57238a3)
 */
export const readWbtcATokenTaikoTotalSupply = /*#__PURE__*/ createReadContract({
  abi: wbtcATokenTaikoAbi,
  address: wbtcATokenTaikoAddress,
  functionName: 'totalSupply',
})

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wbtcATokenTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x2319E98b2E8CdBF09CbBE0764E363A4d5b3414Fd)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4B91BB1816973B4A4A6F19091964C89ED57238a3)
 */
export const writeWbtcATokenTaiko = /*#__PURE__*/ createWriteContract({
  abi: wbtcATokenTaikoAbi,
  address: wbtcATokenTaikoAddress,
})

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wbtcATokenTaikoAbi}__ and `functionName` set to `"approve"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x2319E98b2E8CdBF09CbBE0764E363A4d5b3414Fd)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4B91BB1816973B4A4A6F19091964C89ED57238a3)
 */
export const writeWbtcATokenTaikoApprove = /*#__PURE__*/ createWriteContract({
  abi: wbtcATokenTaikoAbi,
  address: wbtcATokenTaikoAddress,
  functionName: 'approve',
})

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wbtcATokenTaikoAbi}__ and `functionName` set to `"burn"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x2319E98b2E8CdBF09CbBE0764E363A4d5b3414Fd)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4B91BB1816973B4A4A6F19091964C89ED57238a3)
 */
export const writeWbtcATokenTaikoBurn = /*#__PURE__*/ createWriteContract({
  abi: wbtcATokenTaikoAbi,
  address: wbtcATokenTaikoAddress,
  functionName: 'burn',
})

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wbtcATokenTaikoAbi}__ and `functionName` set to `"decreaseAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x2319E98b2E8CdBF09CbBE0764E363A4d5b3414Fd)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4B91BB1816973B4A4A6F19091964C89ED57238a3)
 */
export const writeWbtcATokenTaikoDecreaseAllowance =
  /*#__PURE__*/ createWriteContract({
    abi: wbtcATokenTaikoAbi,
    address: wbtcATokenTaikoAddress,
    functionName: 'decreaseAllowance',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wbtcATokenTaikoAbi}__ and `functionName` set to `"handleRepayment"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x2319E98b2E8CdBF09CbBE0764E363A4d5b3414Fd)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4B91BB1816973B4A4A6F19091964C89ED57238a3)
 */
export const writeWbtcATokenTaikoHandleRepayment =
  /*#__PURE__*/ createWriteContract({
    abi: wbtcATokenTaikoAbi,
    address: wbtcATokenTaikoAddress,
    functionName: 'handleRepayment',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wbtcATokenTaikoAbi}__ and `functionName` set to `"increaseAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x2319E98b2E8CdBF09CbBE0764E363A4d5b3414Fd)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4B91BB1816973B4A4A6F19091964C89ED57238a3)
 */
export const writeWbtcATokenTaikoIncreaseAllowance =
  /*#__PURE__*/ createWriteContract({
    abi: wbtcATokenTaikoAbi,
    address: wbtcATokenTaikoAddress,
    functionName: 'increaseAllowance',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wbtcATokenTaikoAbi}__ and `functionName` set to `"initialize"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x2319E98b2E8CdBF09CbBE0764E363A4d5b3414Fd)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4B91BB1816973B4A4A6F19091964C89ED57238a3)
 */
export const writeWbtcATokenTaikoInitialize = /*#__PURE__*/ createWriteContract(
  {
    abi: wbtcATokenTaikoAbi,
    address: wbtcATokenTaikoAddress,
    functionName: 'initialize',
  },
)

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wbtcATokenTaikoAbi}__ and `functionName` set to `"mint"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x2319E98b2E8CdBF09CbBE0764E363A4d5b3414Fd)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4B91BB1816973B4A4A6F19091964C89ED57238a3)
 */
export const writeWbtcATokenTaikoMint = /*#__PURE__*/ createWriteContract({
  abi: wbtcATokenTaikoAbi,
  address: wbtcATokenTaikoAddress,
  functionName: 'mint',
})

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wbtcATokenTaikoAbi}__ and `functionName` set to `"mintToTreasury"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x2319E98b2E8CdBF09CbBE0764E363A4d5b3414Fd)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4B91BB1816973B4A4A6F19091964C89ED57238a3)
 */
export const writeWbtcATokenTaikoMintToTreasury =
  /*#__PURE__*/ createWriteContract({
    abi: wbtcATokenTaikoAbi,
    address: wbtcATokenTaikoAddress,
    functionName: 'mintToTreasury',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wbtcATokenTaikoAbi}__ and `functionName` set to `"permit"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x2319E98b2E8CdBF09CbBE0764E363A4d5b3414Fd)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4B91BB1816973B4A4A6F19091964C89ED57238a3)
 */
export const writeWbtcATokenTaikoPermit = /*#__PURE__*/ createWriteContract({
  abi: wbtcATokenTaikoAbi,
  address: wbtcATokenTaikoAddress,
  functionName: 'permit',
})

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wbtcATokenTaikoAbi}__ and `functionName` set to `"rescueTokens"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x2319E98b2E8CdBF09CbBE0764E363A4d5b3414Fd)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4B91BB1816973B4A4A6F19091964C89ED57238a3)
 */
export const writeWbtcATokenTaikoRescueTokens =
  /*#__PURE__*/ createWriteContract({
    abi: wbtcATokenTaikoAbi,
    address: wbtcATokenTaikoAddress,
    functionName: 'rescueTokens',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wbtcATokenTaikoAbi}__ and `functionName` set to `"setIncentivesController"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x2319E98b2E8CdBF09CbBE0764E363A4d5b3414Fd)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4B91BB1816973B4A4A6F19091964C89ED57238a3)
 */
export const writeWbtcATokenTaikoSetIncentivesController =
  /*#__PURE__*/ createWriteContract({
    abi: wbtcATokenTaikoAbi,
    address: wbtcATokenTaikoAddress,
    functionName: 'setIncentivesController',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wbtcATokenTaikoAbi}__ and `functionName` set to `"transfer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x2319E98b2E8CdBF09CbBE0764E363A4d5b3414Fd)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4B91BB1816973B4A4A6F19091964C89ED57238a3)
 */
export const writeWbtcATokenTaikoTransfer = /*#__PURE__*/ createWriteContract({
  abi: wbtcATokenTaikoAbi,
  address: wbtcATokenTaikoAddress,
  functionName: 'transfer',
})

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wbtcATokenTaikoAbi}__ and `functionName` set to `"transferFrom"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x2319E98b2E8CdBF09CbBE0764E363A4d5b3414Fd)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4B91BB1816973B4A4A6F19091964C89ED57238a3)
 */
export const writeWbtcATokenTaikoTransferFrom =
  /*#__PURE__*/ createWriteContract({
    abi: wbtcATokenTaikoAbi,
    address: wbtcATokenTaikoAddress,
    functionName: 'transferFrom',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wbtcATokenTaikoAbi}__ and `functionName` set to `"transferOnLiquidation"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x2319E98b2E8CdBF09CbBE0764E363A4d5b3414Fd)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4B91BB1816973B4A4A6F19091964C89ED57238a3)
 */
export const writeWbtcATokenTaikoTransferOnLiquidation =
  /*#__PURE__*/ createWriteContract({
    abi: wbtcATokenTaikoAbi,
    address: wbtcATokenTaikoAddress,
    functionName: 'transferOnLiquidation',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wbtcATokenTaikoAbi}__ and `functionName` set to `"transferUnderlyingTo"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x2319E98b2E8CdBF09CbBE0764E363A4d5b3414Fd)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4B91BB1816973B4A4A6F19091964C89ED57238a3)
 */
export const writeWbtcATokenTaikoTransferUnderlyingTo =
  /*#__PURE__*/ createWriteContract({
    abi: wbtcATokenTaikoAbi,
    address: wbtcATokenTaikoAddress,
    functionName: 'transferUnderlyingTo',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wbtcATokenTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x2319E98b2E8CdBF09CbBE0764E363A4d5b3414Fd)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4B91BB1816973B4A4A6F19091964C89ED57238a3)
 */
export const simulateWbtcATokenTaiko = /*#__PURE__*/ createSimulateContract({
  abi: wbtcATokenTaikoAbi,
  address: wbtcATokenTaikoAddress,
})

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wbtcATokenTaikoAbi}__ and `functionName` set to `"approve"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x2319E98b2E8CdBF09CbBE0764E363A4d5b3414Fd)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4B91BB1816973B4A4A6F19091964C89ED57238a3)
 */
export const simulateWbtcATokenTaikoApprove =
  /*#__PURE__*/ createSimulateContract({
    abi: wbtcATokenTaikoAbi,
    address: wbtcATokenTaikoAddress,
    functionName: 'approve',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wbtcATokenTaikoAbi}__ and `functionName` set to `"burn"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x2319E98b2E8CdBF09CbBE0764E363A4d5b3414Fd)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4B91BB1816973B4A4A6F19091964C89ED57238a3)
 */
export const simulateWbtcATokenTaikoBurn = /*#__PURE__*/ createSimulateContract(
  {
    abi: wbtcATokenTaikoAbi,
    address: wbtcATokenTaikoAddress,
    functionName: 'burn',
  },
)

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wbtcATokenTaikoAbi}__ and `functionName` set to `"decreaseAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x2319E98b2E8CdBF09CbBE0764E363A4d5b3414Fd)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4B91BB1816973B4A4A6F19091964C89ED57238a3)
 */
export const simulateWbtcATokenTaikoDecreaseAllowance =
  /*#__PURE__*/ createSimulateContract({
    abi: wbtcATokenTaikoAbi,
    address: wbtcATokenTaikoAddress,
    functionName: 'decreaseAllowance',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wbtcATokenTaikoAbi}__ and `functionName` set to `"handleRepayment"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x2319E98b2E8CdBF09CbBE0764E363A4d5b3414Fd)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4B91BB1816973B4A4A6F19091964C89ED57238a3)
 */
export const simulateWbtcATokenTaikoHandleRepayment =
  /*#__PURE__*/ createSimulateContract({
    abi: wbtcATokenTaikoAbi,
    address: wbtcATokenTaikoAddress,
    functionName: 'handleRepayment',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wbtcATokenTaikoAbi}__ and `functionName` set to `"increaseAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x2319E98b2E8CdBF09CbBE0764E363A4d5b3414Fd)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4B91BB1816973B4A4A6F19091964C89ED57238a3)
 */
export const simulateWbtcATokenTaikoIncreaseAllowance =
  /*#__PURE__*/ createSimulateContract({
    abi: wbtcATokenTaikoAbi,
    address: wbtcATokenTaikoAddress,
    functionName: 'increaseAllowance',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wbtcATokenTaikoAbi}__ and `functionName` set to `"initialize"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x2319E98b2E8CdBF09CbBE0764E363A4d5b3414Fd)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4B91BB1816973B4A4A6F19091964C89ED57238a3)
 */
export const simulateWbtcATokenTaikoInitialize =
  /*#__PURE__*/ createSimulateContract({
    abi: wbtcATokenTaikoAbi,
    address: wbtcATokenTaikoAddress,
    functionName: 'initialize',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wbtcATokenTaikoAbi}__ and `functionName` set to `"mint"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x2319E98b2E8CdBF09CbBE0764E363A4d5b3414Fd)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4B91BB1816973B4A4A6F19091964C89ED57238a3)
 */
export const simulateWbtcATokenTaikoMint = /*#__PURE__*/ createSimulateContract(
  {
    abi: wbtcATokenTaikoAbi,
    address: wbtcATokenTaikoAddress,
    functionName: 'mint',
  },
)

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wbtcATokenTaikoAbi}__ and `functionName` set to `"mintToTreasury"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x2319E98b2E8CdBF09CbBE0764E363A4d5b3414Fd)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4B91BB1816973B4A4A6F19091964C89ED57238a3)
 */
export const simulateWbtcATokenTaikoMintToTreasury =
  /*#__PURE__*/ createSimulateContract({
    abi: wbtcATokenTaikoAbi,
    address: wbtcATokenTaikoAddress,
    functionName: 'mintToTreasury',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wbtcATokenTaikoAbi}__ and `functionName` set to `"permit"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x2319E98b2E8CdBF09CbBE0764E363A4d5b3414Fd)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4B91BB1816973B4A4A6F19091964C89ED57238a3)
 */
export const simulateWbtcATokenTaikoPermit =
  /*#__PURE__*/ createSimulateContract({
    abi: wbtcATokenTaikoAbi,
    address: wbtcATokenTaikoAddress,
    functionName: 'permit',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wbtcATokenTaikoAbi}__ and `functionName` set to `"rescueTokens"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x2319E98b2E8CdBF09CbBE0764E363A4d5b3414Fd)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4B91BB1816973B4A4A6F19091964C89ED57238a3)
 */
export const simulateWbtcATokenTaikoRescueTokens =
  /*#__PURE__*/ createSimulateContract({
    abi: wbtcATokenTaikoAbi,
    address: wbtcATokenTaikoAddress,
    functionName: 'rescueTokens',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wbtcATokenTaikoAbi}__ and `functionName` set to `"setIncentivesController"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x2319E98b2E8CdBF09CbBE0764E363A4d5b3414Fd)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4B91BB1816973B4A4A6F19091964C89ED57238a3)
 */
export const simulateWbtcATokenTaikoSetIncentivesController =
  /*#__PURE__*/ createSimulateContract({
    abi: wbtcATokenTaikoAbi,
    address: wbtcATokenTaikoAddress,
    functionName: 'setIncentivesController',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wbtcATokenTaikoAbi}__ and `functionName` set to `"transfer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x2319E98b2E8CdBF09CbBE0764E363A4d5b3414Fd)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4B91BB1816973B4A4A6F19091964C89ED57238a3)
 */
export const simulateWbtcATokenTaikoTransfer =
  /*#__PURE__*/ createSimulateContract({
    abi: wbtcATokenTaikoAbi,
    address: wbtcATokenTaikoAddress,
    functionName: 'transfer',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wbtcATokenTaikoAbi}__ and `functionName` set to `"transferFrom"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x2319E98b2E8CdBF09CbBE0764E363A4d5b3414Fd)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4B91BB1816973B4A4A6F19091964C89ED57238a3)
 */
export const simulateWbtcATokenTaikoTransferFrom =
  /*#__PURE__*/ createSimulateContract({
    abi: wbtcATokenTaikoAbi,
    address: wbtcATokenTaikoAddress,
    functionName: 'transferFrom',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wbtcATokenTaikoAbi}__ and `functionName` set to `"transferOnLiquidation"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x2319E98b2E8CdBF09CbBE0764E363A4d5b3414Fd)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4B91BB1816973B4A4A6F19091964C89ED57238a3)
 */
export const simulateWbtcATokenTaikoTransferOnLiquidation =
  /*#__PURE__*/ createSimulateContract({
    abi: wbtcATokenTaikoAbi,
    address: wbtcATokenTaikoAddress,
    functionName: 'transferOnLiquidation',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wbtcATokenTaikoAbi}__ and `functionName` set to `"transferUnderlyingTo"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x2319E98b2E8CdBF09CbBE0764E363A4d5b3414Fd)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4B91BB1816973B4A4A6F19091964C89ED57238a3)
 */
export const simulateWbtcATokenTaikoTransferUnderlyingTo =
  /*#__PURE__*/ createSimulateContract({
    abi: wbtcATokenTaikoAbi,
    address: wbtcATokenTaikoAddress,
    functionName: 'transferUnderlyingTo',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link wbtcATokenTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x2319E98b2E8CdBF09CbBE0764E363A4d5b3414Fd)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4B91BB1816973B4A4A6F19091964C89ED57238a3)
 */
export const watchWbtcATokenTaikoEvent = /*#__PURE__*/ createWatchContractEvent(
  { abi: wbtcATokenTaikoAbi, address: wbtcATokenTaikoAddress },
)

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link wbtcATokenTaikoAbi}__ and `eventName` set to `"Approval"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x2319E98b2E8CdBF09CbBE0764E363A4d5b3414Fd)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4B91BB1816973B4A4A6F19091964C89ED57238a3)
 */
export const watchWbtcATokenTaikoApprovalEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: wbtcATokenTaikoAbi,
    address: wbtcATokenTaikoAddress,
    eventName: 'Approval',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link wbtcATokenTaikoAbi}__ and `eventName` set to `"BalanceTransfer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x2319E98b2E8CdBF09CbBE0764E363A4d5b3414Fd)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4B91BB1816973B4A4A6F19091964C89ED57238a3)
 */
export const watchWbtcATokenTaikoBalanceTransferEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: wbtcATokenTaikoAbi,
    address: wbtcATokenTaikoAddress,
    eventName: 'BalanceTransfer',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link wbtcATokenTaikoAbi}__ and `eventName` set to `"Burn"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x2319E98b2E8CdBF09CbBE0764E363A4d5b3414Fd)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4B91BB1816973B4A4A6F19091964C89ED57238a3)
 */
export const watchWbtcATokenTaikoBurnEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: wbtcATokenTaikoAbi,
    address: wbtcATokenTaikoAddress,
    eventName: 'Burn',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link wbtcATokenTaikoAbi}__ and `eventName` set to `"Initialized"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x2319E98b2E8CdBF09CbBE0764E363A4d5b3414Fd)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4B91BB1816973B4A4A6F19091964C89ED57238a3)
 */
export const watchWbtcATokenTaikoInitializedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: wbtcATokenTaikoAbi,
    address: wbtcATokenTaikoAddress,
    eventName: 'Initialized',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link wbtcATokenTaikoAbi}__ and `eventName` set to `"Mint"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x2319E98b2E8CdBF09CbBE0764E363A4d5b3414Fd)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4B91BB1816973B4A4A6F19091964C89ED57238a3)
 */
export const watchWbtcATokenTaikoMintEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: wbtcATokenTaikoAbi,
    address: wbtcATokenTaikoAddress,
    eventName: 'Mint',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link wbtcATokenTaikoAbi}__ and `eventName` set to `"Transfer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x2319E98b2E8CdBF09CbBE0764E363A4d5b3414Fd)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x4B91BB1816973B4A4A6F19091964C89ED57238a3)
 */
export const watchWbtcATokenTaikoTransferEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: wbtcATokenTaikoAbi,
    address: wbtcATokenTaikoAddress,
    eventName: 'Transfer',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wbtcStableDebtTokenTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x122C2c5dc7DCfd9eeC4B18144bC6Efa025A04e74)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x8A0013e4711464648f7F46e0cC92D50f3E899e6b)
 */
export const readWbtcStableDebtTokenTaiko = /*#__PURE__*/ createReadContract({
  abi: wbtcStableDebtTokenTaikoAbi,
  address: wbtcStableDebtTokenTaikoAddress,
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wbtcStableDebtTokenTaikoAbi}__ and `functionName` set to `"DEBT_TOKEN_REVISION"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x122C2c5dc7DCfd9eeC4B18144bC6Efa025A04e74)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x8A0013e4711464648f7F46e0cC92D50f3E899e6b)
 */
export const readWbtcStableDebtTokenTaikoDebtTokenRevision =
  /*#__PURE__*/ createReadContract({
    abi: wbtcStableDebtTokenTaikoAbi,
    address: wbtcStableDebtTokenTaikoAddress,
    functionName: 'DEBT_TOKEN_REVISION',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wbtcStableDebtTokenTaikoAbi}__ and `functionName` set to `"DELEGATION_WITH_SIG_TYPEHASH"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x122C2c5dc7DCfd9eeC4B18144bC6Efa025A04e74)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x8A0013e4711464648f7F46e0cC92D50f3E899e6b)
 */
export const readWbtcStableDebtTokenTaikoDelegationWithSigTypehash =
  /*#__PURE__*/ createReadContract({
    abi: wbtcStableDebtTokenTaikoAbi,
    address: wbtcStableDebtTokenTaikoAddress,
    functionName: 'DELEGATION_WITH_SIG_TYPEHASH',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wbtcStableDebtTokenTaikoAbi}__ and `functionName` set to `"DOMAIN_SEPARATOR"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x122C2c5dc7DCfd9eeC4B18144bC6Efa025A04e74)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x8A0013e4711464648f7F46e0cC92D50f3E899e6b)
 */
export const readWbtcStableDebtTokenTaikoDomainSeparator =
  /*#__PURE__*/ createReadContract({
    abi: wbtcStableDebtTokenTaikoAbi,
    address: wbtcStableDebtTokenTaikoAddress,
    functionName: 'DOMAIN_SEPARATOR',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wbtcStableDebtTokenTaikoAbi}__ and `functionName` set to `"EIP712_REVISION"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x122C2c5dc7DCfd9eeC4B18144bC6Efa025A04e74)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x8A0013e4711464648f7F46e0cC92D50f3E899e6b)
 */
export const readWbtcStableDebtTokenTaikoEip712Revision =
  /*#__PURE__*/ createReadContract({
    abi: wbtcStableDebtTokenTaikoAbi,
    address: wbtcStableDebtTokenTaikoAddress,
    functionName: 'EIP712_REVISION',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wbtcStableDebtTokenTaikoAbi}__ and `functionName` set to `"POOL"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x122C2c5dc7DCfd9eeC4B18144bC6Efa025A04e74)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x8A0013e4711464648f7F46e0cC92D50f3E899e6b)
 */
export const readWbtcStableDebtTokenTaikoPool =
  /*#__PURE__*/ createReadContract({
    abi: wbtcStableDebtTokenTaikoAbi,
    address: wbtcStableDebtTokenTaikoAddress,
    functionName: 'POOL',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wbtcStableDebtTokenTaikoAbi}__ and `functionName` set to `"UNDERLYING_ASSET_ADDRESS"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x122C2c5dc7DCfd9eeC4B18144bC6Efa025A04e74)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x8A0013e4711464648f7F46e0cC92D50f3E899e6b)
 */
export const readWbtcStableDebtTokenTaikoUnderlyingAssetAddress =
  /*#__PURE__*/ createReadContract({
    abi: wbtcStableDebtTokenTaikoAbi,
    address: wbtcStableDebtTokenTaikoAddress,
    functionName: 'UNDERLYING_ASSET_ADDRESS',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wbtcStableDebtTokenTaikoAbi}__ and `functionName` set to `"allowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x122C2c5dc7DCfd9eeC4B18144bC6Efa025A04e74)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x8A0013e4711464648f7F46e0cC92D50f3E899e6b)
 */
export const readWbtcStableDebtTokenTaikoAllowance =
  /*#__PURE__*/ createReadContract({
    abi: wbtcStableDebtTokenTaikoAbi,
    address: wbtcStableDebtTokenTaikoAddress,
    functionName: 'allowance',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wbtcStableDebtTokenTaikoAbi}__ and `functionName` set to `"balanceOf"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x122C2c5dc7DCfd9eeC4B18144bC6Efa025A04e74)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x8A0013e4711464648f7F46e0cC92D50f3E899e6b)
 */
export const readWbtcStableDebtTokenTaikoBalanceOf =
  /*#__PURE__*/ createReadContract({
    abi: wbtcStableDebtTokenTaikoAbi,
    address: wbtcStableDebtTokenTaikoAddress,
    functionName: 'balanceOf',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wbtcStableDebtTokenTaikoAbi}__ and `functionName` set to `"borrowAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x122C2c5dc7DCfd9eeC4B18144bC6Efa025A04e74)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x8A0013e4711464648f7F46e0cC92D50f3E899e6b)
 */
export const readWbtcStableDebtTokenTaikoBorrowAllowance =
  /*#__PURE__*/ createReadContract({
    abi: wbtcStableDebtTokenTaikoAbi,
    address: wbtcStableDebtTokenTaikoAddress,
    functionName: 'borrowAllowance',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wbtcStableDebtTokenTaikoAbi}__ and `functionName` set to `"decimals"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x122C2c5dc7DCfd9eeC4B18144bC6Efa025A04e74)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x8A0013e4711464648f7F46e0cC92D50f3E899e6b)
 */
export const readWbtcStableDebtTokenTaikoDecimals =
  /*#__PURE__*/ createReadContract({
    abi: wbtcStableDebtTokenTaikoAbi,
    address: wbtcStableDebtTokenTaikoAddress,
    functionName: 'decimals',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wbtcStableDebtTokenTaikoAbi}__ and `functionName` set to `"getAverageStableRate"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x122C2c5dc7DCfd9eeC4B18144bC6Efa025A04e74)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x8A0013e4711464648f7F46e0cC92D50f3E899e6b)
 */
export const readWbtcStableDebtTokenTaikoGetAverageStableRate =
  /*#__PURE__*/ createReadContract({
    abi: wbtcStableDebtTokenTaikoAbi,
    address: wbtcStableDebtTokenTaikoAddress,
    functionName: 'getAverageStableRate',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wbtcStableDebtTokenTaikoAbi}__ and `functionName` set to `"getIncentivesController"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x122C2c5dc7DCfd9eeC4B18144bC6Efa025A04e74)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x8A0013e4711464648f7F46e0cC92D50f3E899e6b)
 */
export const readWbtcStableDebtTokenTaikoGetIncentivesController =
  /*#__PURE__*/ createReadContract({
    abi: wbtcStableDebtTokenTaikoAbi,
    address: wbtcStableDebtTokenTaikoAddress,
    functionName: 'getIncentivesController',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wbtcStableDebtTokenTaikoAbi}__ and `functionName` set to `"getSupplyData"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x122C2c5dc7DCfd9eeC4B18144bC6Efa025A04e74)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x8A0013e4711464648f7F46e0cC92D50f3E899e6b)
 */
export const readWbtcStableDebtTokenTaikoGetSupplyData =
  /*#__PURE__*/ createReadContract({
    abi: wbtcStableDebtTokenTaikoAbi,
    address: wbtcStableDebtTokenTaikoAddress,
    functionName: 'getSupplyData',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wbtcStableDebtTokenTaikoAbi}__ and `functionName` set to `"getTotalSupplyAndAvgRate"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x122C2c5dc7DCfd9eeC4B18144bC6Efa025A04e74)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x8A0013e4711464648f7F46e0cC92D50f3E899e6b)
 */
export const readWbtcStableDebtTokenTaikoGetTotalSupplyAndAvgRate =
  /*#__PURE__*/ createReadContract({
    abi: wbtcStableDebtTokenTaikoAbi,
    address: wbtcStableDebtTokenTaikoAddress,
    functionName: 'getTotalSupplyAndAvgRate',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wbtcStableDebtTokenTaikoAbi}__ and `functionName` set to `"getTotalSupplyLastUpdated"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x122C2c5dc7DCfd9eeC4B18144bC6Efa025A04e74)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x8A0013e4711464648f7F46e0cC92D50f3E899e6b)
 */
export const readWbtcStableDebtTokenTaikoGetTotalSupplyLastUpdated =
  /*#__PURE__*/ createReadContract({
    abi: wbtcStableDebtTokenTaikoAbi,
    address: wbtcStableDebtTokenTaikoAddress,
    functionName: 'getTotalSupplyLastUpdated',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wbtcStableDebtTokenTaikoAbi}__ and `functionName` set to `"getUserLastUpdated"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x122C2c5dc7DCfd9eeC4B18144bC6Efa025A04e74)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x8A0013e4711464648f7F46e0cC92D50f3E899e6b)
 */
export const readWbtcStableDebtTokenTaikoGetUserLastUpdated =
  /*#__PURE__*/ createReadContract({
    abi: wbtcStableDebtTokenTaikoAbi,
    address: wbtcStableDebtTokenTaikoAddress,
    functionName: 'getUserLastUpdated',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wbtcStableDebtTokenTaikoAbi}__ and `functionName` set to `"getUserStableRate"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x122C2c5dc7DCfd9eeC4B18144bC6Efa025A04e74)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x8A0013e4711464648f7F46e0cC92D50f3E899e6b)
 */
export const readWbtcStableDebtTokenTaikoGetUserStableRate =
  /*#__PURE__*/ createReadContract({
    abi: wbtcStableDebtTokenTaikoAbi,
    address: wbtcStableDebtTokenTaikoAddress,
    functionName: 'getUserStableRate',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wbtcStableDebtTokenTaikoAbi}__ and `functionName` set to `"name"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x122C2c5dc7DCfd9eeC4B18144bC6Efa025A04e74)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x8A0013e4711464648f7F46e0cC92D50f3E899e6b)
 */
export const readWbtcStableDebtTokenTaikoName =
  /*#__PURE__*/ createReadContract({
    abi: wbtcStableDebtTokenTaikoAbi,
    address: wbtcStableDebtTokenTaikoAddress,
    functionName: 'name',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wbtcStableDebtTokenTaikoAbi}__ and `functionName` set to `"nonces"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x122C2c5dc7DCfd9eeC4B18144bC6Efa025A04e74)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x8A0013e4711464648f7F46e0cC92D50f3E899e6b)
 */
export const readWbtcStableDebtTokenTaikoNonces =
  /*#__PURE__*/ createReadContract({
    abi: wbtcStableDebtTokenTaikoAbi,
    address: wbtcStableDebtTokenTaikoAddress,
    functionName: 'nonces',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wbtcStableDebtTokenTaikoAbi}__ and `functionName` set to `"principalBalanceOf"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x122C2c5dc7DCfd9eeC4B18144bC6Efa025A04e74)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x8A0013e4711464648f7F46e0cC92D50f3E899e6b)
 */
export const readWbtcStableDebtTokenTaikoPrincipalBalanceOf =
  /*#__PURE__*/ createReadContract({
    abi: wbtcStableDebtTokenTaikoAbi,
    address: wbtcStableDebtTokenTaikoAddress,
    functionName: 'principalBalanceOf',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wbtcStableDebtTokenTaikoAbi}__ and `functionName` set to `"symbol"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x122C2c5dc7DCfd9eeC4B18144bC6Efa025A04e74)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x8A0013e4711464648f7F46e0cC92D50f3E899e6b)
 */
export const readWbtcStableDebtTokenTaikoSymbol =
  /*#__PURE__*/ createReadContract({
    abi: wbtcStableDebtTokenTaikoAbi,
    address: wbtcStableDebtTokenTaikoAddress,
    functionName: 'symbol',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wbtcStableDebtTokenTaikoAbi}__ and `functionName` set to `"totalSupply"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x122C2c5dc7DCfd9eeC4B18144bC6Efa025A04e74)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x8A0013e4711464648f7F46e0cC92D50f3E899e6b)
 */
export const readWbtcStableDebtTokenTaikoTotalSupply =
  /*#__PURE__*/ createReadContract({
    abi: wbtcStableDebtTokenTaikoAbi,
    address: wbtcStableDebtTokenTaikoAddress,
    functionName: 'totalSupply',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wbtcStableDebtTokenTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x122C2c5dc7DCfd9eeC4B18144bC6Efa025A04e74)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x8A0013e4711464648f7F46e0cC92D50f3E899e6b)
 */
export const writeWbtcStableDebtTokenTaiko = /*#__PURE__*/ createWriteContract({
  abi: wbtcStableDebtTokenTaikoAbi,
  address: wbtcStableDebtTokenTaikoAddress,
})

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wbtcStableDebtTokenTaikoAbi}__ and `functionName` set to `"approve"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x122C2c5dc7DCfd9eeC4B18144bC6Efa025A04e74)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x8A0013e4711464648f7F46e0cC92D50f3E899e6b)
 */
export const writeWbtcStableDebtTokenTaikoApprove =
  /*#__PURE__*/ createWriteContract({
    abi: wbtcStableDebtTokenTaikoAbi,
    address: wbtcStableDebtTokenTaikoAddress,
    functionName: 'approve',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wbtcStableDebtTokenTaikoAbi}__ and `functionName` set to `"approveDelegation"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x122C2c5dc7DCfd9eeC4B18144bC6Efa025A04e74)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x8A0013e4711464648f7F46e0cC92D50f3E899e6b)
 */
export const writeWbtcStableDebtTokenTaikoApproveDelegation =
  /*#__PURE__*/ createWriteContract({
    abi: wbtcStableDebtTokenTaikoAbi,
    address: wbtcStableDebtTokenTaikoAddress,
    functionName: 'approveDelegation',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wbtcStableDebtTokenTaikoAbi}__ and `functionName` set to `"burn"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x122C2c5dc7DCfd9eeC4B18144bC6Efa025A04e74)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x8A0013e4711464648f7F46e0cC92D50f3E899e6b)
 */
export const writeWbtcStableDebtTokenTaikoBurn =
  /*#__PURE__*/ createWriteContract({
    abi: wbtcStableDebtTokenTaikoAbi,
    address: wbtcStableDebtTokenTaikoAddress,
    functionName: 'burn',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wbtcStableDebtTokenTaikoAbi}__ and `functionName` set to `"decreaseAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x122C2c5dc7DCfd9eeC4B18144bC6Efa025A04e74)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x8A0013e4711464648f7F46e0cC92D50f3E899e6b)
 */
export const writeWbtcStableDebtTokenTaikoDecreaseAllowance =
  /*#__PURE__*/ createWriteContract({
    abi: wbtcStableDebtTokenTaikoAbi,
    address: wbtcStableDebtTokenTaikoAddress,
    functionName: 'decreaseAllowance',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wbtcStableDebtTokenTaikoAbi}__ and `functionName` set to `"delegationWithSig"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x122C2c5dc7DCfd9eeC4B18144bC6Efa025A04e74)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x8A0013e4711464648f7F46e0cC92D50f3E899e6b)
 */
export const writeWbtcStableDebtTokenTaikoDelegationWithSig =
  /*#__PURE__*/ createWriteContract({
    abi: wbtcStableDebtTokenTaikoAbi,
    address: wbtcStableDebtTokenTaikoAddress,
    functionName: 'delegationWithSig',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wbtcStableDebtTokenTaikoAbi}__ and `functionName` set to `"increaseAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x122C2c5dc7DCfd9eeC4B18144bC6Efa025A04e74)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x8A0013e4711464648f7F46e0cC92D50f3E899e6b)
 */
export const writeWbtcStableDebtTokenTaikoIncreaseAllowance =
  /*#__PURE__*/ createWriteContract({
    abi: wbtcStableDebtTokenTaikoAbi,
    address: wbtcStableDebtTokenTaikoAddress,
    functionName: 'increaseAllowance',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wbtcStableDebtTokenTaikoAbi}__ and `functionName` set to `"initialize"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x122C2c5dc7DCfd9eeC4B18144bC6Efa025A04e74)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x8A0013e4711464648f7F46e0cC92D50f3E899e6b)
 */
export const writeWbtcStableDebtTokenTaikoInitialize =
  /*#__PURE__*/ createWriteContract({
    abi: wbtcStableDebtTokenTaikoAbi,
    address: wbtcStableDebtTokenTaikoAddress,
    functionName: 'initialize',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wbtcStableDebtTokenTaikoAbi}__ and `functionName` set to `"mint"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x122C2c5dc7DCfd9eeC4B18144bC6Efa025A04e74)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x8A0013e4711464648f7F46e0cC92D50f3E899e6b)
 */
export const writeWbtcStableDebtTokenTaikoMint =
  /*#__PURE__*/ createWriteContract({
    abi: wbtcStableDebtTokenTaikoAbi,
    address: wbtcStableDebtTokenTaikoAddress,
    functionName: 'mint',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wbtcStableDebtTokenTaikoAbi}__ and `functionName` set to `"setIncentivesController"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x122C2c5dc7DCfd9eeC4B18144bC6Efa025A04e74)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x8A0013e4711464648f7F46e0cC92D50f3E899e6b)
 */
export const writeWbtcStableDebtTokenTaikoSetIncentivesController =
  /*#__PURE__*/ createWriteContract({
    abi: wbtcStableDebtTokenTaikoAbi,
    address: wbtcStableDebtTokenTaikoAddress,
    functionName: 'setIncentivesController',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wbtcStableDebtTokenTaikoAbi}__ and `functionName` set to `"transfer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x122C2c5dc7DCfd9eeC4B18144bC6Efa025A04e74)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x8A0013e4711464648f7F46e0cC92D50f3E899e6b)
 */
export const writeWbtcStableDebtTokenTaikoTransfer =
  /*#__PURE__*/ createWriteContract({
    abi: wbtcStableDebtTokenTaikoAbi,
    address: wbtcStableDebtTokenTaikoAddress,
    functionName: 'transfer',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wbtcStableDebtTokenTaikoAbi}__ and `functionName` set to `"transferFrom"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x122C2c5dc7DCfd9eeC4B18144bC6Efa025A04e74)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x8A0013e4711464648f7F46e0cC92D50f3E899e6b)
 */
export const writeWbtcStableDebtTokenTaikoTransferFrom =
  /*#__PURE__*/ createWriteContract({
    abi: wbtcStableDebtTokenTaikoAbi,
    address: wbtcStableDebtTokenTaikoAddress,
    functionName: 'transferFrom',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wbtcStableDebtTokenTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x122C2c5dc7DCfd9eeC4B18144bC6Efa025A04e74)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x8A0013e4711464648f7F46e0cC92D50f3E899e6b)
 */
export const simulateWbtcStableDebtTokenTaiko =
  /*#__PURE__*/ createSimulateContract({
    abi: wbtcStableDebtTokenTaikoAbi,
    address: wbtcStableDebtTokenTaikoAddress,
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wbtcStableDebtTokenTaikoAbi}__ and `functionName` set to `"approve"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x122C2c5dc7DCfd9eeC4B18144bC6Efa025A04e74)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x8A0013e4711464648f7F46e0cC92D50f3E899e6b)
 */
export const simulateWbtcStableDebtTokenTaikoApprove =
  /*#__PURE__*/ createSimulateContract({
    abi: wbtcStableDebtTokenTaikoAbi,
    address: wbtcStableDebtTokenTaikoAddress,
    functionName: 'approve',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wbtcStableDebtTokenTaikoAbi}__ and `functionName` set to `"approveDelegation"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x122C2c5dc7DCfd9eeC4B18144bC6Efa025A04e74)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x8A0013e4711464648f7F46e0cC92D50f3E899e6b)
 */
export const simulateWbtcStableDebtTokenTaikoApproveDelegation =
  /*#__PURE__*/ createSimulateContract({
    abi: wbtcStableDebtTokenTaikoAbi,
    address: wbtcStableDebtTokenTaikoAddress,
    functionName: 'approveDelegation',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wbtcStableDebtTokenTaikoAbi}__ and `functionName` set to `"burn"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x122C2c5dc7DCfd9eeC4B18144bC6Efa025A04e74)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x8A0013e4711464648f7F46e0cC92D50f3E899e6b)
 */
export const simulateWbtcStableDebtTokenTaikoBurn =
  /*#__PURE__*/ createSimulateContract({
    abi: wbtcStableDebtTokenTaikoAbi,
    address: wbtcStableDebtTokenTaikoAddress,
    functionName: 'burn',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wbtcStableDebtTokenTaikoAbi}__ and `functionName` set to `"decreaseAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x122C2c5dc7DCfd9eeC4B18144bC6Efa025A04e74)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x8A0013e4711464648f7F46e0cC92D50f3E899e6b)
 */
export const simulateWbtcStableDebtTokenTaikoDecreaseAllowance =
  /*#__PURE__*/ createSimulateContract({
    abi: wbtcStableDebtTokenTaikoAbi,
    address: wbtcStableDebtTokenTaikoAddress,
    functionName: 'decreaseAllowance',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wbtcStableDebtTokenTaikoAbi}__ and `functionName` set to `"delegationWithSig"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x122C2c5dc7DCfd9eeC4B18144bC6Efa025A04e74)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x8A0013e4711464648f7F46e0cC92D50f3E899e6b)
 */
export const simulateWbtcStableDebtTokenTaikoDelegationWithSig =
  /*#__PURE__*/ createSimulateContract({
    abi: wbtcStableDebtTokenTaikoAbi,
    address: wbtcStableDebtTokenTaikoAddress,
    functionName: 'delegationWithSig',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wbtcStableDebtTokenTaikoAbi}__ and `functionName` set to `"increaseAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x122C2c5dc7DCfd9eeC4B18144bC6Efa025A04e74)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x8A0013e4711464648f7F46e0cC92D50f3E899e6b)
 */
export const simulateWbtcStableDebtTokenTaikoIncreaseAllowance =
  /*#__PURE__*/ createSimulateContract({
    abi: wbtcStableDebtTokenTaikoAbi,
    address: wbtcStableDebtTokenTaikoAddress,
    functionName: 'increaseAllowance',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wbtcStableDebtTokenTaikoAbi}__ and `functionName` set to `"initialize"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x122C2c5dc7DCfd9eeC4B18144bC6Efa025A04e74)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x8A0013e4711464648f7F46e0cC92D50f3E899e6b)
 */
export const simulateWbtcStableDebtTokenTaikoInitialize =
  /*#__PURE__*/ createSimulateContract({
    abi: wbtcStableDebtTokenTaikoAbi,
    address: wbtcStableDebtTokenTaikoAddress,
    functionName: 'initialize',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wbtcStableDebtTokenTaikoAbi}__ and `functionName` set to `"mint"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x122C2c5dc7DCfd9eeC4B18144bC6Efa025A04e74)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x8A0013e4711464648f7F46e0cC92D50f3E899e6b)
 */
export const simulateWbtcStableDebtTokenTaikoMint =
  /*#__PURE__*/ createSimulateContract({
    abi: wbtcStableDebtTokenTaikoAbi,
    address: wbtcStableDebtTokenTaikoAddress,
    functionName: 'mint',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wbtcStableDebtTokenTaikoAbi}__ and `functionName` set to `"setIncentivesController"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x122C2c5dc7DCfd9eeC4B18144bC6Efa025A04e74)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x8A0013e4711464648f7F46e0cC92D50f3E899e6b)
 */
export const simulateWbtcStableDebtTokenTaikoSetIncentivesController =
  /*#__PURE__*/ createSimulateContract({
    abi: wbtcStableDebtTokenTaikoAbi,
    address: wbtcStableDebtTokenTaikoAddress,
    functionName: 'setIncentivesController',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wbtcStableDebtTokenTaikoAbi}__ and `functionName` set to `"transfer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x122C2c5dc7DCfd9eeC4B18144bC6Efa025A04e74)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x8A0013e4711464648f7F46e0cC92D50f3E899e6b)
 */
export const simulateWbtcStableDebtTokenTaikoTransfer =
  /*#__PURE__*/ createSimulateContract({
    abi: wbtcStableDebtTokenTaikoAbi,
    address: wbtcStableDebtTokenTaikoAddress,
    functionName: 'transfer',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wbtcStableDebtTokenTaikoAbi}__ and `functionName` set to `"transferFrom"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x122C2c5dc7DCfd9eeC4B18144bC6Efa025A04e74)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x8A0013e4711464648f7F46e0cC92D50f3E899e6b)
 */
export const simulateWbtcStableDebtTokenTaikoTransferFrom =
  /*#__PURE__*/ createSimulateContract({
    abi: wbtcStableDebtTokenTaikoAbi,
    address: wbtcStableDebtTokenTaikoAddress,
    functionName: 'transferFrom',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link wbtcStableDebtTokenTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x122C2c5dc7DCfd9eeC4B18144bC6Efa025A04e74)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x8A0013e4711464648f7F46e0cC92D50f3E899e6b)
 */
export const watchWbtcStableDebtTokenTaikoEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: wbtcStableDebtTokenTaikoAbi,
    address: wbtcStableDebtTokenTaikoAddress,
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link wbtcStableDebtTokenTaikoAbi}__ and `eventName` set to `"Approval"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x122C2c5dc7DCfd9eeC4B18144bC6Efa025A04e74)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x8A0013e4711464648f7F46e0cC92D50f3E899e6b)
 */
export const watchWbtcStableDebtTokenTaikoApprovalEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: wbtcStableDebtTokenTaikoAbi,
    address: wbtcStableDebtTokenTaikoAddress,
    eventName: 'Approval',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link wbtcStableDebtTokenTaikoAbi}__ and `eventName` set to `"BorrowAllowanceDelegated"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x122C2c5dc7DCfd9eeC4B18144bC6Efa025A04e74)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x8A0013e4711464648f7F46e0cC92D50f3E899e6b)
 */
export const watchWbtcStableDebtTokenTaikoBorrowAllowanceDelegatedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: wbtcStableDebtTokenTaikoAbi,
    address: wbtcStableDebtTokenTaikoAddress,
    eventName: 'BorrowAllowanceDelegated',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link wbtcStableDebtTokenTaikoAbi}__ and `eventName` set to `"Burn"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x122C2c5dc7DCfd9eeC4B18144bC6Efa025A04e74)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x8A0013e4711464648f7F46e0cC92D50f3E899e6b)
 */
export const watchWbtcStableDebtTokenTaikoBurnEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: wbtcStableDebtTokenTaikoAbi,
    address: wbtcStableDebtTokenTaikoAddress,
    eventName: 'Burn',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link wbtcStableDebtTokenTaikoAbi}__ and `eventName` set to `"Initialized"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x122C2c5dc7DCfd9eeC4B18144bC6Efa025A04e74)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x8A0013e4711464648f7F46e0cC92D50f3E899e6b)
 */
export const watchWbtcStableDebtTokenTaikoInitializedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: wbtcStableDebtTokenTaikoAbi,
    address: wbtcStableDebtTokenTaikoAddress,
    eventName: 'Initialized',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link wbtcStableDebtTokenTaikoAbi}__ and `eventName` set to `"Mint"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x122C2c5dc7DCfd9eeC4B18144bC6Efa025A04e74)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x8A0013e4711464648f7F46e0cC92D50f3E899e6b)
 */
export const watchWbtcStableDebtTokenTaikoMintEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: wbtcStableDebtTokenTaikoAbi,
    address: wbtcStableDebtTokenTaikoAddress,
    eventName: 'Mint',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link wbtcStableDebtTokenTaikoAbi}__ and `eventName` set to `"Transfer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x122C2c5dc7DCfd9eeC4B18144bC6Efa025A04e74)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x8A0013e4711464648f7F46e0cC92D50f3E899e6b)
 */
export const watchWbtcStableDebtTokenTaikoTransferEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: wbtcStableDebtTokenTaikoAbi,
    address: wbtcStableDebtTokenTaikoAddress,
    eventName: 'Transfer',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wbtcTestnetMintableErc20TaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x181aAaE8fd558f6F21E895c59274dB153001E8b4)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x31dEcF589B30c8fbDA934f1F4b1E0aF5bECfFb86)
 */
export const readWbtcTestnetMintableErc20Taiko =
  /*#__PURE__*/ createReadContract({
    abi: wbtcTestnetMintableErc20TaikoAbi,
    address: wbtcTestnetMintableErc20TaikoAddress,
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wbtcTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"allowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x181aAaE8fd558f6F21E895c59274dB153001E8b4)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x31dEcF589B30c8fbDA934f1F4b1E0aF5bECfFb86)
 */
export const readWbtcTestnetMintableErc20TaikoAllowance =
  /*#__PURE__*/ createReadContract({
    abi: wbtcTestnetMintableErc20TaikoAbi,
    address: wbtcTestnetMintableErc20TaikoAddress,
    functionName: 'allowance',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wbtcTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"balanceOf"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x181aAaE8fd558f6F21E895c59274dB153001E8b4)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x31dEcF589B30c8fbDA934f1F4b1E0aF5bECfFb86)
 */
export const readWbtcTestnetMintableErc20TaikoBalanceOf =
  /*#__PURE__*/ createReadContract({
    abi: wbtcTestnetMintableErc20TaikoAbi,
    address: wbtcTestnetMintableErc20TaikoAddress,
    functionName: 'balanceOf',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wbtcTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"decimals"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x181aAaE8fd558f6F21E895c59274dB153001E8b4)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x31dEcF589B30c8fbDA934f1F4b1E0aF5bECfFb86)
 */
export const readWbtcTestnetMintableErc20TaikoDecimals =
  /*#__PURE__*/ createReadContract({
    abi: wbtcTestnetMintableErc20TaikoAbi,
    address: wbtcTestnetMintableErc20TaikoAddress,
    functionName: 'decimals',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wbtcTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"name"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x181aAaE8fd558f6F21E895c59274dB153001E8b4)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x31dEcF589B30c8fbDA934f1F4b1E0aF5bECfFb86)
 */
export const readWbtcTestnetMintableErc20TaikoName =
  /*#__PURE__*/ createReadContract({
    abi: wbtcTestnetMintableErc20TaikoAbi,
    address: wbtcTestnetMintableErc20TaikoAddress,
    functionName: 'name',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wbtcTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"symbol"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x181aAaE8fd558f6F21E895c59274dB153001E8b4)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x31dEcF589B30c8fbDA934f1F4b1E0aF5bECfFb86)
 */
export const readWbtcTestnetMintableErc20TaikoSymbol =
  /*#__PURE__*/ createReadContract({
    abi: wbtcTestnetMintableErc20TaikoAbi,
    address: wbtcTestnetMintableErc20TaikoAddress,
    functionName: 'symbol',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wbtcTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"tokenDecimals"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x181aAaE8fd558f6F21E895c59274dB153001E8b4)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x31dEcF589B30c8fbDA934f1F4b1E0aF5bECfFb86)
 */
export const readWbtcTestnetMintableErc20TaikoTokenDecimals =
  /*#__PURE__*/ createReadContract({
    abi: wbtcTestnetMintableErc20TaikoAbi,
    address: wbtcTestnetMintableErc20TaikoAddress,
    functionName: 'tokenDecimals',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wbtcTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"totalSupply"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x181aAaE8fd558f6F21E895c59274dB153001E8b4)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x31dEcF589B30c8fbDA934f1F4b1E0aF5bECfFb86)
 */
export const readWbtcTestnetMintableErc20TaikoTotalSupply =
  /*#__PURE__*/ createReadContract({
    abi: wbtcTestnetMintableErc20TaikoAbi,
    address: wbtcTestnetMintableErc20TaikoAddress,
    functionName: 'totalSupply',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wbtcTestnetMintableErc20TaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x181aAaE8fd558f6F21E895c59274dB153001E8b4)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x31dEcF589B30c8fbDA934f1F4b1E0aF5bECfFb86)
 */
export const writeWbtcTestnetMintableErc20Taiko =
  /*#__PURE__*/ createWriteContract({
    abi: wbtcTestnetMintableErc20TaikoAbi,
    address: wbtcTestnetMintableErc20TaikoAddress,
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wbtcTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"approve"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x181aAaE8fd558f6F21E895c59274dB153001E8b4)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x31dEcF589B30c8fbDA934f1F4b1E0aF5bECfFb86)
 */
export const writeWbtcTestnetMintableErc20TaikoApprove =
  /*#__PURE__*/ createWriteContract({
    abi: wbtcTestnetMintableErc20TaikoAbi,
    address: wbtcTestnetMintableErc20TaikoAddress,
    functionName: 'approve',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wbtcTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"decreaseAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x181aAaE8fd558f6F21E895c59274dB153001E8b4)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x31dEcF589B30c8fbDA934f1F4b1E0aF5bECfFb86)
 */
export const writeWbtcTestnetMintableErc20TaikoDecreaseAllowance =
  /*#__PURE__*/ createWriteContract({
    abi: wbtcTestnetMintableErc20TaikoAbi,
    address: wbtcTestnetMintableErc20TaikoAddress,
    functionName: 'decreaseAllowance',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wbtcTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"increaseAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x181aAaE8fd558f6F21E895c59274dB153001E8b4)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x31dEcF589B30c8fbDA934f1F4b1E0aF5bECfFb86)
 */
export const writeWbtcTestnetMintableErc20TaikoIncreaseAllowance =
  /*#__PURE__*/ createWriteContract({
    abi: wbtcTestnetMintableErc20TaikoAbi,
    address: wbtcTestnetMintableErc20TaikoAddress,
    functionName: 'increaseAllowance',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wbtcTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"transfer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x181aAaE8fd558f6F21E895c59274dB153001E8b4)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x31dEcF589B30c8fbDA934f1F4b1E0aF5bECfFb86)
 */
export const writeWbtcTestnetMintableErc20TaikoTransfer =
  /*#__PURE__*/ createWriteContract({
    abi: wbtcTestnetMintableErc20TaikoAbi,
    address: wbtcTestnetMintableErc20TaikoAddress,
    functionName: 'transfer',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wbtcTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"transferFrom"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x181aAaE8fd558f6F21E895c59274dB153001E8b4)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x31dEcF589B30c8fbDA934f1F4b1E0aF5bECfFb86)
 */
export const writeWbtcTestnetMintableErc20TaikoTransferFrom =
  /*#__PURE__*/ createWriteContract({
    abi: wbtcTestnetMintableErc20TaikoAbi,
    address: wbtcTestnetMintableErc20TaikoAddress,
    functionName: 'transferFrom',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wbtcTestnetMintableErc20TaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x181aAaE8fd558f6F21E895c59274dB153001E8b4)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x31dEcF589B30c8fbDA934f1F4b1E0aF5bECfFb86)
 */
export const simulateWbtcTestnetMintableErc20Taiko =
  /*#__PURE__*/ createSimulateContract({
    abi: wbtcTestnetMintableErc20TaikoAbi,
    address: wbtcTestnetMintableErc20TaikoAddress,
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wbtcTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"approve"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x181aAaE8fd558f6F21E895c59274dB153001E8b4)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x31dEcF589B30c8fbDA934f1F4b1E0aF5bECfFb86)
 */
export const simulateWbtcTestnetMintableErc20TaikoApprove =
  /*#__PURE__*/ createSimulateContract({
    abi: wbtcTestnetMintableErc20TaikoAbi,
    address: wbtcTestnetMintableErc20TaikoAddress,
    functionName: 'approve',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wbtcTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"decreaseAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x181aAaE8fd558f6F21E895c59274dB153001E8b4)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x31dEcF589B30c8fbDA934f1F4b1E0aF5bECfFb86)
 */
export const simulateWbtcTestnetMintableErc20TaikoDecreaseAllowance =
  /*#__PURE__*/ createSimulateContract({
    abi: wbtcTestnetMintableErc20TaikoAbi,
    address: wbtcTestnetMintableErc20TaikoAddress,
    functionName: 'decreaseAllowance',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wbtcTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"increaseAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x181aAaE8fd558f6F21E895c59274dB153001E8b4)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x31dEcF589B30c8fbDA934f1F4b1E0aF5bECfFb86)
 */
export const simulateWbtcTestnetMintableErc20TaikoIncreaseAllowance =
  /*#__PURE__*/ createSimulateContract({
    abi: wbtcTestnetMintableErc20TaikoAbi,
    address: wbtcTestnetMintableErc20TaikoAddress,
    functionName: 'increaseAllowance',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wbtcTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"transfer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x181aAaE8fd558f6F21E895c59274dB153001E8b4)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x31dEcF589B30c8fbDA934f1F4b1E0aF5bECfFb86)
 */
export const simulateWbtcTestnetMintableErc20TaikoTransfer =
  /*#__PURE__*/ createSimulateContract({
    abi: wbtcTestnetMintableErc20TaikoAbi,
    address: wbtcTestnetMintableErc20TaikoAddress,
    functionName: 'transfer',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wbtcTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"transferFrom"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x181aAaE8fd558f6F21E895c59274dB153001E8b4)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x31dEcF589B30c8fbDA934f1F4b1E0aF5bECfFb86)
 */
export const simulateWbtcTestnetMintableErc20TaikoTransferFrom =
  /*#__PURE__*/ createSimulateContract({
    abi: wbtcTestnetMintableErc20TaikoAbi,
    address: wbtcTestnetMintableErc20TaikoAddress,
    functionName: 'transferFrom',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link wbtcTestnetMintableErc20TaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x181aAaE8fd558f6F21E895c59274dB153001E8b4)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x31dEcF589B30c8fbDA934f1F4b1E0aF5bECfFb86)
 */
export const watchWbtcTestnetMintableErc20TaikoEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: wbtcTestnetMintableErc20TaikoAbi,
    address: wbtcTestnetMintableErc20TaikoAddress,
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link wbtcTestnetMintableErc20TaikoAbi}__ and `eventName` set to `"Approval"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x181aAaE8fd558f6F21E895c59274dB153001E8b4)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x31dEcF589B30c8fbDA934f1F4b1E0aF5bECfFb86)
 */
export const watchWbtcTestnetMintableErc20TaikoApprovalEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: wbtcTestnetMintableErc20TaikoAbi,
    address: wbtcTestnetMintableErc20TaikoAddress,
    eventName: 'Approval',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link wbtcTestnetMintableErc20TaikoAbi}__ and `eventName` set to `"Transfer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x181aAaE8fd558f6F21E895c59274dB153001E8b4)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x31dEcF589B30c8fbDA934f1F4b1E0aF5bECfFb86)
 */
export const watchWbtcTestnetMintableErc20TaikoTransferEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: wbtcTestnetMintableErc20TaikoAbi,
    address: wbtcTestnetMintableErc20TaikoAddress,
    eventName: 'Transfer',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wbtcTestnetPriceAggregatorTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x7e6554731E5B1eA348ec911366a3Bc766d6601c0)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xf2A0bFA07E920A708C51f5CB98e7A6CbD1D02c24)
 */
export const readWbtcTestnetPriceAggregatorTaiko =
  /*#__PURE__*/ createReadContract({
    abi: wbtcTestnetPriceAggregatorTaikoAbi,
    address: wbtcTestnetPriceAggregatorTaikoAddress,
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wbtcTestnetPriceAggregatorTaikoAbi}__ and `functionName` set to `"decimals"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x7e6554731E5B1eA348ec911366a3Bc766d6601c0)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xf2A0bFA07E920A708C51f5CB98e7A6CbD1D02c24)
 */
export const readWbtcTestnetPriceAggregatorTaikoDecimals =
  /*#__PURE__*/ createReadContract({
    abi: wbtcTestnetPriceAggregatorTaikoAbi,
    address: wbtcTestnetPriceAggregatorTaikoAddress,
    functionName: 'decimals',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wbtcTestnetPriceAggregatorTaikoAbi}__ and `functionName` set to `"getTokenType"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x7e6554731E5B1eA348ec911366a3Bc766d6601c0)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xf2A0bFA07E920A708C51f5CB98e7A6CbD1D02c24)
 */
export const readWbtcTestnetPriceAggregatorTaikoGetTokenType =
  /*#__PURE__*/ createReadContract({
    abi: wbtcTestnetPriceAggregatorTaikoAbi,
    address: wbtcTestnetPriceAggregatorTaikoAddress,
    functionName: 'getTokenType',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wbtcTestnetPriceAggregatorTaikoAbi}__ and `functionName` set to `"latestAnswer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x7e6554731E5B1eA348ec911366a3Bc766d6601c0)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xf2A0bFA07E920A708C51f5CB98e7A6CbD1D02c24)
 */
export const readWbtcTestnetPriceAggregatorTaikoLatestAnswer =
  /*#__PURE__*/ createReadContract({
    abi: wbtcTestnetPriceAggregatorTaikoAbi,
    address: wbtcTestnetPriceAggregatorTaikoAddress,
    functionName: 'latestAnswer',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link wbtcTestnetPriceAggregatorTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x7e6554731E5B1eA348ec911366a3Bc766d6601c0)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xf2A0bFA07E920A708C51f5CB98e7A6CbD1D02c24)
 */
export const watchWbtcTestnetPriceAggregatorTaikoEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: wbtcTestnetPriceAggregatorTaikoAbi,
    address: wbtcTestnetPriceAggregatorTaikoAddress,
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link wbtcTestnetPriceAggregatorTaikoAbi}__ and `eventName` set to `"AnswerUpdated"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x7e6554731E5B1eA348ec911366a3Bc766d6601c0)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xf2A0bFA07E920A708C51f5CB98e7A6CbD1D02c24)
 */
export const watchWbtcTestnetPriceAggregatorTaikoAnswerUpdatedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: wbtcTestnetPriceAggregatorTaikoAbi,
    address: wbtcTestnetPriceAggregatorTaikoAddress,
    eventName: 'AnswerUpdated',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wbtcVariableDebtTokenTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x30B5199E490876eA6E8B2BAC4d5f3294AdA3C4A5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x935c15D0B4e464474F2011Ff3A8aF5283A82929a)
 */
export const readWbtcVariableDebtTokenTaiko = /*#__PURE__*/ createReadContract({
  abi: wbtcVariableDebtTokenTaikoAbi,
  address: wbtcVariableDebtTokenTaikoAddress,
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wbtcVariableDebtTokenTaikoAbi}__ and `functionName` set to `"DEBT_TOKEN_REVISION"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x30B5199E490876eA6E8B2BAC4d5f3294AdA3C4A5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x935c15D0B4e464474F2011Ff3A8aF5283A82929a)
 */
export const readWbtcVariableDebtTokenTaikoDebtTokenRevision =
  /*#__PURE__*/ createReadContract({
    abi: wbtcVariableDebtTokenTaikoAbi,
    address: wbtcVariableDebtTokenTaikoAddress,
    functionName: 'DEBT_TOKEN_REVISION',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wbtcVariableDebtTokenTaikoAbi}__ and `functionName` set to `"DELEGATION_WITH_SIG_TYPEHASH"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x30B5199E490876eA6E8B2BAC4d5f3294AdA3C4A5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x935c15D0B4e464474F2011Ff3A8aF5283A82929a)
 */
export const readWbtcVariableDebtTokenTaikoDelegationWithSigTypehash =
  /*#__PURE__*/ createReadContract({
    abi: wbtcVariableDebtTokenTaikoAbi,
    address: wbtcVariableDebtTokenTaikoAddress,
    functionName: 'DELEGATION_WITH_SIG_TYPEHASH',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wbtcVariableDebtTokenTaikoAbi}__ and `functionName` set to `"DOMAIN_SEPARATOR"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x30B5199E490876eA6E8B2BAC4d5f3294AdA3C4A5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x935c15D0B4e464474F2011Ff3A8aF5283A82929a)
 */
export const readWbtcVariableDebtTokenTaikoDomainSeparator =
  /*#__PURE__*/ createReadContract({
    abi: wbtcVariableDebtTokenTaikoAbi,
    address: wbtcVariableDebtTokenTaikoAddress,
    functionName: 'DOMAIN_SEPARATOR',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wbtcVariableDebtTokenTaikoAbi}__ and `functionName` set to `"EIP712_REVISION"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x30B5199E490876eA6E8B2BAC4d5f3294AdA3C4A5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x935c15D0B4e464474F2011Ff3A8aF5283A82929a)
 */
export const readWbtcVariableDebtTokenTaikoEip712Revision =
  /*#__PURE__*/ createReadContract({
    abi: wbtcVariableDebtTokenTaikoAbi,
    address: wbtcVariableDebtTokenTaikoAddress,
    functionName: 'EIP712_REVISION',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wbtcVariableDebtTokenTaikoAbi}__ and `functionName` set to `"POOL"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x30B5199E490876eA6E8B2BAC4d5f3294AdA3C4A5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x935c15D0B4e464474F2011Ff3A8aF5283A82929a)
 */
export const readWbtcVariableDebtTokenTaikoPool =
  /*#__PURE__*/ createReadContract({
    abi: wbtcVariableDebtTokenTaikoAbi,
    address: wbtcVariableDebtTokenTaikoAddress,
    functionName: 'POOL',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wbtcVariableDebtTokenTaikoAbi}__ and `functionName` set to `"UNDERLYING_ASSET_ADDRESS"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x30B5199E490876eA6E8B2BAC4d5f3294AdA3C4A5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x935c15D0B4e464474F2011Ff3A8aF5283A82929a)
 */
export const readWbtcVariableDebtTokenTaikoUnderlyingAssetAddress =
  /*#__PURE__*/ createReadContract({
    abi: wbtcVariableDebtTokenTaikoAbi,
    address: wbtcVariableDebtTokenTaikoAddress,
    functionName: 'UNDERLYING_ASSET_ADDRESS',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wbtcVariableDebtTokenTaikoAbi}__ and `functionName` set to `"allowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x30B5199E490876eA6E8B2BAC4d5f3294AdA3C4A5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x935c15D0B4e464474F2011Ff3A8aF5283A82929a)
 */
export const readWbtcVariableDebtTokenTaikoAllowance =
  /*#__PURE__*/ createReadContract({
    abi: wbtcVariableDebtTokenTaikoAbi,
    address: wbtcVariableDebtTokenTaikoAddress,
    functionName: 'allowance',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wbtcVariableDebtTokenTaikoAbi}__ and `functionName` set to `"balanceOf"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x30B5199E490876eA6E8B2BAC4d5f3294AdA3C4A5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x935c15D0B4e464474F2011Ff3A8aF5283A82929a)
 */
export const readWbtcVariableDebtTokenTaikoBalanceOf =
  /*#__PURE__*/ createReadContract({
    abi: wbtcVariableDebtTokenTaikoAbi,
    address: wbtcVariableDebtTokenTaikoAddress,
    functionName: 'balanceOf',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wbtcVariableDebtTokenTaikoAbi}__ and `functionName` set to `"borrowAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x30B5199E490876eA6E8B2BAC4d5f3294AdA3C4A5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x935c15D0B4e464474F2011Ff3A8aF5283A82929a)
 */
export const readWbtcVariableDebtTokenTaikoBorrowAllowance =
  /*#__PURE__*/ createReadContract({
    abi: wbtcVariableDebtTokenTaikoAbi,
    address: wbtcVariableDebtTokenTaikoAddress,
    functionName: 'borrowAllowance',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wbtcVariableDebtTokenTaikoAbi}__ and `functionName` set to `"decimals"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x30B5199E490876eA6E8B2BAC4d5f3294AdA3C4A5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x935c15D0B4e464474F2011Ff3A8aF5283A82929a)
 */
export const readWbtcVariableDebtTokenTaikoDecimals =
  /*#__PURE__*/ createReadContract({
    abi: wbtcVariableDebtTokenTaikoAbi,
    address: wbtcVariableDebtTokenTaikoAddress,
    functionName: 'decimals',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wbtcVariableDebtTokenTaikoAbi}__ and `functionName` set to `"getIncentivesController"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x30B5199E490876eA6E8B2BAC4d5f3294AdA3C4A5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x935c15D0B4e464474F2011Ff3A8aF5283A82929a)
 */
export const readWbtcVariableDebtTokenTaikoGetIncentivesController =
  /*#__PURE__*/ createReadContract({
    abi: wbtcVariableDebtTokenTaikoAbi,
    address: wbtcVariableDebtTokenTaikoAddress,
    functionName: 'getIncentivesController',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wbtcVariableDebtTokenTaikoAbi}__ and `functionName` set to `"getPreviousIndex"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x30B5199E490876eA6E8B2BAC4d5f3294AdA3C4A5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x935c15D0B4e464474F2011Ff3A8aF5283A82929a)
 */
export const readWbtcVariableDebtTokenTaikoGetPreviousIndex =
  /*#__PURE__*/ createReadContract({
    abi: wbtcVariableDebtTokenTaikoAbi,
    address: wbtcVariableDebtTokenTaikoAddress,
    functionName: 'getPreviousIndex',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wbtcVariableDebtTokenTaikoAbi}__ and `functionName` set to `"getScaledUserBalanceAndSupply"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x30B5199E490876eA6E8B2BAC4d5f3294AdA3C4A5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x935c15D0B4e464474F2011Ff3A8aF5283A82929a)
 */
export const readWbtcVariableDebtTokenTaikoGetScaledUserBalanceAndSupply =
  /*#__PURE__*/ createReadContract({
    abi: wbtcVariableDebtTokenTaikoAbi,
    address: wbtcVariableDebtTokenTaikoAddress,
    functionName: 'getScaledUserBalanceAndSupply',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wbtcVariableDebtTokenTaikoAbi}__ and `functionName` set to `"name"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x30B5199E490876eA6E8B2BAC4d5f3294AdA3C4A5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x935c15D0B4e464474F2011Ff3A8aF5283A82929a)
 */
export const readWbtcVariableDebtTokenTaikoName =
  /*#__PURE__*/ createReadContract({
    abi: wbtcVariableDebtTokenTaikoAbi,
    address: wbtcVariableDebtTokenTaikoAddress,
    functionName: 'name',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wbtcVariableDebtTokenTaikoAbi}__ and `functionName` set to `"nonces"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x30B5199E490876eA6E8B2BAC4d5f3294AdA3C4A5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x935c15D0B4e464474F2011Ff3A8aF5283A82929a)
 */
export const readWbtcVariableDebtTokenTaikoNonces =
  /*#__PURE__*/ createReadContract({
    abi: wbtcVariableDebtTokenTaikoAbi,
    address: wbtcVariableDebtTokenTaikoAddress,
    functionName: 'nonces',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wbtcVariableDebtTokenTaikoAbi}__ and `functionName` set to `"scaledBalanceOf"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x30B5199E490876eA6E8B2BAC4d5f3294AdA3C4A5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x935c15D0B4e464474F2011Ff3A8aF5283A82929a)
 */
export const readWbtcVariableDebtTokenTaikoScaledBalanceOf =
  /*#__PURE__*/ createReadContract({
    abi: wbtcVariableDebtTokenTaikoAbi,
    address: wbtcVariableDebtTokenTaikoAddress,
    functionName: 'scaledBalanceOf',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wbtcVariableDebtTokenTaikoAbi}__ and `functionName` set to `"scaledTotalSupply"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x30B5199E490876eA6E8B2BAC4d5f3294AdA3C4A5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x935c15D0B4e464474F2011Ff3A8aF5283A82929a)
 */
export const readWbtcVariableDebtTokenTaikoScaledTotalSupply =
  /*#__PURE__*/ createReadContract({
    abi: wbtcVariableDebtTokenTaikoAbi,
    address: wbtcVariableDebtTokenTaikoAddress,
    functionName: 'scaledTotalSupply',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wbtcVariableDebtTokenTaikoAbi}__ and `functionName` set to `"symbol"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x30B5199E490876eA6E8B2BAC4d5f3294AdA3C4A5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x935c15D0B4e464474F2011Ff3A8aF5283A82929a)
 */
export const readWbtcVariableDebtTokenTaikoSymbol =
  /*#__PURE__*/ createReadContract({
    abi: wbtcVariableDebtTokenTaikoAbi,
    address: wbtcVariableDebtTokenTaikoAddress,
    functionName: 'symbol',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wbtcVariableDebtTokenTaikoAbi}__ and `functionName` set to `"totalSupply"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x30B5199E490876eA6E8B2BAC4d5f3294AdA3C4A5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x935c15D0B4e464474F2011Ff3A8aF5283A82929a)
 */
export const readWbtcVariableDebtTokenTaikoTotalSupply =
  /*#__PURE__*/ createReadContract({
    abi: wbtcVariableDebtTokenTaikoAbi,
    address: wbtcVariableDebtTokenTaikoAddress,
    functionName: 'totalSupply',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wbtcVariableDebtTokenTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x30B5199E490876eA6E8B2BAC4d5f3294AdA3C4A5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x935c15D0B4e464474F2011Ff3A8aF5283A82929a)
 */
export const writeWbtcVariableDebtTokenTaiko =
  /*#__PURE__*/ createWriteContract({
    abi: wbtcVariableDebtTokenTaikoAbi,
    address: wbtcVariableDebtTokenTaikoAddress,
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wbtcVariableDebtTokenTaikoAbi}__ and `functionName` set to `"approve"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x30B5199E490876eA6E8B2BAC4d5f3294AdA3C4A5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x935c15D0B4e464474F2011Ff3A8aF5283A82929a)
 */
export const writeWbtcVariableDebtTokenTaikoApprove =
  /*#__PURE__*/ createWriteContract({
    abi: wbtcVariableDebtTokenTaikoAbi,
    address: wbtcVariableDebtTokenTaikoAddress,
    functionName: 'approve',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wbtcVariableDebtTokenTaikoAbi}__ and `functionName` set to `"approveDelegation"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x30B5199E490876eA6E8B2BAC4d5f3294AdA3C4A5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x935c15D0B4e464474F2011Ff3A8aF5283A82929a)
 */
export const writeWbtcVariableDebtTokenTaikoApproveDelegation =
  /*#__PURE__*/ createWriteContract({
    abi: wbtcVariableDebtTokenTaikoAbi,
    address: wbtcVariableDebtTokenTaikoAddress,
    functionName: 'approveDelegation',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wbtcVariableDebtTokenTaikoAbi}__ and `functionName` set to `"burn"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x30B5199E490876eA6E8B2BAC4d5f3294AdA3C4A5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x935c15D0B4e464474F2011Ff3A8aF5283A82929a)
 */
export const writeWbtcVariableDebtTokenTaikoBurn =
  /*#__PURE__*/ createWriteContract({
    abi: wbtcVariableDebtTokenTaikoAbi,
    address: wbtcVariableDebtTokenTaikoAddress,
    functionName: 'burn',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wbtcVariableDebtTokenTaikoAbi}__ and `functionName` set to `"decreaseAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x30B5199E490876eA6E8B2BAC4d5f3294AdA3C4A5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x935c15D0B4e464474F2011Ff3A8aF5283A82929a)
 */
export const writeWbtcVariableDebtTokenTaikoDecreaseAllowance =
  /*#__PURE__*/ createWriteContract({
    abi: wbtcVariableDebtTokenTaikoAbi,
    address: wbtcVariableDebtTokenTaikoAddress,
    functionName: 'decreaseAllowance',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wbtcVariableDebtTokenTaikoAbi}__ and `functionName` set to `"delegationWithSig"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x30B5199E490876eA6E8B2BAC4d5f3294AdA3C4A5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x935c15D0B4e464474F2011Ff3A8aF5283A82929a)
 */
export const writeWbtcVariableDebtTokenTaikoDelegationWithSig =
  /*#__PURE__*/ createWriteContract({
    abi: wbtcVariableDebtTokenTaikoAbi,
    address: wbtcVariableDebtTokenTaikoAddress,
    functionName: 'delegationWithSig',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wbtcVariableDebtTokenTaikoAbi}__ and `functionName` set to `"increaseAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x30B5199E490876eA6E8B2BAC4d5f3294AdA3C4A5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x935c15D0B4e464474F2011Ff3A8aF5283A82929a)
 */
export const writeWbtcVariableDebtTokenTaikoIncreaseAllowance =
  /*#__PURE__*/ createWriteContract({
    abi: wbtcVariableDebtTokenTaikoAbi,
    address: wbtcVariableDebtTokenTaikoAddress,
    functionName: 'increaseAllowance',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wbtcVariableDebtTokenTaikoAbi}__ and `functionName` set to `"initialize"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x30B5199E490876eA6E8B2BAC4d5f3294AdA3C4A5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x935c15D0B4e464474F2011Ff3A8aF5283A82929a)
 */
export const writeWbtcVariableDebtTokenTaikoInitialize =
  /*#__PURE__*/ createWriteContract({
    abi: wbtcVariableDebtTokenTaikoAbi,
    address: wbtcVariableDebtTokenTaikoAddress,
    functionName: 'initialize',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wbtcVariableDebtTokenTaikoAbi}__ and `functionName` set to `"mint"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x30B5199E490876eA6E8B2BAC4d5f3294AdA3C4A5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x935c15D0B4e464474F2011Ff3A8aF5283A82929a)
 */
export const writeWbtcVariableDebtTokenTaikoMint =
  /*#__PURE__*/ createWriteContract({
    abi: wbtcVariableDebtTokenTaikoAbi,
    address: wbtcVariableDebtTokenTaikoAddress,
    functionName: 'mint',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wbtcVariableDebtTokenTaikoAbi}__ and `functionName` set to `"setIncentivesController"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x30B5199E490876eA6E8B2BAC4d5f3294AdA3C4A5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x935c15D0B4e464474F2011Ff3A8aF5283A82929a)
 */
export const writeWbtcVariableDebtTokenTaikoSetIncentivesController =
  /*#__PURE__*/ createWriteContract({
    abi: wbtcVariableDebtTokenTaikoAbi,
    address: wbtcVariableDebtTokenTaikoAddress,
    functionName: 'setIncentivesController',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wbtcVariableDebtTokenTaikoAbi}__ and `functionName` set to `"transfer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x30B5199E490876eA6E8B2BAC4d5f3294AdA3C4A5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x935c15D0B4e464474F2011Ff3A8aF5283A82929a)
 */
export const writeWbtcVariableDebtTokenTaikoTransfer =
  /*#__PURE__*/ createWriteContract({
    abi: wbtcVariableDebtTokenTaikoAbi,
    address: wbtcVariableDebtTokenTaikoAddress,
    functionName: 'transfer',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wbtcVariableDebtTokenTaikoAbi}__ and `functionName` set to `"transferFrom"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x30B5199E490876eA6E8B2BAC4d5f3294AdA3C4A5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x935c15D0B4e464474F2011Ff3A8aF5283A82929a)
 */
export const writeWbtcVariableDebtTokenTaikoTransferFrom =
  /*#__PURE__*/ createWriteContract({
    abi: wbtcVariableDebtTokenTaikoAbi,
    address: wbtcVariableDebtTokenTaikoAddress,
    functionName: 'transferFrom',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wbtcVariableDebtTokenTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x30B5199E490876eA6E8B2BAC4d5f3294AdA3C4A5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x935c15D0B4e464474F2011Ff3A8aF5283A82929a)
 */
export const simulateWbtcVariableDebtTokenTaiko =
  /*#__PURE__*/ createSimulateContract({
    abi: wbtcVariableDebtTokenTaikoAbi,
    address: wbtcVariableDebtTokenTaikoAddress,
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wbtcVariableDebtTokenTaikoAbi}__ and `functionName` set to `"approve"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x30B5199E490876eA6E8B2BAC4d5f3294AdA3C4A5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x935c15D0B4e464474F2011Ff3A8aF5283A82929a)
 */
export const simulateWbtcVariableDebtTokenTaikoApprove =
  /*#__PURE__*/ createSimulateContract({
    abi: wbtcVariableDebtTokenTaikoAbi,
    address: wbtcVariableDebtTokenTaikoAddress,
    functionName: 'approve',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wbtcVariableDebtTokenTaikoAbi}__ and `functionName` set to `"approveDelegation"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x30B5199E490876eA6E8B2BAC4d5f3294AdA3C4A5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x935c15D0B4e464474F2011Ff3A8aF5283A82929a)
 */
export const simulateWbtcVariableDebtTokenTaikoApproveDelegation =
  /*#__PURE__*/ createSimulateContract({
    abi: wbtcVariableDebtTokenTaikoAbi,
    address: wbtcVariableDebtTokenTaikoAddress,
    functionName: 'approveDelegation',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wbtcVariableDebtTokenTaikoAbi}__ and `functionName` set to `"burn"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x30B5199E490876eA6E8B2BAC4d5f3294AdA3C4A5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x935c15D0B4e464474F2011Ff3A8aF5283A82929a)
 */
export const simulateWbtcVariableDebtTokenTaikoBurn =
  /*#__PURE__*/ createSimulateContract({
    abi: wbtcVariableDebtTokenTaikoAbi,
    address: wbtcVariableDebtTokenTaikoAddress,
    functionName: 'burn',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wbtcVariableDebtTokenTaikoAbi}__ and `functionName` set to `"decreaseAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x30B5199E490876eA6E8B2BAC4d5f3294AdA3C4A5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x935c15D0B4e464474F2011Ff3A8aF5283A82929a)
 */
export const simulateWbtcVariableDebtTokenTaikoDecreaseAllowance =
  /*#__PURE__*/ createSimulateContract({
    abi: wbtcVariableDebtTokenTaikoAbi,
    address: wbtcVariableDebtTokenTaikoAddress,
    functionName: 'decreaseAllowance',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wbtcVariableDebtTokenTaikoAbi}__ and `functionName` set to `"delegationWithSig"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x30B5199E490876eA6E8B2BAC4d5f3294AdA3C4A5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x935c15D0B4e464474F2011Ff3A8aF5283A82929a)
 */
export const simulateWbtcVariableDebtTokenTaikoDelegationWithSig =
  /*#__PURE__*/ createSimulateContract({
    abi: wbtcVariableDebtTokenTaikoAbi,
    address: wbtcVariableDebtTokenTaikoAddress,
    functionName: 'delegationWithSig',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wbtcVariableDebtTokenTaikoAbi}__ and `functionName` set to `"increaseAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x30B5199E490876eA6E8B2BAC4d5f3294AdA3C4A5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x935c15D0B4e464474F2011Ff3A8aF5283A82929a)
 */
export const simulateWbtcVariableDebtTokenTaikoIncreaseAllowance =
  /*#__PURE__*/ createSimulateContract({
    abi: wbtcVariableDebtTokenTaikoAbi,
    address: wbtcVariableDebtTokenTaikoAddress,
    functionName: 'increaseAllowance',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wbtcVariableDebtTokenTaikoAbi}__ and `functionName` set to `"initialize"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x30B5199E490876eA6E8B2BAC4d5f3294AdA3C4A5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x935c15D0B4e464474F2011Ff3A8aF5283A82929a)
 */
export const simulateWbtcVariableDebtTokenTaikoInitialize =
  /*#__PURE__*/ createSimulateContract({
    abi: wbtcVariableDebtTokenTaikoAbi,
    address: wbtcVariableDebtTokenTaikoAddress,
    functionName: 'initialize',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wbtcVariableDebtTokenTaikoAbi}__ and `functionName` set to `"mint"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x30B5199E490876eA6E8B2BAC4d5f3294AdA3C4A5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x935c15D0B4e464474F2011Ff3A8aF5283A82929a)
 */
export const simulateWbtcVariableDebtTokenTaikoMint =
  /*#__PURE__*/ createSimulateContract({
    abi: wbtcVariableDebtTokenTaikoAbi,
    address: wbtcVariableDebtTokenTaikoAddress,
    functionName: 'mint',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wbtcVariableDebtTokenTaikoAbi}__ and `functionName` set to `"setIncentivesController"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x30B5199E490876eA6E8B2BAC4d5f3294AdA3C4A5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x935c15D0B4e464474F2011Ff3A8aF5283A82929a)
 */
export const simulateWbtcVariableDebtTokenTaikoSetIncentivesController =
  /*#__PURE__*/ createSimulateContract({
    abi: wbtcVariableDebtTokenTaikoAbi,
    address: wbtcVariableDebtTokenTaikoAddress,
    functionName: 'setIncentivesController',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wbtcVariableDebtTokenTaikoAbi}__ and `functionName` set to `"transfer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x30B5199E490876eA6E8B2BAC4d5f3294AdA3C4A5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x935c15D0B4e464474F2011Ff3A8aF5283A82929a)
 */
export const simulateWbtcVariableDebtTokenTaikoTransfer =
  /*#__PURE__*/ createSimulateContract({
    abi: wbtcVariableDebtTokenTaikoAbi,
    address: wbtcVariableDebtTokenTaikoAddress,
    functionName: 'transfer',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wbtcVariableDebtTokenTaikoAbi}__ and `functionName` set to `"transferFrom"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x30B5199E490876eA6E8B2BAC4d5f3294AdA3C4A5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x935c15D0B4e464474F2011Ff3A8aF5283A82929a)
 */
export const simulateWbtcVariableDebtTokenTaikoTransferFrom =
  /*#__PURE__*/ createSimulateContract({
    abi: wbtcVariableDebtTokenTaikoAbi,
    address: wbtcVariableDebtTokenTaikoAddress,
    functionName: 'transferFrom',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link wbtcVariableDebtTokenTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x30B5199E490876eA6E8B2BAC4d5f3294AdA3C4A5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x935c15D0B4e464474F2011Ff3A8aF5283A82929a)
 */
export const watchWbtcVariableDebtTokenTaikoEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: wbtcVariableDebtTokenTaikoAbi,
    address: wbtcVariableDebtTokenTaikoAddress,
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link wbtcVariableDebtTokenTaikoAbi}__ and `eventName` set to `"Approval"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x30B5199E490876eA6E8B2BAC4d5f3294AdA3C4A5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x935c15D0B4e464474F2011Ff3A8aF5283A82929a)
 */
export const watchWbtcVariableDebtTokenTaikoApprovalEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: wbtcVariableDebtTokenTaikoAbi,
    address: wbtcVariableDebtTokenTaikoAddress,
    eventName: 'Approval',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link wbtcVariableDebtTokenTaikoAbi}__ and `eventName` set to `"BorrowAllowanceDelegated"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x30B5199E490876eA6E8B2BAC4d5f3294AdA3C4A5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x935c15D0B4e464474F2011Ff3A8aF5283A82929a)
 */
export const watchWbtcVariableDebtTokenTaikoBorrowAllowanceDelegatedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: wbtcVariableDebtTokenTaikoAbi,
    address: wbtcVariableDebtTokenTaikoAddress,
    eventName: 'BorrowAllowanceDelegated',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link wbtcVariableDebtTokenTaikoAbi}__ and `eventName` set to `"Burn"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x30B5199E490876eA6E8B2BAC4d5f3294AdA3C4A5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x935c15D0B4e464474F2011Ff3A8aF5283A82929a)
 */
export const watchWbtcVariableDebtTokenTaikoBurnEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: wbtcVariableDebtTokenTaikoAbi,
    address: wbtcVariableDebtTokenTaikoAddress,
    eventName: 'Burn',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link wbtcVariableDebtTokenTaikoAbi}__ and `eventName` set to `"Initialized"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x30B5199E490876eA6E8B2BAC4d5f3294AdA3C4A5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x935c15D0B4e464474F2011Ff3A8aF5283A82929a)
 */
export const watchWbtcVariableDebtTokenTaikoInitializedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: wbtcVariableDebtTokenTaikoAbi,
    address: wbtcVariableDebtTokenTaikoAddress,
    eventName: 'Initialized',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link wbtcVariableDebtTokenTaikoAbi}__ and `eventName` set to `"Mint"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x30B5199E490876eA6E8B2BAC4d5f3294AdA3C4A5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x935c15D0B4e464474F2011Ff3A8aF5283A82929a)
 */
export const watchWbtcVariableDebtTokenTaikoMintEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: wbtcVariableDebtTokenTaikoAbi,
    address: wbtcVariableDebtTokenTaikoAddress,
    eventName: 'Mint',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link wbtcVariableDebtTokenTaikoAbi}__ and `eventName` set to `"Transfer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x30B5199E490876eA6E8B2BAC4d5f3294AdA3C4A5)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x935c15D0B4e464474F2011Ff3A8aF5283A82929a)
 */
export const watchWbtcVariableDebtTokenTaikoTransferEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: wbtcVariableDebtTokenTaikoAbi,
    address: wbtcVariableDebtTokenTaikoAddress,
    eventName: 'Transfer',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wethATokenTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x0fB34fAd66429AEB99b3342De150F301BB4f45Ce)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xbE810D925931A6c6899aD8361668409CEDDC2A12)
 */
export const readWethATokenTaiko = /*#__PURE__*/ createReadContract({
  abi: wethATokenTaikoAbi,
  address: wethATokenTaikoAddress,
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wethATokenTaikoAbi}__ and `functionName` set to `"ATOKEN_REVISION"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x0fB34fAd66429AEB99b3342De150F301BB4f45Ce)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xbE810D925931A6c6899aD8361668409CEDDC2A12)
 */
export const readWethATokenTaikoAtokenRevision =
  /*#__PURE__*/ createReadContract({
    abi: wethATokenTaikoAbi,
    address: wethATokenTaikoAddress,
    functionName: 'ATOKEN_REVISION',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wethATokenTaikoAbi}__ and `functionName` set to `"DOMAIN_SEPARATOR"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x0fB34fAd66429AEB99b3342De150F301BB4f45Ce)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xbE810D925931A6c6899aD8361668409CEDDC2A12)
 */
export const readWethATokenTaikoDomainSeparator =
  /*#__PURE__*/ createReadContract({
    abi: wethATokenTaikoAbi,
    address: wethATokenTaikoAddress,
    functionName: 'DOMAIN_SEPARATOR',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wethATokenTaikoAbi}__ and `functionName` set to `"EIP712_REVISION"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x0fB34fAd66429AEB99b3342De150F301BB4f45Ce)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xbE810D925931A6c6899aD8361668409CEDDC2A12)
 */
export const readWethATokenTaikoEip712Revision =
  /*#__PURE__*/ createReadContract({
    abi: wethATokenTaikoAbi,
    address: wethATokenTaikoAddress,
    functionName: 'EIP712_REVISION',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wethATokenTaikoAbi}__ and `functionName` set to `"PERMIT_TYPEHASH"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x0fB34fAd66429AEB99b3342De150F301BB4f45Ce)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xbE810D925931A6c6899aD8361668409CEDDC2A12)
 */
export const readWethATokenTaikoPermitTypehash =
  /*#__PURE__*/ createReadContract({
    abi: wethATokenTaikoAbi,
    address: wethATokenTaikoAddress,
    functionName: 'PERMIT_TYPEHASH',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wethATokenTaikoAbi}__ and `functionName` set to `"POOL"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x0fB34fAd66429AEB99b3342De150F301BB4f45Ce)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xbE810D925931A6c6899aD8361668409CEDDC2A12)
 */
export const readWethATokenTaikoPool = /*#__PURE__*/ createReadContract({
  abi: wethATokenTaikoAbi,
  address: wethATokenTaikoAddress,
  functionName: 'POOL',
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wethATokenTaikoAbi}__ and `functionName` set to `"RESERVE_TREASURY_ADDRESS"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x0fB34fAd66429AEB99b3342De150F301BB4f45Ce)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xbE810D925931A6c6899aD8361668409CEDDC2A12)
 */
export const readWethATokenTaikoReserveTreasuryAddress =
  /*#__PURE__*/ createReadContract({
    abi: wethATokenTaikoAbi,
    address: wethATokenTaikoAddress,
    functionName: 'RESERVE_TREASURY_ADDRESS',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wethATokenTaikoAbi}__ and `functionName` set to `"UNDERLYING_ASSET_ADDRESS"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x0fB34fAd66429AEB99b3342De150F301BB4f45Ce)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xbE810D925931A6c6899aD8361668409CEDDC2A12)
 */
export const readWethATokenTaikoUnderlyingAssetAddress =
  /*#__PURE__*/ createReadContract({
    abi: wethATokenTaikoAbi,
    address: wethATokenTaikoAddress,
    functionName: 'UNDERLYING_ASSET_ADDRESS',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wethATokenTaikoAbi}__ and `functionName` set to `"allowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x0fB34fAd66429AEB99b3342De150F301BB4f45Ce)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xbE810D925931A6c6899aD8361668409CEDDC2A12)
 */
export const readWethATokenTaikoAllowance = /*#__PURE__*/ createReadContract({
  abi: wethATokenTaikoAbi,
  address: wethATokenTaikoAddress,
  functionName: 'allowance',
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wethATokenTaikoAbi}__ and `functionName` set to `"balanceOf"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x0fB34fAd66429AEB99b3342De150F301BB4f45Ce)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xbE810D925931A6c6899aD8361668409CEDDC2A12)
 */
export const readWethATokenTaikoBalanceOf = /*#__PURE__*/ createReadContract({
  abi: wethATokenTaikoAbi,
  address: wethATokenTaikoAddress,
  functionName: 'balanceOf',
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wethATokenTaikoAbi}__ and `functionName` set to `"decimals"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x0fB34fAd66429AEB99b3342De150F301BB4f45Ce)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xbE810D925931A6c6899aD8361668409CEDDC2A12)
 */
export const readWethATokenTaikoDecimals = /*#__PURE__*/ createReadContract({
  abi: wethATokenTaikoAbi,
  address: wethATokenTaikoAddress,
  functionName: 'decimals',
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wethATokenTaikoAbi}__ and `functionName` set to `"getIncentivesController"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x0fB34fAd66429AEB99b3342De150F301BB4f45Ce)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xbE810D925931A6c6899aD8361668409CEDDC2A12)
 */
export const readWethATokenTaikoGetIncentivesController =
  /*#__PURE__*/ createReadContract({
    abi: wethATokenTaikoAbi,
    address: wethATokenTaikoAddress,
    functionName: 'getIncentivesController',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wethATokenTaikoAbi}__ and `functionName` set to `"getPreviousIndex"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x0fB34fAd66429AEB99b3342De150F301BB4f45Ce)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xbE810D925931A6c6899aD8361668409CEDDC2A12)
 */
export const readWethATokenTaikoGetPreviousIndex =
  /*#__PURE__*/ createReadContract({
    abi: wethATokenTaikoAbi,
    address: wethATokenTaikoAddress,
    functionName: 'getPreviousIndex',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wethATokenTaikoAbi}__ and `functionName` set to `"getScaledUserBalanceAndSupply"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x0fB34fAd66429AEB99b3342De150F301BB4f45Ce)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xbE810D925931A6c6899aD8361668409CEDDC2A12)
 */
export const readWethATokenTaikoGetScaledUserBalanceAndSupply =
  /*#__PURE__*/ createReadContract({
    abi: wethATokenTaikoAbi,
    address: wethATokenTaikoAddress,
    functionName: 'getScaledUserBalanceAndSupply',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wethATokenTaikoAbi}__ and `functionName` set to `"name"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x0fB34fAd66429AEB99b3342De150F301BB4f45Ce)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xbE810D925931A6c6899aD8361668409CEDDC2A12)
 */
export const readWethATokenTaikoName = /*#__PURE__*/ createReadContract({
  abi: wethATokenTaikoAbi,
  address: wethATokenTaikoAddress,
  functionName: 'name',
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wethATokenTaikoAbi}__ and `functionName` set to `"nonces"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x0fB34fAd66429AEB99b3342De150F301BB4f45Ce)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xbE810D925931A6c6899aD8361668409CEDDC2A12)
 */
export const readWethATokenTaikoNonces = /*#__PURE__*/ createReadContract({
  abi: wethATokenTaikoAbi,
  address: wethATokenTaikoAddress,
  functionName: 'nonces',
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wethATokenTaikoAbi}__ and `functionName` set to `"scaledBalanceOf"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x0fB34fAd66429AEB99b3342De150F301BB4f45Ce)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xbE810D925931A6c6899aD8361668409CEDDC2A12)
 */
export const readWethATokenTaikoScaledBalanceOf =
  /*#__PURE__*/ createReadContract({
    abi: wethATokenTaikoAbi,
    address: wethATokenTaikoAddress,
    functionName: 'scaledBalanceOf',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wethATokenTaikoAbi}__ and `functionName` set to `"scaledTotalSupply"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x0fB34fAd66429AEB99b3342De150F301BB4f45Ce)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xbE810D925931A6c6899aD8361668409CEDDC2A12)
 */
export const readWethATokenTaikoScaledTotalSupply =
  /*#__PURE__*/ createReadContract({
    abi: wethATokenTaikoAbi,
    address: wethATokenTaikoAddress,
    functionName: 'scaledTotalSupply',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wethATokenTaikoAbi}__ and `functionName` set to `"symbol"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x0fB34fAd66429AEB99b3342De150F301BB4f45Ce)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xbE810D925931A6c6899aD8361668409CEDDC2A12)
 */
export const readWethATokenTaikoSymbol = /*#__PURE__*/ createReadContract({
  abi: wethATokenTaikoAbi,
  address: wethATokenTaikoAddress,
  functionName: 'symbol',
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wethATokenTaikoAbi}__ and `functionName` set to `"totalSupply"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x0fB34fAd66429AEB99b3342De150F301BB4f45Ce)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xbE810D925931A6c6899aD8361668409CEDDC2A12)
 */
export const readWethATokenTaikoTotalSupply = /*#__PURE__*/ createReadContract({
  abi: wethATokenTaikoAbi,
  address: wethATokenTaikoAddress,
  functionName: 'totalSupply',
})

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wethATokenTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x0fB34fAd66429AEB99b3342De150F301BB4f45Ce)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xbE810D925931A6c6899aD8361668409CEDDC2A12)
 */
export const writeWethATokenTaiko = /*#__PURE__*/ createWriteContract({
  abi: wethATokenTaikoAbi,
  address: wethATokenTaikoAddress,
})

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wethATokenTaikoAbi}__ and `functionName` set to `"approve"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x0fB34fAd66429AEB99b3342De150F301BB4f45Ce)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xbE810D925931A6c6899aD8361668409CEDDC2A12)
 */
export const writeWethATokenTaikoApprove = /*#__PURE__*/ createWriteContract({
  abi: wethATokenTaikoAbi,
  address: wethATokenTaikoAddress,
  functionName: 'approve',
})

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wethATokenTaikoAbi}__ and `functionName` set to `"burn"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x0fB34fAd66429AEB99b3342De150F301BB4f45Ce)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xbE810D925931A6c6899aD8361668409CEDDC2A12)
 */
export const writeWethATokenTaikoBurn = /*#__PURE__*/ createWriteContract({
  abi: wethATokenTaikoAbi,
  address: wethATokenTaikoAddress,
  functionName: 'burn',
})

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wethATokenTaikoAbi}__ and `functionName` set to `"decreaseAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x0fB34fAd66429AEB99b3342De150F301BB4f45Ce)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xbE810D925931A6c6899aD8361668409CEDDC2A12)
 */
export const writeWethATokenTaikoDecreaseAllowance =
  /*#__PURE__*/ createWriteContract({
    abi: wethATokenTaikoAbi,
    address: wethATokenTaikoAddress,
    functionName: 'decreaseAllowance',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wethATokenTaikoAbi}__ and `functionName` set to `"handleRepayment"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x0fB34fAd66429AEB99b3342De150F301BB4f45Ce)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xbE810D925931A6c6899aD8361668409CEDDC2A12)
 */
export const writeWethATokenTaikoHandleRepayment =
  /*#__PURE__*/ createWriteContract({
    abi: wethATokenTaikoAbi,
    address: wethATokenTaikoAddress,
    functionName: 'handleRepayment',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wethATokenTaikoAbi}__ and `functionName` set to `"increaseAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x0fB34fAd66429AEB99b3342De150F301BB4f45Ce)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xbE810D925931A6c6899aD8361668409CEDDC2A12)
 */
export const writeWethATokenTaikoIncreaseAllowance =
  /*#__PURE__*/ createWriteContract({
    abi: wethATokenTaikoAbi,
    address: wethATokenTaikoAddress,
    functionName: 'increaseAllowance',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wethATokenTaikoAbi}__ and `functionName` set to `"initialize"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x0fB34fAd66429AEB99b3342De150F301BB4f45Ce)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xbE810D925931A6c6899aD8361668409CEDDC2A12)
 */
export const writeWethATokenTaikoInitialize = /*#__PURE__*/ createWriteContract(
  {
    abi: wethATokenTaikoAbi,
    address: wethATokenTaikoAddress,
    functionName: 'initialize',
  },
)

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wethATokenTaikoAbi}__ and `functionName` set to `"mint"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x0fB34fAd66429AEB99b3342De150F301BB4f45Ce)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xbE810D925931A6c6899aD8361668409CEDDC2A12)
 */
export const writeWethATokenTaikoMint = /*#__PURE__*/ createWriteContract({
  abi: wethATokenTaikoAbi,
  address: wethATokenTaikoAddress,
  functionName: 'mint',
})

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wethATokenTaikoAbi}__ and `functionName` set to `"mintToTreasury"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x0fB34fAd66429AEB99b3342De150F301BB4f45Ce)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xbE810D925931A6c6899aD8361668409CEDDC2A12)
 */
export const writeWethATokenTaikoMintToTreasury =
  /*#__PURE__*/ createWriteContract({
    abi: wethATokenTaikoAbi,
    address: wethATokenTaikoAddress,
    functionName: 'mintToTreasury',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wethATokenTaikoAbi}__ and `functionName` set to `"permit"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x0fB34fAd66429AEB99b3342De150F301BB4f45Ce)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xbE810D925931A6c6899aD8361668409CEDDC2A12)
 */
export const writeWethATokenTaikoPermit = /*#__PURE__*/ createWriteContract({
  abi: wethATokenTaikoAbi,
  address: wethATokenTaikoAddress,
  functionName: 'permit',
})

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wethATokenTaikoAbi}__ and `functionName` set to `"rescueTokens"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x0fB34fAd66429AEB99b3342De150F301BB4f45Ce)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xbE810D925931A6c6899aD8361668409CEDDC2A12)
 */
export const writeWethATokenTaikoRescueTokens =
  /*#__PURE__*/ createWriteContract({
    abi: wethATokenTaikoAbi,
    address: wethATokenTaikoAddress,
    functionName: 'rescueTokens',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wethATokenTaikoAbi}__ and `functionName` set to `"setIncentivesController"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x0fB34fAd66429AEB99b3342De150F301BB4f45Ce)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xbE810D925931A6c6899aD8361668409CEDDC2A12)
 */
export const writeWethATokenTaikoSetIncentivesController =
  /*#__PURE__*/ createWriteContract({
    abi: wethATokenTaikoAbi,
    address: wethATokenTaikoAddress,
    functionName: 'setIncentivesController',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wethATokenTaikoAbi}__ and `functionName` set to `"transfer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x0fB34fAd66429AEB99b3342De150F301BB4f45Ce)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xbE810D925931A6c6899aD8361668409CEDDC2A12)
 */
export const writeWethATokenTaikoTransfer = /*#__PURE__*/ createWriteContract({
  abi: wethATokenTaikoAbi,
  address: wethATokenTaikoAddress,
  functionName: 'transfer',
})

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wethATokenTaikoAbi}__ and `functionName` set to `"transferFrom"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x0fB34fAd66429AEB99b3342De150F301BB4f45Ce)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xbE810D925931A6c6899aD8361668409CEDDC2A12)
 */
export const writeWethATokenTaikoTransferFrom =
  /*#__PURE__*/ createWriteContract({
    abi: wethATokenTaikoAbi,
    address: wethATokenTaikoAddress,
    functionName: 'transferFrom',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wethATokenTaikoAbi}__ and `functionName` set to `"transferOnLiquidation"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x0fB34fAd66429AEB99b3342De150F301BB4f45Ce)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xbE810D925931A6c6899aD8361668409CEDDC2A12)
 */
export const writeWethATokenTaikoTransferOnLiquidation =
  /*#__PURE__*/ createWriteContract({
    abi: wethATokenTaikoAbi,
    address: wethATokenTaikoAddress,
    functionName: 'transferOnLiquidation',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wethATokenTaikoAbi}__ and `functionName` set to `"transferUnderlyingTo"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x0fB34fAd66429AEB99b3342De150F301BB4f45Ce)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xbE810D925931A6c6899aD8361668409CEDDC2A12)
 */
export const writeWethATokenTaikoTransferUnderlyingTo =
  /*#__PURE__*/ createWriteContract({
    abi: wethATokenTaikoAbi,
    address: wethATokenTaikoAddress,
    functionName: 'transferUnderlyingTo',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wethATokenTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x0fB34fAd66429AEB99b3342De150F301BB4f45Ce)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xbE810D925931A6c6899aD8361668409CEDDC2A12)
 */
export const simulateWethATokenTaiko = /*#__PURE__*/ createSimulateContract({
  abi: wethATokenTaikoAbi,
  address: wethATokenTaikoAddress,
})

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wethATokenTaikoAbi}__ and `functionName` set to `"approve"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x0fB34fAd66429AEB99b3342De150F301BB4f45Ce)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xbE810D925931A6c6899aD8361668409CEDDC2A12)
 */
export const simulateWethATokenTaikoApprove =
  /*#__PURE__*/ createSimulateContract({
    abi: wethATokenTaikoAbi,
    address: wethATokenTaikoAddress,
    functionName: 'approve',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wethATokenTaikoAbi}__ and `functionName` set to `"burn"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x0fB34fAd66429AEB99b3342De150F301BB4f45Ce)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xbE810D925931A6c6899aD8361668409CEDDC2A12)
 */
export const simulateWethATokenTaikoBurn = /*#__PURE__*/ createSimulateContract(
  {
    abi: wethATokenTaikoAbi,
    address: wethATokenTaikoAddress,
    functionName: 'burn',
  },
)

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wethATokenTaikoAbi}__ and `functionName` set to `"decreaseAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x0fB34fAd66429AEB99b3342De150F301BB4f45Ce)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xbE810D925931A6c6899aD8361668409CEDDC2A12)
 */
export const simulateWethATokenTaikoDecreaseAllowance =
  /*#__PURE__*/ createSimulateContract({
    abi: wethATokenTaikoAbi,
    address: wethATokenTaikoAddress,
    functionName: 'decreaseAllowance',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wethATokenTaikoAbi}__ and `functionName` set to `"handleRepayment"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x0fB34fAd66429AEB99b3342De150F301BB4f45Ce)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xbE810D925931A6c6899aD8361668409CEDDC2A12)
 */
export const simulateWethATokenTaikoHandleRepayment =
  /*#__PURE__*/ createSimulateContract({
    abi: wethATokenTaikoAbi,
    address: wethATokenTaikoAddress,
    functionName: 'handleRepayment',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wethATokenTaikoAbi}__ and `functionName` set to `"increaseAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x0fB34fAd66429AEB99b3342De150F301BB4f45Ce)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xbE810D925931A6c6899aD8361668409CEDDC2A12)
 */
export const simulateWethATokenTaikoIncreaseAllowance =
  /*#__PURE__*/ createSimulateContract({
    abi: wethATokenTaikoAbi,
    address: wethATokenTaikoAddress,
    functionName: 'increaseAllowance',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wethATokenTaikoAbi}__ and `functionName` set to `"initialize"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x0fB34fAd66429AEB99b3342De150F301BB4f45Ce)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xbE810D925931A6c6899aD8361668409CEDDC2A12)
 */
export const simulateWethATokenTaikoInitialize =
  /*#__PURE__*/ createSimulateContract({
    abi: wethATokenTaikoAbi,
    address: wethATokenTaikoAddress,
    functionName: 'initialize',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wethATokenTaikoAbi}__ and `functionName` set to `"mint"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x0fB34fAd66429AEB99b3342De150F301BB4f45Ce)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xbE810D925931A6c6899aD8361668409CEDDC2A12)
 */
export const simulateWethATokenTaikoMint = /*#__PURE__*/ createSimulateContract(
  {
    abi: wethATokenTaikoAbi,
    address: wethATokenTaikoAddress,
    functionName: 'mint',
  },
)

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wethATokenTaikoAbi}__ and `functionName` set to `"mintToTreasury"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x0fB34fAd66429AEB99b3342De150F301BB4f45Ce)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xbE810D925931A6c6899aD8361668409CEDDC2A12)
 */
export const simulateWethATokenTaikoMintToTreasury =
  /*#__PURE__*/ createSimulateContract({
    abi: wethATokenTaikoAbi,
    address: wethATokenTaikoAddress,
    functionName: 'mintToTreasury',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wethATokenTaikoAbi}__ and `functionName` set to `"permit"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x0fB34fAd66429AEB99b3342De150F301BB4f45Ce)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xbE810D925931A6c6899aD8361668409CEDDC2A12)
 */
export const simulateWethATokenTaikoPermit =
  /*#__PURE__*/ createSimulateContract({
    abi: wethATokenTaikoAbi,
    address: wethATokenTaikoAddress,
    functionName: 'permit',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wethATokenTaikoAbi}__ and `functionName` set to `"rescueTokens"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x0fB34fAd66429AEB99b3342De150F301BB4f45Ce)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xbE810D925931A6c6899aD8361668409CEDDC2A12)
 */
export const simulateWethATokenTaikoRescueTokens =
  /*#__PURE__*/ createSimulateContract({
    abi: wethATokenTaikoAbi,
    address: wethATokenTaikoAddress,
    functionName: 'rescueTokens',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wethATokenTaikoAbi}__ and `functionName` set to `"setIncentivesController"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x0fB34fAd66429AEB99b3342De150F301BB4f45Ce)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xbE810D925931A6c6899aD8361668409CEDDC2A12)
 */
export const simulateWethATokenTaikoSetIncentivesController =
  /*#__PURE__*/ createSimulateContract({
    abi: wethATokenTaikoAbi,
    address: wethATokenTaikoAddress,
    functionName: 'setIncentivesController',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wethATokenTaikoAbi}__ and `functionName` set to `"transfer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x0fB34fAd66429AEB99b3342De150F301BB4f45Ce)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xbE810D925931A6c6899aD8361668409CEDDC2A12)
 */
export const simulateWethATokenTaikoTransfer =
  /*#__PURE__*/ createSimulateContract({
    abi: wethATokenTaikoAbi,
    address: wethATokenTaikoAddress,
    functionName: 'transfer',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wethATokenTaikoAbi}__ and `functionName` set to `"transferFrom"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x0fB34fAd66429AEB99b3342De150F301BB4f45Ce)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xbE810D925931A6c6899aD8361668409CEDDC2A12)
 */
export const simulateWethATokenTaikoTransferFrom =
  /*#__PURE__*/ createSimulateContract({
    abi: wethATokenTaikoAbi,
    address: wethATokenTaikoAddress,
    functionName: 'transferFrom',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wethATokenTaikoAbi}__ and `functionName` set to `"transferOnLiquidation"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x0fB34fAd66429AEB99b3342De150F301BB4f45Ce)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xbE810D925931A6c6899aD8361668409CEDDC2A12)
 */
export const simulateWethATokenTaikoTransferOnLiquidation =
  /*#__PURE__*/ createSimulateContract({
    abi: wethATokenTaikoAbi,
    address: wethATokenTaikoAddress,
    functionName: 'transferOnLiquidation',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wethATokenTaikoAbi}__ and `functionName` set to `"transferUnderlyingTo"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x0fB34fAd66429AEB99b3342De150F301BB4f45Ce)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xbE810D925931A6c6899aD8361668409CEDDC2A12)
 */
export const simulateWethATokenTaikoTransferUnderlyingTo =
  /*#__PURE__*/ createSimulateContract({
    abi: wethATokenTaikoAbi,
    address: wethATokenTaikoAddress,
    functionName: 'transferUnderlyingTo',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link wethATokenTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x0fB34fAd66429AEB99b3342De150F301BB4f45Ce)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xbE810D925931A6c6899aD8361668409CEDDC2A12)
 */
export const watchWethATokenTaikoEvent = /*#__PURE__*/ createWatchContractEvent(
  { abi: wethATokenTaikoAbi, address: wethATokenTaikoAddress },
)

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link wethATokenTaikoAbi}__ and `eventName` set to `"Approval"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x0fB34fAd66429AEB99b3342De150F301BB4f45Ce)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xbE810D925931A6c6899aD8361668409CEDDC2A12)
 */
export const watchWethATokenTaikoApprovalEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: wethATokenTaikoAbi,
    address: wethATokenTaikoAddress,
    eventName: 'Approval',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link wethATokenTaikoAbi}__ and `eventName` set to `"BalanceTransfer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x0fB34fAd66429AEB99b3342De150F301BB4f45Ce)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xbE810D925931A6c6899aD8361668409CEDDC2A12)
 */
export const watchWethATokenTaikoBalanceTransferEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: wethATokenTaikoAbi,
    address: wethATokenTaikoAddress,
    eventName: 'BalanceTransfer',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link wethATokenTaikoAbi}__ and `eventName` set to `"Burn"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x0fB34fAd66429AEB99b3342De150F301BB4f45Ce)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xbE810D925931A6c6899aD8361668409CEDDC2A12)
 */
export const watchWethATokenTaikoBurnEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: wethATokenTaikoAbi,
    address: wethATokenTaikoAddress,
    eventName: 'Burn',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link wethATokenTaikoAbi}__ and `eventName` set to `"Initialized"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x0fB34fAd66429AEB99b3342De150F301BB4f45Ce)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xbE810D925931A6c6899aD8361668409CEDDC2A12)
 */
export const watchWethATokenTaikoInitializedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: wethATokenTaikoAbi,
    address: wethATokenTaikoAddress,
    eventName: 'Initialized',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link wethATokenTaikoAbi}__ and `eventName` set to `"Mint"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x0fB34fAd66429AEB99b3342De150F301BB4f45Ce)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xbE810D925931A6c6899aD8361668409CEDDC2A12)
 */
export const watchWethATokenTaikoMintEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: wethATokenTaikoAbi,
    address: wethATokenTaikoAddress,
    eventName: 'Mint',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link wethATokenTaikoAbi}__ and `eventName` set to `"Transfer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x0fB34fAd66429AEB99b3342De150F301BB4f45Ce)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xbE810D925931A6c6899aD8361668409CEDDC2A12)
 */
export const watchWethATokenTaikoTransferEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: wethATokenTaikoAbi,
    address: wethATokenTaikoAddress,
    eventName: 'Transfer',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wethStableDebtTokenTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xD7E39C0d80912033490b897A866C03E7509ed3bb)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xC7B7BF79A006785cf7c037E287Be0185f0B17219)
 */
export const readWethStableDebtTokenTaiko = /*#__PURE__*/ createReadContract({
  abi: wethStableDebtTokenTaikoAbi,
  address: wethStableDebtTokenTaikoAddress,
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wethStableDebtTokenTaikoAbi}__ and `functionName` set to `"DEBT_TOKEN_REVISION"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xD7E39C0d80912033490b897A866C03E7509ed3bb)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xC7B7BF79A006785cf7c037E287Be0185f0B17219)
 */
export const readWethStableDebtTokenTaikoDebtTokenRevision =
  /*#__PURE__*/ createReadContract({
    abi: wethStableDebtTokenTaikoAbi,
    address: wethStableDebtTokenTaikoAddress,
    functionName: 'DEBT_TOKEN_REVISION',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wethStableDebtTokenTaikoAbi}__ and `functionName` set to `"DELEGATION_WITH_SIG_TYPEHASH"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xD7E39C0d80912033490b897A866C03E7509ed3bb)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xC7B7BF79A006785cf7c037E287Be0185f0B17219)
 */
export const readWethStableDebtTokenTaikoDelegationWithSigTypehash =
  /*#__PURE__*/ createReadContract({
    abi: wethStableDebtTokenTaikoAbi,
    address: wethStableDebtTokenTaikoAddress,
    functionName: 'DELEGATION_WITH_SIG_TYPEHASH',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wethStableDebtTokenTaikoAbi}__ and `functionName` set to `"DOMAIN_SEPARATOR"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xD7E39C0d80912033490b897A866C03E7509ed3bb)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xC7B7BF79A006785cf7c037E287Be0185f0B17219)
 */
export const readWethStableDebtTokenTaikoDomainSeparator =
  /*#__PURE__*/ createReadContract({
    abi: wethStableDebtTokenTaikoAbi,
    address: wethStableDebtTokenTaikoAddress,
    functionName: 'DOMAIN_SEPARATOR',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wethStableDebtTokenTaikoAbi}__ and `functionName` set to `"EIP712_REVISION"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xD7E39C0d80912033490b897A866C03E7509ed3bb)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xC7B7BF79A006785cf7c037E287Be0185f0B17219)
 */
export const readWethStableDebtTokenTaikoEip712Revision =
  /*#__PURE__*/ createReadContract({
    abi: wethStableDebtTokenTaikoAbi,
    address: wethStableDebtTokenTaikoAddress,
    functionName: 'EIP712_REVISION',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wethStableDebtTokenTaikoAbi}__ and `functionName` set to `"POOL"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xD7E39C0d80912033490b897A866C03E7509ed3bb)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xC7B7BF79A006785cf7c037E287Be0185f0B17219)
 */
export const readWethStableDebtTokenTaikoPool =
  /*#__PURE__*/ createReadContract({
    abi: wethStableDebtTokenTaikoAbi,
    address: wethStableDebtTokenTaikoAddress,
    functionName: 'POOL',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wethStableDebtTokenTaikoAbi}__ and `functionName` set to `"UNDERLYING_ASSET_ADDRESS"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xD7E39C0d80912033490b897A866C03E7509ed3bb)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xC7B7BF79A006785cf7c037E287Be0185f0B17219)
 */
export const readWethStableDebtTokenTaikoUnderlyingAssetAddress =
  /*#__PURE__*/ createReadContract({
    abi: wethStableDebtTokenTaikoAbi,
    address: wethStableDebtTokenTaikoAddress,
    functionName: 'UNDERLYING_ASSET_ADDRESS',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wethStableDebtTokenTaikoAbi}__ and `functionName` set to `"allowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xD7E39C0d80912033490b897A866C03E7509ed3bb)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xC7B7BF79A006785cf7c037E287Be0185f0B17219)
 */
export const readWethStableDebtTokenTaikoAllowance =
  /*#__PURE__*/ createReadContract({
    abi: wethStableDebtTokenTaikoAbi,
    address: wethStableDebtTokenTaikoAddress,
    functionName: 'allowance',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wethStableDebtTokenTaikoAbi}__ and `functionName` set to `"balanceOf"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xD7E39C0d80912033490b897A866C03E7509ed3bb)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xC7B7BF79A006785cf7c037E287Be0185f0B17219)
 */
export const readWethStableDebtTokenTaikoBalanceOf =
  /*#__PURE__*/ createReadContract({
    abi: wethStableDebtTokenTaikoAbi,
    address: wethStableDebtTokenTaikoAddress,
    functionName: 'balanceOf',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wethStableDebtTokenTaikoAbi}__ and `functionName` set to `"borrowAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xD7E39C0d80912033490b897A866C03E7509ed3bb)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xC7B7BF79A006785cf7c037E287Be0185f0B17219)
 */
export const readWethStableDebtTokenTaikoBorrowAllowance =
  /*#__PURE__*/ createReadContract({
    abi: wethStableDebtTokenTaikoAbi,
    address: wethStableDebtTokenTaikoAddress,
    functionName: 'borrowAllowance',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wethStableDebtTokenTaikoAbi}__ and `functionName` set to `"decimals"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xD7E39C0d80912033490b897A866C03E7509ed3bb)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xC7B7BF79A006785cf7c037E287Be0185f0B17219)
 */
export const readWethStableDebtTokenTaikoDecimals =
  /*#__PURE__*/ createReadContract({
    abi: wethStableDebtTokenTaikoAbi,
    address: wethStableDebtTokenTaikoAddress,
    functionName: 'decimals',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wethStableDebtTokenTaikoAbi}__ and `functionName` set to `"getAverageStableRate"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xD7E39C0d80912033490b897A866C03E7509ed3bb)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xC7B7BF79A006785cf7c037E287Be0185f0B17219)
 */
export const readWethStableDebtTokenTaikoGetAverageStableRate =
  /*#__PURE__*/ createReadContract({
    abi: wethStableDebtTokenTaikoAbi,
    address: wethStableDebtTokenTaikoAddress,
    functionName: 'getAverageStableRate',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wethStableDebtTokenTaikoAbi}__ and `functionName` set to `"getIncentivesController"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xD7E39C0d80912033490b897A866C03E7509ed3bb)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xC7B7BF79A006785cf7c037E287Be0185f0B17219)
 */
export const readWethStableDebtTokenTaikoGetIncentivesController =
  /*#__PURE__*/ createReadContract({
    abi: wethStableDebtTokenTaikoAbi,
    address: wethStableDebtTokenTaikoAddress,
    functionName: 'getIncentivesController',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wethStableDebtTokenTaikoAbi}__ and `functionName` set to `"getSupplyData"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xD7E39C0d80912033490b897A866C03E7509ed3bb)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xC7B7BF79A006785cf7c037E287Be0185f0B17219)
 */
export const readWethStableDebtTokenTaikoGetSupplyData =
  /*#__PURE__*/ createReadContract({
    abi: wethStableDebtTokenTaikoAbi,
    address: wethStableDebtTokenTaikoAddress,
    functionName: 'getSupplyData',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wethStableDebtTokenTaikoAbi}__ and `functionName` set to `"getTotalSupplyAndAvgRate"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xD7E39C0d80912033490b897A866C03E7509ed3bb)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xC7B7BF79A006785cf7c037E287Be0185f0B17219)
 */
export const readWethStableDebtTokenTaikoGetTotalSupplyAndAvgRate =
  /*#__PURE__*/ createReadContract({
    abi: wethStableDebtTokenTaikoAbi,
    address: wethStableDebtTokenTaikoAddress,
    functionName: 'getTotalSupplyAndAvgRate',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wethStableDebtTokenTaikoAbi}__ and `functionName` set to `"getTotalSupplyLastUpdated"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xD7E39C0d80912033490b897A866C03E7509ed3bb)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xC7B7BF79A006785cf7c037E287Be0185f0B17219)
 */
export const readWethStableDebtTokenTaikoGetTotalSupplyLastUpdated =
  /*#__PURE__*/ createReadContract({
    abi: wethStableDebtTokenTaikoAbi,
    address: wethStableDebtTokenTaikoAddress,
    functionName: 'getTotalSupplyLastUpdated',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wethStableDebtTokenTaikoAbi}__ and `functionName` set to `"getUserLastUpdated"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xD7E39C0d80912033490b897A866C03E7509ed3bb)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xC7B7BF79A006785cf7c037E287Be0185f0B17219)
 */
export const readWethStableDebtTokenTaikoGetUserLastUpdated =
  /*#__PURE__*/ createReadContract({
    abi: wethStableDebtTokenTaikoAbi,
    address: wethStableDebtTokenTaikoAddress,
    functionName: 'getUserLastUpdated',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wethStableDebtTokenTaikoAbi}__ and `functionName` set to `"getUserStableRate"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xD7E39C0d80912033490b897A866C03E7509ed3bb)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xC7B7BF79A006785cf7c037E287Be0185f0B17219)
 */
export const readWethStableDebtTokenTaikoGetUserStableRate =
  /*#__PURE__*/ createReadContract({
    abi: wethStableDebtTokenTaikoAbi,
    address: wethStableDebtTokenTaikoAddress,
    functionName: 'getUserStableRate',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wethStableDebtTokenTaikoAbi}__ and `functionName` set to `"name"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xD7E39C0d80912033490b897A866C03E7509ed3bb)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xC7B7BF79A006785cf7c037E287Be0185f0B17219)
 */
export const readWethStableDebtTokenTaikoName =
  /*#__PURE__*/ createReadContract({
    abi: wethStableDebtTokenTaikoAbi,
    address: wethStableDebtTokenTaikoAddress,
    functionName: 'name',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wethStableDebtTokenTaikoAbi}__ and `functionName` set to `"nonces"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xD7E39C0d80912033490b897A866C03E7509ed3bb)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xC7B7BF79A006785cf7c037E287Be0185f0B17219)
 */
export const readWethStableDebtTokenTaikoNonces =
  /*#__PURE__*/ createReadContract({
    abi: wethStableDebtTokenTaikoAbi,
    address: wethStableDebtTokenTaikoAddress,
    functionName: 'nonces',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wethStableDebtTokenTaikoAbi}__ and `functionName` set to `"principalBalanceOf"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xD7E39C0d80912033490b897A866C03E7509ed3bb)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xC7B7BF79A006785cf7c037E287Be0185f0B17219)
 */
export const readWethStableDebtTokenTaikoPrincipalBalanceOf =
  /*#__PURE__*/ createReadContract({
    abi: wethStableDebtTokenTaikoAbi,
    address: wethStableDebtTokenTaikoAddress,
    functionName: 'principalBalanceOf',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wethStableDebtTokenTaikoAbi}__ and `functionName` set to `"symbol"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xD7E39C0d80912033490b897A866C03E7509ed3bb)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xC7B7BF79A006785cf7c037E287Be0185f0B17219)
 */
export const readWethStableDebtTokenTaikoSymbol =
  /*#__PURE__*/ createReadContract({
    abi: wethStableDebtTokenTaikoAbi,
    address: wethStableDebtTokenTaikoAddress,
    functionName: 'symbol',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wethStableDebtTokenTaikoAbi}__ and `functionName` set to `"totalSupply"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xD7E39C0d80912033490b897A866C03E7509ed3bb)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xC7B7BF79A006785cf7c037E287Be0185f0B17219)
 */
export const readWethStableDebtTokenTaikoTotalSupply =
  /*#__PURE__*/ createReadContract({
    abi: wethStableDebtTokenTaikoAbi,
    address: wethStableDebtTokenTaikoAddress,
    functionName: 'totalSupply',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wethStableDebtTokenTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xD7E39C0d80912033490b897A866C03E7509ed3bb)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xC7B7BF79A006785cf7c037E287Be0185f0B17219)
 */
export const writeWethStableDebtTokenTaiko = /*#__PURE__*/ createWriteContract({
  abi: wethStableDebtTokenTaikoAbi,
  address: wethStableDebtTokenTaikoAddress,
})

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wethStableDebtTokenTaikoAbi}__ and `functionName` set to `"approve"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xD7E39C0d80912033490b897A866C03E7509ed3bb)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xC7B7BF79A006785cf7c037E287Be0185f0B17219)
 */
export const writeWethStableDebtTokenTaikoApprove =
  /*#__PURE__*/ createWriteContract({
    abi: wethStableDebtTokenTaikoAbi,
    address: wethStableDebtTokenTaikoAddress,
    functionName: 'approve',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wethStableDebtTokenTaikoAbi}__ and `functionName` set to `"approveDelegation"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xD7E39C0d80912033490b897A866C03E7509ed3bb)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xC7B7BF79A006785cf7c037E287Be0185f0B17219)
 */
export const writeWethStableDebtTokenTaikoApproveDelegation =
  /*#__PURE__*/ createWriteContract({
    abi: wethStableDebtTokenTaikoAbi,
    address: wethStableDebtTokenTaikoAddress,
    functionName: 'approveDelegation',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wethStableDebtTokenTaikoAbi}__ and `functionName` set to `"burn"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xD7E39C0d80912033490b897A866C03E7509ed3bb)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xC7B7BF79A006785cf7c037E287Be0185f0B17219)
 */
export const writeWethStableDebtTokenTaikoBurn =
  /*#__PURE__*/ createWriteContract({
    abi: wethStableDebtTokenTaikoAbi,
    address: wethStableDebtTokenTaikoAddress,
    functionName: 'burn',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wethStableDebtTokenTaikoAbi}__ and `functionName` set to `"decreaseAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xD7E39C0d80912033490b897A866C03E7509ed3bb)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xC7B7BF79A006785cf7c037E287Be0185f0B17219)
 */
export const writeWethStableDebtTokenTaikoDecreaseAllowance =
  /*#__PURE__*/ createWriteContract({
    abi: wethStableDebtTokenTaikoAbi,
    address: wethStableDebtTokenTaikoAddress,
    functionName: 'decreaseAllowance',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wethStableDebtTokenTaikoAbi}__ and `functionName` set to `"delegationWithSig"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xD7E39C0d80912033490b897A866C03E7509ed3bb)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xC7B7BF79A006785cf7c037E287Be0185f0B17219)
 */
export const writeWethStableDebtTokenTaikoDelegationWithSig =
  /*#__PURE__*/ createWriteContract({
    abi: wethStableDebtTokenTaikoAbi,
    address: wethStableDebtTokenTaikoAddress,
    functionName: 'delegationWithSig',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wethStableDebtTokenTaikoAbi}__ and `functionName` set to `"increaseAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xD7E39C0d80912033490b897A866C03E7509ed3bb)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xC7B7BF79A006785cf7c037E287Be0185f0B17219)
 */
export const writeWethStableDebtTokenTaikoIncreaseAllowance =
  /*#__PURE__*/ createWriteContract({
    abi: wethStableDebtTokenTaikoAbi,
    address: wethStableDebtTokenTaikoAddress,
    functionName: 'increaseAllowance',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wethStableDebtTokenTaikoAbi}__ and `functionName` set to `"initialize"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xD7E39C0d80912033490b897A866C03E7509ed3bb)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xC7B7BF79A006785cf7c037E287Be0185f0B17219)
 */
export const writeWethStableDebtTokenTaikoInitialize =
  /*#__PURE__*/ createWriteContract({
    abi: wethStableDebtTokenTaikoAbi,
    address: wethStableDebtTokenTaikoAddress,
    functionName: 'initialize',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wethStableDebtTokenTaikoAbi}__ and `functionName` set to `"mint"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xD7E39C0d80912033490b897A866C03E7509ed3bb)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xC7B7BF79A006785cf7c037E287Be0185f0B17219)
 */
export const writeWethStableDebtTokenTaikoMint =
  /*#__PURE__*/ createWriteContract({
    abi: wethStableDebtTokenTaikoAbi,
    address: wethStableDebtTokenTaikoAddress,
    functionName: 'mint',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wethStableDebtTokenTaikoAbi}__ and `functionName` set to `"setIncentivesController"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xD7E39C0d80912033490b897A866C03E7509ed3bb)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xC7B7BF79A006785cf7c037E287Be0185f0B17219)
 */
export const writeWethStableDebtTokenTaikoSetIncentivesController =
  /*#__PURE__*/ createWriteContract({
    abi: wethStableDebtTokenTaikoAbi,
    address: wethStableDebtTokenTaikoAddress,
    functionName: 'setIncentivesController',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wethStableDebtTokenTaikoAbi}__ and `functionName` set to `"transfer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xD7E39C0d80912033490b897A866C03E7509ed3bb)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xC7B7BF79A006785cf7c037E287Be0185f0B17219)
 */
export const writeWethStableDebtTokenTaikoTransfer =
  /*#__PURE__*/ createWriteContract({
    abi: wethStableDebtTokenTaikoAbi,
    address: wethStableDebtTokenTaikoAddress,
    functionName: 'transfer',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wethStableDebtTokenTaikoAbi}__ and `functionName` set to `"transferFrom"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xD7E39C0d80912033490b897A866C03E7509ed3bb)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xC7B7BF79A006785cf7c037E287Be0185f0B17219)
 */
export const writeWethStableDebtTokenTaikoTransferFrom =
  /*#__PURE__*/ createWriteContract({
    abi: wethStableDebtTokenTaikoAbi,
    address: wethStableDebtTokenTaikoAddress,
    functionName: 'transferFrom',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wethStableDebtTokenTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xD7E39C0d80912033490b897A866C03E7509ed3bb)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xC7B7BF79A006785cf7c037E287Be0185f0B17219)
 */
export const simulateWethStableDebtTokenTaiko =
  /*#__PURE__*/ createSimulateContract({
    abi: wethStableDebtTokenTaikoAbi,
    address: wethStableDebtTokenTaikoAddress,
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wethStableDebtTokenTaikoAbi}__ and `functionName` set to `"approve"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xD7E39C0d80912033490b897A866C03E7509ed3bb)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xC7B7BF79A006785cf7c037E287Be0185f0B17219)
 */
export const simulateWethStableDebtTokenTaikoApprove =
  /*#__PURE__*/ createSimulateContract({
    abi: wethStableDebtTokenTaikoAbi,
    address: wethStableDebtTokenTaikoAddress,
    functionName: 'approve',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wethStableDebtTokenTaikoAbi}__ and `functionName` set to `"approveDelegation"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xD7E39C0d80912033490b897A866C03E7509ed3bb)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xC7B7BF79A006785cf7c037E287Be0185f0B17219)
 */
export const simulateWethStableDebtTokenTaikoApproveDelegation =
  /*#__PURE__*/ createSimulateContract({
    abi: wethStableDebtTokenTaikoAbi,
    address: wethStableDebtTokenTaikoAddress,
    functionName: 'approveDelegation',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wethStableDebtTokenTaikoAbi}__ and `functionName` set to `"burn"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xD7E39C0d80912033490b897A866C03E7509ed3bb)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xC7B7BF79A006785cf7c037E287Be0185f0B17219)
 */
export const simulateWethStableDebtTokenTaikoBurn =
  /*#__PURE__*/ createSimulateContract({
    abi: wethStableDebtTokenTaikoAbi,
    address: wethStableDebtTokenTaikoAddress,
    functionName: 'burn',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wethStableDebtTokenTaikoAbi}__ and `functionName` set to `"decreaseAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xD7E39C0d80912033490b897A866C03E7509ed3bb)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xC7B7BF79A006785cf7c037E287Be0185f0B17219)
 */
export const simulateWethStableDebtTokenTaikoDecreaseAllowance =
  /*#__PURE__*/ createSimulateContract({
    abi: wethStableDebtTokenTaikoAbi,
    address: wethStableDebtTokenTaikoAddress,
    functionName: 'decreaseAllowance',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wethStableDebtTokenTaikoAbi}__ and `functionName` set to `"delegationWithSig"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xD7E39C0d80912033490b897A866C03E7509ed3bb)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xC7B7BF79A006785cf7c037E287Be0185f0B17219)
 */
export const simulateWethStableDebtTokenTaikoDelegationWithSig =
  /*#__PURE__*/ createSimulateContract({
    abi: wethStableDebtTokenTaikoAbi,
    address: wethStableDebtTokenTaikoAddress,
    functionName: 'delegationWithSig',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wethStableDebtTokenTaikoAbi}__ and `functionName` set to `"increaseAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xD7E39C0d80912033490b897A866C03E7509ed3bb)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xC7B7BF79A006785cf7c037E287Be0185f0B17219)
 */
export const simulateWethStableDebtTokenTaikoIncreaseAllowance =
  /*#__PURE__*/ createSimulateContract({
    abi: wethStableDebtTokenTaikoAbi,
    address: wethStableDebtTokenTaikoAddress,
    functionName: 'increaseAllowance',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wethStableDebtTokenTaikoAbi}__ and `functionName` set to `"initialize"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xD7E39C0d80912033490b897A866C03E7509ed3bb)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xC7B7BF79A006785cf7c037E287Be0185f0B17219)
 */
export const simulateWethStableDebtTokenTaikoInitialize =
  /*#__PURE__*/ createSimulateContract({
    abi: wethStableDebtTokenTaikoAbi,
    address: wethStableDebtTokenTaikoAddress,
    functionName: 'initialize',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wethStableDebtTokenTaikoAbi}__ and `functionName` set to `"mint"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xD7E39C0d80912033490b897A866C03E7509ed3bb)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xC7B7BF79A006785cf7c037E287Be0185f0B17219)
 */
export const simulateWethStableDebtTokenTaikoMint =
  /*#__PURE__*/ createSimulateContract({
    abi: wethStableDebtTokenTaikoAbi,
    address: wethStableDebtTokenTaikoAddress,
    functionName: 'mint',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wethStableDebtTokenTaikoAbi}__ and `functionName` set to `"setIncentivesController"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xD7E39C0d80912033490b897A866C03E7509ed3bb)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xC7B7BF79A006785cf7c037E287Be0185f0B17219)
 */
export const simulateWethStableDebtTokenTaikoSetIncentivesController =
  /*#__PURE__*/ createSimulateContract({
    abi: wethStableDebtTokenTaikoAbi,
    address: wethStableDebtTokenTaikoAddress,
    functionName: 'setIncentivesController',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wethStableDebtTokenTaikoAbi}__ and `functionName` set to `"transfer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xD7E39C0d80912033490b897A866C03E7509ed3bb)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xC7B7BF79A006785cf7c037E287Be0185f0B17219)
 */
export const simulateWethStableDebtTokenTaikoTransfer =
  /*#__PURE__*/ createSimulateContract({
    abi: wethStableDebtTokenTaikoAbi,
    address: wethStableDebtTokenTaikoAddress,
    functionName: 'transfer',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wethStableDebtTokenTaikoAbi}__ and `functionName` set to `"transferFrom"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xD7E39C0d80912033490b897A866C03E7509ed3bb)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xC7B7BF79A006785cf7c037E287Be0185f0B17219)
 */
export const simulateWethStableDebtTokenTaikoTransferFrom =
  /*#__PURE__*/ createSimulateContract({
    abi: wethStableDebtTokenTaikoAbi,
    address: wethStableDebtTokenTaikoAddress,
    functionName: 'transferFrom',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link wethStableDebtTokenTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xD7E39C0d80912033490b897A866C03E7509ed3bb)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xC7B7BF79A006785cf7c037E287Be0185f0B17219)
 */
export const watchWethStableDebtTokenTaikoEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: wethStableDebtTokenTaikoAbi,
    address: wethStableDebtTokenTaikoAddress,
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link wethStableDebtTokenTaikoAbi}__ and `eventName` set to `"Approval"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xD7E39C0d80912033490b897A866C03E7509ed3bb)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xC7B7BF79A006785cf7c037E287Be0185f0B17219)
 */
export const watchWethStableDebtTokenTaikoApprovalEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: wethStableDebtTokenTaikoAbi,
    address: wethStableDebtTokenTaikoAddress,
    eventName: 'Approval',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link wethStableDebtTokenTaikoAbi}__ and `eventName` set to `"BorrowAllowanceDelegated"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xD7E39C0d80912033490b897A866C03E7509ed3bb)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xC7B7BF79A006785cf7c037E287Be0185f0B17219)
 */
export const watchWethStableDebtTokenTaikoBorrowAllowanceDelegatedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: wethStableDebtTokenTaikoAbi,
    address: wethStableDebtTokenTaikoAddress,
    eventName: 'BorrowAllowanceDelegated',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link wethStableDebtTokenTaikoAbi}__ and `eventName` set to `"Burn"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xD7E39C0d80912033490b897A866C03E7509ed3bb)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xC7B7BF79A006785cf7c037E287Be0185f0B17219)
 */
export const watchWethStableDebtTokenTaikoBurnEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: wethStableDebtTokenTaikoAbi,
    address: wethStableDebtTokenTaikoAddress,
    eventName: 'Burn',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link wethStableDebtTokenTaikoAbi}__ and `eventName` set to `"Initialized"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xD7E39C0d80912033490b897A866C03E7509ed3bb)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xC7B7BF79A006785cf7c037E287Be0185f0B17219)
 */
export const watchWethStableDebtTokenTaikoInitializedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: wethStableDebtTokenTaikoAbi,
    address: wethStableDebtTokenTaikoAddress,
    eventName: 'Initialized',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link wethStableDebtTokenTaikoAbi}__ and `eventName` set to `"Mint"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xD7E39C0d80912033490b897A866C03E7509ed3bb)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xC7B7BF79A006785cf7c037E287Be0185f0B17219)
 */
export const watchWethStableDebtTokenTaikoMintEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: wethStableDebtTokenTaikoAbi,
    address: wethStableDebtTokenTaikoAddress,
    eventName: 'Mint',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link wethStableDebtTokenTaikoAbi}__ and `eventName` set to `"Transfer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xD7E39C0d80912033490b897A866C03E7509ed3bb)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xC7B7BF79A006785cf7c037E287Be0185f0B17219)
 */
export const watchWethStableDebtTokenTaikoTransferEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: wethStableDebtTokenTaikoAbi,
    address: wethStableDebtTokenTaikoAddress,
    eventName: 'Transfer',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wethTestnetMintableErc20TaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x063D33aCa020dE70Dc5f6B12b94F9fA44C9D9330)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2B070a1C7CcE823d9DD4B54DdC44794Fc995c66c)
 */
export const readWethTestnetMintableErc20Taiko =
  /*#__PURE__*/ createReadContract({
    abi: wethTestnetMintableErc20TaikoAbi,
    address: wethTestnetMintableErc20TaikoAddress,
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wethTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"allowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x063D33aCa020dE70Dc5f6B12b94F9fA44C9D9330)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2B070a1C7CcE823d9DD4B54DdC44794Fc995c66c)
 */
export const readWethTestnetMintableErc20TaikoAllowance =
  /*#__PURE__*/ createReadContract({
    abi: wethTestnetMintableErc20TaikoAbi,
    address: wethTestnetMintableErc20TaikoAddress,
    functionName: 'allowance',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wethTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"balanceOf"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x063D33aCa020dE70Dc5f6B12b94F9fA44C9D9330)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2B070a1C7CcE823d9DD4B54DdC44794Fc995c66c)
 */
export const readWethTestnetMintableErc20TaikoBalanceOf =
  /*#__PURE__*/ createReadContract({
    abi: wethTestnetMintableErc20TaikoAbi,
    address: wethTestnetMintableErc20TaikoAddress,
    functionName: 'balanceOf',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wethTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"decimals"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x063D33aCa020dE70Dc5f6B12b94F9fA44C9D9330)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2B070a1C7CcE823d9DD4B54DdC44794Fc995c66c)
 */
export const readWethTestnetMintableErc20TaikoDecimals =
  /*#__PURE__*/ createReadContract({
    abi: wethTestnetMintableErc20TaikoAbi,
    address: wethTestnetMintableErc20TaikoAddress,
    functionName: 'decimals',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wethTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"isProtected"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x063D33aCa020dE70Dc5f6B12b94F9fA44C9D9330)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2B070a1C7CcE823d9DD4B54DdC44794Fc995c66c)
 */
export const readWethTestnetMintableErc20TaikoIsProtected =
  /*#__PURE__*/ createReadContract({
    abi: wethTestnetMintableErc20TaikoAbi,
    address: wethTestnetMintableErc20TaikoAddress,
    functionName: 'isProtected',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wethTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"name"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x063D33aCa020dE70Dc5f6B12b94F9fA44C9D9330)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2B070a1C7CcE823d9DD4B54DdC44794Fc995c66c)
 */
export const readWethTestnetMintableErc20TaikoName =
  /*#__PURE__*/ createReadContract({
    abi: wethTestnetMintableErc20TaikoAbi,
    address: wethTestnetMintableErc20TaikoAddress,
    functionName: 'name',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wethTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"owner"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x063D33aCa020dE70Dc5f6B12b94F9fA44C9D9330)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2B070a1C7CcE823d9DD4B54DdC44794Fc995c66c)
 */
export const readWethTestnetMintableErc20TaikoOwner =
  /*#__PURE__*/ createReadContract({
    abi: wethTestnetMintableErc20TaikoAbi,
    address: wethTestnetMintableErc20TaikoAddress,
    functionName: 'owner',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wethTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"symbol"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x063D33aCa020dE70Dc5f6B12b94F9fA44C9D9330)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2B070a1C7CcE823d9DD4B54DdC44794Fc995c66c)
 */
export const readWethTestnetMintableErc20TaikoSymbol =
  /*#__PURE__*/ createReadContract({
    abi: wethTestnetMintableErc20TaikoAbi,
    address: wethTestnetMintableErc20TaikoAddress,
    functionName: 'symbol',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wethTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"totalSupply"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x063D33aCa020dE70Dc5f6B12b94F9fA44C9D9330)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2B070a1C7CcE823d9DD4B54DdC44794Fc995c66c)
 */
export const readWethTestnetMintableErc20TaikoTotalSupply =
  /*#__PURE__*/ createReadContract({
    abi: wethTestnetMintableErc20TaikoAbi,
    address: wethTestnetMintableErc20TaikoAddress,
    functionName: 'totalSupply',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wethTestnetMintableErc20TaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x063D33aCa020dE70Dc5f6B12b94F9fA44C9D9330)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2B070a1C7CcE823d9DD4B54DdC44794Fc995c66c)
 */
export const writeWethTestnetMintableErc20Taiko =
  /*#__PURE__*/ createWriteContract({
    abi: wethTestnetMintableErc20TaikoAbi,
    address: wethTestnetMintableErc20TaikoAddress,
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wethTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"approve"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x063D33aCa020dE70Dc5f6B12b94F9fA44C9D9330)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2B070a1C7CcE823d9DD4B54DdC44794Fc995c66c)
 */
export const writeWethTestnetMintableErc20TaikoApprove =
  /*#__PURE__*/ createWriteContract({
    abi: wethTestnetMintableErc20TaikoAbi,
    address: wethTestnetMintableErc20TaikoAddress,
    functionName: 'approve',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wethTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"deposit"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x063D33aCa020dE70Dc5f6B12b94F9fA44C9D9330)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2B070a1C7CcE823d9DD4B54DdC44794Fc995c66c)
 */
export const writeWethTestnetMintableErc20TaikoDeposit =
  /*#__PURE__*/ createWriteContract({
    abi: wethTestnetMintableErc20TaikoAbi,
    address: wethTestnetMintableErc20TaikoAddress,
    functionName: 'deposit',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wethTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"mint"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x063D33aCa020dE70Dc5f6B12b94F9fA44C9D9330)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2B070a1C7CcE823d9DD4B54DdC44794Fc995c66c)
 */
export const writeWethTestnetMintableErc20TaikoMint =
  /*#__PURE__*/ createWriteContract({
    abi: wethTestnetMintableErc20TaikoAbi,
    address: wethTestnetMintableErc20TaikoAddress,
    functionName: 'mint',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wethTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"renounceOwnership"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x063D33aCa020dE70Dc5f6B12b94F9fA44C9D9330)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2B070a1C7CcE823d9DD4B54DdC44794Fc995c66c)
 */
export const writeWethTestnetMintableErc20TaikoRenounceOwnership =
  /*#__PURE__*/ createWriteContract({
    abi: wethTestnetMintableErc20TaikoAbi,
    address: wethTestnetMintableErc20TaikoAddress,
    functionName: 'renounceOwnership',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wethTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"setProtected"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x063D33aCa020dE70Dc5f6B12b94F9fA44C9D9330)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2B070a1C7CcE823d9DD4B54DdC44794Fc995c66c)
 */
export const writeWethTestnetMintableErc20TaikoSetProtected =
  /*#__PURE__*/ createWriteContract({
    abi: wethTestnetMintableErc20TaikoAbi,
    address: wethTestnetMintableErc20TaikoAddress,
    functionName: 'setProtected',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wethTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"transfer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x063D33aCa020dE70Dc5f6B12b94F9fA44C9D9330)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2B070a1C7CcE823d9DD4B54DdC44794Fc995c66c)
 */
export const writeWethTestnetMintableErc20TaikoTransfer =
  /*#__PURE__*/ createWriteContract({
    abi: wethTestnetMintableErc20TaikoAbi,
    address: wethTestnetMintableErc20TaikoAddress,
    functionName: 'transfer',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wethTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"transferFrom"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x063D33aCa020dE70Dc5f6B12b94F9fA44C9D9330)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2B070a1C7CcE823d9DD4B54DdC44794Fc995c66c)
 */
export const writeWethTestnetMintableErc20TaikoTransferFrom =
  /*#__PURE__*/ createWriteContract({
    abi: wethTestnetMintableErc20TaikoAbi,
    address: wethTestnetMintableErc20TaikoAddress,
    functionName: 'transferFrom',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wethTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"transferOwnership"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x063D33aCa020dE70Dc5f6B12b94F9fA44C9D9330)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2B070a1C7CcE823d9DD4B54DdC44794Fc995c66c)
 */
export const writeWethTestnetMintableErc20TaikoTransferOwnership =
  /*#__PURE__*/ createWriteContract({
    abi: wethTestnetMintableErc20TaikoAbi,
    address: wethTestnetMintableErc20TaikoAddress,
    functionName: 'transferOwnership',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wethTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"withdraw"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x063D33aCa020dE70Dc5f6B12b94F9fA44C9D9330)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2B070a1C7CcE823d9DD4B54DdC44794Fc995c66c)
 */
export const writeWethTestnetMintableErc20TaikoWithdraw =
  /*#__PURE__*/ createWriteContract({
    abi: wethTestnetMintableErc20TaikoAbi,
    address: wethTestnetMintableErc20TaikoAddress,
    functionName: 'withdraw',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wethTestnetMintableErc20TaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x063D33aCa020dE70Dc5f6B12b94F9fA44C9D9330)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2B070a1C7CcE823d9DD4B54DdC44794Fc995c66c)
 */
export const simulateWethTestnetMintableErc20Taiko =
  /*#__PURE__*/ createSimulateContract({
    abi: wethTestnetMintableErc20TaikoAbi,
    address: wethTestnetMintableErc20TaikoAddress,
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wethTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"approve"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x063D33aCa020dE70Dc5f6B12b94F9fA44C9D9330)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2B070a1C7CcE823d9DD4B54DdC44794Fc995c66c)
 */
export const simulateWethTestnetMintableErc20TaikoApprove =
  /*#__PURE__*/ createSimulateContract({
    abi: wethTestnetMintableErc20TaikoAbi,
    address: wethTestnetMintableErc20TaikoAddress,
    functionName: 'approve',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wethTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"deposit"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x063D33aCa020dE70Dc5f6B12b94F9fA44C9D9330)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2B070a1C7CcE823d9DD4B54DdC44794Fc995c66c)
 */
export const simulateWethTestnetMintableErc20TaikoDeposit =
  /*#__PURE__*/ createSimulateContract({
    abi: wethTestnetMintableErc20TaikoAbi,
    address: wethTestnetMintableErc20TaikoAddress,
    functionName: 'deposit',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wethTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"mint"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x063D33aCa020dE70Dc5f6B12b94F9fA44C9D9330)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2B070a1C7CcE823d9DD4B54DdC44794Fc995c66c)
 */
export const simulateWethTestnetMintableErc20TaikoMint =
  /*#__PURE__*/ createSimulateContract({
    abi: wethTestnetMintableErc20TaikoAbi,
    address: wethTestnetMintableErc20TaikoAddress,
    functionName: 'mint',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wethTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"renounceOwnership"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x063D33aCa020dE70Dc5f6B12b94F9fA44C9D9330)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2B070a1C7CcE823d9DD4B54DdC44794Fc995c66c)
 */
export const simulateWethTestnetMintableErc20TaikoRenounceOwnership =
  /*#__PURE__*/ createSimulateContract({
    abi: wethTestnetMintableErc20TaikoAbi,
    address: wethTestnetMintableErc20TaikoAddress,
    functionName: 'renounceOwnership',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wethTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"setProtected"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x063D33aCa020dE70Dc5f6B12b94F9fA44C9D9330)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2B070a1C7CcE823d9DD4B54DdC44794Fc995c66c)
 */
export const simulateWethTestnetMintableErc20TaikoSetProtected =
  /*#__PURE__*/ createSimulateContract({
    abi: wethTestnetMintableErc20TaikoAbi,
    address: wethTestnetMintableErc20TaikoAddress,
    functionName: 'setProtected',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wethTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"transfer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x063D33aCa020dE70Dc5f6B12b94F9fA44C9D9330)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2B070a1C7CcE823d9DD4B54DdC44794Fc995c66c)
 */
export const simulateWethTestnetMintableErc20TaikoTransfer =
  /*#__PURE__*/ createSimulateContract({
    abi: wethTestnetMintableErc20TaikoAbi,
    address: wethTestnetMintableErc20TaikoAddress,
    functionName: 'transfer',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wethTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"transferFrom"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x063D33aCa020dE70Dc5f6B12b94F9fA44C9D9330)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2B070a1C7CcE823d9DD4B54DdC44794Fc995c66c)
 */
export const simulateWethTestnetMintableErc20TaikoTransferFrom =
  /*#__PURE__*/ createSimulateContract({
    abi: wethTestnetMintableErc20TaikoAbi,
    address: wethTestnetMintableErc20TaikoAddress,
    functionName: 'transferFrom',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wethTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"transferOwnership"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x063D33aCa020dE70Dc5f6B12b94F9fA44C9D9330)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2B070a1C7CcE823d9DD4B54DdC44794Fc995c66c)
 */
export const simulateWethTestnetMintableErc20TaikoTransferOwnership =
  /*#__PURE__*/ createSimulateContract({
    abi: wethTestnetMintableErc20TaikoAbi,
    address: wethTestnetMintableErc20TaikoAddress,
    functionName: 'transferOwnership',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wethTestnetMintableErc20TaikoAbi}__ and `functionName` set to `"withdraw"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x063D33aCa020dE70Dc5f6B12b94F9fA44C9D9330)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2B070a1C7CcE823d9DD4B54DdC44794Fc995c66c)
 */
export const simulateWethTestnetMintableErc20TaikoWithdraw =
  /*#__PURE__*/ createSimulateContract({
    abi: wethTestnetMintableErc20TaikoAbi,
    address: wethTestnetMintableErc20TaikoAddress,
    functionName: 'withdraw',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link wethTestnetMintableErc20TaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x063D33aCa020dE70Dc5f6B12b94F9fA44C9D9330)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2B070a1C7CcE823d9DD4B54DdC44794Fc995c66c)
 */
export const watchWethTestnetMintableErc20TaikoEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: wethTestnetMintableErc20TaikoAbi,
    address: wethTestnetMintableErc20TaikoAddress,
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link wethTestnetMintableErc20TaikoAbi}__ and `eventName` set to `"Approval"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x063D33aCa020dE70Dc5f6B12b94F9fA44C9D9330)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2B070a1C7CcE823d9DD4B54DdC44794Fc995c66c)
 */
export const watchWethTestnetMintableErc20TaikoApprovalEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: wethTestnetMintableErc20TaikoAbi,
    address: wethTestnetMintableErc20TaikoAddress,
    eventName: 'Approval',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link wethTestnetMintableErc20TaikoAbi}__ and `eventName` set to `"Deposit"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x063D33aCa020dE70Dc5f6B12b94F9fA44C9D9330)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2B070a1C7CcE823d9DD4B54DdC44794Fc995c66c)
 */
export const watchWethTestnetMintableErc20TaikoDepositEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: wethTestnetMintableErc20TaikoAbi,
    address: wethTestnetMintableErc20TaikoAddress,
    eventName: 'Deposit',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link wethTestnetMintableErc20TaikoAbi}__ and `eventName` set to `"OwnershipTransferred"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x063D33aCa020dE70Dc5f6B12b94F9fA44C9D9330)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2B070a1C7CcE823d9DD4B54DdC44794Fc995c66c)
 */
export const watchWethTestnetMintableErc20TaikoOwnershipTransferredEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: wethTestnetMintableErc20TaikoAbi,
    address: wethTestnetMintableErc20TaikoAddress,
    eventName: 'OwnershipTransferred',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link wethTestnetMintableErc20TaikoAbi}__ and `eventName` set to `"Transfer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x063D33aCa020dE70Dc5f6B12b94F9fA44C9D9330)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2B070a1C7CcE823d9DD4B54DdC44794Fc995c66c)
 */
export const watchWethTestnetMintableErc20TaikoTransferEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: wethTestnetMintableErc20TaikoAbi,
    address: wethTestnetMintableErc20TaikoAddress,
    eventName: 'Transfer',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link wethTestnetMintableErc20TaikoAbi}__ and `eventName` set to `"Withdrawal"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x063D33aCa020dE70Dc5f6B12b94F9fA44C9D9330)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x2B070a1C7CcE823d9DD4B54DdC44794Fc995c66c)
 */
export const watchWethTestnetMintableErc20TaikoWithdrawalEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: wethTestnetMintableErc20TaikoAbi,
    address: wethTestnetMintableErc20TaikoAddress,
    eventName: 'Withdrawal',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wethTestnetPriceAggregatorTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd7a093a0Aa77939374d83FB85A38e453c5D4B174)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA21F729Edccd1249F719Be2C917d238435d1a792)
 */
export const readWethTestnetPriceAggregatorTaiko =
  /*#__PURE__*/ createReadContract({
    abi: wethTestnetPriceAggregatorTaikoAbi,
    address: wethTestnetPriceAggregatorTaikoAddress,
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wethTestnetPriceAggregatorTaikoAbi}__ and `functionName` set to `"decimals"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd7a093a0Aa77939374d83FB85A38e453c5D4B174)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA21F729Edccd1249F719Be2C917d238435d1a792)
 */
export const readWethTestnetPriceAggregatorTaikoDecimals =
  /*#__PURE__*/ createReadContract({
    abi: wethTestnetPriceAggregatorTaikoAbi,
    address: wethTestnetPriceAggregatorTaikoAddress,
    functionName: 'decimals',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wethTestnetPriceAggregatorTaikoAbi}__ and `functionName` set to `"getTokenType"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd7a093a0Aa77939374d83FB85A38e453c5D4B174)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA21F729Edccd1249F719Be2C917d238435d1a792)
 */
export const readWethTestnetPriceAggregatorTaikoGetTokenType =
  /*#__PURE__*/ createReadContract({
    abi: wethTestnetPriceAggregatorTaikoAbi,
    address: wethTestnetPriceAggregatorTaikoAddress,
    functionName: 'getTokenType',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wethTestnetPriceAggregatorTaikoAbi}__ and `functionName` set to `"latestAnswer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd7a093a0Aa77939374d83FB85A38e453c5D4B174)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA21F729Edccd1249F719Be2C917d238435d1a792)
 */
export const readWethTestnetPriceAggregatorTaikoLatestAnswer =
  /*#__PURE__*/ createReadContract({
    abi: wethTestnetPriceAggregatorTaikoAbi,
    address: wethTestnetPriceAggregatorTaikoAddress,
    functionName: 'latestAnswer',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link wethTestnetPriceAggregatorTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd7a093a0Aa77939374d83FB85A38e453c5D4B174)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA21F729Edccd1249F719Be2C917d238435d1a792)
 */
export const watchWethTestnetPriceAggregatorTaikoEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: wethTestnetPriceAggregatorTaikoAbi,
    address: wethTestnetPriceAggregatorTaikoAddress,
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link wethTestnetPriceAggregatorTaikoAbi}__ and `eventName` set to `"AnswerUpdated"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xd7a093a0Aa77939374d83FB85A38e453c5D4B174)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xA21F729Edccd1249F719Be2C917d238435d1a792)
 */
export const watchWethTestnetPriceAggregatorTaikoAnswerUpdatedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: wethTestnetPriceAggregatorTaikoAbi,
    address: wethTestnetPriceAggregatorTaikoAddress,
    eventName: 'AnswerUpdated',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wethVariableDebtTokenTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x739E2f35970fC4351C59a2E44480696bEe5de1ad)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa5505643bB243c38e18Fef93672534a44B52c1AD)
 */
export const readWethVariableDebtTokenTaiko = /*#__PURE__*/ createReadContract({
  abi: wethVariableDebtTokenTaikoAbi,
  address: wethVariableDebtTokenTaikoAddress,
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wethVariableDebtTokenTaikoAbi}__ and `functionName` set to `"DEBT_TOKEN_REVISION"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x739E2f35970fC4351C59a2E44480696bEe5de1ad)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa5505643bB243c38e18Fef93672534a44B52c1AD)
 */
export const readWethVariableDebtTokenTaikoDebtTokenRevision =
  /*#__PURE__*/ createReadContract({
    abi: wethVariableDebtTokenTaikoAbi,
    address: wethVariableDebtTokenTaikoAddress,
    functionName: 'DEBT_TOKEN_REVISION',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wethVariableDebtTokenTaikoAbi}__ and `functionName` set to `"DELEGATION_WITH_SIG_TYPEHASH"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x739E2f35970fC4351C59a2E44480696bEe5de1ad)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa5505643bB243c38e18Fef93672534a44B52c1AD)
 */
export const readWethVariableDebtTokenTaikoDelegationWithSigTypehash =
  /*#__PURE__*/ createReadContract({
    abi: wethVariableDebtTokenTaikoAbi,
    address: wethVariableDebtTokenTaikoAddress,
    functionName: 'DELEGATION_WITH_SIG_TYPEHASH',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wethVariableDebtTokenTaikoAbi}__ and `functionName` set to `"DOMAIN_SEPARATOR"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x739E2f35970fC4351C59a2E44480696bEe5de1ad)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa5505643bB243c38e18Fef93672534a44B52c1AD)
 */
export const readWethVariableDebtTokenTaikoDomainSeparator =
  /*#__PURE__*/ createReadContract({
    abi: wethVariableDebtTokenTaikoAbi,
    address: wethVariableDebtTokenTaikoAddress,
    functionName: 'DOMAIN_SEPARATOR',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wethVariableDebtTokenTaikoAbi}__ and `functionName` set to `"EIP712_REVISION"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x739E2f35970fC4351C59a2E44480696bEe5de1ad)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa5505643bB243c38e18Fef93672534a44B52c1AD)
 */
export const readWethVariableDebtTokenTaikoEip712Revision =
  /*#__PURE__*/ createReadContract({
    abi: wethVariableDebtTokenTaikoAbi,
    address: wethVariableDebtTokenTaikoAddress,
    functionName: 'EIP712_REVISION',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wethVariableDebtTokenTaikoAbi}__ and `functionName` set to `"POOL"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x739E2f35970fC4351C59a2E44480696bEe5de1ad)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa5505643bB243c38e18Fef93672534a44B52c1AD)
 */
export const readWethVariableDebtTokenTaikoPool =
  /*#__PURE__*/ createReadContract({
    abi: wethVariableDebtTokenTaikoAbi,
    address: wethVariableDebtTokenTaikoAddress,
    functionName: 'POOL',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wethVariableDebtTokenTaikoAbi}__ and `functionName` set to `"UNDERLYING_ASSET_ADDRESS"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x739E2f35970fC4351C59a2E44480696bEe5de1ad)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa5505643bB243c38e18Fef93672534a44B52c1AD)
 */
export const readWethVariableDebtTokenTaikoUnderlyingAssetAddress =
  /*#__PURE__*/ createReadContract({
    abi: wethVariableDebtTokenTaikoAbi,
    address: wethVariableDebtTokenTaikoAddress,
    functionName: 'UNDERLYING_ASSET_ADDRESS',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wethVariableDebtTokenTaikoAbi}__ and `functionName` set to `"allowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x739E2f35970fC4351C59a2E44480696bEe5de1ad)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa5505643bB243c38e18Fef93672534a44B52c1AD)
 */
export const readWethVariableDebtTokenTaikoAllowance =
  /*#__PURE__*/ createReadContract({
    abi: wethVariableDebtTokenTaikoAbi,
    address: wethVariableDebtTokenTaikoAddress,
    functionName: 'allowance',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wethVariableDebtTokenTaikoAbi}__ and `functionName` set to `"balanceOf"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x739E2f35970fC4351C59a2E44480696bEe5de1ad)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa5505643bB243c38e18Fef93672534a44B52c1AD)
 */
export const readWethVariableDebtTokenTaikoBalanceOf =
  /*#__PURE__*/ createReadContract({
    abi: wethVariableDebtTokenTaikoAbi,
    address: wethVariableDebtTokenTaikoAddress,
    functionName: 'balanceOf',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wethVariableDebtTokenTaikoAbi}__ and `functionName` set to `"borrowAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x739E2f35970fC4351C59a2E44480696bEe5de1ad)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa5505643bB243c38e18Fef93672534a44B52c1AD)
 */
export const readWethVariableDebtTokenTaikoBorrowAllowance =
  /*#__PURE__*/ createReadContract({
    abi: wethVariableDebtTokenTaikoAbi,
    address: wethVariableDebtTokenTaikoAddress,
    functionName: 'borrowAllowance',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wethVariableDebtTokenTaikoAbi}__ and `functionName` set to `"decimals"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x739E2f35970fC4351C59a2E44480696bEe5de1ad)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa5505643bB243c38e18Fef93672534a44B52c1AD)
 */
export const readWethVariableDebtTokenTaikoDecimals =
  /*#__PURE__*/ createReadContract({
    abi: wethVariableDebtTokenTaikoAbi,
    address: wethVariableDebtTokenTaikoAddress,
    functionName: 'decimals',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wethVariableDebtTokenTaikoAbi}__ and `functionName` set to `"getIncentivesController"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x739E2f35970fC4351C59a2E44480696bEe5de1ad)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa5505643bB243c38e18Fef93672534a44B52c1AD)
 */
export const readWethVariableDebtTokenTaikoGetIncentivesController =
  /*#__PURE__*/ createReadContract({
    abi: wethVariableDebtTokenTaikoAbi,
    address: wethVariableDebtTokenTaikoAddress,
    functionName: 'getIncentivesController',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wethVariableDebtTokenTaikoAbi}__ and `functionName` set to `"getPreviousIndex"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x739E2f35970fC4351C59a2E44480696bEe5de1ad)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa5505643bB243c38e18Fef93672534a44B52c1AD)
 */
export const readWethVariableDebtTokenTaikoGetPreviousIndex =
  /*#__PURE__*/ createReadContract({
    abi: wethVariableDebtTokenTaikoAbi,
    address: wethVariableDebtTokenTaikoAddress,
    functionName: 'getPreviousIndex',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wethVariableDebtTokenTaikoAbi}__ and `functionName` set to `"getScaledUserBalanceAndSupply"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x739E2f35970fC4351C59a2E44480696bEe5de1ad)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa5505643bB243c38e18Fef93672534a44B52c1AD)
 */
export const readWethVariableDebtTokenTaikoGetScaledUserBalanceAndSupply =
  /*#__PURE__*/ createReadContract({
    abi: wethVariableDebtTokenTaikoAbi,
    address: wethVariableDebtTokenTaikoAddress,
    functionName: 'getScaledUserBalanceAndSupply',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wethVariableDebtTokenTaikoAbi}__ and `functionName` set to `"name"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x739E2f35970fC4351C59a2E44480696bEe5de1ad)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa5505643bB243c38e18Fef93672534a44B52c1AD)
 */
export const readWethVariableDebtTokenTaikoName =
  /*#__PURE__*/ createReadContract({
    abi: wethVariableDebtTokenTaikoAbi,
    address: wethVariableDebtTokenTaikoAddress,
    functionName: 'name',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wethVariableDebtTokenTaikoAbi}__ and `functionName` set to `"nonces"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x739E2f35970fC4351C59a2E44480696bEe5de1ad)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa5505643bB243c38e18Fef93672534a44B52c1AD)
 */
export const readWethVariableDebtTokenTaikoNonces =
  /*#__PURE__*/ createReadContract({
    abi: wethVariableDebtTokenTaikoAbi,
    address: wethVariableDebtTokenTaikoAddress,
    functionName: 'nonces',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wethVariableDebtTokenTaikoAbi}__ and `functionName` set to `"scaledBalanceOf"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x739E2f35970fC4351C59a2E44480696bEe5de1ad)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa5505643bB243c38e18Fef93672534a44B52c1AD)
 */
export const readWethVariableDebtTokenTaikoScaledBalanceOf =
  /*#__PURE__*/ createReadContract({
    abi: wethVariableDebtTokenTaikoAbi,
    address: wethVariableDebtTokenTaikoAddress,
    functionName: 'scaledBalanceOf',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wethVariableDebtTokenTaikoAbi}__ and `functionName` set to `"scaledTotalSupply"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x739E2f35970fC4351C59a2E44480696bEe5de1ad)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa5505643bB243c38e18Fef93672534a44B52c1AD)
 */
export const readWethVariableDebtTokenTaikoScaledTotalSupply =
  /*#__PURE__*/ createReadContract({
    abi: wethVariableDebtTokenTaikoAbi,
    address: wethVariableDebtTokenTaikoAddress,
    functionName: 'scaledTotalSupply',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wethVariableDebtTokenTaikoAbi}__ and `functionName` set to `"symbol"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x739E2f35970fC4351C59a2E44480696bEe5de1ad)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa5505643bB243c38e18Fef93672534a44B52c1AD)
 */
export const readWethVariableDebtTokenTaikoSymbol =
  /*#__PURE__*/ createReadContract({
    abi: wethVariableDebtTokenTaikoAbi,
    address: wethVariableDebtTokenTaikoAddress,
    functionName: 'symbol',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wethVariableDebtTokenTaikoAbi}__ and `functionName` set to `"totalSupply"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x739E2f35970fC4351C59a2E44480696bEe5de1ad)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa5505643bB243c38e18Fef93672534a44B52c1AD)
 */
export const readWethVariableDebtTokenTaikoTotalSupply =
  /*#__PURE__*/ createReadContract({
    abi: wethVariableDebtTokenTaikoAbi,
    address: wethVariableDebtTokenTaikoAddress,
    functionName: 'totalSupply',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wethVariableDebtTokenTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x739E2f35970fC4351C59a2E44480696bEe5de1ad)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa5505643bB243c38e18Fef93672534a44B52c1AD)
 */
export const writeWethVariableDebtTokenTaiko =
  /*#__PURE__*/ createWriteContract({
    abi: wethVariableDebtTokenTaikoAbi,
    address: wethVariableDebtTokenTaikoAddress,
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wethVariableDebtTokenTaikoAbi}__ and `functionName` set to `"approve"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x739E2f35970fC4351C59a2E44480696bEe5de1ad)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa5505643bB243c38e18Fef93672534a44B52c1AD)
 */
export const writeWethVariableDebtTokenTaikoApprove =
  /*#__PURE__*/ createWriteContract({
    abi: wethVariableDebtTokenTaikoAbi,
    address: wethVariableDebtTokenTaikoAddress,
    functionName: 'approve',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wethVariableDebtTokenTaikoAbi}__ and `functionName` set to `"approveDelegation"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x739E2f35970fC4351C59a2E44480696bEe5de1ad)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa5505643bB243c38e18Fef93672534a44B52c1AD)
 */
export const writeWethVariableDebtTokenTaikoApproveDelegation =
  /*#__PURE__*/ createWriteContract({
    abi: wethVariableDebtTokenTaikoAbi,
    address: wethVariableDebtTokenTaikoAddress,
    functionName: 'approveDelegation',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wethVariableDebtTokenTaikoAbi}__ and `functionName` set to `"burn"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x739E2f35970fC4351C59a2E44480696bEe5de1ad)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa5505643bB243c38e18Fef93672534a44B52c1AD)
 */
export const writeWethVariableDebtTokenTaikoBurn =
  /*#__PURE__*/ createWriteContract({
    abi: wethVariableDebtTokenTaikoAbi,
    address: wethVariableDebtTokenTaikoAddress,
    functionName: 'burn',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wethVariableDebtTokenTaikoAbi}__ and `functionName` set to `"decreaseAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x739E2f35970fC4351C59a2E44480696bEe5de1ad)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa5505643bB243c38e18Fef93672534a44B52c1AD)
 */
export const writeWethVariableDebtTokenTaikoDecreaseAllowance =
  /*#__PURE__*/ createWriteContract({
    abi: wethVariableDebtTokenTaikoAbi,
    address: wethVariableDebtTokenTaikoAddress,
    functionName: 'decreaseAllowance',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wethVariableDebtTokenTaikoAbi}__ and `functionName` set to `"delegationWithSig"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x739E2f35970fC4351C59a2E44480696bEe5de1ad)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa5505643bB243c38e18Fef93672534a44B52c1AD)
 */
export const writeWethVariableDebtTokenTaikoDelegationWithSig =
  /*#__PURE__*/ createWriteContract({
    abi: wethVariableDebtTokenTaikoAbi,
    address: wethVariableDebtTokenTaikoAddress,
    functionName: 'delegationWithSig',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wethVariableDebtTokenTaikoAbi}__ and `functionName` set to `"increaseAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x739E2f35970fC4351C59a2E44480696bEe5de1ad)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa5505643bB243c38e18Fef93672534a44B52c1AD)
 */
export const writeWethVariableDebtTokenTaikoIncreaseAllowance =
  /*#__PURE__*/ createWriteContract({
    abi: wethVariableDebtTokenTaikoAbi,
    address: wethVariableDebtTokenTaikoAddress,
    functionName: 'increaseAllowance',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wethVariableDebtTokenTaikoAbi}__ and `functionName` set to `"initialize"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x739E2f35970fC4351C59a2E44480696bEe5de1ad)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa5505643bB243c38e18Fef93672534a44B52c1AD)
 */
export const writeWethVariableDebtTokenTaikoInitialize =
  /*#__PURE__*/ createWriteContract({
    abi: wethVariableDebtTokenTaikoAbi,
    address: wethVariableDebtTokenTaikoAddress,
    functionName: 'initialize',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wethVariableDebtTokenTaikoAbi}__ and `functionName` set to `"mint"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x739E2f35970fC4351C59a2E44480696bEe5de1ad)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa5505643bB243c38e18Fef93672534a44B52c1AD)
 */
export const writeWethVariableDebtTokenTaikoMint =
  /*#__PURE__*/ createWriteContract({
    abi: wethVariableDebtTokenTaikoAbi,
    address: wethVariableDebtTokenTaikoAddress,
    functionName: 'mint',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wethVariableDebtTokenTaikoAbi}__ and `functionName` set to `"setIncentivesController"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x739E2f35970fC4351C59a2E44480696bEe5de1ad)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa5505643bB243c38e18Fef93672534a44B52c1AD)
 */
export const writeWethVariableDebtTokenTaikoSetIncentivesController =
  /*#__PURE__*/ createWriteContract({
    abi: wethVariableDebtTokenTaikoAbi,
    address: wethVariableDebtTokenTaikoAddress,
    functionName: 'setIncentivesController',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wethVariableDebtTokenTaikoAbi}__ and `functionName` set to `"transfer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x739E2f35970fC4351C59a2E44480696bEe5de1ad)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa5505643bB243c38e18Fef93672534a44B52c1AD)
 */
export const writeWethVariableDebtTokenTaikoTransfer =
  /*#__PURE__*/ createWriteContract({
    abi: wethVariableDebtTokenTaikoAbi,
    address: wethVariableDebtTokenTaikoAddress,
    functionName: 'transfer',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wethVariableDebtTokenTaikoAbi}__ and `functionName` set to `"transferFrom"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x739E2f35970fC4351C59a2E44480696bEe5de1ad)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa5505643bB243c38e18Fef93672534a44B52c1AD)
 */
export const writeWethVariableDebtTokenTaikoTransferFrom =
  /*#__PURE__*/ createWriteContract({
    abi: wethVariableDebtTokenTaikoAbi,
    address: wethVariableDebtTokenTaikoAddress,
    functionName: 'transferFrom',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wethVariableDebtTokenTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x739E2f35970fC4351C59a2E44480696bEe5de1ad)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa5505643bB243c38e18Fef93672534a44B52c1AD)
 */
export const simulateWethVariableDebtTokenTaiko =
  /*#__PURE__*/ createSimulateContract({
    abi: wethVariableDebtTokenTaikoAbi,
    address: wethVariableDebtTokenTaikoAddress,
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wethVariableDebtTokenTaikoAbi}__ and `functionName` set to `"approve"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x739E2f35970fC4351C59a2E44480696bEe5de1ad)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa5505643bB243c38e18Fef93672534a44B52c1AD)
 */
export const simulateWethVariableDebtTokenTaikoApprove =
  /*#__PURE__*/ createSimulateContract({
    abi: wethVariableDebtTokenTaikoAbi,
    address: wethVariableDebtTokenTaikoAddress,
    functionName: 'approve',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wethVariableDebtTokenTaikoAbi}__ and `functionName` set to `"approveDelegation"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x739E2f35970fC4351C59a2E44480696bEe5de1ad)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa5505643bB243c38e18Fef93672534a44B52c1AD)
 */
export const simulateWethVariableDebtTokenTaikoApproveDelegation =
  /*#__PURE__*/ createSimulateContract({
    abi: wethVariableDebtTokenTaikoAbi,
    address: wethVariableDebtTokenTaikoAddress,
    functionName: 'approveDelegation',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wethVariableDebtTokenTaikoAbi}__ and `functionName` set to `"burn"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x739E2f35970fC4351C59a2E44480696bEe5de1ad)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa5505643bB243c38e18Fef93672534a44B52c1AD)
 */
export const simulateWethVariableDebtTokenTaikoBurn =
  /*#__PURE__*/ createSimulateContract({
    abi: wethVariableDebtTokenTaikoAbi,
    address: wethVariableDebtTokenTaikoAddress,
    functionName: 'burn',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wethVariableDebtTokenTaikoAbi}__ and `functionName` set to `"decreaseAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x739E2f35970fC4351C59a2E44480696bEe5de1ad)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa5505643bB243c38e18Fef93672534a44B52c1AD)
 */
export const simulateWethVariableDebtTokenTaikoDecreaseAllowance =
  /*#__PURE__*/ createSimulateContract({
    abi: wethVariableDebtTokenTaikoAbi,
    address: wethVariableDebtTokenTaikoAddress,
    functionName: 'decreaseAllowance',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wethVariableDebtTokenTaikoAbi}__ and `functionName` set to `"delegationWithSig"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x739E2f35970fC4351C59a2E44480696bEe5de1ad)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa5505643bB243c38e18Fef93672534a44B52c1AD)
 */
export const simulateWethVariableDebtTokenTaikoDelegationWithSig =
  /*#__PURE__*/ createSimulateContract({
    abi: wethVariableDebtTokenTaikoAbi,
    address: wethVariableDebtTokenTaikoAddress,
    functionName: 'delegationWithSig',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wethVariableDebtTokenTaikoAbi}__ and `functionName` set to `"increaseAllowance"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x739E2f35970fC4351C59a2E44480696bEe5de1ad)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa5505643bB243c38e18Fef93672534a44B52c1AD)
 */
export const simulateWethVariableDebtTokenTaikoIncreaseAllowance =
  /*#__PURE__*/ createSimulateContract({
    abi: wethVariableDebtTokenTaikoAbi,
    address: wethVariableDebtTokenTaikoAddress,
    functionName: 'increaseAllowance',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wethVariableDebtTokenTaikoAbi}__ and `functionName` set to `"initialize"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x739E2f35970fC4351C59a2E44480696bEe5de1ad)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa5505643bB243c38e18Fef93672534a44B52c1AD)
 */
export const simulateWethVariableDebtTokenTaikoInitialize =
  /*#__PURE__*/ createSimulateContract({
    abi: wethVariableDebtTokenTaikoAbi,
    address: wethVariableDebtTokenTaikoAddress,
    functionName: 'initialize',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wethVariableDebtTokenTaikoAbi}__ and `functionName` set to `"mint"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x739E2f35970fC4351C59a2E44480696bEe5de1ad)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa5505643bB243c38e18Fef93672534a44B52c1AD)
 */
export const simulateWethVariableDebtTokenTaikoMint =
  /*#__PURE__*/ createSimulateContract({
    abi: wethVariableDebtTokenTaikoAbi,
    address: wethVariableDebtTokenTaikoAddress,
    functionName: 'mint',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wethVariableDebtTokenTaikoAbi}__ and `functionName` set to `"setIncentivesController"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x739E2f35970fC4351C59a2E44480696bEe5de1ad)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa5505643bB243c38e18Fef93672534a44B52c1AD)
 */
export const simulateWethVariableDebtTokenTaikoSetIncentivesController =
  /*#__PURE__*/ createSimulateContract({
    abi: wethVariableDebtTokenTaikoAbi,
    address: wethVariableDebtTokenTaikoAddress,
    functionName: 'setIncentivesController',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wethVariableDebtTokenTaikoAbi}__ and `functionName` set to `"transfer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x739E2f35970fC4351C59a2E44480696bEe5de1ad)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa5505643bB243c38e18Fef93672534a44B52c1AD)
 */
export const simulateWethVariableDebtTokenTaikoTransfer =
  /*#__PURE__*/ createSimulateContract({
    abi: wethVariableDebtTokenTaikoAbi,
    address: wethVariableDebtTokenTaikoAddress,
    functionName: 'transfer',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wethVariableDebtTokenTaikoAbi}__ and `functionName` set to `"transferFrom"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x739E2f35970fC4351C59a2E44480696bEe5de1ad)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa5505643bB243c38e18Fef93672534a44B52c1AD)
 */
export const simulateWethVariableDebtTokenTaikoTransferFrom =
  /*#__PURE__*/ createSimulateContract({
    abi: wethVariableDebtTokenTaikoAbi,
    address: wethVariableDebtTokenTaikoAddress,
    functionName: 'transferFrom',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link wethVariableDebtTokenTaikoAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x739E2f35970fC4351C59a2E44480696bEe5de1ad)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa5505643bB243c38e18Fef93672534a44B52c1AD)
 */
export const watchWethVariableDebtTokenTaikoEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: wethVariableDebtTokenTaikoAbi,
    address: wethVariableDebtTokenTaikoAddress,
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link wethVariableDebtTokenTaikoAbi}__ and `eventName` set to `"Approval"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x739E2f35970fC4351C59a2E44480696bEe5de1ad)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa5505643bB243c38e18Fef93672534a44B52c1AD)
 */
export const watchWethVariableDebtTokenTaikoApprovalEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: wethVariableDebtTokenTaikoAbi,
    address: wethVariableDebtTokenTaikoAddress,
    eventName: 'Approval',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link wethVariableDebtTokenTaikoAbi}__ and `eventName` set to `"BorrowAllowanceDelegated"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x739E2f35970fC4351C59a2E44480696bEe5de1ad)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa5505643bB243c38e18Fef93672534a44B52c1AD)
 */
export const watchWethVariableDebtTokenTaikoBorrowAllowanceDelegatedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: wethVariableDebtTokenTaikoAbi,
    address: wethVariableDebtTokenTaikoAddress,
    eventName: 'BorrowAllowanceDelegated',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link wethVariableDebtTokenTaikoAbi}__ and `eventName` set to `"Burn"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x739E2f35970fC4351C59a2E44480696bEe5de1ad)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa5505643bB243c38e18Fef93672534a44B52c1AD)
 */
export const watchWethVariableDebtTokenTaikoBurnEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: wethVariableDebtTokenTaikoAbi,
    address: wethVariableDebtTokenTaikoAddress,
    eventName: 'Burn',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link wethVariableDebtTokenTaikoAbi}__ and `eventName` set to `"Initialized"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x739E2f35970fC4351C59a2E44480696bEe5de1ad)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa5505643bB243c38e18Fef93672534a44B52c1AD)
 */
export const watchWethVariableDebtTokenTaikoInitializedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: wethVariableDebtTokenTaikoAbi,
    address: wethVariableDebtTokenTaikoAddress,
    eventName: 'Initialized',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link wethVariableDebtTokenTaikoAbi}__ and `eventName` set to `"Mint"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x739E2f35970fC4351C59a2E44480696bEe5de1ad)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa5505643bB243c38e18Fef93672534a44B52c1AD)
 */
export const watchWethVariableDebtTokenTaikoMintEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: wethVariableDebtTokenTaikoAbi,
    address: wethVariableDebtTokenTaikoAddress,
    eventName: 'Mint',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link wethVariableDebtTokenTaikoAbi}__ and `eventName` set to `"Transfer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x739E2f35970fC4351C59a2E44480696bEe5de1ad)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xa5505643bB243c38e18Fef93672534a44B52c1AD)
 */
export const watchWethVariableDebtTokenTaikoTransferEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: wethVariableDebtTokenTaikoAbi,
    address: wethVariableDebtTokenTaikoAddress,
    eventName: 'Transfer',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link walletBalanceProviderAbi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x0B96Cb6F51501e309eE7c134951f5715d0A4021b)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xb60a23256a168A2401C0FBa01a7dD91AdC3Bab74)
 */
export const readWalletBalanceProvider = /*#__PURE__*/ createReadContract({
  abi: walletBalanceProviderAbi,
  address: walletBalanceProviderAddress,
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link walletBalanceProviderAbi}__ and `functionName` set to `"balanceOf"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x0B96Cb6F51501e309eE7c134951f5715d0A4021b)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xb60a23256a168A2401C0FBa01a7dD91AdC3Bab74)
 */
export const readWalletBalanceProviderBalanceOf =
  /*#__PURE__*/ createReadContract({
    abi: walletBalanceProviderAbi,
    address: walletBalanceProviderAddress,
    functionName: 'balanceOf',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link walletBalanceProviderAbi}__ and `functionName` set to `"batchBalanceOf"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x0B96Cb6F51501e309eE7c134951f5715d0A4021b)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xb60a23256a168A2401C0FBa01a7dD91AdC3Bab74)
 */
export const readWalletBalanceProviderBatchBalanceOf =
  /*#__PURE__*/ createReadContract({
    abi: walletBalanceProviderAbi,
    address: walletBalanceProviderAddress,
    functionName: 'batchBalanceOf',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link walletBalanceProviderAbi}__ and `functionName` set to `"getUserWalletBalances"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0x0B96Cb6F51501e309eE7c134951f5715d0A4021b)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xb60a23256a168A2401C0FBa01a7dD91AdC3Bab74)
 */
export const readWalletBalanceProviderGetUserWalletBalances =
  /*#__PURE__*/ createReadContract({
    abi: walletBalanceProviderAbi,
    address: walletBalanceProviderAddress,
    functionName: 'getUserWalletBalances',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wrappedTokenGatewayV3Abi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xFfA91f8ab6521C2DbCa1E9978a02DC124109c716)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x273c9Bfa85EA5993F770Da9857268b329b32A65b)
 */
export const readWrappedTokenGatewayV3 = /*#__PURE__*/ createReadContract({
  abi: wrappedTokenGatewayV3Abi,
  address: wrappedTokenGatewayV3Address,
})

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wrappedTokenGatewayV3Abi}__ and `functionName` set to `"getWETHAddress"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xFfA91f8ab6521C2DbCa1E9978a02DC124109c716)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x273c9Bfa85EA5993F770Da9857268b329b32A65b)
 */
export const readWrappedTokenGatewayV3GetWethAddress =
  /*#__PURE__*/ createReadContract({
    abi: wrappedTokenGatewayV3Abi,
    address: wrappedTokenGatewayV3Address,
    functionName: 'getWETHAddress',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link wrappedTokenGatewayV3Abi}__ and `functionName` set to `"owner"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xFfA91f8ab6521C2DbCa1E9978a02DC124109c716)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x273c9Bfa85EA5993F770Da9857268b329b32A65b)
 */
export const readWrappedTokenGatewayV3Owner = /*#__PURE__*/ createReadContract({
  abi: wrappedTokenGatewayV3Abi,
  address: wrappedTokenGatewayV3Address,
  functionName: 'owner',
})

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wrappedTokenGatewayV3Abi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xFfA91f8ab6521C2DbCa1E9978a02DC124109c716)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x273c9Bfa85EA5993F770Da9857268b329b32A65b)
 */
export const writeWrappedTokenGatewayV3 = /*#__PURE__*/ createWriteContract({
  abi: wrappedTokenGatewayV3Abi,
  address: wrappedTokenGatewayV3Address,
})

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wrappedTokenGatewayV3Abi}__ and `functionName` set to `"borrowETH"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xFfA91f8ab6521C2DbCa1E9978a02DC124109c716)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x273c9Bfa85EA5993F770Da9857268b329b32A65b)
 */
export const writeWrappedTokenGatewayV3BorrowEth =
  /*#__PURE__*/ createWriteContract({
    abi: wrappedTokenGatewayV3Abi,
    address: wrappedTokenGatewayV3Address,
    functionName: 'borrowETH',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wrappedTokenGatewayV3Abi}__ and `functionName` set to `"depositETH"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xFfA91f8ab6521C2DbCa1E9978a02DC124109c716)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x273c9Bfa85EA5993F770Da9857268b329b32A65b)
 */
export const writeWrappedTokenGatewayV3DepositEth =
  /*#__PURE__*/ createWriteContract({
    abi: wrappedTokenGatewayV3Abi,
    address: wrappedTokenGatewayV3Address,
    functionName: 'depositETH',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wrappedTokenGatewayV3Abi}__ and `functionName` set to `"emergencyEtherTransfer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xFfA91f8ab6521C2DbCa1E9978a02DC124109c716)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x273c9Bfa85EA5993F770Da9857268b329b32A65b)
 */
export const writeWrappedTokenGatewayV3EmergencyEtherTransfer =
  /*#__PURE__*/ createWriteContract({
    abi: wrappedTokenGatewayV3Abi,
    address: wrappedTokenGatewayV3Address,
    functionName: 'emergencyEtherTransfer',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wrappedTokenGatewayV3Abi}__ and `functionName` set to `"emergencyTokenTransfer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xFfA91f8ab6521C2DbCa1E9978a02DC124109c716)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x273c9Bfa85EA5993F770Da9857268b329b32A65b)
 */
export const writeWrappedTokenGatewayV3EmergencyTokenTransfer =
  /*#__PURE__*/ createWriteContract({
    abi: wrappedTokenGatewayV3Abi,
    address: wrappedTokenGatewayV3Address,
    functionName: 'emergencyTokenTransfer',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wrappedTokenGatewayV3Abi}__ and `functionName` set to `"renounceOwnership"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xFfA91f8ab6521C2DbCa1E9978a02DC124109c716)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x273c9Bfa85EA5993F770Da9857268b329b32A65b)
 */
export const writeWrappedTokenGatewayV3RenounceOwnership =
  /*#__PURE__*/ createWriteContract({
    abi: wrappedTokenGatewayV3Abi,
    address: wrappedTokenGatewayV3Address,
    functionName: 'renounceOwnership',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wrappedTokenGatewayV3Abi}__ and `functionName` set to `"repayETH"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xFfA91f8ab6521C2DbCa1E9978a02DC124109c716)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x273c9Bfa85EA5993F770Da9857268b329b32A65b)
 */
export const writeWrappedTokenGatewayV3RepayEth =
  /*#__PURE__*/ createWriteContract({
    abi: wrappedTokenGatewayV3Abi,
    address: wrappedTokenGatewayV3Address,
    functionName: 'repayETH',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wrappedTokenGatewayV3Abi}__ and `functionName` set to `"transferOwnership"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xFfA91f8ab6521C2DbCa1E9978a02DC124109c716)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x273c9Bfa85EA5993F770Da9857268b329b32A65b)
 */
export const writeWrappedTokenGatewayV3TransferOwnership =
  /*#__PURE__*/ createWriteContract({
    abi: wrappedTokenGatewayV3Abi,
    address: wrappedTokenGatewayV3Address,
    functionName: 'transferOwnership',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wrappedTokenGatewayV3Abi}__ and `functionName` set to `"withdrawETH"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xFfA91f8ab6521C2DbCa1E9978a02DC124109c716)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x273c9Bfa85EA5993F770Da9857268b329b32A65b)
 */
export const writeWrappedTokenGatewayV3WithdrawEth =
  /*#__PURE__*/ createWriteContract({
    abi: wrappedTokenGatewayV3Abi,
    address: wrappedTokenGatewayV3Address,
    functionName: 'withdrawETH',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link wrappedTokenGatewayV3Abi}__ and `functionName` set to `"withdrawETHWithPermit"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xFfA91f8ab6521C2DbCa1E9978a02DC124109c716)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x273c9Bfa85EA5993F770Da9857268b329b32A65b)
 */
export const writeWrappedTokenGatewayV3WithdrawEthWithPermit =
  /*#__PURE__*/ createWriteContract({
    abi: wrappedTokenGatewayV3Abi,
    address: wrappedTokenGatewayV3Address,
    functionName: 'withdrawETHWithPermit',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wrappedTokenGatewayV3Abi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xFfA91f8ab6521C2DbCa1E9978a02DC124109c716)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x273c9Bfa85EA5993F770Da9857268b329b32A65b)
 */
export const simulateWrappedTokenGatewayV3 =
  /*#__PURE__*/ createSimulateContract({
    abi: wrappedTokenGatewayV3Abi,
    address: wrappedTokenGatewayV3Address,
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wrappedTokenGatewayV3Abi}__ and `functionName` set to `"borrowETH"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xFfA91f8ab6521C2DbCa1E9978a02DC124109c716)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x273c9Bfa85EA5993F770Da9857268b329b32A65b)
 */
export const simulateWrappedTokenGatewayV3BorrowEth =
  /*#__PURE__*/ createSimulateContract({
    abi: wrappedTokenGatewayV3Abi,
    address: wrappedTokenGatewayV3Address,
    functionName: 'borrowETH',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wrappedTokenGatewayV3Abi}__ and `functionName` set to `"depositETH"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xFfA91f8ab6521C2DbCa1E9978a02DC124109c716)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x273c9Bfa85EA5993F770Da9857268b329b32A65b)
 */
export const simulateWrappedTokenGatewayV3DepositEth =
  /*#__PURE__*/ createSimulateContract({
    abi: wrappedTokenGatewayV3Abi,
    address: wrappedTokenGatewayV3Address,
    functionName: 'depositETH',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wrappedTokenGatewayV3Abi}__ and `functionName` set to `"emergencyEtherTransfer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xFfA91f8ab6521C2DbCa1E9978a02DC124109c716)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x273c9Bfa85EA5993F770Da9857268b329b32A65b)
 */
export const simulateWrappedTokenGatewayV3EmergencyEtherTransfer =
  /*#__PURE__*/ createSimulateContract({
    abi: wrappedTokenGatewayV3Abi,
    address: wrappedTokenGatewayV3Address,
    functionName: 'emergencyEtherTransfer',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wrappedTokenGatewayV3Abi}__ and `functionName` set to `"emergencyTokenTransfer"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xFfA91f8ab6521C2DbCa1E9978a02DC124109c716)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x273c9Bfa85EA5993F770Da9857268b329b32A65b)
 */
export const simulateWrappedTokenGatewayV3EmergencyTokenTransfer =
  /*#__PURE__*/ createSimulateContract({
    abi: wrappedTokenGatewayV3Abi,
    address: wrappedTokenGatewayV3Address,
    functionName: 'emergencyTokenTransfer',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wrappedTokenGatewayV3Abi}__ and `functionName` set to `"renounceOwnership"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xFfA91f8ab6521C2DbCa1E9978a02DC124109c716)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x273c9Bfa85EA5993F770Da9857268b329b32A65b)
 */
export const simulateWrappedTokenGatewayV3RenounceOwnership =
  /*#__PURE__*/ createSimulateContract({
    abi: wrappedTokenGatewayV3Abi,
    address: wrappedTokenGatewayV3Address,
    functionName: 'renounceOwnership',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wrappedTokenGatewayV3Abi}__ and `functionName` set to `"repayETH"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xFfA91f8ab6521C2DbCa1E9978a02DC124109c716)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x273c9Bfa85EA5993F770Da9857268b329b32A65b)
 */
export const simulateWrappedTokenGatewayV3RepayEth =
  /*#__PURE__*/ createSimulateContract({
    abi: wrappedTokenGatewayV3Abi,
    address: wrappedTokenGatewayV3Address,
    functionName: 'repayETH',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wrappedTokenGatewayV3Abi}__ and `functionName` set to `"transferOwnership"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xFfA91f8ab6521C2DbCa1E9978a02DC124109c716)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x273c9Bfa85EA5993F770Da9857268b329b32A65b)
 */
export const simulateWrappedTokenGatewayV3TransferOwnership =
  /*#__PURE__*/ createSimulateContract({
    abi: wrappedTokenGatewayV3Abi,
    address: wrappedTokenGatewayV3Address,
    functionName: 'transferOwnership',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wrappedTokenGatewayV3Abi}__ and `functionName` set to `"withdrawETH"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xFfA91f8ab6521C2DbCa1E9978a02DC124109c716)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x273c9Bfa85EA5993F770Da9857268b329b32A65b)
 */
export const simulateWrappedTokenGatewayV3WithdrawEth =
  /*#__PURE__*/ createSimulateContract({
    abi: wrappedTokenGatewayV3Abi,
    address: wrappedTokenGatewayV3Address,
    functionName: 'withdrawETH',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link wrappedTokenGatewayV3Abi}__ and `functionName` set to `"withdrawETHWithPermit"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xFfA91f8ab6521C2DbCa1E9978a02DC124109c716)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x273c9Bfa85EA5993F770Da9857268b329b32A65b)
 */
export const simulateWrappedTokenGatewayV3WithdrawEthWithPermit =
  /*#__PURE__*/ createSimulateContract({
    abi: wrappedTokenGatewayV3Abi,
    address: wrappedTokenGatewayV3Address,
    functionName: 'withdrawETHWithPermit',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link wrappedTokenGatewayV3Abi}__
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xFfA91f8ab6521C2DbCa1E9978a02DC124109c716)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x273c9Bfa85EA5993F770Da9857268b329b32A65b)
 */
export const watchWrappedTokenGatewayV3Event =
  /*#__PURE__*/ createWatchContractEvent({
    abi: wrappedTokenGatewayV3Abi,
    address: wrappedTokenGatewayV3Address,
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link wrappedTokenGatewayV3Abi}__ and `eventName` set to `"OwnershipTransferred"`
 *
 * - [__View Contract on Holesky Etherscan__](https://holesky.etherscan.io/address/0xFfA91f8ab6521C2DbCa1E9978a02DC124109c716)
 * - [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0x273c9Bfa85EA5993F770Da9857268b329b32A65b)
 */
export const watchWrappedTokenGatewayV3OwnershipTransferredEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: wrappedTokenGatewayV3Abi,
    address: wrappedTokenGatewayV3Address,
    eventName: 'OwnershipTransferred',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link earlyHanaTestnetMintableErc20RewardTaikoAbi}__
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD2877dDbf7A412fe3c998091496b3186AdCFB6E0)
 */
export const readEarlyHanaTestnetMintableErc20RewardTaiko =
  /*#__PURE__*/ createReadContract({
    abi: earlyHanaTestnetMintableErc20RewardTaikoAbi,
    address: earlyHanaTestnetMintableErc20RewardTaikoAddress,
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link earlyHanaTestnetMintableErc20RewardTaikoAbi}__ and `functionName` set to `"allowance"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD2877dDbf7A412fe3c998091496b3186AdCFB6E0)
 */
export const readEarlyHanaTestnetMintableErc20RewardTaikoAllowance =
  /*#__PURE__*/ createReadContract({
    abi: earlyHanaTestnetMintableErc20RewardTaikoAbi,
    address: earlyHanaTestnetMintableErc20RewardTaikoAddress,
    functionName: 'allowance',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link earlyHanaTestnetMintableErc20RewardTaikoAbi}__ and `functionName` set to `"balanceOf"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD2877dDbf7A412fe3c998091496b3186AdCFB6E0)
 */
export const readEarlyHanaTestnetMintableErc20RewardTaikoBalanceOf =
  /*#__PURE__*/ createReadContract({
    abi: earlyHanaTestnetMintableErc20RewardTaikoAbi,
    address: earlyHanaTestnetMintableErc20RewardTaikoAddress,
    functionName: 'balanceOf',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link earlyHanaTestnetMintableErc20RewardTaikoAbi}__ and `functionName` set to `"decimals"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD2877dDbf7A412fe3c998091496b3186AdCFB6E0)
 */
export const readEarlyHanaTestnetMintableErc20RewardTaikoDecimals =
  /*#__PURE__*/ createReadContract({
    abi: earlyHanaTestnetMintableErc20RewardTaikoAbi,
    address: earlyHanaTestnetMintableErc20RewardTaikoAddress,
    functionName: 'decimals',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link earlyHanaTestnetMintableErc20RewardTaikoAbi}__ and `functionName` set to `"name"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD2877dDbf7A412fe3c998091496b3186AdCFB6E0)
 */
export const readEarlyHanaTestnetMintableErc20RewardTaikoName =
  /*#__PURE__*/ createReadContract({
    abi: earlyHanaTestnetMintableErc20RewardTaikoAbi,
    address: earlyHanaTestnetMintableErc20RewardTaikoAddress,
    functionName: 'name',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link earlyHanaTestnetMintableErc20RewardTaikoAbi}__ and `functionName` set to `"symbol"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD2877dDbf7A412fe3c998091496b3186AdCFB6E0)
 */
export const readEarlyHanaTestnetMintableErc20RewardTaikoSymbol =
  /*#__PURE__*/ createReadContract({
    abi: earlyHanaTestnetMintableErc20RewardTaikoAbi,
    address: earlyHanaTestnetMintableErc20RewardTaikoAddress,
    functionName: 'symbol',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link earlyHanaTestnetMintableErc20RewardTaikoAbi}__ and `functionName` set to `"tokenDecimals"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD2877dDbf7A412fe3c998091496b3186AdCFB6E0)
 */
export const readEarlyHanaTestnetMintableErc20RewardTaikoTokenDecimals =
  /*#__PURE__*/ createReadContract({
    abi: earlyHanaTestnetMintableErc20RewardTaikoAbi,
    address: earlyHanaTestnetMintableErc20RewardTaikoAddress,
    functionName: 'tokenDecimals',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link earlyHanaTestnetMintableErc20RewardTaikoAbi}__ and `functionName` set to `"totalSupply"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD2877dDbf7A412fe3c998091496b3186AdCFB6E0)
 */
export const readEarlyHanaTestnetMintableErc20RewardTaikoTotalSupply =
  /*#__PURE__*/ createReadContract({
    abi: earlyHanaTestnetMintableErc20RewardTaikoAbi,
    address: earlyHanaTestnetMintableErc20RewardTaikoAddress,
    functionName: 'totalSupply',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link earlyHanaTestnetMintableErc20RewardTaikoAbi}__
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD2877dDbf7A412fe3c998091496b3186AdCFB6E0)
 */
export const writeEarlyHanaTestnetMintableErc20RewardTaiko =
  /*#__PURE__*/ createWriteContract({
    abi: earlyHanaTestnetMintableErc20RewardTaikoAbi,
    address: earlyHanaTestnetMintableErc20RewardTaikoAddress,
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link earlyHanaTestnetMintableErc20RewardTaikoAbi}__ and `functionName` set to `"approve"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD2877dDbf7A412fe3c998091496b3186AdCFB6E0)
 */
export const writeEarlyHanaTestnetMintableErc20RewardTaikoApprove =
  /*#__PURE__*/ createWriteContract({
    abi: earlyHanaTestnetMintableErc20RewardTaikoAbi,
    address: earlyHanaTestnetMintableErc20RewardTaikoAddress,
    functionName: 'approve',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link earlyHanaTestnetMintableErc20RewardTaikoAbi}__ and `functionName` set to `"decreaseAllowance"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD2877dDbf7A412fe3c998091496b3186AdCFB6E0)
 */
export const writeEarlyHanaTestnetMintableErc20RewardTaikoDecreaseAllowance =
  /*#__PURE__*/ createWriteContract({
    abi: earlyHanaTestnetMintableErc20RewardTaikoAbi,
    address: earlyHanaTestnetMintableErc20RewardTaikoAddress,
    functionName: 'decreaseAllowance',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link earlyHanaTestnetMintableErc20RewardTaikoAbi}__ and `functionName` set to `"increaseAllowance"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD2877dDbf7A412fe3c998091496b3186AdCFB6E0)
 */
export const writeEarlyHanaTestnetMintableErc20RewardTaikoIncreaseAllowance =
  /*#__PURE__*/ createWriteContract({
    abi: earlyHanaTestnetMintableErc20RewardTaikoAbi,
    address: earlyHanaTestnetMintableErc20RewardTaikoAddress,
    functionName: 'increaseAllowance',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link earlyHanaTestnetMintableErc20RewardTaikoAbi}__ and `functionName` set to `"transfer"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD2877dDbf7A412fe3c998091496b3186AdCFB6E0)
 */
export const writeEarlyHanaTestnetMintableErc20RewardTaikoTransfer =
  /*#__PURE__*/ createWriteContract({
    abi: earlyHanaTestnetMintableErc20RewardTaikoAbi,
    address: earlyHanaTestnetMintableErc20RewardTaikoAddress,
    functionName: 'transfer',
  })

/**
 * Wraps __{@link writeContract}__ with `abi` set to __{@link earlyHanaTestnetMintableErc20RewardTaikoAbi}__ and `functionName` set to `"transferFrom"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD2877dDbf7A412fe3c998091496b3186AdCFB6E0)
 */
export const writeEarlyHanaTestnetMintableErc20RewardTaikoTransferFrom =
  /*#__PURE__*/ createWriteContract({
    abi: earlyHanaTestnetMintableErc20RewardTaikoAbi,
    address: earlyHanaTestnetMintableErc20RewardTaikoAddress,
    functionName: 'transferFrom',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link earlyHanaTestnetMintableErc20RewardTaikoAbi}__
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD2877dDbf7A412fe3c998091496b3186AdCFB6E0)
 */
export const simulateEarlyHanaTestnetMintableErc20RewardTaiko =
  /*#__PURE__*/ createSimulateContract({
    abi: earlyHanaTestnetMintableErc20RewardTaikoAbi,
    address: earlyHanaTestnetMintableErc20RewardTaikoAddress,
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link earlyHanaTestnetMintableErc20RewardTaikoAbi}__ and `functionName` set to `"approve"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD2877dDbf7A412fe3c998091496b3186AdCFB6E0)
 */
export const simulateEarlyHanaTestnetMintableErc20RewardTaikoApprove =
  /*#__PURE__*/ createSimulateContract({
    abi: earlyHanaTestnetMintableErc20RewardTaikoAbi,
    address: earlyHanaTestnetMintableErc20RewardTaikoAddress,
    functionName: 'approve',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link earlyHanaTestnetMintableErc20RewardTaikoAbi}__ and `functionName` set to `"decreaseAllowance"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD2877dDbf7A412fe3c998091496b3186AdCFB6E0)
 */
export const simulateEarlyHanaTestnetMintableErc20RewardTaikoDecreaseAllowance =
  /*#__PURE__*/ createSimulateContract({
    abi: earlyHanaTestnetMintableErc20RewardTaikoAbi,
    address: earlyHanaTestnetMintableErc20RewardTaikoAddress,
    functionName: 'decreaseAllowance',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link earlyHanaTestnetMintableErc20RewardTaikoAbi}__ and `functionName` set to `"increaseAllowance"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD2877dDbf7A412fe3c998091496b3186AdCFB6E0)
 */
export const simulateEarlyHanaTestnetMintableErc20RewardTaikoIncreaseAllowance =
  /*#__PURE__*/ createSimulateContract({
    abi: earlyHanaTestnetMintableErc20RewardTaikoAbi,
    address: earlyHanaTestnetMintableErc20RewardTaikoAddress,
    functionName: 'increaseAllowance',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link earlyHanaTestnetMintableErc20RewardTaikoAbi}__ and `functionName` set to `"transfer"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD2877dDbf7A412fe3c998091496b3186AdCFB6E0)
 */
export const simulateEarlyHanaTestnetMintableErc20RewardTaikoTransfer =
  /*#__PURE__*/ createSimulateContract({
    abi: earlyHanaTestnetMintableErc20RewardTaikoAbi,
    address: earlyHanaTestnetMintableErc20RewardTaikoAddress,
    functionName: 'transfer',
  })

/**
 * Wraps __{@link simulateContract}__ with `abi` set to __{@link earlyHanaTestnetMintableErc20RewardTaikoAbi}__ and `functionName` set to `"transferFrom"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD2877dDbf7A412fe3c998091496b3186AdCFB6E0)
 */
export const simulateEarlyHanaTestnetMintableErc20RewardTaikoTransferFrom =
  /*#__PURE__*/ createSimulateContract({
    abi: earlyHanaTestnetMintableErc20RewardTaikoAbi,
    address: earlyHanaTestnetMintableErc20RewardTaikoAddress,
    functionName: 'transferFrom',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link earlyHanaTestnetMintableErc20RewardTaikoAbi}__
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD2877dDbf7A412fe3c998091496b3186AdCFB6E0)
 */
export const watchEarlyHanaTestnetMintableErc20RewardTaikoEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: earlyHanaTestnetMintableErc20RewardTaikoAbi,
    address: earlyHanaTestnetMintableErc20RewardTaikoAddress,
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link earlyHanaTestnetMintableErc20RewardTaikoAbi}__ and `eventName` set to `"Approval"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD2877dDbf7A412fe3c998091496b3186AdCFB6E0)
 */
export const watchEarlyHanaTestnetMintableErc20RewardTaikoApprovalEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: earlyHanaTestnetMintableErc20RewardTaikoAbi,
    address: earlyHanaTestnetMintableErc20RewardTaikoAddress,
    eventName: 'Approval',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link earlyHanaTestnetMintableErc20RewardTaikoAbi}__ and `eventName` set to `"Transfer"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xD2877dDbf7A412fe3c998091496b3186AdCFB6E0)
 */
export const watchEarlyHanaTestnetMintableErc20RewardTaikoTransferEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: earlyHanaTestnetMintableErc20RewardTaikoAbi,
    address: earlyHanaTestnetMintableErc20RewardTaikoAddress,
    eventName: 'Transfer',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link earlyHanaTestnetPriceAggregatorTaikoAbi}__
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xcaF395a7cBF8F949231Fc7344Dd6B5f639B4c5F0)
 */
export const readEarlyHanaTestnetPriceAggregatorTaiko =
  /*#__PURE__*/ createReadContract({
    abi: earlyHanaTestnetPriceAggregatorTaikoAbi,
    address: earlyHanaTestnetPriceAggregatorTaikoAddress,
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link earlyHanaTestnetPriceAggregatorTaikoAbi}__ and `functionName` set to `"decimals"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xcaF395a7cBF8F949231Fc7344Dd6B5f639B4c5F0)
 */
export const readEarlyHanaTestnetPriceAggregatorTaikoDecimals =
  /*#__PURE__*/ createReadContract({
    abi: earlyHanaTestnetPriceAggregatorTaikoAbi,
    address: earlyHanaTestnetPriceAggregatorTaikoAddress,
    functionName: 'decimals',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link earlyHanaTestnetPriceAggregatorTaikoAbi}__ and `functionName` set to `"getTokenType"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xcaF395a7cBF8F949231Fc7344Dd6B5f639B4c5F0)
 */
export const readEarlyHanaTestnetPriceAggregatorTaikoGetTokenType =
  /*#__PURE__*/ createReadContract({
    abi: earlyHanaTestnetPriceAggregatorTaikoAbi,
    address: earlyHanaTestnetPriceAggregatorTaikoAddress,
    functionName: 'getTokenType',
  })

/**
 * Wraps __{@link readContract}__ with `abi` set to __{@link earlyHanaTestnetPriceAggregatorTaikoAbi}__ and `functionName` set to `"latestAnswer"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xcaF395a7cBF8F949231Fc7344Dd6B5f639B4c5F0)
 */
export const readEarlyHanaTestnetPriceAggregatorTaikoLatestAnswer =
  /*#__PURE__*/ createReadContract({
    abi: earlyHanaTestnetPriceAggregatorTaikoAbi,
    address: earlyHanaTestnetPriceAggregatorTaikoAddress,
    functionName: 'latestAnswer',
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link earlyHanaTestnetPriceAggregatorTaikoAbi}__
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xcaF395a7cBF8F949231Fc7344Dd6B5f639B4c5F0)
 */
export const watchEarlyHanaTestnetPriceAggregatorTaikoEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: earlyHanaTestnetPriceAggregatorTaikoAbi,
    address: earlyHanaTestnetPriceAggregatorTaikoAddress,
  })

/**
 * Wraps __{@link watchContractEvent}__ with `abi` set to __{@link earlyHanaTestnetPriceAggregatorTaikoAbi}__ and `eventName` set to `"AnswerUpdated"`
 *
 * [__View Contract on Taiko Hekla L2 Taikoscan__](https://hekla.taikoscan.network/address/0xcaF395a7cBF8F949231Fc7344Dd6B5f639B4c5F0)
 */
export const watchEarlyHanaTestnetPriceAggregatorTaikoAnswerUpdatedEvent =
  /*#__PURE__*/ createWatchContractEvent({
    abi: earlyHanaTestnetPriceAggregatorTaikoAbi,
    address: earlyHanaTestnetPriceAggregatorTaikoAddress,
    eventName: 'AnswerUpdated',
  })
